(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.jc.dv === region.hs.dv)
	{
		return 'on line ' + region.jc.dv;
	}
	return 'on lines ' + region.jc.dv + ' through ' + region.hs.dv;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lW,
		impl.oB,
		impl.n5,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bt: func(record.bt),
		go: record.go,
		ge: record.ge
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bt;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.go;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.ge) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lW,
		impl.oB,
		impl.n5,
		function(sendToApp, initialModel) {
			var view = impl.oH;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.lW,
		impl.oB,
		impl.n5,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.gj && impl.gj(sendToApp)
			var view = impl.oH;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.gZ);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.jr) && (_VirtualDom_doc.title = title = doc.jr);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.m1;
	var onUrlRequest = impl.m2;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		gj: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.np === next.np
							&& curr.dt === next.dt
							&& curr.nf.a === next.nf.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		lW: function(flags)
		{
			return A3(impl.lW, flags, _Browser_getUrl(), key);
		},
		oH: impl.oH,
		oB: impl.oB,
		n5: impl.n5
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { lK: 'hidden', kE: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { lK: 'mozHidden', kE: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { lK: 'msHidden', kE: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { lK: 'webkitHidden', kE: 'webkitvisibilitychange' }
		: { lK: 'hidden', kE: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		i3: _Browser_getScene(),
		jN: {
			dV: _Browser_window.pageXOffset,
			dW: _Browser_window.pageYOffset,
			jR: _Browser_doc.documentElement.clientWidth,
			lI: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		jR: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		lI: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			i3: {
				jR: node.scrollWidth,
				lI: node.scrollHeight
			},
			jN: {
				dV: node.scrollLeft,
				dW: node.scrollTop,
				jR: node.clientWidth,
				lI: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			i3: _Browser_getScene(),
			jN: {
				dV: x,
				dW: y,
				jR: _Browser_doc.documentElement.clientWidth,
				lI: _Browser_doc.documentElement.clientHeight
			},
			lg: {
				dV: x + rect.left,
				dW: y + rect.top,
				jR: rect.width,
				lI: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.hv.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.hv.b, xhr)); });
		$elm$core$Maybe$isJust(request.jz) && _Http_track(router, xhr, request.jz.a);

		try {
			xhr.open(request.ii, request.jF, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.jF));
		}

		_Http_configureRequest(xhr, request);

		request.gZ.a && xhr.setRequestHeader('Content-Type', request.gZ.a);
		xhr.send(request.gZ.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.hO; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.jp.a || 0;
	xhr.responseType = request.hv.d;
	xhr.withCredentials = request.kc;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		jF: xhr.responseURL,
		n_: xhr.status,
		n$: xhr.statusText,
		hO: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			nN: event.loaded,
			aV: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			nr: event.loaded,
			aV: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});




// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.hl))
		{
			lang = options.hl.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.lF.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.n6,
		breaks: gfm && gfm.kA,
		sanitize: options.nC,
		smartypants: options.nS
	};
}
var $author$project$CWS$Messages$LinkClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$CWS$Messages$OnLocationChange = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.G) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.L),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.L);
		} else {
			var treeLen = builder.G * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.O) : builder.O;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.G);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.L) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.L);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{O: nodeList, G: (len / $elm$core$Array$branchFactor) | 0, L: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fu: fragment, dt: host, dD: path, nf: port_, np: protocol, iK: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$CWS$Route$About = {$: 2};
var $author$project$CWS$AppFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$AppLoaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$Route$FullRoute = F2(
	function (main, sub) {
		return {z: main, K: sub};
	});
var $author$project$CWS$Route$None = {$: 0};
var $author$project$CWS$Messages$Root = 0;
var $author$project$CWS$Messages$AboutMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$CWS$Messages$RequestAccess = {$: 38};
var $author$project$CWS$Messages$SignIn = {$: 40};
var $author$project$CWS$About$translator = F2(
	function (td, msg) {
		switch (msg.$) {
			case 0:
				var m = msg.a;
				return td.cO(m);
			case 1:
				return td.mY;
			case 2:
				return td.mX;
			default:
				return td.m_;
		}
	});
var $author$project$CWS$aboutTranslator = $author$project$CWS$About$translator(
	{cO: $author$project$CWS$Messages$AboutMsg, mX: $author$project$CWS$Messages$RequestAccess, mY: $author$project$CWS$Messages$RequestAccess, m_: $author$project$CWS$Messages$SignIn});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$CWS$Model$Loading = {$: 1};
var $author$project$PAM$User$LoggedOut = {$: 0};
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$round = _Basics_round;
var $author$project$PAM$UI$Basic$responsive = F3(
	function (a, _v0, _v1) {
		var aMin = _v0.a;
		var aMax = _v0.b;
		var bMin = _v1.a;
		var bMax = _v1.b;
		if (_Utils_cmp(a, aMin) < 1) {
			return bMin;
		} else {
			if (_Utils_cmp(a, aMax) > -1) {
				return bMax;
			} else {
				var deltaA = $elm$core$Basics$round((a - aMin) / (aMax - aMin));
				return (deltaA * (bMax - bMin)) + bMin;
			}
		}
	});
var $author$project$PAM$UI$Basic$adjustOnHeight = F3(
	function (size, device, range) {
		return A3(
			$author$project$PAM$UI$Basic$responsive,
			size.lI,
			_Utils_Tuple2(600, 1200),
			range);
	});
var $author$project$PAM$UI$Basic$calculatePanelDimensions = F2(
	function (windowSize, device) {
		var calc = A2($author$project$PAM$UI$Basic$adjustOnHeight, windowSize, device);
		var headerAndFooterHeight = calc(
			_Utils_Tuple2(32, 46));
		var mainHeaderHeight = calc(
			_Utils_Tuple2(50, 60));
		var subHeaderHeight = calc(
			_Utils_Tuple2(30, 36));
		var leftSidebarBodyHeight = windowSize.lI - ((mainHeaderHeight + subHeaderHeight) + (headerAndFooterHeight * 2));
		var bottomDrawerHeight = calc(
			_Utils_Tuple2(215, 316));
		return {
			g$: calc(
				_Utils_Tuple2(32, 40)),
			ky: headerAndFooterHeight,
			kz: bottomDrawerHeight,
			fN: leftSidebarBodyHeight,
			h9: headerAndFooterHeight,
			ia: headerAndFooterHeight,
			ib: calc(
				_Utils_Tuple2(30, 40)),
			ey: calc(
				_Utils_Tuple2(390, 480)),
			mh: mainHeaderHeight,
			n3: subHeaderHeight
		};
	});
var $mdgriffith$elm_ui$Element$BigDesktop = 3;
var $mdgriffith$elm_ui$Element$Desktop = 2;
var $mdgriffith$elm_ui$Element$Landscape = 1;
var $mdgriffith$elm_ui$Element$Phone = 0;
var $mdgriffith$elm_ui$Element$Portrait = 0;
var $mdgriffith$elm_ui$Element$Tablet = 1;
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $mdgriffith$elm_ui$Element$classifyDevice = function (window) {
	return {
		g9: function () {
			var shortSide = A2($elm$core$Basics$min, window.jR, window.lI);
			var longSide = A2($elm$core$Basics$max, window.jR, window.lI);
			return (shortSide < 600) ? 0 : ((longSide <= 1200) ? 1 : (((longSide > 1200) && (longSide <= 1920)) ? 2 : 3));
		}(),
		is: (_Utils_cmp(window.jR, window.lI) < 0) ? 0 : 1
	};
};
var $author$project$CWS$LoadableChunks = function (assignedPEs) {
	return function (actionTypes) {
		return function (selectedPE) {
			return function (participatingEntityOverview) {
				return function (participatingEntities) {
					return function (peFiles) {
						return function (peStats) {
							return function (peBreakdownStats) {
								return function (allActionsForApprover) {
									return function (staticFiles) {
										return function (users) {
											return function (userAssignedPEs) {
												return {aG: actionTypes, cl: allActionsForApprover, D: assignedPEs, na: participatingEntities, b0: participatingEntityOverview, az: peBreakdownStats, aA: peFiles, b2: peStats, aC: selectedPE, aE: staticFiles, cg: userAssignedPEs, aY: users};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CWS$Model$NotRequested = {$: 0};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $author$project$CWS$defaultLoadableChunks = $author$project$CWS$LoadableChunks($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested)($elm$core$Dict$empty)($author$project$CWS$Model$NotRequested)($author$project$CWS$Model$NotRequested);
var $author$project$InPageOAuth$NotStarted = {$: 0};
var $author$project$InPageOAuth$Quiet = 1;
var $author$project$InPageOAuth$defaultModel = {kh: $elm$core$Maybe$Nothing, d7: $elm$core$Maybe$Nothing, hd: $elm$core$Maybe$Nothing, mp: 1, dG: 0, a: $author$project$InPageOAuth$NotStarted, f: $author$project$PAM$User$LoggedOut};
var $author$project$CWS$PEHomeMapConfig = F2(
	function (layers, peActionLayer) {
		return {h7: layers, gb: peActionLayer};
	});
var $author$project$PlugMapOld$Plugins$Themes$Layer = F4(
	function (id, name, opacity, config) {
		return {hd: config, ab: id, dz: name, iq: opacity};
	});
var $author$project$PlugMapOld$Plugins$Themes$NoneLayer = {$: 0};
var $author$project$PlugMapOld$Plugins$Themes$emptyLayer = A4($author$project$PlugMapOld$Plugins$Themes$Layer, '', '', $elm$core$Maybe$Nothing, $author$project$PlugMapOld$Plugins$Themes$NoneLayer);
var $author$project$CWS$defaultPEHomeMapConfig = A2($author$project$CWS$PEHomeMapConfig, _List_Nil, $author$project$PlugMapOld$Plugins$Themes$emptyLayer);
var $author$project$CWS$Model$NoConfirmation = {$: 0};
var $author$project$CWS$About$Model = function (content) {
	return {d9: content};
};
var $author$project$CWS$About$defaultModel = $author$project$CWS$About$Model('Loading');
var $author$project$CWS$ActionBoard$Model = F2(
	function (state, category) {
		return {bK: category, a: state};
	});
var $author$project$CWS$Model$NoDynConfirmation = {$: 0};
var $author$project$CWS$ActionBoard$State = F5(
	function (actionChecklist, participatingEntity, year, actionSummaryDboardModel, confirmation) {
		return {bf: actionChecklist, e1: actionSummaryDboardModel, aJ: confirmation, cQ: participatingEntity, r: year};
	});
var $author$project$CWS$Model$Eligible = 0;
var $author$project$CWS$Model$ParticipatingEntityModel = F8(
	function (name, key, status, id, wkt, type_, yearType, years) {
		return {ab: id, v: key, dz: name, jf: status, jE: type_, bc: wkt, oM: yearType, cj: years};
	});
var $author$project$CWS$Model$NamedValue = F2(
	function (id, name) {
		return {ab: id, dz: name};
	});
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$CWS$Model$defaultPEType = A2($author$project$CWS$Model$NamedValue, -1, 'Municipality');
var $author$project$CWS$Model$defaultYearType = A2($author$project$CWS$Model$NamedValue, -1, 'Fiscal');
var $author$project$CWS$Model$defaultParticipatingEntity = A8($author$project$CWS$Model$ParticipatingEntityModel, 'Default', 'Dflt', 0, '-1', '', $author$project$CWS$Model$defaultPEType, $author$project$CWS$Model$defaultYearType, _List_Nil);
var $author$project$CWS$ActionBoard$defaultState = A5($author$project$CWS$ActionBoard$State, _List_Nil, $author$project$CWS$Model$defaultParticipatingEntity, '0', $elm$core$Maybe$Nothing, $author$project$CWS$Model$NoDynConfirmation);
var $author$project$CWS$ActionBoard$defaultModel = A2($author$project$CWS$ActionBoard$Model, $author$project$CWS$ActionBoard$defaultState, 'None');
var $author$project$CWS$ActionDetail$NotChecked = {$: 0};
var $author$project$CWS$ActionDetail$NotSaving = {$: 0};
var $author$project$CWS$ActionDetail$Workflow_PE = 1;
var $author$project$CWS$ActionDetail$defaultConfig = {h1: 0};
var $author$project$CWS$API$Action$defaultModel = {b3: _List_Nil};
var $author$project$PAM$UI$Basic$Closed = 1;
var $author$project$CWS$DrawEditMap$Uninitialized = 0;
var $author$project$PlugMap$Core$defaultModel = {eB: $elm$core$Maybe$Nothing, eL: _List_Nil};
var $author$project$PlugMap$Plugins$ColorUnderPointer$Model = {};
var $author$project$PlugMap$Plugins$ColorUnderPointer$defaultModel = $author$project$PlugMap$Plugins$ColorUnderPointer$Model;
var $author$project$PlugMap$Plugins$Drawing$Model = function (wkts) {
	return function (flatWKTs) {
		return function (hasChanges) {
			return function (editing) {
				return function (enabled) {
					return function (controlEnabled) {
						return function (buffer) {
							return function (mode) {
								return function (options) {
									return function (area) {
										return function (requestedFlatWKTs) {
											return function (id) {
												return function (initialized) {
													return function (nextExpectedId) {
														return {bI: area, dh: buffer, ed: controlEnabled, hr: editing, ax: enabled, fq: flatWKTs, am: hasChanges, ab: id, eu: initialized, mp: mode, eD: nextExpectedId, m6: options, eM: requestedFlatWKTs, c6: wkts};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PlugMap$Plugins$Drawing$NotCalculated = {$: 0};
var $author$project$PlugMap$Plugins$Drawing$Polygon = 0;
var $author$project$PlugMap$Plugins$Drawing$defaultOptions = {fk: false};
var $author$project$PlugMap$Plugins$Drawing$defaultModel = $author$project$PlugMap$Plugins$Drawing$Model(_List_Nil)(_List_Nil)(false)(false)(false)(true)(5.0)(0)($author$project$PlugMap$Plugins$Drawing$defaultOptions)($author$project$PlugMap$Plugins$Drawing$NotCalculated)(false)('')(false)($elm$core$Maybe$Nothing);
var $author$project$PlugMap$Plugins$Identify$defaultModel = {fd: $elm$core$Maybe$Nothing, h7: _List_Nil, gi: $elm$core$Maybe$Nothing, gm: false};
var $author$project$PlugMap$Plugins$Themes$defaultModel = {F: _List_Nil, cF: $elm$core$Dict$empty, h6: $elm$core$Dict$empty};
var $author$project$CWS$DrawEditMap$None = {$: 0};
var $author$project$CWS$DrawEditMap$defaultConfig = {p: $elm$core$Maybe$Nothing, dH: _List_Nil, cW: $elm$core$Dict$empty};
var $author$project$PlugMap$Plugins$Upload$Idle = {$: 0};
var $author$project$PlugMap$Plugins$Upload$defaultModel = {jf: $author$project$PlugMap$Plugins$Upload$Idle};
var $author$project$CWS$DrawEditMap$NotStarted = 0;
var $author$project$PlugMap$Plugins$FeaturePicker$Model = F5(
	function (services, layer, trackingRequests, trackingFeatures, selectedFeatures) {
		return {bT: layer, as: selectedFeatures, cW: services, bD: trackingFeatures, cc: trackingRequests};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$NoFeatures = {$: 0};
var $author$project$PlugMap$Plugins$FeaturePicker$defaultModel = A5($author$project$PlugMap$Plugins$FeaturePicker$Model, $elm$core$Dict$empty, $elm$core$Maybe$Nothing, 0, $author$project$PlugMap$Plugins$FeaturePicker$NoFeatures, _List_Nil);
var $inkuzmin$elm_multiselect$Multiselect$Closed = 0;
var $inkuzmin$elm_multiselect$Multiselect$Model = $elm$core$Basics$identity;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $inkuzmin$elm_multiselect$Multiselect$initModel = F2(
	function (values, tag1) {
		return {
			lj: $elm$core$Maybe$Nothing,
			B: values,
			C: $elm$core$List$head(values),
			E: '',
			fI: 23.0,
			a8: false,
			P: _List_Nil,
			jf: 0,
			Q: tag1,
			jJ: values
		};
	});
var $author$project$CWS$DrawEditMap$defaultSelectModel = {
	dY: _List_Nil,
	N: $author$project$PlugMap$Plugins$FeaturePicker$defaultModel,
	bW: 0,
	an: A2($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, ''),
	b_: 1,
	m6: _List_Nil,
	aR: 0,
	P: $elm$core$Maybe$Nothing,
	as: _List_Nil
};
var $author$project$CWS$DrawEditMap$defaultToolboxModel = {dh: 50, hd: $author$project$CWS$DrawEditMap$defaultConfig, o: $author$project$PlugMap$Plugins$Drawing$defaultModel, hr: false, ay: $elm$core$Maybe$Nothing, e: $author$project$CWS$DrawEditMap$defaultSelectModel, P: $elm$core$Maybe$Nothing, H: $author$project$CWS$DrawEditMap$None, cZ: _List_Nil, e_: false, aX: $author$project$PlugMap$Plugins$Upload$defaultModel};
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$rgb = F3(
	function (r, g, b) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, 1.0);
	});
var $author$project$CWS$DrawEditMap$defaultModel = {
	c9: $elm$core$Maybe$Just(
		A3($avh4$elm_color$Color$rgb, 1, 0, 0)),
	da: '',
	di: $author$project$PlugMap$Plugins$ColorUnderPointer$defaultModel,
	ej: $author$project$PlugMap$Plugins$Drawing$defaultModel,
	a3: $author$project$PlugMap$Plugins$Identify$defaultModel,
	q: $author$project$PlugMap$Core$defaultModel,
	eL: _List_Nil,
	cW: $elm$core$Dict$empty,
	a: 0,
	eU: 1,
	om: $author$project$PlugMap$Plugins$Themes$defaultModel,
	c1: false,
	A: $author$project$CWS$DrawEditMap$defaultToolboxModel,
	dO: 1,
	jv: false
};
var $author$project$CWS$ActionDetail$Details = 0;
var $author$project$CWS$UploadDocuments$NotChecked = {$: 0};
var $author$project$CWS$UploadDocuments$NotEditing = {$: 0};
var $author$project$CWS$UploadDocuments$emptyFileModelList = _List_Nil;
var $author$project$GridOld$Grid$Sort = function (a) {
	return {$: 1, a: a};
};
var $author$project$GridOld$Grid$Table = 1;
var $author$project$CWS$UploadDocuments$getGridModel = {
	k_: 0,
	lb: 1,
	lx: $elm$core$Maybe$Nothing,
	l5: 10,
	gg: $elm$core$Maybe$Nothing,
	aD: $author$project$GridOld$Grid$Sort('Name')
};
var $author$project$CWS$UploadDocuments$defaultModel = function () {
	var defaultState = {aJ: $author$project$CWS$Model$NoDynConfirmation, hr: $author$project$CWS$UploadDocuments$NotEditing, hB: $elm$core$Maybe$Nothing};
	return {
		gH: -1,
		g3: false,
		g4: false,
		bk: '',
		aw: $author$project$CWS$UploadDocuments$NotChecked,
		ff: A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$About, $author$project$CWS$Route$None),
		_: $elm$core$Maybe$Nothing,
		aK: $author$project$CWS$UploadDocuments$emptyFileModelList,
		dr: $author$project$CWS$UploadDocuments$getGridModel,
		eK: $author$project$CWS$Model$defaultParticipatingEntity,
		dE: $elm$core$Maybe$Nothing,
		a: defaultState,
		cf: $elm$core$Maybe$Nothing
	};
}();
var $author$project$CWS$ActionDetail$defaultState = {a$: 0, hr: false, am: false, ab: -1, bs: $elm$core$Maybe$Nothing, cQ: $author$project$CWS$Model$Loading, ba: $author$project$CWS$UploadDocuments$defaultModel};
var $author$project$CWS$ActionDetail$defaultModel = {k: _List_Nil, c: $author$project$CWS$Model$Loading, W: '', gL: $elm$core$Dict$empty, cm: $author$project$CWS$API$Action$defaultModel, hd: $author$project$CWS$ActionDetail$defaultConfig, aJ: $author$project$CWS$Model$NoDynConfirmation, bM: $elm$core$Maybe$Nothing, $7: $elm$core$Maybe$Nothing, q: $author$project$CWS$DrawEditMap$defaultModel, bX: false, dH: _List_Nil, T: $author$project$CWS$ActionDetail$NotSaving, b6: $elm$core$Maybe$Nothing, a: $author$project$CWS$ActionDetail$defaultState, aF: $author$project$CWS$ActionDetail$NotChecked, aZ: _List_Nil, bd: 1};
var $author$project$CWS$Route$APP_Actions = {$: 2};
var $author$project$CWS$Route$CWSApprover = function (a) {
	return {$: 5, a: a};
};
var $author$project$GridOld$Grid$Sort_Reverse = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Approver$Actions$defaultGridModel = {
	k_: 0,
	lb: 1,
	lx: $elm$core$Maybe$Just('Status'),
	l5: 10,
	gg: $elm$core$Maybe$Just('Submitted'),
	aD: $author$project$GridOld$Grid$Sort_Reverse('Days in Queue')
};
var $author$project$CWS$Approver$Actions$defaultModel = {
	au: _List_Nil,
	ff: A2(
		$author$project$CWS$Route$FullRoute,
		$author$project$CWS$Route$CWSApprover($author$project$CWS$Route$APP_Actions),
		$author$project$CWS$Route$None),
	dr: $author$project$CWS$Approver$Actions$defaultGridModel,
	gg: $elm$core$Maybe$Nothing
};
var $author$project$Grid$Grid$Sort = function (a) {
	return {$: 1, a: a};
};
var $author$project$Grid$Grid$Sort_None = {$: 0};
var $author$project$Grid$Grid$defaultGridModel = {cu: 1, k_: 0, lx: $elm$core$Maybe$Nothing, bl: 1, l5: 20, bq: 1, gg: $elm$core$Maybe$Nothing, aD: $author$project$Grid$Grid$Sort_None};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$defaultModel = function () {
	var dgm = $author$project$Grid$Grid$defaultGridModel;
	return {
		ee: '',
		fw: _Utils_update(
			dgm,
			{
				aD: $author$project$Grid$Grid$Sort('Name')
			}),
		dy: A2($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'a'),
		e_: false,
		aY: _List_Nil
	};
}();
var $author$project$CWS$Approver$ManageUserParticipatingEntities$defaultModel = function () {
	var dgm = $author$project$Grid$Grid$defaultGridModel;
	return {
		ee: '',
		fw: _Utils_update(
			dgm,
			{
				aD: $author$project$Grid$Grid$Sort('Name')
			}),
		b4: _List_Nil,
		eW: '',
		e_: false
	};
}();
var $author$project$CWS$Approver$ParticipatingEntities$defaultGridModel = $author$project$Grid$Grid$defaultGridModel;
var $author$project$CWS$Approver$ParticipatingEntities$defaultModel = {dr: $author$project$CWS$Approver$ParticipatingEntities$defaultGridModel, b4: _List_Nil, gg: $elm$core$Maybe$Nothing};
var $author$project$CWS$Approver$Users$defaultGridModel = function (a) {
	return _Utils_update(
		a,
		{
			aD: $author$project$Grid$Grid$Sort('Name')
		});
}($author$project$Grid$Grid$defaultGridModel);
var $author$project$CWS$Approver$Users$defaultModel = {dr: $author$project$CWS$Approver$Users$defaultGridModel, b4: _List_Nil, gg: $elm$core$Maybe$Nothing};
var $author$project$CWS$Home$Model = function (miniDashboardModel) {
	return function (mapModel) {
		return function (mapThemes) {
			return function (extentModel) {
				return function (participatingEntity) {
					return function (statSet) {
						return function (statObject) {
							return function (yearKey) {
								return function (layers) {
									return function (professionalViewerUrl) {
										return {em: extentModel, h7: layers, q: mapModel, fO: mapThemes, mm: miniDashboardModel, cQ: participatingEntity, nl: professionalViewerUrl, nY: statObject, jd: statSet, oL: yearKey};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CWS$MiniDashboard$Model = function (grid) {
	return {fw: grid};
};
var $author$project$CWS$MiniDashboard$defaultModel = $author$project$CWS$MiniDashboard$Model(_List_Nil);
var $author$project$PlugMapOld$Core$defaultModel = {eB: $elm$core$Maybe$Nothing, eL: _List_Nil};
var $author$project$PlugMapOld$Plugins$Extent$Model = {};
var $author$project$PlugMapOld$Plugins$Extent$defaultModel = $author$project$PlugMapOld$Plugins$Extent$Model;
var $author$project$PlugMapOld$Plugins$Themes$LayerUrl = F3(
	function (url, zIndex, tokenKey) {
		return {or: tokenKey, jF: url, gD: zIndex};
	});
var $author$project$PlugMapOld$Plugins$Themes$Multiple = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMapOld$Plugins$Themes$XYZLayer = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMapOld$Plugins$Themes$XYZLayerConfig = function (layers) {
	return {h7: layers};
};
var $author$project$PlugMapOld$Plugins$Themes$esriLightGreyLayer = A4(
	$author$project$PlugMapOld$Plugins$Themes$Layer,
	'esriLightGrey',
	'ESRI Light Grey',
	$elm$core$Maybe$Just(1),
	$author$project$PlugMapOld$Plugins$Themes$XYZLayer(
		$author$project$PlugMapOld$Plugins$Themes$XYZLayerConfig(
			$author$project$PlugMapOld$Plugins$Themes$Multiple(
				_List_fromArray(
					[
						A3($author$project$PlugMapOld$Plugins$Themes$LayerUrl, 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', 10, $elm$core$Maybe$Nothing),
						A3($author$project$PlugMapOld$Plugins$Themes$LayerUrl, 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', 1000, $elm$core$Maybe$Nothing)
					])))));
var $author$project$PlugMapOld$Plugins$Themes$defaultLayers = _List_fromArray(
	[$author$project$PlugMapOld$Plugins$Themes$esriLightGreyLayer]);
var $author$project$PlugMapOld$Plugins$Themes$defaultModel = {h7: $author$project$PlugMapOld$Plugins$Themes$defaultLayers};
var $author$project$CWS$Model$Approved = 4;
var $author$project$Stats$SimpleDisplay$Stat_Multi_Progress = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$CWS$Home$confirmedStat = function (maybeCommitment) {
	var totalCost = maybeCommitment;
	var filtered = function (stats) {
		var inf = A2(
			$elm$core$List$filter,
			function (a) {
				return a.jf === 4;
			},
			stats);
		var filterPrev = A2(
			$elm$core$List$filter,
			function (a) {
				return a.bK.v === 'Prevention';
			},
			inf);
		var filterPrep = A2(
			$elm$core$List$filter,
			function (a) {
				return a.bK.v === 'Preparedness';
			},
			inf);
		var filterMit = A2(
			$elm$core$List$filter,
			function (a) {
				return a.bK.v === 'Mitigation';
			},
			inf);
		return _List_fromArray(
			[
				{
				M: '#8F46A2',
				gv: A3(
					$elm$core$List$foldl,
					function (a) {
						return function (b) {
							return b + a.ov;
						};
					},
					0,
					filterMit)
			},
				{
				M: '#CB4D15',
				gv: A3(
					$elm$core$List$foldl,
					function (a) {
						return function (b) {
							return b + a.ov;
						};
					},
					0,
					filterPrep)
			},
				{
				M: '#203D05',
				gv: A3(
					$elm$core$List$foldl,
					function (a) {
						return function (b) {
							return b + a.ov;
						};
					},
					0,
					filterPrev)
			}
			]);
	};
	return A2(
		$author$project$Stats$SimpleDisplay$Stat_Multi_Progress,
		{a4: 'This graph represents approved actions only.', dz: 'Confirmed Commitment Progress', a9: $elm$core$Maybe$Nothing},
		{
			e7: '#CACACA',
			a1: function (a) {
				return _Utils_Tuple2(
					filtered(a),
					totalCost);
			},
			gl: true,
			bb: $elm$core$Maybe$Just('$')
		});
};
var $author$project$Stats$SimpleDisplay$Stat_Number = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Stats$SimpleDisplay$TotalGetter = function (get) {
	return {hK: get};
};
var $author$project$CWS$Home$mitigationStat = function () {
	var filtered = function (stats) {
		return A3(
			$elm$core$List$foldl,
			function (a) {
				return function (b) {
					return b + a.ot;
				};
			},
			0,
			A2(
				$elm$core$List$filter,
				function (a) {
					return (a.jf === 4) && (a.bK.v === 'Mitigation');
				},
				stats));
	};
	return A2(
		$author$project$Stats$SimpleDisplay$Stat_Number,
		{
			a4: 'This statistic represents acres completed for approved mitigation actions only.',
			dz: 'Wildfire Mitigation',
			a9: $elm$core$Maybe$Just('Acres Treated')
		},
		{
			a1: $author$project$Stats$SimpleDisplay$TotalGetter(
				function (a) {
					return {
						eY: filtered(a)
					};
				}),
			cD: '/images/Mitigation.svg',
			c4: $elm$core$Maybe$Just('#8F46A2'),
			bb: $elm$core$Maybe$Nothing
		});
}();
var $author$project$CWS$Home$prepStat = function () {
	var filtered = function (stats) {
		return A3(
			$elm$core$List$foldl,
			function (a) {
				return function (b) {
					return b + a.kX;
				};
			},
			0,
			A2(
				$elm$core$List$filter,
				function (a) {
					return (a.jf === 4) && (a.bK.v === 'Preparedness');
				},
				stats));
	};
	return A2(
		$author$project$Stats$SimpleDisplay$Stat_Number,
		{
			a4: 'This statistic represents approved preparedness actions only.',
			dz: 'Wildfire Preparedness',
			a9: $elm$core$Maybe$Just('Actions Taken')
		},
		{
			a1: $author$project$Stats$SimpleDisplay$TotalGetter(
				function (a) {
					return {
						eY: filtered(a)
					};
				}),
			cD: '/images/Preparedness.svg',
			c4: $elm$core$Maybe$Just('#CB4D15'),
			bb: $elm$core$Maybe$Nothing
		});
}();
var $author$project$CWS$Home$prevStat = function () {
	var filtered = function (stats) {
		return A3(
			$elm$core$List$foldl,
			function (a) {
				return function (b) {
					return b + a.kX;
				};
			},
			0,
			A2(
				$elm$core$List$filter,
				function (a) {
					return (a.jf === 4) && (a.bK.v === 'Prevention');
				},
				stats));
	};
	return A2(
		$author$project$Stats$SimpleDisplay$Stat_Number,
		{
			a4: 'This statistic represents approved prevention actions only.',
			dz: 'Wildfire Prevention',
			a9: $elm$core$Maybe$Just('Actions Taken')
		},
		{
			a1: $author$project$Stats$SimpleDisplay$TotalGetter(
				function (a) {
					return {
						eY: filtered(a)
					};
				}),
			cD: '/images/Prevention.svg',
			c4: $elm$core$Maybe$Just('#203D05'),
			bb: $elm$core$Maybe$Nothing
		});
}();
var $author$project$CWS$Model$Submitted = 2;
var $author$project$CWS$Home$projectedStat = function (maybeCommitment) {
	var totalCost = maybeCommitment;
	var filtered = function (stats) {
		var inf = A2(
			$elm$core$List$filter,
			function (a) {
				return (a.jf === 4) || (a.jf === 2);
			},
			stats);
		var filterPrev = A2(
			$elm$core$List$filter,
			function (a) {
				return a.bK.v === 'Prevention';
			},
			inf);
		var filterPrep = A2(
			$elm$core$List$filter,
			function (a) {
				return a.bK.v === 'Preparedness';
			},
			inf);
		var filterMit = A2(
			$elm$core$List$filter,
			function (a) {
				return a.bK.v === 'Mitigation';
			},
			inf);
		return _List_fromArray(
			[
				{
				M: '#8F46A2',
				gv: A3(
					$elm$core$List$foldl,
					function (a) {
						return function (b) {
							return b + a.ov;
						};
					},
					0,
					filterMit)
			},
				{
				M: '#CB4D15',
				gv: A3(
					$elm$core$List$foldl,
					function (a) {
						return function (b) {
							return b + a.ov;
						};
					},
					0,
					filterPrep)
			},
				{
				M: '#203D05',
				gv: A3(
					$elm$core$List$foldl,
					function (a) {
						return function (b) {
							return b + a.ov;
						};
					},
					0,
					filterPrev)
			}
			]);
	};
	return A2(
		$author$project$Stats$SimpleDisplay$Stat_Multi_Progress,
		{a4: 'This graph represents all submitted (but not approved) and approved actions.', dz: 'Projected Commitment Progress', a9: $elm$core$Maybe$Nothing},
		{
			e7: '#CACACA',
			a1: function (a) {
				return _Utils_Tuple2(
					filtered(a),
					totalCost);
			},
			gl: true,
			bb: $elm$core$Maybe$Just('$')
		});
};
var $author$project$CWS$Home$defaultStatSet = function (maybeCommitment) {
	return _List_fromArray(
		[
			_List_fromArray(
			[
				$author$project$CWS$Home$projectedStat(maybeCommitment),
				$author$project$CWS$Home$confirmedStat(maybeCommitment)
			]),
			_List_fromArray(
			[$author$project$CWS$Home$mitigationStat, $author$project$CWS$Home$prepStat, $author$project$CWS$Home$prevStat])
		]);
};
var $author$project$CWS$Home$defaultModel = $author$project$CWS$Home$Model($author$project$CWS$MiniDashboard$defaultModel)($author$project$PlugMapOld$Core$defaultModel)($author$project$PlugMapOld$Plugins$Themes$defaultModel)($author$project$PlugMapOld$Plugins$Extent$defaultModel)($author$project$CWS$Model$Loading)(
	$author$project$CWS$Home$defaultStatSet($elm$core$Maybe$Nothing))(_List_Nil)($elm$core$Maybe$Nothing)(_List_Nil)('');
var $author$project$CWS$PE$Reports$Uninitialized = {$: 0};
var $author$project$CWS$PE$Reports$defaultModel = $author$project$CWS$PE$Reports$Uninitialized;
var $author$project$CWS$PeSelect$Model = function (state) {
	return {a: state};
};
var $author$project$CWS$PeSelect$State = F2(
	function (peKey, year) {
		return {gc: peKey, r: year};
	});
var $author$project$CWS$PeSelect$defaultState = A2($author$project$CWS$PeSelect$State, '', 0);
var $author$project$CWS$PeSelect$defaultModel = $author$project$CWS$PeSelect$Model($author$project$CWS$PeSelect$defaultState);
var $author$project$Map$AGS$Model$Model = function (tokens) {
	return {gt: tokens};
};
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Map$AGS$Model$defaultModel = $author$project$Map$AGS$Model$Model(
	$elm$core$Dict$fromList(_List_Nil));
var $author$project$PAM$Header$defaultModel = {dT: 1};
var $author$project$CWS$UploadDocuments$Workflow_None = {$: 3};
var $author$project$CWS$UploadDocuments$noWorkflow = $author$project$CWS$UploadDocuments$Workflow_None;
var $author$project$CWS$defaultState = {
	ck: $author$project$CWS$About$defaultModel,
	be: $author$project$CWS$ActionBoard$defaultModel,
	x: $author$project$CWS$ActionDetail$defaultModel,
	gL: $author$project$Map$AGS$Model$defaultModel,
	U: $author$project$CWS$UploadDocuments$defaultModel,
	dc: $author$project$CWS$Approver$Actions$defaultModel,
	dd: $author$project$CWS$Approver$ParticipatingEntities$defaultModel,
	de: $author$project$CWS$Approver$Users$defaultModel,
	aJ: $author$project$CWS$Model$NoConfirmation,
	n: A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$About, $author$project$CWS$Route$None),
	ds: $author$project$PAM$Header$defaultModel,
	a2: $author$project$CWS$Home$defaultModel,
	cJ: $author$project$CWS$Approver$ManageUserParticipatingEntities$defaultModel,
	cK: $author$project$CWS$Approver$ManageParticipatingEntityUsers$defaultModel,
	cM: $elm$core$Dict$empty,
	cS: $author$project$CWS$PeSelect$defaultModel,
	bz: $author$project$CWS$PE$Reports$defaultModel,
	ae: $elm$core$Maybe$Nothing,
	ce: $author$project$CWS$UploadDocuments$noWorkflow,
	r: '2019'
};
var $author$project$CWS$defaultModel = F3(
	function (key, flags, conf) {
		return {
			Y: $author$project$InPageOAuth$defaultModel,
			cq: flags.cq,
			d1: false,
			d3: $elm$core$Dict$empty,
			cv: conf,
			ef: $author$project$CWS$Model$Loading,
			Z: $mdgriffith$elm_ui$Element$classifyDevice(flags.aV),
			p: flags,
			v: key,
			bS: $elm$core$Maybe$Nothing,
			b: $author$project$CWS$defaultLoadableChunks,
			cL: $elm$core$Dict$empty,
			ac: A2(
				$author$project$PAM$UI$Basic$calculatePanelDimensions,
				flags.aV,
				$mdgriffith$elm_ui$Element$classifyDevice(flags.aV)),
			cR: $author$project$CWS$defaultPEHomeMapConfig,
			b3: _List_Nil,
			dH: _List_Nil,
			a: $author$project$CWS$defaultState,
			f: $author$project$PAM$User$LoggedOut,
			w: flags.aV
		};
	});
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$CWS$Flags = F5(
	function (version, settings, size, browser, year) {
		return {cq: browser, m: settings, aV: size, jL: version, r: year};
	});
var $author$project$PAM$Settings$AppSettings = F7(
	function (api, authorization, header, appCofig, professionalViewerUrl, requestAccessLink, registerLink) {
		return {av: api, kg: appCofig, bJ: authorization, hN: header, nl: professionalViewerUrl, nv: registerLink, nw: requestAccessLink};
	});
var $author$project$PAM$Settings$APISettings = F5(
	function (baseURL, version, defaultMethod, useVersion, endpoints) {
		return {km: baseURL, k8: defaultMethod, lh: endpoints, jG: useVersion, jL: version};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$PAM$Settings$Endpoint = F3(
	function (method, useVersion, version) {
		return {ii: method, jG: useVersion, jL: version};
	});
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$PAM$Settings$endpointDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'version',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'useVersion',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'method',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$PAM$Settings$Endpoint))));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$PAM$Settings$apiSettingsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'endpoints',
	$elm$json$Json$Decode$dict($author$project$PAM$Settings$endpointDecoder),
	$elm$core$Dict$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'useVersion',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'defaultMethod',
			$elm$json$Json$Decode$string,
			'POST',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'version',
				$elm$json$Json$Decode$string,
				'v1',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'baseURL',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$PAM$Settings$APISettings))))));
var $author$project$PAM$Settings$AppTypeConfig = F2(
	function (staticLegend, editorTitle) {
		return {le: editorTitle, nZ: staticLegend};
	});
var $author$project$PAM$Settings$appTypeConfigDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'editorTitle',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'staticLegend',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$PAM$Settings$AppTypeConfig)));
var $author$project$PAM$Settings$AuthorizationSettings = F9(
	function (host, clientId, clientSecret, authorizationEndpoint, tokenEndpoint, userInfoEndpoint, unauthorizedRedirect, https, mode) {
		return {gR: authorizationEndpoint, ha: clientId, kI: clientSecret, dt: host, lO: https, mp: mode, jt: tokenEndpoint, oy: unauthorizedRedirect, oF: userInfoEndpoint};
	});
var $author$project$PAM$Settings$OAuth2 = 0;
var $author$project$PAM$Settings$Demo = 1;
var $author$project$PAM$Settings$authModeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (mode) {
		return (mode === 'demo') ? $elm$json$Json$Decode$succeed(1) : ((mode === 'oauth') ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('mode must be one of [ demo, oauth ]'));
	},
	$elm$json$Json$Decode$string);
var $author$project$PAM$Settings$authorizationSettingsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'mode',
	$author$project$PAM$Settings$authModeDecoder,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'useHttps',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'UnauthorizedRedirect',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'UserInfoEndpoint',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'TokenEndpoint',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'AuthorizationEndpoint',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ClientSecret',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'ClientId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'Host',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$PAM$Settings$AuthorizationSettings))))))))));
var $author$project$PAM$Settings$HeaderSettings = F4(
	function (title, logo, headerLinks, userMenuLinks) {
		return {es: headerLinks, ig: logo, jr: title, gu: userMenuLinks};
	});
var $author$project$PAM$Settings$Link = F3(
	function (name, action, requiredRoles) {
		return {c: action, dz: name, cV: requiredRoles};
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$PAM$Settings$linkDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requiredRoles',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'action',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PAM$Settings$Link))));
var $author$project$PAM$Settings$linksDecoder = $elm$json$Json$Decode$list($author$project$PAM$Settings$linkDecoder);
var $author$project$PAM$Settings$linksListDecoder = $elm$json$Json$Decode$list($author$project$PAM$Settings$linksDecoder);
var $author$project$PAM$Settings$LogoConfig = F3(
	function (src, href, alt) {
		return {kd: alt, fC: href, nX: src};
	});
var $author$project$PAM$Settings$logoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'alt',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'href',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'src',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PAM$Settings$LogoConfig))));
var $author$project$PAM$Settings$TitleConfig = F2(
	function (title, subTitle) {
		return {gp: subTitle, jr: title};
	});
var $author$project$PAM$Settings$titleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'subTitle',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PAM$Settings$TitleConfig)));
var $author$project$PAM$Settings$headerSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'userMenuLinks',
	$author$project$PAM$Settings$linksListDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'headerLinks',
		$author$project$PAM$Settings$linksDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'logo',
			$author$project$PAM$Settings$logoDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$author$project$PAM$Settings$titleDecoder,
				$elm$json$Json$Decode$succeed($author$project$PAM$Settings$HeaderSettings)))));
var $author$project$PAM$Settings$appSettingsDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'registerLink',
	$elm$json$Json$Decode$string,
	'/Account/Create',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'requestAccessLink',
		$elm$json$Json$Decode$string,
		'/Contact',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'professionalViewerUrl',
			$elm$json$Json$Decode$string,
			'/Map/Pro',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'appCofig',
				$elm$json$Json$Decode$maybe($author$project$PAM$Settings$appTypeConfigDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'header',
					$author$project$PAM$Settings$headerSettingsDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'Authorization',
						$author$project$PAM$Settings$authorizationSettingsDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'api',
							$author$project$PAM$Settings$apiSettingsDecoder,
							$elm$json$Json$Decode$succeed($author$project$PAM$Settings$AppSettings))))))));
var $author$project$PAM$Settings$Browser = function (type_) {
	return {jE: type_};
};
var $author$project$PAM$Settings$Chrome = 0;
var $author$project$PAM$Settings$Edge = 1;
var $author$project$PAM$Settings$Firefox = 2;
var $author$project$PAM$Settings$InternetExplorer = 5;
var $author$project$PAM$Settings$NotSupported = 6;
var $author$project$PAM$Settings$Opera = 3;
var $author$project$PAM$Settings$Safari = 4;
var $author$project$PAM$Settings$browserTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return $elm$json$Json$Decode$succeed(
			function () {
				switch (s) {
					case 'chrome':
						return 0;
					case 'edge':
						return 1;
					case 'firefox':
						return 2;
					case 'opera':
						return 3;
					case 'safari':
						return 4;
					case 'ie':
						return 5;
					default:
						return 6;
				}
			}());
	},
	$elm$json$Json$Decode$string);
var $author$project$PAM$Settings$browserDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$author$project$PAM$Settings$browserTypeDecoder,
	$elm$json$Json$Decode$succeed($author$project$PAM$Settings$Browser));
var $author$project$PAM$UI$Basic$WindowSize = F2(
	function (width, height) {
		return {lI: height, jR: width};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$PAM$UI$Basic$windowSizeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$PAM$UI$Basic$WindowSize,
	A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int));
var $author$project$CWS$flagsModelDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'year',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'browser',
		$author$project$PAM$Settings$browserDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'size',
			$author$project$PAM$UI$Basic$windowSizeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'settings',
				$author$project$PAM$Settings$appSettingsDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'version',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$CWS$Flags))))));
var $author$project$CWS$Messages$CapturedOAuthMsg = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$CWS$Messages$CapturedUserAuthorized = function (a) {
	return {$: 35, a: a};
};
var $author$project$CWS$Messages$NoOp = {$: 0};
var $author$project$InPageOAuth$translator = F2(
	function (td, msg) {
		if (!msg.$) {
			var m = msg.a;
			return td.cO(m);
		} else {
			return td.mG;
		}
	});
var $author$project$CWS$genericAuthTranslator = function (_return) {
	return $author$project$InPageOAuth$translator(
		{
			mF: $author$project$CWS$Messages$NoOp,
			mG: $author$project$CWS$Messages$CapturedUserAuthorized(_return),
			cO: $author$project$CWS$Messages$CapturedOAuthMsg(_return)
		});
};
var $author$project$CWS$About$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$About$RetrievedContent = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.n_));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {iR: reqs, jk: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.jz;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.iR));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.jk)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					kc: r.kc,
					gZ: r.gZ,
					hv: A2(_Http_mapExpect, func, r.hv),
					hO: r.hO,
					ii: r.ii,
					jp: r.jp,
					jz: r.jz,
					jF: r.jF
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{kc: false, gZ: r.gZ, hv: r.hv, hO: r.hO, ii: r.ii, jp: r.jp, jz: r.jz, jF: r.jF}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{gZ: $elm$http$Http$emptyBody, hv: r.hv, hO: _List_Nil, ii: 'GET', jp: $elm$core$Maybe$Nothing, jz: $elm$core$Maybe$Nothing, jF: r.jF});
};
var $author$project$CWS$About$getAboutContent = F2(
	function (path, msg) {
		return $elm$http$Http$get(
			{
				hv: $elm$http$Http$expectString(msg),
				jF: path
			});
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$CWS$About$init = function (flags) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		A2($elm$json$Json$Decode$field, 'contentPath', $elm$json$Json$Decode$string),
		flags);
	if (!_v0.$) {
		var path = _v0.a;
		return _Utils_Tuple2(
			$author$project$CWS$About$Model('Loading'),
			A2(
				$author$project$CWS$About$getAboutContent,
				path,
				A2($elm$core$Basics$composeR, $author$project$CWS$About$RetrievedContent, $author$project$CWS$About$Internal)));
	} else {
		return _Utils_Tuple2(
			$author$project$CWS$About$Model(''),
			$elm$core$Platform$Cmd$none);
	}
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$PAM$User$Profile = F4(
	function (id, email, name, roles) {
		return {ek: email, ab: id, dz: name, iW: roles};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$PAM$User$openIDDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			$elm$json$Json$Decode$string,
			'error',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sub',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PAM$User$Profile)))));
var $author$project$PAM$User$wrapProfileDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'roles',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PAM$User$Profile)))));
var $author$project$PAM$User$profileDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$PAM$User$wrapProfileDecoder, $author$project$PAM$User$openIDDecoder]));
var $author$project$CWS$oAuthConfig = F2(
	function (settings, origin) {
		var userInfoEndpoint = settings.bJ.oF;
		var tokenEndpoint = settings.bJ.jt;
		var host = settings.bJ.dt;
		var defaultHttpsUrl = {
			fu: $elm$core$Maybe$Nothing,
			dt: '',
			dD: '',
			nf: $elm$core$Maybe$Nothing,
			np: settings.bJ.lO ? 1 : 0,
			iK: $elm$core$Maybe$Nothing
		};
		var authorizationEndpoint = settings.bJ.gR;
		return {
			gR: _Utils_update(
				defaultHttpsUrl,
				{dt: host, dD: authorizationEndpoint}),
			ha: settings.bJ.ha,
			k7: $author$project$PAM$User$profileDecoder,
			nm: _Utils_update(
				defaultHttpsUrl,
				{dt: host, dD: userInfoEndpoint}),
			nt: _Utils_update(
				origin,
				{fu: $elm$core$Maybe$Nothing, dD: '/oAuthHelper.html', iK: $elm$core$Maybe$Nothing}),
			nE: _List_fromArray(
				['profile', 'openid', 'WRAP_Role']),
			nL: settings.bJ.kI,
			jt: _Utils_update(
				defaultHttpsUrl,
				{dt: host, dD: tokenEndpoint})
		};
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Basics$not = _Basics_not;
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {bP: frag, b$: params, bF: unvisited, gv: value, ch: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.ch;
		var unvisited = _v0.bF;
		var params = _v0.b$;
		var frag = _v0.bP;
		var value = _v0.gv;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.ch;
			var unvisited = _v1.bF;
			var params = _v1.b$;
			var frag = _v1.bP;
			var value = _v1.gv;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.ch;
		var unvisited = _v0.bF;
		var params = _v0.b$;
		var frag = _v0.bP;
		var value = _v0.gv;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$CWS$Route$appActionsMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$CWSApprover,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$APP_Actions,
		$elm$url$Url$Parser$s('Actions')));
var $author$project$CWS$Route$APP_Dashboard = {$: 0};
var $author$project$CWS$Route$appDashMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$CWSApprover,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$APP_Dashboard,
		$elm$url$Url$Parser$s('Dashboard')));
var $author$project$CWS$Route$APP_Documents = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Route$HomeRouteModel = F2(
	function (entity, year) {
		return {d: entity, r: year};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.ch;
			var unvisited = _v0.bF;
			var params = _v0.b$;
			var frag = _v0.bP;
			var value = _v0.gv;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $author$project$CWS$Route$homeMapper = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$HomeRouteModel,
			A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$HomeRouteModel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$string,
				A2(
					$elm$url$Url$Parser$custom,
					'Static',
					function (x) {
						return $elm$core$Maybe$Just('0');
					})))
		]));
var $author$project$CWS$Route$appDocsMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$CWSApprover,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$APP_Documents,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('Documents'),
			$author$project$CWS$Route$homeMapper)));
var $author$project$CWS$Route$APP_Users = {$: 1};
var $author$project$CWS$Route$appUsersMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$CWSApprover,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$APP_Users,
		$elm$url$Url$Parser$s('Users')));
var $author$project$CWS$Route$appRouteMatcher = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('Approver'),
	$elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[$author$project$CWS$Route$appDashMatcher, $author$project$CWS$Route$appUsersMatcher, $author$project$CWS$Route$appActionsMatcher, $author$project$CWS$Route$appDocsMatcher])));
var $author$project$CWS$Route$aboutMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$About,
	$elm$url$Url$Parser$s('About'));
var $author$project$CWS$Route$NotSelected = {$: 1};
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$CWS$Route$notSelectedMatcher = A2($elm$url$Url$Parser$map, $author$project$CWS$Route$NotSelected, $elm$url$Url$Parser$top);
var $author$project$CWS$Route$baseRouteMatcher = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[$author$project$CWS$Route$aboutMatcher, $author$project$CWS$Route$notSelectedMatcher]));
var $author$project$CWS$Route$ActionDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Route$ActionDetailsRouteModel = function (id) {
	return {ab: id};
};
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $author$project$CWS$Route$actionDetailsMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$ActionDetails,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$ActionDetailsRouteModel,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('Action'),
			$elm$url$Url$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('View'),
						$elm$url$Url$Parser$int),
						A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('New'),
						A2(
							$elm$url$Url$Parser$custom,
							'Static',
							function (x) {
								return $elm$core$Maybe$Just(-1);
							}))
					])))));
var $author$project$CWS$Route$APP_Modal_ActionDetails = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Route$CWSApproverModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Route$app_actionDetailsMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$CWSApproverModal,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$APP_Modal_ActionDetails,
		A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$ActionDetailsRouteModel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('Action'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('View'),
					$elm$url$Url$Parser$int)))));
var $author$project$CWS$Route$APP_Modal_AllDocuments = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Route$app_allDocumentsMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$CWSApproverModal,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$APP_Modal_AllDocuments,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('Documents'),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('View'),
				$author$project$CWS$Route$homeMapper))));
var $author$project$CWS$Route$APP_Modal_Manage_User_PEs = function (a) {
	return {$: 4, a: a};
};
var $author$project$CWS$Route$ManagePEsModel = function (user) {
	return {f: user};
};
var $author$project$CWS$Route$app_manageUserMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$CWSApproverModal,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$APP_Modal_Manage_User_PEs,
		A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$ManagePEsModel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('Manage'),
				$elm$url$Url$Parser$string))));
var $author$project$CWS$Route$APP_Modal_Manage_PE_Users = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Route$PERouteModel = function (entity) {
	return {d: entity};
};
var $author$project$CWS$Route$app_manageUsersMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$CWSApproverModal,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$APP_Modal_Manage_PE_Users,
		A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$PERouteModel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('Users'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('Manage'),
					$elm$url$Url$Parser$string)))));
var $author$project$CWS$Route$NewActionDetails = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Route$NewActionDetailsRouteModel = F2(
	function (category, group) {
		return {bK: category, hM: group};
	});
var $author$project$CWS$Route$newActionDetailsMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$NewActionDetails,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$NewActionDetailsRouteModel,
		A2(
			$elm$url$Url$Parser$slash,
			$elm$url$Url$Parser$s('Action'),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('New'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)))));
var $author$project$CWS$Route$noModalMatcher = A2($elm$url$Url$Parser$map, $author$project$CWS$Route$None, $elm$url$Url$Parser$top);
var $author$project$CWS$Route$modalRouteMatcher = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[$author$project$CWS$Route$actionDetailsMatcher, $author$project$CWS$Route$newActionDetailsMatcher, $author$project$CWS$Route$app_allDocumentsMatcher, $author$project$CWS$Route$app_actionDetailsMatcher, $author$project$CWS$Route$app_manageUsersMatcher, $author$project$CWS$Route$app_manageUserMatcher, $author$project$CWS$Route$noModalMatcher]));
var $author$project$CWS$Route$ParticipatingEntity = function (a) {
	return {$: 4, a: a};
};
var $author$project$CWS$Route$ActionsRouteModel = F2(
	function (entity, category) {
		return {bK: category, d: entity};
	});
var $author$project$CWS$Route$PE_Actions = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Route$actionMatcher2 = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$PE_Actions,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$ActionsRouteModel,
		A2(
			$elm$url$Url$Parser$slash,
			$author$project$CWS$Route$homeMapper,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('Actions'),
				$elm$url$Url$Parser$oneOf(
					_List_fromArray(
						[
							$elm$url$Url$Parser$string,
							A2(
							$elm$url$Url$Parser$custom,
							'Static',
							function (x) {
								return $elm$core$Maybe$Just('All');
							})
						]))))));
var $author$project$CWS$Route$actionsMatcher = A2($elm$url$Url$Parser$map, $author$project$CWS$Route$ParticipatingEntity, $author$project$CWS$Route$actionMatcher2);
var $author$project$CWS$Route$AllDocumentsModel = function (entity) {
	return {d: entity};
};
var $author$project$CWS$Route$PE_AllDocuments = function (a) {
	return {$: 4, a: a};
};
var $author$project$CWS$Route$allDocumentsMatcher2 = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$PE_AllDocuments,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$AllDocumentsModel,
		A2(
			$elm$url$Url$Parser$slash,
			$author$project$CWS$Route$homeMapper,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('Documents'),
				$elm$url$Url$Parser$s('All')))));
var $author$project$CWS$Route$allDocumentsMatcher = A2($elm$url$Url$Parser$map, $author$project$CWS$Route$ParticipatingEntity, $author$project$CWS$Route$allDocumentsMatcher2);
var $author$project$CWS$Route$Error = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Route$simpleNotImplementedErrorMatcher = F2(
	function (mod, path) {
		return A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$Error(mod + ' has not been implemented yet'),
			$elm$url$Url$Parser$s(path));
	});
var $author$project$CWS$Route$cwppDocumentMatcher = A2($author$project$CWS$Route$simpleNotImplementedErrorMatcher, 'CWPP Document', 'CWPPDocument');
var $author$project$CWS$Route$PE_Home = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$Route$homeMatcher2 = A2(
	$elm$url$Url$Parser$slash,
	A2($elm$url$Url$Parser$map, $author$project$CWS$Route$PE_Home, $author$project$CWS$Route$homeMapper),
	$elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[
				$elm$url$Url$Parser$s('Home'),
				$elm$url$Url$Parser$top
			])));
var $author$project$CWS$Route$homeMatcher = A2($elm$url$Url$Parser$map, $author$project$CWS$Route$ParticipatingEntity, $author$project$CWS$Route$homeMatcher2);
var $author$project$CWS$Route$participationAgreementMatcher = A2($author$project$CWS$Route$simpleNotImplementedErrorMatcher, 'Participation Agreement', 'ParticipationAgreement');
var $author$project$CWS$Route$PE_PESelect = {$: 5};
var $author$project$CWS$Route$peSelectMatcher2 = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$PE_PESelect,
	$elm$url$Url$Parser$s('Select'));
var $author$project$CWS$Route$peSelectMatcher = A2($elm$url$Url$Parser$map, $author$project$CWS$Route$ParticipatingEntity, $author$project$CWS$Route$peSelectMatcher2);
var $author$project$CWS$Route$Reports = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$CWS$Route$Summary = 0;
var $author$project$CWS$Route$summaryReportMatacher = A2(
	$elm$url$Url$Parser$map,
	0,
	$elm$url$Url$Parser$s('Summary'));
var $author$project$CWS$Route$reportsMatcher = A2(
	$elm$url$Url$Parser$map,
	$author$project$CWS$Route$ParticipatingEntity,
	A2(
		$elm$url$Url$Parser$map,
		$author$project$CWS$Route$Reports,
		A2(
			$elm$url$Url$Parser$slash,
			A2(
				$elm$url$Url$Parser$map,
				$author$project$CWS$Route$HomeRouteModel,
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('Reports'),
				$elm$url$Url$Parser$oneOf(
					_List_fromArray(
						[$author$project$CWS$Route$summaryReportMatacher]))))));
var $author$project$CWS$Route$peRouteMatcher = A2(
	$elm$url$Url$Parser$slash,
	$elm$url$Url$Parser$s('PE'),
	$elm$url$Url$Parser$oneOf(
		_List_fromArray(
			[$author$project$CWS$Route$aboutMatcher, $author$project$CWS$Route$homeMatcher, $author$project$CWS$Route$actionsMatcher, $author$project$CWS$Route$cwppDocumentMatcher, $author$project$CWS$Route$participationAgreementMatcher, $author$project$CWS$Route$allDocumentsMatcher, $author$project$CWS$Route$peSelectMatcher, $author$project$CWS$Route$reportsMatcher, $author$project$CWS$Route$notSelectedMatcher])));
var $author$project$CWS$Route$matchers = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$FullRoute,
			A2($elm$url$Url$Parser$slash, $author$project$CWS$Route$appRouteMatcher, $author$project$CWS$Route$modalRouteMatcher)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$FullRoute,
			A2($elm$url$Url$Parser$slash, $author$project$CWS$Route$peRouteMatcher, $author$project$CWS$Route$modalRouteMatcher)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$CWS$Route$FullRoute,
			A2($elm$url$Url$Parser$slash, $author$project$CWS$Route$baseRouteMatcher, $author$project$CWS$Route$modalRouteMatcher))
		]));
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.bF;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.gv);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.gv);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.dD),
					$elm$url$Url$Parser$prepareQuery(url.iK),
					url.fu,
					$elm$core$Basics$identity)));
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$CWS$Route$parseLocation = function (url) {
	var parts = A2(
		$elm_community$list_extra$List$Extra$filterNot,
		$elm$core$String$isEmpty,
		A2(
			$elm$core$String$split,
			'?',
			A2($elm$core$Maybe$withDefault, '', url.fu)));
	var _v0 = function () {
		if (!parts.b) {
			return _Utils_Tuple2('', $elm$core$Maybe$Nothing);
		} else {
			if (!parts.b.b) {
				var p = parts.a;
				return _Utils_Tuple2(p, $elm$core$Maybe$Nothing);
			} else {
				var p = parts.a;
				var _v2 = parts.b;
				var q = _v2.a;
				return _Utils_Tuple2(
					p,
					$elm$core$Maybe$Just(q));
			}
		}
	}();
	var path = _v0.a;
	var query = _v0.b;
	var _v3 = A2(
		$elm$url$Url$Parser$parse,
		$author$project$CWS$Route$matchers,
		_Utils_update(
			url,
			{fu: $elm$core$Maybe$Nothing, dD: path, iK: query}));
	if (!_v3.$) {
		var route = _v3.a;
		return route;
	} else {
		return A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$About, $author$project$CWS$Route$None);
	}
};
var $author$project$CWS$Model$ReferenceLayer = F6(
	function (name, url, tokenKey, outFields, whereField, nameField) {
		return {dz: name, mw: nameField, m8: outFields, or: tokenKey, jF: url, oJ: whereField};
	});
var $author$project$CWS$Model$referenceLayerDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'nameField',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'whereField',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'outFields',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tokenKey',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$CWS$Model$ReferenceLayer)))))));
var $author$project$CWS$Model$referenceLayersDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$referenceLayerDecoder);
var $author$project$InPageOAuth$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$InPageOAuth$Timeout = {$: 1};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$InPageOAuth$bindToAuthFrame = _Platform_outgoingPort(
	'bindToAuthFrame',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$InPageOAuth$regetAuthorization = function (model) {
	return (!_Utils_eq(model.a, $author$project$InPageOAuth$NotStarted)) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{a: $author$project$InPageOAuth$NotStarted}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						$author$project$InPageOAuth$Internal($author$project$InPageOAuth$Timeout)),
					$elm$core$Process$sleep(100)),
					$author$project$InPageOAuth$bindToAuthFrame(0)
				]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$InPageOAuth$setParameters = F3(
	function (model, oAuth, settings) {
		return _Utils_update(
			model,
			{
				kh: $elm$core$Maybe$Just(settings),
				hd: $elm$core$Maybe$Just(oAuth)
			});
	});
var $author$project$CWS$init = F3(
	function (flags, url, key) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$CWS$flagsModelDecoder, flags);
		if (!_v0.$) {
			var flagData = _v0.a;
			var parsedTargetRoute = $author$project$CWS$Route$parseLocation(url);
			var targetRoute = function () {
				var _v8 = parsedTargetRoute.z;
				if (_v8.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(parsedTargetRoute);
				}
			}();
			var oAuth = A2($author$project$CWS$oAuthConfig, flagData.m, url);
			var dft = A3($author$project$CWS$defaultModel, key, flagData, flags);
			var decodedRefLayers = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, 'refLayers', $author$project$CWS$Model$referenceLayersDecoder),
				flags);
			var aboutRoute = A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$About, $author$project$CWS$Route$None);
			var _v1 = function (_v2) {
				var a = _v2.a;
				var b = _v2.b;
				return _Utils_Tuple2(
					a,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$CWS$genericAuthTranslator(0),
						b));
			}(
				$author$project$InPageOAuth$regetAuthorization(
					A3($author$project$InPageOAuth$setParameters, $author$project$InPageOAuth$defaultModel, oAuth, flagData.m)));
			var newOAuthModel = _v1.a;
			var newOAuthCmds = _v1.b;
			var _v3 = function () {
				var _v4 = A2(
					$elm$json$Json$Decode$decodeValue,
					A2($elm$json$Json$Decode$field, 'about', $elm$json$Json$Decode$value),
					flags);
				if (!_v4.$) {
					var abt = _v4.a;
					var _v5 = $author$project$CWS$About$init(abt);
					var a = _v5.a;
					var b = _v5.b;
					return _Utils_Tuple2(
						a,
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$aboutTranslator, b));
				} else {
					return _Utils_Tuple2($author$project$CWS$About$defaultModel, $elm$core$Platform$Cmd$none);
				}
			}();
			var newAbout = _v3.a;
			var aboutCmds = _v3.b;
			var newState = _Utils_update(
				$author$project$CWS$defaultState,
				{ck: newAbout, ae: targetRoute});
			var newModel = _Utils_update(
				dft,
				{
					Y: newOAuthModel,
					dH: function () {
						if (!decodedRefLayers.$) {
							var refs = decodedRefLayers.a;
							return refs;
						} else {
							return _List_Nil;
						}
					}(),
					a: newState
				});
			var _v6 = _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			var postRouteModel = _v6.a;
			var newCmds = _v6.b;
			return _Utils_Tuple2(
				$author$project$CWS$AppLoaded(postRouteModel),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[newCmds, aboutCmds, newOAuthCmds])));
		} else {
			var msg = _v0.a;
			return _Utils_Tuple2(
				$author$project$CWS$AppFailed('Failed to load'),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$Messages$ActionDetailMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$CWS$Messages$FileUploadMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$CWS$Messages$FileUploadWorkflowMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$CWS$Messages$HomeMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Messages$ReportsMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$CWS$Messages$WindowResized = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {iD: pids, jk: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {hu: event, v: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.iD,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.v;
		var event = _v0.hu;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.jk);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$CWS$ActionDetail$UploadDocumentsMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$ActionDetail$MapMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$CWS$ActionDetail$MapUpdating = {$: 36};
var $author$project$CWS$ActionDetail$NoOp = {$: 0};
var $author$project$CWS$ActionDetail$SpatialChanged = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$CWS$DrawEditMap$apiTranslator = F2(
	function (td, msg) {
		switch (msg.$) {
			case 0:
				var m = msg.a;
				return td.cO(m);
			case 1:
				var id = msg.a;
				return td.mP(id);
			case 2:
				return td.mE;
			case 3:
				var val = msg.a;
				var all = msg.b;
				return A2(td.m$, val, all);
			default:
				return td.m0;
		}
	});
var $author$project$CWS$ActionDetail$mapTranslater = $author$project$CWS$DrawEditMap$apiTranslator(
	{
		mE: $author$project$CWS$ActionDetail$NoOp,
		mP: function (a) {
			return $author$project$CWS$ActionDetail$NoOp;
		},
		cO: $author$project$CWS$ActionDetail$MapMsg,
		m$: $author$project$CWS$ActionDetail$SpatialChanged,
		m0: $author$project$CWS$ActionDetail$MapUpdating
	});
var $author$project$CWS$DrawEditMap$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$DrawEditMap$MultiMessage = function (a) {
	return {$: 19, a: a};
};
var $author$project$CWS$DrawEditMap$Toolbox = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$DrawEditMap$ColorUnderPointerMessage = function (a) {
	return {$: 6, a: a};
};
var $author$project$CWS$DrawEditMap$UpdateColor = function (a) {
	return {$: 15, a: a};
};
var $author$project$PlugMap$Plugins$ColorUnderPointer$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$ColorUnderPointer$apiTranslator = F2(
	function (td, msg) {
		if (!msg.$) {
			var m = msg.a;
			return td.cO(
				$author$project$PlugMap$Plugins$ColorUnderPointer$Internal(m));
		} else {
			var color = msg.a;
			return td.mU(color);
		}
	});
var $author$project$CWS$DrawEditMap$colorUnderPointerTranslator = $author$project$PlugMap$Plugins$ColorUnderPointer$apiTranslator(
	{
		cO: function (msg) {
			return $author$project$CWS$DrawEditMap$Internal(
				$author$project$CWS$DrawEditMap$ColorUnderPointerMessage(msg));
		},
		mU: function (a) {
			return $author$project$CWS$DrawEditMap$Internal(
				$author$project$CWS$DrawEditMap$UpdateColor(
					$elm$core$Maybe$Just(a)));
		}
	});
var $author$project$CWS$DrawEditMap$DrawingMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$PlugMap$Plugins$Drawing$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$Drawing$apiTranslator = F2(
	function (td, msg) {
		switch (msg.$) {
			case 0:
				var m = msg.a;
				return td.cO(
					$author$project$PlugMap$Plugins$Drawing$Internal(m));
			case 1:
				return td.mJ;
			case 2:
				var spatial = msg.a;
				return td.mI(spatial);
			case 3:
				var spatial = msg.a;
				return td.mT(spatial);
			case 4:
				var flat = msg.a;
				return td.mV(flat);
			default:
				var flat = msg.a;
				return td.mW(flat);
		}
	});
var $author$project$CWS$DrawEditMap$AddShape = function (a) {
	return {$: 8, a: a};
};
var $author$project$CWS$DrawEditMap$drawEnd = function (shp) {
	return $author$project$CWS$DrawEditMap$Internal(
		$author$project$CWS$DrawEditMap$Toolbox(
			$author$project$CWS$DrawEditMap$AddShape(
				{bH: shp.bH, ab: shp.ab, jE: shp.jE, bc: shp.bc})));
};
var $author$project$CWS$DrawEditMap$LockUpdating = {$: 29};
var $author$project$CWS$DrawEditMap$drawStart = $author$project$CWS$DrawEditMap$Internal(
	$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$LockUpdating));
var $author$project$CWS$DrawEditMap$ModifyEnd = function (a) {
	return {$: 11, a: a};
};
var $author$project$CWS$DrawEditMap$modifyEnd = function (spatial) {
	return $author$project$CWS$DrawEditMap$Internal(
		$author$project$CWS$DrawEditMap$Toolbox(
			$author$project$CWS$DrawEditMap$ModifyEnd(spatial)));
};
var $author$project$CWS$DrawEditMap$FlatRecalculated = function (a) {
	return {$: 12, a: a};
};
var $author$project$CWS$DrawEditMap$onRecalculatedFlat = function (flat) {
	return $author$project$CWS$DrawEditMap$Internal(
		$author$project$CWS$DrawEditMap$Toolbox(
			$author$project$CWS$DrawEditMap$FlatRecalculated(flat)));
};
var $author$project$CWS$DrawEditMap$FlatReeceived = function (a) {
	return {$: 9, a: a};
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$CWS$DrawEditMap$onReceivedFlat = function (flat) {
	return $author$project$CWS$DrawEditMap$Internal(
		$author$project$CWS$DrawEditMap$Toolbox(
			$author$project$CWS$DrawEditMap$FlatReeceived(
				A2(
					$elm$core$Maybe$map,
					function (shp) {
						return {bH: shp.bH, ab: shp.ab, jE: shp.jE, bc: shp.bc};
					},
					flat))));
};
var $author$project$CWS$DrawEditMap$drawingTranslator = $author$project$PlugMap$Plugins$Drawing$apiTranslator(
	{
		mI: $author$project$CWS$DrawEditMap$drawEnd,
		mJ: $author$project$CWS$DrawEditMap$drawStart,
		cO: A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$CWS$DrawEditMap$Internal, $author$project$CWS$DrawEditMap$Toolbox),
			$author$project$CWS$DrawEditMap$DrawingMsg),
		mT: $author$project$CWS$DrawEditMap$modifyEnd,
		mV: $author$project$CWS$DrawEditMap$onRecalculatedFlat,
		mW: $author$project$CWS$DrawEditMap$onReceivedFlat
	});
var $author$project$CWS$DrawEditMap$FeatureLoading = {$: 28};
var $author$project$CWS$DrawEditMap$FeaturePickerMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$CWS$DrawEditMap$FeaturesLoadError = function (a) {
	return {$: 22, a: a};
};
var $author$project$CWS$DrawEditMap$FeaturesLoaded = function (a) {
	return {$: 21, a: a};
};
var $author$project$CWS$DrawEditMap$FeaturesSelected = function (a) {
	return {$: 23, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$apiTranslator = F2(
	function (td, msg) {
		switch (msg.$) {
			case 0:
				var m = msg.a;
				return td.cO(m);
			case 1:
				var feats = msg.a;
				return td.mN(feats);
			case 2:
				var feats = msg.a;
				return td.mM(feats);
			case 3:
				var err = msg.a;
				return td.mL(err);
			default:
				return td.mK;
		}
	});
var $author$project$CWS$DrawEditMap$featurePickerTranslator = $author$project$PlugMap$Plugins$FeaturePicker$apiTranslator(
	{
		mK: $author$project$CWS$DrawEditMap$Internal(
			$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$FeatureLoading)),
		mL: A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$CWS$DrawEditMap$Internal, $author$project$CWS$DrawEditMap$Toolbox),
			$author$project$CWS$DrawEditMap$FeaturesLoadError),
		mM: A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$CWS$DrawEditMap$Internal, $author$project$CWS$DrawEditMap$Toolbox),
			$author$project$CWS$DrawEditMap$FeaturesLoaded),
		mN: A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$CWS$DrawEditMap$Internal, $author$project$CWS$DrawEditMap$Toolbox),
			$author$project$CWS$DrawEditMap$FeaturesSelected),
		cO: A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$CWS$DrawEditMap$Internal, $author$project$CWS$DrawEditMap$Toolbox),
			$author$project$CWS$DrawEditMap$FeaturePickerMsg)
	});
var $author$project$CWS$DrawEditMap$GetDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$DrawEditMap$IdentifyMessage = function (a) {
	return {$: 7, a: a};
};
var $author$project$PlugMap$Plugins$Identify$apiTranslator = F2(
	function (td, msg) {
		if (!msg.$) {
			var m = msg.a;
			return td.cO(m);
		} else {
			var id = msg.a;
			return td.mP(id);
		}
	});
var $author$project$CWS$DrawEditMap$identifyTranslator = $author$project$PlugMap$Plugins$Identify$apiTranslator(
	{
		mP: $author$project$CWS$DrawEditMap$GetDetails,
		cO: function (id) {
			return $author$project$CWS$DrawEditMap$Internal(
				$author$project$CWS$DrawEditMap$IdentifyMessage(id));
		}
	});
var $inkuzmin$elm_multiselect$Multiselect$Click = {$: 1};
var $inkuzmin$elm_multiselect$Multiselect$Opened = 2;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $inkuzmin$elm_multiselect$Multiselect$subscriptions = function (_v0) {
	var model = _v0;
	return (model.jf === 2) ? $elm$browser$Browser$Events$onClick(
		$elm$json$Json$Decode$succeed($inkuzmin$elm_multiselect$Multiselect$Click)) : $elm$core$Platform$Sub$none;
};
var $author$project$PlugMap$Plugins$ColorUnderPointer$colorChanged = _Platform_incomingPort('colorChanged', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$ColorUnderPointer$I_NoOp = {$: 0};
var $author$project$PlugMap$Plugins$ColorUnderPointer$NewColor = function (a) {
	return {$: 1, a: a};
};
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$PlugMap$Plugins$ColorUnderPointer$colorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'b',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'g',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'r',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($avh4$elm_color$Color$rgb255))));
var $author$project$PlugMap$Plugins$ColorUnderPointer$handleColorChange = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PlugMap$Plugins$ColorUnderPointer$colorDecoder, value);
	if (!_v0.$) {
		var color = _v0.a;
		return $author$project$PlugMap$Plugins$ColorUnderPointer$NewColor(color);
	} else {
		return $author$project$PlugMap$Plugins$ColorUnderPointer$Internal($author$project$PlugMap$Plugins$ColorUnderPointer$I_NoOp);
	}
};
var $author$project$PlugMap$Plugins$ColorUnderPointer$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$PlugMap$Plugins$ColorUnderPointer$colorChanged($author$project$PlugMap$Plugins$ColorUnderPointer$handleColorChange)
			]));
};
var $author$project$PlugMap$Plugins$Drawing$DrawingStart = {$: 1};
var $author$project$PlugMap$Plugins$Drawing$NoOp = 0;
var $author$project$PlugMap$Plugins$Drawing$drawingEnd = _Platform_incomingPort(
	'drawingEnd',
	$elm$json$Json$Decode$null(0));
var $author$project$PlugMap$Plugins$Drawing$drawingEnded = _Platform_incomingPort('drawingEnded', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$Drawing$drawingStarted = _Platform_incomingPort(
	'drawingStarted',
	$elm$json$Json$Decode$null(0));
var $author$project$PlugMap$Plugins$Drawing$flattened = _Platform_incomingPort('flattened', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$Drawing$DrawingEnd = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMap$Plugins$Drawing$ISpatial = F4(
	function (type_, wkt, acres, id) {
		return {bH: acres, ab: id, jE: type_, bc: wkt};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$PlugMap$Plugins$Drawing$spatialDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'acres',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'wkt',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type_',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Drawing$ISpatial)))));
var $author$project$PlugMap$Plugins$Drawing$handleDrawingEnded = function (val) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PlugMap$Plugins$Drawing$spatialDecoder, val);
	if (!_v0.$) {
		var spat = _v0.a;
		return $author$project$PlugMap$Plugins$Drawing$DrawingEnd(spat);
	} else {
		var err = _v0.a;
		return $author$project$PlugMap$Plugins$Drawing$Internal(0);
	}
};
var $author$project$PlugMap$Plugins$Drawing$ReceivedFlat = function (a) {
	return {$: 5, a: a};
};
var $author$project$PlugMap$Plugins$Drawing$handleFlattened = function (val) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		$elm$json$Json$Decode$maybe($author$project$PlugMap$Plugins$Drawing$spatialDecoder),
		val);
	if (!_v0.$) {
		var flat = _v0.a;
		return $author$project$PlugMap$Plugins$Drawing$ReceivedFlat(flat);
	} else {
		var err = _v0.a;
		return $author$project$PlugMap$Plugins$Drawing$Internal(0);
	}
};
var $author$project$PlugMap$Plugins$Drawing$ModifyEnd = function (a) {
	return {$: 3, a: a};
};
var $author$project$PlugMap$Plugins$Drawing$ModifiedSpatial = function (modifiedShapes) {
	return {mr: modifiedShapes};
};
var $author$project$PlugMap$Plugins$Drawing$SimpleSpatial = F5(
	function (type_, wkt, acres, id, ol_uid) {
		return {bH: acres, ab: id, mB: ol_uid, jE: type_, bc: wkt};
	});
var $author$project$PlugMap$Plugins$Drawing$simpleSpatialDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ol_uid',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'acres',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'wkt',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'type_',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Drawing$SimpleSpatial))))));
var $author$project$PlugMap$Plugins$Drawing$modifiedSpatialDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'modifiedShapes',
	$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Drawing$simpleSpatialDecoder),
	$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Drawing$ModifiedSpatial));
var $author$project$PlugMap$Plugins$Drawing$handleModifyEnd = function (val) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PlugMap$Plugins$Drawing$modifiedSpatialDecoder, val);
	if (!_v0.$) {
		var spat = _v0.a;
		return $author$project$PlugMap$Plugins$Drawing$ModifyEnd(spat);
	} else {
		var err = _v0.a;
		return $author$project$PlugMap$Plugins$Drawing$Internal(0);
	}
};
var $author$project$PlugMap$Plugins$Drawing$RecalculatedFlat = function (a) {
	return {$: 4, a: a};
};
var $author$project$PlugMap$Plugins$Drawing$FlatRecalc = F2(
	function (flat, flatArea) {
		return {ay: flat, lz: flatArea};
	});
var $author$project$PlugMap$Plugins$Drawing$flatRecalcDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'flatArea',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'flat',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Drawing$FlatRecalc)));
var $author$project$PlugMap$Plugins$Drawing$handleRecalcEnd = function (val) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		$elm$json$Json$Decode$maybe($author$project$PlugMap$Plugins$Drawing$flatRecalcDecoder),
		val);
	if (!_v0.$) {
		var flat = _v0.a;
		return $author$project$PlugMap$Plugins$Drawing$RecalculatedFlat(flat);
	} else {
		var err = _v0.a;
		return $author$project$PlugMap$Plugins$Drawing$Internal(0);
	}
};
var $author$project$PlugMap$Plugins$Drawing$modifyEnd = _Platform_incomingPort('modifyEnd', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$Drawing$recalcEnded = _Platform_incomingPort('recalcEnded', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$Drawing$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$PlugMap$Plugins$Drawing$drawingStarted(
				$elm$core$Basics$always($author$project$PlugMap$Plugins$Drawing$DrawingStart)),
				$author$project$PlugMap$Plugins$Drawing$drawingEnded($author$project$PlugMap$Plugins$Drawing$handleDrawingEnded),
				$author$project$PlugMap$Plugins$Drawing$flattened($author$project$PlugMap$Plugins$Drawing$handleFlattened),
				$author$project$PlugMap$Plugins$Drawing$drawingEnd(
				$elm$core$Basics$always(
					$author$project$PlugMap$Plugins$Drawing$Internal(0))),
				$author$project$PlugMap$Plugins$Drawing$modifyEnd($author$project$PlugMap$Plugins$Drawing$handleModifyEnd),
				$author$project$PlugMap$Plugins$Drawing$recalcEnded($author$project$PlugMap$Plugins$Drawing$handleRecalcEnd)
			]));
};
var $author$project$PlugMap$Plugins$FeaturePicker$featureSelected = _Platform_incomingPort('featureSelected', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$FeaturePicker$FeatureClicked = function (a) {
	return {$: 6, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$NoOp = {$: 0};
var $author$project$PlugMap$Plugins$FeaturePicker$featureSelectedProcess = F2(
	function (model, val) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, val);
		if (!_v0.$) {
			var id = _v0.a;
			var _int = A2(
				$elm$core$Maybe$withDefault,
				-1,
				$elm$core$String$toInt(id));
			return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
				$author$project$PlugMap$Plugins$FeaturePicker$FeatureClicked(_int));
		} else {
			var err = _v0.a;
			return $author$project$PlugMap$Plugins$FeaturePicker$Internal($author$project$PlugMap$Plugins$FeaturePicker$NoOp);
		}
	});
var $author$project$PlugMap$Plugins$FeaturePicker$EsriRespondedConvert = function (a) {
	return {$: 4, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$EsriRespondedConvertError = function (a) {
	return {$: 5, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$NormalizeEsriRequest = F4(
	function (from, esri, value, showGeometry) {
		return {fm: esri, eq: from, gk: showGeometry, gv: value};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$Select = 0;
var $author$project$PlugMap$Plugins$FeaturePicker$SetLayer = 1;
var $author$project$PlugMap$Plugins$FeaturePicker$decodeResponseFrom = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			(val === 'Select') ? 0 : ((val === 'SetLayer') ? 1 : 1));
	},
	$elm$json$Json$Decode$string);
var $author$project$PlugMap$Plugins$FeaturePicker$EsriResponse = function (features) {
	return {dp: features};
};
var $author$project$PlugMap$Plugins$FeaturePicker$EsriFeature = F2(
	function (properties, geometry) {
		return {lD: geometry, b5: properties};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$Esri_Float = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$Esri_Int = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$Esri_Nil = {$: 3};
var $author$project$PlugMap$Plugins$FeaturePicker$Esri_String = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$decodeEsriProperty = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (v) {
				return $elm$json$Json$Decode$succeed(
					$author$project$PlugMap$Plugins$FeaturePicker$Esri_String(v));
			},
			$elm$json$Json$Decode$string),
			A2(
			$elm$json$Json$Decode$andThen,
			function (v) {
				return $elm$json$Json$Decode$succeed(
					$author$project$PlugMap$Plugins$FeaturePicker$Esri_Int(v));
			},
			$elm$json$Json$Decode$int),
			A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$PlugMap$Plugins$FeaturePicker$Esri_Float),
			$elm$json$Json$Decode$float),
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$Esri_Nil)
		]));
var $author$project$PlugMap$Plugins$FeaturePicker$decodeEsriFeature = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'geometry',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'properties',
		$elm$json$Json$Decode$dict($author$project$PlugMap$Plugins$FeaturePicker$decodeEsriProperty),
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$EsriFeature)));
var $author$project$PlugMap$Plugins$FeaturePicker$decodeEsriFeatures = $elm$json$Json$Decode$list($author$project$PlugMap$Plugins$FeaturePicker$decodeEsriFeature);
var $author$project$PlugMap$Plugins$FeaturePicker$esriResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'features',
	$author$project$PlugMap$Plugins$FeaturePicker$decodeEsriFeatures,
	$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$EsriResponse));
var $author$project$PlugMap$Plugins$FeaturePicker$decodeNormalizeEsri = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'showGeometry',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$maybe($author$project$PlugMap$Plugins$FeaturePicker$esriResponseDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'esri',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'from',
				$author$project$PlugMap$Plugins$FeaturePicker$decodeResponseFrom,
				$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$NormalizeEsriRequest)))));
var $author$project$PlugMap$Plugins$FeaturePicker$normalizeEsriProcess = function (value) {
	var ret = A2($elm$json$Json$Decode$decodeValue, $author$project$PlugMap$Plugins$FeaturePicker$decodeNormalizeEsri, value);
	if (!ret.$) {
		var resp = ret.a;
		return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
			$author$project$PlugMap$Plugins$FeaturePicker$EsriRespondedConvert(resp));
	} else {
		var err = ret.a;
		return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
			$author$project$PlugMap$Plugins$FeaturePicker$EsriRespondedConvertError('normalize'));
	}
};
var $author$project$PlugMap$Plugins$FeaturePicker$normalizeEsriResult = _Platform_incomingPort('normalizeEsriResult', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$FeaturePicker$FeaturesLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$WfsResult = F2(
	function (attributes, wfsMembers) {
		return {kk: attributes, jQ: wfsMembers};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$WfsMember = F2(
	function (typeName, properties) {
		return {b5: properties, ox: typeName};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$Nil = {$: 0};
var $author$project$PlugMap$Plugins$FeaturePicker$Text = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$decodeWFSProperty = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'_text',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$Text)),
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$Nil)
		]));
var $author$project$PlugMap$Plugins$FeaturePicker$decodeWFSMembers = A2(
	$elm$json$Json$Decode$andThen,
	function (itms) {
		return $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					function (collection) {
						return A2(
							$elm$core$Maybe$map,
							function (_v0) {
								var typeName = _v0.a;
								var props = _v0.b;
								return A2($author$project$PlugMap$Plugins$FeaturePicker$WfsMember, typeName, props);
							},
							$elm$core$List$head(
								$elm$core$Dict$toList(collection)));
					},
					itms)));
	},
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$dict(
			$elm$json$Json$Decode$dict($author$project$PlugMap$Plugins$FeaturePicker$decodeWFSProperty))));
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$PlugMap$Plugins$FeaturePicker$WfsAttributes = {};
var $author$project$PlugMap$Plugins$FeaturePicker$wfsAttributesDecoder = $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$WfsAttributes);
var $author$project$PlugMap$Plugins$FeaturePicker$wfsResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['wfs:FeatureCollection', 'wfs:member']),
	$author$project$PlugMap$Plugins$FeaturePicker$decodeWFSMembers,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['wfs:FeatureCollection', '_attributes']),
		$author$project$PlugMap$Plugins$FeaturePicker$wfsAttributesDecoder,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$WfsResult)));
var $author$project$PlugMap$Plugins$FeaturePicker$wfsMemberToFeature = function (member) {
	return {
		bH: $elm$core$Maybe$Nothing,
		lD: $elm$core$Maybe$Nothing,
		ab: A2(
			$elm$core$Maybe$withDefault,
			-1,
			A2(
				$elm$core$Maybe$map,
				function (val) {
					if (val.$ === 1) {
						var i = val.a;
						return A2(
							$elm$core$Maybe$withDefault,
							-1,
							$elm$core$String$toInt(i));
					} else {
						return -1;
					}
				},
				A2($elm$core$Dict$get, 'utwrap_PAM:id', member.b5))),
		dz: A2(
			$elm$core$Maybe$withDefault,
			'Unknown',
			A2(
				$elm$core$Maybe$map,
				function (val) {
					if (val.$ === 1) {
						var i = val.a;
						return i;
					} else {
						return 'Unknown';
					}
				},
				A2($elm$core$Dict$get, 'utwrap_PAM:name', member.b5))),
		fW: -1
	};
};
var $author$project$PlugMap$Plugins$FeaturePicker$wfsResultToFeatures = function (result) {
	return A2($elm$core$List$map, $author$project$PlugMap$Plugins$FeaturePicker$wfsMemberToFeature, result.jQ);
};
var $author$project$PlugMap$Plugins$FeaturePicker$ToJsResult = F3(
	function (typ, xml, result) {
		return {gf: result, eZ: typ, gB: xml};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$X2J_WFS = 0;
var $author$project$PlugMap$Plugins$FeaturePicker$decodeXmlToJsType = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return (val === 'WFS') ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('Unknown XmlToJSType ' + val);
	},
	$elm$json$Json$Decode$string);
var $author$project$PlugMap$Plugins$FeaturePicker$xmlToJsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'result',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$value),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'xml',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$PlugMap$Plugins$FeaturePicker$decodeXmlToJsType,
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$ToJsResult))));
var $author$project$PlugMap$Plugins$FeaturePicker$xmlToJsProcess = function (result) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PlugMap$Plugins$FeaturePicker$xmlToJsDecoder, result);
	if (!_v0.$) {
		var val = _v0.a;
		var _v1 = _Utils_Tuple2(val.eZ, val.gf);
		if (!_v1.b.$) {
			var _v2 = _v1.a;
			var json = _v1.b.a;
			var res = A2($elm$json$Json$Decode$decodeValue, $author$project$PlugMap$Plugins$FeaturePicker$wfsResultDecoder, json);
			if (!res.$) {
				var wfsResult = res.a;
				return $author$project$PlugMap$Plugins$FeaturePicker$FeaturesLoaded(
					$author$project$PlugMap$Plugins$FeaturePicker$wfsResultToFeatures(wfsResult));
			} else {
				var err = res.a;
				return $author$project$PlugMap$Plugins$FeaturePicker$Internal($author$project$PlugMap$Plugins$FeaturePicker$NoOp);
			}
		} else {
			return $author$project$PlugMap$Plugins$FeaturePicker$Internal($author$project$PlugMap$Plugins$FeaturePicker$NoOp);
		}
	} else {
		var err = _v0.a;
		return $author$project$PlugMap$Plugins$FeaturePicker$Internal($author$project$PlugMap$Plugins$FeaturePicker$NoOp);
	}
};
var $author$project$PlugMap$Plugins$FeaturePicker$xmlToJsResult = _Platform_incomingPort('xmlToJsResult', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$FeaturePicker$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$PlugMap$Plugins$FeaturePicker$xmlToJsResult($author$project$PlugMap$Plugins$FeaturePicker$xmlToJsProcess),
				$author$project$PlugMap$Plugins$FeaturePicker$normalizeEsriResult($author$project$PlugMap$Plugins$FeaturePicker$normalizeEsriProcess),
				$author$project$PlugMap$Plugins$FeaturePicker$featureSelected(
				$author$project$PlugMap$Plugins$FeaturePicker$featureSelectedProcess(model))
			]));
};
var $author$project$PlugMap$Plugins$Identify$GetDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$Identify$getDetails = F2(
	function (model, id) {
		return $author$project$PlugMap$Plugins$Identify$GetDetails(id);
	});
var $author$project$PlugMap$Plugins$Identify$IdentifyResultsReceived = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$Identify$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$Identify$NoOp = {$: 1};
var $author$project$PlugMap$Plugins$Identify$IdentifyResults = F3(
	function (clickX, clickY, results) {
		return {kG: clickX, kH: clickY, iV: results};
	});
var $author$project$PlugMap$Plugins$Identify$Results = F2(
	function (layerId, fields) {
		return {hA: fields, md: layerId};
	});
var $author$project$PlugMap$Plugins$Identify$resultsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fields',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'layerID',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Identify$Results)));
var $author$project$PlugMap$Plugins$Identify$identifyResultsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'results',
	$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Identify$resultsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'clickY',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'clickX',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Identify$IdentifyResults))));
var $author$project$PlugMap$Plugins$Identify$handleIdentifyResults = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PlugMap$Plugins$Identify$identifyResultsDecoder, value);
	if (!_v0.$) {
		var results = _v0.a;
		return $author$project$PlugMap$Plugins$Identify$Internal(
			$author$project$PlugMap$Plugins$Identify$IdentifyResultsReceived(results));
	} else {
		var err = _v0.a;
		return $author$project$PlugMap$Plugins$Identify$Internal($author$project$PlugMap$Plugins$Identify$NoOp);
	}
};
var $author$project$PlugMap$Plugins$Identify$identifyGetDetails = _Platform_incomingPort('identifyGetDetails', $elm$json$Json$Decode$int);
var $author$project$PlugMap$Plugins$Identify$identifyResults = _Platform_incomingPort('identifyResults', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$Identify$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$PlugMap$Plugins$Identify$identifyResults($author$project$PlugMap$Plugins$Identify$handleIdentifyResults),
				$author$project$PlugMap$Plugins$Identify$identifyGetDetails(
				$author$project$PlugMap$Plugins$Identify$getDetails(model))
			]));
};
var $author$project$PlugMap$Plugins$Upload$fileUploaded = _Platform_incomingPort('fileUploaded', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$Upload$FeaturesUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$Upload$fileUploadedProcess = function (val) {
	return $author$project$PlugMap$Plugins$Upload$FeaturesUploaded(_List_Nil);
};
var $author$project$PlugMap$Plugins$Upload$Error = function (a) {
	return {$: 9, a: a};
};
var $author$project$PlugMap$Plugins$Upload$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$Upload$UpdateStatus = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$Upload$StatusUpdate = F2(
	function (status, log) {
		return {$8: log, jf: status};
	});
var $author$project$PlugMap$Plugins$Upload$Calculating = {$: 7};
var $author$project$PlugMap$Plugins$Upload$CollectingFeatures = {$: 4};
var $author$project$PlugMap$Plugins$Upload$Converting = {$: 5};
var $author$project$PlugMap$Plugins$Upload$Done = {$: 8};
var $author$project$PlugMap$Plugins$Upload$Opening = {$: 2};
var $author$project$PlugMap$Plugins$Upload$Processing = {$: 3};
var $author$project$PlugMap$Plugins$Upload$SelectingFile = {$: 1};
var $author$project$PlugMap$Plugins$Upload$Unkinking = {$: 6};
var $author$project$PlugMap$Plugins$Upload$statusDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (stringValue) {
				switch (stringValue) {
					case 'SelectingFile':
						return $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$SelectingFile);
					case 'Opening':
						return $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$Opening);
					case 'Processing':
						return $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$Processing);
					case 'CollectingFeatures':
						return $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$CollectingFeatures);
					case 'Unkinking':
						return $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$Unkinking);
					case 'Converting':
						return $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$Converting);
					case 'Calculating':
						return $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$Calculating);
					case 'Done':
						return $elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$Done);
					default:
						return $elm$json$Json$Decode$fail('Unable to parse status');
				}
			},
			$elm$json$Json$Decode$string),
			A2(
			$elm$json$Json$Decode$andThen,
			function (stringValue) {
				return $elm$json$Json$Decode$succeed(
					$author$project$PlugMap$Plugins$Upload$Error(stringValue));
			},
			A2(
				$elm$json$Json$Decode$field,
				'error',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
			$elm$json$Json$Decode$succeed(
			$author$project$PlugMap$Plugins$Upload$Error(
				_List_fromArray(
					['Could not parse status'])))
		]));
var $author$project$PlugMap$Plugins$Upload$statusUpdateDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'log',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$author$project$PlugMap$Plugins$Upload$statusDecoder,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Upload$StatusUpdate)));
var $author$project$PlugMap$Plugins$Upload$processStatusUpdate = function (value) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$PlugMap$Plugins$Upload$statusUpdateDecoder, value);
	if (!_v0.$) {
		var status = _v0.a;
		return $author$project$PlugMap$Plugins$Upload$Internal(
			$author$project$PlugMap$Plugins$Upload$UpdateStatus(status));
	} else {
		var error = _v0.a;
		return $author$project$PlugMap$Plugins$Upload$Internal(
			$author$project$PlugMap$Plugins$Upload$UpdateStatus(
				{
					$8: _List_Nil,
					jf: $author$project$PlugMap$Plugins$Upload$Error(
						_List_fromArray(
							['Cannot parse status update']))
				}));
	}
};
var $author$project$PlugMap$Plugins$Upload$statusUpdate = _Platform_incomingPort('statusUpdate', $elm$json$Json$Decode$value);
var $author$project$PlugMap$Plugins$Upload$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$PlugMap$Plugins$Upload$fileUploaded($author$project$PlugMap$Plugins$Upload$fileUploadedProcess),
				$author$project$PlugMap$Plugins$Upload$statusUpdate($author$project$PlugMap$Plugins$Upload$processStatusUpdate)
			]));
};
var $author$project$CWS$DrawEditMap$FeatureUploaded = function (a) {
	return {$: 27, a: a};
};
var $author$project$CWS$DrawEditMap$UploadMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$PlugMap$Plugins$Upload$apiTranslator = F2(
	function (td, msg) {
		if (!msg.$) {
			var m = msg.a;
			return td.cO(m);
		} else {
			var feats = msg.a;
			return td.mO(feats);
		}
	});
var $author$project$CWS$DrawEditMap$uploadTranslator = $author$project$PlugMap$Plugins$Upload$apiTranslator(
	{
		mO: A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$CWS$DrawEditMap$Internal, $author$project$CWS$DrawEditMap$Toolbox),
			$author$project$CWS$DrawEditMap$FeatureUploaded),
		cO: A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$CWS$DrawEditMap$Internal, $author$project$CWS$DrawEditMap$Toolbox),
			$author$project$CWS$DrawEditMap$UploadMsg)
	});
var $author$project$CWS$DrawEditMap$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$DrawEditMap$colorUnderPointerTranslator,
				$author$project$PlugMap$Plugins$ColorUnderPointer$subscriptions(model.di)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$DrawEditMap$identifyTranslator,
				$author$project$PlugMap$Plugins$Identify$subscriptions(model.a3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$DrawEditMap$drawingTranslator,
				$author$project$PlugMap$Plugins$Drawing$subscriptions(model.A.o)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$DrawEditMap$featurePickerTranslator,
				$author$project$PlugMap$Plugins$FeaturePicker$subscriptions(model.A.e.N)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$DrawEditMap$uploadTranslator,
				$author$project$PlugMap$Plugins$Upload$subscriptions(model.A.aX)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$DrawEditMap$Internal,
				A2(
					$elm$core$Platform$Sub$map,
					$author$project$CWS$DrawEditMap$Toolbox,
					A2(
						$elm$core$Platform$Sub$map,
						$author$project$CWS$DrawEditMap$MultiMessage,
						$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.A.e.an))))
			]));
};
var $author$project$CWS$UploadDocuments$FileInfo = F3(
	function (name, size, type_) {
		return {dz: name, aV: size, jE: type_};
	});
var $author$project$CWS$UploadDocuments$GotFileInfo = function (a) {
	return {$: 8, a: a};
};
var $author$project$CWS$UploadDocuments$fileInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'size',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$CWS$UploadDocuments$FileInfo))));
var $author$project$CWS$UploadDocuments$fileInfoReceived = function (val) {
	var decodedFileInfo = A2($elm$json$Json$Decode$decodeValue, $author$project$CWS$UploadDocuments$fileInfoDecoder, val);
	if (!decodedFileInfo.$) {
		var fileInfo = decodedFileInfo.a;
		return $author$project$CWS$UploadDocuments$GotFileInfo(fileInfo);
	} else {
		var err = decodedFileInfo.a;
		return $author$project$CWS$UploadDocuments$GotFileInfo(
			A3($author$project$CWS$UploadDocuments$FileInfo, 'Error', 0, 'Error'));
	}
};
var $author$project$CWS$UploadDocuments$fileInfoSub = _Platform_incomingPort('fileInfoSub', $elm$json$Json$Decode$value);
var $author$project$CWS$UploadDocuments$FileUploaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$CWS$UploadDocuments$FileUploadedError = function (a) {
	return {$: 12, a: a};
};
var $author$project$CWS$UploadDocuments$UploadResult = function (msg) {
	return {mt: msg};
};
var $author$project$CWS$UploadDocuments$uploadResultDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'msg',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$CWS$UploadDocuments$UploadResult));
var $author$project$CWS$UploadDocuments$fileUploadedHandler = function (val) {
	var decodedResult = A2($elm$json$Json$Decode$decodeValue, $author$project$CWS$UploadDocuments$uploadResultDecoder, val);
	if (!decodedResult.$) {
		var result = decodedResult.a;
		return $author$project$CWS$UploadDocuments$FileUploaded(result);
	} else {
		var err = decodedResult.a;
		return $author$project$CWS$UploadDocuments$FileUploadedError(err);
	}
};
var $author$project$CWS$UploadDocuments$fileUploadedSub = _Platform_incomingPort('fileUploadedSub', $elm$json$Json$Decode$value);
var $author$project$CWS$UploadDocuments$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$CWS$UploadDocuments$fileInfoSub($author$project$CWS$UploadDocuments$fileInfoReceived),
				$author$project$CWS$UploadDocuments$fileUploadedSub($author$project$CWS$UploadDocuments$fileUploadedHandler)
			]));
};
var $author$project$CWS$ActionDetail$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$ActionDetail$UploadDocumentsMsg,
				$author$project$CWS$UploadDocuments$subscriptions(model.a.ba)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$ActionDetail$mapTranslater,
				$author$project$CWS$DrawEditMap$subscriptions(model.q))
			]));
};
var $author$project$CWS$Home$ExtentMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$CWS$Home$MapMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Home$ThemeMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$PlugMapOld$Core$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$PlugMapOld$Plugins$Extent$ExtentSubscriptionResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMapOld$Plugins$Extent$extentSubscription = _Platform_incomingPort(
	'extentSubscription',
	$elm$json$Json$Decode$succeed(
		{}));
var $author$project$PlugMapOld$Plugins$Extent$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$PlugMapOld$Plugins$Extent$extentSubscription($author$project$PlugMapOld$Plugins$Extent$ExtentSubscriptionResponse)
			]));
};
var $author$project$PlugMapOld$Plugins$Themes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$CWS$Home$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$Home$MapMsg,
				$author$project$PlugMapOld$Core$subscriptions(model.q)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$Home$ThemeMsg,
				$author$project$PlugMapOld$Plugins$Themes$subscriptions(model.fO)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$Home$ExtentMsg,
				$author$project$PlugMapOld$Plugins$Extent$subscriptions(model.em))
			]));
};
var $author$project$CWS$PE$Reports$ReportExported = {$: 5};
var $author$project$CWS$PE$Reports$reportExported = _Platform_incomingPort(
	'reportExported',
	$elm$json$Json$Decode$null(0));
var $author$project$CWS$PE$Reports$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$CWS$PE$Reports$reportExported(
			$elm$core$Basics$always($author$project$CWS$PE$Reports$ReportExported));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$InPageOAuth$CodeReceived = function (a) {
	return {$: 2, a: a};
};
var $author$project$InPageOAuth$oAuthCodeReceived = _Platform_incomingPort('oAuthCodeReceived', $elm$json$Json$Decode$string);
var $author$project$InPageOAuth$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$InPageOAuth$oAuthCodeReceived(
				function (code) {
					return $author$project$InPageOAuth$Internal(
						$author$project$InPageOAuth$CodeReceived(code));
				})
			]));
};
var $author$project$CWS$UploadDocuments$cws_file_uploaded_to_s3 = _Platform_incomingPort(
	'cws_file_uploaded_to_s3',
	A2(
		$elm$json$Json$Decode$andThen,
		function (uploadUrl) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (file) {
					return $elm$json$Json$Decode$succeed(
						{lv: file, oD: uploadUrl});
				},
				A2(
					$elm$json$Json$Decode$field,
					'file',
					A2(
						$elm$json$Json$Decode$andThen,
						function (status) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (name) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (modified) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (id) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (fileUserName) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (description) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (actionType) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (actionName) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (actionId) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (actionGroup) {
																									return $elm$json$Json$Decode$succeed(
																										{gG: actionGroup, gH: actionId, gI: actionName, gJ: actionType, hp: description, hC: fileUserName, ab: id, ik: modified, dz: name, jf: status});
																								},
																								A2($elm$json$Json$Decode$field, 'actionGroup', $elm$json$Json$Decode$string));
																						},
																						A2($elm$json$Json$Decode$field, 'actionId', $elm$json$Json$Decode$int));
																				},
																				A2($elm$json$Json$Decode$field, 'actionName', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'actionType', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'fileUserName', $elm$json$Json$Decode$string));
												},
												A2(
													$elm$json$Json$Decode$field,
													'id',
													$elm$json$Json$Decode$oneOf(
														_List_fromArray(
															[
																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
															]))));
										},
										A2($elm$json$Json$Decode$field, 'modified', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$int))));
		},
		A2($elm$json$Json$Decode$field, 'uploadUrl', $elm$json$Json$Decode$string)));
var $author$project$CWS$UploadDocuments$filePickedFor = _Platform_incomingPort('filePickedFor', $elm$json$Json$Decode$value);
var $author$project$CWS$UploadDocuments$StaticMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$UploadDocuments$StaticWorkflow_FileSelecteded = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$CWS$UploadDocuments$StaticWorkflow_NoOp = {$: 0};
var $author$project$CWS$UploadDocuments$filePickedHandler = F2(
	function (model, val) {
		var decodedReference = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'for', $elm$json$Json$Decode$int),
			val);
		var decodedFileInfo = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'file', $author$project$CWS$UploadDocuments$fileInfoDecoder),
			val);
		var _v0 = _Utils_Tuple2(decodedReference, decodedFileInfo);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var id = _v0.a.a;
			var fileInfo = _v0.b.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$CWS$UploadDocuments$StaticMsg($author$project$CWS$UploadDocuments$StaticWorkflow_NoOp),
				A2(
					$elm$core$Maybe$map,
					function (mdl) {
						return $author$project$CWS$UploadDocuments$StaticMsg(
							A2($author$project$CWS$UploadDocuments$StaticWorkflow_FileSelecteded, mdl.J, fileInfo));
					},
					A2($elm$core$Dict$get, id, model.aE)));
		} else {
			return $author$project$CWS$UploadDocuments$StaticMsg($author$project$CWS$UploadDocuments$StaticWorkflow_NoOp);
		}
	});
var $author$project$CWS$UploadDocuments$Workflow_NoOp = {$: 4};
var $author$project$CWS$UploadDocuments$StaticWorkflow_FinishUpload = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$UploadDocuments$staticUploadResponseHandler = F2(
	function (model, file) {
		return $author$project$CWS$UploadDocuments$StaticMsg(
			$author$project$CWS$UploadDocuments$StaticWorkflow_FinishUpload(file));
	});
var $author$project$CWS$UploadDocuments$handleFileUploadedWorkflow = F3(
	function (curWkflw, oldWkflw, upload) {
		if (!oldWkflw.$) {
			var _static = oldWkflw.a;
			return A2($author$project$CWS$UploadDocuments$staticUploadResponseHandler, _static, upload);
		} else {
			return $author$project$CWS$UploadDocuments$Workflow_NoOp;
		}
	});
var $author$project$CWS$UploadDocuments$workflowSubs = function (model) {
	var subSubs = function () {
		if (!model.$) {
			var mdl = model.a;
			return _List_fromArray(
				[
					$author$project$CWS$UploadDocuments$filePickedFor(
					$author$project$CWS$UploadDocuments$filePickedHandler(mdl))
				]);
		} else {
			return _List_Nil;
		}
	}();
	var globalSubs = _List_fromArray(
		[
			$author$project$CWS$UploadDocuments$cws_file_uploaded_to_s3(
			A2($author$project$CWS$UploadDocuments$handleFileUploadedWorkflow, model, model))
		]);
	var allSubs = A2($elm$core$List$append, subSubs, globalSubs);
	return $elm$core$Platform$Sub$batch(allSubs);
};
var $author$project$CWS$appSubscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$Messages$ActionDetailMsg,
				$author$project$CWS$ActionDetail$subscriptions(model.a.x)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$Messages$HomeMsg,
				$author$project$CWS$Home$subscriptions(model.a.a2)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$Messages$FileUploadMsg,
				$author$project$CWS$UploadDocuments$subscriptions(model.a.U)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$Messages$FileUploadWorkflowMsg,
				$author$project$CWS$UploadDocuments$workflowSubs(model.a.ce)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$genericAuthTranslator(
					A2($elm$core$Maybe$withDefault, 0, model.bS)),
				$author$project$InPageOAuth$subscriptions(model.Y)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$CWS$Messages$ReportsMsg,
				$author$project$CWS$PE$Reports$subscriptions(model.a.bz)),
				$elm$browser$Browser$Events$onResize($author$project$CWS$Messages$WindowResized)
			]));
};
var $author$project$CWS$subscriptions = function (app) {
	if (!app.$) {
		var model = app.a;
		return $author$project$CWS$appSubscriptions(model);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$CWS$Model$Canceled = {$: 3};
var $author$project$CWS$Model$Confirmed = {$: 2};
var $author$project$CWS$About$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var res = msg.a;
			if (!res.$) {
				var content = res.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d9: content}),
					$elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d9: 'Unable to load content.'}),
					$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$CWS$aboutUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = function () {
			var _v1 = A2($author$project$CWS$About$update, subMsg, model.a.ck);
			var updatedModel = _v1.a;
			var updatedCmds = _v1.b;
			return _Utils_Tuple2(
				updatedModel,
				A2($elm$core$Platform$Cmd$map, $author$project$CWS$aboutTranslator, updatedCmds));
		}();
		var newAbout = _v0.a;
		var newAboutCmds = _v0.b;
		var newState = _Utils_update(
			oldState,
			{ck: newAbout});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			newAboutCmds);
	});
var $author$project$CWS$Messages$ActionBoardMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$CWS$ActionBoard$CategoryLoad = function (a) {
	return {$: 5, a: a};
};
var $author$project$CWS$ActionBoard$Collapsed = 0;
var $author$project$CWS$ActionBoard$Expanded = 1;
var $author$project$CWS$ActionBoard$cancelDelete = F2(
	function (model, id) {
		var oldState = model.a;
		var newState = _Utils_update(
			oldState,
			{aJ: $author$project$CWS$Model$NoDynConfirmation});
		var cmds = $elm$core$Platform$Cmd$batch(_List_Nil);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$ActionBoard$CancelDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$CWS$ActionBoard$ConfirmDelete = function (a) {
	return {$: 7, a: a};
};
var $author$project$CWS$Model$RequestDynConfirmation = F8(
	function (a, b, c, d, e, f, g, h) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e, f: f, g: g, h: h};
	});
var $author$project$CWS$ActionBoard$confirmDelete = F2(
	function (model, id) {
		var oldState = model.a;
		var newState = _Utils_update(
			oldState,
			{
				aJ: A8($author$project$CWS$Model$RequestDynConfirmation, 'Confirm Delete', 'Are you sure you would like to delete this action?', 'Deleting the action will delete all information entered for the action, including uploaded files and shape files.', 'Yes', $author$project$CWS$ActionBoard$ConfirmDelete, 'No', $author$project$CWS$ActionBoard$CancelDelete, id)
			});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$ActionBoard$ActionDeleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$CWS$Model$ActionModel = function (id) {
	return function (name) {
		return function (category) {
			return function (group) {
				return function (type_) {
					return function (startDate) {
						return function (endDate) {
							return function (funding) {
								return function (estimatedCost) {
									return function (description) {
										return function (hours) {
											return function (acres) {
												return function (bioMass) {
													return function (deleted) {
														return function (status) {
															return function (fields) {
																return function (files) {
																	return function (peName) {
																		return function (daysInQ) {
																			return function (createdBy) {
																				return function (lastModifiedBy) {
																					return function (lastSubmittedBy) {
																						return function (lastSubmittedDate) {
																							return function (lastApprovedBy) {
																								return function (lastApprovedDate) {
																									return function (approvalNotes) {
																										return function (shape) {
																											return function (actionYear) {
																												return {bH: acres, W: actionYear, cn: approvalNotes, e9: bioMass, bK: category, kY: createdBy, hk: daysInQ, hn: deleted, hp: description, el: endDate, ll: estimatedCost, hA: fields, hD: files, fv: funding, hM: group, fB: hours, ab: id, l8: lastApprovedBy, l9: lastApprovedDate, h5: lastModifiedBy, ma: lastSubmittedBy, mb: lastSubmittedDate, dz: name, iA: peName, I: shape, dL: startDate, jf: status, jE: type_};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CWS$Model$NoStatus = 0;
var $author$project$Fields$Shared$NotEntered = {$: 0};
var $author$project$Fields$Shared$Valid = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$CWS$Model$Denied = 3;
var $author$project$CWS$Model$Pending = 1;
var $author$project$CWS$Model$actionStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		return (!value) ? $elm$json$Json$Decode$succeed(1) : ((value === 100) ? $elm$json$Json$Decode$succeed(2) : ((value === 200) ? $elm$json$Json$Decode$succeed(3) : ((value === 300) ? $elm$json$Json$Decode$succeed(4) : $elm$json$Json$Decode$succeed(0))));
	},
	$elm$json$Json$Decode$int);
var $author$project$CWS$Model$KeyedNamedValue = F3(
	function (id, name, key) {
		return {ab: id, v: key, dz: name};
	});
var $author$project$CWS$Model$defaultKeyedNamedValue = A3($author$project$CWS$Model$KeyedNamedValue, -1, 'Not Set', 'Not Set');
var $author$project$CWS$Model$defaultActionType = $author$project$CWS$Model$defaultKeyedNamedValue;
var $author$project$CWS$Model$defaultCategory = $author$project$CWS$Model$defaultKeyedNamedValue;
var $author$project$CWS$Model$defaultFunding = $author$project$CWS$Model$defaultKeyedNamedValue;
var $author$project$CWS$Model$defaultGroup = $author$project$CWS$Model$defaultKeyedNamedValue;
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$CWS$Model$keyedNamedValueDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'key',
	$elm$json$Json$Decode$string,
	'Key Not Set',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'name',
		$elm$json$Json$Decode$string,
		'Name Not Set',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$CWS$Model$KeyedNamedValue))));
var $author$project$CWS$Model$Shape = F2(
	function (id, shape) {
		return {ab: id, I: shape};
	});
var $author$project$CWS$Model$wktDecoder = $elm$json$Json$Decode$string;
var $author$project$CWS$Model$shapeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'wkt',
	$author$project$CWS$Model$wktDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$CWS$Model$Shape)));
var $author$project$CWS$Model$UserInfo = F5(
	function (id, name, roles, email, orgRole) {
		return {ek: email, ab: id, dz: name, ir: orgRole, iW: roles};
	});
var $author$project$CWS$Model$userInfoDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'orgRole',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'email',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'roles',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'name',
				$elm$json$Json$Decode$string,
				'',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$CWS$Model$UserInfo))))));
var $author$project$CWS$Model$actionModelDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'actionYear',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'shape',
		$elm$json$Json$Decode$maybe($author$project$CWS$Model$shapeDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'approvalNotes',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'lastApprovedOn',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'lastApprovalBy',
					$elm$json$Json$Decode$maybe($author$project$CWS$Model$userInfoDecoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'lastSubmittedOn',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'lastSubmittedBy',
							$elm$json$Json$Decode$maybe($author$project$CWS$Model$userInfoDecoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'lastModifiedBy',
								$elm$json$Json$Decode$maybe($author$project$CWS$Model$userInfoDecoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'createBy',
									$elm$json$Json$Decode$maybe($author$project$CWS$Model$userInfoDecoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'daysInQ',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'peName',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
												$author$project$CWS$Model$Loading,
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													$author$project$CWS$Model$Loading,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'status',
														$author$project$CWS$Model$actionStatusDecoder,
														0,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'deleted',
															$elm$json$Json$Decode$bool,
															false,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'bioMass',
																A2(
																	$elm$json$Json$Decode$andThen,
																	function (a) {
																		return $elm$json$Json$Decode$succeed(
																			A2(
																				$author$project$Fields$Shared$Valid,
																				a,
																				$elm$core$String$fromFloat(a)));
																	},
																	$elm$json$Json$Decode$float),
																$author$project$Fields$Shared$NotEntered,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'acres',
																	A2(
																		$elm$json$Json$Decode$andThen,
																		function (a) {
																			return $elm$json$Json$Decode$succeed(
																				A2(
																					$author$project$Fields$Shared$Valid,
																					a,
																					$elm$core$String$fromFloat(a)));
																		},
																		$elm$json$Json$Decode$float),
																	$author$project$Fields$Shared$NotEntered,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'hours',
																		A2(
																			$elm$json$Json$Decode$andThen,
																			function (a) {
																				return $elm$json$Json$Decode$succeed(
																					A2(
																						$author$project$Fields$Shared$Valid,
																						a,
																						$elm$core$String$fromFloat(a)));
																			},
																			$elm$json$Json$Decode$float),
																		$author$project$Fields$Shared$NotEntered,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'description',
																			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																			$elm$core$Maybe$Nothing,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'estimatedCost',
																				A2(
																					$elm$json$Json$Decode$andThen,
																					function (a) {
																						return $elm$json$Json$Decode$succeed(
																							A2(
																								$author$project$Fields$Shared$Valid,
																								a,
																								$elm$core$String$fromFloat(a)));
																					},
																					$elm$json$Json$Decode$float),
																				$author$project$Fields$Shared$NotEntered,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'funding',
																					$author$project$CWS$Model$keyedNamedValueDecoder,
																					$author$project$CWS$Model$defaultFunding,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'endDate',
																						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																						$elm$core$Maybe$Nothing,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'startDate',
																							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																							$elm$core$Maybe$Nothing,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'type',
																								$author$project$CWS$Model$keyedNamedValueDecoder,
																								$author$project$CWS$Model$defaultActionType,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'group',
																									$author$project$CWS$Model$keyedNamedValueDecoder,
																									$author$project$CWS$Model$defaultGroup,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'category',
																										$author$project$CWS$Model$keyedNamedValueDecoder,
																										$author$project$CWS$Model$defaultCategory,
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'name',
																											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
																											$elm$core$Maybe$Nothing,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'id',
																												$elm$json$Json$Decode$int,
																												$elm$json$Json$Decode$succeed($author$project$CWS$Model$ActionModel)))))))))))))))))))))))))))));
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$CWS$API$Action$byIdGetRequestEncoder = function (id) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(id))
			]));
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$CWS$API$bump = F3(
	function (sucessReturn, unauthorizedReturn, result) {
		if (!result.$) {
			return sucessReturn(result);
		} else {
			var err = result.a;
			if (err.$ === 3) {
				var status = err.a;
				return (status === 401) ? unauthorizedReturn(result) : sucessReturn(result);
			} else {
				return sucessReturn(result);
			}
		}
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{kc: true, gZ: r.gZ, hv: r.hv, hO: r.hO, ii: r.ii, jp: r.jp, jz: r.jz, jF: r.jF}));
};
var $truqu$elm_oauth2$OAuth$tokenToString = function (_v0) {
	var t = _v0;
	return 'Bearer ' + t;
};
var $truqu$elm_oauth2$OAuth$useToken = function (token) {
	return $elm$core$List$cons(
		A2(
			$elm$http$Http$header,
			'Authorization',
			$truqu$elm_oauth2$OAuth$tokenToString(token)));
};
var $author$project$CWS$API$postRequestNew = F8(
	function (settings, controller, action, body_, sucessReturn, unauthorizedReturn, user, decoder) {
		var version = A2(
			$elm$core$Maybe$withDefault,
			settings.jG ? $elm$core$Maybe$Just(settings.jL) : $elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$andThen,
				function (x) {
					var _v4 = x.jG;
					if ((!_v4.$) && _v4.a) {
						var _v5 = x.jL;
						if (!_v5.$) {
							var ver = _v5.a;
							return $elm$core$Maybe$Just(
								$elm$core$Maybe$Just(ver));
						} else {
							return $elm$core$Maybe$Just(
								$elm$core$Maybe$Just(settings.jL));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				A2($elm$core$Dict$get, controller, settings.lh)));
		var trok = function () {
			switch (user.$) {
				case 3:
					var token = user.a.oq;
					return token;
				case 2:
					var token = user.a;
					return token;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return $elm$http$Http$riskyRequest(
			{
				gZ: function () {
					if (!body_.$) {
						var body = body_.a;
						return $elm$http$Http$jsonBody(body);
					} else {
						return $elm$http$Http$emptyBody;
					}
				}(),
				hv: A2(
					$elm$http$Http$expectJson,
					A2($author$project$CWS$API$bump, sucessReturn, unauthorizedReturn),
					decoder),
				hO: A2(
					$elm$core$List$append,
					function () {
						if (!trok.$) {
							var tok = trok.a;
							return A2($truqu$elm_oauth2$OAuth$useToken, tok, _List_Nil);
						} else {
							return _List_fromArray(
								[
									A2($elm$http$Http$header, 'Anon', 'True')
								]);
						}
					}(),
					_List_fromArray(
						[
							A2($elm$http$Http$header, 'Accept', 'application/json, text/javascript, */*; q=0.01'),
							A2($elm$http$Http$header, 'Content-Type', 'application/json')
						])),
				ii: 'POST',
				jp: $elm$core$Maybe$Nothing,
				jz: $elm$core$Maybe$Nothing,
				jF: settings.km + (function () {
					if (!version.$) {
						var ver = version.a;
						return ver + '/';
					} else {
						return '';
					}
				}() + (controller + ('/' + action)))
			});
	});
var $author$project$CWS$API$Action$deleteActionById = F5(
	function (settings, user, id, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Actions',
			'Delete',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$Action$byIdGetRequestEncoder(id)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$actionModelDecoder);
	});
var $author$project$CWS$ActionBoard$deleteItem = F3(
	function (model, id, env) {
		var oldState = model.a;
		var newState = _Utils_update(
			oldState,
			{aJ: $author$project$CWS$Model$NoDynConfirmation});
		var cmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A5($author$project$CWS$API$Action$deleteActionById, env.m, env.f, id, $author$project$CWS$ActionBoard$ActionDeleted, $author$project$CWS$ActionBoard$ActionDeleted)
				]));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			cmds);
	});
var $author$project$CWS$Model$ActionCategory = F3(
	function (id, name, groups) {
		return {fx: groups, ab: id, dz: name};
	});
var $author$project$CWS$Model$ActionGroup = F4(
	function (id, name, key, actions) {
		return {au: actions, ab: id, v: key, dz: name};
	});
var $author$project$CWS$Model$actionGroupDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'actions',
	$elm$json$Json$Decode$list($author$project$CWS$Model$actionModelDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'key',
		$elm$json$Json$Decode$string,
		'Key Not Set',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'name',
			$elm$json$Json$Decode$string,
			'Type Not Set',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$CWS$Model$ActionGroup)))));
var $author$project$CWS$Model$actionCategoryDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'groups',
	$elm$json$Json$Decode$list($author$project$CWS$Model$actionGroupDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'name',
		$elm$json$Json$Decode$string,
		'Category Not Set',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$CWS$Model$ActionCategory))));
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$CWS$API$Action$byCategoryPEIDYearKeyGetRequestEncoder = F3(
	function (categoryKey, peID, yearKey) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'peID',
					$elm$json$Json$Encode$string(peID)),
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$string(categoryKey)),
					_Utils_Tuple2(
					'yearKey',
					$elm$json$Json$Encode$string(yearKey))
				]));
	});
var $author$project$CWS$API$Action$getActionCategoryByPEIDYearKey = F7(
	function (settings, user, categoryKey, peID, yearKey, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Actions',
			'GetCategoryByPEIdYearKey',
			$elm$core$Maybe$Just(
				A3($author$project$CWS$API$Action$byCategoryPEIDYearKeyGetRequestEncoder, categoryKey, peID, yearKey)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$actionCategoryDecoder);
	});
var $author$project$CWS$ActionBoard$converterfi = function (input) {
	return A2(
		$elm$core$List$map,
		function (x) {
			return _Utils_Tuple2(0, x);
		},
		input.fx);
};
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$CWS$ActionBoard$maperfi = F2(
	function (input, oldStates) {
		var _v0 = $elm$core$List$unzip(oldStates);
		var states = _v0.a;
		var oldItems = _v0.b;
		return A2($elm_community$list_extra$List$Extra$zip, states, input.fx);
	});
var $author$project$CWS$ActionBoard$handleCategoryLoad = F2(
	function (model, result) {
		if (result.$ === 1) {
			var err = result.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var cat = result.a;
			var oldState = model.a;
			var newCwsmodelChecklist = cat;
			var newState = (!_Utils_eq(
				$elm$core$List$length(oldState.bf),
				$elm$core$List$length(newCwsmodelChecklist.fx))) ? _Utils_update(
				oldState,
				{
					bf: $author$project$CWS$ActionBoard$converterfi(newCwsmodelChecklist)
				}) : _Utils_update(
				oldState,
				{
					bf: A2($author$project$CWS$ActionBoard$maperfi, newCwsmodelChecklist, oldState.bf)
				});
			var cmdz = $elm$core$Platform$Cmd$none;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{a: newState}),
				cmdz);
		}
	});
var $author$project$CWS$ActionBoard$update = F3(
	function (msg, model, env) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var checklistTitle = msg.a;
				var up = F2(
					function (chk, _v2) {
						var state = _v2.a;
						var checklist = _v2.b;
						if (_Utils_eq(checklist.dz, chk)) {
							if (!state) {
								return _Utils_Tuple2(1, checklist);
							} else {
								return _Utils_Tuple2(0, checklist);
							}
						} else {
							return _Utils_Tuple2(state, checklist);
						}
					});
				var oldState = model.a;
				var newChecklist = A2(
					$elm$core$List$map,
					function (item) {
						return A2(up, checklistTitle, item);
					},
					model.a.bf);
				var newState = _Utils_update(
					oldState,
					{bf: newChecklist});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a: newState}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var result = msg.a;
				return A2($author$project$CWS$ActionBoard$handleCategoryLoad, model, result);
			case 6:
				var id = msg.a;
				return A2($author$project$CWS$ActionBoard$confirmDelete, model, id);
			case 7:
				var id = msg.a;
				return A3($author$project$CWS$ActionBoard$deleteItem, model, id, env);
			case 8:
				var id = msg.a;
				return A2($author$project$CWS$ActionBoard$cancelDelete, model, id);
			case 9:
				var action = msg.a;
				var peID = model.a.cQ.ab;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A7($author$project$CWS$API$Action$getActionCategoryByPEIDYearKey, env.m, env.f, model.bK, peID, model.a.r, $author$project$CWS$ActionBoard$CategoryLoad, $author$project$CWS$ActionBoard$CategoryLoad)
							])));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$actionBoardUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = function () {
			var _v1 = A3(
				$author$project$CWS$ActionBoard$update,
				subMsg,
				model.a.be,
				{m: model.p.m.av, f: model.f});
			var changedModel = _v1.a;
			var changedMsg = _v1.b;
			return _Utils_Tuple2(
				changedModel,
				A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionBoardMsg, changedMsg));
		}();
		var newActionBoardModel = _v0.a;
		var newActionBoardMsg = _v0.b;
		var newState = _Utils_update(
			oldState,
			{be: newActionBoardModel});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[newActionBoardMsg])));
	});
var $author$project$CWS$Messages$APIUnauthorizedHandler = function (a) {
	return {$: 36, a: a};
};
var $author$project$CWS$API$APIRequest$API_PE_AddUsers = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$CWS$LoadChunk$AssignedUsers = function (a) {
	return {$: 11, a: a};
};
var $author$project$CWS$Messages$ChunkLoad = function (a) {
	return {$: 20, a: a};
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$CWS$Model$manageUsersEncoder = function (users) {
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$string,
		A2(
			$elm$core$List$map,
			function (user) {
				return user.ab;
			},
			users));
};
var $author$project$CWS$API$ParticipatingEntity$addUsersToPE = F6(
	function (settings, user, peKey, users, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'ParticipatingEntity',
			'AddUsersToPE',
			$elm$core$Maybe$Just(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'key',
							$elm$json$Json$Encode$string(peKey)),
							_Utils_Tuple2(
							'ids',
							$author$project$CWS$Model$manageUsersEncoder(users))
						]))),
			_return,
			onError,
			user,
			$elm$json$Json$Decode$bool);
	});
var $author$project$CWS$API$Core$api_PE_AddUsers = F3(
	function (peKey, users, model) {
		return A6(
			$author$project$CWS$API$ParticipatingEntity$addUsersToPE,
			model.p.m.av,
			model.f,
			peKey,
			users,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$AssignedUsers(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					A2($author$project$CWS$API$APIRequest$API_PE_AddUsers, peKey, users));
			});
	});
var $author$project$CWS$API$APIRequest$API_User_AssignPEs = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$CWS$LoadChunk$UserPEs = function (a) {
	return {$: 12, a: a};
};
var $author$project$CWS$API$ParticipatingEntity$assignPEsEncoder = F2(
	function (userid, peids) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'userId',
					$elm$json$Json$Encode$string(userid)),
					_Utils_Tuple2(
					'peIds',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, peids))
				]));
	});
var $author$project$CWS$Model$UserParticipatingEntity = F2(
	function (entity, assigned) {
		return {df: assigned, d: entity};
	});
var $author$project$CWS$Model$namedValueDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'name',
	$elm$json$Json$Decode$string,
	'Name Not Set',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$CWS$Model$NamedValue)));
var $author$project$CWS$Model$Year = F6(
	function (id, key, name, effective, expires, commitment) {
		return {kQ: commitment, lf: effective, lo: expires, ab: id, v: key, dz: name};
	});
var $author$project$CWS$Model$yearDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'commitment',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'expires',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'effective',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'key',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$CWS$Model$Year)))))));
var $author$project$CWS$Model$participatingEntityModelDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'years',
	$elm$json$Json$Decode$list($author$project$CWS$Model$yearDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'yearType',
		$author$project$CWS$Model$namedValueDecoder,
		$author$project$CWS$Model$defaultYearType,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'type',
			$author$project$CWS$Model$namedValueDecoder,
			$author$project$CWS$Model$defaultPEType,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'wkt',
				$elm$json$Json$Decode$string,
				'Unable to load wkt',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'id',
					$elm$json$Json$Decode$string,
					'Unable to load ID',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						0,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'urlKey',
							$elm$json$Json$Decode$string,
							'Unable to D.succeed key',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'name',
								$elm$json$Json$Decode$string,
								'Unable to D.succeed name',
								$elm$json$Json$Decode$succeed($author$project$CWS$Model$ParticipatingEntityModel)))))))));
var $author$project$CWS$Model$userParticipatingEntityDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'assigned',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'entity',
		$author$project$CWS$Model$participatingEntityModelDecoder,
		$elm$json$Json$Decode$succeed($author$project$CWS$Model$UserParticipatingEntity)));
var $author$project$CWS$Model$userParticipatingEntitiesDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$userParticipatingEntityDecoder);
var $author$project$CWS$API$ParticipatingEntity$assignPEsForUser = F6(
	function (settings, user, userID, peIDs, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Users',
			'AssignPEs',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$API$ParticipatingEntity$assignPEsEncoder, userID, peIDs)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$userParticipatingEntitiesDecoder);
	});
var $author$project$CWS$API$Core$api_User_AssignPEs = F3(
	function (userid, pes, model) {
		return A6(
			$author$project$CWS$API$ParticipatingEntity$assignPEsForUser,
			model.p.m.av,
			model.f,
			userid,
			pes,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$UserPEs(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					A2($author$project$CWS$API$APIRequest$API_User_AssignPEs, userid, pes));
			});
	});
var $author$project$CWS$Messages$AppActionMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$CWS$Approver$Actions$GridMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$GridOld$Grid$filterTextChange = F2(
	function (model, text) {
		var newSearch = ($elm$core$String$length(text) > 0) ? $elm$core$Maybe$Just(text) : $elm$core$Maybe$Nothing;
		var newModel = _Utils_update(
			model,
			{gg: newSearch});
		var newCmd = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmd);
	});
var $author$project$GridOld$Grid$filterTypeChange = F2(
	function (model, column) {
		var newColumn = (column === 'All') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(column);
		var newModel = _Utils_update(
			model,
			{lx: newColumn});
		var newCmd = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmd);
	});
var $author$project$GridOld$Grid$gotoPage = F2(
	function (model, page) {
		var newModel = _Utils_update(
			model,
			{k_: page});
		var newCmds = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$GridOld$Grid$handlePageSizeChanged = F2(
	function (model, newSize) {
		var newModel = _Utils_update(
			model,
			{l5: newSize});
		var newCmds = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$GridOld$Grid$incrementPage = F2(
	function (model, incr) {
		var oldPage = model.k_;
		var upPage = oldPage + incr;
		var newPage = upPage;
		var newModel = _Utils_update(
			model,
			{k_: newPage});
		var newCmds = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$GridOld$Grid$noOut = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(model, cmd, $elm$core$Maybe$Nothing);
};
var $author$project$GridOld$Grid$Sort_None = {$: 0};
var $author$project$GridOld$Grid$updateSort = F2(
	function (model, sort) {
		var newSort = function () {
			var _v0 = model.aD;
			switch (_v0.$) {
				case 0:
					return $author$project$GridOld$Grid$Sort(sort);
				case 1:
					var sortedBy = _v0.a;
					return _Utils_eq(sort, sortedBy) ? $author$project$GridOld$Grid$Sort_Reverse(sort) : $author$project$GridOld$Grid$Sort(sort);
				default:
					var sortedBy = _v0.a;
					return _Utils_eq(sort, sortedBy) ? $author$project$GridOld$Grid$Sort_None : $author$project$GridOld$Grid$Sort(sort);
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aD: newSort}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$GridOld$Grid$update = F2(
	function (model, subMsg) {
		switch (subMsg.$) {
			case 4:
				var newSize = subMsg.a;
				return $author$project$GridOld$Grid$noOut(
					A2($author$project$GridOld$Grid$handlePageSizeChanged, model, newSize));
			case 1:
				var sort = subMsg.a;
				return $author$project$GridOld$Grid$noOut(
					A2($author$project$GridOld$Grid$updateSort, model, sort));
			case 2:
				var incr = subMsg.a;
				return $author$project$GridOld$Grid$noOut(
					A2($author$project$GridOld$Grid$incrementPage, model, incr));
			case 3:
				var upPage = subMsg.a;
				return $author$project$GridOld$Grid$noOut(
					A2($author$project$GridOld$Grid$gotoPage, model, upPage));
			case 5:
				var text = subMsg.a;
				return $author$project$GridOld$Grid$noOut(
					A2($author$project$GridOld$Grid$filterTextChange, model, text));
			case 6:
				var column = subMsg.a;
				return $author$project$GridOld$Grid$noOut(
					A2($author$project$GridOld$Grid$filterTypeChange, model, column));
			case 7:
				var msg = subMsg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(msg));
			default:
				return $author$project$GridOld$Grid$noOut(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$CWS$Approver$Actions$update = F2(
	function (model, msg) {
		update:
		while (true) {
			switch (msg.$) {
				case 1:
					var sub = msg.a;
					var _v1 = A2($author$project$GridOld$Grid$update, model.dr, sub);
					var newGrid = _v1.a;
					var newGridCmd = _v1.b;
					var outMsg = _v1.c;
					var newModel = _Utils_update(
						model,
						{dr: newGrid});
					var newCmd = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Approver$Actions$GridMsg, newGridCmd);
					if (outMsg.$ === 1) {
						return _Utils_Tuple2(newModel, newCmd);
					} else {
						var s = outMsg.a;
						var $temp$model = newModel,
							$temp$msg = s;
						model = $temp$model;
						msg = $temp$msg;
						continue update;
					}
				case 2:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$CWS$appActionUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = A2($author$project$CWS$Approver$Actions$update, model.a.dc, subMsg);
		var newAppAction = _v0.a;
		var newAppActionCmd = _v0.b;
		var newState = _Utils_update(
			oldState,
			{dc: newAppAction});
		var newModel = _Utils_update(
			model,
			{a: newState});
		var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$AppActionMsg, newAppActionCmd);
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$Messages$AppPEMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$CWS$Approver$ParticipatingEntities$GridMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Grid$Grid$ClosePageSizeDropdown = {$: 6};
var $author$project$Grid$Grid$filterTextChange = F2(
	function (model, text) {
		var newSearch = ($elm$core$String$length(text) > 0) ? $elm$core$Maybe$Just(text) : $elm$core$Maybe$Nothing;
		var newModel = _Utils_update(
			model,
			{gg: newSearch});
		var newCmd = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmd);
	});
var $author$project$Grid$Grid$NoOp = {$: 0};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$blur = _Browser_call('blur');
var $author$project$Grid$Grid$inputIds = {hE: 'filter_button', en: 'filter_options', ly: 'filter_search', iw: 'page_size_button', eI: 'page_size_options', i6: 'show_hide_button', nP: 'show_hide_options'};
var $author$project$Grid$Grid$blurFilterOptions = function (model) {
	var _v0 = model.bl;
	if (!_v0) {
		return A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return $author$project$Grid$Grid$NoOp;
			},
			$elm$browser$Browser$Dom$blur($author$project$Grid$Grid$inputIds.en));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Grid$Grid$filterTypeChange = F2(
	function (model, column) {
		var newColumn = (column.jr === 'All') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(column);
		var newModel = _Utils_update(
			model,
			{lx: newColumn});
		var newCmd = $author$project$Grid$Grid$blurFilterOptions(model);
		return _Utils_Tuple2(newModel, newCmd);
	});
var $author$project$PAM$UI$Basic$Open = 0;
var $author$project$PAM$UI$Basic$flipOpenness = function (openness) {
	if (!openness) {
		return 1;
	} else {
		return 0;
	}
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Grid$Grid$focusFilterOptions = function (model) {
	var _v0 = model.bl;
	if (!_v0) {
		return $elm$core$Platform$Cmd$none;
	} else {
		return A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return $author$project$Grid$Grid$NoOp;
			},
			$elm$browser$Browser$Dom$focus($author$project$Grid$Grid$inputIds.en));
	}
};
var $author$project$Grid$Grid$focusPageSizeOptions = function (model) {
	var _v0 = model.bq;
	if (!_v0) {
		return $elm$core$Platform$Cmd$none;
	} else {
		return A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return $author$project$Grid$Grid$NoOp;
			},
			$elm$browser$Browser$Dom$focus($author$project$Grid$Grid$inputIds.eI));
	}
};
var $author$project$Grid$Grid$gotoPage = F2(
	function (model, page) {
		var newModel = _Utils_update(
			model,
			{k_: page});
		var newCmds = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$Grid$Grid$blurPageSizeOptions = function (model) {
	var _v0 = model.bq;
	if (!_v0) {
		return A2(
			$elm$core$Task$attempt,
			function (_v1) {
				return $author$project$Grid$Grid$NoOp;
			},
			$elm$browser$Browser$Dom$blur($author$project$Grid$Grid$inputIds.eI));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Grid$Grid$handlePageSizeChanged = F2(
	function (model, newSize) {
		var newModel = _Utils_update(
			model,
			{l5: newSize});
		var newCmds = $author$project$Grid$Grid$blurPageSizeOptions(model);
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$Grid$Grid$incrementPage = F2(
	function (model, incr) {
		var oldPage = model.k_;
		var upPage = oldPage + incr;
		var newPage = upPage;
		var newModel = _Utils_update(
			model,
			{k_: newPage});
		var newCmds = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$Grid$Grid$noOut = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(model, cmd, $elm$core$Maybe$Nothing);
};
var $author$project$Grid$Grid$Sort_Reverse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Grid$Grid$updateSort = F2(
	function (model, sort) {
		var newSort = function () {
			var _v0 = model.aD;
			switch (_v0.$) {
				case 0:
					return $author$project$Grid$Grid$Sort(sort);
				case 1:
					var sortedBy = _v0.a;
					return _Utils_eq(sort, sortedBy) ? $author$project$Grid$Grid$Sort_Reverse(sort) : $author$project$Grid$Grid$Sort(sort);
				default:
					var sortedBy = _v0.a;
					return _Utils_eq(sort, sortedBy) ? $author$project$Grid$Grid$Sort_None : $author$project$Grid$Grid$Sort(sort);
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{aD: newSort}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Grid$Grid$update = F2(
	function (model, subMsg) {
		switch (subMsg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
			case 4:
				var val = subMsg.a;
				return $author$project$Grid$Grid$noOut(
					A2($author$project$Grid$Grid$handlePageSizeChanged, model, val));
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bq: $author$project$PAM$UI$Basic$flipOpenness(model.bq)
						}),
					$author$project$Grid$Grid$focusPageSizeOptions(model),
					$elm$core$Maybe$Nothing);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bq: 1}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 7:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$Grid$Grid$ClosePageSizeDropdown),
						$elm$core$Process$sleep(100)),
					$elm$core$Maybe$Nothing);
			case 1:
				var sort = subMsg.a;
				return $author$project$Grid$Grid$noOut(
					A2($author$project$Grid$Grid$updateSort, model, sort));
			case 2:
				var incr = subMsg.a;
				return $author$project$Grid$Grid$noOut(
					A2($author$project$Grid$Grid$incrementPage, model, incr));
			case 3:
				var upPage = subMsg.a;
				return $author$project$Grid$Grid$noOut(
					A2($author$project$Grid$Grid$gotoPage, model, upPage));
			case 8:
				var text = subMsg.a;
				return $author$project$Grid$Grid$noOut(
					A2($author$project$Grid$Grid$filterTextChange, model, text));
			case 9:
				var column = subMsg.a;
				return $author$project$Grid$Grid$noOut(
					A2($author$project$Grid$Grid$filterTypeChange, model, column));
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bl: $author$project$PAM$UI$Basic$flipOpenness(model.bl)
						}),
					$author$project$Grid$Grid$focusFilterOptions(model),
					$elm$core$Maybe$Nothing);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bl: 1}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 12:
				var msg = subMsg.a;
				var checked = subMsg.b;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(msg));
			case 13:
				return $author$project$Grid$Grid$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								cu: $author$project$PAM$UI$Basic$flipOpenness(model.cu)
							}),
						$elm$core$Platform$Cmd$none));
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cu: 1}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			default:
				var msg = subMsg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(msg));
		}
	});
var $author$project$CWS$Approver$ParticipatingEntities$update = F2(
	function (model, msg) {
		update:
		while (true) {
			switch (msg.$) {
				case 1:
					var sub = msg.a;
					var _v1 = A2($author$project$Grid$Grid$update, model.dr, sub);
					var newGrid = _v1.a;
					var newGridCmd = _v1.b;
					var outMsg = _v1.c;
					var newModel = _Utils_update(
						model,
						{dr: newGrid});
					var newCmd = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Approver$ParticipatingEntities$GridMsg, newGridCmd);
					if (outMsg.$ === 1) {
						return _Utils_Tuple2(newModel, newCmd);
					} else {
						var s = outMsg.a;
						var $temp$model = newModel,
							$temp$msg = s;
						model = $temp$model;
						msg = $temp$msg;
						continue update;
					}
				case 2:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$CWS$appPEUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = A2($author$project$CWS$Approver$ParticipatingEntities$update, model.a.dd, subMsg);
		var newAppPe = _v0.a;
		var newAppPeCmd = _v0.b;
		var newState = _Utils_update(
			oldState,
			{dd: newAppPe});
		var newModel = _Utils_update(
			model,
			{a: newState});
		var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$AppPEMsg, newAppPeCmd);
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$Messages$AppUsersMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$CWS$Approver$Users$GridMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Approver$Users$update = F2(
	function (model, msg) {
		update:
		while (true) {
			switch (msg.$) {
				case 1:
					var sub = msg.a;
					var _v1 = A2($author$project$Grid$Grid$update, model.dr, sub);
					var newGrid = _v1.a;
					var newGridCmd = _v1.b;
					var outMsg = _v1.c;
					var newModel = _Utils_update(
						model,
						{dr: newGrid});
					var newCmd = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Approver$Users$GridMsg, newGridCmd);
					if (outMsg.$ === 1) {
						return _Utils_Tuple2(newModel, newCmd);
					} else {
						var s = outMsg.a;
						var $temp$model = newModel,
							$temp$msg = s;
						model = $temp$model;
						msg = $temp$msg;
						continue update;
					}
				case 2:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$CWS$appPEUsersUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = A2($author$project$CWS$Approver$Users$update, model.a.de, subMsg);
		var newAppPe = _v0.a;
		var newAppPeCmd = _v0.b;
		var newState = _Utils_update(
			oldState,
			{de: newAppPe});
		var newModel = _Utils_update(
			model,
			{a: newState});
		var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$AppUsersMsg, newAppPeCmd);
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$ActionDetail$ActionSaved = function (a) {
	return {$: 29, a: a};
};
var $author$project$CWS$ActionDetail$ApproveError = function (a) {
	return {$: 14, a: a};
};
var $author$project$CWS$ActionDetail$ApprovedAction = function (a) {
	return {$: 13, a: a};
};
var $author$project$CWS$ActionDetail$CouldntLoadDetails = function (a) {
	return {$: 8, a: a};
};
var $author$project$CWS$ActionDetail$CouldntSave = function (a) {
	return {$: 30, a: a};
};
var $author$project$CWS$ActionDetail$DeniedAction = function (a) {
	return {$: 15, a: a};
};
var $author$project$CWS$ActionDetail$DenyError = function (a) {
	return {$: 16, a: a};
};
var $author$project$CWS$ActionDetail$LoadedDetailsNew = function (a) {
	return {$: 7, a: a};
};
var $author$project$CWS$ActionDetail$SubmitError = function (a) {
	return {$: 11, a: a};
};
var $author$project$CWS$ActionDetail$SubmittedAction = function (a) {
	return {$: 10, a: a};
};
var $author$project$CWS$API$Action$NoOp = {$: 0};
var $author$project$CWS$API$Action$callWithDefault = F2(
	function (maybemsg, nope) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$always(nope),
			maybemsg);
	});
var $author$project$CWS$API$Action$apiTranslator = F2(
	function (td, msg) {
		switch (msg.$) {
			case 10:
				return td.f3;
			case 11:
				var m = msg.a;
				return td.cO(m);
			case 0:
				var m = msg.a;
				if (!m.$) {
					var a = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.fY,
						td.cO($author$project$CWS$API$Action$NoOp))(a);
				} else {
					var e = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.fX,
						td.cO($author$project$CWS$API$Action$NoOp))(e);
				}
			case 5:
				var m = msg.a;
				if (!m.$) {
					var a = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f4,
						td.cO($author$project$CWS$API$Action$NoOp))(a);
				} else {
					var e = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f5,
						td.cO($author$project$CWS$API$Action$NoOp))(e);
				}
			case 9:
				var m = msg.a;
				if (!m.$) {
					var a = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f$,
						td.cO($author$project$CWS$API$Action$NoOp))(a);
				} else {
					var e = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f0,
						td.cO($author$project$CWS$API$Action$NoOp))(e);
				}
			case 6:
				var m = msg.a;
				if (!m.$) {
					var a = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f6,
						td.cO($author$project$CWS$API$Action$NoOp))(a);
				} else {
					var e = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f7,
						td.cO($author$project$CWS$API$Action$NoOp))(e);
				}
			case 7:
				var m = msg.a;
				if (!m.$) {
					var a = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.fZ,
						td.cO($author$project$CWS$API$Action$NoOp))(a);
				} else {
					var e = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f_,
						td.cO($author$project$CWS$API$Action$NoOp))(e);
				}
			case 8:
				var m = msg.a;
				if (!m.$) {
					var a = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f1,
						td.cO($author$project$CWS$API$Action$NoOp))(a);
				} else {
					var e = m.a;
					return A2(
						$author$project$CWS$API$Action$callWithDefault,
						td.f2,
						td.cO($author$project$CWS$API$Action$NoOp))(e);
				}
			default:
				return td.cO($author$project$CWS$API$Action$NoOp);
		}
	});
var $author$project$CWS$ActionDetail$APIMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$CWS$ActionDetail$ApiNeedsAuth = {$: 33};
var $author$project$CWS$API$Action$defaultAPI = F2(
	function (internal, needsAuth) {
		return {fX: $elm$core$Maybe$Nothing, fY: $elm$core$Maybe$Nothing, fZ: $elm$core$Maybe$Nothing, f_: $elm$core$Maybe$Nothing, f$: $elm$core$Maybe$Nothing, f0: $elm$core$Maybe$Nothing, f1: $elm$core$Maybe$Nothing, f2: $elm$core$Maybe$Nothing, cO: internal, f3: needsAuth, f4: $elm$core$Maybe$Nothing, f5: $elm$core$Maybe$Nothing, f6: $elm$core$Maybe$Nothing, f7: $elm$core$Maybe$Nothing};
	});
var $author$project$CWS$ActionDetail$defaultActionApi = A2($author$project$CWS$API$Action$defaultAPI, $author$project$CWS$ActionDetail$APIMsg, $author$project$CWS$ActionDetail$ApiNeedsAuth);
var $author$project$CWS$ActionDetail$actionAPITranslator = $author$project$CWS$API$Action$apiTranslator(
	_Utils_update(
		$author$project$CWS$ActionDetail$defaultActionApi,
		{
			fX: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$CouldntLoadDetails),
			fY: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$LoadedDetailsNew),
			fZ: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$ApprovedAction),
			f_: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$ApproveError),
			f1: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$DeniedAction),
			f2: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$DenyError),
			f4: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$ActionSaved),
			f5: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$CouldntSave),
			f6: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$SubmittedAction),
			f7: $elm$core$Maybe$Just($author$project$CWS$ActionDetail$SubmitError)
		}));
var $author$project$CWS$API$Action$API_Approve = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$CWS$API$Action$ApproveResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$CWS$API$Action$Internal = function (a) {
	return {$: 11, a: a};
};
var $author$project$CWS$API$Action$UnAuthorized = function (a) {
	return {$: 1, a: a};
};
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$CWS$API$Action$approvalEncoder = F2(
	function (id, notes) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id)),
					_Utils_Tuple2(
					'notes',
					$elm_community$json_extra$Json$Encode$Extra$maybe($elm$json$Json$Encode$string)(notes))
				]));
	});
var $author$project$CWS$API$Action$approve = F3(
	function (id, notes, settings) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings.m,
			'Actions',
			'Approve',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$API$Action$approvalEncoder, id, notes)),
			$author$project$CWS$API$Action$ApproveResponse,
			$elm$core$Basics$always(
				$author$project$CWS$API$Action$Internal(
					$author$project$CWS$API$Action$UnAuthorized(
						A2($author$project$CWS$API$Action$API_Approve, id, notes)))),
			settings.f,
			$author$project$CWS$Model$actionModelDecoder);
	});
var $author$project$CWS$API$Action$API_Delete = function (a) {
	return {$: 9, a: a};
};
var $author$project$CWS$API$Action$DeleteResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$CWS$API$Action$delete = F2(
	function (id, settings) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings.m,
			'Actions',
			'Delete',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$Action$byIdGetRequestEncoder(id)),
			$author$project$CWS$API$Action$DeleteResponse,
			$elm$core$Basics$always(
				$author$project$CWS$API$Action$Internal(
					$author$project$CWS$API$Action$UnAuthorized(
						$author$project$CWS$API$Action$API_Delete(id)))),
			settings.f,
			$author$project$CWS$Model$actionModelDecoder);
	});
var $author$project$CWS$API$Action$API_Deny = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$CWS$API$Action$DenyResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$CWS$API$Action$deny = F3(
	function (id, notes, settings) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings.m,
			'Actions',
			'Deny',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$API$Action$approvalEncoder, id, notes)),
			$author$project$CWS$API$Action$DenyResponse,
			$elm$core$Basics$always(
				$author$project$CWS$API$Action$Internal(
					$author$project$CWS$API$Action$UnAuthorized(
						A2($author$project$CWS$API$Action$API_Deny, id, notes)))),
			settings.f,
			$author$project$CWS$Model$actionModelDecoder);
	});
var $author$project$CWS$API$Action$API_Get = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$API$Action$ActionResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$API$Action$get = F2(
	function (id, settings) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings.m,
			'Actions',
			'Get',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$Action$byIdGetRequestEncoder(id)),
			$author$project$CWS$API$Action$ActionResponse,
			$elm$core$Basics$always(
				$author$project$CWS$API$Action$Internal(
					$author$project$CWS$API$Action$UnAuthorized(
						$author$project$CWS$API$Action$API_Get(id)))),
			settings.f,
			$author$project$CWS$Model$actionModelDecoder);
	});
var $author$project$CWS$API$Action$API_Save = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$CWS$API$Action$SaveResponse = function (a) {
	return {$: 5, a: a};
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$CWS$Model$keyedNamedValueEncoder = function (keyedNamedValue) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(keyedNamedValue.ab)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(keyedNamedValue.dz)),
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(keyedNamedValue.v))
			]));
};
var $author$project$CWS$Model$shapeEncoder = function (shape) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(shape.ab)),
				_Utils_Tuple2(
				'WKT',
				$elm$json$Json$Encode$string(shape.I))
			]));
};
var $author$project$Fields$Shared$validityToMaybe = function (v) {
	if (v.$ === 1) {
		var a = v.a;
		return $elm$core$Maybe$Just(a);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$CWS$Model$actionModelEncoder = F2(
	function (peid, model) {
		var actionYear = A2($elm$core$Maybe$withDefault, '', model.W);
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(model.ab)),
					_Utils_Tuple2(
					'name',
					$elm_community$json_extra$Json$Encode$Extra$maybe($elm$json$Json$Encode$string)(model.dz)),
					_Utils_Tuple2(
					'category',
					$author$project$CWS$Model$keyedNamedValueEncoder(model.bK)),
					_Utils_Tuple2(
					'group',
					$author$project$CWS$Model$keyedNamedValueEncoder(model.hM)),
					_Utils_Tuple2(
					'type',
					$author$project$CWS$Model$keyedNamedValueEncoder(model.jE)),
					_Utils_Tuple2(
					'startDate',
					$elm_community$json_extra$Json$Encode$Extra$maybe($elm$json$Json$Encode$string)(model.dL)),
					_Utils_Tuple2(
					'endDate',
					$elm_community$json_extra$Json$Encode$Extra$maybe($elm$json$Json$Encode$string)(model.el)),
					_Utils_Tuple2(
					'funding',
					$author$project$CWS$Model$keyedNamedValueEncoder(model.fv)),
					_Utils_Tuple2(
					'estimatedCost',
					A2(
						$elm_community$json_extra$Json$Encode$Extra$maybe,
						$elm$json$Json$Encode$float,
						$author$project$Fields$Shared$validityToMaybe(model.ll))),
					_Utils_Tuple2(
					'description',
					$elm_community$json_extra$Json$Encode$Extra$maybe($elm$json$Json$Encode$string)(model.hp)),
					_Utils_Tuple2(
					'hours',
					A2(
						$elm_community$json_extra$Json$Encode$Extra$maybe,
						$elm$json$Json$Encode$float,
						$author$project$Fields$Shared$validityToMaybe(model.fB))),
					_Utils_Tuple2(
					'acres',
					A2(
						$elm_community$json_extra$Json$Encode$Extra$maybe,
						$elm$json$Json$Encode$float,
						$author$project$Fields$Shared$validityToMaybe(model.bH))),
					_Utils_Tuple2(
					'bioMass',
					A2(
						$elm_community$json_extra$Json$Encode$Extra$maybe,
						$elm$json$Json$Encode$float,
						$author$project$Fields$Shared$validityToMaybe(model.e9))),
					_Utils_Tuple2(
					'peid',
					$elm$json$Json$Encode$string(peid)),
					_Utils_Tuple2(
					'shape',
					$elm_community$json_extra$Json$Encode$Extra$maybe($author$project$CWS$Model$shapeEncoder)(model.I)),
					_Utils_Tuple2(
					'actionYear',
					$elm$json$Json$Encode$string(actionYear))
				]));
	});
var $author$project$CWS$API$Action$save = F3(
	function (peid, action, settings) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings.m,
			'Actions',
			'Save',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$Model$actionModelEncoder, peid, action)),
			$author$project$CWS$API$Action$SaveResponse,
			$elm$core$Basics$always(
				$author$project$CWS$API$Action$Internal(
					$author$project$CWS$API$Action$UnAuthorized(
						A2($author$project$CWS$API$Action$API_Save, peid, action)))),
			settings.f,
			$author$project$CWS$Model$actionModelDecoder);
	});
var $author$project$CWS$API$Action$API_Submit = function (a) {
	return {$: 6, a: a};
};
var $author$project$CWS$API$Action$SubmitResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$CWS$API$Action$submit = F2(
	function (action, settings) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings.m,
			'Actions',
			'Submit',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$Model$actionModelEncoder, '', action)),
			$author$project$CWS$API$Action$SubmitResponse,
			$elm$core$Basics$always(
				$author$project$CWS$API$Action$Internal(
					$author$project$CWS$API$Action$UnAuthorized(
						$author$project$CWS$API$Action$API_Submit(action)))),
			settings.f,
			$author$project$CWS$Model$actionModelDecoder);
	});
var $author$project$CWS$API$Action$reRequest = function (apiRequest) {
	switch (apiRequest.$) {
		case 0:
			var id = apiRequest.a;
			return $author$project$CWS$API$Action$get(id);
		case 5:
			var pe = apiRequest.a;
			var action = apiRequest.b;
			return A2($author$project$CWS$API$Action$save, pe, action);
		case 9:
			var id = apiRequest.a;
			return $author$project$CWS$API$Action$delete(id);
		case 6:
			var action = apiRequest.a;
			return $author$project$CWS$API$Action$submit(action);
		case 7:
			var id = apiRequest.a;
			var notes = apiRequest.b;
			return A2($author$project$CWS$API$Action$approve, id, notes);
		case 8:
			var id = apiRequest.a;
			var notes = apiRequest.b;
			return A2($author$project$CWS$API$Action$deny, id, notes);
		default:
			return $elm$core$Basics$always($elm$core$Platform$Cmd$none);
	}
};
var $author$project$CWS$API$Action$authorizedRecurs = F2(
	function (env, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		var _v1 = model.b3;
		if (!_v1.b) {
			return _Utils_Tuple2(model, cmds);
		} else {
			if (!_v1.b.b) {
				var item = _v1.a;
				var nm = _Utils_update(
					model,
					{b3: _List_Nil});
				return _Utils_Tuple2(
					nm,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmds,
								A2($author$project$CWS$API$Action$reRequest, item, env)
							])));
			} else {
				var item = _v1.a;
				var more = _v1.b;
				var nm = _Utils_update(
					model,
					{b3: more});
				return A2(
					$author$project$CWS$API$Action$authorizedRecurs,
					env,
					_Utils_Tuple2(
						nm,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmds,
									A2($author$project$CWS$API$Action$reRequest, item, env)
								]))));
			}
		}
	});
var $author$project$CWS$API$Action$authorized = F2(
	function (env, model) {
		return A2(
			$author$project$CWS$API$Action$authorizedRecurs,
			env,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$CWS$ActionDetail$authorized = F2(
	function (model, env) {
		var _v0 = A2($author$project$CWS$API$Action$authorized, env, model.cm);
		var newApi = _v0.a;
		var newApiCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cm: newApi}),
			A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$actionAPITranslator, newApiCmd));
	});
var $author$project$CWS$Model$RequestConfirmation = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$ActionDetail$denit = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$CWS$API$APIRequest$API_Types_GetForActionId = function (a) {
	return {$: 16, a: a};
};
var $author$project$CWS$LoadChunk$ActionTypesForCategory = function (a) {
	return {$: 4, a: a};
};
var $author$project$CWS$API$ActionType$byIdGetRequestEncoder = function (id) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(id))
			]));
};
var $author$project$CWS$Model$keyedNamedValueListDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$keyedNamedValueDecoder);
var $author$project$CWS$API$ActionType$getTypesForActionById = F5(
	function (settings, user, id, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'ActionTypes',
			'GetForAction',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$ActionType$byIdGetRequestEncoder(id)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$keyedNamedValueListDecoder);
	});
var $author$project$CWS$API$Core$api_Types_GetForActionId = F2(
	function (id, model) {
		return A5(
			$author$project$CWS$API$ActionType$getTypesForActionById,
			model.p.m.av,
			model.f,
			id,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$ActionTypesForCategory(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					$author$project$CWS$API$APIRequest$API_Types_GetForActionId(id));
			});
	});
var $author$project$CWS$requestSwitchToAction = F2(
	function (model, id) {
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{aG: $author$project$CWS$Model$Loading});
		var cmd = A2($author$project$CWS$API$Core$api_Types_GetForActionId, id, model);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$API$APIRequest$API_PE_GetBreakdownStats = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$CWS$LoadChunk$ParticipatingEntityBreakdownStats = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Model$ActionCategoryTypeStatusStats = F8(
	function (category, type_, status, count, totalCost, totalAcres, totalBiomass, totalHours) {
		return {bK: category, kX: count, jf: status, ot: totalAcres, ou: totalBiomass, ov: totalCost, ow: totalHours, jE: type_};
	});
var $author$project$CWS$Model$actionCategoryTypeStatusStatsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totalHours',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'totalBiomass',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'totalAcres',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'totalCost',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'count',
					$elm$json$Json$Decode$int,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'status',
						$author$project$CWS$Model$actionStatusDecoder,
						0,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'type',
							$author$project$CWS$Model$keyedNamedValueDecoder,
							$author$project$CWS$Model$defaultActionType,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'category',
								$author$project$CWS$Model$keyedNamedValueDecoder,
								$author$project$CWS$Model$defaultCategory,
								$elm$json$Json$Decode$succeed($author$project$CWS$Model$ActionCategoryTypeStatusStats)))))))));
var $author$project$CWS$Model$actionCategoryTypeStatusStatsListDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$actionCategoryTypeStatusStatsDecoder);
var $author$project$CWS$API$ParticipatingEntity$encodePEStatRequest = F2(
	function (key, year) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'key',
					$elm$json$Json$Encode$string(key)),
					_Utils_Tuple2(
					'year',
					$elm$json$Json$Encode$string(year))
				]));
	});
var $author$project$CWS$API$ParticipatingEntity$getBreakdownStatsFor = F6(
	function (settings, user, key, year, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'ParticipatingEntity',
			'GetBreakdownStats',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$API$ParticipatingEntity$encodePEStatRequest, key, year)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$actionCategoryTypeStatusStatsListDecoder);
	});
var $author$project$CWS$API$Core$api_PE_GetBreakdownStats = F3(
	function (peID, year, model) {
		return A6(
			$author$project$CWS$API$ParticipatingEntity$getBreakdownStatsFor,
			model.p.m.av,
			model.f,
			peID,
			year,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$ParticipatingEntityBreakdownStats(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					A2($author$project$CWS$API$APIRequest$API_PE_GetBreakdownStats, peID, year));
			});
	});
var $author$project$CWS$API$APIRequest$API_PE_GetByKey = function (a) {
	return {$: 5, a: a};
};
var $author$project$CWS$LoadChunk$SelectedParticipatingEntity = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$API$ParticipatingEntity$getByKeyRequestEncoder = function (urlKey) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'urlKey',
				$elm$json$Json$Encode$string(urlKey))
			]));
};
var $author$project$CWS$API$ParticipatingEntity$getPEByKey = F5(
	function (settings, user, urlKey, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'ParticipatingEntity',
			'GetByKey',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$ParticipatingEntity$getByKeyRequestEncoder(urlKey)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$participatingEntityModelDecoder);
	});
var $author$project$CWS$API$Core$api_PE_GetByKey = F2(
	function (peID, model) {
		return A5(
			$author$project$CWS$API$ParticipatingEntity$getPEByKey,
			model.p.m.av,
			model.f,
			peID,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$SelectedParticipatingEntity(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					$author$project$CWS$API$APIRequest$API_PE_GetByKey(peID));
			});
	});
var $author$project$CWS$API$APIRequest$API_Types_GetForCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$CWS$API$ActionType$byKeyGetRequestEncoder = function (id) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(id))
			]));
};
var $author$project$CWS$API$ActionType$getTypesForCategory = F5(
	function (settings, user, catKey, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'ActionTypes',
			'GetForCategory',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$ActionType$byKeyGetRequestEncoder(catKey)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$keyedNamedValueListDecoder);
	});
var $author$project$CWS$API$Core$api_Types_GetForCategory = F2(
	function (category, model) {
		return A5(
			$author$project$CWS$API$ActionType$getTypesForCategory,
			model.p.m.av,
			model.f,
			category,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$ActionTypesForCategory(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					$author$project$CWS$API$APIRequest$API_Types_GetForCategory(category));
			});
	});
var $author$project$CWS$requestSwitchToActions = F4(
	function (model, peID, year, category) {
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{aG: $author$project$CWS$Model$Loading});
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$CWS$API$Core$api_Types_GetForCategory, category, model),
					A3($author$project$CWS$API$Core$api_PE_GetBreakdownStats, peID, year, model),
					A2($author$project$CWS$API$Core$api_PE_GetByKey, peID, model)
				]));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$API$APIRequest$API_File_GetAllDocumentsForPE = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$CWS$LoadChunk$AllDocumentsForPE = function (a) {
	return {$: 7, a: a};
};
var $author$project$CWS$Model$FileModel = function (id) {
	return function (name) {
		return function (description) {
			return function (status) {
				return function (fileUserName) {
					return function (actionGroup) {
						return function (actionType) {
							return function (actionId) {
								return function (actionName) {
									return function (modified) {
										return {gG: actionGroup, gH: actionId, gI: actionName, gJ: actionType, hp: description, hC: fileUserName, ab: id, ik: modified, dz: name, jf: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CWS$Model$fileDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'modified',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'actionName',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'actionId',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'actionType',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'actionGroup',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'fileUserName',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'status',
							$elm$json$Json$Decode$int,
							0,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'description',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$CWS$Model$FileModel)))))))))));
var $author$project$CWS$Model$fileListDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$fileDecoder);
var $author$project$CWS$API$File$getFilesForPeYearRequestEncoder = F2(
	function (peID, yearKey) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'key',
					$elm$json$Json$Encode$string(peID)),
					_Utils_Tuple2(
					'year',
					$elm$json$Json$Encode$string(yearKey))
				]));
	});
var $author$project$CWS$API$File$getFilesForPe = F6(
	function (settings, user, key, yearKey, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'GetByPe',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$API$File$getFilesForPeYearRequestEncoder, key, yearKey)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$fileListDecoder);
	});
var $author$project$CWS$API$File$getAllDocumentsForPE = F6(
	function (settings, user, key, yearKey, _return, onError) {
		return A6($author$project$CWS$API$File$getFilesForPe, settings, user, key, yearKey, _return, onError);
	});
var $author$project$CWS$API$Core$api_File_GetAllDocumentsForPE = F3(
	function (peID, year, model) {
		return A6(
			$author$project$CWS$API$File$getAllDocumentsForPE,
			model.p.m.av,
			model.f,
			peID,
			year,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$AllDocumentsForPE(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					A2($author$project$CWS$API$APIRequest$API_File_GetAllDocumentsForPE, peID, year));
			});
	});
var $author$project$CWS$API$APIRequest$API_PE_GetAssigned = {$: 3};
var $author$project$CWS$LoadChunk$AssignedParticipatingEntities = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$Model$participatingEntityModelListDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$participatingEntityModelDecoder);
var $author$project$CWS$API$ParticipatingEntity$getAssignedPEs = F4(
	function (settings, user, _return, onError) {
		return A8($author$project$CWS$API$postRequestNew, settings, 'ParticipatingEntity', 'GetAssigned', $elm$core$Maybe$Nothing, _return, onError, user, $author$project$CWS$Model$participatingEntityModelListDecoder);
	});
var $author$project$CWS$API$Core$api_PE_GetAssigned = function (model) {
	return A4(
		$author$project$CWS$API$ParticipatingEntity$getAssignedPEs,
		model.p.m.av,
		model.f,
		function (x) {
			return $author$project$CWS$Messages$ChunkLoad(
				$author$project$CWS$LoadChunk$AssignedParticipatingEntities(x));
		},
		function (x) {
			return $author$project$CWS$Messages$APIUnauthorizedHandler($author$project$CWS$API$APIRequest$API_PE_GetAssigned);
		});
};
var $author$project$CWS$requestSwitchToAllDocuments = F3(
	function (model, peID, year) {
		var peCmd = $author$project$CWS$API$Core$api_PE_GetAssigned(model);
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{D: $author$project$CWS$Model$Loading, aA: $author$project$CWS$Model$Loading});
		var docCmd = A3($author$project$CWS$API$Core$api_File_GetAllDocumentsForPE, peID, year, model);
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[docCmd, peCmd]));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$API$APIRequest$API_Action_GetAll = {$: 2};
var $author$project$CWS$LoadChunk$AllActionsForApprover = function (a) {
	return {$: 8, a: a};
};
var $author$project$CWS$Model$actionListDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$actionModelDecoder);
var $author$project$CWS$API$Action$byUidGetRequestEncoder = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'uid',
			$elm$json$Json$Encode$string(''))
		]));
var $author$project$CWS$API$Action$getAllActionsForUid = F4(
	function (settings, user, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Actions',
			'GetAllByUid',
			$elm$core$Maybe$Just($author$project$CWS$API$Action$byUidGetRequestEncoder),
			_return,
			onError,
			user,
			$author$project$CWS$Model$actionListDecoder);
	});
var $author$project$CWS$API$Core$api_Actions_GetAll = function (model) {
	return A4(
		$author$project$CWS$API$Action$getAllActionsForUid,
		model.p.m.av,
		model.f,
		function (x) {
			return $author$project$CWS$Messages$ChunkLoad(
				$author$project$CWS$LoadChunk$AllActionsForApprover(x));
		},
		function (x) {
			return $author$project$CWS$Messages$APIUnauthorizedHandler($author$project$CWS$API$APIRequest$API_Action_GetAll);
		});
};
var $author$project$CWS$requestSwitchToAppActions = F2(
	function (model, year) {
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{cl: $author$project$CWS$Model$Loading});
		var actionListCmd = $author$project$CWS$API$Core$api_Actions_GetAll(model);
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[actionListCmd]));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$API$APIRequest$API_PE_GetAssignedOverview = {$: 8};
var $author$project$CWS$LoadChunk$ParticipatingEntityOverview = function (a) {
	return {$: 6, a: a};
};
var $author$project$CWS$Model$ParticipatingEntityOverviewModel = F7(
	function (pe, year, totalCount, pendingCount, submittedCount, deniedCount, approvedCount) {
		return {gQ: approvedCount, ho: deniedCount, eK: pe, iB: pendingCount, jj: submittedCount, jy: totalCount, r: year};
	});
var $author$project$CWS$Model$participatingEntityOverviewModelDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'approvedCount',
	$elm$json$Json$Decode$int,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'deniedCount',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'submittedCount',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'pendingCount',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'totalCount',
					$elm$json$Json$Decode$int,
					0,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'year',
						$elm$json$Json$Decode$string,
						'0',
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'participatingEntity',
							$author$project$CWS$Model$participatingEntityModelDecoder,
							$elm$json$Json$Decode$succeed($author$project$CWS$Model$ParticipatingEntityOverviewModel))))))));
var $author$project$CWS$Model$participatingEntityOverviewModelListDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$participatingEntityOverviewModelDecoder);
var $author$project$CWS$API$ParticipatingEntity$getAssignedPEsOverview = F4(
	function (settings, user, _return, onError) {
		return A8($author$project$CWS$API$postRequestNew, settings, 'ParticipatingEntity', 'GetOverview', $elm$core$Maybe$Nothing, _return, onError, user, $author$project$CWS$Model$participatingEntityOverviewModelListDecoder);
	});
var $author$project$CWS$API$Core$api_PE_GetAssignedOverview = function (model) {
	return A4(
		$author$project$CWS$API$ParticipatingEntity$getAssignedPEsOverview,
		model.p.m.av,
		model.f,
		function (x) {
			return $author$project$CWS$Messages$ChunkLoad(
				$author$project$CWS$LoadChunk$ParticipatingEntityOverview(x));
		},
		function (x) {
			return $author$project$CWS$Messages$APIUnauthorizedHandler($author$project$CWS$API$APIRequest$API_PE_GetAssignedOverview);
		});
};
var $author$project$CWS$requestSwitchToAppDash = F2(
	function (model, year) {
		var peOverviewCmd = $author$project$CWS$API$Core$api_PE_GetAssignedOverview(model);
		var peAssignedCmd = $author$project$CWS$API$Core$api_PE_GetAssigned(model);
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{D: $author$project$CWS$Model$Loading, b0: $author$project$CWS$Model$Loading});
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[peAssignedCmd, peOverviewCmd]));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$API$APIRequest$API_File_GetStaticForPE = function (a) {
	return {$: 14, a: a};
};
var $author$project$CWS$LoadChunk$StaticFilesForParticipatingEntity = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$CWS$API$File$getFilesForPeRequestEncoder = function (peID) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(peID))
			]));
};
var $author$project$CWS$Model$StaticFileModel = F5(
	function (id, name, mode, participatingEntityID, file) {
		return {lv: file, ab: id, mp: mode, dz: name, iy: participatingEntityID};
	});
var $author$project$CWS$Model$staticFileDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'file',
	$elm$json$Json$Decode$maybe($author$project$CWS$Model$fileDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'participatingEntityID',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mode',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$CWS$Model$StaticFileModel))))));
var $author$project$CWS$Model$staticFileListDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$staticFileDecoder);
var $author$project$CWS$API$File$getStaticFilesForPE = F5(
	function (settings, user, key, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'GetStaticFilesByPEKey',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$File$getFilesForPeRequestEncoder(key)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$staticFileListDecoder);
	});
var $author$project$CWS$API$Core$api_File_GetStaticForPE = F2(
	function (pe, model) {
		return A5(
			$author$project$CWS$API$File$getStaticFilesForPE,
			model.p.m.av,
			model.f,
			pe,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					A2($author$project$CWS$LoadChunk$StaticFilesForParticipatingEntity, pe, x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					$author$project$CWS$API$APIRequest$API_File_GetStaticForPE(pe));
			});
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$CWS$loadStaticFilesForKey = F2(
	function (model, pe) {
		var oldDict = model.b.aE;
		return A2($elm$core$Dict$member, pe, oldDict) ? $elm$core$Platform$Cmd$none : A2($author$project$CWS$API$Core$api_File_GetStaticForPE, pe, model);
	});
var $author$project$CWS$requestSwitchToAppDocs = F3(
	function (model, peKey, year) {
		var fc = A2($author$project$CWS$loadStaticFilesForKey, model, peKey);
		var _v0 = A3($author$project$CWS$requestSwitchToAllDocuments, model, peKey, year);
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple2(
			a,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[b, fc])));
	});
var $author$project$CWS$API$APIRequest$API_GetAllUsers = {$: 12};
var $author$project$CWS$LoadChunk$PEUsers = function (a) {
	return {$: 10, a: a};
};
var $author$project$CWS$Model$ManageUser = F4(
	function (name, email, id, assigned) {
		return {df: assigned, ek: email, ab: id, dz: name};
	});
var $author$project$CWS$Model$manageUserDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'assigned',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$CWS$Model$ManageUser)))));
var $author$project$CWS$Model$manageUsersDecoder = $elm$json$Json$Decode$list($author$project$CWS$Model$manageUserDecoder);
var $author$project$CWS$API$ParticipatingEntity$getAllUsers = F4(
	function (settings, user, _return, onError) {
		return A8($author$project$CWS$API$postRequestNew, settings, 'Users', 'GetAll', $elm$core$Maybe$Nothing, _return, onError, user, $author$project$CWS$Model$manageUsersDecoder);
	});
var $author$project$CWS$API$Core$api_GetAllUsers = function (model) {
	return A4(
		$author$project$CWS$API$ParticipatingEntity$getAllUsers,
		model.p.m.av,
		model.f,
		function (x) {
			return $author$project$CWS$Messages$ChunkLoad(
				$author$project$CWS$LoadChunk$PEUsers(x));
		},
		function (x) {
			return $author$project$CWS$Messages$APIUnauthorizedHandler($author$project$CWS$API$APIRequest$API_GetAllUsers);
		});
};
var $author$project$CWS$requestSwitchToAppUsers = function (model) {
	var peUsersCmd = $author$project$CWS$API$Core$api_GetAllUsers(model);
	var oldLoadableChunks = model.b;
	var newLoadableChunks = _Utils_update(
		oldLoadableChunks,
		{aY: $author$project$CWS$Model$Loading});
	var cmd = $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[peUsersCmd]));
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{b: newLoadableChunks}),
		cmd);
};
var $author$project$CWS$requestSwitchToCWSRoute = F2(
	function (model, route) {
		switch (route.$) {
			case 0:
				return A2($author$project$CWS$requestSwitchToAppDash, model, 0);
			case 1:
				return $author$project$CWS$requestSwitchToAppUsers(model);
			case 2:
				return A2($author$project$CWS$requestSwitchToAppActions, model, 0);
			case 3:
				var pe = route.a;
				return A3($author$project$CWS$requestSwitchToAppDocs, model, pe.d, pe.r);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$API$APIRequest$API_PE_GetStats = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$CWS$LoadChunk$ParticipatingEntityStats = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Model$PEStatObject = F5(
	function (projected, confirmed, mitigation, preparedness, prevention) {
		return {kR: confirmed, mo: mitigation, nj: preparedness, nk: prevention, no: projected};
	});
var $author$project$CWS$Model$StatItem = F2(
	function (value, total) {
		return {eY: total, gv: value};
	});
var $author$project$CWS$Model$statItemDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'total',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$CWS$Model$StatItem)));
var $author$project$CWS$Model$TotalStat = function (total) {
	return {eY: total};
};
var $author$project$CWS$Model$totalStatDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total',
	$elm$json$Json$Decode$float,
	$elm$json$Json$Decode$succeed($author$project$CWS$Model$TotalStat));
var $author$project$CWS$Model$peStatObjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'prevention',
	$author$project$CWS$Model$totalStatDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'preparedness',
		$author$project$CWS$Model$totalStatDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mitigation',
			$author$project$CWS$Model$totalStatDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'confirmed',
				$author$project$CWS$Model$statItemDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'projected',
					$author$project$CWS$Model$statItemDecoder,
					$elm$json$Json$Decode$succeed($author$project$CWS$Model$PEStatObject))))));
var $author$project$CWS$API$ParticipatingEntity$getStatsFor = F6(
	function (settings, user, key, year, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'ParticipatingEntity',
			'GetStats',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$API$ParticipatingEntity$encodePEStatRequest, key, year)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$peStatObjectDecoder);
	});
var $author$project$CWS$API$Core$api_PE_GetStats = F3(
	function (peId, year, model) {
		return A6(
			$author$project$CWS$API$ParticipatingEntity$getStatsFor,
			model.p.m.av,
			model.f,
			peId,
			year,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$ParticipatingEntityStats(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					A2($author$project$CWS$API$APIRequest$API_PE_GetStats, peId, year));
			});
	});
var $author$project$CWS$requestSwitchToHome = F3(
	function (model, peID, year) {
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{az: $author$project$CWS$Model$Loading, b2: $author$project$CWS$Model$Loading, aC: $author$project$CWS$Model$Loading});
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$CWS$API$Core$api_PE_GetByKey, peID, model),
					A3($author$project$CWS$API$Core$api_PE_GetStats, peID, year, model),
					A3($author$project$CWS$API$Core$api_PE_GetBreakdownStats, peID, year, model)
				]));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$API$APIRequest$API_PE_GetUsers = function (a) {
	return {$: 9, a: a};
};
var $author$project$CWS$API$ParticipatingEntity$getByKeyRequestEncoderForReal = function (key) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(key))
			]));
};
var $author$project$CWS$API$ParticipatingEntity$getUsersForPE = F5(
	function (settings, user, pekey, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'ParticipatingEntity',
			'GetUsers',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$ParticipatingEntity$getByKeyRequestEncoderForReal(pekey)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$manageUsersDecoder);
	});
var $author$project$CWS$API$Core$api_PE_GetUsers = F2(
	function (peKey, model) {
		return A5(
			$author$project$CWS$API$ParticipatingEntity$getUsersForPE,
			model.p.m.av,
			model.f,
			peKey,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$PEUsers(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					$author$project$CWS$API$APIRequest$API_PE_GetUsers(peKey));
			});
	});
var $author$project$CWS$requestSwitchToManagePEUsers = F2(
	function (model, peKey) {
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{aY: $author$project$CWS$Model$Loading});
		var cmd = A2($author$project$CWS$API$Core$api_PE_GetUsers, peKey, model);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$API$APIRequest$API_User_GetPEs = function (a) {
	return {$: 10, a: a};
};
var $author$project$CWS$API$ParticipatingEntity$getAssignedPEsForUser = F5(
	function (settings, user, userID, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Users',
			'GetPEs',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$ParticipatingEntity$getByKeyRequestEncoderForReal(userID)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$userParticipatingEntitiesDecoder);
	});
var $author$project$CWS$API$Core$api_User_GetPEs = F2(
	function (userid, model) {
		return A5(
			$author$project$CWS$API$ParticipatingEntity$getAssignedPEsForUser,
			model.p.m.av,
			model.f,
			userid,
			function (x) {
				return $author$project$CWS$Messages$ChunkLoad(
					$author$project$CWS$LoadChunk$UserPEs(x));
			},
			function (x) {
				return $author$project$CWS$Messages$APIUnauthorizedHandler(
					$author$project$CWS$API$APIRequest$API_User_GetPEs(userid));
			});
	});
var $author$project$CWS$requestSwitchToManageUserPEs = F2(
	function (model, userid) {
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{cg: $author$project$CWS$Model$Loading});
		var cmd = A2($author$project$CWS$API$Core$api_User_GetPEs, userid, model);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$requestSwitchToNewAction = F2(
	function (model, category) {
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{aG: $author$project$CWS$Model$Loading});
		var cmd = A2($author$project$CWS$API$Core$api_Types_GetForCategory, category, model);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			cmd);
	});
var $author$project$CWS$requestSwitchToPeSelect = function (model) {
	var os = model.a;
	var ns = _Utils_update(
		os,
		{cS: $author$project$CWS$PeSelect$defaultModel});
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{a: ns}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$CWS$requestSwitchToReports = F3(
	function (model, pe, rte) {
		var oldLoadableChunks = model.b;
		var newLoadableChunks = _Utils_update(
			oldLoadableChunks,
			{az: $author$project$CWS$Model$Loading, b2: $author$project$CWS$Model$Loading, aC: $author$project$CWS$Model$Loading});
		var c = _Utils_ap(
			_List_fromArray(
				[
					A3($author$project$CWS$API$Core$api_PE_GetBreakdownStats, pe.d, pe.r, model),
					A2($author$project$CWS$API$Core$api_PE_GetByKey, pe.d, model),
					A3($author$project$CWS$API$Core$api_PE_GetStats, pe.d, pe.r, model)
				]),
			_Utils_eq(model.b.D, $author$project$CWS$Model$NotRequested) ? _List_fromArray(
				[
					$author$project$CWS$API$Core$api_PE_GetAssigned(model)
				]) : _List_Nil);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{b: newLoadableChunks}),
			$elm$core$Platform$Cmd$batch(c));
	});
var $author$project$CWS$Route$getYearFromRoute = function (currentRoute) {
	var _v0 = currentRoute.z;
	switch (_v0.$) {
		case 4:
			var sub = _v0.a;
			switch (sub.$) {
				case 0:
					var home = sub.a;
					return $elm$core$Maybe$Just(home.r);
				case 1:
					var actions = sub.a;
					return $elm$core$Maybe$Just(actions.d.r);
				case 4:
					var allDocs = sub.a;
					return $elm$core$Maybe$Just(allDocs.d.r);
				default:
					return $elm$core$Maybe$Nothing;
			}
		case 5:
			var sub = _v0.a;
			if (sub.$ === 3) {
				var docs = sub.a;
				return $elm$core$Maybe$Just(docs.r);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PlugMapOld$Core$Ports$destructMapCmd = _Platform_outgoingPort(
	'destructMapCmd',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMapOld$Core$denit = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$PlugMapOld$Core$Ports$destructMapCmd(0));
};
var $author$project$CWS$Home$denit = function (model) {
	var _v0 = $author$project$PlugMapOld$Core$denit(model.q);
	var mapModel = _v0.a;
	var mapCmds = _v0.b;
	return _Utils_Tuple2(
		model,
		A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$MapMsg, mapCmds));
};
var $author$project$CWS$getSelectedPE = F2(
	function (model, targetPEKey) {
		var _v0 = model.b.aC;
		if (_v0.$ === 2) {
			var pe = _v0.a;
			return $elm$core$Maybe$Just(pe);
		} else {
			var _v1 = model.b.D;
			if (_v1.$ === 2) {
				var pes = _v1.a;
				switch (pes.$) {
					case 1:
						var pe = pes.a;
						return _Utils_eq(pe.v, targetPEKey) ? $elm$core$Maybe$Just(pe) : $elm$core$Maybe$Nothing;
					case 2:
						var peas = pes.a;
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (element) {
									return _Utils_eq(element.v, targetPEKey);
								},
								peas));
					default:
						return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$CWS$getSelectedPEFromAppRoute = F2(
	function (model, route) {
		var targetPEKey = function () {
			if (route.$ === 3) {
				var pe = route.a;
				return pe.d;
			} else {
				return 'Unknown';
			}
		}();
		return A2($author$project$CWS$getSelectedPE, model, targetPEKey);
	});
var $author$project$CWS$getSelectedPEFromPERoute = F2(
	function (model, route) {
		var targetPEKey = function () {
			switch (route.$) {
				case 0:
					var home = route.a;
					return home.d;
				case 1:
					var action = route.a;
					return action.d.d;
				case 4:
					var pe = route.a;
					return pe.d.d;
				default:
					return 'Unknown';
			}
		}();
		return A2($author$project$CWS$getSelectedPE, model, targetPEKey);
	});
var $author$project$CWS$getSelectedPEFromMainRoute = F2(
	function (model, route) {
		switch (route.$) {
			case 4:
				var sub = route.a;
				return A2($author$project$CWS$getSelectedPEFromPERoute, model, sub);
			case 5:
				var sub = route.a;
				return A2($author$project$CWS$getSelectedPEFromAppRoute, model, sub);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$CWS$UploadDocuments$StaticWorkflow = function (staticFiles) {
	return {aE: staticFiles};
};
var $author$project$CWS$UploadDocuments$Workflow_Static = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$UploadDocuments$NotUploaded = {$: 0};
var $author$project$CWS$UploadDocuments$Uploaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$CWS$UploadDocuments$staticFileModelToState = function (staticFile) {
	var _v0 = staticFile.lv;
	if (_v0.$ === 1) {
		return $author$project$CWS$UploadDocuments$NotUploaded;
	} else {
		var file = _v0.a;
		return A2($author$project$CWS$UploadDocuments$Uploaded, file.dz, file.hp);
	}
};
var $author$project$CWS$UploadDocuments$newStaticFileUploadModel = function (sf) {
	return {
		fS: $elm$core$Maybe$Nothing,
		fT: $elm$core$Maybe$Nothing,
		dA: $elm$core$Maybe$Nothing,
		bx: $elm$core$Maybe$Nothing,
		a: $author$project$CWS$UploadDocuments$staticFileModelToState(sf),
		J: sf
	};
};
var $author$project$CWS$UploadDocuments$initStaticWorkflow = function (staticFiles) {
	return $author$project$CWS$UploadDocuments$Workflow_Static(
		$author$project$CWS$UploadDocuments$StaticWorkflow(
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (file) {
						return _Utils_Tuple2(
							file.ab,
							$author$project$CWS$UploadDocuments$newStaticFileUploadModel(file));
					},
					staticFiles))));
};
var $author$project$CWS$UploadDocuments$initWithFiles = F6(
	function (pe, currentRoute, files, downloadPrepend, canUpload, canEdit) {
		var oldModel = $author$project$CWS$UploadDocuments$defaultModel;
		var newModel = _Utils_update(
			oldModel,
			{g3: canEdit, g4: canUpload, ff: currentRoute, aK: files, eK: pe, dE: downloadPrepend});
		var newCmds = $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$switchToAllDocuments = F3(
	function (oldRoute, peInfo, model) {
		var selectedPE = A2($author$project$CWS$getSelectedPE, model, peInfo.d);
		var newYear = 0;
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(selectedPE, model.b.aA);
			if ((!_v1.a.$) && (_v1.b.$ === 2)) {
				var pe = _v1.a.a;
				var files = _v1.b.a;
				return A6(
					$author$project$CWS$UploadDocuments$initWithFiles,
					pe,
					A2($author$project$CWS$Route$FullRoute, oldRoute, $author$project$CWS$Route$None),
					files,
					$elm$core$Maybe$Nothing,
					true,
					true);
			} else {
				return _Utils_Tuple2($author$project$CWS$UploadDocuments$defaultModel, $elm$core$Platform$Cmd$none);
			}
		}();
		var newAllDocuments = _v0.a;
		var newCmds = _v0.b;
		return _Utils_Tuple2(
			newAllDocuments,
			A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$FileUploadMsg, newCmds));
	});
var $author$project$CWS$handleMainChangeCWSApp = F3(
	function (oldRoute, model, sub) {
		if (sub.$ === 3) {
			var pe = sub.a;
			var oldState = model.a;
			var lsf = A2($elm$core$Dict$get, pe.d, model.b.aE);
			var newWorkflow = function () {
				if ((!lsf.$) && (lsf.a.$ === 2)) {
					var files = lsf.a.a;
					return $author$project$CWS$UploadDocuments$initStaticWorkflow(files);
				} else {
					return $author$project$CWS$UploadDocuments$noWorkflow;
				}
			}();
			var nmf = function () {
				if (!lsf.$) {
					var files = lsf.a;
					if (files.$ === 2) {
						var filesz = files.a;
						return $elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (a) {
									return _Utils_Tuple2(
										a.ab,
										_Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, a));
								},
								filesz));
					} else {
						return $elm$core$Dict$empty;
					}
				} else {
					return $elm$core$Dict$empty;
				}
			}();
			var _v1 = A3(
				$author$project$CWS$switchToAllDocuments,
				$author$project$CWS$Route$CWSApprover(sub),
				pe,
				model);
			var allDocumentsModel = _v1.a;
			var allDocumentsCmds = _v1.b;
			var newState = _Utils_update(
				oldState,
				{U: allDocumentsModel, cM: nmf, ce: newWorkflow});
			var newModel = _Utils_update(
				model,
				{a: newState});
			return _Utils_Tuple2(
				newModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[allDocumentsCmds])));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PlugMapOld$Plugins$Themes$Single = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMapOld$Plugins$Themes$WMTSLayer = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMapOld$Plugins$Themes$WMTSLayerConfig = F2(
	function (layers, extent) {
		return {cy: extent, h7: layers};
	});
var $author$project$PlugMapOld$Plugins$Themes$defaultExtent = _List_fromArray(
	[-20037508.3428, -20037508.3428, 20037508.3428, 20037508.3428]);
var $author$project$CWS$cwsRiskLayer = A4(
	$author$project$PlugMapOld$Plugins$Themes$Layer,
	'cwsRisk',
	'CWS Risk',
	$elm$core$Maybe$Just(0.8),
	$author$project$PlugMapOld$Plugins$Themes$WMTSLayer(
		A2(
			$author$project$PlugMapOld$Plugins$Themes$WMTSLayerConfig,
			$author$project$PlugMapOld$Plugins$Themes$Single(
				A3(
					$author$project$PlugMapOld$Plugins$Themes$LayerUrl,
					'fireriskindexcws/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.png',
					10,
					$elm$core$Maybe$Just('Timmons MapProxy'))),
			$author$project$PlugMapOld$Plugins$Themes$defaultExtent)));
var $author$project$CWS$PE$Reports$InitMap = {$: 1};
var $author$project$CWS$PE$Reports$Ready = function (a) {
	return {$: 1, a: a};
};
var $cuducos$elm_format_number$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {k4: decimals, h_: integers, it: original, gd: prefix, gq: suffix};
	});
var $cuducos$elm_format_number$Parser$Negative = 2;
var $cuducos$elm_format_number$Parser$Positive = 0;
var $cuducos$elm_format_number$Parser$Zero = 1;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $cuducos$elm_format_number$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.h_,
				$elm$core$List$singleton(formatted.k4))));
	return onlyZeros ? 1 : ((formatted.it < 0) ? 2 : 0);
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$String$filter = _String_filter;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $cuducos$elm_format_number$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$Parser$parse = F2(
	function (locale, original) {
		var parts = A2(
			$elm$core$String$split,
			'.',
			A2($myrho$elm_round$Round$round, locale.k4, original));
		var integers = $cuducos$elm_format_number$Parser$splitThousands(
			A2(
				$elm$core$String$filter,
				$elm$core$Char$isDigit,
				A2(
					$elm$core$Maybe$withDefault,
					'0',
					$elm$core$List$head(parts))));
		var decimals = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2($elm$core$List$drop, 1, parts)));
		var partial = A5($cuducos$elm_format_number$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{gd: locale.mx, gq: locale.my});
			case 0:
				return _Utils_update(
					partial,
					{gd: locale.nh, gq: locale.ni});
			default:
				return partial;
		}
	});
var $cuducos$elm_format_number$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.k3, decimals);
	});
var $cuducos$elm_format_number$Stringfy$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$Stringfy$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$Stringfy$humanizeDecimals = F3(
	function (locale, strategy, decimals) {
		if ((decimals === '') || _Utils_eq(
			A2($elm$core$String$repeat, locale.k4, '0'),
			decimals)) {
			return '';
		} else {
			if (!strategy) {
				return _Utils_ap(locale.k3, decimals);
			} else {
				return A2(
					$cuducos$elm_format_number$Stringfy$formatDecimals,
					locale,
					$cuducos$elm_format_number$Stringfy$removeZeros(decimals));
			}
		}
	});
var $cuducos$elm_format_number$Stringfy$stringfy = F3(
	function (locale, strategy, formatted) {
		var stringfyDecimals = function () {
			if (!strategy.$) {
				var strategy_ = strategy.a;
				return A2($cuducos$elm_format_number$Stringfy$humanizeDecimals, locale, strategy_);
			} else {
				return $cuducos$elm_format_number$Stringfy$formatDecimals(locale);
			}
		}();
		var integers = A2($elm$core$String$join, locale.on, formatted.h_);
		var decimals = stringfyDecimals(formatted.k4);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.gd, integers, decimals, formatted.gq]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A3(
			$cuducos$elm_format_number$Stringfy$stringfy,
			locale,
			$elm$core$Maybe$Nothing,
			A2($cuducos$elm_format_number$Parser$parse, locale, number_));
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Locale = F7(
	function (decimals, thousandSeparator, decimalSeparator, negativePrefix, negativeSuffix, positivePrefix, positiveSuffix) {
		return {k3: decimalSeparator, k4: decimals, mx: negativePrefix, my: negativeSuffix, nh: positivePrefix, ni: positiveSuffix, on: thousandSeparator};
	});
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = A7($cuducos$elm_format_number$FormatNumber$Locales$Locale, 2, ',', '.', '−', '', '', '');
var $author$project$CWS$PE$Reports$formatAcres = function (acres) {
	return A2(
		$cuducos$elm_format_number$FormatNumber$format,
		_Utils_update(
			$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
			{k4: 0}),
		acres);
};
var $author$project$CWS$PE$Reports$moneyFormat = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
	{k4: 2});
var $author$project$CWS$PE$Reports$formatMoney = function (money) {
	return '$' + A2($cuducos$elm_format_number$FormatNumber$format, $author$project$CWS$PE$Reports$moneyFormat, money);
};
var $author$project$CWS$PE$Reports$getStats = function (_v0) {
	var pe = _v0.eK;
	var stats = _v0.je;
	var projectedInf = A2(
		$elm$core$List$filter,
		function (a) {
			return (a.jf === 4) || (a.jf === 2);
		},
		stats);
	var projectedFilterPrev = A2(
		$elm$core$List$filter,
		function (a) {
			return a.bK.v === 'Prevention';
		},
		projectedInf);
	var projectedFilterPrep = A2(
		$elm$core$List$filter,
		function (a) {
			return a.bK.v === 'Preparedness';
		},
		projectedInf);
	var projectedFilterMit = A2(
		$elm$core$List$filter,
		function (a) {
			return a.bK.v === 'Mitigation';
		},
		projectedInf);
	var confirmedInf = A2(
		$elm$core$List$filter,
		function (a) {
			return a.jf === 4;
		},
		stats);
	var confirmedFilterPrev = A2(
		$elm$core$List$filter,
		function (a) {
			return a.bK.v === 'Prevention';
		},
		confirmedInf);
	var confirmedFilterPrep = A2(
		$elm$core$List$filter,
		function (a) {
			return a.bK.v === 'Preparedness';
		},
		confirmedInf);
	var confirmedFilterMit = A2(
		$elm$core$List$filter,
		function (a) {
			return a.bK.v === 'Mitigation';
		},
		confirmedInf);
	return {
		b1: {
			au: $elm$core$String$fromInt(
				A3(
					$elm$core$List$foldl,
					$elm$core$Basics$add,
					0,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.kX;
						},
						confirmedInf))),
			kQ: A2(
				$elm$core$Maybe$withDefault,
				'No Commitment',
				A2(
					$elm$core$Maybe$map,
					$author$project$CWS$PE$Reports$formatMoney,
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.kQ;
						},
						$elm$core$List$head(pe.cj)))),
			kR: $author$project$CWS$PE$Reports$formatMoney(
				A3(
					$elm$core$List$foldl,
					$elm$core$Basics$add,
					0,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.ov;
						},
						confirmedInf))),
			no: $author$project$CWS$PE$Reports$formatMoney(
				A3(
					$elm$core$List$foldl,
					$elm$core$Basics$add,
					0,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.ov;
						},
						projectedInf)))
		},
		iA: pe.dz,
		je: {
			mo: $author$project$CWS$PE$Reports$formatAcres(
				A3(
					$elm$core$List$foldl,
					$elm$core$Basics$add,
					0,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.ot;
						},
						confirmedFilterMit))),
			nj: $elm$core$String$fromInt(
				A3(
					$elm$core$List$foldl,
					$elm$core$Basics$add,
					0,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.kX;
						},
						confirmedFilterPrep))),
			nk: $elm$core$String$fromInt(
				A3(
					$elm$core$List$foldl,
					$elm$core$Basics$add,
					0,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.kX;
						},
						confirmedFilterPrev)))
		}
	};
};
var $author$project$CWS$PE$Reports$init = F2(
	function (layers, cfg) {
		return _Utils_Tuple2(
			$author$project$CWS$PE$Reports$Ready(
				{
					v: cfg.v,
					h7: layers,
					q: $author$project$PlugMapOld$Core$defaultModel,
					iQ: $author$project$CWS$PE$Reports$getStats(cfg),
					jn: cfg.eK
				}),
			A2(
				$elm$core$Task$perform,
				$elm$core$Basics$always($author$project$CWS$PE$Reports$InitMap),
				$elm$core$Process$sleep(200)));
	});
var $author$project$PlugMapOld$Plugins$Themes$ExportLayer = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$peActionLayer = F3(
	function (pe, yearKey, layer) {
		var _v0 = layer.hd;
		if (_v0.$ === 3) {
			var exp = _v0.a;
			return _Utils_update(
				layer,
				{
					hd: $author$project$PlugMapOld$Plugins$Themes$ExportLayer(
						_Utils_update(
							exp,
							{
								mc: $elm$core$Maybe$Just('{\"1\":\"participatingEntityId=\'' + (pe.ab + ('\'\",\"2\":\"participatingEntityId=\'' + (pe.ab + ('\'\",\"0\":\"participatingEntityId=\'' + (pe.ab + ('\' AND yearKey=\'' + (yearKey + '\'\"}'))))))))
							}))
				});
		} else {
			return $author$project$PlugMapOld$Plugins$Themes$emptyLayer;
		}
	});
var $author$project$Graphs$Model$BarView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Graphs$Graphs$newBarView = function (stat) {
	var barView = $author$project$Graphs$Model$BarView(stat);
	return _Utils_Tuple2(barView, $elm$core$Platform$Cmd$none);
};
var $author$project$Graphs$Model$RenderNumber = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$ActionSummaryDboard$sampleStatGenerator = F4(
	function (name, unt, val, tot) {
		var value = {eY: tot, gv: val};
		return {
			hS: '',
			dz: name,
			iP: $author$project$Graphs$Model$RenderNumber(value),
			a9: unt
		};
	});
var $author$project$CWS$ActionSummaryDboard$sample2Row = function () {
	var _v0 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$ActionSummaryDboard$sampleStatGenerator, 'Participation Commitment Budget', 'Dollars', 31000, 45000));
	var item2 = _v0.a;
	var cmd2 = _v0.b;
	var _v1 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$ActionSummaryDboard$sampleStatGenerator, 'Participation Commitment Progress', 'Percent', 45, 100));
	var item1 = _v1.a;
	var cmd1 = _v1.b;
	return _Utils_Tuple2(
		_List_fromArray(
			[item1, item2]),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmd1, cmd2])));
}();
var $author$project$CWS$ActionSummaryDboard$sample3Row = function () {
	var _v0 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$ActionSummaryDboard$sampleStatGenerator, 'PERCENTAGE OF PARTICIPATION COMMITMENT BUDGET', '', 66, 70));
	var item3 = _v0.a;
	var cmd3 = _v0.b;
	var _v1 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$ActionSummaryDboard$sampleStatGenerator, 'COMPLETED WILDFIRE MITIGATION ACTIONS', '', 15, 80));
	var item2 = _v1.a;
	var cmd2 = _v1.b;
	var _v2 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$ActionSummaryDboard$sampleStatGenerator, 'WILDFIRE MITIGATION', 'Acres', 2500, 14000));
	var item1 = _v2.a;
	var cmd1 = _v2.b;
	return _Utils_Tuple2(
		_List_fromArray(
			[item1, item2, item3]),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmd1, cmd2, cmd3])));
}();
var $author$project$CWS$ActionSummaryDboard$generateSampleGrid = function () {
	var _v0 = $author$project$CWS$ActionSummaryDboard$sample3Row;
	var row2 = _v0.a;
	var cmds2 = _v0.b;
	var _v1 = $author$project$CWS$ActionSummaryDboard$sample2Row;
	var row1 = _v1.a;
	var cmds1 = _v1.b;
	return _Utils_Tuple2(
		_List_fromArray(
			[row2]),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmds2])));
}();
var $author$project$CWS$ActionSummaryDboard$initSample = function () {
	var _v0 = $author$project$CWS$ActionSummaryDboard$generateSampleGrid;
	var newGrid = _v0.a;
	var cmds = _v0.b;
	return _Utils_Tuple2(
		{fw: newGrid},
		cmds);
}();
var $author$project$CWS$ActionBoard$initView = F5(
	function (model, yearKey, categoryKey, pe, env) {
		var oldState = model.a;
		var _v0 = $author$project$CWS$ActionSummaryDboard$initSample;
		var mini = _v0.a;
		var cmdMini = _v0.b;
		var newState = _Utils_update(
			oldState,
			{
				e1: $elm$core$Maybe$Just(mini),
				cQ: pe,
				r: yearKey
			});
		var newModel = _Utils_update(
			model,
			{bK: categoryKey, a: newState});
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A7($author$project$CWS$API$Action$getActionCategoryByPEIDYearKey, env.m, env.f, categoryKey, pe.ab, yearKey, $author$project$CWS$ActionBoard$CategoryLoad, $author$project$CWS$ActionBoard$CategoryLoad)
					])));
	});
var $author$project$CWS$switchToActions = F5(
	function (mainModel, yearKey, category, targetPEKey, route) {
		var selectedPE = A2($author$project$CWS$getSelectedPE, mainModel, targetPEKey);
		var oldState = mainModel.a;
		var _v0 = function () {
			if (!selectedPE.$) {
				var pe = selectedPE.a;
				var _v2 = A5(
					$author$project$CWS$ActionBoard$initView,
					mainModel.a.be,
					yearKey,
					category,
					pe,
					{m: mainModel.p.m.av, f: mainModel.f});
				var a = _v2.a;
				var b = _v2.b;
				return _Utils_Tuple2(
					a,
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionBoardMsg, b));
			} else {
				return _Utils_Tuple2(mainModel.a.be, $elm$core$Platform$Cmd$none);
			}
		}();
		var newActions = _v0.a;
		var newActionCmds = _v0.b;
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[newActionCmds]));
		var newState = _Utils_update(
			oldState,
			{be: newActions});
		var newModel = _Utils_update(
			mainModel,
			{ef: $author$project$CWS$Model$Loading, a: newState});
		return _Utils_Tuple3(newModel, newCmds, route);
	});
var $author$project$CWS$Home$InitThemes = {$: 7};
var $author$project$CWS$Model$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Home$MiniDashboardMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMapOld$Plugins$Themes$Model = function (layers) {
	return {h7: layers};
};
var $author$project$PlugMapOld$Plugins$Themes$addLayerCmd = _Platform_outgoingPort('addLayerCmd', $elm$core$Basics$identity);
var $author$project$PlugMapOld$Plugins$Themes$encodeExtent = function (extent) {
	return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, extent);
};
var $author$project$PlugMapOld$Plugins$Themes$encodeLayerUrlTemplate = function (layerUrl) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(layerUrl.jF)),
				_Utils_Tuple2(
				'zIndex',
				$elm$json$Json$Encode$int(layerUrl.gD)),
				_Utils_Tuple2(
				'tokenKey',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, layerUrl.or))
			]));
};
var $author$project$PlugMapOld$Plugins$Themes$encodeLayers = function (urlTemplates) {
	if (!urlTemplates.$) {
		var url = urlTemplates.a;
		return A2(
			$elm$json$Json$Encode$list,
			$author$project$PlugMapOld$Plugins$Themes$encodeLayerUrlTemplate,
			_List_fromArray(
				[url]));
	} else {
		var urls = urlTemplates.a;
		return A2($elm$json$Json$Encode$list, $author$project$PlugMapOld$Plugins$Themes$encodeLayerUrlTemplate, urls);
	}
};
var $author$project$PlugMapOld$Plugins$Themes$encodeExportLayer = function (layer) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'layers',
				$author$project$PlugMapOld$Plugins$Themes$encodeLayers(layer.h7)),
				_Utils_Tuple2(
				'extent',
				$author$project$PlugMapOld$Plugins$Themes$encodeExtent(layer.cy)),
				_Utils_Tuple2(
				'layerDefs',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, layer.mc))
			]));
};
var $author$project$PlugMapOld$Plugins$Themes$encodeWMTSLayer = function (layer) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'layers',
				$author$project$PlugMapOld$Plugins$Themes$encodeLayers(layer.h7)),
				_Utils_Tuple2(
				'extent',
				$author$project$PlugMapOld$Plugins$Themes$encodeExtent(layer.cy))
			]));
};
var $author$project$PlugMapOld$Plugins$Themes$encodeXYZLayer = function (layer) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'layers',
				$author$project$PlugMapOld$Plugins$Themes$encodeLayers(layer.h7))
			]));
};
var $author$project$PlugMapOld$Plugins$Themes$encodeLayerConfig = function (configs) {
	var _v0 = function () {
		switch (configs.$) {
			case 0:
				return _Utils_Tuple2(
					'None',
					$elm$json$Json$Encode$object(_List_Nil));
			case 1:
				var config = configs.a;
				return _Utils_Tuple2(
					'XYZ',
					$author$project$PlugMapOld$Plugins$Themes$encodeXYZLayer(config));
			case 2:
				var config = configs.a;
				return _Utils_Tuple2(
					'WMTS',
					$author$project$PlugMapOld$Plugins$Themes$encodeWMTSLayer(config));
			default:
				var config = configs.a;
				return _Utils_Tuple2(
					'Export',
					$author$project$PlugMapOld$Plugins$Themes$encodeExportLayer(config));
		}
	}();
	var type_ = _v0.a;
	var encoder = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(type_)),
				_Utils_Tuple2('value', encoder)
			]));
};
var $author$project$PlugMapOld$Plugins$Themes$encodeLayer = function (layer) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(layer.ab)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(layer.dz)),
				_Utils_Tuple2(
				'opacity',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, layer.iq)),
				_Utils_Tuple2(
				'config',
				$author$project$PlugMapOld$Plugins$Themes$encodeLayerConfig(layer.hd))
			]));
};
var $author$project$PlugMapOld$Plugins$Themes$addLayer = function (layer) {
	return $author$project$PlugMapOld$Plugins$Themes$addLayerCmd(
		$author$project$PlugMapOld$Plugins$Themes$encodeLayer(layer));
};
var $author$project$PlugMapOld$Plugins$Themes$init = function (layers) {
	return _Utils_Tuple2(
		$author$project$PlugMapOld$Plugins$Themes$Model(layers),
		$elm$core$Platform$Cmd$batch(
			$elm$core$List$map($author$project$PlugMapOld$Plugins$Themes$addLayer)(layers)));
};
var $author$project$CWS$MiniDashboard$sampleStatGenerator = F4(
	function (name, unt, val, tot) {
		var value = {eY: tot, gv: val};
		return {
			hS: '',
			dz: name,
			iP: $author$project$Graphs$Model$RenderNumber(value),
			a9: unt
		};
	});
var $author$project$CWS$MiniDashboard$sample2Row = function () {
	var _v0 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$MiniDashboard$sampleStatGenerator, 'Participation Commitment Budget', 'Dollars', 31000, 45000));
	var item2 = _v0.a;
	var cmd2 = _v0.b;
	var _v1 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$MiniDashboard$sampleStatGenerator, 'Participation Commitment Progress', 'Percent', 45, 100));
	var item1 = _v1.a;
	var cmd1 = _v1.b;
	return _Utils_Tuple2(
		_List_fromArray(
			[item1, item2]),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmd1, cmd2])));
}();
var $author$project$CWS$MiniDashboard$sample3Row = function () {
	var _v0 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$MiniDashboard$sampleStatGenerator, 'WILDFIRE PREVENTION', 'Actions Taken', 13, 80));
	var item3 = _v0.a;
	var cmd3 = _v0.b;
	var _v1 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$MiniDashboard$sampleStatGenerator, 'WILDFIRE PREPAREDNESS', 'Actions Taken', 21, 90));
	var item2 = _v1.a;
	var cmd2 = _v1.b;
	var _v2 = $author$project$Graphs$Graphs$newBarView(
		A4($author$project$CWS$MiniDashboard$sampleStatGenerator, 'WILDFIRE MITIGATION', 'Acres', 2500, 14000));
	var item1 = _v2.a;
	var cmd1 = _v2.b;
	return _Utils_Tuple2(
		_List_fromArray(
			[item1, item2, item3]),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmd1, cmd2, cmd3])));
}();
var $author$project$CWS$MiniDashboard$generateSampleGrid = function () {
	var _v0 = $author$project$CWS$MiniDashboard$sample3Row;
	var row2 = _v0.a;
	var cmds2 = _v0.b;
	var _v1 = $author$project$CWS$MiniDashboard$sample2Row;
	var row1 = _v1.a;
	var cmds1 = _v1.b;
	return _Utils_Tuple2(
		_List_fromArray(
			[row1, row2]),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmds1, cmds2])));
}();
var $author$project$CWS$MiniDashboard$initSample = function () {
	var _v0 = $author$project$CWS$MiniDashboard$generateSampleGrid;
	var newGrid = _v0.a;
	var cmds = _v0.b;
	return _Utils_Tuple2(
		{fw: newGrid},
		cmds);
}();
var $author$project$PlugMapOld$Core$Options$Options = F5(
	function (target, center, zoom, maxZoom, minZoom) {
		return {g6: center, ih: maxZoom, ij: minZoom, n7: target, jY: zoom};
	});
var $author$project$PlugMapOld$Core$Options$defaultOptions = A5(
	$author$project$PlugMapOld$Core$Options$Options,
	'ol-map',
	_Utils_Tuple2(-111.6, 39.4),
	7,
	$elm$core$Maybe$Just(25),
	$elm$core$Maybe$Just(1));
var $author$project$PlugMapOld$Core$Options$encodeCenter = function (_v0) {
	var lat = _v0.a;
	var lon = _v0.b;
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$float,
		_List_fromArray(
			[lat, lon]));
};
var $author$project$PlugMapOld$Core$Options$encodeOptions = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'target',
				$elm$json$Json$Encode$string(options.n7)),
				_Utils_Tuple2(
				'center',
				$author$project$PlugMapOld$Core$Options$encodeCenter(options.g6)),
				_Utils_Tuple2(
				'zoom',
				$elm$json$Json$Encode$int(options.jY)),
				_Utils_Tuple2(
				'maxZoom',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, options.ih)),
				_Utils_Tuple2(
				'minZoom',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, options.ij))
			]));
};
var $author$project$PlugMapOld$Core$Ports$renderMapOld = _Platform_outgoingPort('renderMapOld', $elm$core$Basics$identity);
var $author$project$PlugMapOld$Core$initWithOptions = function (options) {
	var _v0 = _Utils_Tuple2(
		$elm$core$Maybe$Just(options),
		$author$project$PlugMapOld$Core$Options$encodeOptions(options));
	var mapOptions = _v0.a;
	var encodedOptions = _v0.b;
	var initialModel = _Utils_update(
		$author$project$PlugMapOld$Core$defaultModel,
		{eB: mapOptions});
	return _Utils_Tuple2(
		initialModel,
		$author$project$PlugMapOld$Core$Ports$renderMapOld(encodedOptions));
};
var $author$project$PlugMapOld$Core$initWithDefaults = $author$project$PlugMapOld$Core$initWithOptions($author$project$PlugMapOld$Core$Options$defaultOptions);
var $author$project$PlugMapOld$Plugins$Extent$encodeWkts = function (wkts) {
	return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, wkts);
};
var $author$project$PlugMapOld$Plugins$Extent$extentToWKTCmd = _Platform_outgoingPort('extentToWKTCmd', $elm$core$Basics$identity);
var $author$project$PlugMapOld$Plugins$Extent$setExtentWKT = function (wkt) {
	var peWkt = _List_fromArray(
		[wkt]);
	return _Utils_Tuple2(
		$author$project$PlugMapOld$Plugins$Extent$Model,
		$author$project$PlugMapOld$Plugins$Extent$extentToWKTCmd(
			$author$project$PlugMapOld$Plugins$Extent$encodeWkts(peWkt)));
};
var $author$project$CWS$Home$init = F4(
	function (model, yearKey, layers, professionalViewerUrl) {
		var yearOrDefault = A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				yearKey,
				A2(
					$elm$core$Maybe$andThen,
					function (a) {
						return $elm$core$Maybe$Just(a.v);
					},
					$elm$core$List$head(model.cj))),
			A2(
				$elm$core$Maybe$andThen,
				function (a) {
					return $elm$core$Maybe$Just(a.v);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (a) {
							return _Utils_eq(a.v, yearKey);
						},
						model.cj))));
		var selyearcomm = A2(
			$elm$core$Maybe$andThen,
			function (a) {
				return a.kQ;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (a) {
						return _Utils_eq(a.v, yearKey);
					},
					model.cj)));
		var _v0 = $author$project$PlugMapOld$Plugins$Themes$init(layers);
		var themes = _v0.a;
		var themeCmd = _v0.b;
		var _v1 = $author$project$CWS$MiniDashboard$initSample;
		var mini = _v1.a;
		var miniCmd = _v1.b;
		var _v2 = $author$project$PlugMapOld$Core$initWithDefaults;
		var map = _v2.a;
		var mapCmd = _v2.b;
		var _v3 = $author$project$PlugMapOld$Plugins$Extent$setExtentWKT(model.bc);
		var extent = _v3.a;
		var extentCmd = _v3.b;
		return _Utils_Tuple2(
			$author$project$CWS$Home$Model(mini)(map)(themes)(extent)(
				$author$project$CWS$Model$Loaded(model))(
				$author$project$CWS$Home$defaultStatSet(selyearcomm))(_List_Nil)($elm$core$Maybe$Nothing)(layers)(professionalViewerUrl),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$MiniDashboardMsg, miniCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$MapMsg, mapCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$ThemeMsg, themeCmd),
						A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$CWS$Home$InitThemes),
						$elm$core$Process$sleep(100)),
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$ExtentMsg, extentCmd)
					])));
	});
var $author$project$CWS$loadStaticFilesFor = F2(
	function (model, selectedPE) {
		var oldDict = model.b.aE;
		if (!selectedPE.$) {
			var pe = selectedPE.a;
			return A2($elm$core$Dict$member, pe.v, oldDict) ? $elm$core$Platform$Cmd$none : A2($author$project$CWS$API$Core$api_File_GetStaticForPE, pe.v, model);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$CWS$switchToHome = F5(
	function (oldRoute, targetPEKey, yearKey, model, mainModel) {
		var selectedPE = A2($author$project$CWS$getSelectedPE, mainModel, targetPEKey);
		var ol = function () {
			if (!selectedPE.$) {
				var pe = selectedPE.a;
				return _List_fromArray(
					[
						A3($author$project$CWS$peActionLayer, pe, yearKey, mainModel.cR.gb)
					]);
			} else {
				return $author$project$PlugMapOld$Plugins$Themes$defaultLayers;
			}
		}();
		var newYear = 0;
		var fileCmd = A2($author$project$CWS$loadStaticFilesFor, mainModel, selectedPE);
		var _v0 = function () {
			if (!selectedPE.$) {
				var pe = selectedPE.a;
				return A4(
					$author$project$CWS$Home$init,
					pe,
					yearKey,
					A2(
						$elm$core$List$append,
						mainModel.cR.h7,
						A2($elm$core$List$append, ol, $author$project$PlugMapOld$Plugins$Themes$defaultLayers)),
					mainModel.p.m.nl);
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}();
		var newHome = _v0.a;
		var homeCmds = _v0.b;
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$HomeMsg, homeCmds),
					fileCmd
				]));
		return _Utils_Tuple2(newHome, newCmds);
	});
var $author$project$CWS$handleMainChangePE = F3(
	function (oldRoute, model, sub) {
		switch (sub.$) {
			case 0:
				var home = sub.a;
				var oldState = model.a;
				var _v1 = A5($author$project$CWS$switchToHome, oldRoute.z, home.d, home.r, model.a.a2, model);
				var homeModel = _v1.a;
				var homeCmds = _v1.b;
				var newState = _Utils_update(
					oldState,
					{a2: homeModel});
				var newModel = _Utils_update(
					model,
					{a: newState});
				return _Utils_Tuple2(newModel, homeCmds);
			case 1:
				var actions = sub.a;
				var _v2 = A5($author$project$CWS$switchToActions, model, actions.d.r, actions.bK, actions.d.d, oldRoute);
				var a = _v2.a;
				var b = _v2.b;
				var c = _v2.c;
				return _Utils_Tuple2(a, b);
			case 4:
				var pe = sub.a;
				var oldState = model.a;
				var _v3 = A3($author$project$CWS$switchToAllDocuments, oldRoute.z, pe.d, model);
				var allDocumentsModel = _v3.a;
				var allDocumentsCmds = _v3.b;
				var newState = _Utils_update(
					oldState,
					{U: allDocumentsModel});
				var newModel = _Utils_update(
					model,
					{a: newState});
				return _Utils_Tuple2(newModel, allDocumentsCmds);
			case 6:
				var pe = sub.a;
				var rpt = sub.b;
				var selectedPE = A2($author$project$CWS$getSelectedPE, model, pe.d);
				var oldState = model.a;
				var _v4 = function () {
					var _v5 = _Utils_Tuple2(selectedPE, model.b.az);
					if ((!_v5.a.$) && (_v5.b.$ === 2)) {
						var thePE = _v5.a.a;
						var peBreakdownStats = _v5.b.a;
						var _v6 = A2(
							$author$project$CWS$PE$Reports$init,
							_List_fromArray(
								[
									A3($author$project$CWS$peActionLayer, thePE, pe.r, model.cR.gb),
									$author$project$CWS$cwsRiskLayer
								]),
							{v: model.v, eK: thePE, je: peBreakdownStats});
						var a = _v6.a;
						var b = _v6.b;
						return _Utils_Tuple2(
							a,
							A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ReportsMsg, b));
					} else {
						return _Utils_Tuple2(oldState.bz, $elm$core$Platform$Cmd$none);
					}
				}();
				var newReports = _v4.a;
				var newReportsCmd = _v4.b;
				var newState = _Utils_update(
					oldState,
					{bz: newReports});
				var newModel = _Utils_update(
					model,
					{a: newState});
				var newCmds = newReportsCmd;
				return _Utils_Tuple2(newModel, newCmds);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$handleMainChange = F3(
	function (oldRoute, newRoute, model) {
		var selpe = A2($author$project$CWS$getSelectedPEFromMainRoute, model, newRoute.z);
		var needsToLoad = (!_Utils_eq(oldRoute.z, newRoute.z)) || function () {
			var _v5 = oldRoute.K;
			switch (_v5.$) {
				case 1:
					return true;
				case 2:
					return true;
				default:
					return false;
			}
		}();
		var allFileCmds = A2($author$project$CWS$loadStaticFilesFor, model, selpe);
		if (needsToLoad) {
			var destructCmds = function () {
				var _v3 = _Utils_Tuple2(oldRoute.z, newRoute.z);
				if ((_v3.a.$ === 4) && (!_v3.a.a.$)) {
					if ((_v3.b.$ === 4) && (!_v3.b.a.$)) {
						var home = _v3.a.a.a;
						var home2 = _v3.b.a.a;
						return $elm$core$Platform$Cmd$none;
					} else {
						var home = _v3.a.a.a;
						var _v4 = $author$project$CWS$Home$denit(model.a.a2);
						var oh = _v4.a;
						var hc = _v4.b;
						return A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$HomeMsg, hc);
					}
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}();
			var _v0 = newRoute.z;
			switch (_v0.$) {
				case 4:
					var sub = _v0.a;
					var _v1 = A3($author$project$CWS$handleMainChangePE, oldRoute, model, sub);
					var newModel = _v1.a;
					var newCmds = _v1.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[destructCmds, allFileCmds, newCmds])),
						newRoute);
				case 5:
					var sub = _v0.a;
					var _v2 = A3($author$project$CWS$handleMainChangeCWSApp, oldRoute, model, sub);
					var newModel = _v2.a;
					var newCmds = _v2.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[destructCmds, allFileCmds, newCmds])),
						newRoute);
				default:
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[destructCmds, allFileCmds])),
						newRoute);
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, newRoute);
		}
	});
var $author$project$CWS$ActionDetail$DatePickerMsg = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$CWS$ActionDetail$EndDatePicker = 1;
var $author$project$CWS$ActionDetail$StartDatePicker = 0;
var $author$project$CWS$Model$blankActionModel = {bH: $author$project$Fields$Shared$NotEntered, W: $elm$core$Maybe$Nothing, cn: $elm$core$Maybe$Nothing, e9: $author$project$Fields$Shared$NotEntered, bK: $author$project$CWS$Model$defaultCategory, kY: $elm$core$Maybe$Nothing, hk: $elm$core$Maybe$Nothing, hn: false, hp: $elm$core$Maybe$Nothing, el: $elm$core$Maybe$Nothing, ll: $author$project$Fields$Shared$NotEntered, hA: $author$project$CWS$Model$Loading, hD: $author$project$CWS$Model$Loading, fv: $author$project$CWS$Model$defaultFunding, hM: $author$project$CWS$Model$defaultGroup, fB: $author$project$Fields$Shared$NotEntered, ab: -1, l8: $elm$core$Maybe$Nothing, l9: $elm$core$Maybe$Nothing, h5: $elm$core$Maybe$Nothing, ma: $elm$core$Maybe$Nothing, mb: $elm$core$Maybe$Nothing, dz: $elm$core$Maybe$Nothing, iA: $elm$core$Maybe$Nothing, I: $elm$core$Maybe$Nothing, dL: $elm$core$Maybe$Nothing, jf: 0, jE: $author$project$CWS$Model$defaultActionType};
var $author$project$CWS$UploadDocuments$LoadedFiles = function (a) {
	return {$: 10, a: a};
};
var $author$project$CWS$API$File$getFilesForActionRequestEncoder = function (actionID) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(actionID))
			]));
};
var $author$project$CWS$API$File$getFilesForAction = F5(
	function (settings, user, actionID, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'Get',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$File$getFilesForActionRequestEncoder(actionID)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$fileListDecoder);
	});
var $author$project$CWS$UploadDocuments$init = F6(
	function (pe, actionID, downloadPrepend, canUpload, canEdit, env) {
		var model = $author$project$CWS$UploadDocuments$defaultModel;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{gH: actionID, g3: canEdit, g4: canUpload, eK: pe, dE: downloadPrepend}),
			A5($author$project$CWS$API$File$getFilesForAction, env.m, env.f, actionID, $author$project$CWS$UploadDocuments$LoadedFiles, $author$project$CWS$UploadDocuments$LoadedFiles));
	});
var $CurrySoftware$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $elm$time$Time$May = 4;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.jc, posixMinutes) < 0) {
					return posixMinutes + era.mA;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		hj: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		il: month,
		r: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).hj;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).il;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).r;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $CurrySoftware$elm_datepicker$DatePicker$init = _Utils_Tuple2(
	{
		ak: $elm$core$Maybe$Just($CurrySoftware$elm_datepicker$DatePicker$Date$initDate),
		bp: false,
		aL: $elm$core$Maybe$Nothing,
		eF: false,
		bC: $CurrySoftware$elm_datepicker$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $CurrySoftware$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $author$project$CWS$ActionDetail$FieldsInvalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$ActionDetail$FieldsValid = {$: 0};
var $author$project$CWS$ActionDetail$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$ActionDetail$StatusOk = {$: 0};
var $author$project$CWS$ActionDetail$Valid = {$: 1};
var $author$project$CWS$ActionDetail$areFieldsInRowValid = F2(
	function (row, data) {
		var rowCheck = A2(
			$elm$core$List$map,
			function (_v0) {
				var basic = _v0.a;
				var validator = _v0.b;
				if (validator.$ === 1) {
					var valid = validator.a;
					return _Utils_Tuple2(
						valid(data),
						basic);
				} else {
					return _Utils_Tuple2(true, basic);
				}
			},
			row);
		var rowValid = !$elm$core$List$length(rowCheck);
		return rowCheck;
	});
var $author$project$CWS$ActionDetail$areFieldsValid = F2(
	function (validators, data) {
		var rowResults = A2(
			$elm$core$List$map,
			function (row) {
				return A2($author$project$CWS$ActionDetail$areFieldsInRowValid, row, data);
			},
			validators);
		var flatResults = $elm$core$List$concat(rowResults);
		return flatResults;
	});
var $author$project$Fields$GenericField$MaybeFloat = function (a) {
	return {$: 6, a: a};
};
var $author$project$Fields$Shared$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$ActionDetail$makeBasicInfo = F2(
	function (name, readOnly) {
		return {dz: name, nq: readOnly};
	});
var $author$project$Fields$Shared$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$ActionDetail$UpdateAction = function (a) {
	return {$: 24, a: a};
};
var $myrho$elm_round$Round$floor = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('0' === _v0.a.a) {
					var _v1 = _v0.a;
					var rest = _v1.b;
					return signed && A2(
						$elm$core$List$any,
						$elm$core$Basics$neq('0'),
						$elm$core$String$toList(rest));
				} else {
					return signed;
				}
			}
		}));
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$CWS$ActionDetail$maybeFloatField = F3(
	function (field, updater, _default) {
		return {
			a1: function (a) {
				return _Utils_Tuple2(
					field(a),
					_default);
			},
			id: $elm$core$Maybe$Just(10),
			iE: $elm$core$Maybe$Nothing,
			iM: $elm$core$Maybe$Nothing,
			dI: function (item) {
				return function (set_value) {
					return function (val) {
						return $author$project$CWS$ActionDetail$UpdateAction(
							$author$project$CWS$Model$Loaded(
								A2(updater, val, item)));
					}(
						function () {
							if (set_value.$ === 1) {
								var v = set_value.a;
								var t = set_value.b;
								if ((v >= 0) && (v <= 10000000)) {
									var rounded = A2($myrho$elm_round$Round$floor, 2, v);
									return (_Utils_cmp(
										$elm$core$String$length(rounded),
										$elm$core$String$length(t)) < 0) ? A2(
										$author$project$Fields$Shared$Valid,
										A2(
											$elm$core$Maybe$withDefault,
											v,
											$elm$core$String$toFloat(rounded)),
										rounded) : A2($author$project$Fields$Shared$Valid, v, t);
								} else {
									return $author$project$Fields$Shared$Invalid(t);
								}
							} else {
								return set_value;
							}
						}());
				};
			}
		};
	});
var $author$project$CWS$ActionDetail$acresFieldFancy = F2(
	function (readOnly, calculated) {
		return _Utils_Tuple3(
			A2(
				$author$project$CWS$ActionDetail$makeBasicInfo,
				calculated ? 'Acres Completed - Calculated' : 'Acres Completed - Estimated',
				readOnly || calculated),
			$author$project$Fields$Shared$Required(
				function (action) {
					return (!_Utils_eq(
						$author$project$Fields$Shared$validityToMaybe(action.bH),
						$elm$core$Maybe$Nothing)) || (!_Utils_eq(action.I, $elm$core$Maybe$Nothing));
				}),
			$author$project$Fields$GenericField$MaybeFloat(
				A3(
					$author$project$CWS$ActionDetail$maybeFloatField,
					function (action) {
						return action.bH;
					},
					function (value) {
						return function (action) {
							return _Utils_update(
								action,
								{bH: value});
						};
					},
					'Not Set')));
	});
var $author$project$CWS$ActionDetail$actionHasSpatial = function (act) {
	if (act.$ === 2) {
		var action = act.a;
		return !_Utils_eq(action.I, $elm$core$Maybe$Nothing);
	} else {
		return false;
	}
};
var $author$project$Fields$Shared$NotRequired = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$ActionDetail$isValidOrNotEntered = function (v) {
	if (v.$ === 2) {
		return false;
	} else {
		return true;
	}
};
var $author$project$CWS$ActionDetail$biomassFieldFancy = function (readOnly) {
	return _Utils_Tuple3(
		A2($author$project$CWS$ActionDetail$makeBasicInfo, 'Biomass Tons per Acre', readOnly),
		$author$project$Fields$Shared$NotRequired(
			function (action) {
				return $author$project$CWS$ActionDetail$isValidOrNotEntered(action.e9);
			}),
		$author$project$Fields$GenericField$MaybeFloat(
			A3(
				$author$project$CWS$ActionDetail$maybeFloatField,
				function (action) {
					return action.e9;
				},
				function (value) {
					return function (action) {
						return _Utils_update(
							action,
							{e9: value});
					};
				},
				'Not Set')));
};
var $author$project$CWS$ActionDetail$costFieldFancy = function (readOnly) {
	return _Utils_Tuple3(
		A2($author$project$CWS$ActionDetail$makeBasicInfo, 'Total Estimated Cost', readOnly),
		$author$project$Fields$Shared$Required(
			function (action) {
				return !_Utils_eq(
					$author$project$Fields$Shared$validityToMaybe(action.ll),
					$elm$core$Maybe$Nothing);
			}),
		$author$project$Fields$GenericField$MaybeFloat(
			{
				a1: function (item) {
					return _Utils_Tuple2(item.ll, 'Not Set');
				},
				id: $elm$core$Maybe$Just(10),
				iE: $elm$core$Maybe$Just('$'),
				iM: $elm$core$Maybe$Just(
					{
						mj: $elm$core$Maybe$Nothing,
						mk: $elm$core$Maybe$Just(0)
					}),
				dI: function (item) {
					return function (set_value) {
						return function (val) {
							return $author$project$CWS$ActionDetail$UpdateAction(
								$author$project$CWS$Model$Loaded(
									_Utils_update(
										item,
										{ll: val})));
						}(
							function () {
								if (set_value.$ === 1) {
									var v = set_value.a;
									var t = set_value.b;
									if ((v > 0) && (v < 10000000)) {
										var rounded = A2($myrho$elm_round$Round$floor, 2, v);
										return (_Utils_cmp(
											$elm$core$String$length(rounded),
											$elm$core$String$length(t)) < 0) ? A2(
											$author$project$Fields$Shared$Valid,
											A2(
												$elm$core$Maybe$withDefault,
												v,
												$elm$core$String$toFloat(rounded)),
											rounded) : A2($author$project$Fields$Shared$Valid, v, t);
									} else {
										if (!v) {
											return A2($author$project$Fields$Shared$Valid, v, t);
										} else {
											return $author$project$Fields$Shared$Invalid(t);
										}
									}
								} else {
									return set_value;
								}
							}());
					};
				}
			}));
};
var $author$project$Fields$GenericField$Custom = function (a) {
	return {$: 10, a: a};
};
var $author$project$Fields$CustomField$CustomField = function (getter) {
	return {a1: getter};
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {hj: d, il: m, r: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		f8: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		r: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.r, 0, date.f8);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.hj;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.il;
	});
var $author$project$NormalDate$monthToInt = function (mnth) {
	switch (mnth) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$CWS$ActionDetail$dateLessThanOrEqual = F2(
	function (st, ed) {
		return (_Utils_cmp(
			$justinmimbs$date$Date$year(st),
			$justinmimbs$date$Date$year(ed)) < 0) || ((_Utils_eq(
			$justinmimbs$date$Date$year(st),
			$justinmimbs$date$Date$year(ed)) && (_Utils_cmp(
			$author$project$NormalDate$monthToInt(
				$justinmimbs$date$Date$month(st)),
			$author$project$NormalDate$monthToInt(
				$justinmimbs$date$Date$month(ed))) < 0)) || (_Utils_eq(
			$justinmimbs$date$Date$year(st),
			$justinmimbs$date$Date$year(ed)) && (_Utils_eq(
			$author$project$NormalDate$monthToInt(
				$justinmimbs$date$Date$month(st)),
			$author$project$NormalDate$monthToInt(
				$justinmimbs$date$Date$month(ed))) && (_Utils_cmp(
			$justinmimbs$date$Date$day(st),
			$justinmimbs$date$Date$day(ed)) < 1))));
	});
var $elm$time$Time$Sun = 6;
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.f8;
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		jO: 1 + (((rd - week1Day1) / 7) | 0),
		jP: wy,
		oI: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.jO;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.jP;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.eC(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.fR(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.eC(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.fh(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.ci(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.ci(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.ci(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.gx(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.ci(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.ci(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {hc: col, kV: contextStack, iF: problem, i0: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.i0, s.hc, x, s.l));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.mA, s.i0, s.hc, s.nX);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{hc: newCol, l: s.l, s: s.s, mA: newOffset, i0: newRow, nX: s.nX});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.mA, s.nX);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{hc: 1, l: s.l, s: s.s, mA: s.mA + 1, i0: s.i0 + 1, nX: s.nX}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{hc: s.hc + 1, l: s.l, s: s.s, mA: newOffset, i0: s.i0, nX: s.nX}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.nX);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.mA, offset) < 0,
					0,
					{hc: col, l: s0.l, s: s0.s, mA: offset, i0: row, nX: s0.nX});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.mA, s.i0, s.hc, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.mA, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.mA, s1.mA, s0.nX),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.nX),
			s.mA) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {hc: col, iF: problem, i0: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.i0, p.hc, p.iF);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{hc: 1, l: _List_Nil, s: 1, mA: 0, i0: 1, nX: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	fh: $justinmimbs$date$Date$withOrdinalSuffix,
	fR: $justinmimbs$date$Date$monthToName,
	eC: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	gx: $justinmimbs$date$Date$weekdayToName,
	ci: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.iF;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($justinmimbs$date$Date$deadEndToString),
			$elm$core$String$join('; '))));
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	fa: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	d4: $CurrySoftware$elm_datepicker$DatePicker$off,
	cs: 'elm-datepicker--',
	fc: _List_Nil,
	eg: $justinmimbs$date$Date$format('yyyy/MM/dd'),
	fg: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	eo: 6,
	hX: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	fF: _List_Nil,
	fG: $elm$core$Maybe$Nothing,
	fH: $elm$core$Maybe$Nothing,
	h$: $elm$core$Basics$always(false),
	fQ: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	eJ: $justinmimbs$date$Date$fromIsoString,
	nd: 'Please pick a date...',
	gC: $elm$core$String$fromInt
};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$NormalDate$toMonth = function (mnth) {
	switch (mnth) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		case 12:
			return 11;
		default:
			return 0;
	}
};
var $author$project$NormalDate$isoStringToDate = F2(
	function (input, delim) {
		var split = A2(
			$elm$core$List$filterMap,
			function (a) {
				return a;
			},
			A2(
				$elm$core$List$map,
				$elm$core$String$toInt,
				A2(
					$elm$core$String$split,
					delim,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, 'T', input))))));
		if ((split.b && split.b.b) && split.b.b.b) {
			var y = split.a;
			var _v1 = split.b;
			var m = _v1.a;
			var _v2 = _v1.b;
			var d = _v2.a;
			return ((y >= 1970) && (y <= 2099)) ? $elm$core$Maybe$Just(
				A3(
					$justinmimbs$date$Date$fromCalendarDate,
					y,
					$author$project$NormalDate$toMonth(m),
					d)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$NormalDate$fromIsoDate = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Result$Err('Could not parse a date from ' + input),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Result$Ok,
			A2($author$project$NormalDate$isoStringToDate, input, '-')));
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Months = 1;
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.r - 1)) + ($justinmimbs$date$Date$monthToNumber(date.il) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.hj,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $elm$html$Html$button = _VirtualDom_node('button');
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.cs;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			hg: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			fe: date
		};
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.cs;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.h$(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.fa(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.fe;
		var today = _v0.bC;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.ak;
		var today = model.bC;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.eo) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.eo);
		var currentMonth = _v0.fe;
		var currentDates = _v0.hg;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				A2(
					$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
					{fe: currentMonth, bC: today},
					settings.d4)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.fQ(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.d4)) ? $elm$html$Html$text(
											settings.gC(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.fg(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.fG));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.cs + 'input', true)
				]),
			settings.fF);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.fH)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.hX,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.nd),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.eg, pickedDate)),
						model.aL))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.cs + 'container', true),
			settings.fc);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.eF ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$CWS$ActionDetail$customEndDatePickerField = F2(
	function (model, readOnly) {
		return _Utils_Tuple3(
			A2($author$project$CWS$ActionDetail$makeBasicInfo, 'End Date', readOnly),
			$author$project$Fields$Shared$Required(
				function (action) {
					var _v0 = _Utils_Tuple2(action.dL, action.el);
					if (_v0.a.$ === 1) {
						var _v2 = _v0.a;
						return false;
					} else {
						if (_v0.b.$ === 1) {
							var date = _v0.a.a;
							var _v1 = _v0.b;
							return true;
						} else {
							var start = _v0.a.a;
							var end = _v0.b.a;
							var _v3 = _Utils_Tuple2(
								$elm$core$Result$toMaybe(
									$author$project$NormalDate$fromIsoDate(start)),
								$elm$core$Result$toMaybe(
									$author$project$NormalDate$fromIsoDate(end)));
							if ((!_v3.a.$) && (!_v3.b.$)) {
								var st = _v3.a.a;
								var ed = _v3.b.a;
								return A2($author$project$CWS$ActionDetail$dateLessThanOrEqual, st, ed);
							} else {
								return false;
							}
						}
					}
				}),
			$author$project$Fields$GenericField$Custom(
				$author$project$Fields$CustomField$CustomField(
					function (ro) {
						return function (action) {
							var _v4 = model.bM;
							if (!_v4.$) {
								var picker = _v4.a;
								return A2(
									$elm$html$Html$map,
									$author$project$CWS$ActionDetail$DatePickerMsg(1),
									A3(
										$CurrySoftware$elm_datepicker$DatePicker$view,
										A2(
											$elm$core$Maybe$andThen,
											function (a) {
												return $elm$core$Result$toMaybe(
													$author$project$NormalDate$fromIsoDate(a));
											},
											action.el),
										_Utils_update(
											$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
											{
												eg: $justinmimbs$date$Date$format('MM/dd/yyyy'),
												hX: ro ? _List_fromArray(
													[
														$elm$html$Html$Attributes$disabled(true)
													]) : _List_Nil,
												h$: function (a) {
													return ro;
												},
												eJ: $author$project$NormalDate$fromIsoDate
											}),
										picker));
							} else {
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Could not load date picker')
										]));
							}
						};
					})));
	});
var $author$project$NormalDate$stringToDate = F2(
	function (input, delim) {
		var split = A2(
			$elm$core$List$filterMap,
			function (a) {
				return a;
			},
			A2(
				$elm$core$List$map,
				$elm$core$String$toInt,
				A2(
					$elm$core$String$split,
					delim,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, 'T', input))))));
		if ((split.b && split.b.b) && split.b.b.b) {
			var m = split.a;
			var _v1 = split.b;
			var d = _v1.a;
			var _v2 = _v1.b;
			var y = _v2.a;
			return ((y >= 1970) && (y <= 2099)) ? $elm$core$Maybe$Just(
				A3(
					$justinmimbs$date$Date$fromCalendarDate,
					y,
					$author$project$NormalDate$toMonth(m),
					d)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$NormalDate$fromNormalDate = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Result$Err('Could not parse a date from ' + input),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Result$Ok,
			A2($author$project$NormalDate$stringToDate, input, '/')));
};
var $author$project$CWS$ActionDetail$customStartDatePickerField = F2(
	function (model, readOnly) {
		return _Utils_Tuple3(
			A2($author$project$CWS$ActionDetail$makeBasicInfo, 'Start Date', readOnly),
			$author$project$Fields$Shared$Required(
				function (action) {
					var _v0 = _Utils_Tuple2(action.dL, action.el);
					if (_v0.a.$ === 1) {
						var _v2 = _v0.a;
						return false;
					} else {
						if (_v0.b.$ === 1) {
							var date = _v0.a.a;
							var _v1 = _v0.b;
							return true;
						} else {
							var start = _v0.a.a;
							var end = _v0.b.a;
							var _v3 = _Utils_Tuple2(
								$elm$core$Result$toMaybe(
									$author$project$NormalDate$fromIsoDate(start)),
								$elm$core$Result$toMaybe(
									$author$project$NormalDate$fromIsoDate(end)));
							if ((!_v3.a.$) && (!_v3.b.$)) {
								var st = _v3.a.a;
								var ed = _v3.b.a;
								return A2($author$project$CWS$ActionDetail$dateLessThanOrEqual, st, ed);
							} else {
								return false;
							}
						}
					}
				}),
			$author$project$Fields$GenericField$Custom(
				$author$project$Fields$CustomField$CustomField(
					function (ro) {
						return function (action) {
							var d = A2($elm$core$Maybe$map, $author$project$NormalDate$stringToDate, action.dL);
							var _v4 = model.b6;
							if (!_v4.$) {
								var picker = _v4.a;
								return A2(
									$elm$html$Html$map,
									$author$project$CWS$ActionDetail$DatePickerMsg(0),
									A3(
										$CurrySoftware$elm_datepicker$DatePicker$view,
										A2(
											$elm$core$Maybe$andThen,
											function (a) {
												return $elm$core$Result$toMaybe(
													$author$project$NormalDate$fromIsoDate(a));
											},
											action.dL),
										_Utils_update(
											$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
											{
												eg: $justinmimbs$date$Date$format('MM/dd/yyyy'),
												hX: ro ? _List_fromArray(
													[
														$elm$html$Html$Attributes$disabled(true)
													]) : _List_Nil,
												h$: function (a) {
													return ro;
												},
												eJ: $author$project$NormalDate$fromNormalDate
											}),
										picker));
							} else {
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Could not load date picker')
										]));
							}
						};
					})));
	});
var $author$project$Fields$GenericField$MaybeLongString = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$ActionDetail$maybeStringField = F3(
	function (field, updater, _default) {
		return {
			a1: function (a) {
				return _Utils_Tuple2(
					field(a),
					_default);
			},
			dI: function (a) {
				return function (b) {
					return $author$project$CWS$ActionDetail$UpdateAction(
						$author$project$CWS$Model$Loaded(
							A2(updater, b, a)));
				};
			}
		};
	});
var $author$project$CWS$ActionDetail$descriptionFieldFancy = function (readOnly) {
	return _Utils_Tuple3(
		A2($author$project$CWS$ActionDetail$makeBasicInfo, 'Description', readOnly),
		$author$project$Fields$Shared$Required(
			function (action) {
				return !_Utils_eq(action.hp, $elm$core$Maybe$Nothing);
			}),
		$author$project$Fields$GenericField$MaybeLongString(
			A3(
				$author$project$CWS$ActionDetail$maybeStringField,
				function (action) {
					return action.hp;
				},
				function (value) {
					return function (action) {
						return _Utils_update(
							action,
							{hp: value});
					};
				},
				'')));
};
var $author$project$CWS$ActionDetail$hoursFieldFancy = function (readOnly) {
	return _Utils_Tuple3(
		A2($author$project$CWS$ActionDetail$makeBasicInfo, 'Hours', readOnly),
		$author$project$Fields$Shared$NotRequired(
			function (action) {
				return $author$project$CWS$ActionDetail$isValidOrNotEntered(action.fB);
			}),
		$author$project$Fields$GenericField$MaybeFloat(
			A3(
				$author$project$CWS$ActionDetail$maybeFloatField,
				function (action) {
					return action.fB;
				},
				function (value) {
					return function (action) {
						return _Utils_update(
							action,
							{fB: value});
					};
				},
				'Not Set')));
};
var $author$project$Fields$GenericField$MaybeString = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$ActionDetail$nameFieldFancy = function (readOnly) {
	return _Utils_Tuple3(
		A2($author$project$CWS$ActionDetail$makeBasicInfo, 'Action Name', readOnly),
		$author$project$Fields$Shared$Required(
			function (action) {
				return !_Utils_eq(action.dz, $elm$core$Maybe$Nothing);
			}),
		$author$project$Fields$GenericField$MaybeString(
			A3(
				$author$project$CWS$ActionDetail$maybeStringField,
				function (action) {
					return action.dz;
				},
				function (value) {
					return function (action) {
						return function (l) {
							return (l > 50) ? _Utils_update(
								action,
								{
									dz: A2(
										$elm$core$Maybe$map,
										$elm$core$String$left(50),
										value)
								}) : _Utils_update(
								action,
								{dz: value});
						}(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$map, $elm$core$String$length, value)));
					};
				},
				'Not Set')));
};
var $author$project$Fields$Shared$NoValidation = {$: 0};
var $author$project$CWS$ActionDetail$noField = _Utils_Tuple3(
	A2($author$project$CWS$ActionDetail$makeBasicInfo, '', true),
	$author$project$Fields$Shared$NoValidation,
	$author$project$Fields$GenericField$Custom(
		$author$project$Fields$CustomField$CustomField(
			function (readOnly) {
				return function (action) {
					return A2($elm$html$Html$div, _List_Nil, _List_Nil);
				};
			})));
var $author$project$CWS$ActionDetail$notesFieldFancy = function (readOnly) {
	return _Utils_Tuple3(
		A2($author$project$CWS$ActionDetail$makeBasicInfo, 'Approver Notes', readOnly),
		readOnly ? $author$project$Fields$Shared$NoValidation : $author$project$Fields$Shared$Required(
			function (action) {
				return !_Utils_eq(action.cn, $elm$core$Maybe$Nothing);
			}),
		$author$project$Fields$GenericField$MaybeLongString(
			A3(
				$author$project$CWS$ActionDetail$maybeStringField,
				function (action) {
					return action.cn;
				},
				function (value) {
					return function (action) {
						return _Utils_update(
							action,
							{cn: value});
					};
				},
				'')));
};
var $author$project$CWS$ActionDetail$submitNoteFieldFancy = _Utils_Tuple3(
	A2($author$project$CWS$ActionDetail$makeBasicInfo, '', true),
	$author$project$Fields$Shared$NoValidation,
	$author$project$Fields$GenericField$Custom(
		$author$project$Fields$CustomField$CustomField(
			function (readOnly) {
				return function (action) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Action Name is required to save. Fields marked with an ')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('requiredLabel')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' are required to submit.')
									]))
							]));
				};
			})));
var $author$project$Fields$GenericField$SingleChoice = function (a) {
	return {$: 9, a: a};
};
var $author$project$CWS$ActionDetail$knvlToKVL = $elm$core$List$map(
	function (itm) {
		return _Utils_Tuple2(
			$elm$core$String$fromInt(itm.ab),
			itm.dz);
	});
var $author$project$CWS$ActionDetail$singleChoiceField = F3(
	function (field, updater, options) {
		return {
			a1: function (a) {
				var val = field(a);
				if (!val.$) {
					var v = val.a;
					return $elm$core$Maybe$Just(v);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			m6: options,
			dI: function (a) {
				return function (b) {
					return $author$project$CWS$ActionDetail$UpdateAction(
						$author$project$CWS$Model$Loaded(
							A2(updater, b, a)));
				};
			}
		};
	});
var $author$project$CWS$ActionDetail$typeChoiceField = F2(
	function (readOnly, values) {
		return _Utils_Tuple3(
			A2($author$project$CWS$ActionDetail$makeBasicInfo, 'Type', readOnly),
			$author$project$Fields$Shared$Required(
				function (action) {
					return action.jE.ab >= 0;
				}),
			$author$project$Fields$GenericField$SingleChoice(
				A3(
					$author$project$CWS$ActionDetail$singleChoiceField,
					function (action) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$elm$core$String$fromInt(action.jE.ab),
								action.jE.dz));
					},
					function (val) {
						return function (action) {
							var newType = function () {
								if (!val.$) {
									var _v1 = val.a;
									var key = _v1.a;
									var value = _v1.b;
									return A2(
										$elm$core$Maybe$withDefault,
										{ab: -1, v: '', dz: 'Not Set'},
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (itm) {
													return _Utils_eq(
														$elm$core$String$fromInt(itm.ab),
														key);
												},
												values)));
								} else {
									return {ab: -1, v: '', dz: 'Not Set'};
								}
							}();
							return _Utils_update(
								action,
								{jE: newType});
						};
					},
					$author$project$CWS$ActionDetail$knvlToKVL(values))));
	});
var $author$project$CWS$ActionDetail$peFieldsFancy = F2(
	function (readOnly, model) {
		var _v0 = model.c;
		if (_v0.$ === 2) {
			var action = _v0.a;
			var _v1 = _Utils_Tuple2(action.bK.ab, action.jE.ab);
			switch (_v1.b) {
				case 10:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField,
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 11:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 20:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								A2(
								$author$project$CWS$ActionDetail$acresFieldFancy,
								readOnly,
								$author$project$CWS$ActionDetail$actionHasSpatial(model.c)),
								$author$project$CWS$ActionDetail$biomassFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 21:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								A2(
								$author$project$CWS$ActionDetail$acresFieldFancy,
								readOnly,
								$author$project$CWS$ActionDetail$actionHasSpatial(model.c))
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 22:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 23:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField,
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 24:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								A2(
								$author$project$CWS$ActionDetail$acresFieldFancy,
								readOnly,
								$author$project$CWS$ActionDetail$actionHasSpatial(model.c))
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 30:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 31:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField,
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 32:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField,
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 33:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				case 34:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
				default:
					return _List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
							]),
							_List_fromArray(
							[
								A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
								A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$biomassFieldFancy(readOnly),
								A2(
								$author$project$CWS$ActionDetail$acresFieldFancy,
								readOnly,
								$author$project$CWS$ActionDetail$actionHasSpatial(model.c))
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
								$author$project$CWS$ActionDetail$noField
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
							]),
							_List_fromArray(
							[
								$author$project$CWS$ActionDetail$notesFieldFancy(true)
							]),
							_List_fromArray(
							[$author$project$CWS$ActionDetail$submitNoteFieldFancy])
						]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$CWS$ActionDetail$validate = function (model) {
	var _v0 = model.bd;
	if (_v0 === 1) {
		var item = function () {
			var _v4 = model.c;
			if (_v4.$ === 2) {
				var e = _v4.a;
				return e;
			} else {
				return $author$project$CWS$Model$blankActionModel;
			}
		}();
		var invalidFields = A2(
			$elm$core$List$filter,
			function (_v3) {
				var valid = _v3.a;
				var basic = _v3.b;
				return !valid;
			},
			A2(
				$author$project$CWS$ActionDetail$areFieldsValid,
				A2($author$project$CWS$ActionDetail$peFieldsFancy, false, model),
				item));
		var fv = (!$elm$core$List$length(invalidFields)) ? $author$project$CWS$ActionDetail$FieldsValid : $author$project$CWS$ActionDetail$FieldsInvalid(
			{
				fK: A2(
					$elm$core$List$map,
					function (_v2) {
						var basic = _v2.b;
						return basic.dz;
					},
					invalidFields)
			});
		if (fv.$ === 1) {
			return $author$project$CWS$ActionDetail$Invalid(
				{fo: fv, jg: $author$project$CWS$ActionDetail$StatusOk});
		} else {
			return $author$project$CWS$ActionDetail$Valid;
		}
	} else {
		return $author$project$CWS$ActionDetail$Valid;
	}
};
var $author$project$CWS$ActionDetail$init = F7(
	function (id, pe, maybeCatGrp, ags, refs, acceptableActionTypes, env) {
		var oldModel = _Utils_update(
			$author$project$CWS$ActionDetail$defaultModel,
			{dH: refs});
		var oldState = oldModel.a;
		var _v0 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var startDatePicker = _v0.a;
		var startdpc = _v0.b;
		var _v1 = A6(
			$author$project$CWS$UploadDocuments$init,
			pe,
			id,
			$elm$core$Maybe$Just(pe.dz + ' new action '),
			false,
			false,
			env);
		var newDocUpldMdl = _v1.a;
		var newDocUpldCmd = _v1.b;
		var newState = _Utils_update(
			oldState,
			{
				ab: id,
				bs: maybeCatGrp,
				cQ: $author$project$CWS$Model$Loaded(pe),
				ba: newDocUpldMdl
			});
		var _v2 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var endDatePicker = _v2.a;
		var enddpc = _v2.b;
		var newModel = _Utils_update(
			oldModel,
			{
				k: acceptableActionTypes,
				gL: ags,
				bM: $elm$core$Maybe$Just(endDatePicker),
				$7: $elm$core$Maybe$Just(
					{p: env.p, m: env.m, f: env.f}),
				b6: $elm$core$Maybe$Just(startDatePicker),
				a: newState
			});
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$UploadDocumentsMsg, newDocUpldCmd),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$CWS$ActionDetail$DatePickerMsg(0),
					startdpc),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$CWS$ActionDetail$DatePickerMsg(1),
					enddpc)
				]));
		if (id >= 0) {
			return _Utils_Tuple2(
				newModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2(
							$elm$core$Platform$Cmd$map,
							$author$project$CWS$ActionDetail$actionAPITranslator,
							A2($author$project$CWS$API$Action$get, id, env)),
							newCmds
						])));
		} else {
			var newNewModel = _Utils_update(
				newModel,
				{
					c: $author$project$CWS$Model$Loaded($author$project$CWS$Model$blankActionModel)
				});
			return _Utils_Tuple2(
				_Utils_update(
					newNewModel,
					{
						aF: $author$project$CWS$ActionDetail$validate(newNewModel)
					}),
				newCmds);
		}
	});
var $author$project$CWS$switchToAction = F4(
	function (model, id, maybePE, categoryGroup) {
		var refLayers = model.dH;
		var oldState = model.a;
		var acceptableTypes = function () {
			var _v2 = model.b.aG;
			if (_v2.$ === 2) {
				var types = _v2.a;
				return types;
			} else {
				return _List_Nil;
			}
		}();
		var _v0 = function () {
			if (!maybePE.$) {
				var pe = maybePE.a;
				return A7(
					$author$project$CWS$ActionDetail$init,
					id,
					pe,
					categoryGroup,
					model.cL,
					refLayers,
					acceptableTypes,
					{p: model.cv, m: model.p.m.av, f: model.f});
			} else {
				return A7(
					$author$project$CWS$ActionDetail$init,
					id,
					$author$project$CWS$Model$defaultParticipatingEntity,
					categoryGroup,
					model.cL,
					refLayers,
					acceptableTypes,
					{p: model.cv, m: model.p.m.av, f: model.f});
			}
		}();
		var initAction = _v0.a;
		var newActionCmds = _v0.b;
		var newAction = initAction;
		var newState = _Utils_update(
			oldState,
			{x: newAction});
		var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, newActionCmds);
		return _Utils_Tuple2(newState, newCmds);
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$CWS$Approver$ManageUserParticipatingEntities$init = F3(
	function (pes, curUserID, targetUserId) {
		var availPEs = pes;
		var mappedPEs = A2(
			$elm$core$List$map,
			function (pe) {
				return _Utils_Tuple2(pe.d.ab, pe.d.dz);
			},
			A2(
				$elm$core$List$sortBy,
				function (b) {
					return b.d.dz;
				},
				availPEs));
		var assignedPEs = A2(
			$elm$core$List$map,
			function (pe) {
				return _Utils_Tuple2(pe.d.ab, pe.d.dz);
			},
			A2(
				$elm$core$List$filter,
				function (pe) {
					return pe.df;
				},
				availPEs));
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$CWS$Approver$ManageUserParticipatingEntities$defaultModel,
				{ee: curUserID, b4: pes, eW: targetUserId, e_: false}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$Messages$AddPEsToUser = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$CWS$Messages$ManagePEsMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$apiTranslator = F2(
	function (td, msg) {
		if (!msg.$) {
			var m = msg.a;
			return td.cO(m);
		} else {
			var user = msg.a;
			var pes = msg.b;
			return A2(td.mC, user, pes);
		}
	});
var $author$project$CWS$managePEsTranslator = $author$project$CWS$Approver$ManageUserParticipatingEntities$apiTranslator(
	{mC: $author$project$CWS$Messages$AddPEsToUser, cO: $author$project$CWS$Messages$ManagePEsMsg});
var $author$project$CWS$switchToManagePEs = F2(
	function (model, userkey) {
		var oldState = model.a;
		var _v0 = A3(
			$author$project$CWS$Approver$ManageUserParticipatingEntities$init,
			function () {
				var _v1 = model.b.cg;
				if (_v1.$ === 2) {
					var pes = _v1.a;
					return pes;
				} else {
					return _List_Nil;
				}
			}(),
			function () {
				var _v2 = model.f;
				if (_v2.$ === 3) {
					var u = _v2.a;
					return u.aB.ab;
				} else {
					return '';
				}
			}(),
			userkey);
		var newManage = _v0.a;
		var newManageCmds = _v0.b;
		var newState = _Utils_update(
			oldState,
			{cJ: newManage});
		var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$managePEsTranslator, newManageCmds);
		return _Utils_Tuple2(newState, newCmds);
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $inkuzmin$elm_multiselect$Multiselect$filter = F2(
	function (selected, values) {
		return A2(
			$elm$core$List$filter,
			function (value) {
				return !A2($elm$core$List$member, value, selected);
			},
			values);
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $inkuzmin$elm_multiselect$Multiselect$populateValues = F3(
	function (_v0, values, selected) {
		var model = _v0;
		var filtered = $elm$core$List$isEmpty(selected) ? values : A2($inkuzmin$elm_multiselect$Multiselect$filter, selected, values);
		return _Utils_update(
			model,
			{B: filtered, P: selected, jJ: values});
	});
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$init = F2(
	function (users, curUserID) {
		var msmo = A2($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'a');
		var availUsers = A2(
			$elm$core$List$filter,
			function (user) {
				return !_Utils_eq(user.ab, curUserID);
			},
			users);
		var mappedUsers = A2(
			$elm$core$List$map,
			function (user) {
				return _Utils_Tuple2(user.ab, user.dz + (' - ' + user.ek));
			},
			availUsers);
		var assignedUsers = A2(
			$elm$core$List$map,
			function (user) {
				return _Utils_Tuple2(user.ab, user.dz + (' - ' + user.ek));
			},
			A2(
				$elm$core$List$filter,
				function (user) {
					return user.df && (!_Utils_eq(user.ab, curUserID));
				},
				availUsers));
		var msm = A3($inkuzmin$elm_multiselect$Multiselect$populateValues, msmo, mappedUsers, assignedUsers);
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$CWS$Approver$ManageParticipatingEntityUsers$defaultModel,
				{
					ee: curUserID,
					dy: msm,
					e_: false,
					aY: A2(
						$elm$core$List$sortBy,
						function (b) {
							return b.df ? 1 : 0;
						},
						users)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$Messages$AddUsersToPE = function (a) {
	return {$: 24, a: a};
};
var $author$project$CWS$Messages$ManageUsersMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$apiTranslator = F2(
	function (td, msg) {
		if (!msg.$) {
			var m = msg.a;
			return td.cO(m);
		} else {
			var users = msg.a;
			return td.mD(users);
		}
	});
var $author$project$CWS$manageUsersTranslator = $author$project$CWS$Approver$ManageParticipatingEntityUsers$apiTranslator(
	{mD: $author$project$CWS$Messages$AddUsersToPE, cO: $author$project$CWS$Messages$ManageUsersMsg});
var $author$project$CWS$switchToManageUsers = F2(
	function (model, pekey) {
		var oldState = model.a;
		var _v0 = A2(
			$author$project$CWS$Approver$ManageParticipatingEntityUsers$init,
			function () {
				var _v1 = model.b.aY;
				if (_v1.$ === 2) {
					var users = _v1.a;
					return users;
				} else {
					return _List_Nil;
				}
			}(),
			function () {
				var _v2 = model.f;
				if (_v2.$ === 3) {
					var u = _v2.a;
					return u.aB.ab;
				} else {
					return '';
				}
			}());
		var newManage = _v0.a;
		var newManageCmds = _v0.b;
		var newState = _Utils_update(
			oldState,
			{cK: newManage});
		var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$manageUsersTranslator, newManageCmds);
		return _Utils_Tuple2(newState, newCmds);
	});
var $author$project$CWS$ActionDetail$Workflow_App = 2;
var $author$project$CWS$ActionDetail$useApproverWorkflow = function (model) {
	return _Utils_update(
		model,
		{bd: 2});
};
var $author$project$CWS$handleSubChangeCWSApp = F5(
	function (oldRoute, newRoute, model, mainRoute, modal) {
		switch (modal.$) {
			case 1:
				var peInfo = modal.a;
				var selectedPE = A2($author$project$CWS$getSelectedPE, model, peInfo.d);
				var oldState = model.a;
				var newYear = peInfo.r;
				var _v1 = function () {
					var _v2 = _Utils_Tuple2(selectedPE, model.b.aA);
					if ((!_v2.a.$) && (_v2.b.$ === 2)) {
						var pe = _v2.a.a;
						var files = _v2.b.a;
						return A6(
							$author$project$CWS$UploadDocuments$initWithFiles,
							pe,
							A2($author$project$CWS$Route$FullRoute, mainRoute, newRoute),
							files,
							$elm$core$Maybe$Nothing,
							true,
							true);
					} else {
						return _Utils_Tuple2($author$project$CWS$UploadDocuments$defaultModel, $elm$core$Platform$Cmd$none);
					}
				}();
				var newAllDocuments = _v1.a;
				var newAllDocsCmds = _v1.b;
				var newCmds = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$FileUploadMsg, newAllDocsCmds)
						]));
				var newState = _Utils_update(
					oldState,
					{U: newAllDocuments});
				var newModel = _Utils_update(
					model,
					{a: newState});
				return _Utils_Tuple3(newModel, newCmds, newRoute);
			case 2:
				var ad = modal.a;
				var _v3 = A4($author$project$CWS$switchToAction, model, ad.ab, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				var chgState = _v3.a;
				var newCmds = _v3.b;
				var newState = _Utils_update(
					chgState,
					{
						x: $author$project$CWS$ActionDetail$useApproverWorkflow(chgState.x)
					});
				var newModel = _Utils_update(
					model,
					{a: newState});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[newCmds])),
					newRoute);
			case 3:
				var ent = modal.a;
				var _v4 = A2($author$project$CWS$switchToManageUsers, model, ent.d);
				var chgState = _v4.a;
				var newCmds = _v4.b;
				var newState = chgState;
				var newModel = _Utils_update(
					model,
					{a: newState});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[newCmds])),
					newRoute);
			case 4:
				var users = modal.a;
				var _v5 = A2($author$project$CWS$switchToManagePEs, model, users.f);
				var chgState = _v5.a;
				var newCmds = _v5.b;
				var newState = chgState;
				var newModel = _Utils_update(
					model,
					{a: newState});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[newCmds])),
					newRoute);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, newRoute);
		}
	});
var $author$project$CWS$ActionDetail$new = F7(
	function (pe, cat, ags, refs, acceptableActionTypes, maybeSelectedActionType, env) {
		var oldModel = _Utils_update(
			$author$project$CWS$ActionDetail$defaultModel,
			{dH: refs});
		var oldState = oldModel.a;
		var nam = function () {
			if (!maybeSelectedActionType.$) {
				var something = maybeSelectedActionType.a;
				return _Utils_update(
					$author$project$CWS$Model$blankActionModel,
					{jE: something});
			} else {
				return $author$project$CWS$Model$blankActionModel;
			}
		}();
		var mcg = $elm$core$Maybe$Just(
			_Utils_Tuple2(cat, ''));
		var _v0 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var startDatePicker = _v0.a;
		var startdpc = _v0.b;
		var _v1 = A6(
			$author$project$CWS$UploadDocuments$init,
			pe,
			-1,
			$elm$core$Maybe$Just(pe.dz + 'new action'),
			false,
			false,
			env);
		var newDocUpldMdl = _v1.a;
		var newDocUpldCmd = _v1.b;
		var newState = _Utils_update(
			oldState,
			{
				ab: -1,
				bs: mcg,
				cQ: $author$project$CWS$Model$Loaded(pe),
				ba: newDocUpldMdl
			});
		var _v2 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var endDatePicker = _v2.a;
		var enddpc = _v2.b;
		var newModel = _Utils_update(
			oldModel,
			{
				k: acceptableActionTypes,
				gL: ags,
				bM: $elm$core$Maybe$Just(endDatePicker),
				$7: $elm$core$Maybe$Just(
					{p: env.p, m: env.m, f: env.f}),
				b6: $elm$core$Maybe$Just(startDatePicker),
				a: newState
			});
		var newNewModel = _Utils_update(
			newModel,
			{
				c: $author$project$CWS$Model$Loaded(nam)
			});
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$UploadDocumentsMsg, newDocUpldCmd),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$CWS$ActionDetail$DatePickerMsg(0),
					startdpc),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$CWS$ActionDetail$DatePickerMsg(1),
					enddpc)
				]));
		return _Utils_Tuple2(
			_Utils_update(
				newNewModel,
				{
					aF: $author$project$CWS$ActionDetail$validate(newNewModel)
				}),
			newCmds);
	});
var $author$project$CWS$switchToNewAction = F4(
	function (model, pe, category, typeKey) {
		var refLayers = model.dH;
		var oldState = model.a;
		var acceptableTypes = function () {
			var _v1 = model.b.aG;
			if (_v1.$ === 2) {
				var types = _v1.a;
				return types;
			} else {
				return _List_Nil;
			}
		}();
		var selectedType = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (a) {
					return _Utils_eq(a.v, typeKey);
				},
				acceptableTypes));
		var _v0 = A7(
			$author$project$CWS$ActionDetail$new,
			pe,
			category,
			model.cL,
			refLayers,
			acceptableTypes,
			selectedType,
			{p: model.cv, m: model.p.m.av, f: model.f});
		var newAction = _v0.a;
		var newActionCmds = _v0.b;
		var newState = _Utils_update(
			oldState,
			{x: newAction});
		var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, newActionCmds);
		return _Utils_Tuple2(newState, newCmds);
	});
var $author$project$CWS$ActionDetail$usePEWorkflow = function (model) {
	return _Utils_update(
		model,
		{bd: 1});
};
var $author$project$CWS$handleSubChangeOld = F4(
	function (oldRoute, newRoute, model, mainRoute) {
		if (!_Utils_eq(oldRoute, newRoute)) {
			var targetPEKey = function () {
				_v7$4:
				while (true) {
					switch (mainRoute.$) {
						case 4:
							switch (mainRoute.a.$) {
								case 0:
									var home = mainRoute.a.a;
									return home.d;
								case 1:
									var action = mainRoute.a.a;
									return action.d.d;
								case 4:
									var pe = mainRoute.a.a;
									return pe.d.d;
								default:
									break _v7$4;
							}
						case 5:
							if (mainRoute.a.$ === 3) {
								var pe = mainRoute.a.a;
								return pe.d;
							} else {
								break _v7$4;
							}
						default:
							break _v7$4;
					}
				}
				return 'Unknown';
			}();
			var selectedPE = A2($author$project$CWS$getSelectedPE, model, targetPEKey);
			var _v0 = function () {
				var _v1 = _Utils_Tuple2(oldRoute, newRoute);
				if (_v1.a.$ === 1) {
					return $author$project$CWS$ActionDetail$denit(model.a.x);
				} else {
					return _Utils_Tuple2(model.a.x, $elm$core$Platform$Cmd$none);
				}
			}();
			var actionDetails_Denit_Model = _v0.a;
			var actionDetails_Denit_Cmds = _v0.b;
			switch (newRoute.$) {
				case 1:
					var ad = newRoute.a;
					var _v3 = A4($author$project$CWS$switchToAction, model, ad.ab, selectedPE, $elm$core$Maybe$Nothing);
					var chgState = _v3.a;
					var newCmds = _v3.b;
					var newState = function () {
						if (mainRoute.$ === 5) {
							return _Utils_update(
								chgState,
								{
									x: $author$project$CWS$ActionDetail$useApproverWorkflow(chgState.x)
								});
						} else {
							return _Utils_update(
								chgState,
								{
									x: $author$project$CWS$ActionDetail$usePEWorkflow(chgState.x)
								});
						}
					}();
					var newModel = _Utils_update(
						model,
						{a: newState});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, actionDetails_Denit_Cmds),
									newCmds
								])),
						newRoute);
				case 2:
					var catgrp = newRoute.a;
					if (!selectedPE.$) {
						var pe = selectedPE.a;
						var _v6 = A4($author$project$CWS$switchToNewAction, model, pe, catgrp.bK, catgrp.hM);
						var newState = _v6.a;
						var newCmds = _v6.b;
						var newModel = _Utils_update(
							model,
							{a: newState});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, actionDetails_Denit_Cmds),
										newCmds
									])),
							newRoute);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, actionDetails_Denit_Cmds),
										$elm$core$Platform$Cmd$none
									])),
							oldRoute);
					}
				default:
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, actionDetails_Denit_Cmds),
									$elm$core$Platform$Cmd$none
								])),
						newRoute);
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, newRoute);
		}
	});
var $author$project$CWS$handleSubChange = F4(
	function (oldRoute, newRoute, model, mainRoute) {
		if (!_Utils_eq(oldRoute, newRoute)) {
			if (newRoute.$ === 3) {
				var sub = newRoute.a;
				return A5($author$project$CWS$handleSubChangeCWSApp, oldRoute, newRoute, model, mainRoute, sub);
			} else {
				return A4($author$project$CWS$handleSubChangeOld, oldRoute, newRoute, model, mainRoute);
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, newRoute);
		}
	});
var $author$project$CWS$handleReRoute = F3(
	function (model, newRoute, oldRoute) {
		var _v0 = function () {
			if (!_Utils_eq(oldRoute, newRoute)) {
				var _v1 = A3($author$project$CWS$handleMainChange, oldRoute, newRoute, model);
				var model_mainChange = _v1.a;
				var mainCmds = _v1.b;
				var mainRoute = _v1.c;
				var _v2 = A4($author$project$CWS$handleSubChange, oldRoute.K, mainRoute.K, model_mainChange, mainRoute.z);
				var model_subChange = _v2.a;
				var subCmds = _v2.b;
				var subRoute = _v2.c;
				var oldState = model_subChange.a;
				var newView = _Utils_update(
					mainRoute,
					{K: subRoute});
				var newRouteYear = A2(
					$elm$core$Maybe$withDefault,
					oldState.r,
					$author$project$CWS$Route$getYearFromRoute(newView));
				var finalYear = function () {
					var _v3 = model.b.aC;
					if (_v3.$ === 2) {
						var pe = _v3.a;
						return A2(
							$elm$core$Maybe$withDefault,
							A2(
								$elm$core$Maybe$withDefault,
								oldState.r,
								A2(
									$elm$core$Maybe$andThen,
									function (a) {
										return $elm$core$Maybe$Just(a.v);
									},
									$elm$core$List$head(pe.cj))),
							A2(
								$elm$core$Maybe$andThen,
								function (a) {
									return $elm$core$Maybe$Just(a.v);
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (a) {
											return _Utils_eq(a.v, newRouteYear);
										},
										pe.cj))));
					} else {
						return oldState.r;
					}
				}();
				var newState = _Utils_update(
					oldState,
					{n: newView, ae: $elm$core$Maybe$Nothing, r: finalYear});
				var newModel = _Utils_update(
					model_subChange,
					{a: newState});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[mainCmds, subCmds])),
					_Utils_update(
						mainRoute,
						{K: subRoute}));
			} else {
				var oldState = model.a;
				var newState = _Utils_update(
					oldState,
					{n: newRoute, ae: $elm$core$Maybe$Nothing});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a: newState}),
					$elm$core$Platform$Cmd$none,
					newRoute);
			}
		}();
		var updatedModel = _v0.a;
		var newCmds = _v0.b;
		var actualRoute = _v0.c;
		return _Utils_Tuple2(updatedModel, newCmds);
	});
var $author$project$CWS$chunkIsLoaded = function (v) {
	if (v.$ === 2) {
		var x = v.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$CWS$routeCanChangeApp = F2(
	function (model, subRt) {
		switch (subRt.$) {
			case 0:
				return $author$project$CWS$chunkIsLoaded(model.b.D) && $author$project$CWS$chunkIsLoaded(model.b.b0);
			case 2:
				return $author$project$CWS$chunkIsLoaded(model.b.cl);
			case 3:
				var pek = subRt.a;
				var sfg = A2($elm$core$Dict$get, pek.d, model.b.aE);
				var ccsf = function () {
					if (!sfg.$) {
						var lf = sfg.a;
						return $author$project$CWS$chunkIsLoaded(lf);
					} else {
						return false;
					}
				}();
				var ccpef = $author$project$CWS$chunkIsLoaded(model.b.aA);
				var ccape = $author$project$CWS$chunkIsLoaded(model.b.D);
				return ccpef && (ccape && ccsf);
			default:
				return true;
		}
	});
var $author$project$CWS$canChangeToReports = F3(
	function (rte, ent, model) {
		return $author$project$CWS$chunkIsLoaded(model.b.aC) && ($author$project$CWS$chunkIsLoaded(model.b.b2) && ($author$project$CWS$chunkIsLoaded(model.b.D) && $author$project$CWS$chunkIsLoaded(model.b.az)));
	});
var $author$project$CWS$routeCanChangePE = F2(
	function (model, subRt) {
		switch (subRt.$) {
			case 0:
				return $author$project$CWS$chunkIsLoaded(model.b.D) && ($author$project$CWS$chunkIsLoaded(model.b.aC) && $author$project$CWS$chunkIsLoaded(model.b.b2));
			case 1:
				return $author$project$CWS$chunkIsLoaded(model.b.D);
			case 4:
				return $author$project$CWS$chunkIsLoaded(model.b.aA) && $author$project$CWS$chunkIsLoaded(model.b.D);
			case 5:
				return $author$project$CWS$chunkIsLoaded(model.b.D);
			case 6:
				var pe = subRt.a;
				var sub = subRt.b;
				return A3($author$project$CWS$canChangeToReports, sub, pe, model);
			default:
				return true;
		}
	});
var $author$project$CWS$routeCanChangeSubCWSApprover = F2(
	function (model, sub) {
		switch (sub.$) {
			case 1:
				var pek = sub.a;
				var sfg = A2($elm$core$Dict$get, pek.d, model.b.aE);
				var ccsf = function () {
					if (!sfg.$) {
						var lf = sfg.a;
						return $author$project$CWS$chunkIsLoaded(lf);
					} else {
						return false;
					}
				}();
				var ccpef = $author$project$CWS$chunkIsLoaded(model.b.aA);
				var ccape = $author$project$CWS$chunkIsLoaded(model.b.D);
				return ccpef && (ccape && ccsf);
			case 2:
				var deets = sub.a;
				return true;
			case 3:
				var deets = sub.a;
				var _v2 = model.b.aY;
				switch (_v2.$) {
					case 2:
						return true;
					case 3:
						return true;
					default:
						return false;
				}
			case 4:
				var deets = sub.a;
				var _v3 = model.b.cg;
				switch (_v3.$) {
					case 2:
						return true;
					case 3:
						return true;
					default:
						return false;
				}
			default:
				return true;
		}
	});
var $author$project$CWS$routeCanChange = function (model) {
	var _v0 = model.f;
	if (_v0.$ === 3) {
		var _v1 = model.a.ae;
		if (!_v1.$) {
			var route = _v1.a;
			var sub = function () {
				var _v3 = route.K;
				switch (_v3.$) {
					case 1:
						return $author$project$CWS$chunkIsLoaded(model.b.aG) && $author$project$CWS$chunkIsLoaded(model.b.D);
					case 2:
						return $author$project$CWS$chunkIsLoaded(model.b.aG) && $author$project$CWS$chunkIsLoaded(model.b.D);
					case 3:
						var stub = _v3.a;
						return A2($author$project$CWS$routeCanChangeSubCWSApprover, model, stub);
					default:
						return true;
				}
			}();
			var main_ = function () {
				var _v2 = route.z;
				switch (_v2.$) {
					case 4:
						var subRt = _v2.a;
						return A2($author$project$CWS$routeCanChangePE, model, subRt);
					case 5:
						var subRt = _v2.a;
						return A2($author$project$CWS$routeCanChangeApp, model, subRt);
					default:
						return true;
				}
			}();
			return main_ && sub;
		} else {
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$CWS$routeCanChangeCheck = function (model) {
	if ($author$project$CWS$routeCanChange(model)) {
		var target = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$About, $author$project$CWS$Route$None),
			model.a.ae);
		var _v0 = A3($author$project$CWS$handleReRoute, model, target, model.a.n);
		var newModel = _v0.a;
		var newcmds = _v0.b;
		return _Utils_Tuple2(newModel, newcmds);
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$CWS$Route$mainCWSRouteToHref = function (cwsRoute) {
	switch (cwsRoute.$) {
		case 0:
			return 'Dashboard';
		case 1:
			return 'Users';
		case 2:
			return 'Actions';
		case 3:
			var pe = cwsRoute.a;
			return 'Documents/' + (pe.d + ('/' + pe.r));
		default:
			return 'TODO_APP';
	}
};
var $author$project$CWS$Route$reportRouteToHref = function (rte) {
	return 'Summary';
};
var $author$project$CWS$Route$mainPERouteToHref = function (peRoute) {
	switch (peRoute.$) {
		case 0:
			var home = peRoute.a;
			return home.d + ('/' + (home.r + '/Home'));
		case 1:
			var actions = peRoute.a;
			return actions.d.d + ('/' + (actions.d.r + ('/Actions/' + actions.bK)));
		case 4:
			var pe = peRoute.a;
			return pe.d.d + ('/' + (pe.d.r + '/Documents/All'));
		case 5:
			return 'Select';
		case 6:
			var pe = peRoute.a;
			var sub = peRoute.b;
			return pe.d + ('/' + (pe.r + ('/Reports/' + $author$project$CWS$Route$reportRouteToHref(sub))));
		default:
			return 'TODO_PE';
	}
};
var $author$project$CWS$Route$mainRouteToHref = function (route) {
	return '/' + function () {
		switch (route.$) {
			case 4:
				var sub = route.a;
				return 'PE/' + $author$project$CWS$Route$mainPERouteToHref(sub);
			case 5:
				var sub = route.a;
				return 'Approver/' + $author$project$CWS$Route$mainCWSRouteToHref(sub);
			case 2:
				return 'About';
			default:
				return 'TODO';
		}
	}();
};
var $author$project$CWS$Route$cwsApproverModalRouteToHref = function (route) {
	switch (route.$) {
		case 1:
			var pe = route.a;
			return '/Documents/View/' + (pe.d + ('/' + pe.r));
		case 2:
			var details = route.a;
			return '/Action/View/' + $elm$core$String$fromInt(details.ab);
		case 3:
			var pe = route.a;
			return '/Users/Manage/' + pe.d;
		case 4:
			var user = route.a;
			return '/Manage/' + user.f;
		default:
			return '/APP_MODAL_TODO';
	}
};
var $author$project$CWS$Route$modalRouteToHref = function (route) {
	switch (route.$) {
		case 1:
			var details = route.a;
			return '/Action/View/' + $elm$core$String$fromInt(details.ab);
		case 2:
			var details = route.a;
			return '/Action/New/' + (details.bK + ('/' + details.hM));
		case 3:
			var sub = route.a;
			return $author$project$CWS$Route$cwsApproverModalRouteToHref(sub);
		default:
			return '';
	}
};
var $author$project$CWS$Route$routeToHref = function (route) {
	return '#' + ($author$project$CWS$Route$mainRouteToHref(route.z) + $author$project$CWS$Route$modalRouteToHref(route.K));
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$CWS$hasAllRequiredRoles = F2(
	function (user, requiredRoles) {
		if (!$elm$core$List$length(requiredRoles)) {
			return true;
		} else {
			var req = requiredRoles;
			var part = function (itm) {
				return A2($elm$core$List$member, itm, req);
			};
			var _v0 = A2($elm$core$List$partition, part, user.iW);
			var match = _v0.a;
			var nomatch = _v0.b;
			var hasAll = _Utils_eq(
				$elm$core$List$length(match),
				$elm$core$List$length(req));
			return hasAll;
		}
	});
var $author$project$CWS$hasAnyRequiredRoles = F2(
	function (user, requiredRoles) {
		if (!$elm$core$List$length(requiredRoles)) {
			return true;
		} else {
			var req = requiredRoles;
			var part = function (itm) {
				return A2($elm$core$List$member, itm, req);
			};
			var _v0 = A2($elm$core$List$partition, part, user.iW);
			var match = _v0.a;
			var nomatch = _v0.b;
			var hasAny = $elm$core$List$length(match) > 0;
			return hasAny;
		}
	});
var $author$project$CWS$hasRequiredRoles = F3(
	function (user, allRequired, anyRequired) {
		return A2($author$project$CWS$hasAllRequiredRoles, user, allRequired) || A2($author$project$CWS$hasAnyRequiredRoles, user, anyRequired);
	});
var $author$project$CWS$loggedInUserAllowedRoute = F2(
	function (route, user) {
		var allowedSub = function () {
			var _v1 = route.K;
			switch (_v1.$) {
				case 0:
					return true;
				case 2:
					return A3(
						$author$project$CWS$hasRequiredRoles,
						user.aB,
						_List_fromArray(
							['CWS User']),
						_List_fromArray(
							['System Administrator', 'PE Delegate', 'FAM Administrator']));
				case 1:
					return A3(
						$author$project$CWS$hasRequiredRoles,
						user.aB,
						_List_Nil,
						_List_fromArray(
							['System Administrator', 'CWS Approver', 'CWS Approver Delegate', 'CWS User', 'PE Delegate', 'FAM Administrator']));
				default:
					return A3(
						$author$project$CWS$hasRequiredRoles,
						user.aB,
						_List_fromArray(
							['CWS Approver']),
						_List_fromArray(
							['System Administrator', 'CWS Approver Delegate', 'FAM Administrator']));
			}
		}();
		var allowedMain = function () {
			var _v0 = route.z;
			switch (_v0.$) {
				case 4:
					return A3(
						$author$project$CWS$hasRequiredRoles,
						user.aB,
						_List_fromArray(
							['CWS User']),
						_List_fromArray(
							['System Administrator', 'PE Delegate', 'FAM Administrator', 'CWS Approver', 'CWS Approver Delegate']));
				case 5:
					return A3(
						$author$project$CWS$hasRequiredRoles,
						user.aB,
						_List_fromArray(
							['CWS Approver']),
						_List_fromArray(
							['System Administrator', 'CWS Approver Delegate', 'FAM Administrator']));
				case 2:
					return true;
				default:
					return false;
			}
		}();
		return allowedMain && allowedSub;
	});
var $author$project$CWS$loggedOutUserAllowedRoute = function (route) {
	var allowedSub = function () {
		var _v1 = route.K;
		if (!_v1.$) {
			return true;
		} else {
			return false;
		}
	}();
	var allowedMain = function () {
		var _v0 = route.z;
		if (_v0.$ === 2) {
			return true;
		} else {
			return false;
		}
	}();
	return allowedMain && allowedSub;
};
var $author$project$CWS$userAllowedRoute = F2(
	function (route, user) {
		if (user.$ === 3) {
			var u = user.a;
			return A2($author$project$CWS$loggedInUserAllowedRoute, route, u);
		} else {
			return $author$project$CWS$loggedOutUserAllowedRoute(route);
		}
	});
var $author$project$CWS$reRoute = F4(
	function (model, newRoute, oldRoute, updateURL) {
		var loggedOut = _Utils_eq(model.f, $author$project$PAM$User$LoggedOut);
		var allowed = A2($author$project$CWS$userAllowedRoute, newRoute, model.f);
		if ((!_Utils_eq(newRoute, oldRoute)) && allowed) {
			var newURL = $author$project$CWS$Route$routeToHref(newRoute);
			var oldCmds = function () {
				var _v0 = oldRoute.K;
				switch (_v0.$) {
					case 2:
						var action = _v0.a;
						var _v1 = $author$project$CWS$ActionDetail$denit(model.a.x);
						var a = _v1.a;
						var b = _v1.b;
						return A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, b);
					case 1:
						var action = _v0.a;
						var _v2 = $author$project$CWS$ActionDetail$denit(model.a.x);
						var a = _v2.a;
						var b = _v2.b;
						return A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, b);
					default:
						return $elm$core$Platform$Cmd$none;
				}
			}();
			var _v3 = function () {
				var _v4 = newRoute.z;
				_v4$6:
				while (true) {
					switch (_v4.$) {
						case 5:
							var cwsRoute = _v4.a;
							return A2($author$project$CWS$requestSwitchToCWSRoute, model, cwsRoute);
						case 4:
							switch (_v4.a.$) {
								case 0:
									var home = _v4.a.a;
									return A3($author$project$CWS$requestSwitchToHome, model, home.d, home.r);
								case 1:
									var actions = _v4.a.a;
									return A4($author$project$CWS$requestSwitchToActions, model, actions.d.d, actions.d.r, actions.bK);
								case 4:
									var pe = _v4.a.a;
									return A3($author$project$CWS$requestSwitchToAllDocuments, model, pe.d.d, pe.d.r);
								case 6:
									var _v5 = _v4.a;
									var pe = _v5.a;
									var sub = _v5.b;
									return A3($author$project$CWS$requestSwitchToReports, model, pe, sub);
								case 5:
									var _v6 = _v4.a;
									return $author$project$CWS$requestSwitchToPeSelect(model);
								default:
									break _v4$6;
							}
						default:
							break _v4$6;
					}
				}
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}();
			var newMainModel = _v3.a;
			var newMainCommands = _v3.b;
			var _v7 = function () {
				var _v8 = newRoute.K;
				switch (_v8.$) {
					case 1:
						var action = _v8.a;
						return A2($author$project$CWS$requestSwitchToAction, newMainModel, action.ab);
					case 2:
						var catgrp = _v8.a;
						return A2($author$project$CWS$requestSwitchToNewAction, newMainModel, catgrp.bK);
					case 3:
						var sub = _v8.a;
						switch (sub.$) {
							case 1:
								var pe = sub.a;
								return A3($author$project$CWS$requestSwitchToAllDocuments, model, pe.d, pe.r);
							case 3:
								var pe = sub.a;
								return A2($author$project$CWS$requestSwitchToManagePEUsers, model, pe.d);
							case 4:
								var user = sub.a;
								return A2($author$project$CWS$requestSwitchToManageUserPEs, model, user.f);
							default:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					default:
						return _Utils_Tuple2(newMainModel, $elm$core$Platform$Cmd$none);
				}
			}();
			var newSubModel = _v7.a;
			var newSubCommands = _v7.b;
			var oldState = newSubModel.a;
			var newState = _Utils_update(
				oldState,
				{
					ae: $elm$core$Maybe$Just(newRoute)
				});
			var targetingModel = _Utils_update(
				newSubModel,
				{a: newState});
			var _v10 = $author$project$CWS$routeCanChangeCheck(targetingModel);
			var newModel = _v10.a;
			var newCommands = _v10.b;
			var allCmds = $elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					updateURL ? A2($elm$browser$Browser$Navigation$pushUrl, model.v, newURL) : $elm$core$Platform$Cmd$none,
					_List_fromArray(
						[oldCmds, newMainCommands, newSubCommands, newCommands])));
			return _Utils_Tuple2(newModel, allCmds);
		} else {
			if (loggedOut) {
				var oldState = model.a;
				var newState = _Utils_update(
					oldState,
					{
						ae: $elm$core$Maybe$Just(newRoute)
					});
				var targetingModel = _Utils_update(
					model,
					{a: newState});
				var _v11 = $author$project$CWS$routeCanChangeCheck(targetingModel);
				var newModel = _v11.a;
				var newCommands = _v11.b;
				return _Utils_Tuple2(newModel, newCommands);
			} else {
				if (!allowed) {
					var oldState = model.a;
					var errorRoute = A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$About, $author$project$CWS$Route$None);
					var newState = _Utils_update(
						oldState,
						{
							ae: $elm$core$Maybe$Just(errorRoute)
						});
					var targetingModel = _Utils_update(
						model,
						{a: newState});
					var _v12 = $author$project$CWS$routeCanChangeCheck(targetingModel);
					var newModel = _v12.a;
					var newCommands = _v12.b;
					return _Utils_Tuple2(newModel, newCommands);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			}
		}
	});
var $author$project$CWS$closeModalUpdate = F2(
	function (model, confirmClose) {
		var oldState_ = model.a;
		var oldRoute = model.a.n;
		var newRoute = _Utils_update(
			oldRoute,
			{K: $author$project$CWS$Route$None});
		var _v0 = function () {
			if (confirmClose) {
				var oldState = model.a;
				var _v1 = oldState.aJ;
				switch (_v1.$) {
					case 0:
						var newState = _Utils_update(
							oldState,
							{
								aJ: $author$project$CWS$Model$RequestConfirmation('This action has not been saved. If you exit, all changes will be lost.')
							});
						var newModel2 = _Utils_update(
							model,
							{a: newState});
						return _Utils_Tuple2(newModel2, $elm$core$Platform$Cmd$none);
					case 2:
						var _v2 = A4($author$project$CWS$reRoute, model, newRoute, oldRoute, true);
						var newModel2 = _v2.a;
						var newCmd = _v2.b;
						var oldState2 = newModel2.a;
						var newState = _Utils_update(
							oldState2,
							{aJ: $author$project$CWS$Model$NoConfirmation});
						var updatedModel = _Utils_update(
							newModel2,
							{a: newState});
						return _Utils_Tuple2(updatedModel, newCmd);
					case 3:
						var newState = _Utils_update(
							oldState,
							{aJ: $author$project$CWS$Model$NoConfirmation});
						var newModel2 = _Utils_update(
							model,
							{a: newState});
						return _Utils_Tuple2(newModel2, $elm$core$Platform$Cmd$none);
					default:
						var msg = _v1.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			} else {
				var _v3 = A4($author$project$CWS$reRoute, model, newRoute, oldRoute, true);
				var a = _v3.a;
				var b = _v3.b;
				return _Utils_Tuple2(a, b);
			}
		}();
		var newModel = _v0.a;
		var newCmds = _v0.b;
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$closeModal = function (_v0) {
	var model = _v0.a;
	var cmds = _v0.b;
	var oldState = model.a;
	var newState = _Utils_update(
		oldState,
		{aJ: $author$project$CWS$Model$Confirmed});
	var newModel = _Utils_update(
		model,
		{a: newState});
	var _v1 = A2($author$project$CWS$closeModalUpdate, newModel, true);
	var nm = _v1.a;
	var nc = _v1.b;
	return _Utils_Tuple2(
		nm,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[cmds, nc])));
};
var $author$project$CWS$Route$LoadingData = {$: 0};
var $author$project$CWS$UploadDocuments$GridMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$CWS$UploadDocuments$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$UploadDocuments$SentNewFileInfo = function (a) {
	return {$: 7, a: a};
};
var $author$project$CWS$UploadDocuments$Valid = {$: 1};
var $author$project$CWS$UploadDocuments$ValidityResults = F3(
	function (sizeValid, extValid, countLimitValid) {
		return {he: countLimitValid, hx: extValid, i9: sizeValid};
	});
var $author$project$CWS$Model$FileUploadModel = F2(
	function (file, uploadUrl) {
		return {lv: file, oD: uploadUrl};
	});
var $author$project$CWS$Model$fileUploadDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uploadURL',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'file',
		$author$project$CWS$Model$fileDecoder,
		$elm$json$Json$Decode$succeed($author$project$CWS$Model$FileUploadModel)));
var $author$project$CWS$API$File$newFileEncoder = function (file) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(file.dz)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(file.hp)),
				_Utils_Tuple2(
				'status',
				$elm$json$Json$Encode$int(file.jf))
			]));
};
var $author$project$CWS$API$File$newFileRequestEncoder = F4(
	function (file, peID, actionID, fileType) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'File',
					$author$project$CWS$API$File$newFileEncoder(file)),
					_Utils_Tuple2(
					'ActionID',
					$elm$json$Json$Encode$int(actionID)),
					_Utils_Tuple2(
					'PEID',
					$elm$json$Json$Encode$string(peID)),
					_Utils_Tuple2(
					'Type',
					$elm$json$Json$Encode$string(fileType))
				]));
	});
var $author$project$CWS$API$File$addNewFile = F8(
	function (settings, user, model, peID, actionID, fileType, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'New',
			$elm$core$Maybe$Just(
				A4($author$project$CWS$API$File$newFileRequestEncoder, model, peID, actionID, fileType)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$fileUploadDecoder);
	});
var $author$project$CWS$UploadDocuments$cancelDelete = F2(
	function (model, id) {
		var oldState = model.a;
		var newState = _Utils_update(
			oldState,
			{aJ: $author$project$CWS$Model$NoDynConfirmation});
		var cmds = $elm$core$Platform$Cmd$batch(_List_Nil);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$UploadDocuments$CancelDelete = function (a) {
	return {$: 19, a: a};
};
var $author$project$CWS$UploadDocuments$ConfirmDelete = function (a) {
	return {$: 18, a: a};
};
var $author$project$CWS$UploadDocuments$confirmDelete = F2(
	function (model, id) {
		var oldState = model.a;
		var newState = model.g3 ? _Utils_update(
			oldState,
			{
				aJ: A8($author$project$CWS$Model$RequestDynConfirmation, 'Confirm Delete', 'Are you sure you would like to delete this file?', 'Deleting the file will delete the file and all information entered for the file.', 'Yes', $author$project$CWS$UploadDocuments$ConfirmDelete, 'No', $author$project$CWS$UploadDocuments$CancelDelete, id)
			}) : oldState;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$UploadDocuments$FileDeleted = function (a) {
	return {$: 20, a: a};
};
var $author$project$CWS$API$File$byIdGetRequestEncoder = function (id) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(id))
			]));
};
var $author$project$CWS$API$File$deletFileById = F5(
	function (settings, user, id, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'Delete',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$File$byIdGetRequestEncoder(id)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$fileListDecoder);
	});
var $author$project$CWS$UploadDocuments$deleteItem = F3(
	function (model, id, env) {
		var oldState = model.a;
		var newState = _Utils_update(
			oldState,
			{aJ: $author$project$CWS$Model$NoDynConfirmation});
		var cmds = A5($author$project$CWS$API$File$deletFileById, env.m, env.f, id, $author$project$CWS$UploadDocuments$FileDeleted, $author$project$CWS$UploadDocuments$FileDeleted);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			cmds);
	});
var $author$project$CWS$UploadDocuments$Out_FileDeleted = 1;
var $author$project$CWS$UploadDocuments$fileDeletedOut = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(
		model,
		cmd,
		$elm$core$Maybe$Just(1));
};
var $author$project$CWS$UploadDocuments$acceptableExt = _List_fromArray(
	['PDF', 'JPG', 'JPEG', 'TIF', 'TIFF', 'PNG', 'DOC', 'DOCX', 'XLS', 'XLSX', 'ZIP']);
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$CWS$UploadDocuments$fileExtensionValid = function (name) {
	var rawFileNameSplit = A2($elm$core$String$split, '\\', name);
	var newFileNameStr = $elm$core$String$concat(
		A2(
			$elm$core$List$drop,
			$elm$core$List$length(rawFileNameSplit) - 1,
			rawFileNameSplit));
	var newFileNameStrSplit = A2($elm$core$String$split, '.', newFileNameStr);
	var newFileExtStr = $elm$core$String$toUpper(
		$elm$core$String$concat(
			A2(
				$elm$core$List$drop,
				$elm$core$List$length(newFileNameStrSplit) - 1,
				newFileNameStrSplit)));
	var findExt = A2(
		$elm_community$list_extra$List$Extra$find,
		function (item) {
			return _Utils_eq(item, newFileExtStr);
		},
		$author$project$CWS$UploadDocuments$acceptableExt);
	var extValid = !_Utils_eq(findExt, $elm$core$Maybe$Nothing);
	return extValid;
};
var $author$project$CWS$UploadDocuments$fileSizeValid = function (size) {
	return ((size / 1000) / 1000) < 25.0;
};
var $author$project$CWS$UploadDocuments$Out_FileUploaded = 0;
var $author$project$CWS$UploadDocuments$fileUploadedOut = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(
		model,
		cmd,
		$elm$core$Maybe$Just(0));
};
var $author$project$CWS$UploadDocuments$getFileInfo = _Platform_outgoingPort(
	'getFileInfo',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$CWS$UploadDocuments$fileUploadjs = _Platform_outgoingPort(
	'fileUploadjs',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'file',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'actionGroup',
									$elm$json$Json$Encode$string($.gG)),
									_Utils_Tuple2(
									'actionId',
									$elm$json$Json$Encode$int($.gH)),
									_Utils_Tuple2(
									'actionName',
									$elm$json$Json$Encode$string($.gI)),
									_Utils_Tuple2(
									'actionType',
									$elm$json$Json$Encode$string($.gJ)),
									_Utils_Tuple2(
									'description',
									$elm$json$Json$Encode$string($.hp)),
									_Utils_Tuple2(
									'fileUserName',
									$elm$json$Json$Encode$string($.hC)),
									_Utils_Tuple2(
									'id',
									function ($) {
										return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
									}($.ab)),
									_Utils_Tuple2(
									'modified',
									$elm$json$Json$Encode$string($.ik)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string($.dz)),
									_Utils_Tuple2(
									'status',
									$elm$json$Json$Encode$int($.jf))
								]));
					}($.lv)),
					_Utils_Tuple2(
					'uploadUrl',
					$elm$json$Json$Encode$string($.oD))
				]));
	});
var $author$project$CWS$UploadDocuments$gotNewFileId = F2(
	function (model, result) {
		if (result.$ === 1) {
			var httpError = result.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var afm = result.a;
			var oldFileList = model.aK;
			var newFileList = _List_fromArray(
				[afm.lv]);
			var appendedFileList = A2($elm$core$List$append, oldFileList, newFileList);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						bk: '',
						aK: appendedFileList,
						cf: $elm$core$Maybe$Just(afm.lv)
					}),
				$author$project$CWS$UploadDocuments$fileUploadjs(afm));
		}
	});
var $author$project$CWS$UploadDocuments$handleCancelDescriptionClick = function (model) {
	var oldState = model.a;
	var newState = _Utils_update(
		oldState,
		{hr: $author$project$CWS$UploadDocuments$NotEditing});
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{a: newState}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$CWS$UploadDocuments$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$UploadDocuments$handleEditClick = F2(
	function (model, file) {
		var oldState = model.a;
		var newState = model.g3 ? _Utils_update(
			oldState,
			{
				hr: $author$project$CWS$UploadDocuments$Edit(file)
			}) : oldState;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$UploadDocuments$downloadFileCmd = _Platform_outgoingPort(
	'downloadFileCmd',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					function ($) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'file',
								function ($) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'actionGroup',
												$elm$json$Json$Encode$string($.gG)),
												_Utils_Tuple2(
												'actionId',
												$elm$json$Json$Encode$int($.gH)),
												_Utils_Tuple2(
												'actionName',
												$elm$json$Json$Encode$string($.gI)),
												_Utils_Tuple2(
												'actionType',
												$elm$json$Json$Encode$string($.gJ)),
												_Utils_Tuple2(
												'description',
												$elm$json$Json$Encode$string($.hp)),
												_Utils_Tuple2(
												'fileUserName',
												$elm$json$Json$Encode$string($.hC)),
												_Utils_Tuple2(
												'id',
												function ($) {
													return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
												}($.ab)),
												_Utils_Tuple2(
												'modified',
												$elm$json$Json$Encode$string($.ik)),
												_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string($.dz)),
												_Utils_Tuple2(
												'status',
												$elm$json$Json$Encode$int($.jf))
											]));
								}($.lv)),
								_Utils_Tuple2(
								'uploadUrl',
								$elm$json$Json$Encode$string($.oD))
							]));
				}(a),
					function ($) {
					return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
				}(b)
				]));
	});
var $author$project$CWS$UploadDocuments$handleFileDownloadResponse = F2(
	function (model, result) {
		if (result.$ === 1) {
			var httpError = result.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var fileDownload = result.a;
			return _Utils_Tuple2(
				model,
				$author$project$CWS$UploadDocuments$downloadFileCmd(
					_Utils_Tuple2(fileDownload, model.dE)));
		}
	});
var $author$project$CWS$UploadDocuments$handleFileDownloadResponseAs = F3(
	function (model, result, nameAs) {
		if (result.$ === 1) {
			var httpError = result.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var fileDownload = result.a;
			return _Utils_Tuple2(
				model,
				$author$project$CWS$UploadDocuments$downloadFileCmd(
					_Utils_Tuple2(
						fileDownload,
						$elm$core$Maybe$Just(nameAs))));
		}
	});
var $author$project$CWS$UploadDocuments$handleFileUpdated = F3(
	function (result, model, env) {
		return _Utils_Tuple2(
			model,
			A5($author$project$CWS$API$File$getFilesForAction, env.m, env.f, model.gH, $author$project$CWS$UploadDocuments$LoadedFiles, $author$project$CWS$UploadDocuments$LoadedFiles));
	});
var $author$project$CWS$UploadDocuments$FileStatusUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$CWS$API$File$newFileIdRequestEncoder = function (file) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '-1', file.ab)))
			]));
};
var $author$project$CWS$API$File$setFileStatusUploaded = F5(
	function (settings, user, file, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'Uploaded',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$File$newFileIdRequestEncoder(file)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$fileDecoder);
	});
var $author$project$CWS$UploadDocuments$handleFileUploaded = F3(
	function (model, result, env) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{_: $elm$core$Maybe$Nothing}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						function () {
						var _v0 = model.cf;
						if (!_v0.$) {
							var file = _v0.a;
							return A5($author$project$CWS$API$File$setFileStatusUploaded, env.m, env.f, file, $author$project$CWS$UploadDocuments$FileStatusUpdated, $author$project$CWS$UploadDocuments$FileStatusUpdated);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}()
					])));
	});
var $author$project$CWS$UploadDocuments$fileCountValid = function (model) {
	return $elm$core$List$length(model.aK) <= 9;
};
var $author$project$CWS$UploadDocuments$handleLoadedFiles = F2(
	function (model, result) {
		if (result.$ === 1) {
			var httpError = result.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var list = result.a;
			var newModel = _Utils_update(
				model,
				{aK: list});
			var countValid = $author$project$CWS$UploadDocuments$fileCountValid(newModel);
			var valid = (!countValid) ? $author$project$CWS$UploadDocuments$Invalid(
				A3($author$project$CWS$UploadDocuments$ValidityResults, true, true, countValid)) : $author$project$CWS$UploadDocuments$NotChecked;
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{aw: valid}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$UploadDocuments$FileUpdated = function (a) {
	return {$: 24, a: a};
};
var $author$project$CWS$API$File$fileEncoder = function (file) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm_community$json_extra$Json$Encode$Extra$maybe($elm$json$Json$Encode$string)(file.ab)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(file.dz)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(file.hp)),
				_Utils_Tuple2(
				'status',
				$elm$json$Json$Encode$int(file.jf))
			]));
};
var $author$project$CWS$API$File$updateFile = F5(
	function (settings, user, file, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'Update',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$File$fileEncoder(file)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$fileDecoder);
	});
var $author$project$CWS$UploadDocuments$handleSaveDescriptionClick = F2(
	function (model, env) {
		var oldState = model.a;
		var newState = _Utils_update(
			oldState,
			{hr: $author$project$CWS$UploadDocuments$NotEditing});
		var _v0 = model.a.hr;
		if (!_v0.$) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var file = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{a: newState}),
				A5($author$project$CWS$API$File$updateFile, env.m, env.f, file, $author$project$CWS$UploadDocuments$FileUpdated, $author$project$CWS$UploadDocuments$FileUpdated));
		}
	});
var $author$project$CWS$UploadDocuments$FileDownloadResponse = function (a) {
	return {$: 15, a: a};
};
var $author$project$CWS$API$File$downloadFile = F5(
	function (settings, user, file, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'Download',
			$elm$core$Maybe$Just(
				$author$project$CWS$API$File$newFileIdRequestEncoder(file)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$fileUploadDecoder);
	});
var $author$project$CWS$UploadDocuments$initiateFileDownload = F2(
	function (file, env) {
		return A5($author$project$CWS$API$File$downloadFile, env.m, env.f, file, $author$project$CWS$UploadDocuments$FileDownloadResponse, $author$project$CWS$UploadDocuments$FileDownloadResponse);
	});
var $author$project$CWS$UploadDocuments$noOut = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(model, cmd, $elm$core$Maybe$Nothing);
};
var $author$project$CWS$UploadDocuments$handleGridMsg = F3(
	function (model, subMsg, env) {
		var _v5 = A2($author$project$GridOld$Grid$update, model.dr, subMsg);
		var newGrid = _v5.a;
		var newGridCmds = _v5.b;
		var outMsg = _v5.c;
		var newModel = _Utils_update(
			model,
			{dr: newGrid});
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$UploadDocuments$GridMsg, newGridCmds)
				]));
		if (outMsg.$ === 1) {
			return $author$project$CWS$UploadDocuments$noOut(
				_Utils_Tuple2(newModel, newCmds));
		} else {
			var sub = outMsg.a;
			return A3($author$project$CWS$UploadDocuments$update, sub, newModel, env);
		}
	});
var $author$project$CWS$UploadDocuments$update = F3(
	function (msg, model, env) {
		switch (msg.$) {
			case 7:
				var result = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					A2($author$project$CWS$UploadDocuments$gotNewFileId, model, result));
			case 2:
				var filename = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{aw: $author$project$CWS$UploadDocuments$NotChecked, _: $elm$core$Maybe$Nothing}),
						$author$project$CWS$UploadDocuments$getFileInfo(0)));
			case 1:
				var filename = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{aw: $author$project$CWS$UploadDocuments$NotChecked, _: $elm$core$Maybe$Nothing}),
						$author$project$CWS$UploadDocuments$getFileInfo(0)));
			case 3:
				var filedesc = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{bk: filedesc}),
						$elm$core$Platform$Cmd$none));
			case 17:
				var file = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$CWS$UploadDocuments$noOut(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)),
					A2(
						$elm$core$Maybe$map,
						function (f) {
							return $author$project$CWS$UploadDocuments$noOut(
								A2($author$project$CWS$UploadDocuments$confirmDelete, model, f));
						},
						file.ab));
			case 18:
				var id = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					A3($author$project$CWS$UploadDocuments$deleteItem, model, id, env));
			case 19:
				var id = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					A2($author$project$CWS$UploadDocuments$cancelDelete, model, id));
			case 20:
				var filelist = msg.a;
				return $author$project$CWS$UploadDocuments$fileDeletedOut(
					_Utils_Tuple2(
						model,
						(model.gH > 0) ? $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$CWS$API$File$getFilesForAction, env.m, env.f, model.gH, $author$project$CWS$UploadDocuments$LoadedFiles, $author$project$CWS$UploadDocuments$LoadedFiles)
								])) : $elm$core$Platform$Cmd$none));
			case 4:
				var _v1 = model._;
				if (!_v1.$) {
					var info = _v1.a;
					var fileName = function () {
						var _v2 = model._;
						if (!_v2.$) {
							var i = _v2.a;
							return i.dz;
						} else {
							return '';
						}
					}();
					var newFile = {gG: '', gH: 0, gI: '', gJ: '', hp: model.bk, hC: '', ab: $elm$core$Maybe$Nothing, ik: '', dz: fileName, jf: 0};
					return $author$project$CWS$UploadDocuments$noOut(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									cf: $elm$core$Maybe$Just(newFile)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A8($author$project$CWS$API$File$addNewFile, env.m, env.f, newFile, model.eK.ab, model.gH, info.jE, $author$project$CWS$UploadDocuments$SentNewFileInfo, $author$project$CWS$UploadDocuments$SentNewFileInfo)
									]))));
				} else {
					return $author$project$CWS$UploadDocuments$noOut(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 5:
				var mdl = msg.a;
				var _v3 = mdl._;
				if (!_v3.$) {
					var info = _v3.a;
					var fileName = function () {
						var _v4 = mdl._;
						if (!_v4.$) {
							var i = _v4.a;
							return i.dz;
						} else {
							return '';
						}
					}();
					var newFile = {gG: '', gH: 0, gI: '', gJ: '', hp: mdl.bk, hC: '', ab: $elm$core$Maybe$Nothing, ik: '', dz: fileName, jf: 0};
					return $author$project$CWS$UploadDocuments$noOut(
						_Utils_Tuple2(
							_Utils_update(
								mdl,
								{
									cf: $elm$core$Maybe$Just(newFile)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A8($author$project$CWS$API$File$addNewFile, env.m, env.f, newFile, model.eK.ab, model.gH, info.jE, $author$project$CWS$UploadDocuments$SentNewFileInfo, $author$project$CWS$UploadDocuments$SentNewFileInfo)
									]))));
				} else {
					return $author$project$CWS$UploadDocuments$noOut(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 8:
				var fileInfo = msg.a;
				var sizeValid = $author$project$CWS$UploadDocuments$fileSizeValid(fileInfo.aV);
				var extValid = $author$project$CWS$UploadDocuments$fileExtensionValid(fileInfo.dz);
				var countValid = true;
				var newValid = (extValid && (sizeValid && countValid)) ? $author$project$CWS$UploadDocuments$Valid : $author$project$CWS$UploadDocuments$Invalid(
					A3($author$project$CWS$UploadDocuments$ValidityResults, sizeValid, extValid, countValid));
				return $author$project$CWS$UploadDocuments$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								aw: newValid,
								_: $elm$core$Maybe$Just(fileInfo)
							}),
						$elm$core$Platform$Cmd$none));
			case 9:
				return $author$project$CWS$UploadDocuments$noOut(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 10:
				var result = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					A2($author$project$CWS$UploadDocuments$handleLoadedFiles, model, result));
			case 11:
				var result = msg.a;
				return $author$project$CWS$UploadDocuments$fileUploadedOut(
					A3($author$project$CWS$UploadDocuments$handleFileUploaded, model, result, env));
			case 13:
				var result = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{cf: $elm$core$Maybe$Nothing}),
						A5($author$project$CWS$API$File$getFilesForAction, env.m, env.f, model.gH, $author$project$CWS$UploadDocuments$LoadedFiles, $author$project$CWS$UploadDocuments$LoadedFiles)));
			case 14:
				var file = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					_Utils_Tuple2(
						model,
						A2($author$project$CWS$UploadDocuments$initiateFileDownload, file, env)));
			case 15:
				var fileDownload = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					A2($author$project$CWS$UploadDocuments$handleFileDownloadResponse, model, fileDownload));
			case 16:
				var name = msg.a;
				var fileDownload = msg.b;
				return $author$project$CWS$UploadDocuments$noOut(
					A3($author$project$CWS$UploadDocuments$handleFileDownloadResponseAs, model, fileDownload, name));
			case 21:
				var file = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					A2($author$project$CWS$UploadDocuments$handleEditClick, model, file));
			case 22:
				return $author$project$CWS$UploadDocuments$noOut(
					A2($author$project$CWS$UploadDocuments$handleSaveDescriptionClick, model, env));
			case 23:
				return $author$project$CWS$UploadDocuments$noOut(
					$author$project$CWS$UploadDocuments$handleCancelDescriptionClick(model));
			case 24:
				var result = msg.a;
				return $author$project$CWS$UploadDocuments$noOut(
					A3($author$project$CWS$UploadDocuments$handleFileUpdated, result, model, env));
			case 25:
				var subMsg = msg.a;
				return A3($author$project$CWS$UploadDocuments$handleGridMsg, model, subMsg, env);
			default:
				return $author$project$CWS$UploadDocuments$noOut(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$CWS$fileUploadUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = A3(
			$author$project$CWS$UploadDocuments$update,
			subMsg,
			model.a.U,
			{m: model.p.m.av, f: model.f});
		var newFile = _v0.a;
		var newFileCmds = _v0.b;
		var outMsg = _v0.c;
		var newState = _Utils_update(
			oldState,
			{U: newFile});
		var newModel = _Utils_update(
			model,
			{a: newState});
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$FileUploadMsg, newFileCmds)
				]));
		if (outMsg.$ === 1) {
			return _Utils_Tuple2(newModel, newCmds);
		} else {
			var out = outMsg.a;
			var _v2 = model.a.n.K;
			if (_v2.$ === 1) {
				return _Utils_Tuple2(newModel, newCmds);
			} else {
				return A4(
					$author$project$CWS$reRoute,
					newModel,
					newModel.a.n,
					A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$LoadingData, $author$project$CWS$Route$None),
					true);
			}
		}
	});
var $author$project$CWS$UploadDocuments$FileUploadModelWithField = F2(
	function (field, info) {
		return {hz: field, a4: info};
	});
var $author$project$CWS$UploadDocuments$cws_upload_file_to_s3 = _Platform_outgoingPort(
	'cws_upload_file_to_s3',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'field',
					$elm$json$Json$Encode$string($.hz)),
					_Utils_Tuple2(
					'info',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'file',
									function ($) {
										return $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'actionGroup',
													$elm$json$Json$Encode$string($.gG)),
													_Utils_Tuple2(
													'actionId',
													$elm$json$Json$Encode$int($.gH)),
													_Utils_Tuple2(
													'actionName',
													$elm$json$Json$Encode$string($.gI)),
													_Utils_Tuple2(
													'actionType',
													$elm$json$Json$Encode$string($.gJ)),
													_Utils_Tuple2(
													'description',
													$elm$json$Json$Encode$string($.hp)),
													_Utils_Tuple2(
													'fileUserName',
													$elm$json$Json$Encode$string($.hC)),
													_Utils_Tuple2(
													'id',
													function ($) {
														return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
													}($.ab)),
													_Utils_Tuple2(
													'modified',
													$elm$json$Json$Encode$string($.ik)),
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string($.dz)),
													_Utils_Tuple2(
													'status',
													$elm$json$Json$Encode$int($.jf))
												]));
									}($.lv)),
									_Utils_Tuple2(
									'uploadUrl',
									$elm$json$Json$Encode$string($.oD))
								]));
					}($.a4))
				]));
	});
var $author$project$CWS$UploadDocuments$handleStaticFileResponse = F4(
	function (staticModel, field, id, result) {
		if (!result.$) {
			var upload = result.a;
			var oldDict = staticModel.aE;
			var oldVal = A2($elm$core$Dict$get, id, oldDict);
			var newDict = function () {
				if (!oldVal.$) {
					var val = oldVal.a;
					var oldStaticFile = val.J;
					var newFile = upload.lv;
					var newStaticFile = _Utils_update(
						oldStaticFile,
						{
							lv: $elm$core$Maybe$Just(newFile)
						});
					return A3(
						$elm$core$Dict$insert,
						id,
						_Utils_update(
							val,
							{
								fS: $elm$core$Maybe$Nothing,
								fT: $elm$core$Maybe$Nothing,
								dA: $elm$core$Maybe$Nothing,
								a: $author$project$CWS$UploadDocuments$staticFileModelToState(newStaticFile),
								J: newStaticFile
							}),
						oldDict);
				} else {
					return oldDict;
				}
			}();
			return _Utils_Tuple2(
				$author$project$CWS$UploadDocuments$Workflow_Static(
					_Utils_update(
						staticModel,
						{aE: newDict})),
				$author$project$CWS$UploadDocuments$cws_upload_file_to_s3(
					A2($author$project$CWS$UploadDocuments$FileUploadModelWithField, field, upload)));
		} else {
			return _Utils_Tuple2(
				$author$project$CWS$UploadDocuments$Workflow_Static(staticModel),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$UploadDocuments$handleFileResponse = F4(
	function (wkflw, oldWkflw, uploadWorkflow, response) {
		var _v0 = _Utils_Tuple2(wkflw, uploadWorkflow);
		if (!_v0.a.$) {
			var _static = _v0.a.a;
			var _v1 = _v0.b;
			var field = _v1.a;
			var id = _v1.b;
			return A4($author$project$CWS$UploadDocuments$handleStaticFileResponse, _static, field, id, response);
		} else {
			return _Utils_Tuple2(wkflw, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$UploadDocuments$SelectExpiration = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$CWS$UploadDocuments$SelectFile = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$UploadDocuments$StaticWorkflow_DatePickerMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$CWS$UploadDocuments$Uploading = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$NormalDate$dateToNormalString = function (date) {
	return A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$NormalDate$monthToInt(
				$justinmimbs$date$Date$month(date)))) + ('/' + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$justinmimbs$date$Date$day(date))) + ('/' + $elm$core$String$fromInt(
		$justinmimbs$date$Date$year(date)))));
};
var $author$project$CWS$UploadDocuments$pickFileFor = _Platform_outgoingPort('pickFileFor', $elm$json$Json$Encode$int);
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.bp;
		var focused = model.ak;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ak: $elm$core$Maybe$Just(date),
							bC: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ak: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ak: $elm$core$Maybe$Nothing, aL: $elm$core$Maybe$Nothing, eF: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = settings.eJ(
							A2($elm$core$Maybe$withDefault, '', model.aL));
						if (!_v5.$) {
							var date = _v5.a;
							return settings.h$(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
								$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
						} else {
							var e = _v5.a;
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
								$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ak: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.ak;
									}
								}(),
								aL: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.aL;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bp: false, eF: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eF: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bp: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bp: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $author$project$CWS$UploadDocuments$StaticUpload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$CWS$UploadDocuments$Workflow_UploadFileResponse = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$CWS$Model$defaultFileModel = {gG: '', gH: -1, gI: '', gJ: '', hp: '', hC: '', ab: $elm$core$Maybe$Nothing, ik: '', dz: '', jf: -1};
var $author$project$CWS$Model$fileEncoder = function (file) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm_community$json_extra$Json$Encode$Extra$maybe($elm$json$Json$Encode$string)(file.ab)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(file.dz)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(file.hp)),
				_Utils_Tuple2(
				'status',
				$elm$json$Json$Encode$int(file.jf))
			]));
};
var $author$project$CWS$Model$staticFileEncoder = function (file) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(file.ab)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(file.dz)),
				_Utils_Tuple2(
				'mode',
				$elm$json$Json$Encode$int(file.mp)),
				_Utils_Tuple2(
				'participatingEntityID',
				$elm$json$Json$Encode$string(file.iy)),
				_Utils_Tuple2(
				'file',
				$elm_community$json_extra$Json$Encode$Extra$maybe($author$project$CWS$Model$fileEncoder)(file.lv))
			]));
};
var $author$project$CWS$API$File$staticFileWithTypeEncoder = F2(
	function (staticFile, fileType) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'FileType',
					$elm$json$Json$Encode$string(fileType)),
					_Utils_Tuple2(
					'StaticFile',
					$author$project$CWS$Model$staticFileEncoder(staticFile))
				]));
	});
var $author$project$CWS$API$File$updateStaticFile = F6(
	function (settings, user, file, fileType, _return, onError) {
		return A8(
			$author$project$CWS$API$postRequestNew,
			settings,
			'Files',
			'UpdateStaticFile',
			$elm$core$Maybe$Just(
				A2($author$project$CWS$API$File$staticFileWithTypeEncoder, file, fileType)),
			_return,
			onError,
			user,
			$author$project$CWS$Model$fileUploadDecoder);
	});
var $author$project$CWS$UploadDocuments$upldStaticNew = F7(
	function (wkflw, field, id, file, name, exp, env) {
		var oldStaticFile = file.J;
		var oldFile = A2($elm$core$Maybe$withDefault, $author$project$CWS$Model$defaultFileModel, file.J.lv);
		var newFile = _Utils_update(
			oldFile,
			{hp: exp, dz: name});
		var uploadModel = _Utils_update(
			oldStaticFile,
			{
				lv: $elm$core$Maybe$Just(newFile)
			});
		var fileType = function () {
			var _v0 = file.dA;
			if (!_v0.$) {
				var info = _v0.a;
				return info.jE;
			} else {
				return '';
			}
		}();
		return _Utils_Tuple2(
			wkflw,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A6(
						$author$project$CWS$API$File$updateStaticFile,
						env.m,
						env.f,
						uploadModel,
						fileType,
						A2(
							$author$project$CWS$UploadDocuments$Workflow_UploadFileResponse,
							$author$project$CWS$UploadDocuments$Workflow_Static(wkflw),
							A2($author$project$CWS$UploadDocuments$StaticUpload, field, id)),
						A2(
							$author$project$CWS$UploadDocuments$Workflow_UploadFileResponse,
							$author$project$CWS$UploadDocuments$Workflow_Static(wkflw),
							A2($author$project$CWS$UploadDocuments$StaticUpload, field, id)))
					])));
	});
var $author$project$CWS$UploadDocuments$updateStaticWorkflow = F3(
	function (wkflw, msg, env) {
		switch (msg.$) {
			case 2:
				var mdl = msg.a;
				var ov = A2($elm$core$Dict$get, mdl.ab, wkflw.aE);
				var od = wkflw.aE;
				var _v1 = function () {
					if (!ov.$) {
						var f = ov.a;
						return _Utils_Tuple2(
							A3(
								$elm$core$Dict$insert,
								mdl.ab,
								_Utils_update(
									f,
									{
										a: $author$project$CWS$UploadDocuments$SelectFile($elm$core$Maybe$Nothing)
									}),
								od),
							$elm$core$Maybe$Just(mdl.ab));
					} else {
						return _Utils_Tuple2(od, $elm$core$Maybe$Nothing);
					}
				}();
				var nd = _v1.a;
				var nf = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						wkflw,
						{aE: nd}),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $author$project$CWS$UploadDocuments$pickFileFor, nf)));
			case 3:
				var mdl = msg.a;
				var ov = A2($elm$core$Dict$get, mdl.ab, wkflw.aE);
				var od = wkflw.aE;
				var nd = function () {
					if (!ov.$) {
						var f = ov.a;
						return A3(
							$elm$core$Dict$insert,
							mdl.ab,
							_Utils_update(
								f,
								{
									a: $author$project$CWS$UploadDocuments$staticFileModelToState(f.J)
								}),
							od);
					} else {
						return od;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						wkflw,
						{aE: nd}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var mdl = msg.a;
				var info = msg.b;
				var ov = A2($elm$core$Dict$get, mdl.ab, wkflw.aE);
				var od = wkflw.aE;
				var _v4 = $CurrySoftware$elm_datepicker$DatePicker$init;
				var newPicker = _v4.a;
				var newPickerCmd = _v4.b;
				var nd = function () {
					if (!ov.$) {
						var f = ov.a;
						return A3(
							$elm$core$Dict$insert,
							mdl.ab,
							_Utils_update(
								f,
								{
									dA: $elm$core$Maybe$Just(info),
									bx: $elm$core$Maybe$Just(newPicker),
									a: A2($author$project$CWS$UploadDocuments$SelectExpiration, info.dz, $elm$core$Maybe$Nothing)
								}),
							od);
					} else {
						return od;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						wkflw,
						{aE: nd}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$CWS$UploadDocuments$StaticWorkflow_DatePickerMsg(mdl),
							$author$project$CWS$UploadDocuments$StaticMsg),
						newPickerCmd));
			case 6:
				var mdl = msg.a;
				var sub = msg.b;
				var ov = A2($elm$core$Dict$get, mdl.ab, wkflw.aE);
				var od = wkflw.aE;
				var _v6 = function () {
					if (!ov.$) {
						var f = ov.a;
						var ds = $CurrySoftware$elm_datepicker$DatePicker$defaultSettings;
						var _v8 = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
							A2(
								$elm$core$Maybe$map,
								function (_v9) {
									var a = _v9.a;
									var b = _v9.b;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(a),
										$elm$core$Maybe$Just(b));
								},
								A2(
									$elm$core$Maybe$map,
									A2(
										$CurrySoftware$elm_datepicker$DatePicker$update,
										_Utils_update(
											ds,
											{
												eg: $justinmimbs$date$Date$format('MM/dd/yyyy'),
												eJ: $author$project$NormalDate$fromNormalDate
											}),
										sub),
									f.bx)));
						var newPicker = _v8.a;
						var newPickerCmd = _v8.b;
						return _Utils_Tuple2(
							A3(
								$elm$core$Dict$insert,
								mdl.ab,
								_Utils_update(
									f,
									{
										bx: newPicker,
										a: function () {
											if ((!newPickerCmd.$) && (newPickerCmd.a.$ === 2)) {
												var newDate = newPickerCmd.a.a;
												var _v11 = f.a;
												if (_v11.$ === 3) {
													var name = _v11.a;
													return A2(
														$author$project$CWS$UploadDocuments$SelectExpiration,
														name,
														$elm$core$Maybe$Just(
															$author$project$NormalDate$dateToNormalString(newDate)));
												} else {
													return f.a;
												}
											} else {
												return f.a;
											}
										}()
									}),
								od),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(od, $elm$core$Platform$Cmd$none);
					}
				}();
				var nd = _v6.a;
				var nc = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						wkflw,
						{aE: nd}),
					nc);
			case 5:
				var mdl = msg.a;
				var name = msg.b;
				var exp = msg.c;
				var ov = A2($elm$core$Dict$get, mdl.ab, wkflw.aE);
				var od = wkflw.aE;
				var nd = function () {
					if (!ov.$) {
						var f = ov.a;
						return A3(
							$elm$core$Dict$insert,
							mdl.ab,
							_Utils_update(
								f,
								{
									a: A2($author$project$CWS$UploadDocuments$Uploading, name, exp)
								}),
							od);
					} else {
						return od;
					}
				}();
				if (!ov.$) {
					var f = ov.a;
					return A7(
						$author$project$CWS$UploadDocuments$upldStaticNew,
						_Utils_update(
							wkflw,
							{aE: nd}),
						'pickFileFor' + $elm$core$String$fromInt(mdl.ab),
						mdl.ab,
						f,
						name,
						exp,
						env);
				} else {
					return _Utils_Tuple2(wkflw, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(wkflw, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$UploadDocuments$updateWorkflow = F3(
	function (model, msg, env) {
		var _v0 = _Utils_Tuple2(model, msg);
		_v0$2:
		while (true) {
			switch (_v0.b.$) {
				case 0:
					if (!_v0.a.$) {
						var _static = _v0.a.a;
						var swfm = _v0.b.a;
						var _v1 = A3($author$project$CWS$UploadDocuments$updateStaticWorkflow, _static, swfm, env);
						var newSWF = _v1.a;
						var newSWFC = _v1.b;
						return _Utils_Tuple2(
							$author$project$CWS$UploadDocuments$Workflow_Static(newSWF),
							newSWFC);
					} else {
						break _v0$2;
					}
				case 3:
					var _v2 = _v0.b;
					var fromWorkflow = _v2.a;
					var uploadWorkflow = _v2.b;
					var response = _v2.c;
					return A4($author$project$CWS$UploadDocuments$handleFileResponse, model, fromWorkflow, uploadWorkflow, response);
				default:
					break _v0$2;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$fileUploadWorkflowUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = A3(
			$author$project$CWS$UploadDocuments$updateWorkflow,
			model.a.ce,
			subMsg,
			{m: model.p.m.av, f: model.f});
		var newFile = _v0.a;
		var newFileCmds = _v0.b;
		var newState = _Utils_update(
			oldState,
			{ce: newFile});
		var newModel = _Utils_update(
			model,
			{a: newState});
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$FileUploadWorkflowMsg, newFileCmds)
				]));
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$Messages$Action_Details = 1;
var $author$project$CWS$ActionDetail$AndThen_Submit = 1;
var $author$project$CWS$ActionDetail$NeedsAuth = 1;
var $author$project$CWS$ActionDetail$Step_SavedDetailsResults = $elm$core$Basics$identity;
var $author$project$CWS$ActionDetail$changeToDetailsSection = function (model) {
	var oldState = model.a;
	var newState = _Utils_update(
		oldState,
		{a$: 0});
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{a: newState}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$CWS$ActionDetail$Documents = 1;
var $author$project$CWS$ActionDetail$changeToDocumentsSection = function (model) {
	var oldState = model.a;
	var newState = _Utils_update(
		oldState,
		{a$: 1});
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{a: newState}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$CWS$ActionDetail$Map = 2;
var $author$project$CWS$ActionDetail$MapConfigured = {$: 34};
var $author$project$CWS$ActionDetail$canEdit = function (action) {
	return (!action.jf) || ((action.jf === 1) || (action.jf === 3));
};
var $author$project$CWS$DrawEditMap$Init = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$CWS$DrawEditMap$MapMessage = function (a) {
	return {$: 5, a: a};
};
var $author$project$PlugMap$Core$Options$Options = F5(
	function (target, center, zoom, maxZoom, minZoom) {
		return {g6: center, ih: maxZoom, ij: minZoom, n7: target, jY: zoom};
	});
var $author$project$PlugMap$Core$Options$defaultOptions = A5(
	$author$project$PlugMap$Core$Options$Options,
	'ol-map',
	_Utils_Tuple2(-111.6, 39.4),
	7,
	$elm$core$Maybe$Just(22),
	$elm$core$Maybe$Just(3));
var $author$project$PlugMap$Core$Options$encodeCenter = function (_v0) {
	var lat = _v0.a;
	var lon = _v0.b;
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$float,
		_List_fromArray(
			[lat, lon]));
};
var $author$project$PlugMap$Core$Options$encodeOptions = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'target',
				$elm$json$Json$Encode$string(options.n7)),
				_Utils_Tuple2(
				'center',
				$author$project$PlugMap$Core$Options$encodeCenter(options.g6)),
				_Utils_Tuple2(
				'zoom',
				$elm$json$Json$Encode$int(options.jY)),
				_Utils_Tuple2(
				'maxZoom',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, options.ih)),
				_Utils_Tuple2(
				'minZoom',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, options.ij))
			]));
};
var $author$project$PlugMap$Core$Ports$renderMapCmd = _Platform_outgoingPort('renderMapCmd', $elm$core$Basics$identity);
var $author$project$PlugMap$Core$initWithOptions = function (options) {
	var _v0 = _Utils_Tuple2(
		$elm$core$Maybe$Just(options),
		$author$project$PlugMap$Core$Options$encodeOptions(options));
	var mapOptions = _v0.a;
	var encodedOptions = _v0.b;
	var initialModel = _Utils_update(
		$author$project$PlugMap$Core$defaultModel,
		{eB: mapOptions});
	return _Utils_Tuple2(
		initialModel,
		$author$project$PlugMap$Core$Ports$renderMapCmd(encodedOptions));
};
var $author$project$PlugMap$Core$initWithDefaults = $author$project$PlugMap$Core$initWithOptions($author$project$PlugMap$Core$Options$defaultOptions);
var $author$project$PlugMap$Plugins$FeaturePicker$ReferenceLayer = F3(
	function (name, key, config) {
		return {hd: config, v: key, dz: name};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$Esri = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$Esri_Config = F6(
	function (url, tokenKey, layers, propertyNames, idField, nameField) {
		return {et: idField, h7: layers, mw: nameField, ao: propertyNames, or: tokenKey, jF: url};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$esriConfigDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'nameField',
	$elm$json$Json$Decode$string,
	'name',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'idField',
		$elm$json$Json$Decode$string,
		'id',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'propertyNames',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'layers',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'tokenKey',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'url',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$Esri_Config)))))));
var $author$project$PlugMap$Plugins$FeaturePicker$esriDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'esri',
	$author$project$PlugMap$Plugins$FeaturePicker$esriConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$Esri));
var $author$project$PlugMap$Plugins$FeaturePicker$WMS_WFS = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$WFS_Config = F6(
	function (url, tokenKey, typeNames, propertyNames, filter, responseMode) {
		return {fp: filter, ao: propertyNames, nx: responseMode, or: tokenKey, c2: typeNames, jF: url};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$XML = 0;
var $author$project$PlugMap$Plugins$FeaturePicker$EqualTo = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$equalToDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'equals',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'field',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$EqualTo)));
var $author$project$PlugMap$Plugins$FeaturePicker$filterDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$PlugMap$Plugins$FeaturePicker$equalToDecoder]));
var $author$project$PlugMap$Plugins$FeaturePicker$JSON = 1;
var $author$project$PlugMap$Plugins$FeaturePicker$wfsResponseModeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		return (a === 'JSON') ? $elm$json$Json$Decode$succeed(1) : $elm$json$Json$Decode$succeed(0);
	},
	$elm$json$Json$Decode$string);
var $author$project$PlugMap$Plugins$FeaturePicker$wfsConfigDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'mode',
	$author$project$PlugMap$Plugins$FeaturePicker$wfsResponseModeDecoder,
	0,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'filter',
		$elm$json$Json$Decode$maybe($author$project$PlugMap$Plugins$FeaturePicker$filterDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'propertyNames',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'typeNames',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'tokenKey',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'url',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$WFS_Config)))))));
var $author$project$PlugMap$Plugins$FeaturePicker$WMS_Config = F3(
	function (url, tokenKey, layers) {
		return {h7: layers, or: tokenKey, jF: url};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$wmsConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'layers',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'tokenKey',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$WMS_Config))));
var $author$project$PlugMap$Plugins$FeaturePicker$wmsWfsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'wfs',
	$author$project$PlugMap$Plugins$FeaturePicker$wfsConfigDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'wms',
		$author$project$PlugMap$Plugins$FeaturePicker$wmsConfigDecoder,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$WMS_WFS)));
var $author$project$PlugMap$Plugins$FeaturePicker$referenceLayerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'config',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[$author$project$PlugMap$Plugins$FeaturePicker$esriDecoder, $author$project$PlugMap$Plugins$FeaturePicker$wmsWfsDecoder])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$FeaturePicker$ReferenceLayer))));
var $author$project$CWS$DrawEditMap$init = F6(
	function (flags, apiset, user, spatial, flat, toolboxEnabled) {
		var dv = A2(
			$elm$json$Json$Decode$decodeValue,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['cws', 'pe', 'details', 'map', 'referenceLayers']),
				$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$FeaturePicker$referenceLayerDecoder)),
			flags);
		var refs = function () {
			if (!dv.$) {
				var reefs = dv.a;
				return reefs;
			} else {
				var err = dv.a;
				return _List_Nil;
			}
		}();
		var _v0 = $author$project$PlugMap$Core$initWithDefaults;
		var mapModel = _v0.a;
		var mapCmd = _v0.b;
		var dfm = _Utils_update(
			$author$project$CWS$DrawEditMap$defaultModel,
			{q: mapModel, c1: toolboxEnabled});
		var tb = dfm.A;
		var conf = tb.hd;
		return _Utils_Tuple2(
			$elm$core$Result$Ok(
				_Utils_update(
					dfm,
					{
						A: _Utils_update(
							tb,
							{
								hd: _Utils_update(
									conf,
									{dH: refs})
							})
					})),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$CWS$DrawEditMap$Internal,
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$MapMessage, mapCmd)),
						A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							$author$project$CWS$DrawEditMap$Internal(
								A5($author$project$CWS$DrawEditMap$Init, flags, apiset, user, spatial, flat))),
						$elm$core$Process$sleep(500))
					])));
	});
var $author$project$CWS$ActionDetail$changeToMapSection = function (model) {
	var spatial = function () {
		var _v6 = model.aZ;
		if (!_v6.b) {
			var _v7 = model.c;
			if (_v7.$ === 2) {
				var action = _v7.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (a) {
							return _List_fromArray(
								[
									{
									bH: A2(
										$elm$core$Maybe$withDefault,
										-1,
										$author$project$Fields$Shared$validityToMaybe(action.bH)),
									ab: $elm$core$Maybe$Just(1),
									jE: 'Polygon',
									bc: a.I
								}
								]);
						},
						action.I));
			} else {
				return _List_Nil;
			}
		} else {
			return model.aZ;
		}
	}();
	var peID = function () {
		var _v5 = model.a.cQ;
		if (_v5.$ === 2) {
			var pe = _v5.a;
			return pe.ab;
		} else {
			return '';
		}
	}();
	var oldState = model.a;
	var newState = _Utils_update(
		oldState,
		{a$: 2});
	var iCanEdit = function () {
		var _v4 = model.c;
		if (_v4.$ === 2) {
			var e = _v4.a;
			return $author$project$CWS$ActionDetail$canEdit(e);
		} else {
			return false;
		}
	}();
	var flat = function () {
		var _v3 = model.c;
		if (_v3.$ === 2) {
			var action = _v3.a;
			return A2(
				$elm$core$Maybe$map,
				function (a) {
					return {
						bH: A2(
							$elm$core$Maybe$withDefault,
							-1,
							$author$project$Fields$Shared$validityToMaybe(action.bH)),
						ab: $elm$core$Maybe$Just(1),
						jE: 'Polygon',
						bc: a.I
					};
				},
				action.I);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var _v0 = A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2(
			$elm$core$Result$Err('Env was not set'),
			$elm$core$Platform$Cmd$none),
		A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var a = _v1.a;
				var b = _v1.b;
				return _Utils_Tuple2(
					a,
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, b));
			},
			A2(
				$elm$core$Maybe$map,
				function (a) {
					return A6($author$project$CWS$DrawEditMap$init, a.p, a.m, a.f, spatial, flat, iCanEdit && (!(model.bd === 2)));
				},
				model.$7)));
	var mapModel = _v0.a;
	var mapCmds = _v0.b;
	if (!mapModel.$) {
		var map = mapModel.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{q: map, a: newState}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						mapCmds,
						A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$CWS$ActionDetail$MapConfigured),
						$elm$core$Process$sleep(1500))
					])));
	} else {
		var err = mapModel.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$CWS$DrawEditMap$destruct = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$CWS$ActionDetail$changeSection = F2(
	function (model, target) {
		var oldState = model.a;
		var oldTarget = oldState.a$;
		var _v0 = _Utils_Tuple2(target, oldTarget);
		switch (_v0.a) {
			case 2:
				var _v9 = _v0.a;
				return $author$project$CWS$ActionDetail$changeToMapSection(model);
			case 0:
				if (_v0.b === 2) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					var _v3 = $author$project$CWS$DrawEditMap$destruct(model.q);
					var map_Denit_Model = _v3.a;
					var map_Denit_Cmd = _v3.b;
					var nm = _Utils_update(
						model,
						{q: map_Denit_Model});
					var _v4 = $author$project$CWS$ActionDetail$changeToDetailsSection(nm);
					var nmm = _v4.a;
					var nmmc = _v4.b;
					return _Utils_Tuple2(
						nmm,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, map_Denit_Cmd),
									nmmc
								])));
				} else {
					var _v10 = _v0.a;
					return $author$project$CWS$ActionDetail$changeToDetailsSection(model);
				}
			default:
				if (_v0.b === 2) {
					var _v5 = _v0.a;
					var _v6 = _v0.b;
					var _v7 = $author$project$CWS$DrawEditMap$destruct(model.q);
					var map_Denit_Model = _v7.a;
					var map_Denit_Cmd = _v7.b;
					var nm = _Utils_update(
						model,
						{q: map_Denit_Model});
					var _v8 = $author$project$CWS$ActionDetail$changeToDocumentsSection(nm);
					var nmm = _v8.a;
					var nmmc = _v8.b;
					return _Utils_Tuple2(
						nmm,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, map_Denit_Cmd),
									nmmc
								])));
				} else {
					var _v11 = _v0.a;
					return $author$project$CWS$ActionDetail$changeToDocumentsSection(model);
				}
		}
	});
var $author$project$CWS$ActionDetail$CloseModal = 0;
var $author$project$CWS$ActionDetail$closeModal = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(
		model,
		cmd,
		$elm$core$Maybe$Just(0));
};
var $author$project$CWS$ActionDetail$delete = F2(
	function (model, env) {
		var _v0 = model.c;
		if (_v0.$ === 2) {
			var action = _v0.a;
			var actionToDelete = function () {
				var _v1 = model.a.bs;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var cat = _v2.a;
					var grp = _v2.b;
					var newGroup = _Utils_update(
						$author$project$CWS$Model$defaultGroup,
						{v: grp});
					var newCat = _Utils_update(
						$author$project$CWS$Model$defaultCategory,
						{v: cat});
					return _Utils_update(
						action,
						{bK: newCat, hM: newGroup});
				} else {
					return action;
				}
			}();
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$CWS$ActionDetail$actionAPITranslator,
				A2($author$project$CWS$API$Action$delete, actionToDelete.ab, env));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$PlugMap$Plugins$Themes$LayerKey = $elm$core$Basics$identity;
var $author$project$PlugMap$Plugins$Themes$getLayerByKey = F2(
	function (repo, _v0) {
		var key = _v0;
		return A2($elm$core$Dict$get, key, repo);
	});
var $author$project$PlugMap$Plugins$Themes$getLayer = F2(
	function (model, key) {
		return A2($author$project$PlugMap$Plugins$Themes$getLayerByKey, model.h6, key);
	});
var $author$project$CWS$ActionDetail$handleApproveClicked = F2(
	function (model, env) {
		var notes = function () {
			var _v0 = model.c;
			if (_v0.$ === 2) {
				var action = _v0.a;
				return action.cn;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var approveCmd = A2(
			$elm$core$Platform$Cmd$map,
			$author$project$CWS$ActionDetail$actionAPITranslator,
			A3($author$project$CWS$API$Action$approve, model.a.ab, notes, env));
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[approveCmd])));
	});
var $author$project$NormalDate$dateToIsoString = function (date) {
	return $elm$core$String$fromInt(
		$justinmimbs$date$Date$year(date)) + ('-' + (A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$author$project$NormalDate$monthToInt(
				$justinmimbs$date$Date$month(date)))) + ('-' + A3(
		$elm$core$String$padLeft,
		2,
		'0',
		$elm$core$String$fromInt(
			$justinmimbs$date$Date$day(date))))));
};
var $author$project$CWS$ActionDetail$handleDatePicker = F3(
	function (model, which, sub) {
		var _v0 = _Utils_Tuple3(which, model.b6, model.bM);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var picker = _v0.b.a;
					var oldState = model.a;
					var newState = _Utils_update(
						oldState,
						{am: true});
					var newCmds = $elm$core$Platform$Cmd$none;
					var _v2 = A3(
						$CurrySoftware$elm_datepicker$DatePicker$update,
						_Utils_update(
							$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
							{
								eg: $justinmimbs$date$Date$format('MM/dd/yyyy'),
								eJ: $author$project$NormalDate$fromNormalDate
							}),
						sub,
						picker);
					var newPicker = _v2.a;
					var evt = _v2.b;
					var newAction_ = function () {
						if (evt.$ === 2) {
							var newDate = evt.a;
							var _v4 = model.c;
							if (_v4.$ === 2) {
								var act = _v4.a;
								return $author$project$CWS$Model$Loaded(
									_Utils_update(
										act,
										{
											dL: $elm$core$Maybe$Just(
												$author$project$NormalDate$dateToIsoString(newDate))
										}));
							} else {
								return $author$project$CWS$Model$Loading;
							}
						} else {
							return model.c;
						}
					}();
					var newModel = _Utils_update(
						model,
						{
							c: newAction_,
							b6: $elm$core$Maybe$Just(newPicker),
							a: newState
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								aF: $author$project$CWS$ActionDetail$validate(newModel)
							}),
						newCmds);
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.c.$) {
					var _v5 = _v0.a;
					var picker = _v0.c.a;
					var oldState = model.a;
					var newState = _Utils_update(
						oldState,
						{am: true});
					var newCmds = $elm$core$Platform$Cmd$none;
					var _v6 = A3(
						$CurrySoftware$elm_datepicker$DatePicker$update,
						_Utils_update(
							$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
							{
								eg: $justinmimbs$date$Date$format('MM/dd/yyyy'),
								eJ: $author$project$NormalDate$fromNormalDate
							}),
						sub,
						picker);
					var newPicker = _v6.a;
					var evt = _v6.b;
					var newAction_ = function () {
						if (evt.$ === 2) {
							var newDate = evt.a;
							var _v8 = model.c;
							if (_v8.$ === 2) {
								var act = _v8.a;
								return $author$project$CWS$Model$Loaded(
									_Utils_update(
										act,
										{
											el: $elm$core$Maybe$Just(
												$author$project$NormalDate$dateToIsoString(newDate))
										}));
							} else {
								return $author$project$CWS$Model$Loading;
							}
						} else {
							return model.c;
						}
					}();
					var newModel = _Utils_update(
						model,
						{
							c: newAction_,
							bM: $elm$core$Maybe$Just(newPicker),
							a: newState
						});
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								aF: $author$project$CWS$ActionDetail$validate(newModel)
							}),
						newCmds);
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$ActionDetail$handleDenyClicked = F2(
	function (model, env) {
		var notes = function () {
			var _v0 = model.c;
			if (_v0.$ === 2) {
				var action = _v0.a;
				return action.cn;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var approveCmd = A2(
			$elm$core$Platform$Cmd$map,
			$author$project$CWS$ActionDetail$actionAPITranslator,
			A3($author$project$CWS$API$Action$deny, model.a.ab, notes, env));
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[approveCmd])));
	});
var $author$project$CWS$ActionDetail$doNothing = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$CWS$ActionDetail$loadedDetailsHandler = F3(
	function (model, action, env) {
		var oldState = model.a;
		var canEdt = $author$project$CWS$ActionDetail$canEdit(action);
		var _v0 = function () {
			var _v1 = model.a.cQ;
			if (_v1.$ === 2) {
				var pe = _v1.a;
				return A6(
					$author$project$CWS$UploadDocuments$init,
					pe,
					action.ab,
					$elm$core$Maybe$Just(
						pe.dz + ('-' + A2($elm$core$Maybe$withDefault, 'No Action Name', action.dz))),
					canEdt,
					canEdt,
					env);
			} else {
				return A6(
					$author$project$CWS$UploadDocuments$init,
					$author$project$CWS$Model$defaultParticipatingEntity,
					action.ab,
					$elm$core$Maybe$Just(
						'' + ('-' + A2($elm$core$Maybe$withDefault, 'No Action Name', action.dz))),
					canEdt,
					canEdt,
					env);
			}
		}();
		var newDocUpldMdl = _v0.a;
		var newDocUpldCmd = _v0.b;
		var newNewState = _Utils_update(
			oldState,
			{ab: action.ab, ba: newDocUpldMdl});
		var newModel = _Utils_update(
			model,
			{
				c: $author$project$CWS$Model$Loaded(action),
				a: newNewState
			});
		return _Utils_Tuple2(
			newModel,
			A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$UploadDocumentsMsg, newDocUpldCmd));
	});
var $author$project$CWS$ActionDetail$handleLoadedDetails = F3(
	function (model, newActionResult, env) {
		var _v0 = _Utils_Tuple2(newActionResult, model.a.cQ);
		if ((!_v0.a.$) && (_v0.b.$ === 2)) {
			var newAction_ = _v0.a.a;
			var pe = _v0.b.a;
			var peName = function () {
				var _v4 = model.a.cQ;
				if (_v4.$ === 2) {
					var pe_ = _v4.a;
					return pe_.dz;
				} else {
					return '';
				}
			}();
			var oldState = model.a;
			var oldModel = model;
			var newSpatial = function () {
				var _v3 = newAction_.I;
				if (_v3.$ === 1) {
					return _List_Nil;
				} else {
					var shape = _v3.a;
					return _List_fromArray(
						[
							{
							bH: A2(
								$elm$core$Maybe$withDefault,
								-1,
								$author$project$Fields$Shared$validityToMaybe(newAction_.bH)),
							ab: $elm$core$Maybe$Just(1),
							jE: 'Polygon',
							bc: shape.I
						}
						]);
				}
			}();
			var hasChangesState = _Utils_update(
				oldState,
				{am: false});
			var newState = hasChangesState;
			var hasChangesModel = _Utils_update(
				oldModel,
				{a: hasChangesState, aZ: newSpatial});
			var _v1 = A3($author$project$CWS$ActionDetail$loadedDetailsHandler, hasChangesModel, newAction_, env);
			var newModel = _v1.a;
			var newCommands = _v1.b;
			var _v2 = _Utils_Tuple2(model.q, $elm$core$Platform$Cmd$none);
			var newMap = _v2.a;
			var mapCmds = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{
						q: newMap,
						a: newState,
						aF: $author$project$CWS$ActionDetail$validate(newModel)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[newCommands, mapCmds])));
		} else {
			return $author$project$CWS$ActionDetail$doNothing(model);
		}
	});
var $author$project$CWS$ActionDetail$AndThen_Nothing = 0;
var $author$project$CWS$ActionDetail$editableStatus = function (action) {
	return (!action.jf) || ((action.jf === 1) || (action.jf === 3));
};
var $author$project$CWS$ActionDetail$hasChanges = function (model) {
	return model.a.am;
};
var $author$project$CWS$ActionDetail$newAction = function (action) {
	return _Utils_eq(action.ab, -1) && function () {
		var _v0 = action.dz;
		if (!_v0.$) {
			var name = _v0.a;
			return $elm$core$String$length(name) > 0;
		} else {
			return false;
		}
	}();
};
var $author$project$CWS$ActionDetail$notDeleted = function (action) {
	return !action.hn;
};
var $author$project$CWS$ActionDetail$canSave = F2(
	function (model, action) {
		return ($author$project$CWS$ActionDetail$newAction(action) || ($author$project$CWS$ActionDetail$hasChanges(model) && ($author$project$CWS$ActionDetail$notDeleted(action) && $author$project$CWS$ActionDetail$editableStatus(action)))) && (function () {
			var _v0 = action.dz;
			if (!_v0.$) {
				var name = _v0.a;
				return $elm$core$String$length(name) > 0;
			} else {
				return false;
			}
		}() && (function () {
			var _v1 = model.T;
			switch (_v1.$) {
				case 0:
					return true;
				case 3:
					return true;
				case 4:
					return true;
				default:
					return false;
			}
		}() && (!model.bX)));
	});
var $author$project$CWS$ActionDetail$NotGathered = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$CWS$ActionDetail$defaultSaveChunks = {bI: $author$project$CWS$Model$Loading, cw: $author$project$CWS$Model$Loading, cZ: $author$project$CWS$Model$Loading};
var $author$project$CWS$ActionDetail$Saved = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$CWS$ActionDetail$NotSaved = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$CWS$Model$ActionSpatial = F2(
	function (id, wkt) {
		return {ab: id, bc: wkt};
	});
var $author$project$CWS$ActionDetail$roundToTwoDigits = function (size) {
	return $elm$core$Basics$round(size * 100) / 100.0;
};
var $author$project$CWS$ActionDetail$gatherMap = F3(
	function (model, chunks, andThen) {
		var wkts = _List_Nil;
		var newCmds = $elm$core$Platform$Cmd$none;
		var gatheredWKT = $author$project$CWS$Model$Loaded(
			A2(
				$elm$core$List$map,
				function (x) {
					return A2($author$project$CWS$Model$ActionSpatial, -1, x);
				},
				wkts));
		var area = $author$project$CWS$ActionDetail$roundToTwoDigits(0);
		var gatheredSize = $author$project$CWS$Model$Loaded(
			$elm$core$Maybe$Just(area));
		var newChunks = A2(
			$author$project$CWS$ActionDetail$NotSaved,
			_Utils_update(
				chunks,
				{bI: gatheredSize, cZ: gatheredWKT}),
			andThen);
		var newModel = _Utils_update(
			model,
			{T: newChunks});
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$ActionDetail$kickOffGather = F3(
	function (model, chunks, andThen) {
		var oldDetails = function () {
			var _v6 = model.c;
			if (_v6.$ === 2) {
				var deets = _v6.a;
				return deets;
			} else {
				return $author$project$CWS$Model$blankActionModel;
			}
		}();
		var categoryKey = function () {
			var _v1 = model.c;
			if (_v1.$ === 2) {
				var action = _v1.a;
				if (_Utils_eq(action.ab, -1)) {
					var _v2 = model.a.bs;
					if (!_v2.$) {
						var _v3 = _v2.a;
						var ck = _v3.a;
						var grp = _v3.b;
						return ck;
					} else {
						return 'Something Bad Happened';
					}
				} else {
					return action.bK.v;
				}
			} else {
				var _v4 = model.a.bs;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var ck = _v5.a;
					var grp = _v5.b;
					return ck;
				} else {
					return 'Something Bad Happened';
				}
			}
		}();
		var category = {ab: -1, v: categoryKey, dz: '-1'};
		var newDetails = _Utils_update(
			oldDetails,
			{bK: category});
		var newChunks = _Utils_update(
			chunks,
			{
				cw: $author$project$CWS$Model$Loaded(newDetails)
			});
		var chunkedModel = _Utils_update(
			model,
			{
				T: A2($author$project$CWS$ActionDetail$NotSaved, newChunks, andThen)
			});
		var _v0 = A3($author$project$CWS$ActionDetail$gatherMap, chunkedModel, newChunks, andThen);
		var newModel = _v0.a;
		var mapGatherCmds = _v0.b;
		var newCmds = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[mapGatherCmds]));
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$ActionDetail$save_Action = F3(
	function (action, model, env) {
		var peId = function () {
			var _v0 = model.a.cQ;
			if (_v0.$ === 2) {
				var pe = _v0.a;
				return pe.ab;
			} else {
				return '';
			}
		}();
		var cmds = A2(
			$elm$core$Platform$Cmd$map,
			$author$project$CWS$ActionDetail$actionAPITranslator,
			A3($author$project$CWS$API$Action$save, peId, action, env));
		return _Utils_Tuple2(model, cmds);
	});
var $author$project$CWS$ActionDetail$saveChunks_Step1_SaveAction = F5(
	function (actionChunk, spatialChunk, areaChunk, model, env) {
		var oldState = model.a;
		var oldAction = actionChunk;
		var saveActionModel = oldAction;
		var newModel = _Utils_update(
			model,
			{
				c: $author$project$CWS$Model$Loaded(saveActionModel)
			});
		var _v0 = A3($author$project$CWS$ActionDetail$save_Action, saveActionModel, newModel, env);
		var model_SaveAction = _v0.a;
		var saveCmds = _v0.b;
		return _Utils_Tuple2(model_SaveAction, saveCmds);
	});
var $author$project$CWS$ActionDetail$submitableStatus = function (status) {
	return (!status) || ((status === 3) || (status === 1));
};
var $author$project$CWS$ActionDetail$canSubmit = F2(
	function (action, model) {
		return $author$project$CWS$ActionDetail$submitableStatus(action.jf) && (_Utils_eq(model.aF, $author$project$CWS$ActionDetail$Valid) && (!model.bX));
	});
var $author$project$CWS$ActionDetail$submit = F2(
	function (model, env) {
		var _v0 = model.c;
		if (_v0.$ === 2) {
			var action = _v0.a;
			if (A2($author$project$CWS$ActionDetail$canSubmit, action, model)) {
				var actionToSave = function () {
					var _v1 = model.a.bs;
					if (!_v1.$) {
						var _v2 = _v1.a;
						var cat = _v2.a;
						var grp = _v2.b;
						var newGroup = _Utils_update(
							$author$project$CWS$Model$defaultGroup,
							{v: grp});
						var newCat = _Utils_update(
							$author$project$CWS$Model$defaultCategory,
							{v: cat});
						return _Utils_update(
							action,
							{bK: newCat, hM: newGroup});
					} else {
						return action;
					}
				}();
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$CWS$ActionDetail$actionAPITranslator,
					A2($author$project$CWS$API$Action$submit, actionToSave, env));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$CWS$ActionDetail$saveCheck = F2(
	function (m, env) {
		var s1 = F2(
			function (chunks, m_) {
				var _v7 = _Utils_Tuple3(chunks.cw, chunks.cZ, chunks.bI);
				if (((_v7.a.$ === 2) && (_v7.b.$ === 2)) && (_v7.c.$ === 2)) {
					var details = _v7.a.a;
					var spatial = _v7.b.a;
					var area = _v7.c.a;
					return A5(
						$author$project$CWS$ActionDetail$saveChunks_Step1_SaveAction,
						details,
						spatial,
						function () {
							if ($elm$core$List$length(spatial) > 0) {
								return A2(
									$elm$core$Maybe$withDefault,
									$author$project$Fields$Shared$NotEntered,
									A2(
										$elm$core$Maybe$map,
										function (a) {
											return A2(
												$author$project$Fields$Shared$Valid,
												a,
												$elm$core$String$fromFloat(a));
										},
										area));
							} else {
								var _v8 = m_.c;
								if (_v8.$ === 2) {
									var a = _v8.a;
									return a.bH;
								} else {
									return $author$project$Fields$Shared$NotEntered;
								}
							}
						}(),
						m_,
						env);
				} else {
					return $author$project$CWS$ActionDetail$doNothing(m_);
				}
			});
		var _v0 = m.T;
		switch (_v0.$) {
			case 0:
				return $author$project$CWS$ActionDetail$doNothing(m);
			case 1:
				var chunks = _v0.a;
				var andThen = _v0.b;
				var _v1 = A3($author$project$CWS$ActionDetail$kickOffGather, m, chunks, andThen);
				var mod = _v1.a;
				var c = _v1.b;
				var nc = function () {
					var _v3 = mod.T;
					if (_v3.$ === 2) {
						var chk = _v3.a;
						var an_ = _v3.b;
						return chk;
					} else {
						return chunks;
					}
				}();
				var _v2 = A2(s1, nc, mod);
				var s1m = _v2.a;
				var s1c = _v2.b;
				var newCmds = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[c, s1c]));
				return _Utils_Tuple2(s1m, newCmds);
			case 2:
				var chunks = _v0.a;
				var andThen = _v0.b;
				return A2(s1, chunks, m);
			case 3:
				var chunks = _v0.a;
				var andThen = _v0.b;
				var oldState = m.a;
				var newState = _Utils_update(
					oldState,
					{am: false});
				var stateModel = _Utils_update(
					m,
					{
						T: A2($author$project$CWS$ActionDetail$Saved, chunks, andThen),
						a: newState
					});
				var _v4 = function () {
					var _v5 = chunks.cw;
					if (_v5.$ === 2) {
						var details = _v5.a;
						return A3($author$project$CWS$ActionDetail$loadedDetailsHandler, stateModel, details, env);
					} else {
						return _Utils_Tuple2(stateModel, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModelX = _v4.a;
				var newCmds = _v4.b;
				var newModel = _Utils_update(
					newModelX,
					{T: $author$project$CWS$ActionDetail$NotSaving});
				switch (andThen) {
					case 0:
						return _Utils_Tuple2(newModel, newCmds);
					case 1:
						return _Utils_Tuple2(
							newModel,
							A2($author$project$CWS$ActionDetail$submit, m, env));
					default:
						return _Utils_Tuple2(newModel, newCmds);
				}
			default:
				var error = _v0.a;
				var andThen = _v0.b;
				return $author$project$CWS$ActionDetail$doNothing(m);
		}
	});
var $author$project$CWS$ActionDetail$saveClickedNew = F3(
	function (model, andThen, env) {
		var startArea = function () {
			var _v1 = model.c;
			if (_v1.$ === 2) {
				var action = _v1.a;
				var _v2 = $author$project$Fields$Shared$validityToMaybe(action.bH);
				if (!_v2.$) {
					var x = _v2.a;
					return $author$project$CWS$Model$Loaded(
						$elm$core$Maybe$Just(x));
				} else {
					return $author$project$CWS$Model$Loading;
				}
			} else {
				return $author$project$CWS$Model$Loading;
			}
		}();
		var sc = _Utils_update(
			$author$project$CWS$ActionDetail$defaultSaveChunks,
			{bI: startArea});
		var newModel = _Utils_update(
			model,
			{
				T: A2($author$project$CWS$ActionDetail$NotGathered, sc, andThen)
			});
		var newCmds = $elm$core$Platform$Cmd$none;
		var _v0 = A2($author$project$CWS$ActionDetail$saveCheck, newModel, env);
		var saveCheckModel = _v0.a;
		var saveCheckCmd = _v0.b;
		return _Utils_Tuple2(
			saveCheckModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[newCmds, saveCheckCmd])));
	});
var $author$project$CWS$ActionDetail$handleSaveClicked = F2(
	function (model, env) {
		var _v0 = model.c;
		if (_v0.$ === 2) {
			var action = _v0.a;
			if (A2($author$project$CWS$ActionDetail$canSave, model, action)) {
				var fixedAction = _Utils_update(
					action,
					{
						W: $elm$core$Maybe$Just(model.W)
					});
				var newModel = _Utils_update(
					model,
					{
						c: $author$project$CWS$Model$Loaded(fixedAction)
					});
				return A3($author$project$CWS$ActionDetail$saveClickedNew, newModel, 0, env);
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$ActionDetail$SaveError = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$CWS$ActionDetail$errorSaving = function (error) {
	return A2($author$project$CWS$ActionDetail$SaveError, error, 0);
};
var $author$project$PlugMap$Plugins$Drawing$encodeWKTSrc = function (src) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(src.ab)),
				_Utils_Tuple2(
				'wkt',
				$elm$json$Json$Encode$string(src.bc))
			]));
};
var $author$project$PlugMap$Plugins$Drawing$setWKTs = _Platform_outgoingPort('setWKTs', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Drawing$setWKTsAsSource = F3(
	function (model, wkts, clr) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					am: false,
					c6: A2(
						$elm$core$List$map,
						function ($) {
							return $.bc;
						},
						wkts)
				}),
			$author$project$PlugMap$Plugins$Drawing$setWKTs(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'clear',
							$elm$json$Json$Encode$bool(clr)),
							_Utils_Tuple2(
							'wkts',
							A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Drawing$encodeWKTSrc, wkts))
						]))));
	});
var $author$project$PlugMap$Plugins$Drawing$enableModify = _Platform_outgoingPort(
	'enableModify',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$Drawing$enableModifyDrawn = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$PlugMap$Plugins$Drawing$enableModify(0));
};
var $author$project$CWS$DrawEditMap$startEditing = function (model) {
	var _v0 = $author$project$PlugMap$Plugins$Drawing$enableModifyDrawn(model.o);
	var nd = _v0.a;
	var nc = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{o: nd, hr: true}),
		A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, nc));
};
var $author$project$CWS$DrawEditMap$Reference = {$: 3};
var $author$project$CWS$DrawEditMap$SetLayer = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$hideReferenceLayerDisplay = _Platform_outgoingPort(
	'hideReferenceLayerDisplay',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$FeaturePicker$destruct = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$PlugMap$Plugins$FeaturePicker$hideReferenceLayerDisplay(0));
};
var $author$project$PlugMap$Plugins$Drawing$disableDraw = _Platform_outgoingPort(
	'disableDraw',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$Drawing$disableDrawDrawn = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$PlugMap$Plugins$Drawing$disableDraw(0));
};
var $author$project$PlugMap$Plugins$Drawing$disableModify = _Platform_outgoingPort(
	'disableModify',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$Drawing$disableModifyDrawn = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$PlugMap$Plugins$Drawing$disableModify(0));
};
var $author$project$CWS$DrawEditMap$stopEditing = function (model) {
	var ex = _Utils_eq(model.H, $author$project$CWS$DrawEditMap$Reference) ? A2(
		$elm$core$Task$perform,
		$elm$core$Basics$always(
			$author$project$CWS$DrawEditMap$Internal(
				$author$project$CWS$DrawEditMap$SetLayer($elm$core$Maybe$Nothing))),
		$elm$core$Task$succeed('Hi')) : $elm$core$Platform$Cmd$none;
	var _v0 = $author$project$PlugMap$Plugins$Drawing$disableModifyDrawn(model.o);
	var nnd = _v0.a;
	var nnc = _v0.b;
	var _v1 = $author$project$PlugMap$Plugins$Drawing$disableDrawDrawn(nnd);
	var nd = _v1.a;
	var nc = _v1.b;
	var _v2 = $author$project$PlugMap$Plugins$FeaturePicker$destruct(model.e.N);
	var fpModel = _v2.a;
	var fpCmd = _v2.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{o: nd, hr: false}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, nc),
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, nnc),
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, fpCmd),
					ex
				])));
};
var $author$project$CWS$DrawEditMap$initSpatial = F3(
	function (model, spatial, flat) {
		var tb = model.A;
		var _v0 = A3(
			$author$project$PlugMap$Plugins$Drawing$setWKTsAsSource,
			model.A.o,
			A2(
				$elm$core$List$map,
				function (a) {
					return {
						ab: A2($elm$core$Maybe$withDefault, 0, a.ab),
						bc: a.bc
					};
				},
				spatial),
			true);
		var dm = _v0.a;
		var dmc = _v0.b;
		var _v1 = (model.c1 ? $author$project$CWS$DrawEditMap$startEditing : $author$project$CWS$DrawEditMap$stopEditing)(
			_Utils_update(
				tb,
				{o: dm, ay: flat, cZ: spatial}));
		var toybox = _v1.a;
		var tbc = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{A: toybox}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, dmc),
						tbc
					])));
	});
var $author$project$CWS$ActionDetail$handleStepSavedDetailResults = F2(
	function (model, result) {
		var _v0 = model.T;
		if (_v0.$ === 2) {
			var chunks = _v0.a;
			var andThen = _v0.b;
			if (!result.$) {
				var action = result.a;
				var oldState = model.a;
				var oldChunks = function () {
					var _v8 = model.T;
					if (_v8.$ === 2) {
						var chk = _v8.a;
						var an_ = _v8.b;
						return chk;
					} else {
						return $author$project$CWS$ActionDetail$defaultSaveChunks;
					}
				}();
				var newState = _Utils_update(
					oldState,
					{ab: action.ab});
				var newSpatial = function () {
					var _v7 = action.I;
					if (!_v7.$) {
						var shape = _v7.a;
						return _List_fromArray(
							[
								{ab: shape.ab, bc: shape.I}
							]);
					} else {
						return _List_Nil;
					}
				}();
				var newSpat = A2(
					$elm$core$Maybe$map,
					function (shape) {
						return {
							bH: A2(
								$elm$core$Maybe$withDefault,
								-1,
								$author$project$Fields$Shared$validityToMaybe(action.bH)),
							ab: $elm$core$Maybe$Just(1),
							jE: 'Polygon',
							bc: shape.I
						};
					},
					action.I);
				var newNewSpatial = function () {
					var _v6 = action.I;
					if (!_v6.$) {
						var shape = _v6.a;
						return _List_fromArray(
							[shape.I]);
					} else {
						return _List_Nil;
					}
				}();
				var newCmds = $elm$core$Platform$Cmd$none;
				var newChunks = _Utils_update(
					oldChunks,
					{
						cw: $author$project$CWS$Model$Loaded(action)
					});
				var newModel = _Utils_update(
					model,
					{
						c: $author$project$CWS$Model$Loaded(action),
						T: A2($author$project$CWS$ActionDetail$Saved, newChunks, andThen),
						a: newState,
						aZ: function () {
							if (newSpat.$ === 1) {
								return _List_Nil;
							} else {
								var shape = newSpat.a;
								return _List_fromArray(
									[shape]);
							}
						}()
					});
				var _v2 = function (_v4) {
					var a = _v4.a;
					var b = _v4.b;
					return _Utils_Tuple2(
						a,
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, b));
				}(
					A3(
						$author$project$CWS$DrawEditMap$initSpatial,
						model.q,
						function () {
							if (newSpat.$ === 1) {
								return _List_Nil;
							} else {
								var shape = newSpat.a;
								return _List_fromArray(
									[shape]);
							}
						}(),
						newSpat));
				var newMap = _v2.a;
				var newMapCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						newModel,
						{q: newMap}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[newCmds, newMapCmd])));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							T: $author$project$CWS$ActionDetail$errorSaving('Error saving details')
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return $author$project$CWS$ActionDetail$doNothing(model);
		}
	});
var $author$project$CWS$ActionDetail$handleSaveStep = F3(
	function (model, step, env) {
		var _v0 = function () {
			var results = step;
			return A2($author$project$CWS$ActionDetail$handleStepSavedDetailResults, model, results);
		}();
		var handledModel = _v0.a;
		var handledCmd = _v0.b;
		var _v2 = A2($author$project$CWS$ActionDetail$saveCheck, handledModel, env);
		var saveCheckModel = _v2.a;
		var saveCheckCmd = _v2.b;
		return _Utils_Tuple2(
			saveCheckModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[handledCmd, saveCheckCmd])));
	});
var $author$project$CWS$ActionDetail$handleSavedDetails = F3(
	function (model, result, env) {
		var _v0 = A3($author$project$CWS$ActionDetail$handleLoadedDetails, model, result, env);
		var loadedModel = _v0.a;
		var loadedCmds = _v0.b;
		var oldState = loadedModel.a;
		var newState = oldState;
		var _v1 = function () {
			if (model.a.a$ === 2) {
				return _Utils_Tuple3(loadedModel, loadedModel.q, $elm$core$Platform$Cmd$none);
			} else {
				var wkts = _List_fromArray(
					['']);
				var nm = loadedModel;
				var newSpatial = A2(
					$elm$core$List$map,
					function (x) {
						return A2($author$project$CWS$Model$ActionSpatial, loadedModel.a.ab, x);
					},
					wkts);
				return _Utils_Tuple3(nm, loadedModel.q, $elm$core$Platform$Cmd$none);
			}
		}();
		var mmodel = _v1.a;
		var mapModel = _v1.b;
		var extraCmds = _v1.c;
		var newModel = _Utils_update(
			mmodel,
			{q: mapModel, a: newState});
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[loadedCmds, extraCmds])));
	});
var $author$project$CWS$ActionDetail$CancelSubmit = function (a) {
	return {$: 27, a: a};
};
var $author$project$CWS$ActionDetail$ConfirmSubmit = function (a) {
	return {$: 26, a: a};
};
var $author$project$CWS$Model$RequestDynAlert = F6(
	function (a, b, c, d, e, f) {
		return {$: 2, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$CWS$ActionDetail$getValidationMessage = function (issues) {
	var _v0 = issues.fo;
	if (_v0.$ === 1) {
		var results = _v0.a;
		return 'Please fill out the following fields: ' + A2($elm$core$String$join, ', ', results.fK);
	} else {
		return '';
	}
};
var $author$project$CWS$ActionDetail$handleSubmitClicked = function (inModel) {
	var validation = $author$project$CWS$ActionDetail$validate(inModel);
	var modelAction = function () {
		var _v2 = inModel.c;
		if (_v2.$ === 2) {
			var a = _v2.a;
			return a;
		} else {
			return $author$project$CWS$Model$blankActionModel;
		}
	}();
	var fixedAction1 = _Utils_update(
		modelAction,
		{
			W: $elm$core$Maybe$Just(inModel.W)
		});
	var model = _Utils_update(
		inModel,
		{
			c: $author$project$CWS$Model$Loaded(fixedAction1),
			aF: validation
		});
	switch (validation.$) {
		case 1:
			var oldState = model;
			var details = function () {
				var _v1 = model.c;
				if (_v1.$ === 2) {
					var e = _v1.a;
					return e;
				} else {
					return $author$project$CWS$Model$blankActionModel;
				}
			}();
			var newState = A2($author$project$CWS$ActionDetail$canSubmit, details, inModel) ? _Utils_update(
				oldState,
				{
					aJ: A8($author$project$CWS$Model$RequestDynConfirmation, 'Confirm Submit', 'Are you sure you want to proceed?', 'After submitting this action you will not be able to edit it and it will be reviewed by FFSL. Until approved, costs will not be calculated towards your Participation Commitment.', 'Yes', $author$project$CWS$ActionDetail$ConfirmSubmit, 'No', $author$project$CWS$ActionDetail$CancelSubmit, 0)
				}) : oldState;
			return _Utils_Tuple2(newState, $elm$core$Platform$Cmd$none);
		case 2:
			var issues = validation.a;
			var oldState = model;
			var msg = $author$project$CWS$ActionDetail$getValidationMessage(issues);
			var newState = _Utils_update(
				oldState,
				{
					aJ: A6($author$project$CWS$Model$RequestDynAlert, 'Cannot Submit Action', msg, 'Unable to submit due to incomplete information provided', 'Ok', $author$project$CWS$ActionDetail$CancelSubmit, 0)
				});
			return _Utils_Tuple2(newState, $elm$core$Platform$Cmd$none);
		default:
			return $author$project$CWS$ActionDetail$doNothing(model);
	}
};
var $author$project$CWS$ActionDetail$mapUpdating = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{bX: true}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$CWS$ActionDetail$noOut = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple3(model, cmd, $elm$core$Maybe$Nothing);
};
var $author$project$PlugMap$Plugins$Themes$EsriExportLayer = function (a) {
	return {$: 3, a: a};
};
var $author$project$PlugMap$Plugins$Themes$Multiple = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$ActionDetail$peActionLayer = F2(
	function (pe, layer) {
		var _v0 = layer.hd;
		if (_v0.$ === 3) {
			var exp = _v0.a;
			var ep = $author$project$PlugMap$Plugins$Themes$Multiple(
				function () {
					var _v1 = exp.lh;
					if (!_v1.$) {
						var e = _v1.a;
						return _List_fromArray(
							[
								_Utils_update(
								e,
								{
									mc: $elm$core$Maybe$Just('{\"2\":\"participatingEntityId=\'' + (pe.ab + ('\'\",\"1\":\"participatingEntityId=\'' + (pe.ab + '\'\"}'))))
								})
							]);
					} else {
						var m = _v1.a;
						return A2(
							$elm$core$List$map,
							function (e) {
								return _Utils_update(
									e,
									{
										mc: $elm$core$Maybe$Just('{\"1\":\"participatingEntityId=\'' + (pe.ab + ('\'\",\"0\":\"participatingEntityId=\'' + (pe.ab + '\'\"}'))))
									});
							},
							m);
					}
				}());
			return _Utils_update(
				layer,
				{
					hd: $author$project$PlugMap$Plugins$Themes$EsriExportLayer(
						_Utils_update(
							exp,
							{lh: ep}))
				});
		} else {
			return layer;
		}
	});
var $author$project$CWS$API$Action$NeedsAuth = {$: 10};
var $author$project$CWS$API$Action$update = F2(
	function (model, msg) {
		if (!msg.$) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var request = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						b3: _Utils_ap(
							model.b3,
							_List_fromArray(
								[request]))
					}),
				A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always($author$project$CWS$API$Action$NeedsAuth),
					$elm$core$Task$succeed('')));
		}
	});
var $author$project$CWS$DrawEditMap$Msg_Themes = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$DrawEditMap$PluginMessage = function (a) {
	return {$: 8, a: a};
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$PlugMap$Plugins$Themes$encodeMap = function (param) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'query',
				$elm$json$Json$Encode$string(param.iK)),
				_Utils_Tuple2(
				'values',
				A2($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string)(param.jJ))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeIdentifyField = function (idf) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(idf.dz)),
				function () {
				var _v0 = idf.lu;
				switch (_v0.$) {
					case 0:
						var param = _v0.a;
						return _Utils_Tuple2(
							'query',
							$elm$json$Json$Encode$string(param));
					case 1:
						var param = _v0.a;
						return _Utils_Tuple2(
							'static',
							$elm$json$Json$Encode$string(param));
					default:
						var param = _v0.a;
						return _Utils_Tuple2(
							'map',
							$author$project$PlugMap$Plugins$Themes$encodeMap(param));
				}
			}()
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeIdentifyDataMapping = function (idm) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fields',
				A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Themes$encodeIdentifyField, idm.hA))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeIdentify = function (id) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'enabled',
				$elm$json$Json$Encode$bool(id.ax)),
				_Utils_Tuple2(
				'dataMapping',
				$author$project$PlugMap$Plugins$Themes$encodeIdentifyDataMapping(id.hi)),
				_Utils_Tuple2(
				'canViewDetails',
				$elm$json$Json$Encode$bool(id.g5)),
				_Utils_Tuple2(
				'queryLayerIds',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$list($elm$json$Json$Encode$int),
						id.iL))),
				_Utils_Tuple2(
				'tolerance',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, id.ju))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeEndpoint = function (endpoint) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(endpoint.jF)),
				_Utils_Tuple2(
				'zIndex',
				$elm$json$Json$Encode$int(endpoint.gD)),
				_Utils_Tuple2(
				'tokenKey',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, endpoint.or)),
				_Utils_Tuple2(
				'layersToShow',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, endpoint.h8)),
				_Utils_Tuple2(
				'layerDefs',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, endpoint.mc)),
				_Utils_Tuple2(
				'bbox',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, endpoint.gU))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeEndpoints = function (urlTemplates) {
	if (!urlTemplates.$) {
		var url = urlTemplates.a;
		return A2(
			$elm$json$Json$Encode$list,
			$author$project$PlugMap$Plugins$Themes$encodeEndpoint,
			_List_fromArray(
				[url]));
	} else {
		var urls = urlTemplates.a;
		return A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Themes$encodeEndpoint, urls);
	}
};
var $author$project$PlugMap$Plugins$Themes$encodeExtent = function (extent) {
	return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, extent);
};
var $author$project$PlugMap$Plugins$Themes$encodeEsriExportLayer = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'endpoints',
				$author$project$PlugMap$Plugins$Themes$encodeEndpoints(config.lh)),
				_Utils_Tuple2(
				'extent',
				$author$project$PlugMap$Plugins$Themes$encodeExtent(config.cy))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeWMSEndpoint = function (endpoint) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(endpoint.jF)),
				_Utils_Tuple2(
				'tokenKey',
				$elm$json$Json$Encode$string(endpoint.or)),
				_Utils_Tuple2(
				'layers',
				$elm$json$Json$Encode$list($elm$json$Json$Encode$string)(endpoint.h7)),
				_Utils_Tuple2(
				'propertyNames',
				$elm$json$Json$Encode$list($elm$json$Json$Encode$string)(endpoint.ao)),
				_Utils_Tuple2(
				'nameField',
				$elm$json$Json$Encode$string(endpoint.mw)),
				_Utils_Tuple2(
				'idField',
				$elm$json$Json$Encode$string(endpoint.et))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeWMSEndpoints = function (endpoints) {
	return A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Themes$encodeWMSEndpoint, endpoints);
};
var $author$project$PlugMap$Plugins$Themes$encodeWMSLayer = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'endpoints',
				$author$project$PlugMap$Plugins$Themes$encodeWMSEndpoints(config.lh)),
				_Utils_Tuple2(
				'extent',
				$author$project$PlugMap$Plugins$Themes$encodeExtent(config.cy))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeWMTSLayer = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'endpoints',
				$author$project$PlugMap$Plugins$Themes$encodeEndpoints(config.lh)),
				_Utils_Tuple2(
				'extent',
				$author$project$PlugMap$Plugins$Themes$encodeExtent(config.cy))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeXYZLayer = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'endpoints',
				$author$project$PlugMap$Plugins$Themes$encodeEndpoints(config.lh)),
				_Utils_Tuple2(
				'maxZoom',
				$elm$json$Json$Encode$int(config.ih)),
				_Utils_Tuple2(
				'minZoom',
				$elm$json$Json$Encode$int(config.ij))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeLayerConfig = function (config_) {
	var _v0 = function () {
		switch (config_.$) {
			case 0:
				var config = config_.a;
				return _Utils_Tuple2(
					'xyz',
					$author$project$PlugMap$Plugins$Themes$encodeXYZLayer(config));
			case 1:
				var config = config_.a;
				return _Utils_Tuple2(
					'wmts',
					$author$project$PlugMap$Plugins$Themes$encodeWMTSLayer(config));
			case 2:
				var config = config_.a;
				return _Utils_Tuple2(
					'wms',
					$author$project$PlugMap$Plugins$Themes$encodeWMSLayer(config));
			default:
				var config = config_.a;
				return _Utils_Tuple2(
					'esriExport',
					$author$project$PlugMap$Plugins$Themes$encodeEsriExportLayer(config));
		}
	}();
	var type_ = _v0.a;
	var encoder = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(type_)),
				_Utils_Tuple2('value', encoder)
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeLayerKey = function (_v0) {
	var key = _v0;
	return $elm$json$Json$Encode$string(key);
};
var $author$project$PlugMap$Plugins$Themes$encodeLayer = function (layer) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$author$project$PlugMap$Plugins$Themes$encodeLayerKey(layer.v)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(layer.dz)),
				_Utils_Tuple2(
				'opacity',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$float, layer.iq)),
				_Utils_Tuple2(
				'config',
				$author$project$PlugMap$Plugins$Themes$encodeLayerConfig(layer.hd)),
				_Utils_Tuple2(
				'identify',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$PlugMap$Plugins$Themes$encodeIdentify, layer.lQ)))
			]));
};
var $author$project$PlugMap$Plugins$Themes$layerKeyToString = function (_v0) {
	var key = _v0;
	return key;
};
var $author$project$PlugMap$Plugins$Themes$updateLayerCmd = _Platform_outgoingPort('updateLayerCmd', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Themes$updateLayer = F2(
	function (model, layer) {
		var d = A3(
			$elm$core$Dict$insert,
			$author$project$PlugMap$Plugins$Themes$layerKeyToString(layer.v),
			layer,
			model.h6);
		var nm = _Utils_update(
			model,
			{h6: d});
		return _Utils_Tuple2(
			nm,
			$author$project$PlugMap$Plugins$Themes$updateLayerCmd(
				$author$project$PlugMap$Plugins$Themes$encodeLayer(layer)));
	});
var $author$project$CWS$DrawEditMap$updateLayer = F2(
	function (model, layer) {
		var _v0 = A2($author$project$PlugMap$Plugins$Themes$updateLayer, model.om, layer);
		var tm = _v0.a;
		var tc = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{om: tm}),
			A2(
				$elm$core$Platform$Cmd$map,
				function (a) {
					return $author$project$CWS$DrawEditMap$Internal(
						$author$project$CWS$DrawEditMap$PluginMessage(
							$author$project$CWS$DrawEditMap$Msg_Themes(a)));
				},
				tc));
	});
var $author$project$PlugMap$Plugins$Themes$CategoryKey = $elm$core$Basics$identity;
var $author$project$CWS$DrawEditMap$ClearColor = {$: 16};
var $author$project$PlugMap$Plugins$Themes$encodeCategoryKey = function (_v0) {
	var key = _v0;
	return $elm$json$Json$Encode$string(key);
};
var $author$project$PlugMap$Plugins$Themes$encodeSelection = function (selection) {
	switch (selection.$) {
		case 0:
			var maybeKey = selection.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'selection_type',
						$elm$json$Json$Encode$string('monoselection')),
						_Utils_Tuple2(
						'selection_key',
						A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$PlugMap$Plugins$Themes$encodeLayerKey, maybeKey))
					]));
		case 1:
			var keys = selection.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'selection_type',
						$elm$json$Json$Encode$string('polyselection')),
						_Utils_Tuple2(
						'selection_keys',
						A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Themes$encodeLayerKey, keys))
					]));
		case 2:
			var key = selection.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'selection_type',
						$elm$json$Json$Encode$string('monoselection')),
						_Utils_Tuple2(
						'selection_key',
						$author$project$PlugMap$Plugins$Themes$encodeLayerKey(key))
					]));
		default:
			var headKey = selection.a;
			var tailKeys = selection.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'selection_type',
						$elm$json$Json$Encode$string('polyselection')),
						_Utils_Tuple2(
						'selection_keys',
						A2(
							$elm$json$Json$Encode$list,
							$author$project$PlugMap$Plugins$Themes$encodeLayerKey,
							A2($elm$core$List$cons, headKey, tailKeys)))
					]));
	}
};
var $author$project$PlugMap$Plugins$Themes$encodeCategorySelection = function (category) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'category_key',
				$author$project$PlugMap$Plugins$Themes$encodeCategoryKey(category.v)),
				_Utils_Tuple2(
				'selection',
				$author$project$PlugMap$Plugins$Themes$encodeSelection(category.bB))
			]));
};
var $author$project$PlugMap$Plugins$Themes$encodeSelectedThemes = function (model) {
	return A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Themes$encodeCategorySelection, model.F);
};
var $author$project$PlugMap$Core$Ports$fitToWktCmd = _Platform_outgoingPort('fitToWktCmd', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Themes$getCategoryByKey = F2(
	function (model, key) {
		return A2(
			$elm$core$List$filter,
			function (a) {
				return _Utils_eq(a.v, key);
			},
			model.F);
	});
var $author$project$PlugMap$Plugins$Themes$getGroupByKey = F2(
	function (repo, _v0) {
		var key = _v0;
		return A2($elm$core$Dict$get, key, repo);
	});
var $author$project$PlugMap$Plugins$Themes$groupHasLayer = F2(
	function (key, group) {
		return A2($elm$core$List$member, key, group.h7);
	});
var $author$project$PlugMap$Plugins$Themes$categoryHasLayer = F3(
	function (key, category, model) {
		return A2(
			$elm$core$List$any,
			$author$project$PlugMap$Plugins$Themes$groupHasLayer(key),
			A2(
				$elm$core$List$filterMap,
				$author$project$PlugMap$Plugins$Themes$getGroupByKey(model.cF),
				category.ex));
	});
var $author$project$PlugMap$Plugins$Themes$getCategoryFromLayerKey = F2(
	function (model, key) {
		return A2(
			$elm$core$List$filter,
			function (c) {
				return A3($author$project$PlugMap$Plugins$Themes$categoryHasLayer, key, c, model);
			},
			model.F);
	});
var $author$project$CWS$DrawEditMap$InitSpatial = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$CWS$DrawEditMap$Ready = 1;
var $author$project$CWS$DrawEditMap$ErrorLoadingServices = {$: 2};
var $author$project$CWS$DrawEditMap$handleErrorLoadMapServices = function (res) {
	return $author$project$CWS$DrawEditMap$ErrorLoadingServices;
};
var $author$project$CWS$DrawEditMap$NoOp = {$: 0};
var $author$project$CWS$DrawEditMap$UpdateServices = function (a) {
	return {$: 9, a: a};
};
var $author$project$CWS$DrawEditMap$handleLoadMapServices = function (res) {
	if (!res.$) {
		var services = res.a;
		return $author$project$CWS$DrawEditMap$Internal(
			$author$project$CWS$DrawEditMap$UpdateServices(services));
	} else {
		return $author$project$CWS$DrawEditMap$Internal($author$project$CWS$DrawEditMap$NoOp);
	}
};
var $author$project$PlugMap$Plugins$ColorUnderPointer$ColorUnderPointerOptions = function (layers) {
	return {h7: layers};
};
var $author$project$PlugMap$Plugins$ColorUnderPointer$enableColorUnderPointerCmd = _Platform_outgoingPort('enableColorUnderPointerCmd', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$ColorUnderPointer$encodeColorUnderPointerOptions = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'layers',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.h7))
			]));
};
var $author$project$PlugMap$Plugins$ColorUnderPointer$init = function (layersToWatch) {
	return _Utils_Tuple2(
		$author$project$PlugMap$Plugins$ColorUnderPointer$Model,
		$author$project$PlugMap$Plugins$ColorUnderPointer$enableColorUnderPointerCmd(
			$author$project$PlugMap$Plugins$ColorUnderPointer$encodeColorUnderPointerOptions(
				$author$project$PlugMap$Plugins$ColorUnderPointer$ColorUnderPointerOptions(layersToWatch))));
};
var $author$project$PlugMap$Plugins$Drawing$encodeOptions = function (options) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'enableMultishape',
				$elm$json$Json$Encode$bool(options.fk))
			]));
};
var $author$project$PlugMap$Plugins$Drawing$initDrawingCmd = _Platform_outgoingPort('initDrawingCmd', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Drawing$wrapId = F2(
	function (id, val) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id)),
					_Utils_Tuple2('data', val)
				]));
	});
var $author$project$PlugMap$Plugins$Drawing$init = _Utils_Tuple2(
	$author$project$PlugMap$Plugins$Drawing$defaultModel,
	$elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$PlugMap$Plugins$Drawing$initDrawingCmd(
				A2(
					$author$project$PlugMap$Plugins$Drawing$wrapId,
					'moop',
					$author$project$PlugMap$Plugins$Drawing$encodeOptions($author$project$PlugMap$Plugins$Drawing$defaultOptions)))
			])));
var $author$project$PlugMap$Plugins$Identify$enableIdentify = _Platform_outgoingPort('enableIdentify', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Identify$init = function (layers) {
	var filteredLayers = A2(
		$elm$core$List$filter,
		function (layer) {
			return !_Utils_eq(layer.lQ, $elm$core$Maybe$Nothing);
		},
		layers);
	return _Utils_Tuple2(
		_Utils_update(
			$author$project$PlugMap$Plugins$Identify$defaultModel,
			{h7: filteredLayers}),
		$author$project$PlugMap$Plugins$Identify$enableIdentify(
			A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Themes$encodeLayer, filteredLayers)));
};
var $author$project$PlugMap$Plugins$Themes$addThemesCmd = _Platform_outgoingPort('addThemesCmd', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Themes$encodeCategory = F2(
	function (model, category) {
		var layers = A2(
			$elm$core$List$filterMap,
			$author$project$PlugMap$Plugins$Themes$getLayerByKey(model.h6),
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.h7;
				},
				A2(
					$elm$core$List$filterMap,
					$author$project$PlugMap$Plugins$Themes$getGroupByKey(model.cF),
					category.ex)));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category_key',
					$author$project$PlugMap$Plugins$Themes$encodeCategoryKey(category.v)),
					_Utils_Tuple2(
					'opacity',
					$elm$json$Json$Encode$float(category.bE)),
					_Utils_Tuple2(
					'layers',
					A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Themes$encodeLayer, layers)),
					_Utils_Tuple2(
					'selection',
					$author$project$PlugMap$Plugins$Themes$encodeSelection(category.bB))
				]));
	});
var $author$project$PlugMap$Plugins$Themes$encodeThemes = function (model) {
	return A2(
		$elm$json$Json$Encode$list,
		$author$project$PlugMap$Plugins$Themes$encodeCategory(model),
		model.F);
};
var $author$project$PlugMap$Plugins$Themes$Model = F3(
	function (layerRepo, layerGroupRepo, layerCategories) {
		return {F: layerCategories, cF: layerGroupRepo, h6: layerRepo};
	});
var $author$project$PlugMap$Plugins$Themes$LayerCategory = function (key) {
	return function (name) {
		return function (selection) {
			return function (multiphasic) {
				return function (transparency) {
					return function (openness) {
						return function (usesRasterLegend) {
							return function (activeIcon) {
								return function (infoIcon) {
									return function (layerGroups) {
										return {j$: activeIcon, lV: infoIcon, v: key, ex: layerGroups, mv: multiphasic, dz: name, b_: openness, bB: selection, bE: transparency, jI: usesRasterLegend};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$PlugMap$Plugins$Themes$categoryKeyDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
	$elm$json$Json$Decode$string);
var $author$project$PlugMap$Plugins$Themes$GroupKey = $elm$core$Basics$identity;
var $author$project$PlugMap$Plugins$Themes$groupKeyDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
	$elm$json$Json$Decode$string);
var $author$project$PlugMap$Plugins$Themes$Icon = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMap$Plugins$Themes$Img = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$Themes$NoImage = {$: 0};
var $author$project$PlugMap$Plugins$Themes$linkImageDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'iconImg',
			A2($elm$json$Json$Decode$map, $author$project$PlugMap$Plugins$Themes$Img, $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$field,
			'iconClass',
			A2($elm$json$Json$Decode$map, $author$project$PlugMap$Plugins$Themes$Icon, $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$NoImage)
		]));
var $author$project$PlugMap$Plugins$Themes$Closed = 1;
var $author$project$PlugMap$Plugins$Themes$Open = 0;
var $author$project$PlugMap$Plugins$Themes$opennessDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (openness) {
		switch (openness) {
			case 'open':
				return $elm$json$Json$Decode$succeed(0);
			case 'closed':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('PlugMap.Plugins.Themes.opennessDecoder :: invalid configuration value. Must be either \'open\' or \'closed\'.');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PlugMap$Plugins$Themes$EnforcedMonoselection = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMap$Plugins$Themes$EnforcedPolyselection = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$PlugMap$Plugins$Themes$Monoselection = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$Themes$Polyselection = function (a) {
	return {$: 1, a: a};
};
var $elm_community$json_extra$Json$Decode$Extra$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$PlugMap$Plugins$Themes$layerKeyDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$PlugMap$Plugins$Themes$Monoselective = 0;
var $author$project$PlugMap$Plugins$Themes$Polyselective = 1;
var $author$project$PlugMap$Plugins$Themes$selectivenessDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (selectiveness) {
		switch (selectiveness) {
			case 'monoselective':
				return $elm$json$Json$Decode$succeed(0);
			case 'polyselective':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('PlugMap.Plugins.Themes.selectivenessDecoder :: invalid configuration value. Must be either \'monoselective\' or \'polyselective\'.');
		}
	},
	$elm$json$Json$Decode$string);
var $elm_community$json_extra$Json$Decode$Extra$withDefault = F2(
	function (fallback, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(fallback),
			$elm$json$Json$Decode$maybe(decoder));
	});
var $author$project$PlugMap$Plugins$Themes$selectionDecoder = function () {
	var toSelection = F3(
		function (selectiveness, mustHave, defaults) {
			var errMsg = 'PlugMap.Plugins.Themes.selectionDecoder :: invalid configuration value. If a Layer Category has \'mustHaveSelection=true\' then it must also have a valid \'defaultSelection\' set.';
			var _v0 = _Utils_Tuple2(selectiveness, mustHave);
			if (!_v0.a) {
				if (!_v0.b) {
					var _v1 = _v0.a;
					if (!defaults.b) {
						return $elm$core$Result$Ok(
							$author$project$PlugMap$Plugins$Themes$Monoselection($elm$core$Maybe$Nothing));
					} else {
						var head = defaults.a;
						return $elm$core$Result$Ok(
							$author$project$PlugMap$Plugins$Themes$Monoselection(
								$elm$core$Maybe$Just(head)));
					}
				} else {
					var _v4 = _v0.a;
					if (!defaults.b) {
						return $elm$core$Result$Err(errMsg);
					} else {
						var head = defaults.a;
						return $elm$core$Result$Ok(
							$author$project$PlugMap$Plugins$Themes$EnforcedMonoselection(head));
					}
				}
			} else {
				if (!_v0.b) {
					var _v3 = _v0.a;
					return $elm$core$Result$Ok(
						$author$project$PlugMap$Plugins$Themes$Polyselection(defaults));
				} else {
					var _v6 = _v0.a;
					if (!defaults.b) {
						return $elm$core$Result$Err(errMsg);
					} else {
						var head = defaults.a;
						var tail = defaults.b;
						return $elm$core$Result$Ok(
							A2($author$project$PlugMap$Plugins$Themes$EnforcedPolyselection, head, tail));
					}
				}
			}
		});
	return A2(
		$elm$json$Json$Decode$andThen,
		$elm_community$json_extra$Json$Decode$Extra$fromResult,
		A4(
			$elm$json$Json$Decode$map3,
			toSelection,
			A2($elm$json$Json$Decode$field, 'selectiveness', $author$project$PlugMap$Plugins$Themes$selectivenessDecoder),
			A2($elm$json$Json$Decode$field, 'mustHaveSelection', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$withDefault,
				_List_Nil,
				A2(
					$elm$json$Json$Decode$field,
					'defaultSelection',
					$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$layerKeyDecoder)))));
}();
var $author$project$PlugMap$Plugins$Themes$transparencyDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Decode$succeed,
		A2($elm$core$Basics$clamp, 0.0, 1.0)),
	$elm$json$Json$Decode$float);
var $author$project$PlugMap$Plugins$Themes$layerCategoryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'layerGroups',
	$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$groupKeyDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'infoIcon',
		$author$project$PlugMap$Plugins$Themes$linkImageDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'activeIcon',
			$author$project$PlugMap$Plugins$Themes$linkImageDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'usesRasterLegend',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'openness',
					$author$project$PlugMap$Plugins$Themes$opennessDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'transparency',
						$author$project$PlugMap$Plugins$Themes$transparencyDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'multiphasic',
							$elm$json$Json$Decode$bool,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
								$author$project$PlugMap$Plugins$Themes$selectionDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'key',
										$author$project$PlugMap$Plugins$Themes$categoryKeyDecoder,
										$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$LayerCategory)))))))))));
var $author$project$PlugMap$Plugins$Themes$layerCategoriesDecoder = $elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$layerCategoryDecoder);
var $author$project$PlugMap$Plugins$Themes$LayerGroup = F4(
	function (key, name, openness, layers) {
		return {v: key, h7: layers, dz: name, b_: openness};
	});
var $author$project$PlugMap$Plugins$Themes$groupKeyToString = function (_v0) {
	var key = _v0;
	return key;
};
var $author$project$PlugMap$Plugins$Themes$layerGroupDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (lg) {
		return $elm$json$Json$Decode$succeed(
			_Utils_Tuple2(
				$author$project$PlugMap$Plugins$Themes$groupKeyToString(lg.v),
				lg));
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'layers',
		$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$layerKeyDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'openness',
			$author$project$PlugMap$Plugins$Themes$opennessDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'name',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'key',
					$author$project$PlugMap$Plugins$Themes$groupKeyDecoder,
					$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$LayerGroup))))));
var $author$project$PlugMap$Plugins$Themes$layerGroupRepoDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Dict$fromList),
	$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$layerGroupDecoder));
var $author$project$PlugMap$Plugins$Themes$Layer = F6(
	function (key, name, opacity, config, legend, identify) {
		return {hd: config, lQ: identify, v: key, ez: legend, dz: name, iq: opacity};
	});
var $author$project$PlugMap$Plugins$Themes$EsriExportConfig = F2(
	function (endpoints, extent) {
		return {lh: endpoints, cy: extent};
	});
var $author$project$PlugMap$Plugins$Themes$Endpoint = F6(
	function (url, zIndex, tokenKey, layersToShow, layerDefs, bbox) {
		return {gU: bbox, mc: layerDefs, h8: layersToShow, or: tokenKey, jF: url, gD: zIndex};
	});
var $author$project$PlugMap$Plugins$Themes$endpointDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'bbox',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'layerDefs',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'layersToShow',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'tokenKey',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'z-index',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'url',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$Endpoint)))))));
var $author$project$PlugMap$Plugins$Themes$endpointsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$endpointDecoder),
	$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$Multiple));
var $author$project$PlugMap$Plugins$Themes$extentDecoder = $elm$json$Json$Decode$list($elm$json$Json$Decode$float);
var $author$project$PlugMap$Plugins$Themes$esriExportConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'extent',
	$author$project$PlugMap$Plugins$Themes$extentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'endpoints',
		$author$project$PlugMap$Plugins$Themes$endpointsDecoder,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$EsriExportConfig)));
var $author$project$PlugMap$Plugins$Themes$esriExportLayerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'esriExport',
	$author$project$PlugMap$Plugins$Themes$esriExportConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$EsriExportLayer));
var $author$project$PlugMap$Plugins$Themes$WMSLayer = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMap$Plugins$Themes$WMSConfig = F2(
	function (endpoints, extent) {
		return {lh: endpoints, cy: extent};
	});
var $author$project$PlugMap$Plugins$Themes$WMSEndpoint = F7(
	function (url, zIndex, tokenKey, layers, propertyNames, nameField, idField) {
		return {et: idField, h7: layers, mw: nameField, ao: propertyNames, or: tokenKey, jF: url, gD: zIndex};
	});
var $author$project$PlugMap$Plugins$Themes$wmsEndpointDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'idField',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'nameField',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'propertyNames',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'layers',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'tokenKey',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'z-index',
						$elm$json$Json$Decode$int,
						0,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'url',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$WMSEndpoint))))))));
var $author$project$PlugMap$Plugins$Themes$wmsEndpointsDecoder = $elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$wmsEndpointDecoder);
var $author$project$PlugMap$Plugins$Themes$wmsConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'extent',
	$author$project$PlugMap$Plugins$Themes$extentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'endpoints',
		$author$project$PlugMap$Plugins$Themes$wmsEndpointsDecoder,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$WMSConfig)));
var $author$project$PlugMap$Plugins$Themes$wmsLayerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'wms',
	$author$project$PlugMap$Plugins$Themes$wmsConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$WMSLayer));
var $author$project$PlugMap$Plugins$Themes$WMTSLayer = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$Themes$WMTSConfig = F2(
	function (endpoints, extent) {
		return {lh: endpoints, cy: extent};
	});
var $author$project$PlugMap$Plugins$Themes$wmtsConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'extent',
	$author$project$PlugMap$Plugins$Themes$extentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'endpoints',
		$author$project$PlugMap$Plugins$Themes$endpointsDecoder,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$WMTSConfig)));
var $author$project$PlugMap$Plugins$Themes$wmtsLayerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'wmts',
	$author$project$PlugMap$Plugins$Themes$wmtsConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$WMTSLayer));
var $author$project$PlugMap$Plugins$Themes$XYZLayer = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$Themes$XYZConfig = F3(
	function (endpoints, maxZoom, minZoom) {
		return {lh: endpoints, ih: maxZoom, ij: minZoom};
	});
var $author$project$PlugMap$Plugins$Themes$xyzConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'minZoom',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'maxZoom',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'endpoints',
			$author$project$PlugMap$Plugins$Themes$endpointsDecoder,
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$XYZConfig))));
var $author$project$PlugMap$Plugins$Themes$xyzLayerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'xyz',
	$author$project$PlugMap$Plugins$Themes$xyzConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$XYZLayer));
var $author$project$PlugMap$Plugins$Themes$configDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$PlugMap$Plugins$Themes$xyzLayerDecoder, $author$project$PlugMap$Plugins$Themes$wmtsLayerDecoder, $author$project$PlugMap$Plugins$Themes$wmsLayerDecoder, $author$project$PlugMap$Plugins$Themes$esriExportLayerDecoder]));
var $author$project$PlugMap$Plugins$Themes$Identify = F5(
	function (enabled, dataMapping, canViewDetails, queryLayerIds, tolerance) {
		return {g5: canViewDetails, hi: dataMapping, ax: enabled, iL: queryLayerIds, ju: tolerance};
	});
var $author$project$PlugMap$Plugins$Themes$IdentifyDataMapping = F2(
	function (title, fields) {
		return {hA: fields, jr: title};
	});
var $author$project$PlugMap$Plugins$Themes$IdentifyField = F2(
	function (name, fieldType) {
		return {lu: fieldType, dz: name};
	});
var $author$project$PlugMap$Plugins$Themes$Map = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMap$Plugins$Themes$Query = function (a) {
	return {$: 0, a: a};
};
var $author$project$PlugMap$Plugins$Themes$Static = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$Themes$ValueMapperParam = F2(
	function (query, values) {
		return {iK: query, jJ: values};
	});
var $author$project$PlugMap$Plugins$Themes$mapDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'query',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$ValueMapperParam)));
var $author$project$PlugMap$Plugins$Themes$identifyFieldDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'query',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$Query)),
				A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'static',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$Static)),
				A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'map',
				$author$project$PlugMap$Plugins$Themes$mapDecoder,
				$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$Map))
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$IdentifyField)));
var $author$project$PlugMap$Plugins$Themes$identifyDataMappingDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fields',
	$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$identifyFieldDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$author$project$PlugMap$Plugins$Themes$identifyFieldDecoder,
		$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$IdentifyDataMapping)));
var $author$project$PlugMap$Plugins$Themes$identifyDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tolerance',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'queryLayerIds',
		$elm$json$Json$Decode$maybe(
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'canViewDetails',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'dataMapping',
				$author$project$PlugMap$Plugins$Themes$identifyDataMappingDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'enabled',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$Identify))))));
var $author$project$PlugMap$Plugins$Themes$LegendEntry = F3(
	function (name, color, fontColor) {
		return {M: color, hI: fontColor, dz: name};
	});
var $author$project$PlugMap$Plugins$Themes$colorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'b',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'g',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'r',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($avh4$elm_color$Color$rgb255))));
var $author$project$PlugMap$Plugins$Themes$darkFont = A3($avh4$elm_color$Color$rgb255, 36, 36, 36);
var $avh4$elm_color$Color$white = A4($avh4$elm_color$Color$RgbaSpace, 255 / 255, 255 / 255, 255 / 255, 1.0);
var $author$project$PlugMap$Plugins$Themes$lightFont = $avh4$elm_color$Color$white;
var $elm$core$Basics$pow = _Basics_pow;
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {af: a, ag: b, al: g, aq: r};
};
var $noahzgordon$elm_color_extra$Color$Accessibility$luminance = function (cl) {
	var f = function (intensity) {
		return (intensity <= 0.03928) ? (intensity / 12.92) : A2($elm$core$Basics$pow, (intensity + 0.055) / 1.055, 2.4);
	};
	var _v0 = function (a) {
		return _Utils_Tuple3(
			f(a.aq),
			f(a.al),
			f(a.ag));
	}(
		$avh4$elm_color$Color$toRgba(cl));
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	return ((0.2126 * r) + (0.7152 * g)) + (0.0722 * b);
};
var $noahzgordon$elm_color_extra$Color$Accessibility$contrastRatio = F2(
	function (c1, c2) {
		var b = $noahzgordon$elm_color_extra$Color$Accessibility$luminance(c2) + 0.05;
		var a = $noahzgordon$elm_color_extra$Color$Accessibility$luminance(c1) + 0.05;
		return (_Utils_cmp(a, b) > 0) ? (a / b) : (b / a);
	});
var $elm$core$List$sortWith = _List_sortWith;
var $noahzgordon$elm_color_extra$Color$Accessibility$maximumContrast = F2(
	function (base, options) {
		var compareContrast = F2(
			function (c1, c2) {
				return A2(
					$elm$core$Basics$compare,
					A2($noahzgordon$elm_color_extra$Color$Accessibility$contrastRatio, base, c2),
					A2($noahzgordon$elm_color_extra$Color$Accessibility$contrastRatio, base, c1));
			});
		return $elm$core$List$head(
			A2($elm$core$List$sortWith, compareContrast, options));
	});
var $author$project$PlugMap$Plugins$Themes$fontColorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (c) {
		return $elm$json$Json$Decode$succeed(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$PlugMap$Plugins$Themes$darkFont,
				A2(
					$noahzgordon$elm_color_extra$Color$Accessibility$maximumContrast,
					c,
					_List_fromArray(
						[$author$project$PlugMap$Plugins$Themes$lightFont, $author$project$PlugMap$Plugins$Themes$darkFont]))));
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['color']),
		$author$project$PlugMap$Plugins$Themes$colorDecoder));
var $author$project$PlugMap$Plugins$Themes$legendEntryDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$PlugMap$Plugins$Themes$fontColorDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'color',
		$author$project$PlugMap$Plugins$Themes$colorDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$LegendEntry))));
var $author$project$PlugMap$Plugins$Themes$legendDecoder = $elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$legendEntryDecoder);
var $author$project$PlugMap$Plugins$Themes$layerDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (ly) {
		return $elm$json$Json$Decode$succeed(
			_Utils_Tuple2(
				$author$project$PlugMap$Plugins$Themes$layerKeyToString(ly.v),
				ly));
	},
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'identify',
		$elm$json$Json$Decode$maybe($author$project$PlugMap$Plugins$Themes$identifyDecoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'legend',
			$elm$json$Json$Decode$maybe($author$project$PlugMap$Plugins$Themes$legendDecoder),
			$elm$core$Maybe$Nothing,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$PlugMap$Plugins$Themes$configDecoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'opacity',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'key',
							$author$project$PlugMap$Plugins$Themes$layerKeyDecoder,
							$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$Layer))))))));
var $author$project$PlugMap$Plugins$Themes$layerRepoDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Dict$fromList),
	$elm$json$Json$Decode$list($author$project$PlugMap$Plugins$Themes$layerDecoder));
var $author$project$PlugMap$Plugins$Themes$themesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'layerCategories',
	$author$project$PlugMap$Plugins$Themes$layerCategoriesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'layerGroups',
		$author$project$PlugMap$Plugins$Themes$layerGroupRepoDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'layers',
			$author$project$PlugMap$Plugins$Themes$layerRepoDecoder,
			$elm$json$Json$Decode$succeed($author$project$PlugMap$Plugins$Themes$Model))));
var $author$project$PlugMap$Plugins$Themes$init = F2(
	function (flags, fieldPath) {
		var _v0 = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$at, fieldPath, $author$project$PlugMap$Plugins$Themes$themesDecoder),
			flags);
		if (!_v0.$) {
			var model = _v0.a;
			return _Utils_Tuple2(
				$elm$core$Result$Ok(model),
				$author$project$PlugMap$Plugins$Themes$addThemesCmd(
					$author$project$PlugMap$Plugins$Themes$encodeThemes(model)));
		} else {
			var err = _v0.a;
			return _Utils_Tuple2(
				$elm$core$Result$Err(
					'PlugMap.Plugins.Themes.init :: ' + $elm$json$Json$Decode$errorToString(err)),
				$elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$PlugMap$Plugins$Themes$layersWithIdentify = function (repo) {
	return $elm$core$Dict$values(
		A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, lyr) {
					return $elm_community$maybe_extra$Maybe$Extra$isJust(lyr.lQ);
				}),
			repo));
};
var $author$project$PlugMap$Plugins$Themes$layersWithLegend = function (repo) {
	return $elm$core$Dict$values(
		A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, lyr) {
					return $elm_community$maybe_extra$Maybe$Extra$isJust(lyr.ez);
				}),
			repo));
};
var $author$project$PAM$MapServices$Insecured = function (a) {
	return {$: 0, a: a};
};
var $author$project$PAM$MapServices$BaseMapServiceConfig = F2(
	function (baseUrl, key) {
		return {kn: baseUrl, v: key};
	});
var $author$project$PAM$MapServices$baseMapServiceConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'key',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'baseUrl',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PAM$MapServices$BaseMapServiceConfig)));
var $author$project$PAM$MapServices$insecuredMapServiceDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$PAM$MapServices$baseMapServiceConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PAM$MapServices$Insecured));
var $author$project$PAM$MapServices$Secured = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$PAM$MapServices$ServiceToken = F2(
	function (token, expires) {
		return {lo: expires, oq: token};
	});
var $author$project$PAM$MapServices$serviceTokenDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'expires',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'token',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$PAM$MapServices$ServiceToken)));
var $author$project$PAM$MapServices$securedMapServiceDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$PAM$MapServices$serviceTokenDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$PAM$MapServices$baseMapServiceConfigDecoder,
		$elm$json$Json$Decode$succeed($author$project$PAM$MapServices$Secured)));
var $author$project$PAM$MapServices$mapServiceDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$PAM$MapServices$securedMapServiceDecoder, $author$project$PAM$MapServices$insecuredMapServiceDecoder]));
var $author$project$PAM$API$APIBase$bump = F3(
	function (sucessReturn, unauthorizedReturn, result) {
		if (!result.$) {
			return sucessReturn(result);
		} else {
			var err = result.a;
			if (err.$ === 3) {
				var status = err.a;
				return (status === 401) ? unauthorizedReturn(result) : sucessReturn(result);
			} else {
				return sucessReturn(result);
			}
		}
	});
var $author$project$PAM$API$APIBase$postRequest = F8(
	function (settings, controller, action, body_, sucessReturn, unauthorizedReturn, user, decoder) {
		var version = A2(
			$elm$core$Maybe$withDefault,
			settings.jG ? $elm$core$Maybe$Just(settings.jL) : $elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$andThen,
				function (x) {
					var _v4 = x.jG;
					if ((!_v4.$) && _v4.a) {
						var _v5 = x.jL;
						if (!_v5.$) {
							var ver = _v5.a;
							return $elm$core$Maybe$Just(
								$elm$core$Maybe$Just(ver));
						} else {
							return $elm$core$Maybe$Just(
								$elm$core$Maybe$Just(settings.jL));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				A2($elm$core$Dict$get, controller, settings.lh)));
		var trok = function () {
			switch (user.$) {
				case 3:
					var token = user.a.oq;
					return token;
				case 2:
					var token = user.a;
					return token;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return $elm$http$Http$riskyRequest(
			{
				gZ: function () {
					if (!body_.$) {
						var body = body_.a;
						return $elm$http$Http$jsonBody(body);
					} else {
						return $elm$http$Http$emptyBody;
					}
				}(),
				hv: A2(
					$elm$http$Http$expectJson,
					A2($author$project$PAM$API$APIBase$bump, sucessReturn, unauthorizedReturn),
					decoder),
				hO: A2(
					$elm$core$List$append,
					function () {
						if (!trok.$) {
							var tok = trok.a;
							return A2($truqu$elm_oauth2$OAuth$useToken, tok, _List_Nil);
						} else {
							return _List_fromArray(
								[
									A2($elm$http$Http$header, 'Anon', 'True')
								]);
						}
					}(),
					_List_fromArray(
						[
							A2($elm$http$Http$header, 'Accept', 'application/json, text/javascript, */*; q=0.01'),
							A2($elm$http$Http$header, 'Content-Type', 'application/json')
						])),
				ii: 'POST',
				jp: $elm$core$Maybe$Nothing,
				jz: $elm$core$Maybe$Nothing,
				jF: settings.km + (function () {
					if (!version.$) {
						var ver = version.a;
						return ver + '/';
					} else {
						return '';
					}
				}() + (controller + ('/' + action)))
			});
	});
var $author$project$PAM$API$APIBase$map_GetAllMapServices = F4(
	function (settings, user, _return, onError) {
		return A8(
			$author$project$PAM$API$APIBase$postRequest,
			settings,
			'map',
			'GetAllTokens',
			$elm$core$Maybe$Nothing,
			_return,
			onError,
			user,
			$elm$json$Json$Decode$list($author$project$PAM$MapServices$mapServiceDecoder));
	});
var $author$project$CWS$DrawEditMap$initStep = F6(
	function (model, flags, apiset, user, spatial, flat) {
		var _v0 = A2(
			$author$project$PlugMap$Plugins$Themes$init,
			flags,
			_List_fromArray(
				['cws', 'pe', 'details', 'map', 'themes']));
		var themesModel = _v0.a;
		var themesCmd = _v0.b;
		if (!themesModel.$) {
			var themes = themesModel.a;
			var tb = model.A;
			var _v2 = $author$project$PlugMap$Plugins$Identify$init(
				$author$project$PlugMap$Plugins$Themes$layersWithIdentify(themes.h6));
			var identifyModel = _v2.a;
			var idCmd = _v2.b;
			var _v3 = $author$project$PlugMap$Plugins$Drawing$init;
			var dm = _v3.a;
			var dmc = _v3.b;
			var _v4 = (model.c1 ? $author$project$CWS$DrawEditMap$startEditing : $author$project$CWS$DrawEditMap$stopEditing)(
				_Utils_update(
					tb,
					{o: dm, ay: $elm$core$Maybe$Nothing}));
			var toybox = _v4.a;
			var tbc = _v4.b;
			var _v5 = $author$project$PlugMap$Plugins$ColorUnderPointer$init(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.v;
						},
						$author$project$PlugMap$Plugins$Themes$layerKeyToString),
					$author$project$PlugMap$Plugins$Themes$layersWithLegend(themes.h6)));
			var cupModel = _v5.a;
			var cupCmd = _v5.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{di: cupModel, a3: identifyModel, a: 1, om: themes, A: toybox}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A4($author$project$PAM$API$APIBase$map_GetAllMapServices, apiset, user, $author$project$CWS$DrawEditMap$handleLoadMapServices, $author$project$CWS$DrawEditMap$handleErrorLoadMapServices),
							A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$identifyTranslator, idCmd),
							A2(
							$elm$core$Platform$Cmd$map,
							function (a) {
								return $author$project$CWS$DrawEditMap$Internal(
									$author$project$CWS$DrawEditMap$PluginMessage(
										$author$project$CWS$DrawEditMap$Msg_Themes(a)));
							},
							themesCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$colorUnderPointerTranslator, cupCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, dmc),
							tbc,
							A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								$author$project$CWS$DrawEditMap$Internal(
									A2($author$project$CWS$DrawEditMap$InitSpatial, spatial, flat))),
							$elm$core$Process$sleep(500))
						])));
		} else {
			var err = themesModel.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PlugMap$Plugins$Themes$deselectAll = function (cats) {
	return A2(
		$elm$core$List$map,
		function (cat) {
			var ns = function () {
				var _v0 = cat.bB;
				switch (_v0.$) {
					case 0:
						return $author$project$PlugMap$Plugins$Themes$Monoselection($elm$core$Maybe$Nothing);
					case 1:
						var keys = _v0.a;
						return $author$project$PlugMap$Plugins$Themes$Polyselection(_List_Nil);
					case 2:
						var key = _v0.a;
						return $author$project$PlugMap$Plugins$Themes$EnforcedMonoselection(key);
					default:
						if (!_v0.b.b) {
							var key = _v0.a;
							return A2($author$project$PlugMap$Plugins$Themes$EnforcedPolyselection, key, _List_Nil);
						} else {
							var key = _v0.a;
							var _v1 = _v0.b;
							var head = _v1.a;
							var tail = _v1.b;
							return A2($author$project$PlugMap$Plugins$Themes$EnforcedPolyselection, key, _List_Nil);
						}
				}
			}();
			return _Utils_update(
				cat,
				{bB: ns});
		},
		cats);
};
var $author$project$PlugMap$Plugins$Themes$replaceCategory = F2(
	function (category, categories) {
		return A2(
			$elm$core$List$map,
			function (cat) {
				return _Utils_eq(cat.v, category.v) ? category : cat;
			},
			categories);
	});
var $author$project$PlugMap$Plugins$Themes$resetCategory = F2(
	function (key, model) {
		var meow = A2($author$project$PlugMap$Plugins$Themes$getCategoryByKey, model, key);
		var newSelection = $author$project$PlugMap$Plugins$Themes$deselectAll(meow);
		var newCategories = A2(
			$elm$core$Maybe$withDefault,
			model.F,
			A2(
				$elm$core$Maybe$map,
				function (cat) {
					return A2($author$project$PlugMap$Plugins$Themes$replaceCategory, cat, model.F);
				},
				$elm$core$List$head(newSelection)));
		return _Utils_update(
			model,
			{F: newCategories});
	});
var $author$project$CWS$DrawEditMap$addDrawingPlugin = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$PlugMap$Plugins$FeaturePicker$init = function (services) {
	return _Utils_Tuple2(
		_Utils_update(
			$author$project$PlugMap$Plugins$FeaturePicker$defaultModel,
			{cW: services}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$PAM$MapServices$encodeBaseConfig = function (base) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'baseUrl',
			$elm$json$Json$Encode$string(base.kn)),
			_Utils_Tuple2(
			'key',
			$elm$json$Json$Encode$string(base.v))
		]);
};
var $author$project$PAM$MapServices$encodeInsecured = function (base) {
	return $elm$json$Json$Encode$object(
		$author$project$PAM$MapServices$encodeBaseConfig(base));
};
var $author$project$PAM$MapServices$encodeToken = function (token) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'token',
			$elm$json$Json$Encode$string(token.oq)),
			_Utils_Tuple2(
			'expires',
			$elm$json$Json$Encode$string(token.lo))
		]);
};
var $author$project$PAM$MapServices$encodeSecured = F2(
	function (base, token) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				$author$project$PAM$MapServices$encodeBaseConfig(base),
				$author$project$PAM$MapServices$encodeToken(token)));
	});
var $author$project$PAM$MapServices$encodeMapService = function (svc) {
	if (!svc.$) {
		var base = svc.a;
		return $author$project$PAM$MapServices$encodeInsecured(base);
	} else {
		var base = svc.a;
		var tok = svc.b;
		return A2($author$project$PAM$MapServices$encodeSecured, base, tok);
	}
};
var $author$project$PlugMap$Core$Ports$setServicesCmd = _Platform_outgoingPort('setServicesCmd', $elm$core$Basics$identity);
var $author$project$PlugMap$Core$setServices = F2(
	function (model, services) {
		var encodedServices = A2($elm$json$Json$Encode$list, $author$project$PAM$MapServices$encodeMapService, services);
		return _Utils_Tuple2(
			model,
			$author$project$PlugMap$Core$Ports$setServicesCmd(encodedServices));
	});
var $author$project$CWS$DrawEditMap$setServices = F2(
	function (model, services) {
		var tb = model.A;
		var sel = tb.e;
		var mappedServices = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (service) {
					if (!service.$) {
						var base = service.a;
						return _Utils_Tuple2(base.v, service);
					} else {
						var base = service.a;
						return _Utils_Tuple2(base.v, service);
					}
				},
				services));
		var conf = tb.hd;
		var _v0 = A2($author$project$PlugMap$Core$setServices, model.q, services);
		var newMap = _v0.a;
		var newMapCmd = _v0.b;
		var _v1 = $author$project$PlugMap$Plugins$FeaturePicker$init(mappedServices);
		var fp = _v1.a;
		var fpc = _v1.b;
		var newModel = _Utils_update(
			model,
			{
				q: newMap,
				cW: mappedServices,
				A: _Utils_update(
					tb,
					{
						hd: _Utils_update(
							conf,
							{cW: mappedServices}),
						e: _Utils_update(
							sel,
							{N: fp})
					})
			});
		var _v2 = $author$project$CWS$DrawEditMap$addDrawingPlugin(newModel);
		var newNewNewModel = _v2.a;
		var addlalldCmds = _v2.b;
		return _Utils_Tuple2(
			newNewNewModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						addlalldCmds,
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$CWS$DrawEditMap$Internal,
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$MapMessage, newMapCmd)),
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, fpc)
					])));
	});
var $author$project$PlugMap$Plugins$Themes$isLayerSelected = F2(
	function (layerKey, selection) {
		_v0$4:
		while (true) {
			switch (selection.$) {
				case 0:
					if (!selection.a.$) {
						var key = selection.a.a;
						return _Utils_eq(key, layerKey);
					} else {
						break _v0$4;
					}
				case 1:
					if (selection.a.b) {
						var _v1 = selection.a;
						var head = _v1.a;
						var tail = _v1.b;
						return A2(
							$elm$core$List$any,
							function (k) {
								return _Utils_eq(k, layerKey);
							},
							A2($elm$core$List$cons, head, tail));
					} else {
						break _v0$4;
					}
				case 2:
					var key = selection.a;
					return _Utils_eq(key, layerKey);
				default:
					if (selection.b.b) {
						var key = selection.a;
						var _v2 = selection.b;
						var head = _v2.a;
						var tail = _v2.b;
						return A2(
							$elm$core$List$any,
							function (k) {
								return _Utils_eq(k, layerKey);
							},
							A2(
								$elm$core$List$cons,
								key,
								A2($elm$core$List$cons, head, tail)));
					} else {
						break _v0$4;
					}
			}
		}
		return false;
	});
var $author$project$PlugMap$Plugins$Themes$updateSelection = F2(
	function (layerKey, selection) {
		if (A2($author$project$PlugMap$Plugins$Themes$isLayerSelected, layerKey, selection)) {
			switch (selection.$) {
				case 0:
					return $author$project$PlugMap$Plugins$Themes$Monoselection($elm$core$Maybe$Nothing);
				case 1:
					var keys = selection.a;
					return $author$project$PlugMap$Plugins$Themes$Polyselection(
						A2(
							$elm$core$List$filter,
							function (key) {
								return !_Utils_eq(key, layerKey);
							},
							keys));
				case 2:
					var key = selection.a;
					return $author$project$PlugMap$Plugins$Themes$EnforcedMonoselection(key);
				default:
					if (!selection.b.b) {
						var key = selection.a;
						return A2($author$project$PlugMap$Plugins$Themes$EnforcedPolyselection, key, _List_Nil);
					} else {
						var key = selection.a;
						var _v1 = selection.b;
						var head = _v1.a;
						var tail = _v1.b;
						return _Utils_eq(key, layerKey) ? A2($author$project$PlugMap$Plugins$Themes$EnforcedPolyselection, head, tail) : A2(
							$author$project$PlugMap$Plugins$Themes$EnforcedPolyselection,
							key,
							A2(
								$elm$core$List$filter,
								function (k) {
									return !_Utils_eq(k, layerKey);
								},
								A2($elm$core$List$cons, head, tail)));
					}
			}
		} else {
			switch (selection.$) {
				case 0:
					return $author$project$PlugMap$Plugins$Themes$Monoselection(
						$elm$core$Maybe$Just(layerKey));
				case 1:
					var keys = selection.a;
					return $author$project$PlugMap$Plugins$Themes$Polyselection(
						A2($elm$core$List$cons, layerKey, keys));
				case 2:
					return $author$project$PlugMap$Plugins$Themes$EnforcedMonoselection(layerKey);
				default:
					var key = selection.a;
					var keys = selection.b;
					return A2(
						$author$project$PlugMap$Plugins$Themes$EnforcedPolyselection,
						layerKey,
						A2($elm$core$List$cons, key, keys));
			}
		}
	});
var $author$project$PlugMap$Plugins$Themes$toggleLayerSelection = F3(
	function (key, category, model) {
		if (A3($author$project$PlugMap$Plugins$Themes$categoryHasLayer, key, category, model)) {
			var newSelection = A2($author$project$PlugMap$Plugins$Themes$updateSelection, key, category.bB);
			var newCategory = _Utils_update(
				category,
				{bB: newSelection});
			var newCategories = A2($author$project$PlugMap$Plugins$Themes$replaceCategory, newCategory, model.F);
			return _Utils_update(
				model,
				{F: newCategories});
		} else {
			return model;
		}
	});
var $author$project$PlugMap$Plugins$Themes$toggleSelectedThemesCmd = _Platform_outgoingPort('toggleSelectedThemesCmd', $elm$core$Basics$identity);
var $author$project$CWS$DrawEditMap$LoadError = 3;
var $author$project$CWS$DrawEditMap$LoadLoaded = 2;
var $author$project$CWS$DrawEditMap$Requested = 1;
var $author$project$PlugMap$Plugins$Drawing$addReferenceItems = _Platform_outgoingPort(
	'addReferenceItems',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$Drawing$addSelectedReferenceItems = F2(
	function (model, wkts) {
		return _Utils_Tuple2(
			model,
			$author$project$PlugMap$Plugins$Drawing$addReferenceItems(0));
	});
var $author$project$CWS$DrawEditMap$NotDrawing = 0;
var $author$project$CWS$DrawEditMap$newSpatial = F2(
	function (model, spatial) {
		return _Utils_update(
			spatial,
			{jE: 'Polygon'});
	});
var $author$project$CWS$DrawEditMap$Draw = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$Drawing$Line = 2;
var $author$project$PlugMap$Plugins$Drawing$modeToText = function (mode) {
	switch (mode) {
		case 0:
			return 'Polygon';
		case 1:
			return 'Point';
		case 2:
			return 'Line';
		case 3:
			return 'Circle';
		default:
			return 'Modify';
	}
};
var $author$project$PlugMap$Plugins$Drawing$encodeMode = function (mode) {
	return $elm$json$Json$Encode$string(
		$author$project$PlugMap$Plugins$Drawing$modeToText(mode));
};
var $author$project$PlugMap$Plugins$Drawing$encodeStartDrawingWithModeOptions = F2(
	function (mode, id) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mode',
					$author$project$PlugMap$Plugins$Drawing$encodeMode(mode)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(id))
				]));
	});
var $author$project$PlugMap$Plugins$Drawing$startDrawingWithMode = _Platform_outgoingPort('startDrawingWithMode', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Drawing$drawLine = F2(
	function (model, id) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					mp: 2,
					eD: $elm$core$Maybe$Just(id)
				}),
			$author$project$PlugMap$Plugins$Drawing$startDrawingWithMode(
				A2($author$project$PlugMap$Plugins$Drawing$encodeStartDrawingWithModeOptions, 2, id)));
	});
var $author$project$PlugMap$Plugins$Drawing$Point = 1;
var $author$project$PlugMap$Plugins$Drawing$drawPoint = F2(
	function (model, id) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					mp: 1,
					eD: $elm$core$Maybe$Just(id)
				}),
			$author$project$PlugMap$Plugins$Drawing$startDrawingWithMode(
				A2($author$project$PlugMap$Plugins$Drawing$encodeStartDrawingWithModeOptions, 1, id)));
	});
var $author$project$PlugMap$Plugins$Drawing$drawPoly = F2(
	function (model, id) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					mp: 0,
					eD: $elm$core$Maybe$Just(id)
				}),
			$author$project$PlugMap$Plugins$Drawing$startDrawingWithMode(
				A2($author$project$PlugMap$Plugins$Drawing$encodeStartDrawingWithModeOptions, 0, id)));
	});
var $author$project$PlugMap$Plugins$Drawing$disableDrawingCmd = _Platform_outgoingPort(
	'disableDrawingCmd',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$Drawing$stopAndUnload = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{ax: false}),
		$author$project$PlugMap$Plugins$Drawing$disableDrawingCmd(0));
};
var $author$project$CWS$DrawEditMap$setupDrawingTool = F2(
	function (model, tool) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.H, tool);
			if (_v1.a.$ === 1) {
				switch (_v1.b) {
					case 3:
						var _v2 = _v1.b;
						return A2($author$project$PlugMap$Plugins$Drawing$drawPoly, model.o, 0);
					case 1:
						var _v3 = _v1.b;
						return A2($author$project$PlugMap$Plugins$Drawing$drawPoint, model.o, 0);
					case 2:
						var _v4 = _v1.b;
						return A2($author$project$PlugMap$Plugins$Drawing$drawLine, model.o, 0);
					default:
						var _v5 = _v1.b;
						return $author$project$PlugMap$Plugins$Drawing$stopAndUnload(model.o);
				}
			} else {
				return $author$project$PlugMap$Plugins$Drawing$stopAndUnload(model.o);
			}
		}();
		var newDrawModel = _v0.a;
		var newDrawCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					o: newDrawModel,
					H: $author$project$CWS$DrawEditMap$Draw(tool)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, newDrawCmd));
	});
var $author$project$CWS$DrawEditMap$UpdateValue = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$CWS$DrawEditMap$updateParentHack = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{e_: false}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					A2(
					$elm$core$Task$perform,
					function (dontCareAboutThisValue) {
						return A2(
							$author$project$CWS$DrawEditMap$UpdateValue,
							function () {
								var _v1 = model.ay;
								if (!_v1.$) {
									var v = _v1.a;
									return A2($author$project$Fields$Shared$Valid, v, v.bc);
								} else {
									return $author$project$Fields$Shared$NotEntered;
								}
							}(),
							model.cZ);
					},
					$elm$core$Task$succeed('Hello'))
				])));
};
var $author$project$CWS$DrawEditMap$addShape = F2(
	function (model, spatial) {
		return $author$project$CWS$DrawEditMap$updateParentHack(
			function () {
				var _v0 = model.H;
				if (_v0.$ === 1) {
					return A2(
						$author$project$CWS$DrawEditMap$setupDrawingTool,
						_Utils_update(
							model,
							{
								cZ: A2(
									$elm$core$List$cons,
									A2($author$project$CWS$DrawEditMap$newSpatial, model, spatial),
									model.cZ)
							}),
						0);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cZ: A2(
									$elm$core$List$cons,
									A2($author$project$CWS$DrawEditMap$newSpatial, model, spatial),
									model.cZ)
							}),
						$elm$core$Platform$Cmd$none);
				}
			}());
	});
var $author$project$PlugMap$Plugins$Drawing$addSpatialEncoder = function (spatial) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'wkt',
				$elm$json$Json$Encode$string(spatial.bc)),
				_Utils_Tuple2(
				'acres',
				$elm$json$Json$Encode$float(spatial.bH))
			]));
};
var $author$project$PlugMap$Plugins$Drawing$addWKTsToMap = _Platform_outgoingPort('addWKTsToMap', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Drawing$addWKTs = F2(
	function (model, wkts) {
		return _Utils_Tuple2(
			model,
			$author$project$PlugMap$Plugins$Drawing$addWKTsToMap(
				A2($elm$json$Json$Encode$list, $author$project$PlugMap$Plugins$Drawing$addSpatialEncoder, wkts)));
	});
var $author$project$PlugMap$Plugins$Upload$openChooseFile = _Platform_outgoingPort(
	'openChooseFile',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$Upload$chooseFile = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{jf: $author$project$PlugMap$Plugins$Upload$SelectingFile}),
		$author$project$PlugMap$Plugins$Upload$openChooseFile(0));
};
var $author$project$PlugMap$Plugins$FeaturePicker$clearReferenceFeatures = _Platform_outgoingPort(
	'clearReferenceFeatures',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$FeaturePicker$clear = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$PlugMap$Plugins$FeaturePicker$clearReferenceFeatures(0));
};
var $author$project$PlugMap$Plugins$Drawing$deleteFeatureById = _Platform_outgoingPort('deleteFeatureById', $elm$json$Json$Encode$int);
var $author$project$PlugMap$Plugins$Drawing$deleteById = F2(
	function (model, id) {
		return _Utils_Tuple2(
			model,
			$author$project$PlugMap$Plugins$Drawing$deleteFeatureById(id));
	});
var $author$project$CWS$DrawEditMap$deleteFeature = F2(
	function (model, id) {
		var spa = A2(
			$elm$core$List$filterMap,
			function (itm) {
				return _Utils_eq(
					A2($elm$core$Maybe$withDefault, 1, itm.ab),
					id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(itm);
			},
			model.cZ);
		var _v0 = A2($author$project$PlugMap$Plugins$Drawing$deleteById, model.o, id);
		var dmo = _v0.a;
		var dme = _v0.b;
		var msg = A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, dme);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					P: _Utils_eq(
						model.P,
						$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : model.P,
					cZ: spa
				}),
			msg);
	});
var $author$project$PlugMap$Plugins$FeaturePicker$deselectFeature = _Platform_outgoingPort('deselectFeature', $elm$json$Json$Encode$int);
var $author$project$PlugMap$Plugins$FeaturePicker$deselect = F2(
	function (id, model) {
		return _Utils_Tuple2(
			model,
			$author$project$PlugMap$Plugins$FeaturePicker$deselectFeature(id));
	});
var $inkuzmin$elm_multiselect$Multiselect$getSelectedValues = function (_v0) {
	var model = _v0;
	return model.P;
};
var $author$project$PlugMap$Plugins$FeaturePicker$hideReferenceLayer = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$PlugMap$Plugins$FeaturePicker$hideReferenceLayerDisplay(0));
};
var $author$project$CWS$DrawEditMap$toolsMatch = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a, b);
		_v0$3:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (_v0.b.$ === 1) {
						return true;
					} else {
						break _v0$3;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$3;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						return true;
					} else {
						break _v0$3;
					}
				default:
					break _v0$3;
			}
		}
		return false;
	});
var $author$project$CWS$DrawEditMap$switchTo = F2(
	function (_v0, tool) {
		var model = _v0.a;
		var cmds = _v0.b;
		if (!A2($author$project$CWS$DrawEditMap$toolsMatch, model.H, tool)) {
			var _v1 = model.H;
			switch (_v1.$) {
				case 3:
					var osm = model.e;
					var nsm = _Utils_update(
						osm,
						{P: $elm$core$Maybe$Nothing});
					var _v2 = $author$project$PlugMap$Plugins$FeaturePicker$hideReferenceLayer(model.e.N);
					var rm = _v2.a;
					var rc = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{e: nsm, H: tool}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmds,
									A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, rc),
									A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always(
										$author$project$CWS$DrawEditMap$Internal(
											$author$project$CWS$DrawEditMap$SetLayer($elm$core$Maybe$Nothing))),
									$elm$core$Task$succeed('Hi'))
								])));
				case 2:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: tool}),
						cmds);
				default:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: tool}),
						cmds);
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{H: $author$project$CWS$DrawEditMap$None}),
				cmds);
		}
	});
var $author$project$CWS$DrawEditMap$handleDrawClicked = function (model) {
	return A2(
		$author$project$CWS$DrawEditMap$switchTo,
		_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
		$author$project$CWS$DrawEditMap$Draw(0));
};
var $author$project$PlugMap$Plugins$Drawing$update = F2(
	function (model, msg) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
	});
var $author$project$CWS$DrawEditMap$handleDrawingMsg = F2(
	function (model, sub) {
		var _v0 = A2($author$project$PlugMap$Plugins$Drawing$update, model.o, sub);
		var nd = _v0.a;
		var ndc = _v0.b;
		var om = _v0.c;
		var nm = _Utils_update(
			model,
			{o: nd});
		var nc = A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, ndc);
		return _Utils_Tuple2(nm, nc);
	});
var $author$project$CWS$DrawEditMap$handleFlatRecalculated = F2(
	function (model, maybeFlat) {
		return $author$project$CWS$DrawEditMap$updateParentHack(
			function (nm) {
				return _Utils_Tuple2(nm, $elm$core$Platform$Cmd$none);
			}(
				A2(
					$elm$core$Maybe$withDefault,
					_Utils_update(
						model,
						{ay: $elm$core$Maybe$Nothing}),
					A2(
						$elm$core$Maybe$map,
						function (flat) {
							return _Utils_update(
								model,
								{
									ay: $elm$core$Maybe$Just(
										{bH: flat.lz, ab: $elm$core$Maybe$Nothing, jE: 'Polygon', bc: flat.ay})
								});
						},
						maybeFlat))));
	});
var $author$project$CWS$DrawEditMap$handleFlatReceived = F2(
	function (model, flat) {
		return $author$project$CWS$DrawEditMap$updateParentHack(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{ay: flat}),
				$elm$core$Platform$Cmd$none));
	});
var $author$project$CWS$DrawEditMap$replaceIfMatch = F4(
	function (spatials, length, index, item) {
		return A2(
			$elm$core$Maybe$withDefault,
			item,
			A2(
				$elm$core$Maybe$map,
				function (shp) {
					return {bH: shp.bH, ab: shp.ab, jE: shp.jE, bc: shp.bc};
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (itm) {
							return _Utils_eq(
								A2($elm$core$Maybe$withDefault, 1, itm.ab),
								index + 1);
						},
						spatials))));
	});
var $author$project$CWS$DrawEditMap$handleModifyEnd = F2(
	function (model, modifiedItems) {
		var updootedItems = $elm$core$List$reverse(
			A2(
				$elm$core$List$indexedMap,
				A2(
					$author$project$CWS$DrawEditMap$replaceIfMatch,
					modifiedItems.mr,
					$elm$core$List$length(model.cZ)),
				$elm$core$List$reverse(model.cZ)));
		return $author$project$CWS$DrawEditMap$updateParentHack(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{cZ: updootedItems}),
				$elm$core$Platform$Cmd$none));
	});
var $author$project$CWS$DrawEditMap$handleReferenceClicked = function (model) {
	return A2(
		$author$project$CWS$DrawEditMap$switchTo,
		_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
		$author$project$CWS$DrawEditMap$Reference);
};
var $author$project$CWS$DrawEditMap$Upload = {$: 2};
var $author$project$CWS$DrawEditMap$handleUploadClicked = function (model) {
	return A2(
		$author$project$CWS$DrawEditMap$switchTo,
		_Utils_Tuple2(
			_Utils_update(
				model,
				{aX: $author$project$PlugMap$Plugins$Upload$defaultModel}),
			$elm$core$Platform$Cmd$none),
		$author$project$CWS$DrawEditMap$Upload);
};
var $author$project$CWS$DrawEditMap$Updating = {$: 4};
var $author$project$CWS$DrawEditMap$lockUpdating = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{e_: true}),
		A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always($author$project$CWS$DrawEditMap$Updating),
			$elm$core$Task$succeed('Hello')));
};
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$PlugMap$Plugins$FeaturePicker$FeatureLoading = {$: 4};
var $author$project$PlugMap$Plugins$FeaturePicker$dictGet = F2(
	function (dict, key) {
		return A2($elm$core$Dict$get, key, dict);
	});
var $author$project$PlugMap$Plugins$FeaturePicker$buildUrl = F3(
	function (layer, ags, params) {
		var tokenService = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$PlugMap$Plugins$FeaturePicker$dictGet(ags),
				layer.or));
		var pstr = '?' + A2(
			$elm$core$String$join,
			'&',
			A2(
				$elm$core$List$map,
				function (_v2) {
					var key = _v2.a;
					var value = _v2.b;
					return key + ('=' + value);
				},
				_Utils_ap(
					params,
					function () {
						if ((!tokenService.$) && (tokenService.a.$ === 1)) {
							var _v4 = tokenService.a;
							var service = _v4.b;
							return _List_fromArray(
								[
									_Utils_Tuple2('token', service.oq)
								]);
						} else {
							return _List_Nil;
						}
					}())));
		var baseUrl = function () {
			if (!tokenService.$) {
				if (!tokenService.a.$) {
					var service = tokenService.a.a;
					return service.kn;
				} else {
					var _v1 = tokenService.a;
					var service = _v1.a;
					return service.kn;
				}
			} else {
				return '';
			}
		}();
		return _Utils_ap(
			baseUrl,
			_Utils_ap(layer.jF, pstr));
	});
var $author$project$PlugMap$Plugins$FeaturePicker$EsriResponded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$EsriRespondedError = function (a) {
	return {$: 3, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$handleEsriRequestByIdResponse = function (result) {
	if (!result.$) {
		var esriResponse = result.a;
		return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
			A2($author$project$PlugMap$Plugins$FeaturePicker$EsriResponded, 0, esriResponse));
	} else {
		var err = result.a;
		return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
			$author$project$PlugMap$Plugins$FeaturePicker$EsriRespondedError('Select'));
	}
};
var $author$project$PlugMap$Plugins$FeaturePicker$esriRequestById = F3(
	function (services, id, config) {
		var params = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('outSR', '3857'),
					_Utils_Tuple2(
					'where',
					config.et + ('=' + $elm$core$String$fromInt(id))),
					_Utils_Tuple2('returnGeometry', 'true'),
					_Utils_Tuple2('f', 'geojson')
				]),
			($elm$core$List$length(config.ao) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(
					'outFields',
					A2($elm$core$String$join, ',', config.ao))
				]) : _List_Nil);
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				function (lyr) {
					return $elm$http$Http$riskyRequest(
						{
							gZ: $elm$http$Http$emptyBody,
							hv: $elm$http$Http$expectString($author$project$PlugMap$Plugins$FeaturePicker$handleEsriRequestByIdResponse),
							hO: _List_Nil,
							ii: 'GET',
							jp: $elm$core$Maybe$Nothing,
							jz: $elm$core$Maybe$Nothing,
							jF: A3(
								$author$project$PlugMap$Plugins$FeaturePicker$buildUrl,
								_Utils_update(
									config,
									{jF: config.jF + (lyr + '/query')}),
								services,
								params)
						});
				},
				config.h7));
	});
var $author$project$PlugMap$Plugins$FeaturePicker$And = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$buildFilterXml = function (mFilter) {
	return _List_fromArray(
		[
			_Utils_Tuple2('filter', '<Filter></Filter>')
		]);
};
var $author$project$PlugMap$Plugins$FeaturePicker$WFSXmlResult = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$handleWfsRequestByIdResponse = function (result) {
	return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
		A2($author$project$PlugMap$Plugins$FeaturePicker$WFSXmlResult, 0, result));
};
var $author$project$PlugMap$Plugins$FeaturePicker$wfsRequestById = F3(
	function (services, id, config) {
		var params = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('service', 'WFS'),
					_Utils_Tuple2('version', '2.0.0'),
					_Utils_Tuple2('request', 'GetFeature')
				]),
			($elm$core$List$length(config.c2) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(
					'typeNames',
					A2($elm$core$String$join, ',', config.c2))
				]) : _Utils_ap(
				_List_Nil,
				($elm$core$List$length(config.ao) > 0) ? _List_fromArray(
					[
						_Utils_Tuple2(
						'propertyName',
						A2($elm$core$String$join, ',', config.ao))
					]) : _Utils_ap(
					_List_Nil,
					$author$project$PlugMap$Plugins$FeaturePicker$buildFilterXml(
						function () {
							var _v0 = config.fp;
							if (!_v0.$) {
								var filter = _v0.a;
								return $elm$core$Maybe$Just(
									A2(
										$author$project$PlugMap$Plugins$FeaturePicker$And,
										filter,
										A2(
											$author$project$PlugMap$Plugins$FeaturePicker$EqualTo,
											'id',
											$elm$core$String$fromInt(id))));
							} else {
								return $elm$core$Maybe$Just(
									A2(
										$author$project$PlugMap$Plugins$FeaturePicker$EqualTo,
										'id',
										$elm$core$String$fromInt(id)));
							}
						}()))));
		return $elm$http$Http$riskyRequest(
			{
				gZ: $elm$http$Http$emptyBody,
				hv: $elm$http$Http$expectString($author$project$PlugMap$Plugins$FeaturePicker$handleWfsRequestByIdResponse),
				hO: _List_Nil,
				ii: 'GET',
				jp: $elm$core$Maybe$Nothing,
				jz: $elm$core$Maybe$Nothing,
				jF: A3($author$project$PlugMap$Plugins$FeaturePicker$buildUrl, config, services, params)
			});
	});
var $author$project$PlugMap$Plugins$FeaturePicker$getSingleFeature = F4(
	function (services, refLayer, id, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		if (!refLayer.$) {
			var layer = refLayer.a;
			var _v2 = layer.hd;
			if (_v2.$ === 1) {
				var wms = _v2.a;
				var wfs = _v2.b;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$PlugMap$Plugins$FeaturePicker$wfsRequestById, services, id, wfs),
								cmds,
								A2(
								$elm$core$Task$perform,
								function (dontCareAboutThisValue) {
									return $author$project$PlugMap$Plugins$FeaturePicker$FeatureLoading;
								},
								$elm$core$Task$succeed('Hello'))
							])));
			} else {
				var conf = _v2.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$PlugMap$Plugins$FeaturePicker$esriRequestById, services, id, conf),
								cmds,
								A2(
								$elm$core$Task$perform,
								function (dontCareAboutThisValue) {
									return $author$project$PlugMap$Plugins$FeaturePicker$FeatureLoading;
								},
								$elm$core$Task$succeed('Hello'))
							])));
			}
		} else {
			return _Utils_Tuple2(model, cmds);
		}
	});
var $author$project$PlugMap$Plugins$FeaturePicker$selectFeature = _Platform_outgoingPort('selectFeature', $elm$json$Json$Encode$int);
var $author$project$PlugMap$Plugins$FeaturePicker$select = F2(
	function (id, model) {
		return A4(
			$author$project$PlugMap$Plugins$FeaturePicker$getSingleFeature,
			model.cW,
			model.bT,
			id,
			function () {
				var _v0 = model.bD;
				if (_v0.$ === 2) {
					var feats = _v0.a;
					var newFeat = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (a) {
								return _Utils_eq(a.ab, id);
							},
							feats));
					if (!newFeat.$) {
						var f = newFeat.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									as: _Utils_ap(
										model.as,
										_List_fromArray(
											[f]))
								}),
							$author$project$PlugMap$Plugins$FeaturePicker$selectFeature(id));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			}());
	});
var $author$project$PlugMap$Plugins$Drawing$encodeBuffer = function (value) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'buffer',
				$elm$json$Json$Encode$float(value))
			]));
};
var $author$project$PlugMap$Plugins$Drawing$setBuffer = _Platform_outgoingPort('setBuffer', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Drawing$handleBufferChanged = F2(
	function (model, newValue) {
		var setValue = (newValue < 5) ? 5.0 : newValue;
		var changeCmd = (!_Utils_eq(setValue, model.dh)) ? $author$project$PlugMap$Plugins$Drawing$setBuffer(
			$author$project$PlugMap$Plugins$Drawing$encodeBuffer(setValue)) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{dh: setValue}),
			changeCmd,
			$elm$core$Maybe$Nothing);
	});
var $author$project$CWS$DrawEditMap$setAndUpdateBuffer = F2(
	function (model, buf) {
		var _v0 = A2($author$project$PlugMap$Plugins$Drawing$handleBufferChanged, model.o, buf);
		var nd = _v0.a;
		var ndc = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dh: buf, o: nd}),
			A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, ndc));
	});
var $author$project$PlugMap$Plugins$Drawing$selectById = _Platform_outgoingPort('selectById', $elm$json$Json$Encode$int);
var $author$project$PlugMap$Plugins$Drawing$lockModifyById = F2(
	function (model, id) {
		return _Utils_Tuple2(
			model,
			$author$project$PlugMap$Plugins$Drawing$selectById(id));
	});
var $author$project$CWS$DrawEditMap$setFeatureToEdit = F2(
	function (model, id) {
		var _v0 = A2($author$project$PlugMap$Plugins$Drawing$lockModifyById, model.o, id);
		var dmo = _v0.a;
		var dme = _v0.b;
		var msg = A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, dme);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					P: _Utils_eq(
						model.P,
						$elm$core$Maybe$Just(id)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
				}),
			msg);
	});
var $author$project$PlugMap$Plugins$FeaturePicker$encodeEsriConfig = function (conf) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(conf.jF)),
				_Utils_Tuple2(
				'tokenKey',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, conf.or))),
				_Utils_Tuple2(
				'layers',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, conf.h7)),
				_Utils_Tuple2(
				'propertyNames',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, conf.ao)),
				_Utils_Tuple2(
				'idField',
				$elm$json$Json$Encode$string(conf.et)),
				_Utils_Tuple2(
				'nameField',
				$elm$json$Json$Encode$string(conf.mw))
			]));
};
var $author$project$PlugMap$Plugins$FeaturePicker$encodeWFSConfig = function (wfs) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(wfs.jF)),
				_Utils_Tuple2(
				'tokenKey',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, wfs.or)),
				_Utils_Tuple2(
				'typeNames',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, wfs.c2)),
				_Utils_Tuple2(
				'propertyNames',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, wfs.ao))
			]));
};
var $author$project$PlugMap$Plugins$FeaturePicker$encodeWMSConfig = function (wms) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(wms.jF)),
				_Utils_Tuple2(
				'tokenKey',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, wms.or)),
				_Utils_Tuple2(
				'layers',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, wms.h7))
			]));
};
var $author$project$PlugMap$Plugins$FeaturePicker$encodeReferenceLayerConfig = function (layer) {
	return $elm$json$Json$Encode$object(
		function () {
			if (!layer.$) {
				var conf = layer.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'esri',
						$author$project$PlugMap$Plugins$FeaturePicker$encodeEsriConfig(conf))
					]);
			} else {
				var wms = layer.a;
				var wfs = layer.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'wfs',
						$author$project$PlugMap$Plugins$FeaturePicker$encodeWFSConfig(wfs)),
						_Utils_Tuple2(
						'wms',
						$author$project$PlugMap$Plugins$FeaturePicker$encodeWMSConfig(wms))
					]);
			}
		}());
};
var $author$project$PlugMap$Plugins$FeaturePicker$encodeReferenceLayer = function (layer) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(layer.dz)),
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(layer.v)),
				_Utils_Tuple2(
				'config',
				$author$project$PlugMap$Plugins$FeaturePicker$encodeReferenceLayerConfig(layer.hd))
			]));
};
var $author$project$PlugMap$Plugins$FeaturePicker$featurePickerDisable = _Platform_outgoingPort(
	'featurePickerDisable',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$PlugMap$Plugins$FeaturePicker$featurePickerSetLayer = _Platform_outgoingPort('featurePickerSetLayer', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$FeaturePicker$handleEsriRequestResponse = function (result) {
	if (!result.$) {
		var esriResponse = result.a;
		return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
			A2($author$project$PlugMap$Plugins$FeaturePicker$EsriResponded, 1, esriResponse));
	} else {
		var err = result.a;
		return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
			$author$project$PlugMap$Plugins$FeaturePicker$EsriRespondedError('SetLayer'));
	}
};
var $author$project$PlugMap$Plugins$FeaturePicker$esriRequest = F2(
	function (services, config) {
		var params = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('outSR', '3857'),
					_Utils_Tuple2('where', '1=1'),
					_Utils_Tuple2('f', 'pjson'),
					_Utils_Tuple2('returnGeometry', 'false')
				]),
			($elm$core$List$length(config.ao) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(
					'outFields',
					A2($elm$core$String$join, ',', config.ao))
				]) : _List_Nil);
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				function (lyr) {
					return $elm$http$Http$riskyRequest(
						{
							gZ: $elm$http$Http$emptyBody,
							hv: $elm$http$Http$expectString($author$project$PlugMap$Plugins$FeaturePicker$handleEsriRequestResponse),
							hO: _List_Nil,
							ii: 'GET',
							jp: $elm$core$Maybe$Nothing,
							jz: $elm$core$Maybe$Nothing,
							jF: A3(
								$author$project$PlugMap$Plugins$FeaturePicker$buildUrl,
								_Utils_update(
									config,
									{jF: config.jF + (lyr + '/query')}),
								services,
								params)
						});
				},
				config.h7));
	});
var $author$project$PlugMap$Plugins$FeaturePicker$handleWfsRequestResponse = function (result) {
	return $author$project$PlugMap$Plugins$FeaturePicker$Internal(
		A2($author$project$PlugMap$Plugins$FeaturePicker$WFSXmlResult, 1, result));
};
var $author$project$PlugMap$Plugins$FeaturePicker$wfsRequest = F2(
	function (services, config) {
		var params = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('service', 'WFS'),
					_Utils_Tuple2('version', '2.0.0'),
					_Utils_Tuple2('request', 'GetFeature')
				]),
			($elm$core$List$length(config.c2) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(
					'typeNames',
					A2($elm$core$String$join, ',', config.c2))
				]) : _Utils_ap(
				_List_Nil,
				($elm$core$List$length(config.ao) > 0) ? _List_fromArray(
					[
						_Utils_Tuple2(
						'propertyName',
						A2($elm$core$String$join, ',', config.ao))
					]) : _Utils_ap(
					_List_Nil,
					$author$project$PlugMap$Plugins$FeaturePicker$buildFilterXml(config.fp))));
		return $elm$http$Http$riskyRequest(
			{
				gZ: $elm$http$Http$emptyBody,
				hv: $elm$http$Http$expectString($author$project$PlugMap$Plugins$FeaturePicker$handleWfsRequestResponse),
				hO: _List_Nil,
				ii: 'GET',
				jp: $elm$core$Maybe$Nothing,
				jz: $elm$core$Maybe$Nothing,
				jF: A3($author$project$PlugMap$Plugins$FeaturePicker$buildUrl, config, services, params)
			});
	});
var $author$project$PlugMap$Plugins$FeaturePicker$getFeatures = F3(
	function (services, refLayer, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		if (!refLayer.$) {
			var layer = refLayer.a;
			var _v2 = layer.hd;
			if (_v2.$ === 1) {
				var wms = _v2.a;
				var wfs = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{as: _List_Nil, bD: $author$project$PlugMap$Plugins$FeaturePicker$NoFeatures, cc: 1}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$PlugMap$Plugins$FeaturePicker$wfsRequest, services, wfs),
								cmds
							])));
			} else {
				var conf = _v2.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							as: _List_Nil,
							bD: $author$project$PlugMap$Plugins$FeaturePicker$NoFeatures,
							cc: $elm$core$List$length(conf.h7)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$PlugMap$Plugins$FeaturePicker$esriRequest, services, conf),
								cmds
							])));
			}
		} else {
			return _Utils_Tuple2(model, cmds);
		}
	});
var $author$project$PlugMap$Plugins$FeaturePicker$setReferenceLayer = F2(
	function (model, refLayer) {
		return function (_v1) {
			var a = _v1.a;
			var b = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					a,
					{bT: refLayer}),
				b);
		}(
			A3(
				$author$project$PlugMap$Plugins$FeaturePicker$getFeatures,
				model.cW,
				refLayer,
				function () {
					if (!refLayer.$) {
						var layer = refLayer.a;
						return _Utils_Tuple2(
							model,
							$author$project$PlugMap$Plugins$FeaturePicker$featurePickerSetLayer(
								$author$project$PlugMap$Plugins$FeaturePicker$encodeReferenceLayer(layer)));
					} else {
						return _Utils_Tuple2(
							model,
							$author$project$PlugMap$Plugins$FeaturePicker$featurePickerDisable(0));
					}
				}()));
	});
var $elm$core$String$toLower = _String_toLower;
var $inkuzmin$elm_multiselect$Multiselect$Cleared = {$: 2};
var $inkuzmin$elm_multiselect$Multiselect$DisableProtection = {$: 3};
var $inkuzmin$elm_multiselect$Multiselect$FocusResult = function (a) {
	return {$: 8, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$NotFound = function (a) {
	return {$: 3, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$ScrollResult = function (a) {
	return {$: 9, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$ScrollY = function (a) {
	return {$: 14, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Selected = function (a) {
	return {$: 0, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Unselected = function (a) {
	return {$: 1, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$backspace = 8;
var $inkuzmin$elm_multiselect$Multiselect$delayInMs = F2(
	function (ms, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(ms));
	});
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $inkuzmin$elm_multiselect$Multiselect$domScrollToY = F2(
	function (id, y) {
		return A2(
			$elm$core$Task$andThen,
			function (vp) {
				return A3($elm$browser$Browser$Dom$setViewportOf, id, vp.jN.dV, y);
			},
			$elm$browser$Browser$Dom$getViewportOf(id));
	});
var $inkuzmin$elm_multiselect$Multiselect$domScrollY = function (id) {
	return A2(
		$elm$core$Task$map,
		function (vp) {
			return vp.jN.dW;
		},
		$elm$browser$Browser$Dom$getViewportOf(id));
};
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow = 40;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$end = 35;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$escape = 27;
var $inkuzmin$elm_multiselect$Multiselect$fitViewPort = F2(
	function (_v0, _v1) {
		var top = _v0.a;
		var bottom = _v0.b;
		var vpTop = _v1.a;
		var vpBottom = _v1.b;
		return (_Utils_cmp(top, vpTop) < 0) ? top : ((_Utils_cmp(bottom, vpBottom) > 0) ? (vpTop + (bottom - vpBottom)) : vpTop);
	});
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight = 32;
var $inkuzmin$elm_multiselect$Multiselect$getBoundaries = function (i) {
	return _Utils_Tuple2(i * $inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight, (i * $inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight) + $inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight);
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight = 200;
var $inkuzmin$elm_multiselect$Multiselect$getViewPortBoundaries = function (i) {
	return _Utils_Tuple2(i, i + $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight);
};
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$home = 36;
var $inkuzmin$elm_multiselect$Multiselect$indexOf = F2(
	function (el, list) {
		var helper = F2(
			function (l, index) {
				helper:
				while (true) {
					if (!l.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var xs = l.b;
						if (_Utils_eq(x, el)) {
							return $elm$core$Maybe$Just(index);
						} else {
							var $temp$l = xs,
								$temp$index = index + 1;
							l = $temp$l;
							index = $temp$index;
							continue helper;
						}
					}
				}
			});
		return A2(helper, list, 0);
	});
var $inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter = '\u200C\u200C';
var $inkuzmin$elm_multiselect$Multiselect$lastElem = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$always),
	$elm$core$Maybe$Nothing);
var $inkuzmin$elm_multiselect$Multiselect$nextItem = F2(
	function (list, item) {
		var findNextInList = function (l) {
			findNextInList:
			while (true) {
				if (!l.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						var x = l.a;
						return _Utils_eq(x, item) ? $elm$core$List$head(list) : $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var _v1 = l.b;
						var y = _v1.a;
						var rest = _v1.b;
						if (_Utils_eq(x, item)) {
							return $elm$core$Maybe$Just(y);
						} else {
							var $temp$l = A2($elm$core$List$cons, y, rest);
							l = $temp$l;
							continue findNextInList;
						}
					}
				}
			}
		};
		return findNextInList(list);
	});
var $inkuzmin$elm_multiselect$Multiselect$nextSelectedItem = F2(
	function (list, item) {
		var takeLast = function (l) {
			if (!l.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				if (!l.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v3 = l.b;
					var y = _v3.a;
					return $elm$core$Maybe$Just(y);
				}
			}
		};
		var findNextInList = function (l) {
			findNextInList:
			while (true) {
				if (!l.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						var x = l.a;
						return _Utils_eq(x, item) ? takeLast(
							$elm$core$List$reverse(list)) : $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var _v1 = l.b;
						var y = _v1.a;
						var rest = _v1.b;
						if (_Utils_eq(x, item)) {
							return $elm$core$Maybe$Just(y);
						} else {
							var $temp$l = A2($elm$core$List$cons, y, rest);
							l = $temp$l;
							continue findNextInList;
						}
					}
				}
			}
		};
		return findNextInList(list);
	});
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$pageDown = 34;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$pageUp = 33;
var $inkuzmin$elm_multiselect$Multiselect$prevItem = F2(
	function (list, item) {
		return A2(
			$inkuzmin$elm_multiselect$Multiselect$nextItem,
			$elm$core$List$reverse(list),
			item);
	});
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$return = 13;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$tab = 9;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow = 38;
var $inkuzmin$elm_multiselect$Multiselect$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
			case 4:
				return (model.jf === 2) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{jf: 0}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.Q))
							])),
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jf: 2}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.Q))
							])),
					$elm$core$Maybe$Nothing);
			case 1:
				return model.a8 ? _Utils_Tuple3(
					_Utils_update(
						model,
						{a8: false}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jf: 0}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a8: false}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 2:
				return model.a8 ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{a8: true, jf: 2}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.Q)),
								A2($inkuzmin$elm_multiselect$Multiselect$delayInMs, 100, $inkuzmin$elm_multiselect$Multiselect$DisableProtection)
							])),
					$elm$core$Maybe$Nothing);
			case 9:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lj: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_eq(model.E, $inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{E: ''}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing) : _Utils_Tuple3(
						_Utils_update(
							model,
							{lj: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				}
			case 8:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lj: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_eq(model.E, $inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{E: ''}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing) : _Utils_Tuple3(
						_Utils_update(
							model,
							{lj: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				}
			case 11:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fI: value}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 10:
				var value = msg.a;
				var filtered = A2(
					$inkuzmin$elm_multiselect$Multiselect$filter,
					model.P,
					A2(
						$elm$core$List$filter,
						function (_v5) {
							var val = _v5.b;
							return A2(
								$elm$core$String$contains,
								$elm$core$String$toLower(value),
								$elm$core$String$toLower(val));
						},
						model.jJ));
				if (model.a8) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{a8: false}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					var _v4 = model.C;
					if (_v4.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									B: filtered,
									C: $elm$core$List$head(filtered),
									E: value,
									jf: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					} else {
						var item = _v4.a;
						return (!$elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (i) {
									return _Utils_eq(i, item);
								},
								filtered))) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									B: filtered,
									C: $elm$core$List$head(filtered),
									E: value,
									jf: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									B: filtered,
									E: value,
									jf: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					}
				}
			case 5:
				var item = msg.a;
				var selected = _Utils_ap(
					model.P,
					_List_fromArray(
						[item]));
				var filtered = A2($inkuzmin$elm_multiselect$Multiselect$filter, selected, model.jJ);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							B: filtered,
							C: A2($inkuzmin$elm_multiselect$Multiselect$nextSelectedItem, model.B, item),
							E: $inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
							P: selected,
							jf: $elm$core$List$isEmpty(filtered) ? 0 : 2
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.Q))
							])),
					$elm$core$Maybe$Just(
						$inkuzmin$elm_multiselect$Multiselect$Selected(item)));
			case 6:
				var item = msg.a;
				var selected = A2(
					$elm$core$List$filter,
					function (value) {
						return !_Utils_eq(value, item);
					},
					model.P);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							B: A2($inkuzmin$elm_multiselect$Multiselect$filter, selected, model.jJ),
							C: $elm$core$Maybe$Just(item),
							P: selected
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$ScrollY,
								$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.Q))
							])),
					$elm$core$Maybe$Just(
						$inkuzmin$elm_multiselect$Multiselect$Unselected(item)));
			case 7:
				var selected = _List_Nil;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							B: A2($inkuzmin$elm_multiselect$Multiselect$filter, selected, model.jJ),
							E: $inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
							P: selected,
							jf: 0
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.Q))
							])),
					$elm$core$Maybe$Just($inkuzmin$elm_multiselect$Multiselect$Cleared));
			case 12:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 14:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lj: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					var y = result.a;
					var _v7 = model.C;
					if (_v7.$ === 1) {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					} else {
						var item = _v7.a;
						var _v8 = A2($inkuzmin$elm_multiselect$Multiselect$indexOf, item, model.B);
						if (_v8.$ === 1) {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						} else {
							var idx = _v8.a;
							var vpBoundaries = $inkuzmin$elm_multiselect$Multiselect$getViewPortBoundaries(y);
							var boundaries = $inkuzmin$elm_multiselect$Multiselect$getBoundaries(idx);
							var scroll = A2($inkuzmin$elm_multiselect$Multiselect$fitViewPort, boundaries, vpBoundaries);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{lj: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$inkuzmin$elm_multiselect$Multiselect$ScrollResult,
											A2($inkuzmin$elm_multiselect$Multiselect$domScrollToY, 'multiselectMenu' + model.Q, scroll))
										])),
								$elm$core$Maybe$Nothing);
						}
					}
				}
			default:
				var key = msg.a;
				if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow)) {
					var _v9 = model.C;
					if (_v9.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									C: $elm$core$List$head(model.B)
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					} else {
						var item = _v9.a;
						var prev = A2($inkuzmin$elm_multiselect$Multiselect$prevItem, model.B, item);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{C: prev}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$attempt,
										$inkuzmin$elm_multiselect$Multiselect$ScrollY,
										$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.Q))
									])),
							$elm$core$Maybe$Nothing);
					}
				} else {
					if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow)) {
						var _v10 = model.C;
						if (_v10.$ === 1) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										C: $elm$core$List$head(model.B)
									}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Nothing);
						} else {
							var item = _v10.a;
							var next = A2($inkuzmin$elm_multiselect$Multiselect$nextItem, model.B, item);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{C: next}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$inkuzmin$elm_multiselect$Multiselect$ScrollY,
											$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.Q))
										])),
								$elm$core$Maybe$Nothing);
						}
					} else {
						if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$pageUp) || _Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$home)) {
							var first = $elm$core$List$head(model.B);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{C: first}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$inkuzmin$elm_multiselect$Multiselect$ScrollY,
											$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.Q))
										])),
								$elm$core$Maybe$Nothing);
						} else {
							if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$pageDown) || _Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$end)) {
								var last = $inkuzmin$elm_multiselect$Multiselect$lastElem(model.B);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{C: last}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												$elm$core$Task$attempt,
												$inkuzmin$elm_multiselect$Multiselect$ScrollY,
												$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.Q))
											])),
									$elm$core$Maybe$Nothing);
							} else {
								if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$return)) {
									var _v11 = model.C;
									if (_v11.$ === 1) {
										var isInvisible = _Utils_eq(model.E, $inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter);
										var isEmpty = $elm$core$String$isEmpty(model.E);
										return (isInvisible || isEmpty) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : _Utils_Tuple3(
											model,
											$elm$core$Platform$Cmd$none,
											$elm$core$Maybe$Just(
												$inkuzmin$elm_multiselect$Multiselect$NotFound(model.E)));
									} else {
										var item = _v11.a;
										var selected = _Utils_ap(
											model.P,
											_List_fromArray(
												[item]));
										var filtered = A2($inkuzmin$elm_multiselect$Multiselect$filter, selected, model.jJ);
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{
													B: filtered,
													C: A2($inkuzmin$elm_multiselect$Multiselect$nextSelectedItem, model.B, item),
													E: $inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter,
													P: selected,
													jf: $elm$core$List$isEmpty(filtered) ? 0 : 2
												}),
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2(
														$elm$core$Task$attempt,
														$inkuzmin$elm_multiselect$Multiselect$FocusResult,
														$elm$browser$Browser$Dom$focus('multiselectInput' + model.Q))
													])),
											$elm$core$Maybe$Just(
												$inkuzmin$elm_multiselect$Multiselect$Selected(item)));
									}
								} else {
									if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$escape)) {
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{a8: true, jf: 0}),
											$elm$core$Platform$Cmd$none,
											$elm$core$Maybe$Nothing);
									} else {
										if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$tab)) {
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{jf: 0}),
												$elm$core$Platform$Cmd$none,
												$elm$core$Maybe$Nothing);
										} else {
											if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$backspace)) {
												if (model.E === '') {
													var _v12 = $inkuzmin$elm_multiselect$Multiselect$lastElem(model.P);
													if (_v12.$ === 1) {
														return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
													} else {
														var item = _v12.a;
														var selected = A2(
															$elm$core$List$filter,
															function (value) {
																return !_Utils_eq(value, item);
															},
															model.P);
														return _Utils_Tuple3(
															_Utils_update(
																model,
																{
																	B: A2($inkuzmin$elm_multiselect$Multiselect$filter, selected, model.jJ),
																	C: $elm$core$Maybe$Just(item),
																	P: selected
																}),
															$elm$core$Platform$Cmd$batch(
																_List_fromArray(
																	[
																		A2(
																		$elm$core$Task$attempt,
																		$inkuzmin$elm_multiselect$Multiselect$ScrollY,
																		$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.Q))
																	])),
															$elm$core$Maybe$Just(
																$inkuzmin$elm_multiselect$Multiselect$Unselected(item)));
													}
												} else {
													return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
												}
											} else {
												return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
											}
										}
									}
								}
							}
						}
					}
				}
		}
	});
var $author$project$PlugMap$Plugins$FeaturePicker$FeaturesLoadError = function (a) {
	return {$: 3, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$FeaturesSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$Loading = function (a) {
	return {$: 1, a: a};
};
var $author$project$PlugMap$Plugins$FeaturePicker$responseFromToString = function (from) {
	if (!from) {
		return 'Select';
	} else {
		return 'SetLayer';
	}
};
var $author$project$PlugMap$Plugins$FeaturePicker$encodeNormalizeEsri = function (request) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from',
				$elm$json$Json$Encode$string(
					$author$project$PlugMap$Plugins$FeaturePicker$responseFromToString(request.eq))),
				_Utils_Tuple2(
				'esri',
				$elm$json$Json$Encode$string(request.fm)),
				_Utils_Tuple2(
				'showGeometry',
				$elm$json$Json$Encode$bool(request.gk))
			]));
};
var $author$project$PlugMap$Plugins$FeaturePicker$xmlToJsTypeToString = function (typ) {
	return 'WFS';
};
var $author$project$PlugMap$Plugins$FeaturePicker$encodeXMLToJsRequest = function (result) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$PlugMap$Plugins$FeaturePicker$xmlToJsTypeToString(result.eZ))),
				_Utils_Tuple2(
				'xml',
				$elm$json$Json$Encode$string(result.gB))
			]));
};
var $author$project$PlugMap$Plugins$FeaturePicker$esriFeatureToFeature = F2(
	function (lyr, feat) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2('id', 'name'),
			A2(
				$elm$core$Maybe$map,
				function (l) {
					var _v1 = l.hd;
					if (!_v1.$) {
						var config = _v1.a;
						return _Utils_Tuple2(config.et, config.mw);
					} else {
						return _Utils_Tuple2('id', 'name');
					}
				},
				lyr));
		var idField = _v0.a;
		var nameField = _v0.b;
		return {
			bH: A2(
				$elm$core$Maybe$map,
				function (itm) {
					switch (itm.$) {
						case 0:
							var str = itm.a;
							return A2(
								$elm$core$Maybe$withDefault,
								-1,
								$elm$core$String$toFloat(str));
						case 1:
							var _float = itm.a;
							return _float;
						case 2:
							var _int = itm.a;
							return _int;
						default:
							return -1;
					}
				},
				A2($elm$core$Dict$get, 'acres', feat.b5)),
			lD: feat.lD,
			ab: A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function (itm) {
						switch (itm.$) {
							case 0:
								var str = itm.a;
								return A2(
									$elm$core$Maybe$withDefault,
									-1,
									$elm$core$String$toInt(str));
							case 2:
								var _int = itm.a;
								return _int;
							case 1:
								var _float = itm.a;
								return -1;
							default:
								return -1;
						}
					},
					A2($elm$core$Dict$get, idField, feat.b5))),
			dz: A2(
				$elm$core$Maybe$withDefault,
				'Unknown',
				A2(
					$elm$core$Maybe$map,
					function (itm) {
						switch (itm.$) {
							case 0:
								var str = itm.a;
								return str;
							case 2:
								var _int = itm.a;
								return $elm$core$String$fromInt(_int);
							case 1:
								var _float = itm.a;
								return $elm$core$String$fromFloat(_float);
							default:
								return 'Unknown';
						}
					},
					A2($elm$core$Dict$get, nameField, feat.b5))),
			fW: -1
		};
	});
var $author$project$PlugMap$Plugins$FeaturePicker$noop = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$PlugMap$Plugins$FeaturePicker$normalizeEsri = _Platform_outgoingPort('normalizeEsri', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$FeaturePicker$xmlToJs = _Platform_outgoingPort('xmlToJs', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$FeaturePicker$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var from = msg.a;
				var result = msg.b;
				var _v1 = _Utils_Tuple2(from, result);
				if (!_v1.b.$) {
					if (_v1.a === 1) {
						var _v2 = _v1.a;
						var res = _v1.b.a;
						return _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$PlugMap$Plugins$FeaturePicker$xmlToJs(
										$author$project$PlugMap$Plugins$FeaturePicker$encodeXMLToJsRequest(
											{gf: $elm$core$Maybe$Nothing, eZ: 0, gB: res}))
									])));
					} else {
						return $author$project$PlugMap$Plugins$FeaturePicker$noop(model);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var from = msg.a;
				var feats = msg.b;
				return _Utils_Tuple2(
					model,
					$author$project$PlugMap$Plugins$FeaturePicker$normalizeEsri(
						$author$project$PlugMap$Plugins$FeaturePicker$encodeNormalizeEsri(
							{fm: feats, eq: from, gk: true, gv: $elm$core$Maybe$Nothing})));
			case 3:
				var error = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						function (dontCareAboutThisValue) {
							return $author$project$PlugMap$Plugins$FeaturePicker$FeaturesLoadError(error);
						},
						$elm$core$Task$succeed('Hello')));
			case 5:
				var error = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						function (dontCareAboutThisValue) {
							return $author$project$PlugMap$Plugins$FeaturePicker$FeaturesLoadError(error);
						},
						$elm$core$Task$succeed('Hello')));
			case 4:
				var res = msg.a;
				var _v3 = res.eq;
				if (_v3 === 1) {
					if ((model.cc - 1) > 0) {
						var oldFeats = function () {
							var _v4 = model.bD;
							if (_v4.$ === 1) {
								var featz = _v4.a;
								return featz;
							} else {
								return _List_Nil;
							}
						}();
						var allFeats = _Utils_ap(
							oldFeats,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$map(
										$author$project$PlugMap$Plugins$FeaturePicker$esriFeatureToFeature(model.bT)),
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.dp;
										},
										res.gv))));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bD: $author$project$PlugMap$Plugins$FeaturePicker$Loading(allFeats),
									cc: model.cc - 1
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var oldFeats = function () {
							var _v5 = model.bD;
							if (_v5.$ === 1) {
								var featz = _v5.a;
								return featz;
							} else {
								return _List_Nil;
							}
						}();
						var allFeats = _Utils_ap(
							oldFeats,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$elm$core$List$map(
										$author$project$PlugMap$Plugins$FeaturePicker$esriFeatureToFeature(model.bT)),
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.dp;
										},
										res.gv))));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bD: $author$project$PlugMap$Plugins$FeaturePicker$Loaded(allFeats),
									cc: 0
								}),
							A2(
								$elm$core$Task$perform,
								function (dontCareAboutThisValue) {
									return $author$project$PlugMap$Plugins$FeaturePicker$FeaturesLoaded(allFeats);
								},
								$elm$core$Task$succeed('Hello')));
					}
				} else {
					if ($elm$core$List$length(
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.dp;
								},
								res.gv))) > 0) {
						var allFeats = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$map(
									$author$project$PlugMap$Plugins$FeaturePicker$esriFeatureToFeature(model.bT)),
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.dp;
									},
									res.gv)));
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$perform,
								function (dontCareAboutThisValue) {
									return $author$project$PlugMap$Plugins$FeaturePicker$FeaturesSelected(allFeats);
								},
								$elm$core$Task$succeed('Hello')));
					} else {
						return $author$project$PlugMap$Plugins$FeaturePicker$noop(model);
					}
				}
			case 6:
				var id = msg.a;
				return A4(
					$author$project$PlugMap$Plugins$FeaturePicker$getSingleFeature,
					model.cW,
					model.bT,
					id,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			default:
				return $author$project$PlugMap$Plugins$FeaturePicker$noop(model);
		}
	});
var $author$project$PlugMap$Plugins$Upload$noop = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$PlugMap$Plugins$Upload$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var feats = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jf: $author$project$PlugMap$Plugins$Upload$Done}),
					A2(
						$elm$core$Task$perform,
						function (dontCareAboutThisValue) {
							return $author$project$PlugMap$Plugins$Upload$FeaturesUploaded(feats);
						},
						$elm$core$Task$succeed('Hello')));
			case 1:
				var status = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jf: status.jf}),
					$elm$core$Platform$Cmd$none);
			default:
				return $author$project$PlugMap$Plugins$Upload$noop(model);
		}
	});
var $author$project$PlugMap$Plugins$Drawing$setExtentByFeatueId = _Platform_outgoingPort('setExtentByFeatueId', $elm$core$Basics$identity);
var $author$project$PlugMap$Plugins$Drawing$zoomToFeatureById = F4(
	function (model, id, leftPadding, bottomPadding) {
		return _Utils_Tuple2(
			model,
			$author$project$PlugMap$Plugins$Drawing$setExtentByFeatueId(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'id',
							$elm$json$Json$Encode$int(id)),
							_Utils_Tuple2(
							'left',
							$elm$json$Json$Encode$int(leftPadding)),
							_Utils_Tuple2(
							'bottom',
							$elm$json$Json$Encode$int(bottomPadding))
						]))));
	});
var $author$project$CWS$DrawEditMap$zoomToFeatureById = F4(
	function (model, id, leftPadding, bottomPadding) {
		var _v0 = A4($author$project$PlugMap$Plugins$Drawing$zoomToFeatureById, model.o, id, leftPadding, bottomPadding);
		var dmo = _v0.a;
		var dme = _v0.b;
		var msg = A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, dme);
		return _Utils_Tuple2(model, msg);
	});
var $author$project$CWS$DrawEditMap$toolboxUpdate = F2(
	function (model, msg) {
		switch (msg.$) {
			case 1:
				return $author$project$CWS$DrawEditMap$handleDrawClicked(model);
			case 2:
				return $author$project$CWS$DrawEditMap$handleUploadClicked(model);
			case 3:
				return $author$project$CWS$DrawEditMap$handleReferenceClicked(model);
			case 6:
				var sub = msg.a;
				return A2($author$project$CWS$DrawEditMap$handleDrawingMsg, model, sub);
			case 7:
				var tool = msg.a;
				return A2($author$project$CWS$DrawEditMap$setupDrawingTool, model, tool);
			case 8:
				var spatial = msg.a;
				return A2($author$project$CWS$DrawEditMap$addShape, model, spatial);
			case 11:
				var spatial = msg.a;
				return A2($author$project$CWS$DrawEditMap$handleModifyEnd, model, spatial);
			case 29:
				return $author$project$CWS$DrawEditMap$lockUpdating(model);
			case 10:
				var buffer = msg.a;
				return A2($author$project$CWS$DrawEditMap$setAndUpdateBuffer, model, buffer);
			case 14:
				var id = msg.a;
				return A2($author$project$CWS$DrawEditMap$setFeatureToEdit, model, id);
			case 15:
				var id = msg.a;
				return A2($author$project$CWS$DrawEditMap$deleteFeature, model, id);
			case 12:
				var flat = msg.a;
				return A2($author$project$CWS$DrawEditMap$handleFlatRecalculated, model, flat);
			case 13:
				var id = msg.a;
				var leftPadding = msg.b;
				var bottomPadding = msg.c;
				return A4($author$project$CWS$DrawEditMap$zoomToFeatureById, model, id, leftPadding, bottomPadding);
			case 17:
				var layer = msg.a;
				var selectModel = model.e;
				var _v1 = A2($author$project$PlugMap$Plugins$FeaturePicker$setReferenceLayer, model.e.N, layer);
				var fpm = _v1.a;
				var fpc = _v1.b;
				var sm = _Utils_update(
					selectModel,
					{
						N: fpm,
						bW: 1,
						an: A2($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, ''),
						b_: 1,
						P: layer,
						as: _List_Nil
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e: sm}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, fpc),
								A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always(
									$author$project$CWS$DrawEditMap$Internal(
										$author$project$CWS$DrawEditMap$SetLayer(
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.v;
												},
												layer)))),
								$elm$core$Task$succeed('Hi'))
							])));
			case 18:
				var selectModel = model.e;
				var sm = _Utils_update(
					selectModel,
					{
						b_: function () {
							var _v2 = selectModel.b_;
							if (!_v2) {
								return 1;
							} else {
								return 0;
							}
						}()
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e: sm}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var sub = msg.a;
				var selectModel = model.e;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.e.an);
				var a = _v3.a;
				var b = _v3.b;
				var c = _v3.c;
				var _v4 = function () {
					_v5$3:
					while (true) {
						if (!c.$) {
							switch (c.a.$) {
								case 0:
									var _v6 = c.a.a;
									var x = _v6.a;
									var y = _v6.b;
									var featId = A2(
										$elm$core$Maybe$withDefault,
										-1,
										$elm$core$String$toInt(x));
									var _v7 = A2($author$project$PlugMap$Plugins$FeaturePicker$select, featId, model.e.N);
									var f = _v7.a;
									var co = _v7.b;
									return _Utils_Tuple2(
										f,
										$elm$core$Maybe$Just(
											A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, co)));
								case 1:
									var _v8 = c.a.a;
									var x = _v8.a;
									var y = _v8.b;
									var featId = A2(
										$elm$core$Maybe$withDefault,
										-1,
										$elm$core$String$toInt(x));
									var _v9 = A2($author$project$PlugMap$Plugins$FeaturePicker$deselect, featId, model.e.N);
									var f = _v9.a;
									var co = _v9.b;
									return _Utils_Tuple2(
										f,
										$elm$core$Maybe$Just(
											A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, co)));
								case 2:
									var _v10 = c.a;
									var _v11 = $author$project$PlugMap$Plugins$FeaturePicker$clear(model.e.N);
									var f = _v11.a;
									var co = _v11.b;
									return _Utils_Tuple2(
										f,
										$elm$core$Maybe$Just(
											A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, co)));
								default:
									break _v5$3;
							}
						} else {
							break _v5$3;
						}
					}
					return _Utils_Tuple2(model.e.N, $elm$core$Maybe$Nothing);
				}();
				var nfp = _v4.a;
				var nfpc = _v4.b;
				var ns = _Utils_update(
					selectModel,
					{
						N: nfp,
						an: a,
						as: function () {
							_v12$2:
							while (true) {
								if (!c.$) {
									switch (c.a.$) {
										case 2:
											var _v13 = c.a;
											return _List_Nil;
										case 1:
											var _v14 = c.a.a;
											var x = _v14.a;
											var y = _v14.b;
											var featId = A2(
												$elm$core$Maybe$withDefault,
												-1,
												$elm$core$String$toInt(x));
											return A2(
												$elm$core$List$filter,
												function (itm) {
													return !_Utils_eq(itm.ab, featId);
												},
												model.e.as);
										default:
											break _v12$2;
									}
								} else {
									break _v12$2;
								}
							}
							return model.e.as;
						}()
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e: ns}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									$elm$core$Maybe$Just(
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$CWS$DrawEditMap$Internal,
										A2(
											$elm$core$Platform$Cmd$map,
											$author$project$CWS$DrawEditMap$Toolbox,
											A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$MultiMessage, b)))),
									nfpc
								]))));
			case 20:
				var sub = msg.a;
				var os = model.e;
				var _v15 = A2($author$project$PlugMap$Plugins$FeaturePicker$update, sub, model.e.N);
				var nfp = _v15.a;
				var nc = _v15.b;
				var ns = _Utils_update(
					os,
					{N: nfp});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e: ns}),
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, nc));
			case 21:
				var feats = msg.a;
				var osm = model.e;
				var msm = A2(
					$inkuzmin$elm_multiselect$Multiselect$initModel,
					A2(
						$elm$core$List$map,
						function (feature) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(feature.ab),
								feature.dz);
						},
						A2(
							$elm$core$List$sortBy,
							function (a) {
								return A3(
									$elm$core$String$replace,
									'\"',
									'',
									$elm$core$String$toLower(a.dz));
							},
							feats)),
					'');
				var sm = _Utils_update(
					osm,
					{dY: feats, bW: 2, an: msm});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e: sm}),
					$elm$core$Platform$Cmd$none);
			case 23:
				var feats = msg.a;
				var osm = model.e;
				var oldSelectedItems = $elm$core$Dict$fromList(
					$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(osm.an));
				var newSelectedItems = $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (a) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(a.ab),
								a.dz);
						},
						feats));
				var iAsDict = $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (itm) {
							return _Utils_Tuple2(itm.ab, itm);
						},
						osm.as));
				var fAsDict = $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (a) {
							return _Utils_Tuple2(a.ab, a);
						},
						feats));
				var uDict = A2($elm$core$Dict$union, iAsDict, fAsDict);
				var ff = $elm$core$Dict$values(uDict);
				var allSelectedItems = A2($elm$core$Dict$union, oldSelectedItems, newSelectedItems);
				var ms = A3(
					$inkuzmin$elm_multiselect$Multiselect$populateValues,
					model.e.an,
					A2(
						$elm$core$List$map,
						function (a) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(a.ab),
								a.dz);
						},
						osm.dY),
					$elm$core$Dict$toList(allSelectedItems));
				var sm = _Utils_update(
					osm,
					{an: ms, aR: osm.aR - 1, as: ff});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e: sm}),
					$elm$core$Platform$Cmd$none);
			case 24:
				var selectModel = model.e;
				var _v16 = $author$project$PlugMap$Plugins$FeaturePicker$hideReferenceLayer(model.e.N);
				var fpm = _v16.a;
				var fpc = _v16.b;
				var sm = _Utils_update(
					selectModel,
					{
						N: fpm,
						bW: 0,
						an: A2($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, ''),
						b_: 1,
						P: $elm$core$Maybe$Nothing,
						as: _List_Nil
					});
				var _v17 = A2(
					$author$project$PlugMap$Plugins$Drawing$addSelectedReferenceItems,
					model.o,
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$map,
							function (a) {
								var _v18 = _Utils_Tuple2(a.lD, a.bH);
								if (!_v18.a.$) {
									if (!_v18.b.$) {
										var geo = _v18.a.a;
										var acres = _v18.b.a;
										return $elm$core$Maybe$Just(
											{bH: acres, bc: geo});
									} else {
										var geo = _v18.a.a;
										return $elm$core$Maybe$Just(
											{bH: -1, bc: geo});
									}
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							model.e.as)));
				var dre = _v17.a;
				var drc = _v17.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{o: dre, e: sm, H: $author$project$CWS$DrawEditMap$None}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$featurePickerTranslator, fpc),
								A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, drc),
								A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always(
									$author$project$CWS$DrawEditMap$Internal(
										$author$project$CWS$DrawEditMap$SetLayer($elm$core$Maybe$Nothing))),
								$elm$core$Task$succeed('Hi'))
							])));
			case 25:
				var _v19 = $author$project$PlugMap$Plugins$Upload$chooseFile(model.aX);
				var um = _v19.a;
				var uc = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aX: um}),
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$uploadTranslator, uc));
			case 26:
				var sub = msg.a;
				var _v20 = A2($author$project$PlugMap$Plugins$Upload$update, sub, model.aX);
				var um = _v20.a;
				var uc = _v20.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aX: um}),
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$uploadTranslator, uc));
			case 27:
				var feats = msg.a;
				var _v21 = A2(
					$author$project$PlugMap$Plugins$Drawing$addWKTs,
					model.o,
					A2(
						$elm$core$List$map,
						function (a) {
							return {bH: a.bH, bc: a.bc};
						},
						feats));
				var dre = _v21.a;
				var drc = _v21.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{o: dre, H: $author$project$CWS$DrawEditMap$None}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$drawingTranslator, drc)
							])));
			case 22:
				var err = msg.a;
				var osm = model.e;
				var nsm = _Utils_update(
					osm,
					{bW: 3});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e: nsm}),
					$elm$core$Platform$Cmd$none);
			case 28:
				var osm = model.e;
				var nsm = _Utils_update(
					osm,
					{aR: osm.aR + 1});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{e: nsm}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var flat = msg.a;
				return A2($author$project$CWS$DrawEditMap$handleFlatReceived, model, flat);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$PlugMap$Plugins$Identify$update = F2(
	function (model, msg) {
		if (!msg.$) {
			var results = msg.a;
			return ($elm$core$List$length(results.iV) > 0) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{
						fd: $elm$core$Maybe$Just(results),
						gi: $elm$core$Maybe$Just(0),
						gm: true
					}),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$DrawEditMap$noop = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$CWS$DrawEditMap$Msg_Drawing = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$DrawEditMap$updateDrawNoOut = F2(
	function (model, _v0) {
		var nd = _v0.a;
		var nc = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{ej: nd}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$CWS$DrawEditMap$Internal,
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$CWS$DrawEditMap$PluginMessage,
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$Msg_Drawing, nc))));
	});
var $author$project$CWS$DrawEditMap$updateDraw = F2(
	function (model, _v0) {
		var nd = _v0.a;
		var nc = _v0.b;
		var omnom = _v0.c;
		return A2(
			$author$project$CWS$DrawEditMap$updateDrawNoOut,
			model,
			_Utils_Tuple2(nd, nc));
	});
var $author$project$CWS$DrawEditMap$updatePlugin = F2(
	function (model, sub) {
		if (sub.$ === 1) {
			var msg = sub.a;
			return A2(
				$author$project$CWS$DrawEditMap$updateDraw,
				model,
				A2($author$project$PlugMap$Plugins$Drawing$update, model.ej, msg));
		} else {
			return $author$project$CWS$DrawEditMap$noop(model);
		}
	});
var $author$project$CWS$DrawEditMap$update = F2(
	function (model, msg) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var mlayer = msg.a;
				if (!mlayer.$) {
					var layer = mlayer.a;
					var cats = A2($author$project$PlugMap$Plugins$Themes$getCategoryFromLayerKey, model.om, layer);
					var nt = A2(
						$elm$core$Maybe$withDefault,
						model.om,
						A2(
							$elm$core$Maybe$map,
							function (c) {
								return A3($author$project$PlugMap$Plugins$Themes$toggleLayerSelection, layer, c, model.om);
							},
							$elm$core$List$head(cats)));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{om: nt}),
						$author$project$PlugMap$Plugins$Themes$toggleSelectedThemesCmd(
							$author$project$PlugMap$Plugins$Themes$encodeSelectedThemes(nt)));
				} else {
					var refCat = A2($author$project$PlugMap$Plugins$Themes$getCategoryByKey, model.om, 'ref');
					var nt2 = A2($author$project$PlugMap$Plugins$Themes$resetCategory, 'cat_reference', model.om);
					var nt = A2($author$project$PlugMap$Plugins$Themes$resetCategory, 'cat_fam', nt2);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{om: nt}),
						$author$project$PlugMap$Plugins$Themes$toggleSelectedThemesCmd(
							$author$project$PlugMap$Plugins$Themes$encodeSelectedThemes(nt)));
				}
			case 3:
				var flags = msg.a;
				var settings = msg.b;
				var user = msg.c;
				var spatial = msg.d;
				var flat = msg.e;
				return A6($author$project$CWS$DrawEditMap$initStep, model, flags, settings, user, spatial, flat);
			case 4:
				var spatial = msg.a;
				var flat = msg.b;
				return A3($author$project$CWS$DrawEditMap$initSpatial, model, spatial, flat);
			case 9:
				var services = msg.a;
				return A2($author$project$CWS$DrawEditMap$setServices, model, services);
			case 8:
				var sub = msg.a;
				return A2($author$project$CWS$DrawEditMap$updatePlugin, model, sub);
			case 13:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{da: item}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{da: ''}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var color = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c9: color}),
					$elm$core$Platform$Cmd$none);
			case 16:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c9: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var wkt = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$PlugMap$Core$Ports$fitToWktCmd(
						$elm$json$Json$Encode$string(wkt)));
			case 18:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eU: $author$project$PAM$UI$Basic$flipOpenness(model.eU)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var m = msg.a;
				var _v2 = A2($author$project$PlugMap$Plugins$Identify$update, model.a3, m);
				var im = _v2.a;
				var ic = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a3: im}),
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$DrawEditMap$identifyTranslator, ic));
			case 5:
				if (msg.a === 1) {
					var _v3 = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								$author$project$CWS$DrawEditMap$Internal($author$project$CWS$DrawEditMap$ClearColor)),
							$elm$core$Process$sleep(200)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var sub = msg.a;
				var _v4 = A2($author$project$CWS$DrawEditMap$toolboxUpdate, model.A, sub);
				var tb = _v4.a;
				var tbc = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{A: tb}),
					tbc);
			case 19:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dO: function () {
								var _v5 = model.dO;
								if (!_v5) {
									return 1;
								} else {
									return 0;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$ActionDetail$updateMap = F2(
	function (model, subMsg) {
		var otherCmds = $elm$core$Platform$Cmd$none;
		var oldState = model.a;
		var oldSpatial = model.aZ;
		var oldAction = model.c;
		var newState = oldState;
		var newSpatial = oldSpatial;
		var newAction_ = oldAction;
		var _v0 = A2($author$project$CWS$DrawEditMap$update, model.q, subMsg);
		var newMap = _v0.a;
		var newMapCmd = _v0.b;
		var xModel = _Utils_update(
			model,
			{c: newAction_, q: newMap, a: newState, aZ: newSpatial});
		var newModel = xModel;
		var _v1 = _Utils_Tuple2(newMap, newMapCmd);
		var finalMap = _v1.a;
		var finalMapCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				newModel,
				{
					aF: $author$project$CWS$ActionDetail$validate(newModel)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, finalMapCmd),
						otherCmds
					])));
	});
var $author$project$CWS$ActionDetail$updateSpatial = F3(
	function (model, result, workInProgress) {
		var _v0 = _Utils_Tuple2(model.c, result);
		if (_v0.a.$ === 2) {
			if (_v0.b.$ === 1) {
				var action = _v0.a.a;
				var _v1 = _v0.b;
				var spatial = _v1.a;
				var rounded = function (r) {
					return A2(
						$elm$core$Maybe$withDefault,
						$author$project$Fields$Shared$Invalid(r),
						A2(
							$elm$core$Maybe$map,
							function (asFloat) {
								return A2($author$project$Fields$Shared$Valid, asFloat, r);
							},
							$elm$core$String$toFloat(r)));
				}(
					A2($myrho$elm_round$Round$floor, 2, spatial.bH));
				var updAction = _Utils_update(
					action,
					{
						bH: rounded,
						I: $elm$core$Maybe$Just(
							{ab: -1, I: spatial.bc})
					});
				var os = model.a;
				var ns = _Utils_update(
					os,
					{am: true});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$CWS$Model$Loaded(updAction),
							bX: false,
							a: ns,
							aZ: workInProgress
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var action = _v0.a.a;
				var updAction = _Utils_update(
					action,
					{bH: $author$project$Fields$Shared$NotEntered, I: $elm$core$Maybe$Nothing});
				var os = model.a;
				var ns = _Utils_update(
					os,
					{am: true});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$CWS$Model$Loaded(updAction),
							bX: false,
							a: ns,
							aZ: workInProgress
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$ActionDetail$canUpload = function (model) {
	var _v0 = model.c;
	if (_v0.$ === 2) {
		var action = _v0.a;
		return ((action.ab > 0) && ((model.bd === 1) && ((action.jf === 1) || (action.jf === 3)))) ? true : false;
	} else {
		return false;
	}
};
var $author$project$CWS$ActionDetail$updateUpload = F3(
	function (model, subMsg, env) {
		var oldState = model.a;
		var _v0 = function () {
			var odum = model.a.ba;
			var dum = _Utils_update(
				odum,
				{
					g3: $author$project$CWS$ActionDetail$canUpload(model),
					g4: $author$project$CWS$ActionDetail$canUpload(model)
				});
			var _v1 = A3($author$project$CWS$UploadDocuments$update, subMsg, dum, env);
			var changedModel = _v1.a;
			var changedMsg = _v1.b;
			var outMsg = _v1.c;
			return _Utils_Tuple2(
				changedModel,
				A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$UploadDocumentsMsg, changedMsg));
		}();
		var newUploadDocumentsModel = _v0.a;
		var newUploadDocumentsMsg = _v0.b;
		var newState = _Utils_update(
			oldState,
			{ba: newUploadDocumentsModel});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[newUploadDocumentsMsg])));
	});
var $author$project$CWS$DrawEditMap$zoomToWkt = F4(
	function (wkt, model, leftPadding, bottomPadding) {
		return _Utils_Tuple2(
			model,
			$author$project$PlugMap$Core$Ports$fitToWktCmd(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'wkt',
							$elm$json$Json$Encode$string(wkt)),
							_Utils_Tuple2(
							'left',
							$elm$json$Json$Encode$int(leftPadding)),
							_Utils_Tuple2(
							'bottom',
							$elm$json$Json$Encode$int(bottomPadding))
						]))));
	});
var $author$project$CWS$ActionDetail$update = F3(
	function (model, msg, env) {
		switch (msg.$) {
			case 32:
				var apimsg = msg.a;
				var _v1 = A2($author$project$CWS$API$Action$update, model.cm, apimsg);
				var newApi = _v1.a;
				var newApiCmd = _v1.b;
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{cm: newApi}),
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$actionAPITranslator, newApiCmd)));
			case 33:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(1));
			case 2:
				var target = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A2($author$project$CWS$ActionDetail$changeSection, model, target));
			case 3:
				var subMsg = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A3($author$project$CWS$ActionDetail$updateUpload, model, subMsg, env));
			case 4:
				var subMsg = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A2($author$project$CWS$ActionDetail$updateMap, model, subMsg));
			case 6:
				var deets = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A3($author$project$CWS$ActionDetail$handleLoadedDetails, model, deets, env));
			case 7:
				var actionDetails = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A3(
						$author$project$CWS$ActionDetail$handleLoadedDetails,
						model,
						$elm$core$Result$Ok(actionDetails),
						env));
			case 8:
				var err = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A3(
						$author$project$CWS$ActionDetail$handleLoadedDetails,
						model,
						$elm$core$Result$Err(err),
						env));
			case 9:
				var deets = msg.a;
				if (!deets.$) {
					return $author$project$CWS$ActionDetail$closeModal(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				} else {
					return $author$project$CWS$ActionDetail$noOut(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 10:
				var action = msg.a;
				return $author$project$CWS$ActionDetail$closeModal(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 11:
				var err = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 12:
				var deets = msg.a;
				if (!deets.$) {
					return $author$project$CWS$ActionDetail$closeModal(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				} else {
					return $author$project$CWS$ActionDetail$noOut(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			case 13:
				var action = msg.a;
				return $author$project$CWS$ActionDetail$closeModal(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 14:
				var err = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 15:
				var action = msg.a;
				return $author$project$CWS$ActionDetail$closeModal(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 16:
				var err = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 17:
				var result = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A3($author$project$CWS$ActionDetail$handleSavedDetails, model, result, env));
			case 20:
				var year = msg.a;
				var newModel = _Utils_update(
					model,
					{W: year});
				return $author$project$CWS$ActionDetail$noOut(
					A2($author$project$CWS$ActionDetail$handleSaveClicked, newModel, env));
			case 21:
				var year = msg.a;
				var newModel = _Utils_update(
					model,
					{W: year});
				return $author$project$CWS$ActionDetail$noOut(
					$author$project$CWS$ActionDetail$handleSubmitClicked(newModel));
			case 22:
				return $author$project$CWS$ActionDetail$noOut(
					A2($author$project$CWS$ActionDetail$handleApproveClicked, model, env));
			case 23:
				return $author$project$CWS$ActionDetail$noOut(
					A2($author$project$CWS$ActionDetail$handleDenyClicked, model, env));
			case 25:
				var cmds = A2($author$project$CWS$ActionDetail$delete, model, env);
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(model, cmds));
			case 24:
				var newAction_ = msg.a;
				var valid = $author$project$CWS$ActionDetail$validate(
					_Utils_update(
						model,
						{c: newAction_}));
				var oldState = model.a;
				var newState = _Utils_update(
					oldState,
					{am: true});
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{c: newAction_, a: newState, aF: valid}),
						$elm$core$Platform$Cmd$none));
			case 26:
				var newModel = model;
				return $author$project$CWS$ActionDetail$noOut(
					A3($author$project$CWS$ActionDetail$saveClickedNew, newModel, 1, env));
			case 27:
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{aJ: $author$project$CWS$Model$NoDynConfirmation}),
						$elm$core$Platform$Cmd$none));
			case 28:
				var step = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A3($author$project$CWS$ActionDetail$handleSaveStep, model, step, env));
			case 29:
				var action = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A3(
						$author$project$CWS$ActionDetail$handleSaveStep,
						model,
						$elm$core$Result$Ok(action),
						env));
			case 30:
				var err = msg.a;
				return $author$project$CWS$ActionDetail$noOut(
					A3(
						$author$project$CWS$ActionDetail$handleSaveStep,
						model,
						$elm$core$Result$Err(err),
						env));
			case 31:
				var which = msg.a;
				var sub = msg.b;
				return $author$project$CWS$ActionDetail$noOut(
					A3($author$project$CWS$ActionDetail$handleDatePicker, model, which, sub));
			case 35:
				var spatial = msg.a;
				var all = msg.b;
				return $author$project$CWS$ActionDetail$noOut(
					A3($author$project$CWS$ActionDetail$updateSpatial, model, spatial, all));
			case 36:
				return $author$project$CWS$ActionDetail$noOut(
					$author$project$CWS$ActionDetail$mapUpdating(model));
			case 34:
				var ol = A2($author$project$PlugMap$Plugins$Themes$getLayer, model.q.om, 'lyr_pe_filter');
				var nl = A2(
					$elm$core$Maybe$map,
					function (layer) {
						var _v14 = model.a.cQ;
						if (_v14.$ === 2) {
							var pe = _v14.a;
							return A2($author$project$CWS$ActionDetail$peActionLayer, pe, layer);
						} else {
							return layer;
						}
					},
					ol);
				var _v4 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.q, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var mdl = _v5.a;
							var cm = _v5.b;
							return _Utils_Tuple2(
								mdl,
								A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, cm));
						},
						A2(
							$elm$core$Maybe$map,
							function (layer) {
								return A2($author$project$CWS$DrawEditMap$updateLayer, model.q, layer);
							},
							nl)));
				var mmm = _v4.a;
				var mmmc = _v4.b;
				var _v6 = function () {
					var _v7 = model.c;
					if (_v7.$ === 2) {
						var action = _v7.a;
						var _v8 = action.I;
						if (!_v8.$) {
							var s = _v8.a;
							return function (_v9) {
								var a = _v9.a;
								var b = _v9.b;
								return _Utils_Tuple2(
									a,
									A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, b));
							}(
								A4($author$project$CWS$DrawEditMap$zoomToWkt, s.I, model.q, 0, 0));
						} else {
							var _v10 = model.a.cQ;
							if (_v10.$ === 2) {
								var pe = _v10.a;
								return function (_v11) {
									var a = _v11.a;
									var b = _v11.b;
									return _Utils_Tuple2(
										a,
										A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, b));
								}(
									A4($author$project$CWS$DrawEditMap$zoomToWkt, pe.bc, model.q, 0, 0));
							} else {
								return _Utils_Tuple2(model.q, $elm$core$Platform$Cmd$none);
							}
						}
					} else {
						var _v12 = model.a.cQ;
						if (_v12.$ === 2) {
							var pe = _v12.a;
							return function (_v13) {
								var a = _v13.a;
								var b = _v13.b;
								return _Utils_Tuple2(
									a,
									A2($elm$core$Platform$Cmd$map, $author$project$CWS$ActionDetail$mapTranslater, b));
							}(
								A4($author$project$CWS$DrawEditMap$zoomToWkt, pe.bc, model.q, 0, 0));
						} else {
							return _Utils_Tuple2(model.q, $elm$core$Platform$Cmd$none);
						}
					}
				}();
				var mm = _v6.a;
				var mc = _v6.b;
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{q: mm}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[mc, mmmc]))));
			default:
				return $author$project$CWS$ActionDetail$noOut(
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$CWS$updateActionDetails = F5(
	function (model, sub, id, category, group) {
		var oldState = model.a;
		var _v0 = _Utils_Tuple2(oldState.x, $elm$core$Platform$Cmd$none);
		var oldActionDetailModel = _v0.a;
		var initCmds = _v0.b;
		var _v1 = A3(
			$author$project$CWS$ActionDetail$update,
			oldActionDetailModel,
			sub,
			{m: model.p.m.av, f: model.f});
		var newActionDetail = _v1.a;
		var newActionDetailCmds = _v1.b;
		var actionDetailOut = _v1.c;
		var newState = _Utils_update(
			oldState,
			{x: newActionDetail});
		var nm = _Utils_update(
			model,
			{a: newState});
		var nc = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, newActionDetailCmds);
		if (!actionDetailOut.$) {
			if (!actionDetailOut.a) {
				var _v3 = actionDetailOut.a;
				var _v4 = A2($author$project$CWS$closeModalUpdate, nm, false);
				var a = _v4.a;
				var b = _v4.b;
				return _Utils_Tuple2(
					a,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[b, nc])));
			} else {
				var _v5 = actionDetailOut.a;
				var _v6 = $author$project$InPageOAuth$regetAuthorization(model.Y);
				var newAuth = _v6.a;
				var authCmds = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						nm,
						{
							Y: newAuth,
							bS: $elm$core$Maybe$Just(1)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								nc,
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$CWS$genericAuthTranslator(1),
								authCmds)
							])));
			}
		} else {
			return _Utils_Tuple2(nm, nc);
		}
	});
var $author$project$CWS$handleActionDetailMessage = F2(
	function (model, sub) {
		var _v0 = model.a.n.K;
		switch (_v0.$) {
			case 1:
				var action = _v0.a;
				return A5($author$project$CWS$updateActionDetails, model, sub, action.ab, '', '');
			case 2:
				var catgrp = _v0.a;
				return A5($author$project$CWS$updateActionDetails, model, sub, -1, '', '');
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$API$APIRequest$API_App_GetConfig = {$: 1};
var $author$project$CWS$Messages$AppConfigResponse = function (a) {
	return {$: 30, a: a};
};
var $author$project$PAM$API$APIBase$app_GetConfig = F4(
	function (settings, user, _return, onError) {
		return A8($author$project$PAM$API$APIBase$postRequest, settings, 'app', 'GetConfig', $elm$core$Maybe$Nothing, _return, onError, user, $elm$json$Json$Decode$value);
	});
var $author$project$CWS$API$Core$api_App_GetConfig = function (model) {
	return A4(
		$author$project$PAM$API$APIBase$app_GetConfig,
		model.p.m.av,
		model.f,
		$author$project$CWS$Messages$AppConfigResponse,
		function (res) {
			return $author$project$CWS$Messages$APIUnauthorizedHandler($author$project$CWS$API$APIRequest$API_App_GetConfig);
		});
};
var $author$project$InPageOAuth$getUser = function (model) {
	return model.f;
};
var $author$project$CWS$Messages$GotMapServices = function (a) {
	return {$: 33, a: a};
};
var $author$project$CWS$getDefaultRouteForUser = function (ls) {
	if (ls.$ === 3) {
		var user = ls.a;
		return A2(
			$author$project$CWS$hasAllRequiredRoles,
			user.aB,
			_List_fromArray(
				['System Administrator'])) ? A2(
			$author$project$CWS$Route$FullRoute,
			$author$project$CWS$Route$CWSApprover($author$project$CWS$Route$APP_Dashboard),
			$author$project$CWS$Route$None) : (A3(
			$author$project$CWS$hasRequiredRoles,
			user.aB,
			_List_fromArray(
				['CWS Approver']),
			_List_fromArray(
				['CWS Approver Delegate', 'FAM Administrator'])) ? A2(
			$author$project$CWS$Route$FullRoute,
			$author$project$CWS$Route$CWSApprover($author$project$CWS$Route$APP_Dashboard),
			$author$project$CWS$Route$None) : (A3(
			$author$project$CWS$hasRequiredRoles,
			user.aB,
			_List_fromArray(
				['CWS User']),
			_List_fromArray(
				['PE Delegate'])) ? A2(
			$author$project$CWS$Route$FullRoute,
			$author$project$CWS$Route$ParticipatingEntity($author$project$CWS$Route$PE_PESelect),
			$author$project$CWS$Route$None) : A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$About, $author$project$CWS$Route$None)));
	} else {
		return A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$About, $author$project$CWS$Route$None);
	}
};
var $author$project$PlugMapOld$Plugins$Themes$ExportLayerConfig = F3(
	function (layers, extent, layerDefs) {
		return {cy: extent, mc: layerDefs, h7: layers};
	});
var $author$project$PlugMapOld$Plugins$Themes$extentDecoder = $elm$json$Json$Decode$list($elm$json$Json$Decode$float);
var $author$project$PlugMapOld$Plugins$Themes$layerUrlDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'tokenKey',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'z-index',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'url',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$LayerUrl))));
var $author$project$PlugMapOld$Plugins$Themes$layersDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$elm$json$Json$Decode$list($author$project$PlugMapOld$Plugins$Themes$layerUrlDecoder),
	$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$Multiple));
var $author$project$PlugMapOld$Plugins$Themes$exportLayerConfigDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'layerDefs',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'extent',
		$author$project$PlugMapOld$Plugins$Themes$extentDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'layers',
			$author$project$PlugMapOld$Plugins$Themes$layersDecoder,
			$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$ExportLayerConfig))));
var $author$project$PlugMapOld$Plugins$Themes$exportLayerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'export',
	$author$project$PlugMapOld$Plugins$Themes$exportLayerConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$ExportLayer));
var $author$project$PlugMapOld$Plugins$Themes$wmtsLayerConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'extent',
	$author$project$PlugMapOld$Plugins$Themes$extentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'layers',
		$author$project$PlugMapOld$Plugins$Themes$layersDecoder,
		$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$WMTSLayerConfig)));
var $author$project$PlugMapOld$Plugins$Themes$wmtsLayerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'wmts',
	$author$project$PlugMapOld$Plugins$Themes$wmtsLayerConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$WMTSLayer));
var $author$project$PlugMapOld$Plugins$Themes$xyzLayerConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'layers',
	$author$project$PlugMapOld$Plugins$Themes$layersDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$XYZLayerConfig));
var $author$project$PlugMapOld$Plugins$Themes$xyzLayerDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'xyz',
	$author$project$PlugMapOld$Plugins$Themes$xyzLayerConfigDecoder,
	$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$XYZLayer));
var $author$project$PlugMapOld$Plugins$Themes$configDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$PlugMapOld$Plugins$Themes$xyzLayerDecoder, $author$project$PlugMapOld$Plugins$Themes$wmtsLayerDecoder, $author$project$PlugMapOld$Plugins$Themes$exportLayerDecoder]));
var $author$project$PlugMapOld$Plugins$Themes$layerDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$PlugMapOld$Plugins$Themes$configDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'opacity',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PlugMapOld$Plugins$Themes$Layer)))));
var $author$project$CWS$peHomeMapConfigDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cwsPEActionLayer',
	$author$project$PlugMapOld$Plugins$Themes$layerDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'layers',
		$elm$json$Json$Decode$list($author$project$PlugMapOld$Plugins$Themes$layerDecoder),
		$elm$json$Json$Decode$succeed($author$project$CWS$PEHomeMapConfig)));
var $author$project$CWS$peHomeMapConfigDecoderBoot = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['pe', 'home', 'map']),
	$author$project$CWS$peHomeMapConfigDecoder);
var $author$project$CWS$logIn = function (_v0) {
	var model = _v0.a;
	var cmds = _v0.b;
	var targetRoute = function () {
		var _v3 = model.a.ae;
		if (!_v3.$) {
			var vw = _v3.a;
			return vw;
		} else {
			return $author$project$CWS$getDefaultRouteForUser(model.f);
		}
	}();
	var peHomeConfig = function () {
		var _v2 = A2(
			$elm$json$Json$Decode$decodeValue,
			A2($elm$json$Json$Decode$field, 'cws', $author$project$CWS$peHomeMapConfigDecoderBoot),
			model.cv);
		if (!_v2.$) {
			var conf = _v2.a;
			return conf;
		} else {
			var e = _v2.a;
			return $author$project$CWS$defaultPEHomeMapConfig;
		}
	}();
	var peCMD = $author$project$CWS$API$Core$api_PE_GetAssigned(model);
	var flags = model.p;
	var currentRoute = A2($author$project$CWS$Route$FullRoute, $author$project$CWS$Route$LoadingData, $author$project$CWS$Route$None);
	var _v1 = A4($author$project$CWS$reRoute, model, targetRoute, model.a.n, true);
	var newModel = _v1.a;
	var reRouteCmds = _v1.b;
	var batchedCmds = $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				peCMD,
				reRouteCmds,
				cmds,
				A4($author$project$PAM$API$APIBase$map_GetAllMapServices, model.p.m.av, model.f, $author$project$CWS$Messages$GotMapServices, $author$project$CWS$Messages$GotMapServices)
			]));
	return _Utils_Tuple2(
		_Utils_update(
			newModel,
			{cR: peHomeConfig}),
		batchedCmds);
};
var $author$project$CWS$API$Core$api_Map_GetServices = function (model) {
	return $elm$core$Platform$Cmd$none;
};
var $author$project$CWS$reRequest = function (apiRequest) {
	switch (apiRequest.$) {
		case 0:
			return $author$project$CWS$API$Core$api_Map_GetServices;
		case 1:
			return $author$project$CWS$API$Core$api_App_GetConfig;
		case 2:
			return $author$project$CWS$API$Core$api_Actions_GetAll;
		case 3:
			return $author$project$CWS$API$Core$api_PE_GetAssigned;
		case 4:
			var pe = apiRequest.a;
			var users = apiRequest.b;
			return A2($author$project$CWS$API$Core$api_PE_AddUsers, pe, users);
		case 5:
			var pe = apiRequest.a;
			return $author$project$CWS$API$Core$api_PE_GetByKey(pe);
		case 6:
			var pe = apiRequest.a;
			var year = apiRequest.b;
			return A2($author$project$CWS$API$Core$api_PE_GetStats, pe, year);
		case 7:
			var pe = apiRequest.a;
			var year = apiRequest.b;
			return A2($author$project$CWS$API$Core$api_PE_GetBreakdownStats, pe, year);
		case 8:
			return $author$project$CWS$API$Core$api_PE_GetAssignedOverview;
		case 9:
			var pe = apiRequest.a;
			return $author$project$CWS$API$Core$api_PE_GetUsers(pe);
		case 12:
			return $author$project$CWS$API$Core$api_GetAllUsers;
		case 10:
			var userid = apiRequest.a;
			return $author$project$CWS$API$Core$api_User_GetPEs(userid);
		case 11:
			var userid = apiRequest.a;
			var peids = apiRequest.b;
			return A2($author$project$CWS$API$Core$api_User_AssignPEs, userid, peids);
		case 13:
			var pe = apiRequest.a;
			var year = apiRequest.b;
			return A2($author$project$CWS$API$Core$api_File_GetAllDocumentsForPE, pe, year);
		case 14:
			var pe = apiRequest.a;
			return $author$project$CWS$API$Core$api_File_GetStaticForPE(pe);
		case 15:
			var category = apiRequest.a;
			return $author$project$CWS$API$Core$api_Types_GetForCategory(category);
		default:
			var id = apiRequest.a;
			return $author$project$CWS$API$Core$api_Types_GetForActionId(id);
	}
};
var $author$project$CWS$processPendingAPIRecursive = function (_v0) {
	var model = _v0.a;
	var cmds = _v0.b;
	var _v1 = model.b3;
	if (!_v1.b) {
		return _Utils_Tuple2(model, cmds);
	} else {
		if (!_v1.b.b) {
			var item = _v1.a;
			var nm = _Utils_update(
				model,
				{b3: _List_Nil});
			return _Utils_Tuple2(
				nm,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmds,
							A2($author$project$CWS$reRequest, item, nm)
						])));
		} else {
			var item = _v1.a;
			var more = _v1.b;
			var nm = _Utils_update(
				model,
				{b3: more});
			return $author$project$CWS$processPendingAPIRecursive(
				_Utils_Tuple2(
					nm,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmds,
								A2($author$project$CWS$reRequest, item, nm)
							]))));
		}
	}
};
var $author$project$CWS$handleAuthorized = function (model) {
	var loginState = $author$project$InPageOAuth$getUser(model.Y);
	return $author$project$CWS$processPendingAPIRecursive(
		function (_v2) {
			var mo = _v2.a;
			var c = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					mo,
					{f: loginState}),
				c);
		}(
			function () {
				var _v0 = _Utils_Tuple2(model.f, loginState);
				if ((!_v0.a.$) && (_v0.b.$ === 3)) {
					var _v1 = _v0.a;
					var user = _v0.b.a;
					return $author$project$CWS$logIn(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{f: loginState}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$CWS$API$Core$api_App_GetConfig(model)
									]))));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{f: loginState}),
						$elm$core$Platform$Cmd$none);
				}
			}()));
};
var $author$project$CWS$Model$Error = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$httpErrorToString = function (err) {
	switch (err.$) {
		case 0:
			var url = err.a;
			return 'Invalid Url';
		case 2:
			return 'Network';
		case 3:
			var num = err.a;
			return 'Status ' + $elm$core$String$fromInt(num);
		case 1:
			return 'Timeout';
		default:
			return 'Payload';
	}
};
var $author$project$CWS$chunkLoadActions = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var actions = result.a;
			return _Utils_update(
				oldChunks,
				{
					cl: $author$project$CWS$Model$Loaded(actions)
				});
		} else {
			var err = result.a;
			var e = $author$project$CWS$httpErrorToString(err);
			return _Utils_update(
				oldChunks,
				{
					cl: $author$project$CWS$Model$Error(e)
				});
		}
	});
var $author$project$CWS$chunkLoadAllDocumentsForPE = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var files = result.a;
			return _Utils_update(
				oldChunks,
				{
					aA: $author$project$CWS$Model$Loaded(files)
				});
		} else {
			return oldChunks;
		}
	});
var $author$project$CWS$chunkLoadAllStaticFilesForPE = F3(
	function (oldChunks, key, result) {
		if (!result.$) {
			var files = result.a;
			var oldDict = oldChunks.aE;
			var newDict = A3(
				$elm$core$Dict$insert,
				key,
				$author$project$CWS$Model$Loaded(files),
				oldDict);
			return _Utils_update(
				oldChunks,
				{aE: newDict});
		} else {
			var err = result.a;
			var oldDict = oldChunks.aE;
			var e = $author$project$CWS$httpErrorToString(err);
			var newDict = A3(
				$elm$core$Dict$insert,
				key,
				$author$project$CWS$Model$Error(e),
				oldDict);
			return _Utils_update(
				oldChunks,
				{aE: newDict});
		}
	});
var $author$project$CWS$chunkLoadPEUsers = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var users = result.a;
			return _Utils_update(
				oldChunks,
				{
					aY: $author$project$CWS$Model$Loaded(users)
				});
		} else {
			return _Utils_update(
				oldChunks,
				{
					aY: $author$project$CWS$Model$Error('Unable To Load Users')
				});
		}
	});
var $author$project$CWS$ManyPEs = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$NoPEAssigned = {$: 0};
var $author$project$CWS$OnePE = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$chunkLoadParticipatingEntities = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var entities = result.a;
			var entCount = $elm$core$List$length(entities);
			var newAssignedPE = function () {
				if (entCount > 1) {
					return $author$project$CWS$ManyPEs(entities);
				} else {
					var _v1 = $elm$core$List$head(entities);
					if (!_v1.$) {
						var ent = _v1.a;
						return $author$project$CWS$OnePE(ent);
					} else {
						return $author$project$CWS$NoPEAssigned;
					}
				}
			}();
			return _Utils_update(
				oldChunks,
				{
					D: $author$project$CWS$Model$Loaded(newAssignedPE)
				});
		} else {
			var err = result.a;
			return _Utils_update(
				oldChunks,
				{
					D: $author$project$CWS$Model$Error(
						$author$project$CWS$httpErrorToString(err))
				});
		}
	});
var $author$project$CWS$chunkLoadParticipatingEntityBreakdownStats = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var selectedPE = result.a;
			return _Utils_update(
				oldChunks,
				{
					az: $author$project$CWS$Model$Loaded(selectedPE)
				});
		} else {
			var err = result.a;
			var e = $author$project$CWS$httpErrorToString(err);
			return _Utils_update(
				oldChunks,
				{
					az: $author$project$CWS$Model$Error(e)
				});
		}
	});
var $author$project$CWS$chunkLoadParticipatingEntityStats = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var selectedPE = result.a;
			return _Utils_update(
				oldChunks,
				{
					b2: $author$project$CWS$Model$Loaded(selectedPE)
				});
		} else {
			var err = result.a;
			var e = $author$project$CWS$httpErrorToString(err);
			return _Utils_update(
				oldChunks,
				{
					b2: $author$project$CWS$Model$Error(e)
				});
		}
	});
var $author$project$CWS$chunkLoadParticipatingEntiyOverview = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var overviews = result.a;
			return _Utils_update(
				oldChunks,
				{
					b0: $author$project$CWS$Model$Loaded(overviews)
				});
		} else {
			var err = result.a;
			var e = $author$project$CWS$httpErrorToString(err);
			return _Utils_update(
				oldChunks,
				{
					b0: $author$project$CWS$Model$Error(e)
				});
		}
	});
var $author$project$CWS$chunkLoadSelectedParticipatingEntity = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var selectedPE = result.a;
			return _Utils_update(
				oldChunks,
				{
					aC: $author$project$CWS$Model$Loaded(selectedPE)
				});
		} else {
			var err = result.a;
			var e = $author$project$CWS$httpErrorToString(err);
			return _Utils_update(
				oldChunks,
				{
					aC: $author$project$CWS$Model$Error(e)
				});
		}
	});
var $author$project$CWS$chunkLoadTypesForCategory = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var types = result.a;
			return _Utils_update(
				oldChunks,
				{
					aG: $author$project$CWS$Model$Loaded(types)
				});
		} else {
			var err = result.a;
			return _Utils_update(
				oldChunks,
				{
					aG: $author$project$CWS$Model$Error(
						$author$project$CWS$httpErrorToString(err))
				});
		}
	});
var $author$project$CWS$chunkLoadUserAssignedPEs = F2(
	function (oldChunks, result) {
		if (!result.$) {
			var pes = result.a;
			return _Utils_update(
				oldChunks,
				{
					cg: $author$project$CWS$Model$Loaded(pes)
				});
		} else {
			return _Utils_update(
				oldChunks,
				{
					cg: $author$project$CWS$Model$Error('Unable To Load Users')
				});
		}
	});
var $author$project$CWS$handleChunkLoad = F2(
	function (model, chunk) {
		var oldChunks = model.b;
		var newChunks = function () {
			switch (chunk.$) {
				case 4:
					var result = chunk.a;
					return A2($author$project$CWS$chunkLoadTypesForCategory, oldChunks, result);
				case 0:
					var result = chunk.a;
					return A2($author$project$CWS$chunkLoadParticipatingEntities, oldChunks, result);
				case 6:
					var result = chunk.a;
					return A2($author$project$CWS$chunkLoadParticipatingEntiyOverview, oldChunks, result);
				case 7:
					var result = chunk.a;
					return A2($author$project$CWS$chunkLoadAllDocumentsForPE, oldChunks, result);
				case 1:
					var result = chunk.a;
					return A2($author$project$CWS$chunkLoadSelectedParticipatingEntity, oldChunks, result);
				case 2:
					var results = chunk.a;
					return A2($author$project$CWS$chunkLoadParticipatingEntityStats, oldChunks, results);
				case 3:
					var results = chunk.a;
					return A2($author$project$CWS$chunkLoadParticipatingEntityBreakdownStats, oldChunks, results);
				case 8:
					var result = chunk.a;
					return A2($author$project$CWS$chunkLoadActions, oldChunks, result);
				case 9:
					var pe = chunk.a;
					var result = chunk.b;
					return A3($author$project$CWS$chunkLoadAllStaticFilesForPE, oldChunks, pe, result);
				case 10:
					var result = chunk.a;
					return A2($author$project$CWS$chunkLoadPEUsers, oldChunks, result);
				case 12:
					var result = chunk.a;
					return A2($author$project$CWS$chunkLoadUserAssignedPEs, oldChunks, result);
				default:
					return oldChunks;
			}
		}();
		var newModel = _Utils_update(
			model,
			{b: newChunks});
		return $author$project$CWS$routeCanChangeCheck(newModel);
	});
var $author$project$CWS$ActionDetail$hasUnsaved = function (model) {
	return model.a.am;
};
var $author$project$CWS$Messages$HeaderMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$PAM$Header$translator = F2(
	function (td, msg) {
		var m = msg;
		return td.cO(m);
	});
var $author$project$CWS$headerTranslator = $author$project$PAM$Header$translator(
	{cO: $author$project$CWS$Messages$HeaderMsg});
var $author$project$PAM$Header$update = F2(
	function (model, msg) {
		switch (msg) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dT: function () {
								var _v1 = model.dT;
								if (!_v1) {
									return 1;
								} else {
									return 0;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dT: 0}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dT: 1}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$headerUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = A2($author$project$PAM$Header$update, model.a.ds, subMsg);
		var newHeaderModel = _v0.a;
		var newMsg = _v0.b;
		var newState = _Utils_update(
			oldState,
			{ds: newHeaderModel});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			A2($elm$core$Platform$Cmd$map, $author$project$CWS$headerTranslator, newMsg));
	});
var $author$project$PlugMapOld$Plugins$Extent$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			var response = msg.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$Home$handleExtentMsg = F2(
	function (model, sub) {
		var _v0 = A2($author$project$PlugMapOld$Plugins$Extent$update, sub, model.em);
		var newExtentModel = _v0.a;
		var newExtentCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{em: newExtentModel}),
			A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$ExtentMsg, newExtentCmd));
	});
var $author$project$CWS$Home$handleMapMsg = F2(
	function (model, sub) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$Home$handlePELoad = F2(
	function (model, result) {
		if (result.$ === 1) {
			var err = result.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var pe = result.a;
			var newPE = $author$project$CWS$Model$Loaded(pe);
			var _v1 = $author$project$PlugMapOld$Plugins$Extent$setExtentWKT(pe.bc);
			var extent = _v1.a;
			var extentCmd = _v1.b;
			var _v2 = $author$project$CWS$MiniDashboard$initSample;
			var mini = _v2.a;
			var cmdMini = _v2.b;
			var _v3 = $author$project$PlugMapOld$Core$initWithDefaults;
			var map = _v3.a;
			var cmdMap = _v3.b;
			var cmdz = $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$MiniDashboardMsg, cmdMini),
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$MapMsg, cmdMap),
						A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$ExtentMsg, extentCmd)
					]));
			return _Utils_Tuple2(
				$author$project$CWS$Home$Model(mini)(map)($author$project$PlugMapOld$Plugins$Themes$defaultModel)(extent)(newPE)(
					$author$project$CWS$Home$defaultStatSet($elm$core$Maybe$Nothing))(_List_Nil)($elm$core$Maybe$Nothing)(model.h7)(model.nl),
				cmdz);
		}
	});
var $author$project$CWS$Home$handleThemesMsg = F2(
	function (model, sub) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$Home$update = F2(
	function (model, msg) {
		switch (msg.$) {
			case 5:
				var result = msg.a;
				return A2($author$project$CWS$Home$handlePELoad, model, result);
			case 2:
				var sub = msg.a;
				return A2($author$project$CWS$Home$handleMapMsg, model, sub);
			case 3:
				var sub = msg.a;
				return A2($author$project$CWS$Home$handleThemesMsg, model, sub);
			case 4:
				var sub = msg.a;
				return A2($author$project$CWS$Home$handleExtentMsg, model, sub);
			case 7:
				var _v1 = $author$project$PlugMapOld$Plugins$Themes$init(model.h7);
				var themes = _v1.a;
				var themeCmd = _v1.b;
				var nm = _Utils_update(
					model,
					{fO: themes});
				return _Utils_Tuple2(
					nm,
					A2($elm$core$Platform$Cmd$map, $author$project$CWS$Home$ThemeMsg, themeCmd));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$homeUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = A2($author$project$CWS$Home$update, model.a.a2, subMsg);
		var newHomeModel = _v0.a;
		var newHomeMsg = _v0.b;
		var newState = _Utils_update(
			oldState,
			{a2: newHomeModel});
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a: newState}),
			A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$HomeMsg, newHomeMsg));
	});
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$CWS$locationChangeUpdate = F2(
	function (model, location) {
		var oldState = model.a;
		var oldRoute = model.a.n;
		var newRoute = $author$project$CWS$Route$parseLocation(location);
		var _v0 = A4($author$project$CWS$reRoute, model, newRoute, oldRoute, false);
		var newModel = _v0.a;
		var newCmds = _v0.b;
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$CWS$notImplementedUpdate = F2(
	function (model, msg) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $truqu$elm_oauth2$Internal$Code = 0;
var $truqu$elm_oauth2$Internal$protocolToString = function (protocol) {
	if (!protocol) {
		return 'http';
	} else {
		return 'https';
	}
};
var $truqu$elm_oauth2$Internal$makeRedirectUri = function (url) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$truqu$elm_oauth2$Internal$protocolToString(url.np),
				'://',
				url.dt,
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (i) {
						return ':' + $elm$core$String$fromInt(i);
					},
					url.nf)),
				url.dD,
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (q) {
						return '?' + q;
					},
					url.iK))
			]));
};
var $truqu$elm_oauth2$Internal$responseTypeToString = function (r) {
	if (!r) {
		return 'code';
	} else {
		return 'token';
	}
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $truqu$elm_oauth2$Internal$urlAddList = F3(
	function (param, xs, qs) {
		return _Utils_ap(
			qs,
			function () {
				if (!xs.b) {
					return _List_Nil;
				} else {
					return _List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							param,
							A2($elm$core$String$join, ' ', xs))
						]);
				}
			}());
	});
var $truqu$elm_oauth2$Internal$urlAddMaybe = F3(
	function (param, ms, qs) {
		return _Utils_ap(
			qs,
			function () {
				if (ms.$ === 1) {
					return _List_Nil;
				} else {
					var s = ms.a;
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, param, s)
						]);
				}
			}());
	});
var $truqu$elm_oauth2$Internal$makeAuthUrl = F2(
	function (responseType, _v0) {
		var clientId = _v0.ha;
		var url = _v0.jF;
		var redirectUri = _v0.nt;
		var scope = _v0.nE;
		var state = _v0.a;
		var query = A2(
			$elm$core$String$dropLeft,
			1,
			$elm$url$Url$Builder$toQuery(
				A3(
					$truqu$elm_oauth2$Internal$urlAddMaybe,
					'state',
					state,
					A3(
						$truqu$elm_oauth2$Internal$urlAddList,
						'scope',
						scope,
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'client_id', clientId),
								A2(
								$elm$url$Url$Builder$string,
								'redirect_uri',
								$truqu$elm_oauth2$Internal$makeRedirectUri(redirectUri)),
								A2(
								$elm$url$Url$Builder$string,
								'response_type',
								$truqu$elm_oauth2$Internal$responseTypeToString(responseType))
							])))));
		var _v1 = url.iK;
		if (_v1.$ === 1) {
			return _Utils_update(
				url,
				{
					iK: $elm$core$Maybe$Just(query)
				});
		} else {
			var baseQuery = _v1.a;
			return _Utils_update(
				url,
				{
					iK: $elm$core$Maybe$Just(baseQuery + ('&' + query))
				});
		}
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthUrl = $truqu$elm_oauth2$Internal$makeAuthUrl(0);
var $author$project$InPageOAuth$openAuth = _Platform_outgoingPort('openAuth', $elm$json$Json$Encode$string);
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.np;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.fu,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.iK,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.nf,
					_Utils_ap(http, url.dt)),
				url.dD)));
};
var $author$project$InPageOAuth$openLogin = function (model) {
	var _v0 = model.hd;
	if (!_v0.$) {
		var config = _v0.a;
		return $author$project$InPageOAuth$openAuth(
			$elm$url$Url$toString(
				$truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthUrl(
					{
						ha: config.ha,
						nt: config.nt,
						nE: config.nE,
						a: $elm$core$Maybe$Just('PAM.init'),
						jF: config.gR
					})));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$CWS$Messages$GoToPE = function (a) {
	return {$: 8, a: a};
};
var $author$project$CWS$Messages$PeSelectMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$CWS$PeSelect$translator = F2(
	function (td, msg) {
		if (!msg.$) {
			var m = msg.a;
			return td.cO(m);
		} else {
			var pe = msg.a;
			return td.mQ(pe);
		}
	});
var $author$project$CWS$peSelectTranslator = $author$project$CWS$PeSelect$translator(
	{mQ: $author$project$CWS$Messages$GoToPE, cO: $author$project$CWS$Messages$PeSelectMsg});
var $author$project$CWS$PeSelect$GoToAPE = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$PeSelect$update = F2(
	function (model, msg) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var pe = msg.a;
				var pes = msg.b;
				var oldState = model.a;
				var newState = _Utils_update(
					oldState,
					{gc: pe});
				var newModel = _Utils_update(
					model,
					{a: newState});
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			default:
				var pes = msg.a;
				var selectedPE = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (x) {
							return _Utils_eq(x.v, model.a.gc);
						},
						pes));
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							function (pe) {
								return A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always(
										$author$project$CWS$PeSelect$GoToAPE(pe)),
									$elm$core$Task$succeed('Hi'));
							},
							selectedPE)));
		}
	});
var $author$project$CWS$peSelectUpdate = F2(
	function (model, subMsg) {
		var oldState = model.a;
		var _v0 = A2($author$project$CWS$PeSelect$update, model.a.cS, subMsg);
		var newPeSelect = _v0.a;
		var newPeSelectCmd = _v0.b;
		var newState = _Utils_update(
			oldState,
			{cS: newPeSelect});
		var newModel = _Utils_update(
			model,
			{a: newState});
		var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$peSelectTranslator, newPeSelectCmd);
		return _Utils_Tuple2(newModel, newCmds);
	});
var $author$project$PlugMapOld$Core$Ports$setMapServices = _Platform_outgoingPort('setMapServices', $elm$core$Basics$identity);
var $author$project$PlugMapOld$Core$setServices = function (services) {
	var val = A2($elm$json$Json$Encode$list, $author$project$PAM$MapServices$encodeMapService, services);
	return $author$project$PlugMapOld$Core$Ports$setMapServices(
		A2($elm$json$Json$Encode$list, $author$project$PAM$MapServices$encodeMapService, services));
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$AddUsers = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$MSM = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$update = F2(
	function (model, msg) {
		update:
		while (true) {
			switch (msg.$) {
				case 4:
					var sub = msg.a;
					if (sub.$ === 15) {
						var subsub = sub.a;
						if (!subsub.$) {
							var subsubsub = subsub.a;
							var $temp$model = model,
								$temp$msg = subsubsub;
							model = $temp$model;
							msg = $temp$msg;
							continue update;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						var _v3 = A2($author$project$Grid$Grid$update, model.fw, sub);
						var ng = _v3.a;
						var ngc = _v3.b;
						var o = _v3.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fw: ng}),
							$elm$core$Platform$Cmd$none);
					}
				case 5:
					var usr = msg.a;
					var sel = msg.b;
					var oldUsers = model.aY;
					var newUsers = A2(
						$elm$core$List$map,
						function (user) {
							return _Utils_eq(user.ab, usr.ab) ? _Utils_update(
								usr,
								{df: sel}) : user;
						},
						oldUsers);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aY: newUsers}),
						$elm$core$Platform$Cmd$none);
				case 3:
					var sub = msg.a;
					var os = model;
					var _v4 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.dy);
					var msm = _v4.a;
					var c = _v4.b;
					var om = _v4.c;
					var ns = _Utils_update(
						os,
						{dy: msm});
					return _Utils_Tuple2(
						ns,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$CWS$Approver$ManageParticipatingEntityUsers$Internal,
							A2($elm$core$Platform$Cmd$map, $author$project$CWS$Approver$ManageParticipatingEntityUsers$MSM, c)));
				case 1:
					var selected = A2(
						$elm$core$List$filter,
						function ($) {
							return $.df;
						},
						model.aY);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{e_: true}),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								$author$project$CWS$Approver$ManageParticipatingEntityUsers$AddUsers(selected)),
							$elm$core$Task$succeed('')));
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$CWS$Approver$ManageUserParticipatingEntities$AddPEs = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$CWS$Approver$ManageUserParticipatingEntities$update = F2(
	function (model, msg) {
		update:
		while (true) {
			switch (msg.$) {
				case 3:
					var sub = msg.a;
					if (sub.$ === 15) {
						var subsub = sub.a;
						if (!subsub.$) {
							var subsubsub = subsub.a;
							var $temp$model = model,
								$temp$msg = subsubsub;
							model = $temp$model;
							msg = $temp$msg;
							continue update;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						var _v3 = A2($author$project$Grid$Grid$update, model.fw, sub);
						var ng = _v3.a;
						var ngc = _v3.b;
						var o = _v3.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fw: ng}),
							$elm$core$Platform$Cmd$none);
					}
				case 4:
					var usr = msg.a;
					var sel = msg.b;
					var oldUsers = model.b4;
					var newUsers = A2(
						$elm$core$List$map,
						function (pe) {
							return _Utils_eq(pe.d.ab, usr.d.ab) ? _Utils_update(
								usr,
								{df: sel}) : pe;
						},
						oldUsers);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b4: newUsers}),
						$elm$core$Platform$Cmd$none);
				case 1:
					var selected = A2(
						$elm$core$List$map,
						function (c) {
							return c.d.ab;
						},
						A2(
							$elm$core$List$filter,
							function ($) {
								return $.df;
							},
							model.b4));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{e_: true}),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								A2($author$project$CWS$Approver$ManageUserParticipatingEntities$AddPEs, model.eW, selected)),
							$elm$core$Task$succeed('')));
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$CWS$PE$Reports$InitThemes = {$: 2};
var $author$project$CWS$PE$Reports$MapMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$PE$Reports$NoOp = {$: 0};
var $author$project$CWS$PE$Reports$Print = {$: 4};
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $author$project$CWS$PE$Reports$pcEncode = function (pc) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'commitment',
				$elm$json$Json$Encode$string(pc.kQ)),
				_Utils_Tuple2(
				'projected',
				$elm$json$Json$Encode$string(pc.no)),
				_Utils_Tuple2(
				'confirmed',
				$elm$json$Json$Encode$string(pc.kR)),
				_Utils_Tuple2(
				'actions',
				$elm$json$Json$Encode$string(pc.au))
			]));
};
var $author$project$CWS$PE$Reports$reportStatsEncode = function (stats) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'mitigation',
				$elm$json$Json$Encode$string(stats.mo)),
				_Utils_Tuple2(
				'preparedness',
				$elm$json$Json$Encode$string(stats.nj)),
				_Utils_Tuple2(
				'prevention',
				$elm$json$Json$Encode$string(stats.nk))
			]));
};
var $author$project$CWS$PE$Reports$encodeReport = function (report) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'participationCommitment',
				$author$project$CWS$PE$Reports$pcEncode(report.b1)),
				_Utils_Tuple2(
				'stats',
				$author$project$CWS$PE$Reports$reportStatsEncode(report.je)),
				_Utils_Tuple2(
				'peName',
				$elm$json$Json$Encode$string(report.iA))
			]));
};
var $author$project$CWS$PE$Reports$peSummaryReport = _Platform_outgoingPort('peSummaryReport', $elm$core$Basics$identity);
var $author$project$CWS$PE$Reports$updateReady = F2(
	function (model, msg) {
		switch (msg.$) {
			case 1:
				var _v1 = $author$project$PlugMapOld$Core$initWithDefaults;
				var map = _v1.a;
				var mapCmd = _v1.b;
				var newCmds = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$CWS$PE$Reports$MapMsg, mapCmd),
							A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always($author$project$CWS$PE$Reports$InitThemes),
							$elm$core$Process$sleep(500))
						]));
				return _Utils_Tuple2(
					$author$project$CWS$PE$Reports$Ready(
						_Utils_update(
							model,
							{q: map})),
					newCmds);
			case 2:
				var _v2 = $author$project$PlugMapOld$Plugins$Themes$init(
					A2($elm$core$List$append, model.h7, $author$project$PlugMapOld$Plugins$Themes$defaultLayers));
				var themes = _v2.a;
				var themeCmd = _v2.b;
				var _v3 = $author$project$PlugMapOld$Plugins$Extent$setExtentWKT(model.jn.bc);
				var extent = _v3.a;
				var extentCmd = _v3.b;
				return _Utils_Tuple2(
					$author$project$CWS$PE$Reports$Ready(model),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								$elm$core$Basics$always($author$project$CWS$PE$Reports$NoOp),
								themeCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								$elm$core$Basics$always($author$project$CWS$PE$Reports$NoOp),
								extentCmd),
								A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always($author$project$CWS$PE$Reports$Print),
								$elm$core$Process$sleep(200))
							])));
			case 4:
				return _Utils_Tuple2(
					$author$project$CWS$PE$Reports$Ready(model),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$CWS$PE$Reports$peSummaryReport(
								$author$project$CWS$PE$Reports$encodeReport(model.iQ))
							])));
			case 5:
				return _Utils_Tuple2(
					$author$project$CWS$PE$Reports$Ready(model),
					A2($elm$browser$Browser$Navigation$back, model.v, 1));
			default:
				return _Utils_Tuple2(
					$author$project$CWS$PE$Reports$Ready(model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$PE$Reports$update = F2(
	function (model, msg) {
		if (model.$ === 1) {
			var mdl = model.a;
			return A2($author$project$CWS$PE$Reports$updateReady, mdl, msg);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$CWS$UploadDocuments$FileDownloadResponseAs = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$CWS$UploadDocuments$initiateFileDownloadAs = F3(
	function (name, file, env) {
		return A5(
			$author$project$CWS$API$File$downloadFile,
			env.m,
			env.f,
			file,
			$author$project$CWS$UploadDocuments$FileDownloadResponseAs(name),
			$author$project$CWS$UploadDocuments$FileDownloadResponseAs(name));
	});
var $author$project$CWS$Menu$ChangeYear = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Menu$DownloadRequested = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$Menu$update = function (inMsg) {
	switch (inMsg.$) {
		case 1:
			var file = inMsg.a;
			return $elm$core$Maybe$Just(
				$author$project$CWS$Menu$DownloadRequested(file));
		case 2:
			var yearKey = inMsg.a;
			return $elm$core$Maybe$Just(
				$author$project$CWS$Menu$ChangeYear(yearKey));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$CWS$updateMenu = F2(
	function (model, sub) {
		var _v0 = $author$project$CWS$Menu$update(sub);
		if (!_v0.$) {
			var out = _v0.a;
			if (!out.$) {
				var file = out.a;
				var _v2 = file.lv;
				if (!_v2.$) {
					var f = _v2.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$CWS$Messages$FileUploadMsg,
							A3(
								$author$project$CWS$UploadDocuments$initiateFileDownloadAs,
								file.dz + ' - ',
								f,
								{m: model.p.m.av, f: model.f})));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			} else {
				var yearKey = out.a;
				var oldState = model.a;
				var oldRoute = model.a.n;
				var oldSub = oldRoute.K;
				var oldMain = oldRoute.z;
				var oldChunks = model.b;
				var newState = _Utils_update(
					oldState,
					{r: yearKey});
				var newMain = function () {
					if (oldMain.$ === 4) {
						var suby = oldMain.a;
						return $author$project$CWS$Route$ParticipatingEntity(
							function () {
								switch (suby.$) {
									case 0:
										var home = suby.a;
										return $author$project$CWS$Route$PE_Home(
											_Utils_update(
												home,
												{r: yearKey}));
									case 1:
										var actions = suby.a;
										var ee = actions.d;
										var ne = _Utils_update(
											ee,
											{r: yearKey});
										return $author$project$CWS$Route$PE_Actions(
											_Utils_update(
												actions,
												{d: ne}));
									case 4:
										var docs = suby.a;
										var ee = docs.d;
										var ne = _Utils_update(
											ee,
											{r: yearKey});
										return $author$project$CWS$Route$PE_AllDocuments(
											_Utils_update(
												docs,
												{d: ne}));
									default:
										return suby;
								}
							}());
					} else {
						return oldMain;
					}
				}();
				var newRoute = {z: newMain, K: oldSub};
				var newChunks = _Utils_update(
					oldChunks,
					{az: $author$project$CWS$Model$Loading});
				var _v3 = A4(
					$author$project$CWS$reRoute,
					_Utils_update(
						model,
						{a: newState}),
					newRoute,
					model.a.n,
					true);
				var m_reRouted = _v3.a;
				var c_reRouted = _v3.b;
				return _Utils_Tuple2(m_reRouted, c_reRouted);
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$InPageOAuth$AuthError = function (a) {
	return {$: 7, a: a};
};
var $author$project$InPageOAuth$Authorized = {$: 3};
var $author$project$InPageOAuth$Pending = {$: 1};
var $author$project$PAM$User$TokenReceived = function (a) {
	return {$: 2, a: a};
};
var $author$project$InPageOAuth$Unauthorized = {$: 2};
var $author$project$InPageOAuth$UserAuthorized = {$: 1};
var $author$project$InPageOAuth$GettingACLs = {$: 6};
var $author$project$InPageOAuth$Error = function (a) {
	return {$: 6, a: a};
};
var $author$project$InPageOAuth$handleAuthStateError = function (err) {
	return $author$project$InPageOAuth$Internal(
		$author$project$InPageOAuth$Error('Unable to retrieve your permissions. If this problem continues contact your system administrator.'));
};
var $author$project$InPageOAuth$ACLsLoaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$InPageOAuth$handleLoadACL = function (res) {
	if (!res.$) {
		var acls = res.a;
		return $author$project$InPageOAuth$Internal(
			$author$project$InPageOAuth$ACLsLoaded(acls));
	} else {
		return $author$project$InPageOAuth$Internal(
			$author$project$InPageOAuth$Error('Unable to get permissions. Try reloading.'));
	}
};
var $author$project$PAM$User$ACL = F4(
	function (id, section, value, access) {
		return {gF: access, ab: id, gh: section, gv: value};
	});
var $author$project$PAM$User$NoAccess = 0;
var $author$project$PAM$User$Create = 2;
var $author$project$PAM$User$Delete = 6;
var $author$project$PAM$User$DeleteIfOwn = 4;
var $author$project$PAM$User$Modify = 5;
var $author$project$PAM$User$ModifyIfOwn = 3;
var $author$project$PAM$User$Read = 1;
var $author$project$PAM$User$accessDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		return $elm$json$Json$Decode$succeed(
			function () {
				switch (value) {
					case 0:
						return 0;
					case 1:
						return 1;
					case 2:
						return 2;
					case 3:
						return 3;
					case 4:
						return 4;
					case 5:
						return 5;
					case 6:
						return 6;
					default:
						return 0;
				}
			}());
	},
	$elm$json$Json$Decode$int);
var $author$project$PAM$User$aclDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'access',
	$author$project$PAM$User$accessDecoder,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'section',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PAM$User$ACL)))));
var $author$project$PAM$API$APIBase$user_GetACLs = F4(
	function (settings, user, _return, onError) {
		return A8(
			$author$project$PAM$API$APIBase$postRequest,
			settings,
			'user',
			'GetACLs',
			$elm$core$Maybe$Nothing,
			_return,
			onError,
			user,
			$elm$json$Json$Decode$list($author$project$PAM$User$aclDecoder));
	});
var $author$project$InPageOAuth$getACLs = function (model) {
	var ncp = $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					function (settings) {
						return A4($author$project$PAM$API$APIBase$user_GetACLs, settings.av, model.f, $author$project$InPageOAuth$handleLoadACL, $author$project$InPageOAuth$handleAuthStateError);
					},
					model.kh))
			]));
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{a: $author$project$InPageOAuth$GettingACLs}),
		ncp);
};
var $author$project$InPageOAuth$GettingToken = {$: 4};
var $author$project$InPageOAuth$GotAccessToken = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $truqu$elm_base64$Base64$Encode$intToBase64 = function (i) {
	switch (i) {
		case 0:
			return 'A';
		case 1:
			return 'B';
		case 2:
			return 'C';
		case 3:
			return 'D';
		case 4:
			return 'E';
		case 5:
			return 'F';
		case 6:
			return 'G';
		case 7:
			return 'H';
		case 8:
			return 'I';
		case 9:
			return 'J';
		case 10:
			return 'K';
		case 11:
			return 'L';
		case 12:
			return 'M';
		case 13:
			return 'N';
		case 14:
			return 'O';
		case 15:
			return 'P';
		case 16:
			return 'Q';
		case 17:
			return 'R';
		case 18:
			return 'S';
		case 19:
			return 'T';
		case 20:
			return 'U';
		case 21:
			return 'V';
		case 22:
			return 'W';
		case 23:
			return 'X';
		case 24:
			return 'Y';
		case 25:
			return 'Z';
		case 26:
			return 'a';
		case 27:
			return 'b';
		case 28:
			return 'c';
		case 29:
			return 'd';
		case 30:
			return 'e';
		case 31:
			return 'f';
		case 32:
			return 'g';
		case 33:
			return 'h';
		case 34:
			return 'i';
		case 35:
			return 'j';
		case 36:
			return 'k';
		case 37:
			return 'l';
		case 38:
			return 'm';
		case 39:
			return 'n';
		case 40:
			return 'o';
		case 41:
			return 'p';
		case 42:
			return 'q';
		case 43:
			return 'r';
		case 44:
			return 's';
		case 45:
			return 't';
		case 46:
			return 'u';
		case 47:
			return 'v';
		case 48:
			return 'w';
		case 49:
			return 'x';
		case 50:
			return 'y';
		case 51:
			return 'z';
		case 52:
			return '0';
		case 53:
			return '1';
		case 54:
			return '2';
		case 55:
			return '3';
		case 56:
			return '4';
		case 57:
			return '5';
		case 58:
			return '6';
		case 59:
			return '7';
		case 60:
			return '8';
		case 61:
			return '9';
		case 62:
			return '+';
		default:
			return '/';
	}
};
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_base64$Base64$Encode$toBase64 = function (_int) {
	return _Utils_ap(
		$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 18)),
		_Utils_ap(
			$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 12)),
			_Utils_ap(
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 6)),
				$truqu$elm_base64$Base64$Encode$intToBase64(63 & (_int >>> 0)))));
};
var $truqu$elm_base64$Base64$Encode$add = F2(
	function (_char, _v0) {
		var res = _v0.a;
		var count = _v0.b;
		var acc = _v0.c;
		var current = (acc << 8) | _char;
		if (count === 2) {
			return _Utils_Tuple3(
				_Utils_ap(
					res,
					$truqu$elm_base64$Base64$Encode$toBase64(current)),
				0,
				0);
		} else {
			return _Utils_Tuple3(res, count + 1, current);
		}
	});
var $truqu$elm_base64$Base64$Encode$chomp = F2(
	function (char_, acc) {
		var _char = $elm$core$Char$toCode(char_);
		return (_char < 128) ? A2($truqu$elm_base64$Base64$Encode$add, _char, acc) : ((_char < 2048) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2($truqu$elm_base64$Base64$Encode$add, 192 | (_char >>> 6), acc)) : (((_char < 55296) || ((_char >= 57344) && (_char <= 65535))) ? A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2($truqu$elm_base64$Base64$Encode$add, 224 | (_char >>> 12), acc))) : A2(
			$truqu$elm_base64$Base64$Encode$add,
			128 | (63 & _char),
			A2(
				$truqu$elm_base64$Base64$Encode$add,
				128 | (63 & (_char >>> 6)),
				A2(
					$truqu$elm_base64$Base64$Encode$add,
					128 | (63 & (_char >>> 12)),
					A2($truqu$elm_base64$Base64$Encode$add, 240 | (_char >>> 18), acc))))));
	});
var $elm$core$String$foldl = _String_foldl;
var $truqu$elm_base64$Base64$Encode$initial = _Utils_Tuple3('', 0, 0);
var $truqu$elm_base64$Base64$Encode$wrapUp = function (_v0) {
	var res = _v0.a;
	var cnt = _v0.b;
	var acc = _v0.c;
	switch (cnt) {
		case 1:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 2)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 4)) + '=='));
		case 2:
			return res + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 10)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc >>> 4)) + ($truqu$elm_base64$Base64$Encode$intToBase64(63 & (acc << 2)) + '=')));
		default:
			return res;
	}
};
var $truqu$elm_base64$Base64$Encode$encode = function (input) {
	return $truqu$elm_base64$Base64$Encode$wrapUp(
		A3($elm$core$String$foldl, $truqu$elm_base64$Base64$Encode$chomp, $truqu$elm_base64$Base64$Encode$initial, input));
};
var $truqu$elm_base64$Base64$encode = $truqu$elm_base64$Base64$Encode$encode;
var $truqu$elm_oauth2$Internal$makeHeaders = function (credentials) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (s) {
				return _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Basic ' + s)
					]);
			},
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var clientId = _v0.ha;
					var secret = _v0.nL;
					return $truqu$elm_base64$Base64$encode(clientId + (':' + secret));
				},
				credentials)));
};
var $truqu$elm_oauth2$Internal$AuthenticationSuccess = F4(
	function (token, refreshToken, expiresIn, scope) {
		return {lp: expiresIn, nu: refreshToken, nE: scope, oq: token};
	});
var $truqu$elm_oauth2$Internal$expiresInDecoder = $elm$json$Json$Decode$maybe(
	A2($elm$json$Json$Decode$field, 'expires_in', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $truqu$elm_oauth2$Internal$decoderFromJust = function (msg) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
		$elm$core$Maybe$withDefault(
			$elm$json$Json$Decode$fail(msg)));
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $truqu$elm_oauth2$OAuth$maybeAndThen2 = F3(
	function (fn, ma, mb) {
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$Basics$identity,
			A3($elm$core$Maybe$map2, fn, ma, mb));
	});
var $truqu$elm_oauth2$OAuth$Bearer = $elm$core$Basics$identity;
var $truqu$elm_oauth2$OAuth$tryMakeToken = F2(
	function (tokenType, token) {
		var _v0 = $elm$core$String$toLower(tokenType);
		if (_v0 === 'bearer') {
			return $elm$core$Maybe$Just(token);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $truqu$elm_oauth2$OAuth$makeRefreshToken = F2(
	function (tokenType, mToken) {
		var _v0 = _Utils_Tuple2(
			mToken,
			A3(
				$truqu$elm_oauth2$OAuth$maybeAndThen2,
				$truqu$elm_oauth2$OAuth$tryMakeToken,
				$elm$core$Maybe$Just(tokenType),
				mToken));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return $elm$core$Maybe$Just($elm$core$Maybe$Nothing);
		} else {
			if (!_v0.b.$) {
				var token = _v0.b.a;
				return $elm$core$Maybe$Just(
					$elm$core$Maybe$Just(token));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $truqu$elm_oauth2$Internal$refreshTokenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$truqu$elm_oauth2$Internal$decoderFromJust('missing or invalid \'refresh_token\' / \'token_type\''),
	A3(
		$elm$json$Json$Decode$map2,
		$truqu$elm_oauth2$OAuth$makeRefreshToken,
		A2($elm$json$Json$Decode$field, 'token_type', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'refresh_token', $elm$json$Json$Decode$string))));
var $truqu$elm_oauth2$Internal$scopeDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault(_List_Nil),
	$elm$json$Json$Decode$maybe(
		A2(
			$elm$json$Json$Decode$field,
			'scope',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $truqu$elm_oauth2$OAuth$makeToken = $truqu$elm_oauth2$OAuth$maybeAndThen2($truqu$elm_oauth2$OAuth$tryMakeToken);
var $truqu$elm_oauth2$Internal$tokenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$truqu$elm_oauth2$Internal$decoderFromJust('missing or invalid \'access_token\' / \'token_type\''),
	A3(
		$elm$json$Json$Decode$map2,
		$truqu$elm_oauth2$OAuth$makeToken,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A2($elm$json$Json$Decode$field, 'token_type', $elm$json$Json$Decode$string)),
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$Just,
			A2($elm$json$Json$Decode$field, 'access_token', $elm$json$Json$Decode$string))));
var $truqu$elm_oauth2$Internal$authenticationSuccessDecoder = A5($elm$json$Json$Decode$map4, $truqu$elm_oauth2$Internal$AuthenticationSuccess, $truqu$elm_oauth2$Internal$tokenDecoder, $truqu$elm_oauth2$Internal$refreshTokenDecoder, $truqu$elm_oauth2$Internal$expiresInDecoder, $truqu$elm_oauth2$Internal$scopeDecoder);
var $elm$http$Http$stringBody = _Http_pair;
var $truqu$elm_oauth2$Internal$makeRequest = F4(
	function (toMsg, url, headers, body) {
		return {
			gZ: A2($elm$http$Http$stringBody, 'application/x-www-form-urlencoded', body),
			hv: A2($elm$http$Http$expectJson, toMsg, $truqu$elm_oauth2$Internal$authenticationSuccessDecoder),
			hO: headers,
			ii: 'POST',
			jp: $elm$core$Maybe$Nothing,
			jz: $elm$core$Maybe$Nothing,
			jF: $elm$url$Url$toString(url)
		};
	});
var $truqu$elm_oauth2$OAuth$AuthorizationCode$makeTokenRequest = F2(
	function (toMsg, _v0) {
		var credentials = _v0.kZ;
		var code = _v0.d7;
		var url = _v0.jF;
		var redirectUri = _v0.nt;
		var headers = $truqu$elm_oauth2$Internal$makeHeaders(
			function () {
				var _v1 = credentials.nL;
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var secret = _v1.a;
					return $elm$core$Maybe$Just(
						{ha: credentials.ha, nL: secret});
				}
			}());
		var body = A2(
			$elm$core$String$dropLeft,
			1,
			$elm$url$Url$Builder$toQuery(
				_List_fromArray(
					[
						A2($elm$url$Url$Builder$string, 'grant_type', 'authorization_code'),
						A2($elm$url$Url$Builder$string, 'client_id', credentials.ha),
						A2(
						$elm$url$Url$Builder$string,
						'redirect_uri',
						$truqu$elm_oauth2$Internal$makeRedirectUri(redirectUri)),
						A2($elm$url$Url$Builder$string, 'code', code)
					])));
		return A4($truqu$elm_oauth2$Internal$makeRequest, toMsg, url, headers, body);
	});
var $author$project$InPageOAuth$getAccessToken = F2(
	function (code, config) {
		var clientId = config.ha;
		var secret = config.nL;
		var tokenEndpoint = config.jt;
		var redirectUri = config.nt;
		var req = A2(
			$truqu$elm_oauth2$OAuth$AuthorizationCode$makeTokenRequest,
			function (r) {
				return $author$project$InPageOAuth$Internal(
					$author$project$InPageOAuth$GotAccessToken(r));
			},
			{
				d7: code,
				kZ: {
					ha: clientId,
					nL: $elm$core$Maybe$Just(secret)
				},
				nt: config.nt,
				jF: tokenEndpoint
			});
		var tok = A2(
			$elm$core$List$map,
			function (a) {
				return a;
			},
			req.hO);
		return $elm$http$Http$request(req);
	});
var $author$project$InPageOAuth$handleGotCode = F2(
	function (model, code) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					d7: $elm$core$Maybe$Just(code),
					a: $author$project$InPageOAuth$GettingToken
				}),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					$author$project$InPageOAuth$getAccessToken(code),
					model.hd)));
	});
var $author$project$InPageOAuth$GettingUserInfo = {$: 5};
var $author$project$InPageOAuth$ReAuth = {$: 8};
var $truqu$elm_oauth2$Internal$AuthenticationError = F3(
	function (error, errorDescription, errorUri) {
		return {lj: error, lk: errorDescription, ht: errorUri};
	});
var $truqu$elm_oauth2$Internal$errorDescriptionDecoder = $elm$json$Json$Decode$maybe(
	A2($elm$json$Json$Decode$field, 'error_description', $elm$json$Json$Decode$string));
var $truqu$elm_oauth2$Internal$errorUriDecoder = $elm$json$Json$Decode$maybe(
	A2($elm$json$Json$Decode$field, 'error_uri', $elm$json$Json$Decode$string));
var $truqu$elm_oauth2$Internal$authenticationErrorDecoder = function (errorCodeDecoder) {
	return A4($elm$json$Json$Decode$map3, $truqu$elm_oauth2$Internal$AuthenticationError, errorCodeDecoder, $truqu$elm_oauth2$Internal$errorDescriptionDecoder, $truqu$elm_oauth2$Internal$errorUriDecoder);
};
var $truqu$elm_oauth2$OAuth$AccessDenied = {$: 2};
var $truqu$elm_oauth2$OAuth$Custom = function (a) {
	return {$: 7, a: a};
};
var $truqu$elm_oauth2$OAuth$InvalidRequest = {$: 0};
var $truqu$elm_oauth2$OAuth$InvalidScope = {$: 4};
var $truqu$elm_oauth2$OAuth$ServerError = {$: 5};
var $truqu$elm_oauth2$OAuth$TemporarilyUnavailable = {$: 6};
var $truqu$elm_oauth2$OAuth$UnauthorizedClient = {$: 1};
var $truqu$elm_oauth2$OAuth$UnsupportedResponseType = {$: 3};
var $truqu$elm_oauth2$OAuth$errorCodeFromString = function (str) {
	switch (str) {
		case 'invalid_request':
			return $truqu$elm_oauth2$OAuth$InvalidRequest;
		case 'unauthorized_client':
			return $truqu$elm_oauth2$OAuth$UnauthorizedClient;
		case 'access_denied':
			return $truqu$elm_oauth2$OAuth$AccessDenied;
		case 'unsupported_response_type':
			return $truqu$elm_oauth2$OAuth$UnsupportedResponseType;
		case 'invalid_scope':
			return $truqu$elm_oauth2$OAuth$InvalidScope;
		case 'server_error':
			return $truqu$elm_oauth2$OAuth$ServerError;
		case 'temporarily_unavailable':
			return $truqu$elm_oauth2$OAuth$TemporarilyUnavailable;
		default:
			return $truqu$elm_oauth2$OAuth$Custom(str);
	}
};
var $truqu$elm_oauth2$Internal$errorDecoder = function (errorCodeFromString) {
	return A2(
		$elm$json$Json$Decode$map,
		errorCodeFromString,
		A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string));
};
var $truqu$elm_oauth2$OAuth$AuthorizationCode$defaultErrorDecoder = $truqu$elm_oauth2$Internal$errorDecoder($truqu$elm_oauth2$OAuth$errorCodeFromString);
var $truqu$elm_oauth2$OAuth$AuthorizationCode$defaultAuthenticationErrorDecoder = $truqu$elm_oauth2$Internal$authenticationErrorDecoder($truqu$elm_oauth2$OAuth$AuthorizationCode$defaultErrorDecoder);
var $author$project$InPageOAuth$NoOp = {$: 0};
var $author$project$InPageOAuth$UserInfoLoaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$InPageOAuth$gotUserInfo = function (res) {
	if (!res.$) {
		var prof = res.a;
		return $author$project$InPageOAuth$Internal(
			$author$project$InPageOAuth$UserInfoLoaded(prof));
	} else {
		return $author$project$InPageOAuth$Internal($author$project$InPageOAuth$NoOp);
	}
};
var $author$project$InPageOAuth$getUserInfo = F2(
	function (_v0, token) {
		var profileEndpoint = _v0.nm;
		var decoder = _v0.k7;
		return $elm$http$Http$request(
			{
				gZ: $elm$http$Http$emptyBody,
				hv: A2($elm$http$Http$expectJson, $author$project$InPageOAuth$gotUserInfo, decoder),
				hO: A2(
					$truqu$elm_oauth2$OAuth$useToken,
					token,
					_List_fromArray(
						[
							A2(
							$elm$http$Http$header,
							'X-Hack-Authorization',
							$truqu$elm_oauth2$OAuth$tokenToString(token))
						])),
				ii: 'GET',
				jp: $elm$core$Maybe$Nothing,
				jz: $elm$core$Maybe$Nothing,
				jF: $elm$url$Url$toString(profileEndpoint)
			});
	});
var $author$project$InPageOAuth$handleGotToken = F3(
	function (model, config, res) {
		if (res.$ === 1) {
			if (res.a.$ === 4) {
				var body = res.a.a;
				var _v1 = A2($elm$json$Json$Decode$decodeString, $truqu$elm_oauth2$OAuth$AuthorizationCode$defaultAuthenticationErrorDecoder, body);
				if (!_v1.$) {
					var error = _v1.a.lj;
					var errorDescription = _v1.a.lk;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$InPageOAuth$AuthError('Unable to get a valid token.')
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			var expiresIn = res.a.lp;
			var token = res.a.oq;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						a: $author$project$InPageOAuth$GettingUserInfo,
						f: $author$project$PAM$User$TokenReceived(
							$elm$core$Maybe$Just(token))
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$InPageOAuth$getUserInfo, config, token),
							A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								$author$project$InPageOAuth$Internal($author$project$InPageOAuth$ReAuth)),
							$elm$core$Process$sleep(
								(A2($elm$core$Maybe$withDefault, 3000, expiresIn) - 10) * 1000))
						])));
		}
	});
var $author$project$InPageOAuth$noop = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$PAM$User$LoggedIn = function (a) {
	return {$: 3, a: a};
};
var $author$project$InPageOAuth$setACLs = F2(
	function (model, acls) {
		var _v0 = model.f;
		if (_v0.$ === 3) {
			var um = _v0.a;
			return _Utils_update(
				model,
				{
					f: $author$project$PAM$User$LoggedIn(
						_Utils_update(
							um,
							{j_: acls}))
				});
		} else {
			return model;
		}
	});
var $author$project$PAM$User$User = F3(
	function (profile, acls, token) {
		return {j_: acls, aB: profile, oq: token};
	});
var $author$project$InPageOAuth$defaultUser = F2(
	function (profile, token) {
		return A3($author$project$PAM$User$User, profile, _List_Nil, token);
	});
var $author$project$InPageOAuth$setUser = F2(
	function (model, profile) {
		var _v0 = model.f;
		switch (_v0.$) {
			case 3:
				var um = _v0.a;
				return _Utils_update(
					model,
					{
						f: $author$project$PAM$User$LoggedIn(
							_Utils_update(
								um,
								{aB: profile}))
					});
			case 2:
				var token = _v0.a;
				return _Utils_update(
					model,
					{
						f: $author$project$PAM$User$LoggedIn(
							A2($author$project$InPageOAuth$defaultUser, profile, token))
					});
			default:
				return model;
		}
	});
var $author$project$InPageOAuth$update = F2(
	function (model, msg) {
		switch (msg.$) {
			case 2:
				var code = msg.a;
				return A2($author$project$InPageOAuth$handleGotCode, model, code);
			case 3:
				var res = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$InPageOAuth$noop(model),
					A2(
						$elm$core$Maybe$map,
						function (config) {
							return A3($author$project$InPageOAuth$handleGotToken, model, config, res);
						},
						model.hd));
			case 4:
				var profile = msg.a;
				return $author$project$InPageOAuth$getACLs(
					A2($author$project$InPageOAuth$setUser, model, profile));
			case 5:
				var acls = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$InPageOAuth$setACLs,
						_Utils_update(
							model,
							{a: $author$project$InPageOAuth$Authorized}),
						acls),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always($author$project$InPageOAuth$UserAuthorized),
								$elm$core$Task$succeed(''))
							])));
			case 1:
				var _v1 = model.a;
				switch (_v1.$) {
					case 0:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{a: $author$project$InPageOAuth$Pending}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$perform,
										$elm$core$Basics$always(
											$author$project$InPageOAuth$Internal($author$project$InPageOAuth$Timeout)),
										$elm$core$Process$sleep(10000))
									])));
					case 1:
						var _v2 = _Utils_Tuple2(model.hd, model.kh);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var config = _v2.a.a;
							var settings = _v2.b.a;
							if (!settings.bJ.mp) {
								var auth = {
									ha: config.ha,
									nt: config.nt,
									nE: config.nE,
									a: $elm$core$Maybe$Just('PAM.init'),
									jF: config.gR
								};
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{a: $author$project$InPageOAuth$Unauthorized}),
									$author$project$InPageOAuth$openAuth(
										$elm$url$Url$toString(
											$truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthUrl(auth))));
							} else {
								return $author$project$InPageOAuth$getACLs(
									A2(
										$author$project$InPageOAuth$setUser,
										_Utils_update(
											model,
											{
												a: $author$project$InPageOAuth$Authorized,
												f: $author$project$PAM$User$TokenReceived($elm$core$Maybe$Nothing)
											}),
										{
											ek: 'DEMO',
											ab: '00000000-0000-0000-0000-000000000000',
											dz: 'DEMO',
											iW: _List_fromArray(
												['DEMO'])
										}));
							}
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{a: $author$project$InPageOAuth$Unauthorized}),
								$elm$core$Platform$Cmd$none);
						}
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var _v3 = model.hd;
				if (!_v3.$) {
					var config = _v3.a;
					var auth = {
						ha: config.ha,
						nt: config.nt,
						nE: config.nE,
						a: $elm$core$Maybe$Just('PAM.init'),
						jF: config.gR
					};
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a: $author$project$InPageOAuth$Unauthorized}),
						$author$project$InPageOAuth$openLogin(model));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				return $author$project$InPageOAuth$regetAuthorization(
					_Utils_update(
						model,
						{dG: model.dG + 1}));
			case 6:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a: $author$project$InPageOAuth$AuthError(error)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return $author$project$InPageOAuth$noop(model);
		}
	});
var $author$project$CWS$updateOAuth = F3(
	function (model, msg, _return) {
		var _v0 = A2($author$project$InPageOAuth$update, model.Y, msg);
		var noa = _v0.a;
		var noacmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{Y: noa}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$CWS$genericAuthTranslator(_return),
				noacmd));
	});
var $author$project$CWS$updateSF = F4(
	function (model, staticFile, newName, newDesc) {
		var oldState = model.a;
		var oldSF = model.a.cM;
		var newSF = A3(
			$elm$core$Dict$insert,
			staticFile.ab,
			_Utils_Tuple3(newName, newDesc, staticFile),
			oldSF);
		var newState = _Utils_update(
			oldState,
			{cM: newSF});
		var newModel = _Utils_update(
			model,
			{a: newState});
		return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
	});
var $author$project$CWS$appUpdate = F2(
	function (msg, model) {
		switch (msg.$) {
			case 40:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$CWS$genericAuthTranslator(0),
						$author$project$InPageOAuth$openLogin(model.Y)));
			case 38:
				return _Utils_Tuple2(
					model,
					$elm$browser$Browser$Navigation$load(model.p.m.nw));
			case 39:
				return _Utils_Tuple2(
					model,
					$elm$browser$Browser$Navigation$load(model.p.m.nv));
			case 41:
				var x = msg.a;
				var y = msg.b;
				var newSize = A2($author$project$PAM$UI$Basic$WindowSize, x, y);
				var newDevice = $mdgriffith$elm_ui$Element$classifyDevice(newSize);
				var newPanelDimensions = A2($author$project$PAM$UI$Basic$calculatePanelDimensions, newSize, newDevice);
				var newModel = _Utils_update(
					model,
					{Z: newDevice, ac: newPanelDimensions, w: newSize});
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			case 8:
				var pe = msg.a;
				var latestYear = A2(
					$elm$core$Maybe$withDefault,
					'-1',
					A2(
						$elm$core$Maybe$andThen,
						function (x) {
							return $elm$core$Maybe$Just(x.v);
						},
						$elm$core$List$head(pe.cj)));
				return A4(
					$author$project$CWS$reRoute,
					model,
					A2(
						$author$project$CWS$Route$FullRoute,
						$author$project$CWS$Route$ParticipatingEntity(
							$author$project$CWS$Route$PE_Home(
								{d: pe.v, r: latestYear})),
						$author$project$CWS$Route$None),
					model.a.n,
					true);
			case 29:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d1: true}),
					$elm$core$Platform$Cmd$none);
			case 20:
				var chunk = msg.a;
				return A2($author$project$CWS$handleChunkLoad, model, chunk);
			case 1:
				var subMsg = msg.a;
				return A2($author$project$CWS$headerUpdate, model, subMsg);
			case 6:
				var subMsg = msg.a;
				return A2($author$project$CWS$actionBoardUpdate, model, subMsg);
			case 4:
				var location = msg.a;
				return A2($author$project$CWS$locationChangeUpdate, model, location);
			case 9:
				var subMsg = msg.a;
				return A2($author$project$CWS$aboutUpdate, model, subMsg);
			case 10:
				var subMessage = msg.a;
				var _v1 = A2($author$project$CWS$handleActionDetailMessage, model, subMessage);
				var a = _v1.a;
				var b = _v1.b;
				return _Utils_Tuple2(a, b);
			case 35:
				var authReturn = msg.a;
				var nm = model;
				return $author$project$CWS$processPendingAPIRecursive(
					function () {
						if (!authReturn) {
							return $author$project$CWS$handleAuthorized(nm);
						} else {
							var oldState = nm.a;
							var _v3 = A2(
								$author$project$CWS$ActionDetail$authorized,
								nm.a.x,
								{m: nm.p.m.av, f: nm.f});
							var newActionDetails = _v3.a;
							var newActionDetailCmds = _v3.b;
							var newState = _Utils_update(
								oldState,
								{x: newActionDetails});
							return _Utils_Tuple2(
								_Utils_update(
									nm,
									{bS: $elm$core$Maybe$Nothing, a: newState}),
								A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ActionDetailMsg, newActionDetailCmds));
						}
					}());
			case 16:
				var _v4 = model.a.n.K;
				switch (_v4.$) {
					case 1:
						var confirm = $author$project$CWS$ActionDetail$hasUnsaved(model.a.x);
						return A2($author$project$CWS$closeModalUpdate, model, confirm);
					case 2:
						var confirm = $author$project$CWS$ActionDetail$hasUnsaved(model.a.x);
						return A2($author$project$CWS$closeModalUpdate, model, confirm);
					default:
						return A2($author$project$CWS$closeModalUpdate, model, true);
				}
			case 17:
				var oldState = model.a;
				var newState = _Utils_update(
					oldState,
					{aJ: $author$project$CWS$Model$Confirmed});
				var newModel = _Utils_update(
					model,
					{a: newState});
				return A2($author$project$CWS$closeModalUpdate, newModel, true);
			case 18:
				var oldState = model.a;
				var newState = _Utils_update(
					oldState,
					{aJ: $author$project$CWS$Model$Canceled});
				var newModel = _Utils_update(
					model,
					{a: newState});
				return A2($author$project$CWS$closeModalUpdate, newModel, true);
			case 2:
				var subMsg = msg.a;
				return A2($author$project$CWS$homeUpdate, model, subMsg);
			case 19:
				return $author$project$CWS$routeCanChangeCheck(model);
			case 14:
				var subMsg = msg.a;
				return A2($author$project$CWS$appPEUpdate, model, subMsg);
			case 15:
				var subMsg = msg.a;
				return A2($author$project$CWS$appPEUsersUpdate, model, subMsg);
			case 12:
				var subMsg = msg.a;
				return A2($author$project$CWS$appActionUpdate, model, subMsg);
			case 7:
				var subMsg = msg.a;
				return A2($author$project$CWS$peSelectUpdate, model, subMsg);
			case 11:
				var subMsg = msg.a;
				return A2($author$project$CWS$fileUploadUpdate, model, subMsg);
			case 13:
				var wkfwMsg = msg.a;
				return A2($author$project$CWS$fileUploadWorkflowUpdate, model, wkfwMsg);
			case 3:
				var subMsg = msg.a;
				return A2($author$project$CWS$updateMenu, model, subMsg);
			case 21:
				var sf = msg.a;
				var newName = msg.b;
				var newDesc = msg.c;
				return A4($author$project$CWS$updateSF, model, sf, newName, newDesc);
			case 22:
				var sub = msg.a;
				var os = model.a;
				var _v5 = A2($author$project$CWS$Approver$ManageParticipatingEntityUsers$update, os.cK, sub);
				var mu = _v5.a;
				var muc = _v5.b;
				var ns = _Utils_update(
					os,
					{cK: mu});
				var nc = A2($elm$core$Platform$Cmd$map, $author$project$CWS$manageUsersTranslator, muc);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a: ns}),
					nc);
			case 23:
				var sub = msg.a;
				var os = model.a;
				var _v6 = A2($author$project$CWS$Approver$ManageUserParticipatingEntities$update, os.cJ, sub);
				var mu = _v6.a;
				var muc = _v6.b;
				var ns = _Utils_update(
					os,
					{cJ: mu});
				var nc = A2($elm$core$Platform$Cmd$map, $author$project$CWS$managePEsTranslator, muc);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a: ns}),
					nc);
			case 24:
				var users = msg.a;
				var _v7 = model.a.n.K;
				if ((_v7.$ === 3) && (_v7.a.$ === 3)) {
					var pe = _v7.a.a;
					var pekey = pe.d;
					return $author$project$CWS$closeModal(
						_Utils_Tuple2(
							model,
							A3($author$project$CWS$API$Core$api_PE_AddUsers, pekey, users, model)));
				} else {
					return A2($author$project$CWS$notImplementedUpdate, model, msg);
				}
			case 25:
				var user = msg.a;
				var pes = msg.b;
				return $author$project$CWS$closeModal(
					_Utils_Tuple2(
						model,
						A3($author$project$CWS$API$Core$api_User_AssignPEs, user, pes, model)));
			case 26:
				var sub = msg.a;
				return A3($author$project$CWS$updateOAuth, model, sub, 0);
			case 27:
				var authReturn = msg.a;
				var sub = msg.b;
				return A3($author$project$CWS$updateOAuth, model, sub, authReturn);
			case 34:
				return $author$project$CWS$handleAuthorized(model);
			case 36:
				var sub = msg.a;
				var _v8 = $author$project$InPageOAuth$regetAuthorization(model.Y);
				var newAuth = _v8.a;
				var authCmds = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Y: newAuth,
							bS: $elm$core$Maybe$Just(0),
							b3: _Utils_ap(
								model.b3,
								_List_fromArray(
									[sub]))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$CWS$genericAuthTranslator(0),
						authCmds));
			case 5:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					var _v10 = url.fu;
					if (_v10.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								model.v,
								$elm$url$Url$toString(url)));
					}
				} else {
					var href = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(href));
				}
			case 32:
				var sub = msg.a;
				var oldState = model.a;
				var _v11 = A2($author$project$CWS$PE$Reports$update, oldState.bz, sub);
				var newReports = _v11.a;
				var newReportsCmd = _v11.b;
				var newState = _Utils_update(
					oldState,
					{bz: newReports});
				var newModel = _Utils_update(
					model,
					{a: newState});
				var newCmds = A2($elm$core$Platform$Cmd$map, $author$project$CWS$Messages$ReportsMsg, newReportsCmd);
				return _Utils_Tuple2(newModel, newCmds);
			case 33:
				var servicesResult = msg.a;
				if (!servicesResult.$) {
					var services = servicesResult.a;
					var os = model.a;
					var mappedServices = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (service) {
								if (!service.$) {
									var base = service.a;
									return _Utils_Tuple2(base.v, service);
								} else {
									var base = service.a;
									return _Utils_Tuple2(base.v, service);
								}
							},
							services));
					var ns = _Utils_update(
						model,
						{cL: mappedServices});
					var cmd = $author$project$PlugMapOld$Core$setServices(services);
					return _Utils_Tuple2(
						ns,
						A2(
							$elm$core$Platform$Cmd$map,
							$elm$core$Basics$always($author$project$CWS$Messages$NoOp),
							cmd));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				return A2($author$project$CWS$notImplementedUpdate, model, msg);
		}
	});
var $author$project$CWS$update = F2(
	function (msg, app) {
		if (!app.$) {
			var model = app.a;
			return function (_v1) {
				var a = _v1.a;
				var b = _v1.b;
				return _Utils_Tuple2(
					$author$project$CWS$AppLoaded(a),
					b);
			}(
				A2($author$project$CWS$appUpdate, msg, model));
		} else {
			return _Utils_Tuple2(app, $elm$core$Platform$Cmd$none);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Rgba = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Element$rgb255 = F3(
	function (red, green, blue) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, 1);
	});
var $author$project$PAM$UI$Basic$black = A3($mdgriffith$elm_ui$Element$rgb255, 0, 0, 0);
var $mdgriffith$elm_ui$Internal$Model$AlignX = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$CenterX = 1;
var $mdgriffith$elm_ui$Element$centerX = $mdgriffith$elm_ui$Internal$Model$AlignX(1);
var $mdgriffith$elm_ui$Internal$Model$AlignY = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$CenterY = 1;
var $mdgriffith$elm_ui$Element$centerY = $mdgriffith$elm_ui$Internal$Model$AlignY(1);
var $mdgriffith$elm_ui$Internal$Model$Class = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$classes = {jZ: 'a', c8: 'atv', j3: 'ab', j4: 'cx', j5: 'cy', j6: 'acb', j7: 'accx', j8: 'accy', j9: 'acr', gN: 'al', gO: 'ar', kb: 'at', e2: 'ah', e3: 'av', kf: 's', kp: 'bh', kq: 'b', ks: 'w7', ku: 'bd', kv: 'bdt', d_: 'bn', kw: 'bs', d2: 'cpe', kJ: 'cp', kK: 'cpx', kL: 'cpy', bi: 'c', d8: 'ctr', ea: 'cb', eb: 'ccx', bj: 'ccy', dj: 'cl', ec: 'cr', kU: 'ct', k$: 'cptr', k0: 'ctxt', lA: 'fcs', hH: 'focus-within', lC: 'fs', fw: 'g', fy: 'hbh', fz: 'hc', hP: 'he', fA: 'hf', hQ: 'hfp', lL: 'hv', lR: 'ic', lT: 'fr', ev: 'lbl', lX: 'iml', lY: 'imlf', lZ: 'imlp', l_: 'implw', aL: 'it', l4: 'i', ie: 'lnk', cN: 'nb', $9: 'notxt', mR: 'ol', mZ: 'or', bZ: 'oq', m9: 'oh', iv: 'pg', ix: 'p', nb: 'ppe', iX: 'ui', i0: 'r', nH: 'sb', nI: 'sbx', nJ: 'sby', nK: 'sbt', nQ: 'e', nR: 'cap', nU: 'sev', n1: 'sk', n8: 't', n9: 'tc', oa: 'w8', ob: 'w2', oc: 'w9', od: 'tj', eX: 'tja', oe: 'tl', of: 'w3', og: 'w5', oh: 'w4', oi: 'tr', oj: 'w6', ok: 'w1', ol: 'tun', jD: 'ts', cd: 'clr', oz: 'u', gy: 'wc', jS: 'we', gz: 'wf', jT: 'wfp', gA: 'wrp'};
var $mdgriffith$elm_ui$Internal$Flag$Flag = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Second = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$flag = function (i) {
	return (i > 31) ? $mdgriffith$elm_ui$Internal$Flag$Second(1 << (i - 32)) : $mdgriffith$elm_ui$Internal$Flag$Flag(1 << i);
};
var $mdgriffith$elm_ui$Internal$Flag$overflow = $mdgriffith$elm_ui$Internal$Flag$flag(20);
var $mdgriffith$elm_ui$Element$clip = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.kJ);
var $mdgriffith$elm_ui$Internal$Model$Colored = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$StyleClass = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$bgColor = $mdgriffith$elm_ui$Internal$Flag$flag(8);
var $mdgriffith$elm_ui$Internal$Model$floatClass = function (x) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(x * 255));
};
var $mdgriffith$elm_ui$Internal$Model$formatColorClass = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return $mdgriffith$elm_ui$Internal$Model$floatClass(red) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(green) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(blue) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(alpha))))));
};
var $mdgriffith$elm_ui$Element$Background$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$bgColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'background-color',
			clr));
};
var $mdgriffith$elm_ui$Internal$Flag$fontColor = $mdgriffith$elm_ui$Internal$Flag$flag(14);
var $mdgriffith$elm_ui$Element$Font$color = function (fontColor) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(fontColor),
			'color',
			fontColor));
};
var $mdgriffith$elm_ui$Internal$Model$Unkeyed = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$AsColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$asColumn = 1;
var $mdgriffith$elm_ui$Internal$Model$Generic = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$div = $mdgriffith$elm_ui$Internal$Model$Generic;
var $mdgriffith$elm_ui$Internal$Model$NoNearbyChildren = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$columnClass = $mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.bi);
var $mdgriffith$elm_ui$Internal$Model$gridClass = $mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fw);
var $mdgriffith$elm_ui$Internal$Model$pageClass = $mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.iv);
var $mdgriffith$elm_ui$Internal$Model$paragraphClass = $mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ix);
var $mdgriffith$elm_ui$Internal$Model$rowClass = $mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.i0);
var $mdgriffith$elm_ui$Internal$Model$singleClass = $mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.nQ);
var $mdgriffith$elm_ui$Internal$Model$contextClasses = function (context) {
	switch (context) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Model$rowClass;
		case 1:
			return $mdgriffith$elm_ui$Internal$Model$columnClass;
		case 2:
			return $mdgriffith$elm_ui$Internal$Model$singleClass;
		case 3:
			return $mdgriffith$elm_ui$Internal$Model$gridClass;
		case 4:
			return $mdgriffith$elm_ui$Internal$Model$paragraphClass;
		default:
			return $mdgriffith$elm_ui$Internal$Model$pageClass;
	}
};
var $mdgriffith$elm_ui$Internal$Model$Keyed = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$NoStyleSheet = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$Styled = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$Unstyled = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addChildren = F2(
	function (existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(behind, existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(existing, inFront);
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					behind,
					_Utils_ap(existing, inFront));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$addKeyedChildren = F3(
	function (key, existing, nearbyChildren) {
		switch (nearbyChildren.$) {
			case 0:
				return existing;
			case 1:
				var behind = nearbyChildren.a;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					existing);
			case 2:
				var inFront = nearbyChildren.a;
				return _Utils_ap(
					existing,
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						inFront));
			default:
				var behind = nearbyChildren.a;
				var inFront = nearbyChildren.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						function (x) {
							return _Utils_Tuple2(key, x);
						},
						behind),
					_Utils_ap(
						existing,
						A2(
							$elm$core$List$map,
							function (x) {
								return _Utils_Tuple2(key, x);
							},
							inFront)));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$AsEl = 2;
var $mdgriffith$elm_ui$Internal$Model$asEl = 2;
var $mdgriffith$elm_ui$Internal$Model$AsParagraph = 4;
var $mdgriffith$elm_ui$Internal$Model$asParagraph = 4;
var $mdgriffith$elm_ui$Internal$Flag$alignBottom = $mdgriffith$elm_ui$Internal$Flag$flag(41);
var $mdgriffith$elm_ui$Internal$Flag$alignRight = $mdgriffith$elm_ui$Internal$Flag$flag(40);
var $mdgriffith$elm_ui$Internal$Flag$centerX = $mdgriffith$elm_ui$Internal$Flag$flag(42);
var $mdgriffith$elm_ui$Internal$Flag$centerY = $mdgriffith$elm_ui$Internal$Flag$flag(43);
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $mdgriffith$elm_ui$Internal$Model$lengthClassName = function (x) {
	switch (x.$) {
		case 0:
			var px = x.a;
			return $elm$core$String$fromInt(px) + 'px';
		case 1:
			return 'auto';
		case 2:
			var i = x.a;
			return $elm$core$String$fromInt(i) + 'fr';
		case 3:
			var min = x.a;
			var len = x.b;
			return 'min' + ($elm$core$String$fromInt(min) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
		default:
			var max = x.a;
			var len = x.b;
			return 'max' + ($elm$core$String$fromInt(max) + $mdgriffith$elm_ui$Internal$Model$lengthClassName(len));
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformClass = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'mv-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(x) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(y) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(z))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			return $elm$core$Maybe$Just(
				'tfrm-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ty) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(tz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sx) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(sz) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(ox) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oy) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(oz) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(angle))))))))))))))))))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$getStyleName = function (style) {
	switch (style.$) {
		case 13:
			var name = style.a;
			return name;
		case 12:
			var name = style.a;
			var o = style.b;
			return name;
		case 0:
			var _class = style.a;
			return _class;
		case 1:
			var name = style.a;
			return name;
		case 2:
			var i = style.a;
			return 'font-size-' + $elm$core$String$fromInt(i);
		case 3:
			var _class = style.a;
			return _class;
		case 4:
			var _class = style.a;
			return _class;
		case 5:
			var cls = style.a;
			var x = style.b;
			var y = style.c;
			return cls;
		case 7:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 6:
			var cls = style.a;
			var top = style.b;
			var right = style.c;
			var bottom = style.d;
			var left = style.e;
			return cls;
		case 8:
			var template = style.a;
			return 'grid-rows-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.nB)) + ('-cols-' + (A2(
				$elm$core$String$join,
				'-',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.kP)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.nV.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.nV.b)))))));
		case 9:
			var pos = style.a;
			return 'gp grid-pos-' + ($elm$core$String$fromInt(pos.i0) + ('-' + ($elm$core$String$fromInt(pos.hc) + ('-' + ($elm$core$String$fromInt(pos.jR) + ('-' + $elm$core$String$fromInt(pos.lI)))))));
		case 11:
			var selector = style.a;
			var subStyle = style.b;
			var name = function () {
				switch (selector) {
					case 0:
						return 'fs';
					case 1:
						return 'hv';
					default:
						return 'act';
				}
			}();
			return A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$map,
					function (sty) {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$getStyleName(sty);
						if (_v1 === '') {
							return '';
						} else {
							var styleName = _v1;
							return styleName + ('-' + name);
						}
					},
					subStyle));
		default:
			var x = style.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$mdgriffith$elm_ui$Internal$Model$transformClass(x));
	}
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $mdgriffith$elm_ui$Internal$Model$reduceStyles = F2(
	function (style, nevermind) {
		var cache = nevermind.a;
		var existing = nevermind.b;
		var styleName = $mdgriffith$elm_ui$Internal$Model$getStyleName(style);
		return A2($elm$core$Set$member, styleName, cache) ? nevermind : _Utils_Tuple2(
			A2($elm$core$Set$insert, styleName, cache),
			A2($elm$core$List$cons, style, existing));
	});
var $mdgriffith$elm_ui$Internal$Model$Property = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$Style = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$dot = function (c) {
	return '.' + c;
};
var $mdgriffith$elm_ui$Internal$Model$formatColor = function (_v0) {
	var red = _v0.a;
	var green = _v0.b;
	var blue = _v0.c;
	var alpha = _v0.d;
	return 'rgba(' + ($elm$core$String$fromInt(
		$elm$core$Basics$round(red * 255)) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(green * 255))) + ((',' + $elm$core$String$fromInt(
		$elm$core$Basics$round(blue * 255))) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))));
};
var $mdgriffith$elm_ui$Internal$Model$formatBoxShadow = function (shadow) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					shadow.hY ? $elm$core$Maybe$Just('inset') : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.mA.a) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.mA.b) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.aI) + 'px'),
					$elm$core$Maybe$Just(
					$elm$core$String$fromFloat(shadow.aV) + 'px'),
					$elm$core$Maybe$Just(
					$mdgriffith$elm_ui$Internal$Model$formatColor(shadow.M))
				])));
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $mdgriffith$elm_ui$Internal$Model$renderFocusStyle = function (focus) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hH) + ':focus-within',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.kt),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.kl),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										aI: shadow.aI,
										M: shadow.M,
										hY: false,
										mA: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.mA)),
										aV: shadow.aV
									}));
						},
						focus.nO),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					]))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$Style,
			($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + ':focus .focusable, ') + (($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + '.focusable:focus, ') + ('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + ' .focusable-thumb'))),
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'border-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.kt),
						A2(
						$elm$core$Maybe$map,
						function (color) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'background-color',
								$mdgriffith$elm_ui$Internal$Model$formatColor(color));
						},
						focus.kl),
						A2(
						$elm$core$Maybe$map,
						function (shadow) {
							return A2(
								$mdgriffith$elm_ui$Internal$Model$Property,
								'box-shadow',
								$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(
									{
										aI: shadow.aI,
										M: shadow.M,
										hY: false,
										mA: A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Basics$toFloat,
											A2($elm$core$Tuple$mapFirst, $elm$core$Basics$toFloat, shadow.mA)),
										aV: shadow.aV
									}));
						},
						focus.nO),
						$elm$core$Maybe$Just(
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'outline', 'none'))
					])))
		]);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $mdgriffith$elm_ui$Internal$Style$AllChildren = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Batch = function (a) {
	return {$: 6, a: a};
};
var $mdgriffith$elm_ui$Internal$Style$Child = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Class = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Descriptor = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Left = 3;
var $mdgriffith$elm_ui$Internal$Style$Prop = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Right = 2;
var $mdgriffith$elm_ui$Internal$Style$Self = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Supports = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Style$Content = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$Bottom = 1;
var $mdgriffith$elm_ui$Internal$Style$CenterX = 4;
var $mdgriffith$elm_ui$Internal$Style$CenterY = 5;
var $mdgriffith$elm_ui$Internal$Style$Top = 0;
var $mdgriffith$elm_ui$Internal$Style$alignments = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $mdgriffith$elm_ui$Internal$Style$contentName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kU);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ea);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ec);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.dj);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eb);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bj);
	}
};
var $mdgriffith$elm_ui$Internal$Style$selfName = function (desc) {
	switch (desc) {
		case 0:
			var _v1 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kb);
		case 1:
			var _v2 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j3);
		case 2:
			var _v3 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gO);
		case 3:
			var _v4 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gN);
		case 4:
			var _v5 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j4);
		default:
			var _v6 = desc;
			return $mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j5);
	}
};
var $mdgriffith$elm_ui$Internal$Style$describeAlignment = function (values) {
	var createDescription = function (alignment) {
		var _v0 = values(alignment);
		var content = _v0.a;
		var indiv = _v0.b;
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$contentName(alignment),
				content),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						indiv)
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$elDescription = _List_fromArray(
	[
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
		A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fy),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kp),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Descriptor,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nK),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n8),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gz),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'auto !important')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fz),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gz),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jT),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Child,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gy),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
			])),
		$mdgriffith$elm_ui$Internal$Style$describeAlignment(
		function (alignment) {
			switch (alignment) {
				case 0:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
							]));
				case 1:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
							]));
				case 2:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
							]));
				case 3:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							]));
				case 4:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
							]));
				default:
					return _Utils_Tuple2(
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
									]))
							]),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
							]));
			}
		})
	]);
var $mdgriffith$elm_ui$Internal$Style$gridAlignments = function (values) {
	var createDescription = function (alignment) {
		return _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$selfName(alignment),
						values(alignment))
					]))
			]);
	};
	return $mdgriffith$elm_ui$Internal$Style$Batch(
		A2($elm$core$List$concatMap, createDescription, $mdgriffith$elm_ui$Internal$Style$alignments));
};
var $mdgriffith$elm_ui$Internal$Style$Above = 0;
var $mdgriffith$elm_ui$Internal$Style$Behind = 5;
var $mdgriffith$elm_ui$Internal$Style$Below = 1;
var $mdgriffith$elm_ui$Internal$Style$OnLeft = 3;
var $mdgriffith$elm_ui$Internal$Style$OnRight = 2;
var $mdgriffith$elm_ui$Internal$Style$Within = 4;
var $mdgriffith$elm_ui$Internal$Style$locations = function () {
	var loc = 0;
	var _v0 = function () {
		switch (loc) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 0;
			case 3:
				return 0;
			case 4:
				return 0;
			default:
				return 0;
		}
	}();
	return _List_fromArray(
		[0, 1, 2, 3, 4, 5]);
}();
var $mdgriffith$elm_ui$Internal$Style$baseSheet = _List_fromArray(
	[
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		'html,body',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		_Utils_ap(
			$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
			_Utils_ap(
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nQ),
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lR))),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-height', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gz),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'img',
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'max-width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'object-fit', 'cover')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + ':focus',
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'outline', 'none')
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iX),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', '100%'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Child,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lT),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cN),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20')
							]))
					]))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cN),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nQ),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				$mdgriffith$elm_ui$Internal$Style$Batch(
				function (fn) {
					return A2($elm$core$List$map, fn, $mdgriffith$elm_ui$Internal$Style$locations);
				}(
					function (loc) {
						switch (loc) {
							case 0:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jZ),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gz),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
												])),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 1:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kq),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'bottom', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												])),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', 'auto')
												]))
										]));
							case 2:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mZ),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 3:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mR),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'right', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '20'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							case 4:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lT),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
							default:
								return A2(
									$mdgriffith$elm_ui$Internal$Style$Descriptor,
									$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kp),
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'absolute'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none'),
											A2(
											$mdgriffith$elm_ui$Internal$Style$Child,
											'*',
											_List_fromArray(
												[
													A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto')
												]))
										]));
						}
					}))
			])),
		A2(
		$mdgriffith$elm_ui$Internal$Style$Class,
		$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
		_List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'relative'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'resize', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'box-sizing', 'border-box'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'padding', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-size', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-family', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', 'inherit'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'none'),
				A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'inherit'),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gA),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-wrap', 'wrap')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.$9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-moz-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-webkit-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, '-ms-user-select', 'none'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'user-select', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k$),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'pointer')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.k0),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nb),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.d2),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'auto !important')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.cd),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bZ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.lL, $mdgriffith$elm_ui$Internal$Style$classes.cd)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.lL, $mdgriffith$elm_ui$Internal$Style$classes.bZ)) + ':hover',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.lA, $mdgriffith$elm_ui$Internal$Style$classes.cd)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.lA, $mdgriffith$elm_ui$Internal$Style$classes.bZ)) + ':focus',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.c8, $mdgriffith$elm_ui$Internal$Style$classes.cd)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot(
					_Utils_ap($mdgriffith$elm_ui$Internal$Style$classes.c8, $mdgriffith$elm_ui$Internal$Style$classes.bZ)) + ':active',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'opacity', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jD),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Prop,
						'transition',
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function (x) {
									return x + ' 160ms';
								},
								_List_fromArray(
									['transform', 'opacity', 'filter', 'background-color', 'color', 'font-size']))))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nH),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nI),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i0),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nJ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'auto'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bi),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-shrink', '1')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kJ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kK),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-x', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kL),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-y', 'hidden')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gy),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', 'auto')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.d_),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-width', '0')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ku),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dashed')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'dotted')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kw),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'border-style', 'solid')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n8),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.aL),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'line-height', '1.05'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background', 'transparent'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'inherit')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nQ),
				$mdgriffith$elm_ui$Internal$Style$elDescription),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i0),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'row'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0%'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jS),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ie),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gz),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.d8),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.j9,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.j7,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j4),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-left', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.j7,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j4),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-right', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.j7,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j5),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.j7 + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.j9 + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.j7)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_Nil);
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_Nil);
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nU),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ev),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'baseline')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bi),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-direction', 'column'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', '0px'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'min-height', 'min-content'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.hP),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fA),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '100000')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gz),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jT),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.gy),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.j6,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:first-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.j8,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j5),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.j8,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j5),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', '0 !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:only-of-type.' + $mdgriffith$elm_ui$Internal$Style$classes.j8,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '1'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.j5),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto !important'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto !important')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						's:last-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.j8 + ' ~ u'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'u:first-of-type.' + ($mdgriffith$elm_ui$Internal$Style$classes.j6 + (' ~ s.' + $mdgriffith$elm_ui$Internal$Style$classes.j8)),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-bottom', 'auto')
											]));
								case 1:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin-top', 'auto')
											]));
								case 2:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-end')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'flex-start')
											]));
								case 4:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
											]),
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'center')
											]));
								default:
									return _Utils_Tuple2(
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
											]),
										_List_Nil);
							}
						}),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.d8),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-grow', '0'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-self', 'stretch !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nU),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'space-between')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fw),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', '-ms-grid'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						'.gp',
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Supports,
						_Utils_Tuple2('display', 'grid'),
						_List_fromArray(
							[
								_Utils_Tuple2('display', 'grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$gridAlignments(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-start')
										]);
								case 1:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'flex-end')
										]);
								case 2:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-end')
										]);
								case 3:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'flex-start')
										]);
								case 4:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'align-items', 'center')
										]);
								default:
									return _List_fromArray(
										[
											A2($mdgriffith$elm_ui$Internal$Style$Prop, 'justify-content', 'center')
										]);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.iv),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf + ':first-child'),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.kf + ($mdgriffith$elm_ui$Internal$Style$selfName(3) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.kf))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot(
							$mdgriffith$elm_ui$Internal$Style$classes.kf + ($mdgriffith$elm_ui$Internal$Style$selfName(2) + (':first-child + .' + $mdgriffith$elm_ui$Internal$Style$classes.kf))),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'margin', '0 !important')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left'),
												A2(
												$mdgriffith$elm_ui$Internal$Style$Descriptor,
												'::after',
												_List_fromArray(
													[
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', '\"\"'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'table'),
														A2($mdgriffith$elm_ui$Internal$Style$Prop, 'clear', 'both')
													]))
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'background-color', 'transparent')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.l_),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'flex-basis', 'auto')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lZ),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'cursor', 'text'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lY),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'pre-wrap !important'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'color', 'transparent')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ix),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'block'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'overflow-wrap', 'break-word'),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Descriptor,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fy),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '0'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kp),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'z-index', '-1')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n8),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ix),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::after',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								'::before',
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'content', 'none')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$AllChildren,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.nQ),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal'),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jS),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-block')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.lT),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kp),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.jZ),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kq),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mZ),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Descriptor,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.mR),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'flex')
									])),
								A2(
								$mdgriffith$elm_ui$Internal$Style$Child,
								$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n8),
								_List_fromArray(
									[
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline'),
										A2($mdgriffith$elm_ui$Internal$Style$Prop, 'white-space', 'normal')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i0),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.bi),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-flex')
							])),
						A2(
						$mdgriffith$elm_ui$Internal$Style$Child,
						$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.fw),
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'inline-grid')
							])),
						$mdgriffith$elm_ui$Internal$Style$describeAlignment(
						function (alignment) {
							switch (alignment) {
								case 0:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 1:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								case 2:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'right')
											]));
								case 3:
									return _Utils_Tuple2(
										_List_Nil,
										_List_fromArray(
											[
												A2($mdgriffith$elm_ui$Internal$Style$Prop, 'float', 'left')
											]));
								case 4:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
								default:
									return _Utils_Tuple2(_List_Nil, _List_Nil);
							}
						})
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.hidden',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'display', 'none')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ok),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '100')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ob),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '200')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.of),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '300')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oh),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '400')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.og),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '500')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oj),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '600')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ks),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '700')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oa),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '800')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oc),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-weight', '900')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.l4),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'italic')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n1),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oz),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				_Utils_ap(
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oz),
					$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n1)),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration', 'line-through underline'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip-ink', 'auto'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-decoration-skip', 'ink')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.ol),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-style', 'normal')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.od),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.eX),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'justify-all')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.n9),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'center')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oi),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'right')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				$mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.oe),
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'text-align', 'left')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Descriptor,
				'.modal',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'position', 'fixed'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'left', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'top', '0'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'width', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'height', '100%'),
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'pointer-events', 'none')
					]))
			]))
	]);
var $mdgriffith$elm_ui$Internal$Style$fontVariant = function (_var) {
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + _var,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\"'))
				])),
			A2(
			$mdgriffith$elm_ui$Internal$Style$Class,
			'.v-' + (_var + '-off'),
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-feature-settings', '\"' + (_var + '\" 0'))
				]))
		]);
};
var $mdgriffith$elm_ui$Internal$Style$commonValues = $elm$core$List$concat(
	_List_fromArray(
		[
			A2(
			$elm$core$List$map,
			function (x) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.border-' + $elm$core$String$fromInt(x),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'border-width',
							$elm$core$String$fromInt(x) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 6)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 8, 32)),
			A2(
			$elm$core$List$map,
			function (i) {
				return A2(
					$mdgriffith$elm_ui$Internal$Style$Class,
					'.p-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Style$Prop,
							'padding',
							$elm$core$String$fromInt(i) + 'px')
						]));
			},
			A2($elm$core$List$range, 0, 24)),
			_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'small-caps')
					])),
				A2(
				$mdgriffith$elm_ui$Internal$Style$Class,
				'.v-smcp-off',
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Internal$Style$Prop, 'font-variant', 'normal')
					]))
			]),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('zero'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('onum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('liga'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('dlig'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('ordn'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('tnum'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('afrc'),
			$mdgriffith$elm_ui$Internal$Style$fontVariant('frac')
		]));
var $mdgriffith$elm_ui$Internal$Style$explainer = '\n.explain {\n    border: 6px solid rgb(174, 121, 15) !important;\n}\n.explain > .' + ($mdgriffith$elm_ui$Internal$Style$classes.kf + (' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n.ctr {\n    border: none !important;\n}\n.explain > .ctr > .' + ($mdgriffith$elm_ui$Internal$Style$classes.kf + ' {\n    border: 4px dashed rgb(0, 151, 167) !important;\n}\n\n')));
var $mdgriffith$elm_ui$Internal$Style$inputTextReset = '\ninput[type="search"],\ninput[type="search"]::-webkit-search-decoration,\ninput[type="search"]::-webkit-search-cancel-button,\ninput[type="search"]::-webkit-search-results-button,\ninput[type="search"]::-webkit-search-results-decoration {\n  -webkit-appearance:none;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$sliderReset = '\ninput[type=range] {\n  -webkit-appearance: none; \n  background: transparent;\n  position:absolute;\n  left:0;\n  top:0;\n  z-index:10;\n  width: 100%;\n  outline: dashed 1px;\n  height: 100%;\n  opacity: 0;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$thumbReset = '\ninput[type=range]::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-moz-range-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range]::-ms-thumb {\n    opacity: 0.5;\n    width: 80px;\n    height: 80px;\n    background-color: black;\n    border:none;\n    border-radius: 5px;\n}\ninput[type=range][orient=vertical]{\n    writing-mode: bt-lr; /* IE */\n    -webkit-appearance: slider-vertical;  /* WebKit */\n}\n';
var $mdgriffith$elm_ui$Internal$Style$trackReset = '\ninput[type=range]::-moz-range-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-ms-track {\n    background: transparent;\n    cursor: pointer;\n}\ninput[type=range]::-webkit-slider-runnable-track {\n    background: transparent;\n    cursor: pointer;\n}\n';
var $mdgriffith$elm_ui$Internal$Style$overrides = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i0) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + (' { flex-basis: auto !important; } ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.i0) + (' > ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.d8) + (' { flex-basis: auto !important; }}' + ($mdgriffith$elm_ui$Internal$Style$inputTextReset + ($mdgriffith$elm_ui$Internal$Style$sliderReset + ($mdgriffith$elm_ui$Internal$Style$trackReset + ($mdgriffith$elm_ui$Internal$Style$thumbReset + $mdgriffith$elm_ui$Internal$Style$explainer)))))))))))))));
var $mdgriffith$elm_ui$Internal$Style$Intermediate = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Internal$Style$emptyIntermediate = F2(
	function (selector, closing) {
		return {d6: closing, S: _List_Nil, by: _List_Nil, aU: selector};
	});
var $mdgriffith$elm_ui$Internal$Style$renderRules = F2(
	function (_v0, rulesToRender) {
		var parent = _v0;
		var generateIntermediates = F2(
			function (rule, rendered) {
				switch (rule.$) {
					case 0:
						var name = rule.a;
						var val = rule.b;
						return _Utils_update(
							rendered,
							{
								by: A2(
									$elm$core$List$cons,
									_Utils_Tuple2(name, val),
									rendered.by)
							});
					case 3:
						var _v2 = rule.a;
						var prop = _v2.a;
						var value = _v2.b;
						var props = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									{d6: '\n}', S: _List_Nil, by: props, aU: '@supports (' + (prop + (':' + (value + (') {' + parent.aU))))},
									rendered.S)
							});
					case 5:
						var selector = rule.a;
						var adjRules = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.aU + (' + ' + selector), ''),
										adjRules),
									rendered.S)
							});
					case 1:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.aU + (' > ' + child), ''),
										childRules),
									rendered.S)
							});
					case 2:
						var child = rule.a;
						var childRules = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.aU + (' ' + child), ''),
										childRules),
									rendered.S)
							});
					case 4:
						var descriptor = rule.a;
						var descriptorRules = rule.b;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2(
											$mdgriffith$elm_ui$Internal$Style$emptyIntermediate,
											_Utils_ap(parent.aU, descriptor),
											''),
										descriptorRules),
									rendered.S)
							});
					default:
						var batched = rule.a;
						return _Utils_update(
							rendered,
							{
								S: A2(
									$elm$core$List$cons,
									A2(
										$mdgriffith$elm_ui$Internal$Style$renderRules,
										A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, parent.aU, ''),
										batched),
									rendered.S)
							});
				}
			});
		return A3($elm$core$List$foldr, generateIntermediates, parent, rulesToRender);
	});
var $mdgriffith$elm_ui$Internal$Style$renderCompact = function (styleClasses) {
	var renderValues = function (values) {
		return $elm$core$String$concat(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var x = _v3.a;
					var y = _v3.b;
					return x + (':' + (y + ';'));
				},
				values));
	};
	var renderClass = function (rule) {
		var _v2 = rule.by;
		if (!_v2.b) {
			return '';
		} else {
			return rule.aU + ('{' + (renderValues(rule.by) + (rule.d6 + '}')));
		}
	};
	var renderIntermediate = function (_v0) {
		var rule = _v0;
		return _Utils_ap(
			renderClass(rule),
			$elm$core$String$concat(
				A2($elm$core$List$map, renderIntermediate, rule.S)));
	};
	return $elm$core$String$concat(
		A2(
			$elm$core$List$map,
			renderIntermediate,
			A3(
				$elm$core$List$foldr,
				F2(
					function (_v1, existing) {
						var name = _v1.a;
						var styleRules = _v1.b;
						return A2(
							$elm$core$List$cons,
							A2(
								$mdgriffith$elm_ui$Internal$Style$renderRules,
								A2($mdgriffith$elm_ui$Internal$Style$emptyIntermediate, name, ''),
								styleRules),
							existing);
					}),
				_List_Nil,
				styleClasses)));
};
var $mdgriffith$elm_ui$Internal$Style$rules = _Utils_ap(
	$mdgriffith$elm_ui$Internal$Style$overrides,
	$mdgriffith$elm_ui$Internal$Style$renderCompact(
		_Utils_ap($mdgriffith$elm_ui$Internal$Style$baseSheet, $mdgriffith$elm_ui$Internal$Style$commonValues)));
var $mdgriffith$elm_ui$Internal$Model$staticRoot = function (opts) {
	var _v0 = opts.mp;
	switch (_v0) {
		case 0:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'div',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$virtual_dom$VirtualDom$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$virtual_dom$VirtualDom$text($mdgriffith$elm_ui$Internal$Style$rules)
							]))
					]));
		case 1:
			return $elm$virtual_dom$VirtualDom$text('');
		default:
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				'elm-ui-static-rules',
				_List_fromArray(
					[
						A2(
						$elm$virtual_dom$VirtualDom$property,
						'rules',
						$elm$json$Json$Encode$string($mdgriffith$elm_ui$Internal$Style$rules))
					]),
				_List_Nil);
	}
};
var $mdgriffith$elm_ui$Internal$Model$fontName = function (font) {
	switch (font.$) {
		case 0:
			return 'serif';
		case 1:
			return 'sans-serif';
		case 2:
			return 'monospace';
		case 3:
			var name = font.a;
			return '\"' + (name + '\"');
		case 4:
			var name = font.a;
			var url = font.b;
			return '\"' + (name + '\"');
		default:
			var name = font.a.dz;
			return '\"' + (name + '\"');
	}
};
var $mdgriffith$elm_ui$Internal$Model$isSmallCaps = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return name === 'smcp';
		case 1:
			var name = _var.a;
			return false;
		default:
			var name = _var.a;
			var index = _var.b;
			return (name === 'smcp') && (index === 1);
	}
};
var $mdgriffith$elm_ui$Internal$Model$hasSmallCaps = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$isSmallCaps, font.jK);
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderProps = F3(
	function (force, _v0, existing) {
		var key = _v0.a;
		var val = _v0.b;
		return force ? (existing + ('\n  ' + (key + (': ' + (val + ' !important;'))))) : (existing + ('\n  ' + (key + (': ' + (val + ';')))));
	});
var $mdgriffith$elm_ui$Internal$Model$renderStyle = F4(
	function (options, maybePseudo, selector, props) {
		if (maybePseudo.$ === 1) {
			return _List_fromArray(
				[
					selector + ('{' + (A3(
					$elm$core$List$foldl,
					$mdgriffith$elm_ui$Internal$Model$renderProps(false),
					'',
					props) + '\n}'))
				]);
		} else {
			var pseudo = maybePseudo.a;
			switch (pseudo) {
				case 1:
					var _v2 = options.lL;
					switch (_v2) {
						case 0:
							return _List_Nil;
						case 2:
							return _List_fromArray(
								[
									selector + ('-hv {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(true),
									'',
									props) + '\n}'))
								]);
						default:
							return _List_fromArray(
								[
									selector + ('-hv:hover {' + (A3(
									$elm$core$List$foldl,
									$mdgriffith$elm_ui$Internal$Model$renderProps(false),
									'',
									props) + '\n}'))
								]);
					}
				case 0:
					var renderedProps = A3(
						$elm$core$List$foldl,
						$mdgriffith$elm_ui$Internal$Model$renderProps(false),
						'',
						props);
					return _List_fromArray(
						[
							selector + ('-fs:focus {' + (renderedProps + '\n}')),
							('.' + ($mdgriffith$elm_ui$Internal$Style$classes.kf + (':focus ' + (selector + '-fs  {')))) + (renderedProps + '\n}'),
							(selector + '-fs:focus-within {') + (renderedProps + '\n}'),
							('.ui-slide-bar:focus + ' + ($mdgriffith$elm_ui$Internal$Style$dot($mdgriffith$elm_ui$Internal$Style$classes.kf) + (' .focusable-thumb' + (selector + '-fs {')))) + (renderedProps + '\n}')
						]);
				default:
					return _List_fromArray(
						[
							selector + ('-act:active {' + (A3(
							$elm$core$List$foldl,
							$mdgriffith$elm_ui$Internal$Model$renderProps(false),
							'',
							props) + '\n}'))
						]);
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderVariant = function (_var) {
	switch (_var.$) {
		case 0:
			var name = _var.a;
			return '\"' + (name + '\"');
		case 1:
			var name = _var.a;
			return '\"' + (name + '\" 0');
		default:
			var name = _var.a;
			var index = _var.b;
			return '\"' + (name + ('\" ' + $elm$core$String$fromInt(index)));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderVariants = function (typeface) {
	if (typeface.$ === 5) {
		var font = typeface.a;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$renderVariant, font.jK)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$transformValue = function (transform) {
	switch (transform.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var _v1 = transform.a;
			var x = _v1.a;
			var y = _v1.b;
			var z = _v1.c;
			return $elm$core$Maybe$Just(
				'translate3d(' + ($elm$core$String$fromFloat(x) + ('px, ' + ($elm$core$String$fromFloat(y) + ('px, ' + ($elm$core$String$fromFloat(z) + 'px)'))))));
		default:
			var _v2 = transform.a;
			var tx = _v2.a;
			var ty = _v2.b;
			var tz = _v2.c;
			var _v3 = transform.b;
			var sx = _v3.a;
			var sy = _v3.b;
			var sz = _v3.c;
			var _v4 = transform.c;
			var ox = _v4.a;
			var oy = _v4.b;
			var oz = _v4.c;
			var angle = transform.d;
			var translate = 'translate3d(' + ($elm$core$String$fromFloat(tx) + ('px, ' + ($elm$core$String$fromFloat(ty) + ('px, ' + ($elm$core$String$fromFloat(tz) + 'px)')))));
			var scale = 'scale3d(' + ($elm$core$String$fromFloat(sx) + (', ' + ($elm$core$String$fromFloat(sy) + (', ' + ($elm$core$String$fromFloat(sz) + ')')))));
			var rotate = 'rotate3d(' + ($elm$core$String$fromFloat(ox) + (', ' + ($elm$core$String$fromFloat(oy) + (', ' + ($elm$core$String$fromFloat(oz) + (', ' + ($elm$core$String$fromFloat(angle) + 'rad)')))))));
			return $elm$core$Maybe$Just(translate + (' ' + (scale + (' ' + rotate))));
	}
};
var $mdgriffith$elm_ui$Internal$Model$renderStyleRule = F3(
	function (options, rule, maybePseudo) {
		switch (rule.$) {
			case 0:
				var selector = rule.a;
				var props = rule.b;
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, selector, props);
			case 13:
				var name = rule.a;
				var prop = rule.b;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, 'box-shadow', prop)
						]));
			case 12:
				var name = rule.a;
				var transparency = rule.b;
				var opacity = A2(
					$elm$core$Basics$max,
					0,
					A2($elm$core$Basics$min, 1, 1 - transparency));
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + name,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'opacity',
							$elm$core$String$fromFloat(opacity))
						]));
			case 2:
				var i = rule.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.font-size-' + $elm$core$String$fromInt(i),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'font-size',
							$elm$core$String$fromInt(i) + 'px')
						]));
			case 1:
				var name = rule.a;
				var typefaces = rule.b;
				var features = A2(
					$elm$core$String$join,
					', ',
					A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Internal$Model$renderVariants, typefaces));
				var families = _List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-family',
						A2(
							$elm$core$String$join,
							', ',
							A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$fontName, typefaces))),
						A2($mdgriffith$elm_ui$Internal$Model$Property, 'font-feature-settings', features),
						A2(
						$mdgriffith$elm_ui$Internal$Model$Property,
						'font-variant',
						A2($elm$core$List$any, $mdgriffith$elm_ui$Internal$Model$hasSmallCaps, typefaces) ? 'small-caps' : 'normal')
					]);
				return A4($mdgriffith$elm_ui$Internal$Model$renderStyle, options, maybePseudo, '.' + name, families);
			case 3:
				var _class = rule.a;
				var prop = rule.b;
				var val = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Internal$Model$Property, prop, val)
						]));
			case 4:
				var _class = rule.a;
				var prop = rule.b;
				var color = rule.c;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					'.' + _class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							prop,
							$mdgriffith$elm_ui$Internal$Model$formatColor(color))
						]));
			case 5:
				var cls = rule.a;
				var x = rule.b;
				var y = rule.c;
				var yPx = $elm$core$String$fromInt(y) + 'px';
				var xPx = $elm$core$String$fromInt(x) + 'px';
				var single = '.' + $mdgriffith$elm_ui$Internal$Style$classes.nQ;
				var row = '.' + $mdgriffith$elm_ui$Internal$Style$classes.i0;
				var wrappedRow = '.' + ($mdgriffith$elm_ui$Internal$Style$classes.gA + row);
				var right = '.' + $mdgriffith$elm_ui$Internal$Style$classes.gO;
				var paragraph = '.' + $mdgriffith$elm_ui$Internal$Style$classes.ix;
				var page = '.' + $mdgriffith$elm_ui$Internal$Style$classes.iv;
				var left = '.' + $mdgriffith$elm_ui$Internal$Style$classes.gN;
				var halfY = $elm$core$String$fromFloat(y / 2) + 'px';
				var halfX = $elm$core$String$fromFloat(x / 2) + 'px';
				var column = '.' + $mdgriffith$elm_ui$Internal$Style$classes.bi;
				var _class = '.' + cls;
				var any = '.' + $mdgriffith$elm_ui$Internal$Style$classes.kf;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (row + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (wrappedRow + (' > ' + any)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin', halfY + (' ' + halfX))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (column + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + (any + (' + ' + any)))),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-top', yPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (page + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_Utils_ap(_class, paragraph),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							'textarea' + (any + _class),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'line-height',
									'calc(1em + ' + ($elm$core$String$fromInt(y) + 'px)')),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'height',
									'calc(100% + ' + ($elm$core$String$fromInt(y) + 'px)'))
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + left)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-right', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + (' > ' + right)),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'margin-left', xPx)
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::after'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-top',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								])),
							A4(
							$mdgriffith$elm_ui$Internal$Model$renderStyle,
							options,
							maybePseudo,
							_class + (paragraph + '::before'),
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'content', '\'\''),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'display', 'block'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', '0'),
									A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', '0'),
									A2(
									$mdgriffith$elm_ui$Internal$Model$Property,
									'margin-bottom',
									$elm$core$String$fromInt((-1) * ((y / 2) | 0)) + 'px')
								]))
						]));
			case 7:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'padding',
							$elm$core$String$fromFloat(top) + ('px ' + ($elm$core$String$fromFloat(right) + ('px ' + ($elm$core$String$fromFloat(bottom) + ('px ' + ($elm$core$String$fromFloat(left) + 'px')))))))
						]));
			case 6:
				var cls = rule.a;
				var top = rule.b;
				var right = rule.c;
				var bottom = rule.d;
				var left = rule.e;
				var _class = '.' + cls;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$renderStyle,
					options,
					maybePseudo,
					_class,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$Property,
							'border-width',
							$elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px')))))))
						]));
			case 8:
				var template = rule.a;
				var toGridLengthHelper = F3(
					function (minimum, maximum, x) {
						toGridLengthHelper:
						while (true) {
							switch (x.$) {
								case 0:
									var px = x.a;
									return $elm$core$String$fromInt(px) + 'px';
								case 1:
									var _v2 = _Utils_Tuple2(minimum, maximum);
									if (_v2.a.$ === 1) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.a;
											var _v4 = _v2.b;
											return 'max-content';
										} else {
											var _v6 = _v2.a;
											var maxSize = _v2.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v2.b.$ === 1) {
											var minSize = _v2.a.a;
											var _v5 = _v2.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + 'max-content)'));
										} else {
											var minSize = _v2.a.a;
											var maxSize = _v2.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 2:
									var i = x.a;
									var _v7 = _Utils_Tuple2(minimum, maximum);
									if (_v7.a.$ === 1) {
										if (_v7.b.$ === 1) {
											var _v8 = _v7.a;
											var _v9 = _v7.b;
											return $elm$core$String$fromInt(i) + 'fr';
										} else {
											var _v11 = _v7.a;
											var maxSize = _v7.b.a;
											return 'minmax(max-content, ' + ($elm$core$String$fromInt(maxSize) + 'px)');
										}
									} else {
										if (_v7.b.$ === 1) {
											var minSize = _v7.a.a;
											var _v10 = _v7.b;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(i) + ('fr' + 'fr)'))));
										} else {
											var minSize = _v7.a.a;
											var maxSize = _v7.b.a;
											return 'minmax(' + ($elm$core$String$fromInt(minSize) + ('px, ' + ($elm$core$String$fromInt(maxSize) + 'px)')));
										}
									}
								case 3:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = $elm$core$Maybe$Just(m),
										$temp$maximum = maximum,
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
								default:
									var m = x.a;
									var len = x.b;
									var $temp$minimum = minimum,
										$temp$maximum = $elm$core$Maybe$Just(m),
										$temp$x = len;
									minimum = $temp$minimum;
									maximum = $temp$maximum;
									x = $temp$x;
									continue toGridLengthHelper;
							}
						}
					});
				var toGridLength = function (x) {
					return A3(toGridLengthHelper, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, x);
				};
				var xSpacing = toGridLength(template.nV.a);
				var ySpacing = toGridLength(template.nV.b);
				var rows = function (x) {
					return 'grid-template-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.nB)));
				var msRows = function (x) {
					return '-ms-grid-rows: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.kP)));
				var msColumns = function (x) {
					return '-ms-grid-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						ySpacing,
						A2($elm$core$List$map, toGridLength, template.kP)));
				var gapY = 'grid-row-gap:' + (toGridLength(template.nV.b) + ';');
				var gapX = 'grid-column-gap:' + (toGridLength(template.nV.a) + ';');
				var columns = function (x) {
					return 'grid-template-columns: ' + (x + ';');
				}(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, toGridLength, template.kP)));
				var _class = '.grid-rows-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.nB)) + ('-cols-' + (A2(
					$elm$core$String$join,
					'-',
					A2($elm$core$List$map, $mdgriffith$elm_ui$Internal$Model$lengthClassName, template.kP)) + ('-space-x-' + ($mdgriffith$elm_ui$Internal$Model$lengthClassName(template.nV.a) + ('-space-y-' + $mdgriffith$elm_ui$Internal$Model$lengthClassName(template.nV.b)))))));
				var modernGrid = _class + ('{' + (columns + (rows + (gapX + (gapY + '}')))));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msColumns + (msRows + '}')));
				return _List_fromArray(
					[base, supports]);
			case 9:
				var position = rule.a;
				var msPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'-ms-grid-row: ' + ($elm$core$String$fromInt(position.i0) + ';'),
							'-ms-grid-row-span: ' + ($elm$core$String$fromInt(position.lI) + ';'),
							'-ms-grid-column: ' + ($elm$core$String$fromInt(position.hc) + ';'),
							'-ms-grid-column-span: ' + ($elm$core$String$fromInt(position.jR) + ';')
						]));
				var modernPosition = A2(
					$elm$core$String$join,
					' ',
					_List_fromArray(
						[
							'grid-row: ' + ($elm$core$String$fromInt(position.i0) + (' / ' + ($elm$core$String$fromInt(position.i0 + position.lI) + ';'))),
							'grid-column: ' + ($elm$core$String$fromInt(position.hc) + (' / ' + ($elm$core$String$fromInt(position.hc + position.jR) + ';')))
						]));
				var _class = '.grid-pos-' + ($elm$core$String$fromInt(position.i0) + ('-' + ($elm$core$String$fromInt(position.hc) + ('-' + ($elm$core$String$fromInt(position.jR) + ('-' + $elm$core$String$fromInt(position.lI)))))));
				var modernGrid = _class + ('{' + (modernPosition + '}'));
				var supports = '@supports (display:grid) {' + (modernGrid + '}');
				var base = _class + ('{' + (msPosition + '}'));
				return _List_fromArray(
					[base, supports]);
			case 11:
				var _class = rule.a;
				var styles = rule.b;
				var renderPseudoRule = function (style) {
					return A3(
						$mdgriffith$elm_ui$Internal$Model$renderStyleRule,
						options,
						style,
						$elm$core$Maybe$Just(_class));
				};
				return A2($elm$core$List$concatMap, renderPseudoRule, styles);
			default:
				var transform = rule.a;
				var val = $mdgriffith$elm_ui$Internal$Model$transformValue(transform);
				var _class = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				var _v12 = _Utils_Tuple2(_class, val);
				if ((!_v12.a.$) && (!_v12.b.$)) {
					var cls = _v12.a.a;
					var v = _v12.b.a;
					return A4(
						$mdgriffith$elm_ui$Internal$Model$renderStyle,
						options,
						maybePseudo,
						'.' + cls,
						_List_fromArray(
							[
								A2($mdgriffith$elm_ui$Internal$Model$Property, 'transform', v)
							]));
				} else {
					return _List_Nil;
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$encodeStyles = F2(
	function (options, stylesheet) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$map,
				function (style) {
					var styled = A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing);
					return _Utils_Tuple2(
						$mdgriffith$elm_ui$Internal$Model$getStyleName(style),
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, styled));
				},
				stylesheet));
	});
var $mdgriffith$elm_ui$Internal$Model$bracket = F2(
	function (selector, rules) {
		var renderPair = function (_v0) {
			var name = _v0.a;
			var val = _v0.b;
			return name + (': ' + (val + ';'));
		};
		return selector + (' {' + (A2(
			$elm$core$String$join,
			'',
			A2($elm$core$List$map, renderPair, rules)) + '}'));
	});
var $mdgriffith$elm_ui$Internal$Model$fontRule = F3(
	function (name, modifier, _v0) {
		var parentAdj = _v0.a;
		var textAdjustment = _v0.b;
		return _List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + (', ' + ('.' + (name + (' .' + modifier))))))), parentAdj),
				A2($mdgriffith$elm_ui$Internal$Model$bracket, '.' + (name + ('.' + (modifier + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.n8 + (', .' + (name + (' .' + (modifier + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.n8)))))))))), textAdjustment)
			]);
	});
var $mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule = F3(
	function (fontToAdjust, _v0, otherFontName) {
		var full = _v0.a;
		var capital = _v0.b;
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_Utils_ap(
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.nR, capital),
				A3($mdgriffith$elm_ui$Internal$Model$fontRule, name, $mdgriffith$elm_ui$Internal$Style$classes.lC, full)));
	});
var $mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule = F2(
	function (fontToAdjust, otherFontName) {
		var name = _Utils_eq(fontToAdjust, otherFontName) ? fontToAdjust : (otherFontName + (' .' + fontToAdjust));
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.nR + (', ' + ('.' + (name + (' .' + $mdgriffith$elm_ui$Internal$Style$classes.nR))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('line-height', '1')
						])),
					A2(
					$mdgriffith$elm_ui$Internal$Model$bracket,
					'.' + (name + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.nR + ('> .' + ($mdgriffith$elm_ui$Internal$Style$classes.n8 + (', .' + (name + (' .' + ($mdgriffith$elm_ui$Internal$Style$classes.nR + (' > .' + $mdgriffith$elm_ui$Internal$Style$classes.n8)))))))))),
					_List_fromArray(
						[
							_Utils_Tuple2('vertical-align', '0'),
							_Utils_Tuple2('line-height', '1')
						]))
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$adjust = F3(
	function (size, height, vertical) {
		return {lI: height / size, aV: size, jM: vertical};
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$convertAdjustment = function (adjustment) {
	var lines = _List_fromArray(
		[adjustment.kC, adjustment.ko, adjustment.k9, adjustment.mg]);
	var lineHeight = 1.5;
	var normalDescender = (lineHeight - 1) / 2;
	var oldMiddle = lineHeight / 2;
	var descender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.k9,
		$elm$core$List$minimum(lines));
	var newBaseline = A2(
		$elm$core$Maybe$withDefault,
		adjustment.ko,
		$elm$core$List$minimum(
			A2(
				$elm$core$List$filter,
				function (x) {
					return !_Utils_eq(x, descender);
				},
				lines)));
	var base = lineHeight;
	var ascender = A2(
		$elm$core$Maybe$withDefault,
		adjustment.kC,
		$elm$core$List$maximum(lines));
	var capitalSize = 1 / (ascender - newBaseline);
	var capitalVertical = 1 - ascender;
	var fullSize = 1 / (ascender - descender);
	var fullVertical = 1 - ascender;
	var newCapitalMiddle = ((ascender - newBaseline) / 2) + newBaseline;
	var newFullMiddle = ((ascender - descender) / 2) + descender;
	return {
		kC: A3($mdgriffith$elm_ui$Internal$Model$adjust, capitalSize, ascender - newBaseline, capitalVertical),
		er: A3($mdgriffith$elm_ui$Internal$Model$adjust, fullSize, ascender - descender, fullVertical)
	};
};
var $mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules = function (converted) {
	return _Utils_Tuple2(
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'block')
			]),
		_List_fromArray(
			[
				_Utils_Tuple2('display', 'inline-block'),
				_Utils_Tuple2(
				'line-height',
				$elm$core$String$fromFloat(converted.lI)),
				_Utils_Tuple2(
				'vertical-align',
				$elm$core$String$fromFloat(converted.jM) + 'em'),
				_Utils_Tuple2(
				'font-size',
				$elm$core$String$fromFloat(converted.aV) + 'em')
			]));
};
var $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment = function (typefaces) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (face, found) {
				if (found.$ === 1) {
					if (face.$ === 5) {
						var _with = face.a;
						var _v2 = _with.j2;
						if (_v2.$ === 1) {
							return found;
						} else {
							var adjustment = _v2.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.er;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment))),
									$mdgriffith$elm_ui$Internal$Model$fontAdjustmentRules(
										function ($) {
											return $.kC;
										}(
											$mdgriffith$elm_ui$Internal$Model$convertAdjustment(adjustment)))));
						}
					} else {
						return found;
					}
				} else {
					return found;
				}
			}),
		$elm$core$Maybe$Nothing,
		typefaces);
};
var $mdgriffith$elm_ui$Internal$Model$renderTopLevelValues = function (rules) {
	var withImport = function (font) {
		if (font.$ === 4) {
			var url = font.b;
			return $elm$core$Maybe$Just('@import url(\'' + (url + '\');'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var fontImports = function (_v2) {
		var name = _v2.a;
		var typefaces = _v2.b;
		var imports = A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$filterMap, withImport, typefaces));
		return imports;
	};
	var allNames = A2($elm$core$List$map, $elm$core$Tuple$first, rules);
	var fontAdjustments = function (_v1) {
		var name = _v1.a;
		var typefaces = _v1.b;
		var _v0 = $mdgriffith$elm_ui$Internal$Model$typefaceAdjustment(typefaces);
		if (_v0.$ === 1) {
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					$mdgriffith$elm_ui$Internal$Model$renderNullAdjustmentRule(name),
					allNames));
		} else {
			var adjustment = _v0.a;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$map,
					A2($mdgriffith$elm_ui$Internal$Model$renderFontAdjustmentRule, name, adjustment),
					allNames));
		}
	};
	return _Utils_ap(
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontImports, rules)),
		A2(
			$elm$core$String$join,
			'\n',
			A2($elm$core$List$map, fontAdjustments, rules)));
};
var $mdgriffith$elm_ui$Internal$Model$topLevelValue = function (rule) {
	if (rule.$ === 1) {
		var name = rule.a;
		var typefaces = rule.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(name, typefaces));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$toStyleSheetString = F2(
	function (options, stylesheet) {
		var combine = F2(
			function (style, rendered) {
				return {
					eP: _Utils_ap(
						rendered.eP,
						A3($mdgriffith$elm_ui$Internal$Model$renderStyleRule, options, style, $elm$core$Maybe$Nothing)),
					dP: function () {
						var _v1 = $mdgriffith$elm_ui$Internal$Model$topLevelValue(style);
						if (_v1.$ === 1) {
							return rendered.dP;
						} else {
							var topLevel = _v1.a;
							return A2($elm$core$List$cons, topLevel, rendered.dP);
						}
					}()
				};
			});
		var _v0 = A3(
			$elm$core$List$foldl,
			combine,
			{eP: _List_Nil, dP: _List_Nil},
			stylesheet);
		var topLevel = _v0.dP;
		var rules = _v0.eP;
		return _Utils_ap(
			$mdgriffith$elm_ui$Internal$Model$renderTopLevelValues(topLevel),
			$elm$core$String$concat(rules));
	});
var $mdgriffith$elm_ui$Internal$Model$toStyleSheet = F2(
	function (options, styleSheet) {
		var _v0 = options.mp;
		switch (_v0) {
			case 0:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			case 1:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$elm$virtual_dom$VirtualDom$node,
							'style',
							_List_Nil,
							_List_fromArray(
								[
									$elm$virtual_dom$VirtualDom$text(
									A2($mdgriffith$elm_ui$Internal$Model$toStyleSheetString, options, styleSheet))
								]))
						]));
			default:
				return A3(
					$elm$virtual_dom$VirtualDom$node,
					'elm-ui-rules',
					_List_fromArray(
						[
							A2(
							$elm$virtual_dom$VirtualDom$property,
							'rules',
							A2($mdgriffith$elm_ui$Internal$Model$encodeStyles, options, styleSheet))
						]),
					_List_Nil);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$embedKeyed = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.lA)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'static-stylesheet',
				$mdgriffith$elm_ui$Internal$Model$staticRoot(opts)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
				children)) : A2(
			$elm$core$List$cons,
			_Utils_Tuple2('dynamic-stylesheet', dynamicStyleSheet),
			children);
	});
var $mdgriffith$elm_ui$Internal$Model$embedWith = F4(
	function (_static, opts, styles, children) {
		var dynamicStyleSheet = A2(
			$mdgriffith$elm_ui$Internal$Model$toStyleSheet,
			opts,
			A3(
				$elm$core$List$foldl,
				$mdgriffith$elm_ui$Internal$Model$reduceStyles,
				_Utils_Tuple2(
					$elm$core$Set$empty,
					$mdgriffith$elm_ui$Internal$Model$renderFocusStyle(opts.lA)),
				styles).b);
		return _static ? A2(
			$elm$core$List$cons,
			$mdgriffith$elm_ui$Internal$Model$staticRoot(opts),
			A2($elm$core$List$cons, dynamicStyleSheet, children)) : A2($elm$core$List$cons, dynamicStyleSheet, children);
	});
var $mdgriffith$elm_ui$Internal$Flag$heightBetween = $mdgriffith$elm_ui$Internal$Flag$flag(45);
var $mdgriffith$elm_ui$Internal$Flag$heightFill = $mdgriffith$elm_ui$Internal$Flag$flag(37);
var $elm$html$Html$p = _VirtualDom_node('p');
var $mdgriffith$elm_ui$Internal$Flag$present = F2(
	function (myFlag, _v0) {
		var fieldOne = _v0.a;
		var fieldTwo = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return _Utils_eq(first & fieldOne, first);
		} else {
			var second = myFlag.a;
			return _Utils_eq(second & fieldTwo, second);
		}
	});
var $elm$html$Html$s = _VirtualDom_node('s');
var $elm$html$Html$u = _VirtualDom_node('u');
var $mdgriffith$elm_ui$Internal$Flag$widthBetween = $mdgriffith$elm_ui$Internal$Flag$flag(44);
var $mdgriffith$elm_ui$Internal$Flag$widthFill = $mdgriffith$elm_ui$Internal$Flag$flag(39);
var $mdgriffith$elm_ui$Internal$Model$finalizeNode = F6(
	function (has, node, attributes, children, embedMode, parentContext) {
		var createNode = F2(
			function (nodeName, attrs) {
				if (children.$ === 1) {
					var keyed = children.a;
					return A3(
						$elm$virtual_dom$VirtualDom$keyedNode,
						nodeName,
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return keyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, false, opts, styles, keyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedKeyed, true, opts, styles, keyed);
							}
						}());
				} else {
					var unkeyed = children.a;
					return A2(
						function () {
							switch (nodeName) {
								case 'div':
									return $elm$html$Html$div;
								case 'p':
									return $elm$html$Html$p;
								default:
									return $elm$virtual_dom$VirtualDom$node(nodeName);
							}
						}(),
						attrs,
						function () {
							switch (embedMode.$) {
								case 0:
									return unkeyed;
								case 2:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, false, opts, styles, unkeyed);
								default:
									var opts = embedMode.a;
									var styles = embedMode.b;
									return A4($mdgriffith$elm_ui$Internal$Model$embedWith, true, opts, styles, unkeyed);
							}
						}());
				}
			});
		var html = function () {
			switch (node.$) {
				case 0:
					return A2(createNode, 'div', attributes);
				case 1:
					var nodeName = node.a;
					return A2(createNode, nodeName, attributes);
				default:
					var nodeName = node.a;
					var internal = node.b;
					return A3(
						$elm$virtual_dom$VirtualDom$node,
						nodeName,
						attributes,
						_List_fromArray(
							[
								A2(
								createNode,
								internal,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.nQ))
									]))
							]));
			}
		}();
		switch (parentContext) {
			case 0:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$widthBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignRight, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.kf, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.d8, $mdgriffith$elm_ui$Internal$Style$classes.bj, $mdgriffith$elm_ui$Internal$Style$classes.j9])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerX, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.kf, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.d8, $mdgriffith$elm_ui$Internal$Style$classes.bj, $mdgriffith$elm_ui$Internal$Style$classes.j7])))
						]),
					_List_fromArray(
						[html])) : html));
			case 1:
				return (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightFill, has) && (!A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$heightBetween, has))) ? html : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$centerY, has) ? A2(
					$elm$html$Html$s,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.kf, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.d8, $mdgriffith$elm_ui$Internal$Style$classes.j8])))
						]),
					_List_fromArray(
						[html])) : (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$alignBottom, has) ? A2(
					$elm$html$Html$u,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									[$mdgriffith$elm_ui$Internal$Style$classes.kf, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.d8, $mdgriffith$elm_ui$Internal$Style$classes.j6])))
						]),
					_List_fromArray(
						[html])) : html));
			default:
				return html;
		}
	});
var $mdgriffith$elm_ui$Internal$Model$textElementClasses = $mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.n8 + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.gy + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fz)))));
var $mdgriffith$elm_ui$Internal$Model$textElement = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$textElementFillClasses = $mdgriffith$elm_ui$Internal$Style$classes.kf + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.n8 + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.gz + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.fA)))));
var $mdgriffith$elm_ui$Internal$Model$textElementFill = function (str) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Model$textElementFillClasses)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $mdgriffith$elm_ui$Internal$Model$createElement = F3(
	function (context, children, rendered) {
		var gatherKeyed = F2(
			function (_v8, _v9) {
				var key = _v8.a;
				var child = _v8.b;
				var htmls = _v9.a;
				var existingStyles = _v9.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									html(context)),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.lN, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.n2 : _Utils_ap(styled.n2, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									A2(styled.lN, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context)),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.n2 : _Utils_ap(styled.n2, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									key,
									_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str)),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		var gather = F2(
			function (child, _v6) {
				var htmls = _v6.a;
				var existingStyles = _v6.b;
				switch (child.$) {
					case 0:
						var html = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								html(context),
								htmls),
							existingStyles);
					case 1:
						var styled = child.a;
						return _Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asParagraph) ? _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.lN, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.n2 : _Utils_ap(styled.n2, existingStyles)) : _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								A2(styled.lN, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, context),
								htmls),
							$elm$core$List$isEmpty(existingStyles) ? styled.n2 : _Utils_ap(styled.n2, existingStyles));
					case 2:
						var str = child.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								_Utils_eq(context, $mdgriffith$elm_ui$Internal$Model$asEl) ? $mdgriffith$elm_ui$Internal$Model$textElementFill(str) : $mdgriffith$elm_ui$Internal$Model$textElement(str),
								htmls),
							existingStyles);
					default:
						return _Utils_Tuple2(htmls, existingStyles);
				}
			});
		if (children.$ === 1) {
			var keyedChildren = children.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				gatherKeyed,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				keyedChildren);
			var keyed = _v1.a;
			var styles = _v1.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.n2 : _Utils_ap(rendered.n2, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.bR,
						rendered.bY,
						rendered.kk,
						$mdgriffith$elm_ui$Internal$Model$Keyed(
							A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.bL)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						lN: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.bR,
							rendered.bY,
							rendered.kk,
							$mdgriffith$elm_ui$Internal$Model$Keyed(
								A3($mdgriffith$elm_ui$Internal$Model$addKeyedChildren, 'nearby-element-pls', keyed, rendered.bL))),
						n2: allStyles
					});
			}
		} else {
			var unkeyedChildren = children.a;
			var _v3 = A3(
				$elm$core$List$foldr,
				gather,
				_Utils_Tuple2(_List_Nil, _List_Nil),
				unkeyedChildren);
			var unkeyed = _v3.a;
			var styles = _v3.b;
			var newStyles = $elm$core$List$isEmpty(styles) ? rendered.n2 : _Utils_ap(rendered.n2, styles);
			if (!newStyles.b) {
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A5(
						$mdgriffith$elm_ui$Internal$Model$finalizeNode,
						rendered.bR,
						rendered.bY,
						rendered.kk,
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.bL)),
						$mdgriffith$elm_ui$Internal$Model$NoStyleSheet));
			} else {
				var allStyles = newStyles;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						lN: A4(
							$mdgriffith$elm_ui$Internal$Model$finalizeNode,
							rendered.bR,
							rendered.bY,
							rendered.kk,
							$mdgriffith$elm_ui$Internal$Model$Unkeyed(
								A2($mdgriffith$elm_ui$Internal$Model$addChildren, unkeyed, rendered.bL))),
						n2: allStyles
					});
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Single = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Model$Transform = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$add = F2(
	function (myFlag, _v0) {
		var one = _v0.a;
		var two = _v0.b;
		if (!myFlag.$) {
			var first = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, first | one, two);
		} else {
			var second = myFlag.a;
			return A2($mdgriffith$elm_ui$Internal$Flag$Field, one, second | two);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehind = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$ChildrenInFront = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$nearbyElement = F2(
	function (location, elem) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					function () {
						switch (location) {
							case 0:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.cN, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.jZ]));
							case 1:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.cN, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.kq]));
							case 2:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.cN, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.mZ]));
							case 3:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.cN, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.mR]));
							case 4:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.cN, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.lT]));
							default:
								return A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[$mdgriffith$elm_ui$Internal$Style$classes.cN, $mdgriffith$elm_ui$Internal$Style$classes.nQ, $mdgriffith$elm_ui$Internal$Style$classes.kp]));
						}
					}())
				]),
			_List_fromArray(
				[
					function () {
					switch (elem.$) {
						case 3:
							return $elm$virtual_dom$VirtualDom$text('');
						case 2:
							var str = elem.a;
							return $mdgriffith$elm_ui$Internal$Model$textElement(str);
						case 0:
							var html = elem.a;
							return html($mdgriffith$elm_ui$Internal$Model$asEl);
						default:
							var styled = elem.a;
							return A2(styled.lN, $mdgriffith$elm_ui$Internal$Model$NoStyleSheet, $mdgriffith$elm_ui$Internal$Model$asEl);
					}
				}()
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$addNearbyElement = F3(
	function (location, elem, existing) {
		var nearby = A2($mdgriffith$elm_ui$Internal$Model$nearbyElement, location, elem);
		switch (existing.$) {
			case 0:
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						_List_fromArray(
							[nearby]));
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						_List_fromArray(
							[nearby]));
				}
			case 1:
				var existingBehind = existing.a;
				if (location === 5) {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenBehind(
						A2($elm$core$List$cons, nearby, existingBehind));
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						_List_fromArray(
							[nearby]));
				}
			case 2:
				var existingInFront = existing.a;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						_List_fromArray(
							[nearby]),
						existingInFront);
				} else {
					return $mdgriffith$elm_ui$Internal$Model$ChildrenInFront(
						A2($elm$core$List$cons, nearby, existingInFront));
				}
			default:
				var existingBehind = existing.a;
				var existingInFront = existing.b;
				if (location === 5) {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						A2($elm$core$List$cons, nearby, existingBehind),
						existingInFront);
				} else {
					return A2(
						$mdgriffith$elm_ui$Internal$Model$ChildrenBehindAndInFront,
						existingBehind,
						A2($elm$core$List$cons, nearby, existingInFront));
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Embedded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$NodeName = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$addNodeName = F2(
	function (newNode, old) {
		switch (old.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NodeName(newNode);
			case 1:
				var name = old.a;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, name, newNode);
			default:
				var x = old.a;
				var y = old.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Embedded, x, y);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$alignXName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.e2 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gN);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.e2 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gO);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.e2 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.j4);
	}
};
var $mdgriffith$elm_ui$Internal$Model$alignYName = function (align) {
	switch (align) {
		case 0:
			return $mdgriffith$elm_ui$Internal$Style$classes.e3 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.kb);
		case 2:
			return $mdgriffith$elm_ui$Internal$Style$classes.e3 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.j3);
		default:
			return $mdgriffith$elm_ui$Internal$Style$classes.e3 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.j5);
	}
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $mdgriffith$elm_ui$Internal$Model$FullTransform = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $mdgriffith$elm_ui$Internal$Model$Moved = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$composeTransformation = F2(
	function (transform, component) {
		switch (transform.$) {
			case 0:
				switch (component.$) {
					case 0:
						var x = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, 0, 0));
					case 1:
						var y = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, y, 0));
					case 2:
						var z = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(0, 0, z));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var xyz = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(0, 0, 0),
							xyz,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			case 1:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(newX, y, z));
					case 1:
						var newY = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, newY, z));
					case 2:
						var newZ = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(
							_Utils_Tuple3(x, y, newZ));
					case 3:
						var xyz = component.a;
						return $mdgriffith$elm_ui$Internal$Model$Moved(xyz);
					case 4:
						var xyz = component.a;
						var angle = component.b;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							_Utils_Tuple3(1, 1, 1),
							xyz,
							angle);
					default:
						var scale = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							moved,
							scale,
							_Utils_Tuple3(0, 0, 1),
							0);
				}
			default:
				var moved = transform.a;
				var x = moved.a;
				var y = moved.b;
				var z = moved.c;
				var scaled = transform.b;
				var origin = transform.c;
				var angle = transform.d;
				switch (component.$) {
					case 0:
						var newX = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(newX, y, z),
							scaled,
							origin,
							angle);
					case 1:
						var newY = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, newY, z),
							scaled,
							origin,
							angle);
					case 2:
						var newZ = component.a;
						return A4(
							$mdgriffith$elm_ui$Internal$Model$FullTransform,
							_Utils_Tuple3(x, y, newZ),
							scaled,
							origin,
							angle);
					case 3:
						var newMove = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, newMove, scaled, origin, angle);
					case 4:
						var newOrigin = component.a;
						var newAngle = component.b;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, scaled, newOrigin, newAngle);
					default:
						var newScale = component.a;
						return A4($mdgriffith$elm_ui$Internal$Model$FullTransform, moved, newScale, origin, angle);
				}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$height = $mdgriffith$elm_ui$Internal$Flag$flag(7);
var $mdgriffith$elm_ui$Internal$Flag$heightContent = $mdgriffith$elm_ui$Internal$Flag$flag(36);
var $mdgriffith$elm_ui$Internal$Flag$merge = F2(
	function (_v0, _v1) {
		var one = _v0.a;
		var two = _v0.b;
		var three = _v1.a;
		var four = _v1.b;
		return A2($mdgriffith$elm_ui$Internal$Flag$Field, one | three, two | four);
	});
var $mdgriffith$elm_ui$Internal$Flag$none = A2($mdgriffith$elm_ui$Internal$Flag$Field, 0, 0);
var $mdgriffith$elm_ui$Internal$Model$renderHeight = function (h) {
	switch (h.$) {
		case 0:
			var px = h.a;
			var val = $elm$core$String$fromInt(px);
			var name = 'height-px-' + val;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.hP + (' ' + name),
				_List_fromArray(
					[
						A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height', val + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.fz,
				_List_Nil);
		case 2:
			var portion = h.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.fA,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.hQ + (' height-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.kf + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.bi + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'height-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = h.a;
			var len = h.b;
			var cls = 'min-height-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-height',
				$elm$core$String$fromInt(minSize) + 'px !important');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = h.a;
			var len = h.b;
			var cls = 'max-height-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-height',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderHeight(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$heightBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$widthContent = $mdgriffith$elm_ui$Internal$Flag$flag(38);
var $mdgriffith$elm_ui$Internal$Model$renderWidth = function (w) {
	switch (w.$) {
		case 0:
			var px = w.a;
			return _Utils_Tuple3(
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Style$classes.jS + (' width-px-' + $elm$core$String$fromInt(px)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						'width-px-' + $elm$core$String$fromInt(px),
						'width',
						$elm$core$String$fromInt(px) + 'px')
					]));
		case 1:
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthContent, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.gy,
				_List_Nil);
		case 2:
			var portion = w.a;
			return (portion === 1) ? _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.gz,
				_List_Nil) : _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthFill, $mdgriffith$elm_ui$Internal$Flag$none),
				$mdgriffith$elm_ui$Internal$Style$classes.jT + (' width-fill-' + $elm$core$String$fromInt(portion)),
				_List_fromArray(
					[
						A3(
						$mdgriffith$elm_ui$Internal$Model$Single,
						$mdgriffith$elm_ui$Internal$Style$classes.kf + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.i0 + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
							'width-fill-' + $elm$core$String$fromInt(portion))))),
						'flex-grow',
						$elm$core$String$fromInt(portion * 100000))
					]));
		case 3:
			var minSize = w.a;
			var len = w.b;
			var cls = 'min-width-' + $elm$core$String$fromInt(minSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'min-width',
				$elm$core$String$fromInt(minSize) + 'px');
			var _v1 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v1.a;
			var newAttrs = _v1.b;
			var newStyle = _v1.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
		default:
			var maxSize = w.a;
			var len = w.b;
			var cls = 'max-width-' + $elm$core$String$fromInt(maxSize);
			var style = A3(
				$mdgriffith$elm_ui$Internal$Model$Single,
				cls,
				'max-width',
				$elm$core$String$fromInt(maxSize) + 'px');
			var _v2 = $mdgriffith$elm_ui$Internal$Model$renderWidth(len);
			var newFlag = _v2.a;
			var newAttrs = _v2.b;
			var newStyle = _v2.c;
			return _Utils_Tuple3(
				A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$widthBetween, newFlag),
				cls + (' ' + newAttrs),
				A2($elm$core$List$cons, style, newStyle));
	}
};
var $mdgriffith$elm_ui$Internal$Flag$borderWidth = $mdgriffith$elm_ui$Internal$Flag$flag(27);
var $mdgriffith$elm_ui$Internal$Model$skippable = F2(
	function (flag, style) {
		if (_Utils_eq(flag, $mdgriffith$elm_ui$Internal$Flag$borderWidth)) {
			if (style.$ === 3) {
				var val = style.c;
				switch (val) {
					case '0px':
						return true;
					case '1px':
						return true;
					case '2px':
						return true;
					case '3px':
						return true;
					case '4px':
						return true;
					case '5px':
						return true;
					case '6px':
						return true;
					default:
						return false;
				}
			} else {
				return false;
			}
		} else {
			switch (style.$) {
				case 2:
					var i = style.a;
					return (i >= 8) && (i <= 32);
				case 7:
					var name = style.a;
					var t = style.b;
					var r = style.c;
					var b = style.d;
					var l = style.e;
					return _Utils_eq(t, b) && (_Utils_eq(t, r) && (_Utils_eq(t, l) && ((t >= 0) && (t <= 24))));
				default:
					return false;
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Flag$width = $mdgriffith$elm_ui$Internal$Flag$flag(6);
var $mdgriffith$elm_ui$Internal$Flag$xAlign = $mdgriffith$elm_ui$Internal$Flag$flag(30);
var $mdgriffith$elm_ui$Internal$Flag$yAlign = $mdgriffith$elm_ui$Internal$Flag$flag(29);
var $mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive = F8(
	function (classes, node, has, transform, styles, attrs, children, elementAttrs) {
		gatherAttrRecursive:
		while (true) {
			if (!elementAttrs.b) {
				var _v1 = $mdgriffith$elm_ui$Internal$Model$transformClass(transform);
				if (_v1.$ === 1) {
					return {
						kk: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes),
							attrs),
						bL: children,
						bR: has,
						bY: node,
						n2: styles
					};
				} else {
					var _class = _v1.a;
					return {
						kk: A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(classes + (' ' + _class)),
							attrs),
						bL: children,
						bR: has,
						bY: node,
						n2: A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$Transform(transform),
							styles)
					};
				}
			} else {
				var attribute = elementAttrs.a;
				var remaining = elementAttrs.b;
				switch (attribute.$) {
					case 0:
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 3:
						var flag = attribute.a;
						var exactClassName = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = exactClassName + (' ' + classes),
								$temp$node = node,
								$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					case 1:
						var actualAttribute = attribute.a;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = styles,
							$temp$attrs = A2($elm$core$List$cons, actualAttribute, attrs),
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 4:
						var flag = attribute.a;
						var style = attribute.b;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, flag, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							if (A2($mdgriffith$elm_ui$Internal$Model$skippable, flag, style)) {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							} else {
								var $temp$classes = $mdgriffith$elm_ui$Internal$Model$getStyleName(style) + (' ' + classes),
									$temp$node = node,
									$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
									$temp$transform = transform,
									$temp$styles = A2($elm$core$List$cons, style, styles),
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							}
						}
					case 10:
						var flag = attribute.a;
						var component = attribute.b;
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, flag, has),
							$temp$transform = A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, transform, component),
							$temp$styles = styles,
							$temp$attrs = attrs,
							$temp$children = children,
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 7:
						var width = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$width, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (width.$) {
								case 0:
									var px = width.a;
									var $temp$classes = ($mdgriffith$elm_ui$Internal$Style$classes.jS + (' width-px-' + $elm$core$String$fromInt(px))) + (' ' + classes),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3(
											$mdgriffith$elm_ui$Internal$Model$Single,
											'width-px-' + $elm$core$String$fromInt(px),
											'width',
											$elm$core$String$fromInt(px) + 'px'),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gy),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$widthContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = width.a;
									if (portion === 1) {
										var $temp$classes = classes + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.gz),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.jT + (' width-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$widthFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.kf + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.i0 + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'width-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v4 = $mdgriffith$elm_ui$Internal$Model$renderWidth(width);
									var addToFlags = _v4.a;
									var newClass = _v4.b;
									var newStyles = _v4.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$width, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 8:
						var height = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$height, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							switch (height.$) {
								case 0:
									var px = height.a;
									var val = $elm$core$String$fromInt(px) + 'px';
									var name = 'height-px-' + val;
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.hP + (' ' + (name + (' ' + classes))),
										$temp$node = node,
										$temp$has = A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has),
										$temp$transform = transform,
										$temp$styles = A2(
										$elm$core$List$cons,
										A3($mdgriffith$elm_ui$Internal$Model$Single, name, 'height ', val),
										styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 1:
									var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.fz + (' ' + classes),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$add,
										$mdgriffith$elm_ui$Internal$Flag$heightContent,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								case 2:
									var portion = height.a;
									if (portion === 1) {
										var $temp$classes = $mdgriffith$elm_ui$Internal$Style$classes.fA + (' ' + classes),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.hQ + (' height-fill-' + $elm$core$String$fromInt(portion)))),
											$temp$node = node,
											$temp$has = A2(
											$mdgriffith$elm_ui$Internal$Flag$add,
											$mdgriffith$elm_ui$Internal$Flag$heightFill,
											A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
											$temp$transform = transform,
											$temp$styles = A2(
											$elm$core$List$cons,
											A3(
												$mdgriffith$elm_ui$Internal$Model$Single,
												$mdgriffith$elm_ui$Internal$Style$classes.kf + ('.' + ($mdgriffith$elm_ui$Internal$Style$classes.bi + (' > ' + $mdgriffith$elm_ui$Internal$Style$dot(
													'height-fill-' + $elm$core$String$fromInt(portion))))),
												'flex-grow',
												$elm$core$String$fromInt(portion * 100000)),
											styles),
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								default:
									var _v6 = $mdgriffith$elm_ui$Internal$Model$renderHeight(height);
									var addToFlags = _v6.a;
									var newClass = _v6.b;
									var newStyles = _v6.c;
									var $temp$classes = classes + (' ' + newClass),
										$temp$node = node,
										$temp$has = A2(
										$mdgriffith$elm_ui$Internal$Flag$merge,
										addToFlags,
										A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$height, has)),
										$temp$transform = transform,
										$temp$styles = _Utils_ap(newStyles, styles),
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
							}
						}
					case 2:
						var description = attribute.a;
						switch (description.$) {
							case 0:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'main', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 1:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'nav', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 2:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'footer', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 3:
								var $temp$classes = classes,
									$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'aside', node),
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 4:
								var i = description.a;
								if (i <= 1) {
									var $temp$classes = classes,
										$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h1', node),
										$temp$has = has,
										$temp$transform = transform,
										$temp$styles = styles,
										$temp$attrs = attrs,
										$temp$children = children,
										$temp$elementAttrs = remaining;
									classes = $temp$classes;
									node = $temp$node;
									has = $temp$has;
									transform = $temp$transform;
									styles = $temp$styles;
									attrs = $temp$attrs;
									children = $temp$children;
									elementAttrs = $temp$elementAttrs;
									continue gatherAttrRecursive;
								} else {
									if (i < 7) {
										var $temp$classes = classes,
											$temp$node = A2(
											$mdgriffith$elm_ui$Internal$Model$addNodeName,
											'h' + $elm$core$String$fromInt(i),
											node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									} else {
										var $temp$classes = classes,
											$temp$node = A2($mdgriffith$elm_ui$Internal$Model$addNodeName, 'h6', node),
											$temp$has = has,
											$temp$transform = transform,
											$temp$styles = styles,
											$temp$attrs = attrs,
											$temp$children = children,
											$temp$elementAttrs = remaining;
										classes = $temp$classes;
										node = $temp$node;
										has = $temp$has;
										transform = $temp$transform;
										styles = $temp$styles;
										attrs = $temp$attrs;
										children = $temp$children;
										elementAttrs = $temp$elementAttrs;
										continue gatherAttrRecursive;
									}
								}
							case 9:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = attrs,
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 8:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'role', 'button'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 5:
								var label = description.a;
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-label', label),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							case 6:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'polite'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
							default:
								var $temp$classes = classes,
									$temp$node = node,
									$temp$has = has,
									$temp$transform = transform,
									$temp$styles = styles,
									$temp$attrs = A2(
									$elm$core$List$cons,
									A2($elm$virtual_dom$VirtualDom$attribute, 'aria-live', 'assertive'),
									attrs),
									$temp$children = children,
									$temp$elementAttrs = remaining;
								classes = $temp$classes;
								node = $temp$node;
								has = $temp$has;
								transform = $temp$transform;
								styles = $temp$styles;
								attrs = $temp$attrs;
								children = $temp$children;
								elementAttrs = $temp$elementAttrs;
								continue gatherAttrRecursive;
						}
					case 9:
						var location = attribute.a;
						var elem = attribute.b;
						var newStyles = function () {
							switch (elem.$) {
								case 3:
									return styles;
								case 2:
									var str = elem.a;
									return styles;
								case 0:
									var html = elem.a;
									return styles;
								default:
									var styled = elem.a;
									return _Utils_ap(styles, styled.n2);
							}
						}();
						var $temp$classes = classes,
							$temp$node = node,
							$temp$has = has,
							$temp$transform = transform,
							$temp$styles = newStyles,
							$temp$attrs = attrs,
							$temp$children = A3($mdgriffith$elm_ui$Internal$Model$addNearbyElement, location, elem, children),
							$temp$elementAttrs = remaining;
						classes = $temp$classes;
						node = $temp$node;
						has = $temp$has;
						transform = $temp$transform;
						styles = $temp$styles;
						attrs = $temp$attrs;
						children = $temp$children;
						elementAttrs = $temp$elementAttrs;
						continue gatherAttrRecursive;
					case 6:
						var x = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignXName(x) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (x) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerX, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignRight, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$xAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
					default:
						var y = attribute.a;
						if (A2($mdgriffith$elm_ui$Internal$Flag$present, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)) {
							var $temp$classes = classes,
								$temp$node = node,
								$temp$has = has,
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						} else {
							var $temp$classes = $mdgriffith$elm_ui$Internal$Model$alignYName(y) + (' ' + classes),
								$temp$node = node,
								$temp$has = function (flags) {
								switch (y) {
									case 1:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$centerY, flags);
									case 2:
										return A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$alignBottom, flags);
									default:
										return flags;
								}
							}(
								A2($mdgriffith$elm_ui$Internal$Flag$add, $mdgriffith$elm_ui$Internal$Flag$yAlign, has)),
								$temp$transform = transform,
								$temp$styles = styles,
								$temp$attrs = attrs,
								$temp$children = children,
								$temp$elementAttrs = remaining;
							classes = $temp$classes;
							node = $temp$node;
							has = $temp$has;
							transform = $temp$transform;
							styles = $temp$styles;
							attrs = $temp$attrs;
							children = $temp$children;
							elementAttrs = $temp$elementAttrs;
							continue gatherAttrRecursive;
						}
				}
			}
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Untransformed = {$: 0};
var $mdgriffith$elm_ui$Internal$Model$untransformed = $mdgriffith$elm_ui$Internal$Model$Untransformed;
var $mdgriffith$elm_ui$Internal$Model$element = F4(
	function (context, node, attributes, children) {
		return A3(
			$mdgriffith$elm_ui$Internal$Model$createElement,
			context,
			children,
			A8(
				$mdgriffith$elm_ui$Internal$Model$gatherAttrRecursive,
				$mdgriffith$elm_ui$Internal$Model$contextClasses(context),
				node,
				$mdgriffith$elm_ui$Internal$Flag$none,
				$mdgriffith$elm_ui$Internal$Model$untransformed,
				_List_Nil,
				_List_Nil,
				$mdgriffith$elm_ui$Internal$Model$NoNearbyChildren,
				$elm$core$List$reverse(attributes)));
	});
var $mdgriffith$elm_ui$Internal$Model$Height = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_ui$Element$height = $mdgriffith$elm_ui$Internal$Model$Height;
var $mdgriffith$elm_ui$Internal$Model$Attr = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$htmlClass = function (cls) {
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		$elm$html$Html$Attributes$class(cls));
};
var $mdgriffith$elm_ui$Internal$Model$Content = {$: 1};
var $mdgriffith$elm_ui$Element$shrink = $mdgriffith$elm_ui$Internal$Model$Content;
var $mdgriffith$elm_ui$Internal$Model$Width = function (a) {
	return {$: 7, a: a};
};
var $mdgriffith$elm_ui$Element$width = $mdgriffith$elm_ui$Internal$Model$Width;
var $mdgriffith$elm_ui$Element$column = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.kU + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.dj)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $author$project$CWS$Messages$CancelClose = {$: 18};
var $author$project$CWS$Messages$ConfirmClose = {$: 17};
var $author$project$CWS$confirmCloseView = function (model) {
	var _v0 = model.a.aJ;
	if (_v0.$ === 1) {
		var msg = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirmWrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Confirm Close')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(msg)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('actions')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('confirmAction'),
													$elm$html$Html$Events$onClick($author$project$CWS$Messages$ConfirmClose)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ok')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cancelAction'),
													$elm$html$Html$Events$onClick($author$project$CWS$Messages$CancelClose)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												]))
										]))
								]))
						]))
				]));
	} else {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	}
};
var $mdgriffith$elm_ui$Internal$Model$Empty = {$: 3};
var $mdgriffith$elm_ui$Internal$Model$Text = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$map = F2(
	function (fn, el) {
		switch (el.$) {
			case 1:
				var styled = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Styled(
					{
						lN: F2(
							function (add, context) {
								return A2(
									$elm$virtual_dom$VirtualDom$map,
									fn,
									A2(styled.lN, add, context));
							}),
						n2: styled.n2
					});
			case 0:
				var html = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Unstyled(
					A2(
						$elm$core$Basics$composeL,
						$elm$virtual_dom$VirtualDom$map(fn),
						html));
			case 2:
				var str = el.a;
				return $mdgriffith$elm_ui$Internal$Model$Text(str);
			default:
				return $mdgriffith$elm_ui$Internal$Model$Empty;
		}
	});
var $mdgriffith$elm_ui$Element$map = $mdgriffith$elm_ui$Internal$Model$map;
var $mdgriffith$elm_ui$Internal$Model$Fill = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$fill = $mdgriffith$elm_ui$Internal$Model$Fill(1);
var $mdgriffith$elm_ui$Element$fillPortion = $mdgriffith$elm_ui$Internal$Model$Fill;
var $author$project$CWS$About$hasAnyRequiredRoles = F2(
	function (user, requiredRoles) {
		if (!$elm$core$List$length(requiredRoles)) {
			return true;
		} else {
			var req = requiredRoles;
			var part = function (itm) {
				return A2($elm$core$List$member, itm, req);
			};
			var _v0 = A2($elm$core$List$partition, part, user.iW);
			var match = _v0.a;
			var nomatch = _v0.b;
			var hasAny = $elm$core$List$length(match) > 0;
			return hasAny;
		}
	});
var $author$project$CWS$About$hasCwsRoles = function (profile) {
	return A2(
		$author$project$CWS$About$hasAnyRequiredRoles,
		profile,
		_List_fromArray(
			['System Administrator', 'FAM Administrator', 'CWS Approver', 'CWS Approver Deligate', 'CWS User', 'PE Delegate']));
};
var $author$project$CWS$About$SignIn = {$: 3};
var $mdgriffith$elm_ui$Internal$Flag$fontWeight = $mdgriffith$elm_ui$Internal$Flag$flag(13);
var $mdgriffith$elm_ui$Element$Font$bold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.ks);
var $mdgriffith$elm_ui$Internal$Model$Button = {$: 8};
var $mdgriffith$elm_ui$Internal$Model$Describe = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Element$Input$enter = 'Enter';
var $mdgriffith$elm_ui$Internal$Model$NoAttribute = {$: 0};
var $mdgriffith$elm_ui$Element$Input$hasFocusStyle = function (attr) {
	if (((attr.$ === 4) && (attr.b.$ === 11)) && (!attr.b.a)) {
		var _v1 = attr.b;
		var _v2 = _v1.a;
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$focusDefault = function (attrs) {
	return A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, attrs) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass('focusable');
};
var $mdgriffith$elm_ui$Element$Events$onClick = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onClick);
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $mdgriffith$elm_ui$Element$Input$onKeyLookup = function (lookup) {
	var decode = function (code) {
		var _v0 = lookup(code);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('No key matched');
		} else {
			var msg = _v0.a;
			return $elm$json$Json$Decode$succeed(msg);
		}
	};
	var isKey = A2(
		$elm$json$Json$Decode$andThen,
		decode,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return $mdgriffith$elm_ui$Internal$Model$Attr(
		A2(
			$elm$html$Html$Events$preventDefaultOn,
			'keydown',
			A2(
				$elm$json$Json$Decode$map,
				function (fired) {
					return _Utils_Tuple2(fired, true);
				},
				isKey)));
};
var $mdgriffith$elm_ui$Internal$Flag$cursor = $mdgriffith$elm_ui$Internal$Flag$flag(21);
var $mdgriffith$elm_ui$Element$pointer = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.k$);
var $mdgriffith$elm_ui$Element$Input$space = ' ';
var $mdgriffith$elm_ui$Element$Input$button = F2(
	function (attrs, _v0) {
		var onPress = _v0.ip;
		var label = _v0.h3;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eb + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.bj + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.nK + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.$9)))))),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$pointer,
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$Input$focusDefault(attrs),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Button),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Internal$Model$Attr(
											$elm$html$Html$Attributes$tabindex(0)),
										function () {
											if (onPress.$ === 1) {
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Internal$Model$Attr(
														$elm$html$Html$Attributes$disabled(true)),
													attrs);
											} else {
												var msg = onPress.a;
												return A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Element$Events$onClick(msg),
													A2(
														$elm$core$List$cons,
														$mdgriffith$elm_ui$Element$Input$onKeyLookup(
															function (code) {
																return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(msg) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(msg) : $elm$core$Maybe$Nothing);
															}),
														attrs));
											}
										}()))))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $mdgriffith$elm_ui$Internal$Flag$fontAlignment = $mdgriffith$elm_ui$Internal$Flag$flag(12);
var $mdgriffith$elm_ui$Element$Font$center = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.n9);
var $mdgriffith$elm_ui$Element$el = F2(
	function (attrs, child) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					attrs)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[child])));
	});
var $author$project$PAM$UI$Basic$orangeRoughy = A3($mdgriffith$elm_ui$Element$rgb255, 203, 77, 21);
var $mdgriffith$elm_ui$Internal$Model$PaddingStyle = F5(
	function (a, b, c, d, e) {
		return {$: 7, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Internal$Flag$padding = $mdgriffith$elm_ui$Internal$Flag$flag(2);
var $mdgriffith$elm_ui$Internal$Model$paddingName = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left)))))));
	});
var $mdgriffith$elm_ui$Element$paddingEach = function (_v0) {
	var top = _v0.os;
	var right = _v0.nA;
	var bottom = _v0.kx;
	var left = _v0.me;
	if (_Utils_eq(top, right) && (_Utils_eq(top, bottom) && _Utils_eq(top, left))) {
		var topFloat = top;
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				'p-' + $elm$core$String$fromInt(top),
				topFloat,
				topFloat,
				topFloat,
				topFloat));
	} else {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$padding,
			A5(
				$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
				A4($mdgriffith$elm_ui$Internal$Model$paddingName, top, right, bottom, left),
				top,
				right,
				bottom,
				left));
	}
};
var $mdgriffith$elm_ui$Internal$Model$Paragraph = {$: 9};
var $mdgriffith$elm_ui$Internal$Model$SpacingStyle = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Internal$Flag$spacing = $mdgriffith$elm_ui$Internal$Flag$flag(3);
var $mdgriffith$elm_ui$Internal$Model$spacingName = F2(
	function (x, y) {
		return 'spacing-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y)));
	});
var $mdgriffith$elm_ui$Element$spacing = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$spacing,
		A3(
			$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
			A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, x),
			x,
			x));
};
var $mdgriffith$elm_ui$Element$paragraph = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asParagraph,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$Paragraph),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$spacing(5),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $author$project$PAM$UI$Basic$pineTree = A3($mdgriffith$elm_ui$Element$rgb255, 32, 61, 5);
var $mdgriffith$elm_ui$Internal$Flag$borderRound = $mdgriffith$elm_ui$Internal$Flag$flag(17);
var $mdgriffith$elm_ui$Element$Border$rounded = function (radius) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + $elm$core$String$fromInt(radius),
			'border-radius',
			$elm$core$String$fromInt(radius) + 'px'));
};
var $mdgriffith$elm_ui$Internal$Model$FontSize = function (a) {
	return {$: 2, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$fontSize = $mdgriffith$elm_ui$Internal$Flag$flag(4);
var $mdgriffith$elm_ui$Element$Font$size = function (i) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontSize,
		$mdgriffith$elm_ui$Internal$Model$FontSize(i));
};
var $mdgriffith$elm_ui$Element$text = function (content) {
	return $mdgriffith$elm_ui$Internal$Model$Text(content);
};
var $mdgriffith$elm_ui$Internal$Model$AsTextColumn = 5;
var $mdgriffith$elm_ui$Internal$Model$asTextColumn = 5;
var $mdgriffith$elm_ui$Internal$Model$Max = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$maximum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Max, i, l);
	});
var $mdgriffith$elm_ui$Internal$Model$Min = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$minimum = F2(
	function (i, l) {
		return A2($mdgriffith$elm_ui$Internal$Model$Min, i, l);
	});
var $mdgriffith$elm_ui$Element$textColumn = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asTextColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width(
					A2(
						$mdgriffith$elm_ui$Element$maximum,
						750,
						A2($mdgriffith$elm_ui$Element$minimum, 500, $mdgriffith$elm_ui$Element$fill))),
				attrs),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $author$project$PAM$UI$Basic$white = A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255);
var $author$project$CWS$About$loginView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(15)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$textColumn,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$Font$center,
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$pineTree)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$textColumn,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(16),
								$mdgriffith$elm_ui$Element$Font$bold,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(2)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Already a Member? Sign in.')
									]))
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$Border$rounded(6)
					]),
				{
					h3: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$paddingEach(
								{kx: 10, me: 35, nA: 35, os: 10})
							]),
						$mdgriffith$elm_ui$Element$text('SIGN IN')),
					ip: $elm$core$Maybe$Just($author$project$CWS$About$SignIn)
				})
			]));
};
var $author$project$CWS$About$RequestAccess = {$: 1};
var $author$project$CWS$About$noAccessView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(15)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$textColumn,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$Font$center,
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$pineTree)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$textColumn,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(16),
								$mdgriffith$elm_ui$Element$Font$bold,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(2)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Interested in participating?')
									])),
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(' Request access today.')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(14)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Your account does not have access to CWS. Request access and help Utah fight wildfires today!')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$Border$rounded(6)
					]),
				{
					h3: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$paddingEach(
								{kx: 10, me: 35, nA: 35, os: 10})
							]),
						$mdgriffith$elm_ui$Element$text('REQUEST ACCESS')),
					ip: $elm$core$Maybe$Just($author$project$CWS$About$RequestAccess)
				})
			]));
};
var $mdgriffith$elm_ui$Element$none = $mdgriffith$elm_ui$Internal$Model$Empty;
var $author$project$CWS$About$Register = {$: 2};
var $author$project$CWS$About$registerView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$spacing(15)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$textColumn,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$spacing(10),
						$mdgriffith$elm_ui$Element$Font$center,
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$pineTree)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$textColumn,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(16),
								$mdgriffith$elm_ui$Element$Font$bold,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$spacing(2)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Interested in participating?')
									])),
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								_List_Nil,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text(' Request access today.')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$size(14)
							]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Registration is straightforward and easy. Sign up and help Utah fight wildfires today!')
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$Border$rounded(6)
					]),
				{
					h3: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$paddingEach(
								{kx: 10, me: 35, nA: 35, os: 10})
							]),
						$mdgriffith$elm_ui$Element$text('REQUEST ACCESS')),
					ip: $elm$core$Maybe$Just($author$project$CWS$About$Register)
				})
			]));
};
var $author$project$PAM$UI$Basic$asparagus = A3($mdgriffith$elm_ui$Element$rgb255, 130, 151, 80);
var $mdgriffith$elm_ui$Internal$Flag$borderColor = $mdgriffith$elm_ui$Internal$Flag$flag(28);
var $mdgriffith$elm_ui$Element$Border$color = function (clr) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderColor,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Colored,
			'bc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(clr),
			'border-color',
			clr));
};
var $mdgriffith$elm_ui$Internal$Model$BorderWidth = F5(
	function (a, b, c, d, e) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e};
	});
var $mdgriffith$elm_ui$Element$Border$width = function (v) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + $elm$core$String$fromInt(v),
			v,
			v,
			v,
			v));
};
var $author$project$CWS$About$sidePanelWidget = $mdgriffith$elm_ui$Element$el(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Border$width(1),
			$mdgriffith$elm_ui$Element$Border$color($author$project$PAM$UI$Basic$asparagus),
			$mdgriffith$elm_ui$Element$Border$rounded(6),
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$paddingEach(
			{kx: 20, me: 40, nA: 40, os: 20}),
			$mdgriffith$elm_ui$Element$centerX
		]));
var $author$project$CWS$About$accountView = F2(
	function (model, user) {
		var showRegister = function () {
			if (user.$ === 3) {
				var profile = user.a;
				return false;
			} else {
				return true;
			}
		}();
		var showNoAccess = function () {
			if (user.$ === 3) {
				var usr = user.a;
				return $author$project$CWS$About$hasCwsRoles(usr.aB) ? false : true;
			} else {
				return false;
			}
		}();
		var showLogin = function () {
			if (user.$ === 3) {
				var profile = user.a;
				return false;
			} else {
				return true;
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$fillPortion(1)),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(20)
				]),
			_List_fromArray(
				[
					showNoAccess ? $author$project$CWS$About$sidePanelWidget(
					$author$project$CWS$About$noAccessView(model)) : $mdgriffith$elm_ui$Element$none,
					showRegister ? $author$project$CWS$About$sidePanelWidget(
					$author$project$CWS$About$registerView(model)) : $mdgriffith$elm_ui$Element$none,
					showLogin ? $author$project$CWS$About$sidePanelWidget(
					$author$project$CWS$About$loginView(model)) : $mdgriffith$elm_ui$Element$none
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$unstyled = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Unstyled, $elm$core$Basics$always);
var $mdgriffith$elm_ui$Element$html = $mdgriffith$elm_ui$Internal$Model$unstyled;
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $mdgriffith$elm_ui$Element$image = F2(
	function (attrs, _v0) {
		var src = _v0.nX;
		var description = _v0.hp;
		var imageAttributes = A2(
			$elm$core$List$filter,
			function (a) {
				switch (a.$) {
					case 7:
						return true;
					case 8:
						return true;
					default:
						return false;
				}
			},
			attrs);
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.lR),
				attrs),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[
						A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asEl,
						$mdgriffith$elm_ui$Internal$Model$NodeName('img'),
						_Utils_ap(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$src(src)),
									$mdgriffith$elm_ui$Internal$Model$Attr(
									$elm$html$Html$Attributes$alt(description))
								]),
							imageAttributes),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil))
					])));
	});
var $mdgriffith$elm_ui$Element$padding = function (x) {
	var f = x;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$padding,
		A5(
			$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
			'p-' + $elm$core$String$fromInt(x),
			f,
			f,
			f,
			f));
};
var $mdgriffith$elm_ui$Internal$Model$AsRow = 0;
var $mdgriffith$elm_ui$Internal$Model$asRow = 0;
var $mdgriffith$elm_ui$Element$row = F2(
	function (attrs, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.dj + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.bj)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
						attrs))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$spaceEvenly = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$spacing, $mdgriffith$elm_ui$Internal$Style$classes.nU);
var $elm_explorations$markdown$Markdown$defaultOptions = {
	hl: $elm$core$Maybe$Nothing,
	lF: $elm$core$Maybe$Just(
		{kA: false, n6: false}),
	nC: true,
	nS: false
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $elm_explorations$markdown$Markdown$toHtml = $elm_explorations$markdown$Markdown$toHtmlWith($elm_explorations$markdown$Markdown$defaultOptions);
var $author$project$CWS$About$view = F2(
	function (model, user) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$spaceEvenly
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(2)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$padding(10)
						]),
					_List_Nil),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(4)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$padding(10)
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$image,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$centerX
								]),
							{hp: 'Wildfire consuming a hillside.', nX: '/images/about.jpg'}),
							A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$html(
									A2($elm_explorations$markdown$Markdown$toHtml, _List_Nil, model.d9))
								]))
						])),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(2)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$padding(10)
						]),
					_List_fromArray(
						[
							A2($author$project$CWS$About$accountView, model, user)
						]))
				]));
	});
var $author$project$CWS$aboutView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$map,
		$author$project$CWS$aboutTranslator,
		A2($author$project$CWS$About$view, model.a.ck, model.f));
};
var $author$project$CWS$blankView = A2($elm$html$Html$div, _List_Nil, _List_Nil);
var $author$project$CWS$calculateModalContentSize = function (env) {
	var paddingTopBottom = 40;
	var paddingLeftRight = 200;
	var modalHeaderHeight = 50;
	var maxWidth = env.w.jR - (paddingLeftRight * 2);
	var headerHeight = env.ac.mh + env.ac.n3;
	var maxHeight = (env.w.lI - headerHeight) - (paddingTopBottom * 2);
	return {kT: maxHeight, lH: modalHeaderHeight, jR: maxWidth};
};
var $author$project$CWS$UploadDocuments$confirmCloseView = function (model) {
	var _v0 = model.a.aJ;
	if (_v0.$ === 1) {
		var title = _v0.a;
		var question = _v0.b;
		var description = _v0.c;
		var confirmName = _v0.d;
		var confirmMsg = _v0.e;
		var cancelName = _v0.f;
		var cancelMsg = _v0.g;
		var id = _v0.h;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirmWrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(title)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(description)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('question')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(question)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('actions')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('confirmAction'),
													$elm$html$Html$Events$onClick(
													confirmMsg(id))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(confirmName)
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cancelAction'),
													$elm$html$Html$Events$onClick(
													cancelMsg(id))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(cancelName)
												]))
										]))
								]))
						]))
				]));
	} else {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	}
};
var $author$project$GridOld$Grid$DynamicGetter = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$CWS$Route$makeSimpleFullRoute = F2(
	function (main, sub) {
		return A2($author$project$CWS$Route$FullRoute, main, sub);
	});
var $author$project$CWS$Route$makeViewAction = function (id) {
	return $author$project$CWS$Route$ActionDetails(
		{ab: id});
};
var $author$project$CWS$UploadDocuments$actionNameColumn = function (cr) {
	return {
		a1: $author$project$GridOld$Grid$DynamicGetter(
			function (b) {
				var actionRoute = A2(
					$author$project$CWS$Route$makeSimpleFullRoute,
					cr.z,
					$author$project$CWS$Route$makeViewAction(b.gH));
				return _Utils_Tuple2(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$CWS$Route$routeToHref(actionRoute))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(b.gI)
									]))
							])),
					b.gI);
			}),
		aD: {
			aP: function (b) {
				return A2(
					$elm$core$List$sortBy,
					function (a) {
						return $elm$core$String$toLower(a.gI);
					},
					b);
			}
		},
		jr: 'Action Name'
	};
};
var $author$project$GridOld$Grid$StringGetter = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$UploadDocuments$actionTypeColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			return b.gJ;
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.gJ;
				},
				b);
		}
	},
	jr: 'Action Type'
};
var $author$project$CWS$UploadDocuments$categoryColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			return b.gG;
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.gG;
				},
				b);
		}
	},
	jr: 'Category'
};
var $author$project$CWS$UploadDocuments$descriptionColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			return b.hp;
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.hp;
				},
				b);
		}
	},
	jr: 'Description'
};
var $author$project$CWS$UploadDocuments$Delete = function (a) {
	return {$: 17, a: a};
};
var $author$project$CWS$UploadDocuments$DownloadClicked = function (a) {
	return {$: 14, a: a};
};
var $author$project$CWS$UploadDocuments$downloadDynColumn = {
	a1: $author$project$GridOld$Grid$DynamicGetter(
		function (b) {
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('download')
						]),
					_Utils_ap(
						(b.gH <= 0) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('peFiledownload'),
										$elm$html$Html$Events$onClick(
										$author$project$CWS$UploadDocuments$Delete(b))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('spacer')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(' | ')
									]))
							]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('peFiledownload'),
										$elm$html$Html$Events$onClick(
										$author$project$CWS$UploadDocuments$DownloadClicked(b))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Download')
									]))
							]))),
				'');
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.ik;
				},
				b);
		}
	},
	jr: ''
};
var $author$project$CWS$UploadDocuments$splitDT = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, 'T', input)));
};
var $author$project$CWS$UploadDocuments$lastModifiedColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			return A2(
				$elm$core$Maybe$withDefault,
				'-',
				A2(
					$elm$core$Maybe$map,
					$author$project$NormalDate$dateToNormalString,
					$elm$core$Result$toMaybe(
						function (d) {
							return $author$project$NormalDate$fromIsoDate(d);
						}(
							$author$project$CWS$UploadDocuments$splitDT(b.ik)))));
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.ik;
				},
				b);
		}
	},
	jr: 'Last Modified'
};
var $author$project$CWS$UploadDocuments$nameColumn = {
	a1: $author$project$GridOld$Grid$DynamicGetter(
		function (b) {
			var fileId = function () {
				var _v0 = b.ab;
				if (!_v0.$) {
					var val = _v0.a;
					return val;
				} else {
					return '';
				}
			}();
			return _Utils_Tuple2(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(b.dz)
								]))
						])),
				b.dz);
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return $elm$core$String$toLower(a.dz);
				},
				b);
		}
	},
	jr: 'Name'
};
var $author$project$CWS$UploadDocuments$uploadedByColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			return b.hC;
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.hC;
				},
				b);
		}
	},
	jr: 'Uploaded By'
};
var $author$project$CWS$UploadDocuments$colDefs = function (currentRoute) {
	return _List_fromArray(
		[
			$author$project$CWS$UploadDocuments$nameColumn,
			$author$project$CWS$UploadDocuments$descriptionColumn,
			$author$project$CWS$UploadDocuments$categoryColumn,
			$author$project$CWS$UploadDocuments$actionTypeColumn,
			$author$project$CWS$UploadDocuments$actionNameColumn(currentRoute),
			$author$project$CWS$UploadDocuments$uploadedByColumn,
			$author$project$CWS$UploadDocuments$lastModifiedColumn,
			$author$project$CWS$UploadDocuments$downloadDynColumn
		]);
};
var $author$project$GridOld$Grid$filter = F3(
	function (model, columnDefs, data) {
		var _v0 = model.gg;
		if (!_v0.$) {
			var search = _v0.a;
			var o = $elm$core$List$map($elm$core$Basics$or);
			var lowerSearch = $elm$core$String$toLower(search);
			var l = $elm$core$String$toLower;
			var columns = function () {
				var _v3 = model.lx;
				if (!_v3.$) {
					var column = _v3.a;
					return A2(
						$elm$core$List$filter,
						function (a) {
							return _Utils_eq(a.jr, column);
						},
						columnDefs);
				} else {
					return columnDefs;
				}
			}();
			return A2(
				$elm$core$List$filter,
				function (item) {
					return A2(
						$elm$core$List$any,
						function (a) {
							return a;
						},
						A2(
							$elm$core$List$map,
							function (column) {
								var value = function () {
									var _v1 = column.a1;
									switch (_v1.$) {
										case 0:
											var getter = _v1.a;
											return $elm$core$String$toLower(
												getter(item));
										case 1:
											var getter = _v1.a;
											return $elm$core$String$fromInt(
												getter(item));
										case 2:
											var getter = _v1.a;
											return $elm$core$String$fromFloat(
												getter(item));
										default:
											var getter = _v1.a;
											var _v2 = getter(item);
											var searchable = _v2.b;
											return $elm$core$String$toLower(searchable);
									}
								}();
								var matches = A2($elm$core$String$contains, lowerSearch, value);
								return matches;
							},
							columns));
				},
				data);
		} else {
			return data;
		}
	});
var $author$project$GridOld$Grid$getSorter = F3(
	function (model, columnDefs, by) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (a) {
					return _Utils_eq(a.jr, by);
				},
				columnDefs));
		if (!_v0.$) {
			var column = _v0.a;
			return $elm$core$Maybe$Just(column.aD);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$GridOld$Grid$getSortedDataFrom = F3(
	function (model, columnDefs, data) {
		var _v0 = model.aD;
		switch (_v0.$) {
			case 0:
				return data;
			case 1:
				var by = _v0.a;
				var sorter = A3($author$project$GridOld$Grid$getSorter, model, columnDefs, by);
				if (!sorter.$) {
					var srt = sorter.a;
					return srt.aP(data);
				} else {
					return data;
				}
			default:
				var by = _v0.a;
				var sorter = A3($author$project$GridOld$Grid$getSorter, model, columnDefs, by);
				return $elm$core$List$reverse(
					function () {
						if (!sorter.$) {
							var srt = sorter.a;
							return srt.aP(data);
						} else {
							return data;
						}
					}());
		}
	});
var $author$project$GridOld$Grid$getRenderDataFrom = F3(
	function (model, columnDefs, data) {
		return A2(
			$elm$core$List$take,
			model.l5,
			A2(
				$elm$core$List$drop,
				model.k_ * model.l5,
				A3($author$project$GridOld$Grid$getSortedDataFrom, model, columnDefs, data)));
	});
var $author$project$GridOld$Grid$SpitOut = function (a) {
	return {$: 7, a: a};
};
var $author$project$GridOld$Grid$renderItemField = F2(
	function (getter, itm) {
		switch (getter.$) {
			case 0:
				var get = getter.a;
				return $elm$html$Html$text(
					get(itm));
			case 1:
				var get = getter.a;
				return $elm$html$Html$text(
					$elm$core$String$fromInt(
						get(itm)));
			case 2:
				var get = getter.a;
				return $elm$html$Html$text(
					$elm$core$String$fromFloat(
						get(itm)));
			default:
				var get = getter.a;
				var _v1 = get(itm);
				var html = _v1.a;
				return A2(
					$elm$html$Html$map,
					function (a) {
						return $author$project$GridOld$Grid$SpitOut(a);
					},
					html);
		}
	});
var $author$project$GridOld$Grid$gridColumnDivBodyView = F2(
	function (data, column) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('gridColumnData')
				]),
			A2(
				$elm$core$List$map,
				function (itm) {
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('row')
							]),
						_List_fromArray(
							[
								A2($author$project$GridOld$Grid$renderItemField, column.a1, itm)
							]));
				},
				data));
	});
var $author$project$GridOld$Grid$SortBy = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$GridOld$Grid$gridColumnDivHeaderView = F2(
	function (column, sort) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('gridColumnHeader row'),
					$elm$html$Html$Events$onClick(
					$author$project$GridOld$Grid$SortBy(column.jr))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(column.jr)
						])),
					A2(
					$elm$html$Html$i,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							function () {
								switch (sort.$) {
									case 0:
										return 'fa fa-sort none';
									case 1:
										var col = sort.a;
										return _Utils_eq(column.jr, col) ? 'fa fa-sort-down' : 'fa fa-sort none';
									default:
										var col = sort.a;
										return _Utils_eq(column.jr, col) ? 'fa fa-sort-up' : 'fa fa-sort none';
								}
							}())
						]),
					_List_Nil)
				]));
	});
var $author$project$GridOld$Grid$gridColumnDivView = F3(
	function (data, column, sort) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column')
				]),
			_List_fromArray(
				[
					A2($author$project$GridOld$Grid$gridColumnDivHeaderView, column, sort),
					A2($author$project$GridOld$Grid$gridColumnDivBodyView, data, column)
				]));
	});
var $author$project$GridOld$Grid$gridColumnsDivView = F3(
	function (data, columns, sort) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columnCollection')
				]),
			A2(
				$elm$core$List$map,
				function (a) {
					return A3($author$project$GridOld$Grid$gridColumnDivView, data, a, sort);
				},
				columns));
	});
var $author$project$GridOld$Grid$getTitle = F2(
	function (getter_, itm) {
		switch (getter_.$) {
			case 0:
				var getter = getter_.a;
				return getter(itm);
			case 1:
				var getter = getter_.a;
				return $elm$core$String$fromInt(
					getter(itm));
			case 2:
				var getter = getter_.a;
				return $elm$core$String$fromFloat(
					getter(itm));
			default:
				var getter = getter_.a;
				var _v1 = getter(itm);
				var searchable = _v1.b;
				return searchable;
		}
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$GridOld$Grid$tableRow = F2(
	function (columns, row) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (column) {
					return A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$title(
								A2($author$project$GridOld$Grid$getTitle, column.a1, row))
							]),
						_List_fromArray(
							[
								A2($author$project$GridOld$Grid$renderItemField, column.a1, row)
							]));
				},
				columns));
	});
var $author$project$GridOld$Grid$tableBody = F2(
	function (data, columns) {
		return A2(
			$elm$core$List$map,
			$author$project$GridOld$Grid$tableRow(columns),
			data);
	});
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$GridOld$Grid$tableHeader = F2(
	function (columns, sort) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (column) {
					return A2(
						$elm$html$Html$th,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$GridOld$Grid$SortBy(column.jr))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(column.jr)
									])),
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										function () {
											switch (sort.$) {
												case 0:
													return 'fa fa-sort none';
												case 1:
													var col = sort.a;
													return _Utils_eq(column.jr, col) ? 'fa fa-sort-down' : 'fa fa-sort none';
												default:
													var col = sort.a;
													return _Utils_eq(column.jr, col) ? 'fa fa-sort-up' : 'fa fa-sort none';
											}
										}())
									]),
								_List_Nil)
							]));
				},
				columns));
	});
var $author$project$GridOld$Grid$gridTableView = F3(
	function (data, columns, sort) {
		return A2(
			$elm$html$Html$table,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2($author$project$GridOld$Grid$tableHeader, columns, sort),
				A2($author$project$GridOld$Grid$tableBody, data, columns)));
	});
var $author$project$GridOld$Grid$gridBodyWithData = F3(
	function (model, columnDefs, data) {
		var renderer = function () {
			var _v0 = model.lb;
			if (!_v0) {
				return $author$project$GridOld$Grid$gridColumnsDivView;
			} else {
				return $author$project$GridOld$Grid$gridTableView;
			}
		}();
		var renderData = A3($author$project$GridOld$Grid$getRenderDataFrom, model, columnDefs, data);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('gridBody')
				]),
			_List_fromArray(
				[
					A3(renderer, renderData, columnDefs, model.aD)
				]));
	});
var $author$project$GridOld$Grid$currentPageDisplay = F3(
	function (model, filteredData, data) {
		var totalCount = $elm$core$List$length(data);
		var pageStart = (model.k_ * model.l5) + 1;
		var pageMax = (model.k_ + 1) * model.l5;
		var filteredCount = $elm$core$List$length(filteredData);
		var pageEnd = (_Utils_cmp(pageMax, filteredCount) < 1) ? pageMax : filteredCount;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(pageStart) + (' - ' + ($elm$core$String$fromInt(pageEnd) + (' of ' + $elm$core$String$fromInt(filteredCount)))))
						]))
				]));
	});
var $author$project$GridOld$Grid$GotoPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$GridOld$Grid$NoOp = {$: 0};
var $author$project$GridOld$Grid$UpdatePage = function (a) {
	return {$: 2, a: a};
};
var $author$project$GridOld$Grid$maxPageOf = F2(
	function (data, itemsPerPage) {
		var length = $elm$core$List$length(data) - 1;
		var max = $elm$core$Basics$floor(length / itemsPerPage);
		return max;
	});
var $author$project$GridOld$Grid$pageNavigation = F2(
	function (model, filteredData) {
		var pageMax = (model.k_ + 1) * model.l5;
		var filteredCount = $elm$core$List$length(filteredData);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pageNavigation')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$GridOld$Grid$GotoPage(0)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('disabled', model.k_ <= 0)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-step-backward')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							(model.k_ > 0) ? $author$project$GridOld$Grid$UpdatePage(-1) : $author$project$GridOld$Grid$NoOp),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('disabled', model.k_ <= 0)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-caret-left')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							(_Utils_cmp(pageMax, filteredCount) < 0) ? $author$project$GridOld$Grid$UpdatePage(1) : $author$project$GridOld$Grid$NoOp),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'disabled',
									_Utils_cmp(pageMax, filteredCount) > -1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-caret-right')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$GridOld$Grid$GotoPage(
								A2($author$project$GridOld$Grid$maxPageOf, filteredData, model.l5))),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'disabled',
									_Utils_cmp(pageMax, filteredCount) > -1)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-step-forward')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$GridOld$Grid$PageSizeChanged = function (a) {
	return {$: 4, a: a};
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$GridOld$Grid$pageSizeSelector = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('pageSizeSelector')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$for('pagenationPageSize')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Items Per Page')
				])),
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('pagenationPageSize'),
							$elm$html$Html$Events$onInput(
							function (a) {
								return $author$project$GridOld$Grid$PageSizeChanged(
									function () {
										var _v0 = $elm$core$String$toInt(a);
										if (!_v0.$) {
											var val = _v0.a;
											return val;
										} else {
											return 10;
										}
									}());
							})
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('10')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('10')
								])),
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('25')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('25')
								])),
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('50')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('50')
								])),
							A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value('100')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('100')
								]))
						]))
				]))
		]));
var $author$project$GridOld$Grid$paginationControls = F3(
	function (model, filteredData, data) {
		var totalCount = $elm$core$List$length(data);
		var pageStart = (model.k_ * model.l5) + 1;
		var pageMax = (model.k_ + 1) * model.l5;
		var filteredCount = $elm$core$List$length(filteredData);
		var pageEnd = (_Utils_cmp(pageMax, filteredCount) < 1) ? pageMax : filteredCount;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('paginationControls right')
				]),
			_List_fromArray(
				[
					$author$project$GridOld$Grid$pageSizeSelector,
					A3($author$project$GridOld$Grid$currentPageDisplay, model, filteredData, data),
					A2($author$project$GridOld$Grid$pageNavigation, model, filteredData)
				]));
	});
var $author$project$GridOld$Grid$gridFooterWithData = F3(
	function (model, filteredData, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('gridFooter')
				]),
			_List_fromArray(
				[
					A3($author$project$GridOld$Grid$paginationControls, model, filteredData, data)
				]));
	});
var $author$project$GridOld$Grid$FilterTextChange = function (a) {
	return {$: 5, a: a};
};
var $author$project$GridOld$Grid$FilterTypeChange = function (a) {
	return {$: 6, a: a};
};
var $author$project$GridOld$Grid$filterView = F2(
	function (model, columnDefs) {
		var searchTxt = function () {
			var _v1 = model.gg;
			if (_v1.$ === 1) {
				return '';
			} else {
				var txt = _v1.a;
				return txt;
			}
		}();
		var filterCol = function () {
			var _v0 = model.lx;
			if (_v0.$ === 1) {
				return '';
			} else {
				var col = _v0.a;
				return col;
			}
		}();
		var colTitles = A2(
			$elm$core$List$map,
			function (col) {
				return col.jr;
			},
			columnDefs);
		var choices = A2(
			$elm$core$List$map,
			function (col) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(col),
							$elm$html$Html$Attributes$selected(
							_Utils_eq(filterCol, col))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(col)
						]));
			},
			colTitles);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filters left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for('filterBy')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Filter By')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput($author$project$GridOld$Grid$FilterTypeChange)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$selected(true),
											$elm$html$Html$Attributes$value('-')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('All')
										])),
								choices))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput($author$project$GridOld$Grid$FilterTextChange),
									$elm$html$Html$Attributes$placeholder('Enter a value to filter by'),
									$elm$html$Html$Attributes$value(searchTxt)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$GridOld$Grid$headerView = F2(
	function (model, columnDefs) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('gridHeader')
				]),
			_List_fromArray(
				[
					A2($author$project$GridOld$Grid$filterView, model, columnDefs)
				]));
	});
var $author$project$GridOld$Grid$viewWithData = F3(
	function (model, columnDefs, data) {
		var filteredData = A3($author$project$GridOld$Grid$filter, model, columnDefs, data);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('gridContainer')
				]),
			_List_fromArray(
				[
					A2($author$project$GridOld$Grid$headerView, model, columnDefs),
					A3($author$project$GridOld$Grid$gridBodyWithData, model, columnDefs, filteredData),
					A3($author$project$GridOld$Grid$gridFooterWithData, model, filteredData, data)
				]));
	});
var $author$project$CWS$UploadDocuments$fileGridView = F3(
	function (model, columnDefs, files) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$CWS$UploadDocuments$GridMsg,
					A3(
						$author$project$GridOld$Grid$viewWithData,
						model.dr,
						$author$project$CWS$UploadDocuments$colDefs(model.ff),
						files))
				]));
	});
var $author$project$CWS$UploadDocuments$gridOnlyView = F3(
	function (currentRoute, model, fileList) {
		return A3(
			$author$project$CWS$UploadDocuments$fileGridView,
			model,
			$author$project$CWS$UploadDocuments$colDefs(currentRoute),
			fileList);
	});
var $author$project$CWS$UploadDocuments$headerOnlyView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('actionboard-subTitle')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(model.eK.dz + ' Dashboard: '),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('subTitleContent')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('All Documents')
					]))
			]));
};
var $author$project$CWS$loadingView = $elm$html$Html$text('Loading');
var $author$project$CWS$UploadDocuments$staticFileUploadInstructions = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('trow')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex wrap column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Static files are represented in the side menu for the Participating Entity. '),
							$elm$html$Html$text('Files can be uploaded using the controls below. ')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Please note that once uploaded, static files can only be replaced, but they cannot be deleted.')
						]))
				]))
		]));
var $author$project$CWS$UploadDocuments$StaticWorkflow_Cancel = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$UploadDocuments$StaticWorkflow_ReplaceStaticFile = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$UploadDocuments$StaticWorkflow_Upload = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$CWS$UploadDocuments$staticFileUploadViewNew = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('staticFileRow trow')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('tcol')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('staticFileName')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.J.dz)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tcol alignTop')
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = model.bd;
								switch (_v0.$) {
									case 0:
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('No file has been uploaded. Please select a file. ')
												]));
									case 1:
										var name = _v0.a;
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('staticFileFileName')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(name)
												]));
									case 2:
										var file = _v0.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($elm$core$Maybe$withDefault, 'Select a file or cancel.', file))
												]));
									case 3:
										var name = _v0.a;
										var exp = _v0.b;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(name)
												]));
									default:
										var name = _v0.a;
										var expiration = _v0.b;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Uploading.')
												]));
								}
							}(),
								function () {
								var _v1 = model.bd;
								switch (_v1.$) {
									case 1:
										var expiration = _v1.b;
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('staticFileExpiration')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Expires on: ' + expiration)
												]));
									case 3:
										var name = _v1.a;
										var exp = _v1.b;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Select an expiration or cancel.')
												]));
									default:
										return $elm$html$Html$text('');
								}
							}()
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('trow')
					]),
				function () {
					var _v2 = model.bd;
					switch (_v2.$) {
						case 0:
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button btn primaryAction'),
											$elm$html$Html$Events$onClick(
											$author$project$CWS$UploadDocuments$StaticMsg(
												$author$project$CWS$UploadDocuments$StaticWorkflow_ReplaceStaticFile(model.J)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('SELECT')
										]))
								]);
						case 1:
							var name = _v2.a;
							var expiration = _v2.b;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button btn primaryAction'),
											$elm$html$Html$Events$onClick(
											$author$project$CWS$UploadDocuments$StaticMsg(
												$author$project$CWS$UploadDocuments$StaticWorkflow_ReplaceStaticFile(model.J)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('REPLACE')
										]))
								]);
						case 2:
							var file = _v2.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button btn primaryAction'),
											$elm$html$Html$Events$onClick(
											$author$project$CWS$UploadDocuments$StaticMsg(
												$author$project$CWS$UploadDocuments$StaticWorkflow_ReplaceStaticFile(model.J)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('SELECT')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button btn primaryAction'),
											$elm$html$Html$Events$onClick(
											$author$project$CWS$UploadDocuments$StaticMsg(
												$author$project$CWS$UploadDocuments$StaticWorkflow_Cancel(model.J)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('CANCEL')
										]))
								]);
						case 3:
							var name = _v2.a;
							var exp = _v2.b;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('required')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('requiredLabel')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('*')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Expiration Date')
												]))
										])),
									function () {
									var _v3 = model.bx;
									if (!_v3.$) {
										var picker = _v3.a;
										var ds = $CurrySoftware$elm_datepicker$DatePicker$defaultSettings;
										return A2(
											$elm$html$Html$map,
											A2(
												$elm$core$Basics$composeR,
												$author$project$CWS$UploadDocuments$StaticWorkflow_DatePickerMsg(model.J),
												$author$project$CWS$UploadDocuments$StaticMsg),
											A3(
												$CurrySoftware$elm_datepicker$DatePicker$view,
												A2(
													$elm$core$Maybe$andThen,
													function (d) {
														return A2($author$project$NormalDate$stringToDate, d, '/');
													},
													exp),
												_Utils_update(
													ds,
													{
														eg: $justinmimbs$date$Date$format('MM/dd/yyyy'),
														eJ: $author$project$NormalDate$fromNormalDate
													}),
												picker));
									} else {
										return $elm$html$Html$text('Uh oh');
									}
								}(),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button btn primaryAction'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'disabled',
													_Utils_eq(exp, $elm$core$Maybe$Nothing))
												])),
											$elm$html$Html$Events$onClick(
											$author$project$CWS$UploadDocuments$StaticMsg(
												function () {
													if (!exp.$) {
														var expire = exp.a;
														return A3($author$project$CWS$UploadDocuments$StaticWorkflow_Upload, model.J, name, expire);
													} else {
														return $author$project$CWS$UploadDocuments$StaticWorkflow_NoOp;
													}
												}()))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('UPLOAD')
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button btn primaryAction'),
											$elm$html$Html$Events$onClick(
											$author$project$CWS$UploadDocuments$StaticMsg(
												$author$project$CWS$UploadDocuments$StaticWorkflow_Cancel(model.J)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('CANCEL')
										]))
								]);
						default:
							var name = _v2.a;
							var expiration = _v2.b;
							return _List_Nil;
					}
				}())
			]));
};
var $author$project$CWS$UploadDocuments$staticUploadView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('staticFileView')
			]),
		_Utils_ap(
			_List_fromArray(
				[$author$project$CWS$UploadDocuments$staticFileUploadInstructions]),
			A2(
				$elm$core$List$map,
				function (a) {
					return $author$project$CWS$UploadDocuments$staticFileUploadViewNew(
						{bx: a.bx, J: a.J, bd: a.a});
				},
				$elm$core$Dict$values(model.aE))));
};
var $author$project$CWS$UploadDocuments$uploadWorkflowView = function (model) {
	switch (model.$) {
		case 3:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('No Workflow Selected!')
					]));
		case 0:
			var stat = model.a;
			return $author$project$CWS$UploadDocuments$staticUploadView(stat);
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Workflow not implemented!')
					]));
	}
};
var $author$project$CWS$Approver$Actions$headerView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Actions')
					]))
			]));
};
var $author$project$CWS$Approver$Actions$actionNameColumn = function (currentRoute) {
	return {
		a1: $author$project$GridOld$Grid$DynamicGetter(
			function (b) {
				var actionRoute = A2(
					$author$project$CWS$Route$makeSimpleFullRoute,
					currentRoute.z,
					$author$project$CWS$Route$makeViewAction(b.ab));
				var actionName = function () {
					var _v0 = b.dz;
					if (_v0.$ === 1) {
						return 'Not Set';
					} else {
						var name = _v0.a;
						return name;
					}
				}();
				return _Utils_Tuple2(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										$author$project$CWS$Route$routeToHref(actionRoute))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(actionName)
									]))
							])),
					actionName);
			}),
		aD: {
			aP: function (b) {
				return A2(
					$elm$core$List$sortBy,
					function (a) {
						var _v1 = a.dz;
						if (_v1.$ === 1) {
							return '';
						} else {
							var name = _v1.a;
							return $elm$core$String$toLower(name);
						}
					},
					b);
			}
		},
		jr: 'Action Name'
	};
};
var $author$project$CWS$Approver$Actions$catColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			return b.bK.dz;
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.bK.dz;
				},
				b);
		}
	},
	jr: 'Category'
};
var $author$project$GridOld$Grid$FloatGetter = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Approver$Actions$costColumn = {
	a1: $author$project$GridOld$Grid$FloatGetter(
		function (b) {
			var _v0 = $author$project$Fields$Shared$validityToMaybe(b.ll);
			if (_v0.$ === 1) {
				return 0.00;
			} else {
				var estimatedCost = _v0.a;
				return estimatedCost;
			}
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					var _v1 = $author$project$Fields$Shared$validityToMaybe(a.ll);
					if (_v1.$ === 1) {
						return 0.00;
					} else {
						var estimatedCost = _v1.a;
						return estimatedCost;
					}
				},
				b);
		}
	},
	jr: 'Cost'
};
var $author$project$CWS$Approver$Actions$createNameColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			var _v0 = b.kY;
			if (_v0.$ === 1) {
				return '';
			} else {
				var person = _v0.a;
				return person.dz;
			}
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					var _v1 = a.kY;
					if (_v1.$ === 1) {
						return '';
					} else {
						var person = _v1.a;
						return $elm$core$String$toLower(person.dz);
					}
				},
				b);
		}
	},
	jr: 'Created By'
};
var $author$project$GridOld$Grid$IntGetter = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Approver$Actions$daysInQColumn = {
	a1: $author$project$GridOld$Grid$IntGetter(
		function (b) {
			var _v0 = b.hk;
			if (_v0.$ === 1) {
				return -1;
			} else {
				var daysInQ = _v0.a;
				return daysInQ;
			}
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					var _v1 = a.hk;
					if (_v1.$ === 1) {
						return -1;
					} else {
						var daysInQ = _v1.a;
						return daysInQ;
					}
				},
				b);
		}
	},
	jr: 'Days in Queue'
};
var $author$project$CWS$Approver$Actions$peNameColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			var _v0 = b.iA;
			if (_v0.$ === 1) {
				return '';
			} else {
				var name = _v0.a;
				return name;
			}
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					var _v1 = a.iA;
					if (_v1.$ === 1) {
						return '';
					} else {
						var name = _v1.a;
						return $elm$core$String$toLower(name);
					}
				},
				b);
		}
	},
	jr: 'PE Name'
};
var $author$project$CWS$Approver$Actions$statusColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			var _v0 = b.jf;
			switch (_v0) {
				case 1:
					return 'Pending';
				case 2:
					return 'Submitted';
				case 3:
					return 'Denied';
				case 4:
					return 'Approved';
				default:
					return '';
			}
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					var _v1 = a.jf;
					switch (_v1) {
						case 1:
							return 'Pending';
						case 2:
							return 'Submitted';
						case 3:
							return 'Denied';
						case 4:
							return 'Approved';
						default:
							return '';
					}
				},
				b);
		}
	},
	jr: 'Status'
};
var $author$project$CWS$Approver$Actions$submitNameColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			var _v0 = b.ma;
			if (_v0.$ === 1) {
				return '';
			} else {
				var person = _v0.a;
				return person.dz;
			}
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					var _v1 = a.ma;
					if (_v1.$ === 1) {
						return '';
					} else {
						var person = _v1.a;
						return $elm$core$String$toLower(person.dz);
					}
				},
				b);
		}
	},
	jr: 'Submitted By'
};
var $author$project$CWS$Approver$Actions$typeColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			return b.jE.dz;
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return $elm$core$String$toLower(a.jE.dz);
				},
				b);
		}
	},
	jr: 'Type'
};
var $author$project$CWS$Approver$Actions$userRoleColumn = {
	a1: $author$project$GridOld$Grid$StringGetter(
		function (b) {
			var _v0 = b.ma;
			if (_v0.$ === 1) {
				return '';
			} else {
				var person = _v0.a;
				return person.ir;
			}
		}),
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					var _v1 = a.ma;
					if (_v1.$ === 1) {
						return '';
					} else {
						var person = _v1.a;
						return $elm$core$String$toLower(person.ir);
					}
				},
				b);
		}
	},
	jr: 'Org. Role'
};
var $author$project$CWS$Approver$Actions$colDefs = function (currentRoute) {
	return _List_fromArray(
		[
			$author$project$CWS$Approver$Actions$peNameColumn,
			$author$project$CWS$Approver$Actions$catColumn,
			$author$project$CWS$Approver$Actions$typeColumn,
			$author$project$CWS$Approver$Actions$actionNameColumn(currentRoute),
			$author$project$CWS$Approver$Actions$costColumn,
			$author$project$CWS$Approver$Actions$createNameColumn,
			$author$project$CWS$Approver$Actions$submitNameColumn,
			$author$project$CWS$Approver$Actions$userRoleColumn,
			$author$project$CWS$Approver$Actions$statusColumn,
			$author$project$CWS$Approver$Actions$daysInQColumn
		]);
};
var $author$project$CWS$Approver$Actions$peGridView = F2(
	function (model, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('grid')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$CWS$Approver$Actions$GridMsg,
					A3(
						$author$project$GridOld$Grid$viewWithData,
						model.dr,
						$author$project$CWS$Approver$Actions$colDefs(model.ff),
						data))
				]));
	});
var $author$project$CWS$Approver$Actions$view = F2(
	function (model, data) {
		var filtered = data;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('APP_ACTIONS')
				]),
			_List_fromArray(
				[
					$author$project$CWS$Approver$Actions$headerView(model),
					A2($author$project$CWS$Approver$Actions$peGridView, model, filtered)
				]));
	});
var $mdgriffith$elm_ui$Element$paddingXY = F2(
	function (x, y) {
		if (_Utils_eq(x, y)) {
			var f = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + $elm$core$String$fromInt(x),
					f,
					f,
					f,
					f));
		} else {
			var yFloat = y;
			var xFloat = x;
			return A2(
				$mdgriffith$elm_ui$Internal$Model$StyleClass,
				$mdgriffith$elm_ui$Internal$Flag$padding,
				A5(
					$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
					'p-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
					yFloat,
					xFloat,
					yFloat,
					xFloat));
		}
	});
var $author$project$CWS$Approver$ParticipatingEntities$headerView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size(26),
				$mdgriffith$elm_ui$Element$Font$bold,
				A2($mdgriffith$elm_ui$Element$paddingXY, 0, 10)
			]),
		$mdgriffith$elm_ui$Element$text('Participating Entities'));
};
var $author$project$Grid$Grid$DisableHideShow = 1;
var $author$project$Grid$Grid$IntGetter = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Approver$ParticipatingEntities$approvedColumn = {
	a1: $author$project$Grid$Grid$IntGetter(
		function (a) {
			return a.gQ;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.gQ;
				},
				b);
		}
	},
	jr: 'Approved',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$Grid$Grid$StringGetter = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$Approver$ParticipatingEntities$entityColumn = {
	a1: $author$project$Grid$Grid$StringGetter(
		function (b) {
			return b.eK.dz;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.eK.dz;
				},
				b);
		}
	},
	jr: 'Entity',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$fill
};
var $author$project$CWS$Approver$ParticipatingEntities$entityTypeColumn = {
	a1: $author$project$Grid$Grid$StringGetter(
		function (b) {
			return b.eK.jE.dz;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.eK.jE.dz;
				},
				b);
		}
	},
	jr: 'Type',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$CWS$Approver$ParticipatingEntities$notSubmittedColumn = {
	a1: $author$project$Grid$Grid$IntGetter(
		function (a) {
			return a.iB;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.iB;
				},
				b);
		}
	},
	jr: 'Not Submitted',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$CWS$Approver$ParticipatingEntities$pendingColumn = {
	a1: $author$project$Grid$Grid$IntGetter(
		function (a) {
			return a.jj;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.jj;
				},
				b);
		}
	},
	jr: 'Pending',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$Grid$Grid$DynamicGetter = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Approver$ParticipatingEntities$getMostRecentYearKey = function (peo) {
	var late = $elm$core$List$head(peo.eK.cj);
	if (!late.$) {
		var latest = late.a;
		return latest.v;
	} else {
		return '0';
	}
};
var $author$project$CWS$Route$makeCWSApproverAllDocuments = F2(
	function (key, year) {
		return $author$project$CWS$Route$CWSApprover(
			$author$project$CWS$Route$APP_Documents(
				{d: key, r: year}));
	});
var $author$project$CWS$Route$makeCWSApproverDashboard = $author$project$CWS$Route$CWSApprover($author$project$CWS$Route$APP_Dashboard);
var $author$project$CWS$Route$makeAppModalRoute = function (per) {
	return $author$project$CWS$Route$CWSApproverModal(per);
};
var $author$project$CWS$Route$makeCWSApproverManageUsers = function (peKey) {
	return $author$project$CWS$Route$makeAppModalRoute(
		$author$project$CWS$Route$APP_Modal_Manage_PE_Users(
			{d: peKey}));
};
var $author$project$CWS$Route$makePEMainRoute = function (per) {
	return $author$project$CWS$Route$ParticipatingEntity(per);
};
var $author$project$CWS$Route$makePEHome = F2(
	function (peKey, year) {
		return $author$project$CWS$Route$makePEMainRoute(
			$author$project$CWS$Route$PE_Home(
				{d: peKey, r: year}));
	});
var $author$project$CWS$Model$peStatusToString = function (status) {
	switch (status) {
		case 0:
			return 'Eligible';
		case 1:
			return 'Opted Out';
		case 2:
			return 'Participating';
		default:
			return 'Probation';
	}
};
var $author$project$CWS$Approver$ParticipatingEntities$statusTransformer = function (id) {
	return $author$project$CWS$Model$peStatusToString(id);
};
var $author$project$CWS$Approver$ParticipatingEntities$testDynColumn = {
	a1: $author$project$Grid$Grid$DynamicGetter(
		function (b) {
			var reportRoute = A2(
				$author$project$CWS$Route$makeSimpleFullRoute,
				A2(
					$author$project$CWS$Route$makePEHome,
					b.eK.v,
					$author$project$CWS$Approver$ParticipatingEntities$getMostRecentYearKey(b)),
				$author$project$CWS$Route$None);
			var documentRoute = A2(
				$author$project$CWS$Route$makeSimpleFullRoute,
				A2(
					$author$project$CWS$Route$makeCWSApproverAllDocuments,
					b.eK.v,
					$author$project$CWS$Approver$ParticipatingEntities$getMostRecentYearKey(b)),
				$author$project$CWS$Route$None);
			var addUserRoute = A2(
				$author$project$CWS$Route$makeSimpleFullRoute,
				$author$project$CWS$Route$makeCWSApproverDashboard,
				$author$project$CWS$Route$makeCWSApproverManageUsers(b.eK.v));
			return _Utils_Tuple2(
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerY]),
					$mdgriffith$elm_ui$Element$html(
						A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$CWS$Route$routeToHref(documentRoute))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Documents')
										])),
									$elm$html$Html$text(' | '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$CWS$Route$routeToHref(reportRoute))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Dashboard')
										])),
									$elm$html$Html$text(' | '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$CWS$Route$routeToHref(addUserRoute))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Users')
										]))
								])))),
				'');
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return $author$project$CWS$Approver$ParticipatingEntities$statusTransformer(a.eK.jf);
				},
				b);
		}
	},
	jr: '',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$CWS$Approver$ParticipatingEntities$yearColumn = {
	a1: $author$project$Grid$Grid$StringGetter(
		function (b) {
			return b.eK.oM.dz;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function (a) {
					return a.eK.oM.dz;
				},
				b);
		}
	},
	jr: 'Year Type',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$CWS$Approver$ParticipatingEntities$colDefs = _List_fromArray(
	[$author$project$CWS$Approver$ParticipatingEntities$entityColumn, $author$project$CWS$Approver$ParticipatingEntities$entityTypeColumn, $author$project$CWS$Approver$ParticipatingEntities$yearColumn, $author$project$CWS$Approver$ParticipatingEntities$notSubmittedColumn, $author$project$CWS$Approver$ParticipatingEntities$pendingColumn, $author$project$CWS$Approver$ParticipatingEntities$approvedColumn, $author$project$CWS$Approver$ParticipatingEntities$testDynColumn]);
var $author$project$CWS$Approver$ParticipatingEntities$columnToggles = _List_Nil;
var $author$project$Grid$Grid$FilterTextChange = function (a) {
	return {$: 8, a: a};
};
var $mdgriffith$elm_ui$Element$rgba = $mdgriffith$elm_ui$Internal$Model$Rgba;
var $mdgriffith$elm_ui$Element$toRgb = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {af: a, ag: b, al: g, aq: r};
};
var $author$project$PAM$UI$Basic$fadeColor = F2(
	function (alpha, color) {
		var c = $mdgriffith$elm_ui$Element$toRgb(color);
		return A4($mdgriffith$elm_ui$Element$rgba, c.aq, c.al, c.ag, alpha);
	});
var $author$project$Grid$Grid$CloseFilterDropdown = {$: 11};
var $author$project$Grid$Grid$ColumnFilter = function (title) {
	return {jr: title};
};
var $author$project$Grid$Grid$FilterTypeChange = function (a) {
	return {$: 9, a: a};
};
var $author$project$PAM$UI$Select$SelectDown = 0;
var $author$project$Grid$Grid$ToggleFilterDropdown = {$: 10};
var $author$project$PAM$UI$Basic$edges = {kx: 0, me: 0, nA: 0, os: 0};
var $mdgriffith$elm_ui$Element$modular = F3(
	function (normal, ratio, rescale) {
		return (!rescale) ? normal : ((rescale < 0) ? (normal * A2($elm$core$Basics$pow, ratio, rescale)) : (normal * A2($elm$core$Basics$pow, ratio, rescale - 1)));
	});
var $author$project$PAM$UI$Basic$responsiveFont = F3(
	function (a, _v0, _v1) {
		var aMin = _v0.a;
		var aMax = _v0.b;
		var bMin = _v1.a;
		var bMax = _v1.b;
		if (_Utils_cmp(a, aMin) < 1) {
			return bMin;
		} else {
			if (_Utils_cmp(a, aMax) > -1) {
				return bMax;
			} else {
				var deltaA = (a - aMin) / (aMax - aMin);
				return (deltaA * (bMax - bMin)) + bMin;
			}
		}
	});
var $author$project$PAM$UI$Basic$scaleFont = F2(
	function (size, factor) {
		var baseFont = A3(
			$author$project$PAM$UI$Basic$responsiveFont,
			size.jR,
			_Utils_Tuple2(1200, 1800),
			_Utils_Tuple2(13, 16));
		return $elm$core$Basics$round(
			A3($mdgriffith$elm_ui$Element$modular, baseFont, 1.15, factor));
	});
var $author$project$PAM$UI$Select$defaultButtonConfig = F2(
	function (size, args) {
		return {
			gV: $author$project$PAM$UI$Basic$white,
			hI: $author$project$PAM$UI$Basic$black,
			lB: A2($author$project$PAM$UI$Basic$scaleFont, size, -1),
			lI: args.lI,
			ab: args.ab,
			ip: args.ip,
			iu: _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Border$width(1)
				]),
			a7: _Utils_update(
				$author$project$PAM$UI$Basic$edges,
				{me: 6, nA: 6}),
			jR: args.jR
		};
	});
var $author$project$PAM$UI$Basic$Edges = F4(
	function (top, right, bottom, left) {
		return {kx: bottom, me: left, nA: right, os: top};
	});
var $author$project$PAM$UI$Basic$greenKelp = A3($mdgriffith$elm_ui$Element$rgb255, 53, 61, 34);
var $author$project$PAM$UI$Basic$woodland = A3($mdgriffith$elm_ui$Element$rgb255, 78, 90, 48);
var $author$project$PAM$UI$Select$defaultOptionConfig = F2(
	function (size, args) {
		return {
			fs: _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Background$color(
					A2($author$project$PAM$UI$Basic$fadeColor, 0.5, $author$project$PAM$UI$Basic$greenKelp))
				]),
			lI: $mdgriffith$elm_ui$Element$fill,
			fD: _List_Nil,
			ms: _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Background$color(
					A2($author$project$PAM$UI$Basic$fadeColor, 0.5, $author$project$PAM$UI$Basic$greenKelp))
				]),
			iu: _List_Nil,
			a7: A4($author$project$PAM$UI$Basic$Edges, 8, 6, 8, 6),
			nM: _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Background$color(
					A2($author$project$PAM$UI$Basic$fadeColor, 0.75, $author$project$PAM$UI$Basic$woodland))
				]),
			op: args.op,
			jR: $mdgriffith$elm_ui$Element$fill
		};
	});
var $mdgriffith$elm_ui$Element$Border$widthXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$borderWidth,
			A5(
				$mdgriffith$elm_ui$Internal$Model$BorderWidth,
				'b-' + ($elm$core$String$fromInt(x) + ('-' + $elm$core$String$fromInt(y))),
				y,
				x,
				y,
				x));
	});
var $mdgriffith$elm_ui$Element$Border$widthEach = function (_v0) {
	var bottom = _v0.kx;
	var top = _v0.os;
	var left = _v0.me;
	var right = _v0.nA;
	return (_Utils_eq(top, bottom) && _Utils_eq(left, right)) ? (_Utils_eq(top, right) ? $mdgriffith$elm_ui$Element$Border$width(top) : A2($mdgriffith$elm_ui$Element$Border$widthXY, left, top)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderWidth,
		A5(
			$mdgriffith$elm_ui$Internal$Model$BorderWidth,
			'b-' + ($elm$core$String$fromInt(top) + ('-' + ($elm$core$String$fromInt(right) + ('-' + ($elm$core$String$fromInt(bottom) + ('-' + $elm$core$String$fromInt(left))))))),
			top,
			right,
			bottom,
			left));
};
var $author$project$PAM$UI$Select$defaultOptionListConfig = F2(
	function (config, args) {
		var maxHeight = 40;
		return {
			gV: $author$project$PAM$UI$Basic$white,
			hI: $author$project$PAM$UI$Basic$black,
			lB: A2($author$project$PAM$UI$Basic$scaleFont, config.w, -1),
			lI: A2($mdgriffith$elm_ui$Element$maximum, maxHeight, $mdgriffith$elm_ui$Element$shrink),
			ab: args.ab,
			h3: args.h3,
			mH: args.mH,
			mS: args.mS,
			f9: _List_Nil,
			m7: _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Border$widthEach(
					{kx: 1, me: 1, nA: 1, os: 1})
				]),
			a7: _Utils_update(
				$author$project$PAM$UI$Basic$edges,
				{kx: 4, os: 4}),
			P: args.P
		};
	});
var $author$project$PAM$UI$Select$defaultSelectConfig = F2(
	function (size, args) {
		return {
			d$: 3,
			kB: args.kB,
			la: args.la,
			l7: args.l7,
			m4: args.m4,
			m5: args.m5,
			iu: _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
				])
		};
	});
var $author$project$PAM$UI$Basic$is1080p = function (size) {
	return (size.jR >= 1920) || (size.lI >= 1080);
};
var $mdgriffith$elm_ui$Internal$Model$Above = 0;
var $mdgriffith$elm_ui$Internal$Model$Nearby = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$createNearby = F2(
	function (loc, element) {
		if (element.$ === 3) {
			return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
		} else {
			return A2($mdgriffith$elm_ui$Internal$Model$Nearby, loc, element);
		}
	});
var $mdgriffith$elm_ui$Element$above = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 0, element);
};
var $mdgriffith$elm_ui$Internal$Model$Below = 1;
var $mdgriffith$elm_ui$Element$below = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 1, element);
};
var $author$project$PAM$UI$Basic$corners = {g0: 0, g1: 0, jw: 0, jx: 0};
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $mdgriffith$elm_ui$Element$htmlAttribute = $mdgriffith$elm_ui$Internal$Model$Attr;
var $author$project$PAM$UI$Basic$id = function (idname) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2($elm$html$Html$Attributes$attribute, 'id', idname));
};
var $mdgriffith$elm_ui$Element$Border$roundEach = function (_v0) {
	var topLeft = _v0.jw;
	var topRight = _v0.jx;
	var bottomLeft = _v0.g0;
	var bottomRight = _v0.g1;
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$borderRound,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			'br-' + ($elm$core$String$fromInt(topLeft) + ('-' + ($elm$core$String$fromInt(topRight) + ($elm$core$String$fromInt(bottomLeft) + ('-' + $elm$core$String$fromInt(bottomRight)))))),
			'border-radius',
			$elm$core$String$fromInt(topLeft) + ('px ' + ($elm$core$String$fromInt(topRight) + ('px ' + ($elm$core$String$fromInt(bottomRight) + ('px ' + ($elm$core$String$fromInt(bottomLeft) + 'px'))))))));
};
var $mdgriffith$elm_ui$Internal$Model$Left = 0;
var $mdgriffith$elm_ui$Element$alignLeft = $mdgriffith$elm_ui$Internal$Model$AlignX(0);
var $author$project$PAM$UI$Basic$icon = function (className) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width(
				A2($mdgriffith$elm_ui$Element$minimum, 14, $mdgriffith$elm_ui$Element$fill)),
				$mdgriffith$elm_ui$Element$height(
				A2($mdgriffith$elm_ui$Element$minimum, 14, $mdgriffith$elm_ui$Element$shrink))
			]),
		$mdgriffith$elm_ui$Element$html(
			A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(className)
					]),
				_List_Nil)));
};
var $author$project$PAM$UI$Basic$centeredIcon = function (className) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY]),
		$author$project$PAM$UI$Basic$icon(className));
};
var $author$project$PAM$UI$Select$selectLabel = F2(
	function (labelConfig, openness) {
		var theIcon = function () {
			if (!openness) {
				return labelConfig.m3;
			} else {
				return labelConfig.kM;
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				labelConfig.iu),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$alignLeft,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					$mdgriffith$elm_ui$Element$text(labelConfig.h3)),
					function () {
					if (!theIcon.$) {
						var icon = theIcon.a;
						return $author$project$PAM$UI$Basic$centeredIcon(icon);
					} else {
						return $mdgriffith$elm_ui$Element$none;
					}
				}()
				]));
	});
var $author$project$PAM$UI$Select$selectButton = F2(
	function (_v0, openness) {
		var labelConfig = _v0.l7;
		var buttonConfig = _v0.kB;
		var borderRadius = _v0.d$;
		var direction = _v0.la;
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$PAM$UI$Basic$id(buttonConfig.ab),
						$mdgriffith$elm_ui$Element$width(buttonConfig.jR),
						$mdgriffith$elm_ui$Element$height(buttonConfig.lI),
						$mdgriffith$elm_ui$Element$paddingEach(buttonConfig.a7),
						$mdgriffith$elm_ui$Element$Font$size(buttonConfig.lB),
						$mdgriffith$elm_ui$Element$Font$color(buttonConfig.hI),
						$mdgriffith$elm_ui$Element$Background$color(buttonConfig.gV),
						function () {
						var _v1 = _Utils_Tuple2(direction, openness);
						if (!_v1.b) {
							if (!_v1.a) {
								var _v2 = _v1.a;
								var _v3 = _v1.b;
								return $mdgriffith$elm_ui$Element$Border$roundEach(
									_Utils_update(
										$author$project$PAM$UI$Basic$corners,
										{jw: borderRadius, jx: borderRadius}));
							} else {
								var _v4 = _v1.a;
								var _v5 = _v1.b;
								return $mdgriffith$elm_ui$Element$Border$roundEach(
									_Utils_update(
										$author$project$PAM$UI$Basic$corners,
										{g0: borderRadius, g1: borderRadius}));
							}
						} else {
							var _v6 = _v1.b;
							return $mdgriffith$elm_ui$Element$Border$rounded(borderRadius);
						}
					}()
					]),
				buttonConfig.iu),
			{
				h3: A2($author$project$PAM$UI$Select$selectLabel, labelConfig, openness),
				ip: buttonConfig.ip
			});
	});
var $mdgriffith$elm_ui$Element$Input$HiddenLabel = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Element$Input$labelHidden = $mdgriffith$elm_ui$Element$Input$HiddenLabel;
var $mdgriffith$elm_ui$Element$Events$onLoseFocus = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onBlur);
var $mdgriffith$elm_ui$Element$Input$Column = 1;
var $mdgriffith$elm_ui$Element$Input$AfterFound = 2;
var $mdgriffith$elm_ui$Element$Input$BeforeFound = 1;
var $mdgriffith$elm_ui$Element$Input$Idle = 0;
var $mdgriffith$elm_ui$Element$Input$NotFound = 0;
var $mdgriffith$elm_ui$Element$Input$Selected = 2;
var $mdgriffith$elm_ui$Internal$Model$LivePolite = {$: 6};
var $mdgriffith$elm_ui$Element$Region$announce = $mdgriffith$elm_ui$Internal$Model$Describe($mdgriffith$elm_ui$Internal$Model$LivePolite);
var $mdgriffith$elm_ui$Element$Input$applyLabel = F3(
	function (attrs, label, input) {
		if (label.$ === 1) {
			var labelText = label.a;
			return A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asColumn,
				$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
				attrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[input])));
		} else {
			var position = label.a;
			var labelAttrs = label.b;
			var labelChild = label.c;
			var labelElement = A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				labelAttrs,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[labelChild])));
			switch (position) {
				case 2:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.ev),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
				case 3:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asColumn,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.ev),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				case 0:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.ev),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[input, labelElement])));
				default:
					return A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asRow,
						$mdgriffith$elm_ui$Internal$Model$NodeName('label'),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.ev),
							attrs),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(
							_List_fromArray(
								[labelElement, input])));
			}
		}
	});
var $mdgriffith$elm_ui$Element$Input$column = F2(
	function (attributes, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asColumn,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					attributes)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Input$downArrow = 'ArrowDown';
var $mdgriffith$elm_ui$Internal$Model$filter = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (x, _v0) {
				var found = _v0.a;
				var has = _v0.b;
				switch (x.$) {
					case 0:
						return _Utils_Tuple2(found, has);
					case 3:
						var key = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 1:
						var attr = x.a;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 4:
						var style = x.b;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 7:
						var width = x.a;
						return A2($elm$core$Set$member, 'width', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'width', has));
					case 8:
						var height = x.a;
						return A2($elm$core$Set$member, 'height', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'height', has));
					case 2:
						var description = x.a;
						return A2($elm$core$Set$member, 'described', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'described', has));
					case 9:
						var location = x.a;
						var elem = x.b;
						return _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							has);
					case 6:
						return A2($elm$core$Set$member, 'align-x', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'align-x', has));
					case 5:
						return A2($elm$core$Set$member, 'align-y', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'align-y', has));
					default:
						return A2($elm$core$Set$member, 'transform', has) ? _Utils_Tuple2(found, has) : _Utils_Tuple2(
							A2($elm$core$List$cons, x, found),
							A2($elm$core$Set$insert, 'transform', has));
				}
			}),
		_Utils_Tuple2(_List_Nil, $elm$core$Set$empty),
		attrs).a;
};
var $mdgriffith$elm_ui$Internal$Model$get = F2(
	function (attrs, isAttr) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, found) {
					return isAttr(x) ? A2($elm$core$List$cons, x, found) : found;
				}),
			_List_Nil,
			$mdgriffith$elm_ui$Internal$Model$filter(attrs));
	});
var $mdgriffith$elm_ui$Internal$Model$Label = function (a) {
	return {$: 5, a: a};
};
var $mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute = function (label) {
	if (label.$ === 1) {
		var textLabel = label.a;
		return $mdgriffith$elm_ui$Internal$Model$Describe(
			$mdgriffith$elm_ui$Internal$Model$Label(textLabel));
	} else {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	}
};
var $mdgriffith$elm_ui$Element$Input$leftArrow = 'ArrowLeft';
var $mdgriffith$elm_ui$Element$Input$rightArrow = 'ArrowRight';
var $mdgriffith$elm_ui$Element$Input$row = F2(
	function (attributes, children) {
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asRow,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				attributes),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(children));
	});
var $mdgriffith$elm_ui$Element$Input$tabindex = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$tabindex);
var $mdgriffith$elm_ui$Element$Input$upArrow = 'ArrowUp';
var $mdgriffith$elm_ui$Element$Input$radioHelper = F3(
	function (orientation, attrs, input) {
		var track = F2(
			function (opt, _v14) {
				var found = _v14.a;
				var prev = _v14.b;
				var nxt = _v14.c;
				var val = opt.a;
				switch (found) {
					case 0:
						return _Utils_eq(
							$elm$core$Maybe$Just(val),
							input.P) ? _Utils_Tuple3(1, prev, nxt) : _Utils_Tuple3(found, val, nxt);
					case 1:
						return _Utils_Tuple3(2, prev, val);
					default:
						return _Utils_Tuple3(found, prev, nxt);
				}
			});
		var renderOption = function (_v11) {
			var val = _v11.a;
			var view = _v11.b;
			var status = _Utils_eq(
				$elm$core$Maybe$Just(val),
				input.P) ? 2 : 0;
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$pointer,
						function () {
						if (!orientation) {
							return $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink);
						} else {
							return $mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill);
						}
					}(),
						$mdgriffith$elm_ui$Element$Events$onClick(
						input.mH(val)),
						function () {
						if (status === 2) {
							return $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'aria-checked', 'true'));
						} else {
							return $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'aria-checked', 'false'));
						}
					}(),
						$mdgriffith$elm_ui$Internal$Model$Attr(
						A2($elm$html$Html$Attributes$attribute, 'role', 'radio'))
					]),
				view(status));
		};
		var prevNext = function () {
			var _v5 = input.m6;
			if (!_v5.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v6 = _v5.a;
				var val = _v6.a;
				return function (_v7) {
					var found = _v7.a;
					var b = _v7.b;
					var a = _v7.c;
					switch (found) {
						case 0:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, val));
						case 1:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, val));
						default:
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(b, a));
					}
				}(
					A3(
						$elm$core$List$foldl,
						track,
						_Utils_Tuple3(0, val, val),
						input.m6));
			}
		}();
		var optionArea = function () {
			if (!orientation) {
				return A2(
					$mdgriffith$elm_ui$Element$Input$row,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.h3),
						attrs),
					A2($elm$core$List$map, renderOption, input.m6));
			} else {
				return A2(
					$mdgriffith$elm_ui$Element$Input$column,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.h3),
						attrs),
					A2($elm$core$List$map, renderOption, input.m6));
			}
		}();
		var events = A2(
			$mdgriffith$elm_ui$Internal$Model$get,
			attrs,
			function (attr) {
				_v3$3:
				while (true) {
					switch (attr.$) {
						case 7:
							if (attr.a.$ === 2) {
								return true;
							} else {
								break _v3$3;
							}
						case 8:
							if (attr.a.$ === 2) {
								return true;
							} else {
								break _v3$3;
							}
						case 1:
							return true;
						default:
							break _v3$3;
					}
				}
				return false;
			});
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			_Utils_ap(
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							$elm$core$Maybe$Just($mdgriffith$elm_ui$Element$alignLeft),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Element$Input$tabindex(0)),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Internal$Model$htmlClass('focus')),
							$elm$core$Maybe$Just($mdgriffith$elm_ui$Element$Region$announce),
							$elm$core$Maybe$Just(
							$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'role', 'radiogroup'))),
							function () {
							if (prevNext.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var _v1 = prevNext.a;
								var prev = _v1.a;
								var next = _v1.b;
								return $elm$core$Maybe$Just(
									$mdgriffith$elm_ui$Element$Input$onKeyLookup(
										function (code) {
											if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$leftArrow)) {
												return $elm$core$Maybe$Just(
													input.mH(prev));
											} else {
												if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$upArrow)) {
													return $elm$core$Maybe$Just(
														input.mH(prev));
												} else {
													if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$rightArrow)) {
														return $elm$core$Maybe$Just(
															input.mH(next));
													} else {
														if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$downArrow)) {
															return $elm$core$Maybe$Just(
																input.mH(next));
														} else {
															if (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space)) {
																var _v2 = input.P;
																if (_v2.$ === 1) {
																	return $elm$core$Maybe$Just(
																		input.mH(prev));
																} else {
																	return $elm$core$Maybe$Nothing;
																}
															} else {
																return $elm$core$Maybe$Nothing;
															}
														}
													}
												}
											}
										}));
							}
						}()
						])),
				events),
			input.h3,
			optionArea);
	});
var $mdgriffith$elm_ui$Element$Input$radio = $mdgriffith$elm_ui$Element$Input$radioHelper(1);
var $mdgriffith$elm_ui$Element$scrollbarY = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$overflow, $mdgriffith$elm_ui$Internal$Style$classes.nJ);
var $mdgriffith$elm_ui$Internal$Model$Hover = 1;
var $mdgriffith$elm_ui$Internal$Model$PseudoSelector = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$hover = $mdgriffith$elm_ui$Internal$Flag$flag(33);
var $mdgriffith$elm_ui$Internal$Model$TransformComponent = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle = F2(
	function (fn, attr) {
		switch (attr.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
			case 2:
				var description = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Describe(description);
			case 6:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignX(x);
			case 5:
				var y = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignY(y);
			case 7:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Width(x);
			case 8:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Height(x);
			case 3:
				var x = attr.a;
				var y = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Class, x, y);
			case 4:
				var flag = attr.a;
				var style = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$StyleClass, flag, style);
			case 9:
				var location = attr.a;
				var elem = attr.b;
				return A2(
					$mdgriffith$elm_ui$Internal$Model$Nearby,
					location,
					A2($mdgriffith$elm_ui$Internal$Model$map, fn, elem));
			case 1:
				var htmlAttr = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$virtual_dom$VirtualDom$mapAttribute, fn, htmlAttr));
			default:
				var fl = attr.a;
				var trans = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$TransformComponent, fl, trans);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$removeNever = function (style) {
	return A2($mdgriffith$elm_ui$Internal$Model$mapAttrFromStyle, $elm$core$Basics$never, style);
};
var $mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper = F2(
	function (attr, _v0) {
		var styles = _v0.a;
		var trans = _v0.b;
		var _v1 = $mdgriffith$elm_ui$Internal$Model$removeNever(attr);
		switch (_v1.$) {
			case 4:
				var style = _v1.b;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, style, styles),
					trans);
			case 10:
				var flag = _v1.a;
				var component = _v1.b;
				return _Utils_Tuple2(
					styles,
					A2($mdgriffith$elm_ui$Internal$Model$composeTransformation, trans, component));
			default:
				return _Utils_Tuple2(styles, trans);
		}
	});
var $mdgriffith$elm_ui$Internal$Model$unwrapDecorations = function (attrs) {
	var _v0 = A3(
		$elm$core$List$foldl,
		$mdgriffith$elm_ui$Internal$Model$unwrapDecsHelper,
		_Utils_Tuple2(_List_Nil, $mdgriffith$elm_ui$Internal$Model$Untransformed),
		attrs);
	var styles = _v0.a;
	var transform = _v0.b;
	return A2(
		$elm$core$List$cons,
		$mdgriffith$elm_ui$Internal$Model$Transform(transform),
		styles);
};
var $mdgriffith$elm_ui$Element$mouseOver = function (decs) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$hover,
		A2(
			$mdgriffith$elm_ui$Internal$Model$PseudoSelector,
			1,
			$mdgriffith$elm_ui$Internal$Model$unwrapDecorations(decs)));
};
var $mdgriffith$elm_ui$Element$Input$Option = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$optionWith = F2(
	function (val, view) {
		return A2($mdgriffith$elm_ui$Element$Input$Option, val, view);
	});
var $author$project$PAM$UI$Select$selectOption = F2(
	function (optionConfig, option) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$optionWith,
			option,
			function (optState) {
				var stateAttrs = function () {
					switch (optState) {
						case 0:
							return optionConfig.fD;
						case 1:
							return optionConfig.fs;
						default:
							return optionConfig.nM;
					}
				}();
				return A2(
					$mdgriffith$elm_ui$Element$row,
					_Utils_ap(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(optionConfig.jR),
								$mdgriffith$elm_ui$Element$height(optionConfig.lI),
								$mdgriffith$elm_ui$Element$alignLeft,
								$mdgriffith$elm_ui$Element$paddingEach(optionConfig.a7),
								$mdgriffith$elm_ui$Element$mouseOver(optionConfig.ms)
							]),
						_Utils_ap(optionConfig.iu, stateAttrs)),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(
							optionConfig.op(option))
						]));
			});
	});
var $author$project$PAM$UI$Select$selectOptionList = F2(
	function (_v0, options) {
		var optionConfig = _v0.m4;
		var optionListConfig = _v0.m5;
		var borderRadius = _v0.d$;
		var direction = _v0.la;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(optionListConfig.lI),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$clip,
						$mdgriffith$elm_ui$Element$Font$size(optionListConfig.lB),
						$mdgriffith$elm_ui$Element$Font$color(optionListConfig.hI),
						$mdgriffith$elm_ui$Element$Background$color(optionListConfig.gV),
						function () {
						if (!direction) {
							return $mdgriffith$elm_ui$Element$Border$roundEach(
								_Utils_update(
									$author$project$PAM$UI$Basic$corners,
									{g0: borderRadius, g1: borderRadius}));
						} else {
							return $mdgriffith$elm_ui$Element$Border$roundEach(
								_Utils_update(
									$author$project$PAM$UI$Basic$corners,
									{jw: borderRadius, jx: borderRadius}));
						}
					}()
					]),
				optionListConfig.m7),
			A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$scrollbarY,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				A2(
					$mdgriffith$elm_ui$Element$Input$radio,
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$PAM$UI$Basic$id(optionListConfig.ab),
								$mdgriffith$elm_ui$Element$paddingEach(optionListConfig.a7),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$Events$onLoseFocus(optionListConfig.mS)
							]),
						optionListConfig.f9),
					{
						h3: $mdgriffith$elm_ui$Element$Input$labelHidden(optionListConfig.h3),
						mH: optionListConfig.mH,
						m6: A2(
							$elm$core$List$map,
							$author$project$PAM$UI$Select$selectOption(optionConfig),
							options),
						P: optionListConfig.P
					})));
	});
var $author$project$PAM$UI$Select$select = F3(
	function (config, openness, options) {
		var openFn = function () {
			var _v1 = config.la;
			if (!_v1) {
				return $mdgriffith$elm_ui$Element$below;
			} else {
				return $mdgriffith$elm_ui$Element$above;
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$el,
			function () {
				if (!openness) {
					return _Utils_ap(
						_List_fromArray(
							[
								openFn(
								A2($author$project$PAM$UI$Select$selectOptionList, config, options))
							]),
						config.iu);
				} else {
					return config.iu;
				}
			}(),
			A2($author$project$PAM$UI$Select$selectButton, config, openness));
	});
var $mdgriffith$elm_ui$Element$spacingXY = F2(
	function (x, y) {
		return A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$spacing,
			A3(
				$mdgriffith$elm_ui$Internal$Model$SpacingStyle,
				A2($mdgriffith$elm_ui$Internal$Model$spacingName, x, y),
				x,
				y));
	});
var $author$project$Grid$Grid$filterDropdown = F2(
	function (config, _v0) {
		var filterDropdownOpenness = _v0.bl;
		var filterColumn = _v0.lx;
		var options = A2(
			$elm$core$List$append,
			_List_fromArray(
				[
					$author$project$Grid$Grid$ColumnFilter('All')
				]),
			A2(
				$elm$core$List$map,
				function (t) {
					return $author$project$Grid$Grid$ColumnFilter(t.jr);
				},
				config.kO));
		var optionListConfig = A2(
			$author$project$PAM$UI$Select$defaultOptionListConfig,
			config,
			{
				ab: $author$project$Grid$Grid$inputIds.en,
				h3: 'Filter Options',
				mH: $author$project$Grid$Grid$FilterTypeChange,
				mS: $author$project$Grid$Grid$CloseFilterDropdown,
				P: $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Grid$Grid$ColumnFilter('All'),
						filterColumn))
			});
		var optionConfig = A2(
			$author$project$PAM$UI$Select$defaultOptionConfig,
			config.w,
			{
				op: function ($) {
					return $.jr;
				}
			});
		var labelConfig = {
			kM: $elm$core$Maybe$Just('fa fa-caret-down'),
			h3: A2(
				$elm$core$Maybe$withDefault,
				'All',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.jr;
					},
					filterColumn)),
			m3: $elm$core$Maybe$Just('fa fa-times'),
			iu: _List_fromArray(
				[
					A2($mdgriffith$elm_ui$Element$spacingXY, 6, 0)
				])
		};
		var buttonConfig = A2(
			$author$project$PAM$UI$Select$defaultButtonConfig,
			config.w,
			{
				lI: $mdgriffith$elm_ui$Element$fill,
				ab: $author$project$Grid$Grid$inputIds.hE,
				ip: $elm$core$Maybe$Just($author$project$Grid$Grid$ToggleFilterDropdown),
				jR: $author$project$PAM$UI$Basic$is1080p(config.w) ? A2($mdgriffith$elm_ui$Element$minimum, 256, $mdgriffith$elm_ui$Element$fill) : A2($mdgriffith$elm_ui$Element$minimum, 220, $mdgriffith$elm_ui$Element$fill)
			});
		var selectConfig = A2(
			$author$project$PAM$UI$Select$defaultSelectConfig,
			config.w,
			{kB: buttonConfig, la: 0, l7: labelConfig, m4: optionConfig, m5: optionListConfig});
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					$mdgriffith$elm_ui$Element$height(config.lI)
				]),
			A3($author$project$PAM$UI$Select$select, selectConfig, filterDropdownOpenness, options));
	});
var $author$project$PAM$UI$Basic$lunarGreen = A3($mdgriffith$elm_ui$Element$rgb255, 63, 67, 61);
var $mdgriffith$elm_ui$Internal$Model$FontFamily = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$fontFamily = $mdgriffith$elm_ui$Internal$Flag$flag(5);
var $elm$core$String$words = _String_words;
var $mdgriffith$elm_ui$Internal$Model$renderFontClassName = F2(
	function (font, current) {
		return _Utils_ap(
			current,
			function () {
				switch (font.$) {
					case 0:
						return 'serif';
					case 1:
						return 'sans-serif';
					case 2:
						return 'monospace';
					case 3:
						var name = font.a;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					case 4:
						var name = font.a;
						var url = font.b;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
					default:
						var name = font.a.dz;
						return A2(
							$elm$core$String$join,
							'-',
							$elm$core$String$words(
								$elm$core$String$toLower(name)));
				}
			}());
	});
var $mdgriffith$elm_ui$Element$Font$family = function (families) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$fontFamily,
		A2(
			$mdgriffith$elm_ui$Internal$Model$FontFamily,
			A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'ff-', families),
			families));
};
var $mdgriffith$elm_ui$Internal$Model$SansSerif = {$: 1};
var $mdgriffith$elm_ui$Element$Font$sansSerif = $mdgriffith$elm_ui$Internal$Model$SansSerif;
var $mdgriffith$elm_ui$Internal$Model$Typeface = function (a) {
	return {$: 3, a: a};
};
var $mdgriffith$elm_ui$Element$Font$typeface = $mdgriffith$elm_ui$Internal$Model$Typeface;
var $author$project$PAM$UI$Basic$montserrat = $mdgriffith$elm_ui$Element$Font$family(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Font$typeface('Montserrat'),
			$mdgriffith$elm_ui$Element$Font$sansSerif
		]));
var $mdgriffith$elm_ui$Element$Input$Placeholder = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$placeholder = $mdgriffith$elm_ui$Element$Input$Placeholder;
var $mdgriffith$elm_ui$Element$Font$semiBold = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontWeight, $mdgriffith$elm_ui$Internal$Style$classes.oj);
var $mdgriffith$elm_ui$Element$Input$TextInputNode = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$Input$TextArea = {$: 1};
var $mdgriffith$elm_ui$Element$Input$autofill = A2(
	$elm$core$Basics$composeL,
	$mdgriffith$elm_ui$Internal$Model$Attr,
	$elm$html$Html$Attributes$attribute('autocomplete'));
var $mdgriffith$elm_ui$Internal$Model$Behind = 5;
var $mdgriffith$elm_ui$Element$behindContent = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 5, element);
};
var $mdgriffith$elm_ui$Internal$Model$MoveY = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$moveY = $mdgriffith$elm_ui$Internal$Flag$flag(26);
var $mdgriffith$elm_ui$Element$moveUp = function (y) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveY,
		$mdgriffith$elm_ui$Internal$Model$MoveY(-y));
};
var $mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding = function (attrs) {
	var gatherSpacing = F2(
		function (attr, found) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v2 = attr.b;
				var x = _v2.b;
				var y = _v2.c;
				if (found.$ === 1) {
					return $elm$core$Maybe$Just(y);
				} else {
					return found;
				}
			} else {
				return found;
			}
		});
	var _v0 = A3($elm$core$List$foldr, gatherSpacing, $elm$core$Maybe$Nothing, attrs);
	if (_v0.$ === 1) {
		return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
	} else {
		var vSpace = _v0.a;
		return $mdgriffith$elm_ui$Element$moveUp(
			$elm$core$Basics$floor(vSpace / 2));
	}
};
var $mdgriffith$elm_ui$Element$rgb = F3(
	function (r, g, b) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, r, g, b, 1);
	});
var $mdgriffith$elm_ui$Element$Input$darkGrey = A3($mdgriffith$elm_ui$Element$rgb, 186 / 255, 189 / 255, 182 / 255);
var $mdgriffith$elm_ui$Element$Input$defaultTextPadding = A2($mdgriffith$elm_ui$Element$paddingXY, 12, 12);
var $mdgriffith$elm_ui$Element$Input$white = A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1);
var $mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$Input$defaultTextPadding,
		$mdgriffith$elm_ui$Element$Border$rounded(3),
		$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$darkGrey),
		$mdgriffith$elm_ui$Element$Background$color($mdgriffith$elm_ui$Element$Input$white),
		$mdgriffith$elm_ui$Element$Border$width(1),
		$mdgriffith$elm_ui$Element$spacing(5),
		$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
		$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
	]);
var $mdgriffith$elm_ui$Element$Input$getHeight = function (attr) {
	if (attr.$ === 8) {
		var h = attr.a;
		return $elm$core$Maybe$Just(h);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $mdgriffith$elm_ui$Internal$Model$InFront = 4;
var $mdgriffith$elm_ui$Element$inFront = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 4, element);
};
var $mdgriffith$elm_ui$Element$Input$isConstrained = function (len) {
	isConstrained:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return true;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isConstrained;
			default:
				var l = len.b;
				return true;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isHiddenLabel = function (label) {
	if (label.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $mdgriffith$elm_ui$Element$Input$isStacked = function (label) {
	if (!label.$) {
		var loc = label.a;
		switch (loc) {
			case 0:
				return false;
			case 1:
				return false;
			case 2:
				return true;
			default:
				return true;
		}
	} else {
		return true;
	}
};
var $mdgriffith$elm_ui$Element$Input$negateBox = function (box) {
	return {kx: -box.kx, me: -box.me, nA: -box.nA, os: -box.os};
};
var $mdgriffith$elm_ui$Element$Input$isFill = function (len) {
	isFill:
	while (true) {
		switch (len.$) {
			case 2:
				return true;
			case 1:
				return false;
			case 0:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isFill;
		}
	}
};
var $mdgriffith$elm_ui$Element$Input$isPixel = function (len) {
	isPixel:
	while (true) {
		switch (len.$) {
			case 1:
				return false;
			case 0:
				return true;
			case 2:
				return false;
			case 3:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
			default:
				var l = len.b;
				var $temp$len = l;
				len = $temp$len;
				continue isPixel;
		}
	}
};
var $mdgriffith$elm_ui$Internal$Model$paddingNameFloat = F4(
	function (top, right, bottom, left) {
		return 'pad-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(top) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(right) + ('-' + ($mdgriffith$elm_ui$Internal$Model$floatClass(bottom) + ('-' + $mdgriffith$elm_ui$Internal$Model$floatClass(left)))))));
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $mdgriffith$elm_ui$Element$Input$redistributeOver = F4(
	function (isMultiline, stacked, attr, els) {
		switch (attr.$) {
			case 9:
				return _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					});
			case 7:
				var width = attr.a;
				return $mdgriffith$elm_ui$Element$Input$isFill(width) ? _Utils_update(
					els,
					{
						y: A2($elm$core$List$cons, attr, els.y),
						E: A2($elm$core$List$cons, attr, els.E),
						j: A2($elm$core$List$cons, attr, els.j)
					}) : (stacked ? _Utils_update(
					els,
					{
						y: A2($elm$core$List$cons, attr, els.y)
					}) : _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					}));
			case 8:
				var height = attr.a;
				return (!stacked) ? _Utils_update(
					els,
					{
						y: A2($elm$core$List$cons, attr, els.y),
						j: A2($elm$core$List$cons, attr, els.j)
					}) : ($mdgriffith$elm_ui$Element$Input$isFill(height) ? _Utils_update(
					els,
					{
						y: A2($elm$core$List$cons, attr, els.y),
						j: A2($elm$core$List$cons, attr, els.j)
					}) : ($mdgriffith$elm_ui$Element$Input$isPixel(height) ? _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					}) : _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					})));
			case 6:
				return _Utils_update(
					els,
					{
						y: A2($elm$core$List$cons, attr, els.y)
					});
			case 5:
				return _Utils_update(
					els,
					{
						y: A2($elm$core$List$cons, attr, els.y)
					});
			case 4:
				switch (attr.b.$) {
					case 5:
						var _v1 = attr.b;
						return _Utils_update(
							els,
							{
								y: A2($elm$core$List$cons, attr, els.y),
								E: A2($elm$core$List$cons, attr, els.E),
								j: A2($elm$core$List$cons, attr, els.j),
								c7: A2($elm$core$List$cons, attr, els.c7)
							});
					case 7:
						var cls = attr.a;
						var _v2 = attr.b;
						var pad = _v2.a;
						var t = _v2.b;
						var r = _v2.c;
						var b = _v2.d;
						var l = _v2.e;
						if (isMultiline) {
							return _Utils_update(
								els,
								{
									ai: A2($elm$core$List$cons, attr, els.ai),
									j: A2($elm$core$List$cons, attr, els.j)
								});
						} else {
							var newTop = t - A2($elm$core$Basics$min, t, b);
							var newLineHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'line-height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newHeight = $mdgriffith$elm_ui$Element$htmlAttribute(
								A2(
									$elm$html$Html$Attributes$style,
									'height',
									'calc(1.0em + ' + ($elm$core$String$fromFloat(
										2 * A2($elm$core$Basics$min, t, b)) + 'px)')));
							var newBottom = b - A2($elm$core$Basics$min, t, b);
							var reducedVerticalPadding = A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$padding,
								A5(
									$mdgriffith$elm_ui$Internal$Model$PaddingStyle,
									A4($mdgriffith$elm_ui$Internal$Model$paddingNameFloat, newTop, r, newBottom, l),
									newTop,
									r,
									newBottom,
									l));
							return _Utils_update(
								els,
								{
									ai: A2($elm$core$List$cons, attr, els.ai),
									E: A2(
										$elm$core$List$cons,
										newHeight,
										A2($elm$core$List$cons, newLineHeight, els.E)),
									j: A2($elm$core$List$cons, reducedVerticalPadding, els.j)
								});
						}
					case 6:
						var _v3 = attr.b;
						return _Utils_update(
							els,
							{
								ai: A2($elm$core$List$cons, attr, els.ai),
								j: A2($elm$core$List$cons, attr, els.j)
							});
					case 10:
						return _Utils_update(
							els,
							{
								ai: A2($elm$core$List$cons, attr, els.ai),
								j: A2($elm$core$List$cons, attr, els.j)
							});
					case 2:
						return _Utils_update(
							els,
							{
								y: A2($elm$core$List$cons, attr, els.y)
							});
					case 1:
						var _v4 = attr.b;
						return _Utils_update(
							els,
							{
								y: A2($elm$core$List$cons, attr, els.y)
							});
					default:
						var flag = attr.a;
						var cls = attr.b;
						return _Utils_update(
							els,
							{
								j: A2($elm$core$List$cons, attr, els.j)
							});
				}
			case 0:
				return els;
			case 1:
				var a = attr.a;
				return _Utils_update(
					els,
					{
						E: A2($elm$core$List$cons, attr, els.E)
					});
			case 2:
				return _Utils_update(
					els,
					{
						E: A2($elm$core$List$cons, attr, els.E)
					});
			case 3:
				return _Utils_update(
					els,
					{
						j: A2($elm$core$List$cons, attr, els.j)
					});
			default:
				return _Utils_update(
					els,
					{
						E: A2($elm$core$List$cons, attr, els.E)
					});
		}
	});
var $mdgriffith$elm_ui$Element$Input$redistribute = F3(
	function (isMultiline, stacked, attrs) {
		return function (redist) {
			return {
				ai: $elm$core$List$reverse(redist.ai),
				y: $elm$core$List$reverse(redist.y),
				E: $elm$core$List$reverse(redist.E),
				j: $elm$core$List$reverse(redist.j),
				c7: $elm$core$List$reverse(redist.c7)
			};
		}(
			A3(
				$elm$core$List$foldl,
				A2($mdgriffith$elm_ui$Element$Input$redistributeOver, isMultiline, stacked),
				{ai: _List_Nil, y: _List_Nil, E: _List_Nil, j: _List_Nil, c7: _List_Nil},
				attrs));
	});
var $mdgriffith$elm_ui$Element$Input$renderBox = function (_v0) {
	var top = _v0.os;
	var right = _v0.nA;
	var bottom = _v0.kx;
	var left = _v0.me;
	return $elm$core$String$fromInt(top) + ('px ' + ($elm$core$String$fromInt(right) + ('px ' + ($elm$core$String$fromInt(bottom) + ('px ' + ($elm$core$String$fromInt(left) + 'px'))))));
};
var $mdgriffith$elm_ui$Internal$Model$Transparency = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$transparency = $mdgriffith$elm_ui$Internal$Flag$flag(0);
var $mdgriffith$elm_ui$Element$alpha = function (o) {
	var transparency = function (x) {
		return 1 - x;
	}(
		A2(
			$elm$core$Basics$min,
			1.0,
			A2($elm$core$Basics$max, 0.0, o)));
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Transparency,
			'transparency-' + $mdgriffith$elm_ui$Internal$Model$floatClass(transparency),
			transparency));
};
var $mdgriffith$elm_ui$Element$Input$charcoal = A3($mdgriffith$elm_ui$Element$rgb, 136 / 255, 138 / 255, 133 / 255);
var $mdgriffith$elm_ui$Element$Input$renderPlaceholder = F3(
	function (_v0, forPlaceholder, on) {
		var placeholderAttrs = _v0.a;
		var placeholderEl = _v0.b;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_Utils_ap(
				forPlaceholder,
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$charcoal),
							$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.$9 + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.nb)),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$Border$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$Background$color(
							A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0)),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$alpha(
							on ? 1 : 0)
						]),
					placeholderAttrs)),
			placeholderEl);
	});
var $elm$html$Html$Attributes$spellcheck = $elm$html$Html$Attributes$boolProperty('spellcheck');
var $mdgriffith$elm_ui$Element$Input$spellcheck = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$spellcheck);
var $mdgriffith$elm_ui$Element$Input$value = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Attributes$value);
var $mdgriffith$elm_ui$Element$Input$textHelper = F3(
	function (textInput, attrs, textOptions) {
		var withDefaults = _Utils_ap($mdgriffith$elm_ui$Element$Input$defaultTextBoxStyle, attrs);
		var redistributed = A3(
			$mdgriffith$elm_ui$Element$Input$redistribute,
			_Utils_eq(textInput.jE, $mdgriffith$elm_ui$Element$Input$TextArea),
			$mdgriffith$elm_ui$Element$Input$isStacked(textOptions.h3),
			withDefaults);
		var onlySpacing = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 5)) {
				var _v9 = attr.b;
				return true;
			} else {
				return false;
			}
		};
		var heightConstrained = function () {
			var _v7 = textInput.jE;
			if (!_v7.$) {
				var inputType = _v7.a;
				return false;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$mdgriffith$elm_ui$Element$Input$isConstrained,
						$elm$core$List$head(
							$elm$core$List$reverse(
								A2($elm$core$List$filterMap, $mdgriffith$elm_ui$Element$Input$getHeight, withDefaults)))));
			}
		}();
		var getPadding = function (attr) {
			if ((attr.$ === 4) && (attr.b.$ === 7)) {
				var cls = attr.a;
				var _v6 = attr.b;
				var pad = _v6.a;
				var t = _v6.b;
				var r = _v6.c;
				var b = _v6.d;
				var l = _v6.e;
				return $elm$core$Maybe$Just(
					{
						kx: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(b - 3)),
						me: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(l - 3)),
						nA: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(r - 3)),
						os: A2(
							$elm$core$Basics$max,
							0,
							$elm$core$Basics$floor(t - 3))
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var parentPadding = A2(
			$elm$core$Maybe$withDefault,
			{kx: 0, me: 0, nA: 0, os: 0},
			$elm$core$List$head(
				$elm$core$List$reverse(
					A2($elm$core$List$filterMap, getPadding, withDefaults))));
		var inputElement = A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			function () {
				var _v3 = textInput.jE;
				if (!_v3.$) {
					var inputType = _v3.a;
					return $mdgriffith$elm_ui$Internal$Model$NodeName('input');
				} else {
					return $mdgriffith$elm_ui$Internal$Model$NodeName('textarea');
				}
			}(),
			_Utils_ap(
				function () {
					var _v4 = textInput.jE;
					if (!_v4.$) {
						var inputType = _v4.a;
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$type_(inputType)),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.aL)
							]);
					} else {
						return _List_fromArray(
							[
								$mdgriffith$elm_ui$Element$clip,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.lX),
								$mdgriffith$elm_ui$Element$Input$calcMoveToCompensateForPadding(withDefaults),
								$mdgriffith$elm_ui$Element$paddingEach(parentPadding),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2(
									$elm$html$Html$Attributes$style,
									'margin',
									$mdgriffith$elm_ui$Element$Input$renderBox(
										$mdgriffith$elm_ui$Element$Input$negateBox(parentPadding)))),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$style, 'box-sizing', 'content-box'))
							]);
					}
				}(),
				_Utils_ap(
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Input$value(textOptions.n8),
							$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Events$onInput(textOptions.mH)),
							$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(textOptions.h3),
							$mdgriffith$elm_ui$Element$Input$spellcheck(textInput.aW),
							A2(
							$elm$core$Maybe$withDefault,
							$mdgriffith$elm_ui$Internal$Model$NoAttribute,
							A2($elm$core$Maybe$map, $mdgriffith$elm_ui$Element$Input$autofill, textInput.aH))
						]),
					redistributed.E)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil));
		var wrappedInput = function () {
			var _v0 = textInput.jE;
			if (_v0.$ === 1) {
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					_Utils_ap(
						(heightConstrained ? $elm$core$List$cons($mdgriffith$elm_ui$Element$scrollbarY) : $elm$core$Basics$identity)(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hH),
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.l_)
								])),
						redistributed.j),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[
								A4(
								$mdgriffith$elm_ui$Internal$Model$element,
								$mdgriffith$elm_ui$Internal$Model$asParagraph,
								$mdgriffith$elm_ui$Internal$Model$div,
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									A2(
										$elm$core$List$cons,
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										A2(
											$elm$core$List$cons,
											$mdgriffith$elm_ui$Element$inFront(inputElement),
											A2(
												$elm$core$List$cons,
												$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.lZ),
												redistributed.c7)))),
								$mdgriffith$elm_ui$Internal$Model$Unkeyed(
									function () {
										if (textOptions.n8 === '') {
											var _v1 = textOptions.nd;
											if (_v1.$ === 1) {
												return _List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text('\u00A0')
													]);
											} else {
												var place = _v1.a;
												return _List_fromArray(
													[
														A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, _List_Nil, textOptions.n8 === '')
													]);
											}
										} else {
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Internal$Model$unstyled(
													A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class($mdgriffith$elm_ui$Internal$Style$classes.lY)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(textOptions.n8 + '\u00A0')
															])))
												]);
										}
									}()))
							])));
			} else {
				var inputType = _v0.a;
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						A2(
							$elm$core$List$cons,
							A2($elm$core$List$any, $mdgriffith$elm_ui$Element$Input$hasFocusStyle, withDefaults) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.hH),
							$elm$core$List$concat(
								_List_fromArray(
									[
										redistributed.j,
										function () {
										var _v2 = textOptions.nd;
										if (_v2.$ === 1) {
											return _List_Nil;
										} else {
											var place = _v2.a;
											return _List_fromArray(
												[
													$mdgriffith$elm_ui$Element$behindContent(
													A3($mdgriffith$elm_ui$Element$Input$renderPlaceholder, place, redistributed.ai, textOptions.n8 === ''))
												]);
										}
									}()
									])))),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[inputElement])));
			}
		}();
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$cursor, $mdgriffith$elm_ui$Internal$Style$classes.k0),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(textOptions.h3) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(5),
					A2($elm$core$List$cons, $mdgriffith$elm_ui$Element$Region$announce, redistributed.y))),
			textOptions.h3,
			wrappedInput);
	});
var $mdgriffith$elm_ui$Element$Input$text = $mdgriffith$elm_ui$Element$Input$textHelper(
	{
		aH: $elm$core$Maybe$Nothing,
		aW: false,
		jE: $mdgriffith$elm_ui$Element$Input$TextInputNode('text')
	});
var $author$project$Grid$Grid$filterView = F2(
	function (config, model) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spacing(10),
					$mdgriffith$elm_ui$Element$height(config.lI),
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(config.lB),
							$mdgriffith$elm_ui$Element$Font$semiBold,
							$author$project$PAM$UI$Basic$montserrat,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							$mdgriffith$elm_ui$Element$centerY
						]),
					$mdgriffith$elm_ui$Element$text('Filter By')),
					A2($author$project$Grid$Grid$filterDropdown, config, model),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$padding(0),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(config.lI),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$centerY
						]),
					A2(
						$mdgriffith$elm_ui$Element$Input$text,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height(config.lI),
								A2($mdgriffith$elm_ui$Element$paddingXY, 12, 0),
								$mdgriffith$elm_ui$Element$Font$size(config.lB),
								$mdgriffith$elm_ui$Element$centerY,
								$mdgriffith$elm_ui$Element$htmlAttribute(
								$elm$html$Html$Attributes$class('centerInputHack')),
								$mdgriffith$elm_ui$Element$Border$color($author$project$PAM$UI$Basic$lunarGreen)
							]),
						{
							h3: $mdgriffith$elm_ui$Element$Input$labelHidden('Search By'),
							mH: $author$project$Grid$Grid$FilterTextChange,
							nd: $elm$core$Maybe$Just(
								A2(
									$mdgriffith$elm_ui$Element$Input$placeholder,
									_List_fromArray(
										[
											A2($mdgriffith$elm_ui$Element$paddingXY, 12, 0),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
											$mdgriffith$elm_ui$Element$centerY
										]),
									A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$Font$color(
												A2($author$project$PAM$UI$Basic$fadeColor, 0.5, $author$project$PAM$UI$Basic$black))
											]),
										$mdgriffith$elm_ui$Element$text('Enter a value to filter by')))),
							n8: A2($elm$core$Maybe$withDefault, '', model.gg)
						}))
				]));
	});
var $author$project$CWS$Approver$ParticipatingEntities$gridHeaderSize = 30;
var $author$project$Grid$Grid$filterColumns = F3(
	function (model, columnDefs, data) {
		var _v0 = model.gg;
		if (!_v0.$) {
			var search = _v0.a;
			var lowerSearch = $elm$core$String$toLower(search);
			var columns = function () {
				var _v3 = model.lx;
				if (!_v3.$) {
					var column = _v3.a;
					return A2(
						$elm$core$List$filter,
						function (a) {
							return _Utils_eq(a.jr, column.jr);
						},
						columnDefs);
				} else {
					return columnDefs;
				}
			}();
			return A2(
				$elm$core$List$filter,
				function (item) {
					return A2(
						$elm$core$List$any,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$map,
							function (column) {
								return A2(
									$elm$core$String$contains,
									lowerSearch,
									function () {
										var _v1 = column.a1;
										switch (_v1.$) {
											case 0:
												var getter = _v1.a;
												return $elm$core$String$toLower(
													getter(item));
											case 1:
												var getter = _v1.a;
												return $elm$core$String$fromInt(
													getter(item));
											case 2:
												var getter = _v1.a;
												return $elm$core$String$fromFloat(
													getter(item));
											default:
												var getter = _v1.a;
												var _v2 = getter(item);
												var searchable = _v2.b;
												return $elm$core$String$toLower(searchable);
										}
									}());
							},
							columns));
				},
				data);
		} else {
			return data;
		}
	});
var $author$project$PAM$UI$Basic$doveGray = A3($mdgriffith$elm_ui$Element$rgb255, 103, 103, 103);
var $author$project$PAM$UI$Basic$helvetica = $mdgriffith$elm_ui$Element$Font$family(
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$Font$typeface('Helvetica'),
			$mdgriffith$elm_ui$Element$Font$sansSerif
		]));
var $mdgriffith$elm_ui$Internal$Model$Px = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Element$px = $mdgriffith$elm_ui$Internal$Model$Px;
var $author$project$PAM$UI$Basic$satinLinen = A3($mdgriffith$elm_ui$Element$rgb255, 230, 232, 214);
var $author$project$Grid$Grid$tableDataTitle = F2(
	function (getter, item) {
		switch (getter.$) {
			case 0:
				var get = getter.a;
				return get(item);
			case 1:
				var get = getter.a;
				return $elm$core$String$fromInt(
					get(item));
			case 2:
				var get = getter.a;
				return $elm$core$String$fromFloat(
					get(item));
			default:
				var get = getter.a;
				return get(item).b;
		}
	});
var $author$project$Grid$Grid$SpitOut = function (a) {
	return {$: 15, a: a};
};
var $author$project$Grid$Grid$tableDataUi = F2(
	function (getter, item) {
		switch (getter.$) {
			case 0:
				var get = getter.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerY]),
					$mdgriffith$elm_ui$Element$text(
						get(item)));
			case 1:
				var get = getter.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerY]),
					$mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromInt(
							get(item))));
			case 2:
				var get = getter.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerY]),
					$mdgriffith$elm_ui$Element$text(
						$elm$core$String$fromFloat(
							get(item))));
			default:
				var get = getter.a;
				return A2(
					$mdgriffith$elm_ui$Element$map,
					$author$project$Grid$Grid$SpitOut,
					get(item).a);
		}
	});
var $author$project$PAM$UI$Basic$title = function (data) {
	return $mdgriffith$elm_ui$Element$htmlAttribute(
		A2($elm$html$Html$Attributes$attribute, 'title', data));
};
var $author$project$Grid$Grid$tableCellUi = F6(
	function (config, rowHeight, sort, _v0, index, item) {
		var getter = _v0.a1;
		var bgColor = (!A2($elm$core$Basics$modBy, 2, index)) ? $author$project$PAM$UI$Basic$white : $author$project$PAM$UI$Basic$satinLinen;
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$author$project$PAM$UI$Basic$title(
					A2($author$project$Grid$Grid$tableDataTitle, getter, item)),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(rowHeight)),
					A2($mdgriffith$elm_ui$Element$paddingXY, 5, 0),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
					$mdgriffith$elm_ui$Element$Background$color(bgColor),
					$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$doveGray),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, config.w, 1)),
					$author$project$PAM$UI$Basic$helvetica
				]),
			A2($author$project$Grid$Grid$tableDataUi, getter, item));
	});
var $author$project$Grid$Grid$SortBy = function (a) {
	return {$: 1, a: a};
};
var $author$project$Grid$Grid$sortByIconClass = F2(
	function (sort, definition) {
		switch (sort.$) {
			case 0:
				return '';
			case 1:
				var col = sort.a;
				return _Utils_eq(definition.jr, col) ? 'fa fa-sort-up' : '';
			default:
				var col = sort.a;
				return _Utils_eq(definition.jr, col) ? 'fa fa-sort-down' : '';
		}
	});
var $author$project$Grid$Grid$tableHeaderUi = F4(
	function (config, rowHeight, sort, definition) {
		var sortClass = A2($author$project$Grid$Grid$sortByIconClass, sort, definition);
		var btnTitle = function () {
			switch (sort.$) {
				case 0:
					return 'Sort ascending (' + (definition.jr + ')');
				case 1:
					var a = sort.a;
					return 'Sort descending (' + (definition.jr + ')');
				default:
					var a = sort.a;
					return 'Clear sort (' + (definition.jr + ')');
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$pineTree),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(rowHeight)),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 5, 0),
					$author$project$PAM$UI$Basic$title(btnTitle)
				]),
			{
				h3: A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							A2($mdgriffith$elm_ui$Element$spacingXY, 5, 0),
							$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, config.w, 1)),
							$author$project$PAM$UI$Basic$helvetica,
							$mdgriffith$elm_ui$Element$Font$bold
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(definition.jr),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[$mdgriffith$elm_ui$Element$alignLeft, $mdgriffith$elm_ui$Element$centerY]),
							$author$project$PAM$UI$Basic$icon(sortClass))
						])),
				ip: $elm$core$Maybe$Just(
					$author$project$Grid$Grid$SortBy(definition.jr))
			});
	});
var $author$project$Grid$Grid$columnDefToColumn = F3(
	function (config, sort, definition) {
		var rowHeight = A3(
			$author$project$PAM$UI$Basic$adjustOnHeight,
			config.w,
			config.Z,
			_Utils_Tuple2(22, 31));
		return {
			hN: A4($author$project$Grid$Grid$tableHeaderUi, config, rowHeight, sort, definition),
			oH: A4($author$project$Grid$Grid$tableCellUi, config, rowHeight, sort, definition),
			jR: definition.jR
		};
	});
var $author$project$Grid$Grid$getSorter = F3(
	function (model, columnDefs, by) {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (a) {
					return _Utils_eq(a.jr, by);
				},
				columnDefs));
		if (!_v0.$) {
			var column = _v0.a;
			return $elm$core$Maybe$Just(column.aD);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Grid$Grid$getSortedDataFrom = F3(
	function (model, columnDefs, data) {
		var _v0 = model.aD;
		switch (_v0.$) {
			case 0:
				return data;
			case 1:
				var by = _v0.a;
				var gotted_sorter = A3($author$project$Grid$Grid$getSorter, model, columnDefs, by);
				if (!gotted_sorter.$) {
					var sorter = gotted_sorter.a;
					return sorter.aP(data);
				} else {
					return data;
				}
			default:
				var by = _v0.a;
				var gotted_sorter = A3($author$project$Grid$Grid$getSorter, model, columnDefs, by);
				return $elm$core$List$reverse(
					function () {
						if (!gotted_sorter.$) {
							var sorter = gotted_sorter.a;
							return sorter.aP(data);
						} else {
							return data;
						}
					}());
		}
	});
var $author$project$Grid$Grid$getRenderDataFrom = F3(
	function (model, columnDefs, data) {
		return A2(
			$elm$core$List$take,
			model.l5,
			A2(
				$elm$core$List$drop,
				model.k_ * model.l5,
				A3($author$project$Grid$Grid$getSortedDataFrom, model, columnDefs, data)));
	});
var $mdgriffith$elm_ui$Element$InternalIndexedColumn = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$GridPosition = function (a) {
	return {$: 9, a: a};
};
var $mdgriffith$elm_ui$Internal$Model$GridTemplateStyle = function (a) {
	return {$: 8, a: a};
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $mdgriffith$elm_ui$Internal$Model$AsGrid = 3;
var $mdgriffith$elm_ui$Internal$Model$asGrid = 3;
var $mdgriffith$elm_ui$Internal$Model$getSpacing = F2(
	function (attrs, _default) {
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A3(
				$elm$core$List$foldr,
				F2(
					function (attr, acc) {
						if (!acc.$) {
							var x = acc.a;
							return $elm$core$Maybe$Just(x);
						} else {
							if ((attr.$ === 4) && (attr.b.$ === 5)) {
								var _v2 = attr.b;
								var x = _v2.b;
								var y = _v2.c;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(x, y));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}),
				$elm$core$Maybe$Nothing,
				attrs));
	});
var $mdgriffith$elm_ui$Internal$Flag$gridPosition = $mdgriffith$elm_ui$Internal$Flag$flag(35);
var $mdgriffith$elm_ui$Internal$Flag$gridTemplate = $mdgriffith$elm_ui$Internal$Flag$flag(34);
var $mdgriffith$elm_ui$Element$tableHelper = F2(
	function (attrs, config) {
		var onGrid = F3(
			function (rowLevel, columnLevel, elem) {
				return A4(
					$mdgriffith$elm_ui$Internal$Model$element,
					$mdgriffith$elm_ui$Internal$Model$asEl,
					$mdgriffith$elm_ui$Internal$Model$div,
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Internal$Model$StyleClass,
							$mdgriffith$elm_ui$Internal$Flag$gridPosition,
							$mdgriffith$elm_ui$Internal$Model$GridPosition(
								{hc: columnLevel, lI: 1, i0: rowLevel, jR: 1}))
						]),
					$mdgriffith$elm_ui$Internal$Model$Unkeyed(
						_List_fromArray(
							[elem])));
			});
		var columnWidth = function (col) {
			if (!col.$) {
				var colConfig = col.a;
				return colConfig.jR;
			} else {
				var colConfig = col.a;
				return colConfig.jR;
			}
		};
		var columnHeader = function (col) {
			if (!col.$) {
				var colConfig = col.a;
				return colConfig.hN;
			} else {
				var colConfig = col.a;
				return colConfig.hN;
			}
		};
		var maybeHeaders = function (headers) {
			return A2(
				$elm$core$List$all,
				$elm$core$Basics$eq($mdgriffith$elm_ui$Internal$Model$Empty),
				headers) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (col, header) {
							return A3(onGrid, 1, col + 1, header);
						}),
					headers));
		}(
			A2($elm$core$List$map, columnHeader, config.kP));
		var add = F3(
			function (cell, columnConfig, cursor) {
				if (!columnConfig.$) {
					var col = columnConfig.a;
					return _Utils_update(
						cursor,
						{
							bi: cursor.bi + 1,
							a0: A2(
								$elm$core$List$cons,
								A3(
									onGrid,
									cursor.i0,
									cursor.bi,
									A2(
										col.oH,
										_Utils_eq(maybeHeaders, $elm$core$Maybe$Nothing) ? (cursor.i0 - 1) : (cursor.i0 - 2),
										cell)),
								cursor.a0)
						});
				} else {
					var col = columnConfig.a;
					return {
						bi: cursor.bi + 1,
						a0: A2(
							$elm$core$List$cons,
							A3(
								onGrid,
								cursor.i0,
								cursor.bi,
								col.oH(cell)),
							cursor.a0),
						i0: cursor.i0
					};
				}
			});
		var build = F3(
			function (columns, rowData, cursor) {
				var newCursor = A3(
					$elm$core$List$foldl,
					add(rowData),
					cursor,
					columns);
				return {bi: 1, a0: newCursor.a0, i0: cursor.i0 + 1};
			});
		var children = A3(
			$elm$core$List$foldl,
			build(config.kP),
			{
				bi: 1,
				a0: _List_Nil,
				i0: _Utils_eq(maybeHeaders, $elm$core$Maybe$Nothing) ? 1 : 2
			},
			config.k1);
		var _v0 = A2(
			$mdgriffith$elm_ui$Internal$Model$getSpacing,
			attrs,
			_Utils_Tuple2(0, 0));
		var sX = _v0.a;
		var sY = _v0.b;
		var template = A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$gridTemplate,
			$mdgriffith$elm_ui$Internal$Model$GridTemplateStyle(
				{
					kP: A2($elm$core$List$map, columnWidth, config.kP),
					nB: A2(
						$elm$core$List$repeat,
						$elm$core$List$length(config.k1),
						$mdgriffith$elm_ui$Internal$Model$Content),
					nV: _Utils_Tuple2(
						$mdgriffith$elm_ui$Element$px(sX),
						$mdgriffith$elm_ui$Element$px(sY))
				}));
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asGrid,
			$mdgriffith$elm_ui$Internal$Model$div,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				A2($elm$core$List$cons, template, attrs)),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				function () {
					if (maybeHeaders.$ === 1) {
						return children.a0;
					} else {
						var renderedHeaders = maybeHeaders.a;
						return _Utils_ap(
							renderedHeaders,
							$elm$core$List$reverse(children.a0));
					}
				}()));
	});
var $mdgriffith$elm_ui$Element$indexedTable = F2(
	function (attrs, config) {
		return A2(
			$mdgriffith$elm_ui$Element$tableHelper,
			attrs,
			{
				kP: A2($elm$core$List$map, $mdgriffith$elm_ui$Element$InternalIndexedColumn, config.kP),
				k1: config.k1
			});
	});
var $author$project$Grid$Grid$gridBodyWithData = F2(
	function (config, model) {
		var renderData = A3($author$project$Grid$Grid$getRenderDataFrom, model, config.gw, config.hF);
		var gridHeight = (config.ac.kz - config.ac.g$) - config.ac.ky;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 0, 5),
					$mdgriffith$elm_ui$Element$scrollbarY,
					$mdgriffith$elm_ui$Element$height(config.lI)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$indexedTable,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
						]),
					{
						kP: A2(
							$elm$core$List$map,
							A2($author$project$Grid$Grid$columnDefToColumn, config, model.aD),
							config.gw),
						k1: renderData
					})
				]));
	});
var $mdgriffith$elm_ui$Internal$Model$Bottom = 2;
var $mdgriffith$elm_ui$Element$alignBottom = $mdgriffith$elm_ui$Internal$Model$AlignY(2);
var $author$project$Grid$Grid$currentPageDisplay = F3(
	function (pageStart, pageEnd, filteredCount) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size(14),
					$mdgriffith$elm_ui$Element$Font$semiBold,
					$author$project$PAM$UI$Basic$montserrat
				]),
			$mdgriffith$elm_ui$Element$text(
				$elm$core$String$fromInt(pageStart) + (' - ' + ($elm$core$String$fromInt(pageEnd) + (' of ' + $elm$core$String$fromInt(filteredCount))))));
	});
var $author$project$Grid$Grid$maxPageOf = F2(
	function (data, itemsPerPage) {
		var length = $elm$core$List$length(data) - 1;
		var max = $elm$core$Basics$floor(length / itemsPerPage);
		return max;
	});
var $author$project$Grid$Grid$GotoPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Grid$Grid$UpdatePage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Grid$Grid$pageNavigation = F4(
	function (pageMax, filteredCount, filteredMax, model) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$size(14),
					$mdgriffith$elm_ui$Element$spacing(12)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$author$project$PAM$UI$Basic$title('First page')
						]),
					{
						h3: $author$project$PAM$UI$Basic$centeredIcon('fa fa-step-backward'),
						ip: (model.k_ > 0) ? $elm$core$Maybe$Just(
							$author$project$Grid$Grid$GotoPage(0)) : $elm$core$Maybe$Nothing
					}),
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$author$project$PAM$UI$Basic$title('Previous page')
						]),
					{
						h3: $author$project$PAM$UI$Basic$centeredIcon('fa fa-caret-left'),
						ip: (model.k_ > 0) ? $elm$core$Maybe$Just(
							$author$project$Grid$Grid$UpdatePage(-1)) : $elm$core$Maybe$Nothing
					}),
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$author$project$PAM$UI$Basic$title('Next page')
						]),
					{
						h3: $author$project$PAM$UI$Basic$centeredIcon('fa fa-caret-right'),
						ip: (_Utils_cmp(pageMax, filteredCount) < 0) ? $elm$core$Maybe$Just(
							$author$project$Grid$Grid$UpdatePage(1)) : $elm$core$Maybe$Nothing
					}),
					A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$author$project$PAM$UI$Basic$title('Last page')
						]),
					{
						h3: $author$project$PAM$UI$Basic$centeredIcon('fa fa-step-forward'),
						ip: (_Utils_cmp(pageMax, filteredCount) < 0) ? $elm$core$Maybe$Just(
							$author$project$Grid$Grid$GotoPage(filteredMax)) : $elm$core$Maybe$Nothing
					})
				]));
	});
var $author$project$Grid$Grid$ClosePageSizeDropdownHack = {$: 7};
var $author$project$Grid$Grid$PageSizeChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$PAM$UI$Select$SelectUp = 1;
var $author$project$Grid$Grid$TogglePageSizeDropdown = {$: 5};
var $author$project$PAM$UI$Basic$inputHeight = function (_v0) {
	var windowSize = _v0.w;
	var device = _v0.Z;
	return $mdgriffith$elm_ui$Element$px(
		A3(
			$author$project$PAM$UI$Basic$adjustOnHeight,
			windowSize,
			device,
			_Utils_Tuple2(26, 30)));
};
var $author$project$Grid$Grid$pageSizeSelector = F2(
	function (config, _v0) {
		var itemsPerPageOpenness = _v0.bq;
		var itemsPerPage = _v0.l5;
		var options = _List_fromArray(
			[20, 50, 100]);
		var optionListConfig = A2(
			$author$project$PAM$UI$Select$defaultOptionListConfig,
			config,
			{
				ab: $author$project$Grid$Grid$inputIds.eI,
				h3: 'Page Size Options',
				mH: $author$project$Grid$Grid$PageSizeChanged,
				mS: $author$project$Grid$Grid$ClosePageSizeDropdownHack,
				P: $elm$core$Maybe$Just(itemsPerPage)
			});
		var optionConfig = A2(
			$author$project$PAM$UI$Select$defaultOptionConfig,
			config.w,
			{op: $elm$core$String$fromInt});
		var labelConfig = {
			kM: $elm$core$Maybe$Just('fa fa-caret-up'),
			h3: $elm$core$String$fromInt(itemsPerPage),
			m3: $elm$core$Maybe$Just('fa fa-times'),
			iu: _List_Nil
		};
		var buttonConfig = A2(
			$author$project$PAM$UI$Select$defaultButtonConfig,
			config.w,
			{
				lI: $author$project$PAM$UI$Basic$inputHeight(config),
				ab: $author$project$Grid$Grid$inputIds.iw,
				ip: $elm$core$Maybe$Just($author$project$Grid$Grid$TogglePageSizeDropdown),
				jR: A2($mdgriffith$elm_ui$Element$minimum, 55, $mdgriffith$elm_ui$Element$shrink)
			});
		var selectConfig = A2(
			$author$project$PAM$UI$Select$defaultSelectConfig,
			config.w,
			{kB: buttonConfig, la: 1, l7: labelConfig, m4: optionConfig, m5: optionListConfig});
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, config.w, 1)),
							$mdgriffith$elm_ui$Element$Font$semiBold,
							$author$project$PAM$UI$Basic$montserrat
						]),
					$mdgriffith$elm_ui$Element$text('Items Per Page')),
					A3($author$project$PAM$UI$Select$select, selectConfig, itemsPerPageOpenness, options)
				]));
	});
var $author$project$Grid$Grid$paginationControls = F3(
	function (config, model, filteredData) {
		var totalCount = $elm$core$List$length(config.k1);
		var pageStart = (model.k_ * model.l5) + 1;
		var pageMax = (model.k_ + 1) * model.l5;
		var filteredMax = A2($author$project$Grid$Grid$maxPageOf, filteredData, model.l5);
		var filteredCount = $elm$core$List$length(filteredData);
		var pageEnd = (_Utils_cmp(pageMax, filteredCount) < 1) ? pageMax : filteredCount;
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$spacing(20),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2($author$project$Grid$Grid$pageSizeSelector, config, model),
					A3($author$project$Grid$Grid$currentPageDisplay, pageStart, pageEnd, filteredCount),
					A4($author$project$Grid$Grid$pageNavigation, pageMax, filteredCount, filteredMax, model)
				]));
	});
var $author$project$Grid$Grid$gridFooterWithData = F3(
	function (config, model, filteredData) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$alignBottom,
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(config.ac.g$)),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A3($author$project$Grid$Grid$paginationControls, config, model, filteredData)
				]));
	});
var $author$project$Grid$Grid$gridView = F2(
	function (config, model) {
		var visibleColumns = A2(
			$elm$core$List$filter,
			function ($) {
				return $.dJ;
			},
			config.kN);
		var filteredData = A3($author$project$Grid$Grid$filterColumns, model, config.kN, config.k1);
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(config.lI),
					$mdgriffith$elm_ui$Element$clip
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Grid$Grid$gridBodyWithData,
					{Z: config.Z, hF: filteredData, lI: config.lI, ac: config.ac, gw: visibleColumns, w: config.w},
					model),
					A3($author$project$Grid$Grid$gridFooterWithData, config, model, filteredData)
				]));
	});
var $author$project$CWS$Approver$ParticipatingEntities$peGridView = F3(
	function (env, model, data) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1)),
					$mdgriffith$elm_ui$Element$spacing(0),
					A2($mdgriffith$elm_ui$Element$paddingXY, 20, 0)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px($author$project$CWS$Approver$ParticipatingEntities$gridHeaderSize)),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$CWS$Approver$ParticipatingEntities$GridMsg,
						A2(
							$author$project$Grid$Grid$filterView,
							{
								kO: $author$project$CWS$Approver$ParticipatingEntities$columnToggles,
								Z: env.Z,
								lB: A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1),
								lI: $mdgriffith$elm_ui$Element$fill,
								ac: env.ac,
								w: env.w
							},
							model.dr))),
					A2(
					$mdgriffith$elm_ui$Element$map,
					$author$project$CWS$Approver$ParticipatingEntities$GridMsg,
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$clip
							]),
						A2(
							$author$project$Grid$Grid$gridView,
							{
								kN: $author$project$CWS$Approver$ParticipatingEntities$colDefs,
								k1: data,
								Z: env.Z,
								lI: $mdgriffith$elm_ui$Element$px(env.w.lI - 175),
								ac: env.ac,
								w: env.w
							},
							model.dr)))
				]));
	});
var $author$project$CWS$Approver$ParticipatingEntities$view = F3(
	function (env, model, data) {
		var filtered = data;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 5, 0)
				]),
			_List_fromArray(
				[
					$author$project$CWS$Approver$ParticipatingEntities$headerView(model),
					A3($author$project$CWS$Approver$ParticipatingEntities$peGridView, env, model, filtered)
				]));
	});
var $author$project$CWS$Approver$Users$headerView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size(26),
				$mdgriffith$elm_ui$Element$Font$bold,
				A2($mdgriffith$elm_ui$Element$paddingXY, 0, 10)
			]),
		$mdgriffith$elm_ui$Element$text('Users'));
};
var $author$project$CWS$Approver$Users$emailColumn = {
	a1: $author$project$Grid$Grid$StringGetter(
		function (obj) {
			return obj.ek;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (a) {
			return $elm$core$List$sortBy(
				function (b) {
					return $elm$core$String$toLower(b.ek);
				})(a);
		}
	},
	jr: 'Email',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$fill
};
var $author$project$CWS$Approver$Users$nameColumn = {
	a1: $author$project$Grid$Grid$StringGetter(
		function (obj) {
			return obj.dz;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (a) {
			return $elm$core$List$sortBy(
				function (b) {
					return $elm$core$String$toLower(b.dz);
				})(a);
		}
	},
	jr: 'Name',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$fill
};
var $author$project$CWS$Route$makeCWSApproverUsers = $author$project$CWS$Route$CWSApprover($author$project$CWS$Route$APP_Users);
var $author$project$CWS$Route$makeUsersManagePEs = function (userID) {
	return $author$project$CWS$Route$makeAppModalRoute(
		$author$project$CWS$Route$APP_Modal_Manage_User_PEs(
			{f: userID}));
};
var $author$project$CWS$Approver$Users$testDynColumn = {
	a1: $author$project$Grid$Grid$DynamicGetter(
		function (b) {
			var addPERoute = A2(
				$author$project$CWS$Route$makeSimpleFullRoute,
				$author$project$CWS$Route$makeCWSApproverUsers,
				$author$project$CWS$Route$makeUsersManagePEs(b.ab));
			return _Utils_Tuple2(
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerY]),
					$mdgriffith$elm_ui$Element$html(
						A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$CWS$Route$routeToHref(addPERoute))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Participating Entities')
										]))
								])))),
				'');
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (b) {
			return A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.dz;
				},
				b);
		}
	},
	jr: '',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$CWS$Approver$Users$colDefs = _List_fromArray(
	[$author$project$CWS$Approver$Users$nameColumn, $author$project$CWS$Approver$Users$emailColumn, $author$project$CWS$Approver$Users$testDynColumn]);
var $author$project$CWS$Approver$Users$NoOp = {$: 0};
var $author$project$CWS$Approver$Users$emailToggle = {dx: 0, dJ: true, jr: 'Email', js: $author$project$CWS$Approver$Users$NoOp, dQ: 0};
var $author$project$CWS$Approver$Users$nameToggle = {dx: 0, dJ: true, jr: 'Name', js: $author$project$CWS$Approver$Users$NoOp, dQ: 0};
var $author$project$CWS$Approver$Users$columnToggles = _List_fromArray(
	[$author$project$CWS$Approver$Users$nameToggle, $author$project$CWS$Approver$Users$emailToggle]);
var $author$project$CWS$Approver$Users$gridHeaderSize = 30;
var $author$project$CWS$Approver$Users$peGridView = F3(
	function (env, model, data) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1)),
					$mdgriffith$elm_ui$Element$spacing(0),
					A2($mdgriffith$elm_ui$Element$paddingXY, 20, 0)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px($author$project$CWS$Approver$Users$gridHeaderSize)),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$CWS$Approver$Users$GridMsg,
						A2(
							$author$project$Grid$Grid$filterView,
							{
								kO: $author$project$CWS$Approver$Users$columnToggles,
								Z: env.Z,
								lB: A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1),
								lI: $mdgriffith$elm_ui$Element$fill,
								ac: env.ac,
								w: env.w
							},
							model.dr))),
					A2(
					$mdgriffith$elm_ui$Element$map,
					$author$project$CWS$Approver$Users$GridMsg,
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$clip
							]),
						A2(
							$author$project$Grid$Grid$gridView,
							{
								kN: $author$project$CWS$Approver$Users$colDefs,
								k1: data,
								Z: env.Z,
								lI: $mdgriffith$elm_ui$Element$px(env.w.lI - 175),
								ac: env.ac,
								w: env.w
							},
							model.dr)))
				]));
	});
var $author$project$CWS$Approver$Users$view = F3(
	function (env, model, data) {
		var filtered = data;
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					A2($mdgriffith$elm_ui$Element$paddingXY, 5, 0)
				]),
			_List_fromArray(
				[
					$author$project$CWS$Approver$Users$headerView(model),
					A3($author$project$CWS$Approver$Users$peGridView, env, model, filtered)
				]));
	});
var $author$project$CWS$approverView = F2(
	function (model, subRt) {
		var _v0 = _Utils_Tuple2(subRt, model.b.D);
		_v0$4:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var pes = _v0.b.a;
						var _v2 = model.b.b0;
						if (_v2.$ === 2) {
							var peo = _v2.a;
							return A2(
								$mdgriffith$elm_ui$Element$map,
								$author$project$CWS$Messages$AppPEMsg,
								A3(
									$author$project$CWS$Approver$ParticipatingEntities$view,
									{
										Z: model.Z,
										dw: $author$project$CWS$calculateModalContentSize(model),
										ac: model.ac,
										w: model.p.aV
									},
									model.a.dd,
									peo));
						} else {
							return $mdgriffith$elm_ui$Element$html($author$project$CWS$blankView);
						}
					} else {
						break _v0$4;
					}
				case 1:
					var _v3 = _v0.a;
					var _v4 = model.b.aY;
					if (_v4.$ === 2) {
						var peo = _v4.a;
						return A2(
							$mdgriffith$elm_ui$Element$map,
							$author$project$CWS$Messages$AppUsersMsg,
							A3(
								$author$project$CWS$Approver$Users$view,
								{
									Z: model.Z,
									dw: $author$project$CWS$calculateModalContentSize(model),
									ac: model.ac,
									w: model.p.aV
								},
								model.a.de,
								peo));
					} else {
						return $mdgriffith$elm_ui$Element$html($author$project$CWS$loadingView);
					}
				case 2:
					var _v5 = _v0.a;
					var _v6 = model.b.cl;
					if (_v6.$ === 2) {
						var aco = _v6.a;
						return A2(
							$mdgriffith$elm_ui$Element$map,
							$author$project$CWS$Messages$AppActionMsg,
							$mdgriffith$elm_ui$Element$html(
								A2($author$project$CWS$Approver$Actions$view, model.a.dc, aco)));
					} else {
						return $mdgriffith$elm_ui$Element$html($author$project$CWS$blankView);
					}
				case 3:
					var pe = _v0.a.a;
					var _v7 = model.b.aA;
					if (_v7.$ === 2) {
						var files = _v7.a;
						var sf = $elm$core$Dict$values(model.a.cM);
						var oldallDocumentsModel = model.a.U;
						var newallDocumentsModel = _Utils_update(
							oldallDocumentsModel,
							{g4: true});
						var filz = function () {
							var _v8 = model.b.aA;
							if (_v8.$ === 2) {
								var f = _v8.a;
								return f;
							} else {
								return _List_Nil;
							}
						}();
						return $mdgriffith$elm_ui$Element$html(
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$CWS$Messages$FileUploadMsg,
										$author$project$CWS$UploadDocuments$headerOnlyView(model.a.U)),
										A2(
										$elm$html$Html$map,
										$author$project$CWS$Messages$FileUploadWorkflowMsg,
										$author$project$CWS$UploadDocuments$uploadWorkflowView(model.a.ce)),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('uploadDownloadContainer')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$CWS$Messages$FileUploadMsg,
												A3($author$project$CWS$UploadDocuments$gridOnlyView, model.a.n, model.a.U, filz))
											])),
										A2(
										$elm$html$Html$map,
										$author$project$CWS$Messages$FileUploadMsg,
										$author$project$CWS$UploadDocuments$confirmCloseView(model.a.U))
									])));
					} else {
						return $mdgriffith$elm_ui$Element$html($author$project$CWS$blankView);
					}
				default:
					break _v0$4;
			}
		}
		return $mdgriffith$elm_ui$Element$html(
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Loading')
					])));
	});
var $author$project$CWS$errorView = function (errorModule) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('error')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Could not load view. ' + errorModule)
			]));
};
var $author$project$CWS$ActionBoard$ToggleChecklistCollapse = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$ActionBoard$Delete = function (a) {
	return {$: 6, a: a};
};
var $author$project$CWS$ActionBoard$NoOp = {$: 0};
var $author$project$CWS$ActionBoard$canEdit = function (action) {
	return (action.jf === 1) || (action.jf === 3);
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$CWS$Route$makeActionCategory = F3(
	function (peKey, year, category) {
		return $author$project$CWS$Route$makePEMainRoute(
			$author$project$CWS$Route$PE_Actions(
				{
					bK: category,
					d: {d: peKey, r: year}
				}));
	});
var $author$project$CWS$ActionBoard$splitDT = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, 'T', input)));
};
var $author$project$CWS$ActionBoard$statusToText = function (status) {
	switch (status) {
		case 0:
			return 'Unknown';
		case 1:
			return 'Not Submitted';
		case 4:
			return 'Approved';
		case 3:
			return 'Denied';
		default:
			return 'Submitted';
	}
};
var $author$project$CWS$ActionBoard$moneyFormat = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
	{k4: 2});
var $author$project$CWS$ActionBoard$toAcres = function (acres) {
	if (!acres.$) {
		var a = acres.a;
		return A2($cuducos$elm_format_number$FormatNumber$format, $author$project$CWS$ActionBoard$moneyFormat, a) + ' acres';
	} else {
		return 'n/a';
	}
};
var $author$project$CWS$ActionBoard$toMoney = function (money) {
	if (!money.$) {
		var m = money.a;
		return '$' + A2($cuducos$elm_format_number$FormatNumber$format, $author$project$CWS$ActionBoard$moneyFormat, m);
	} else {
		return '-';
	}
};
var $author$project$CWS$ActionBoard$activitySummaryView = F4(
	function (item, pe, year, category) {
		var newRoute = A2(
			$author$project$CWS$Route$FullRoute,
			A3($author$project$CWS$Route$makeActionCategory, pe.v, year, category),
			$author$project$CWS$Route$makeViewAction(item.ab));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('activitySummary')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('deleteActivityBtn'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'disabled',
									!$author$project$CWS$ActionBoard$canEdit(item))
								])),
							$elm$html$Html$Events$onClick(
							$author$project$CWS$ActionBoard$canEdit(item) ? $author$project$CWS$ActionBoard$Delete(item.ab) : $author$project$CWS$ActionBoard$NoOp)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-trash')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activitySummaryContainer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemHeader')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Action Name')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemContent')
								]),
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text('No Name Set'),
									A2($elm$core$Maybe$map, $elm$html$Html$text, item.dz))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activitySummaryContainer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemHeader')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Action Cost')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemContent')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$CWS$ActionBoard$toMoney(
										$author$project$Fields$Shared$validityToMaybe(item.ll)))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activitySummaryContainer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemHeader')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Action Area')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemContent')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$CWS$ActionBoard$toAcres(
										$author$project$Fields$Shared$validityToMaybe(item.bH)))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activitySummaryContainer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemHeader')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Date Submitted')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemContent')
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = item.jf;
									if (_v0 === 1) {
										return $elm$html$Html$text('Pending');
									} else {
										return $elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'-',
												A2(
													$elm$core$Maybe$map,
													$author$project$NormalDate$dateToNormalString,
													A2(
														$elm$core$Maybe$andThen,
														function (d) {
															return $elm$core$Result$toMaybe(
																$author$project$NormalDate$fromIsoDate(d));
														},
														A2($elm$core$Maybe$map, $author$project$CWS$ActionBoard$splitDT, item.mb)))));
									}
								}()
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('activitySummaryContainer')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemHeader')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Status')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('activitySummaryItemContent pending')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$CWS$ActionBoard$statusToText(item.jf))
								]))
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('openActivityBtn'),
							$elm$html$Html$Attributes$href(
							$author$project$CWS$Route$routeToHref(newRoute))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('../images/circleArrow.png'),
									$elm$html$Html$Attributes$class('pointerCursor')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$CWS$ActionBoard$activitySummariesView = F4(
	function (lists, pe, year, category) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('widgetColumn')
				]),
			A2(
				$elm$core$List$map,
				function (item) {
					return A4($author$project$CWS$ActionBoard$activitySummaryView, item, pe, year, category);
				},
				lists));
	});
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$CWS$Route$makeNewAction = F2(
	function (category, type_) {
		return $author$project$CWS$Route$NewActionDetails(
			{bK: category, hM: type_});
	});
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$CWS$ActionBoard$actionChecklistView = F5(
	function (_v0, pe, year, category, viewOnly) {
		var state = _v0.a;
		var item = _v0.b;
		var newRoute = A2(
			$author$project$CWS$Route$FullRoute,
			A3($author$project$CWS$Route$makeActionCategory, pe.v, year, category),
			A2($author$project$CWS$Route$makeNewAction, category, item.v));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('checklistWidget')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('widgetHeader')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('widgetTitle')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$section,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('widgetTitle')
										]),
									_List_fromArray(
										[
											function () {
											if (state === 1) {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pointerCursor'),
															$elm$html$Html$Events$onClick(
															$author$project$CWS$ActionBoard$ToggleChecklistCollapse(item.dz))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$src('../images/greenTriangle.png'),
																	$elm$html$Html$Attributes$class('alignMiddle')
																]),
															_List_Nil),
															$elm$html$Html$text(
															item.dz + (' (' + ($elm$core$String$fromInt(
																$elm$core$List$length(item.au)) + ')')))
														]));
											} else {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pointerCursor'),
															$elm$html$Html$Events$onClick(
															$author$project$CWS$ActionBoard$ToggleChecklistCollapse(item.dz))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$src('../images/greenDownTriangle.png'),
																	$elm$html$Html$Attributes$class('alignMiddle')
																]),
															_List_Nil),
															$elm$html$Html$text(
															item.dz + (' (' + ($elm$core$String$fromInt(
																$elm$core$List$length(item.au)) + ')')))
														]));
											}
										}()
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('widgetHeaderBtnSection')
								]),
							_List_fromArray(
								[
									viewOnly ? A2($elm$html$Html$div, _List_Nil, _List_Nil) : A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$CWS$Route$routeToHref(newRoute)),
											$elm$html$Html$Attributes$title('Add New'),
											$elm$html$Html$Attributes$class('button widgetHeaderBtn')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('+ New Action')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('itemContainer')
						]),
					_List_fromArray(
						[
							function () {
							if (state === 1) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('items')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$hr,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('actionBoardHr')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('widgetColumn')
												]),
											_List_fromArray(
												[
													A4($author$project$CWS$ActionBoard$activitySummariesView, item.au, pe, year, category)
												]))
										]));
							} else {
								return A2($elm$html$Html$div, _List_Nil, _List_Nil);
							}
						}()
						]))
				]));
	});
var $author$project$CWS$ActionBoard$actionChecklistsView = F5(
	function (lists, pe, year, category, viewOnly) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('widgetItem')
				]),
			A2(
				$elm$core$List$map,
				function (item) {
					return A5($author$project$CWS$ActionBoard$actionChecklistView, item, pe, year, category, viewOnly);
				},
				lists));
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$CWS$ActionBoard$checkllistSubView = F2(
	function (cwsmodel, viewOnly) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('actionListContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('actionBoardHr')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('actionboard-subTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Wildfire ' + (cwsmodel.bK + ' Checklist'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('widgetColumn')
						]),
					_List_fromArray(
						[
							A5($author$project$CWS$ActionBoard$actionChecklistsView, cwsmodel.a.bf, cwsmodel.a.cQ, cwsmodel.a.r, cwsmodel.bK, viewOnly)
						]))
				]));
	});
var $author$project$CWS$ActionBoard$confirmCloseView = function (model) {
	var _v0 = model.a.aJ;
	if (_v0.$ === 1) {
		var title = _v0.a;
		var question = _v0.b;
		var description = _v0.c;
		var confirmName = _v0.d;
		var confirmMsg = _v0.e;
		var cancelName = _v0.f;
		var cancelMsg = _v0.g;
		var id = _v0.h;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirmWrapper')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(title)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('description')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(description)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('question')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(question)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('actions')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('confirmAction'),
													$elm$html$Html$Events$onClick(
													confirmMsg(id))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(confirmName)
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('cancelAction'),
													$elm$html$Html$Events$onClick(
													cancelMsg(id))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(cancelName)
												]))
										]))
								]))
						]))
				]));
	} else {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	}
};
var $author$project$CWS$ActionBoard$debugStatItem = F2(
	function (value, total) {
		return {eY: total, gv: value};
	});
var $author$project$CWS$ActionBoard$debugTotalStat = function (total) {
	return {eY: total};
};
var $author$project$CWS$ActionBoard$blankActionStatsObject = {
	bH: $author$project$CWS$ActionBoard$debugTotalStat(0),
	au: $author$project$CWS$ActionBoard$debugTotalStat(0),
	aM: A2($author$project$CWS$ActionBoard$debugStatItem, 0, $elm$core$Maybe$Nothing)
};
var $author$project$CWS$ActionBoard$aggregate = F3(
	function (actss, category, commitment) {
		if (actss.$ === 2) {
			var stats = actss.a;
			var participationCommitment = commitment;
			var approvedStats = A2(
				$elm$core$List$filter,
				function (a) {
					return _Utils_eq(a.bK.v, category) && (a.jf === 4);
				},
				stats);
			var approvedCost = A3(
				$elm$core$List$foldl,
				function (a) {
					return function (b) {
						return b + a.ov;
					};
				},
				0,
				approvedStats);
			var approvedActions = A3(
				$elm$core$List$foldl,
				function (a) {
					return function (b) {
						return b + a.kX;
					};
				},
				0,
				approvedStats);
			var approvedAcres = A3(
				$elm$core$List$foldl,
				function (a) {
					return function (b) {
						return b + a.ot;
					};
				},
				0,
				approvedStats);
			return (category === 'Mitigation') ? $author$project$CWS$Model$Loaded(
				{
					bH: $author$project$CWS$ActionBoard$debugTotalStat(approvedAcres),
					au: $author$project$CWS$ActionBoard$debugTotalStat(approvedActions),
					aM: A2($author$project$CWS$ActionBoard$debugStatItem, approvedCost, participationCommitment)
				}) : ((category === 'Preparedness') ? $author$project$CWS$Model$Loaded(
				{
					bH: $author$project$CWS$ActionBoard$debugTotalStat(approvedAcres),
					au: $author$project$CWS$ActionBoard$debugTotalStat(approvedActions),
					aM: A2(
						$author$project$CWS$ActionBoard$debugStatItem,
						approvedCost,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$mul(0.25),
							participationCommitment))
				}) : ((category === 'Prevention') ? $author$project$CWS$Model$Loaded(
				{
					bH: $author$project$CWS$ActionBoard$debugTotalStat(approvedAcres),
					au: $author$project$CWS$ActionBoard$debugTotalStat(approvedActions),
					aM: A2($author$project$CWS$ActionBoard$debugStatItem, approvedCost, participationCommitment)
				}) : $author$project$CWS$Model$Loaded($author$project$CWS$ActionBoard$blankActionStatsObject)));
		} else {
			return $author$project$CWS$Model$Loading;
		}
	});
var $author$project$CWS$ActionBoard$mitAcresStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Number,
	{
		a4: 'This statistic represents acres completed for approved mitigation actions only.',
		dz: 'Wildfire Mitigation',
		a9: $elm$core$Maybe$Just('Acres')
	},
	{
		a1: $author$project$Stats$SimpleDisplay$TotalGetter(
			function ($) {
				return $.bH;
			}),
		cD: '/images/Mitigation.svg',
		c4: $elm$core$Maybe$Just('#8F46A2'),
		bb: $elm$core$Maybe$Nothing
	});
var $author$project$CWS$ActionBoard$mitApprovedStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Number,
	{a4: 'This statistic represents approved mitigation actions only.', dz: 'Approved Wildfire Mitigation Actions', a9: $elm$core$Maybe$Nothing},
	{
		a1: $author$project$Stats$SimpleDisplay$TotalGetter(
			function ($) {
				return $.au;
			}),
		cD: '/images/Mitigation.svg',
		c4: $elm$core$Maybe$Just('#8F46A2'),
		bb: $elm$core$Maybe$Nothing
	});
var $author$project$Stats$SimpleDisplay$Stat_Progress = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Stats$SimpleDisplay$ValueTotalGetter = function (get) {
	return {hK: get};
};
var $author$project$CWS$ActionBoard$mitPercentageStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Progress,
	{a4: 'This graph represents the estimated cost for approved mitigation actions only.', dz: 'Mitigation Dollars Spent', a9: $elm$core$Maybe$Nothing},
	{
		e7: '#CACACA',
		ft: '#8F46A2',
		a1: $author$project$Stats$SimpleDisplay$ValueTotalGetter(
			function ($) {
				return $.aM;
			}),
		gl: true,
		bb: $elm$core$Maybe$Just('$')
	});
var $author$project$CWS$ActionBoard$defaultStatSetMit = _List_fromArray(
	[
		_List_fromArray(
		[$author$project$CWS$ActionBoard$mitAcresStat, $author$project$CWS$ActionBoard$mitApprovedStat, $author$project$CWS$ActionBoard$mitPercentageStat])
	]);
var $author$project$CWS$ActionBoard$prepApprovedStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Number,
	{a4: 'This statistic represents approved preparedness actions only.', dz: 'Approved Wildfire Preparedness Actions', a9: $elm$core$Maybe$Nothing},
	{
		a1: $author$project$Stats$SimpleDisplay$TotalGetter(
			function ($) {
				return $.au;
			}),
		cD: '/images/Preparedness.svg',
		c4: $elm$core$Maybe$Just('#CB4D15'),
		bb: $elm$core$Maybe$Nothing
	});
var $author$project$CWS$ActionBoard$prepSpentNumberStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Number,
	{a4: 'This statistic represents the estimated cost for approved preparedness actions only.', dz: 'Dollars Spent on Wildfire Preparedness', a9: $elm$core$Maybe$Nothing},
	{
		a1: {
			hK: function (a) {
				return {eY: a.aM.gv};
			}
		},
		cD: '/images/Preparedness.svg',
		c4: $elm$core$Maybe$Just('#CB4D15'),
		bb: $elm$core$Maybe$Just('$')
	});
var $author$project$CWS$ActionBoard$prepSpentStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Progress,
	{a4: 'This graph represents the estimated cost for approved preparedness actions only.', dz: 'Preparedness Dollars Spent', a9: $elm$core$Maybe$Nothing},
	{
		e7: '#CACACA',
		ft: '#CB4D15',
		a1: $author$project$Stats$SimpleDisplay$ValueTotalGetter(
			function ($) {
				return $.aM;
			}),
		gl: true,
		bb: $elm$core$Maybe$Just('$')
	});
var $author$project$CWS$ActionBoard$defaultStatSetPrep = _List_fromArray(
	[
		_List_fromArray(
		[$author$project$CWS$ActionBoard$prepSpentNumberStat, $author$project$CWS$ActionBoard$prepApprovedStat, $author$project$CWS$ActionBoard$prepSpentStat])
	]);
var $author$project$CWS$ActionBoard$prevCompletedStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Number,
	{a4: 'This statistic represents approved prevention actions only.', dz: 'Approved Wildfire Prevention Actions', a9: $elm$core$Maybe$Nothing},
	{
		a1: $author$project$Stats$SimpleDisplay$TotalGetter(
			function ($) {
				return $.au;
			}),
		cD: '/images/Prevention.svg',
		c4: $elm$core$Maybe$Just('#203D05'),
		bb: $elm$core$Maybe$Nothing
	});
var $author$project$CWS$ActionBoard$prevPercentageStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Progress,
	{a4: 'This graph represents the estimated cost for approved prevention actions only.', dz: 'Prevention Dollars Spent', a9: $elm$core$Maybe$Nothing},
	{
		e7: '#CACACA',
		ft: '#203D05',
		a1: $author$project$Stats$SimpleDisplay$ValueTotalGetter(
			function ($) {
				return $.aM;
			}),
		gl: true,
		bb: $elm$core$Maybe$Just('$')
	});
var $author$project$CWS$ActionBoard$prevSpentNumberStat = A2(
	$author$project$Stats$SimpleDisplay$Stat_Number,
	{a4: 'This statistic represents the estimated cost for approved prevention actions only.', dz: 'Dollars Spent on Wildfire Prevention ', a9: $elm$core$Maybe$Nothing},
	{
		a1: {
			hK: function (a) {
				return {eY: a.aM.gv};
			}
		},
		cD: '/images/Prevention.svg',
		c4: $elm$core$Maybe$Just('#203D05'),
		bb: $elm$core$Maybe$Just('$')
	});
var $author$project$CWS$ActionBoard$defaultStatSetPrev = _List_fromArray(
	[
		_List_fromArray(
		[$author$project$CWS$ActionBoard$prevSpentNumberStat, $author$project$CWS$ActionBoard$prevCompletedStat, $author$project$CWS$ActionBoard$prevPercentageStat])
	]);
var $author$project$Stats$SimpleDisplay$infoIcon = function (stat) {
	var textual = function () {
		switch (stat.$) {
			case 1:
				var base = stat.a;
				return base.a4;
			case 2:
				var base = stat.a;
				return base.a4;
			case 3:
				var base = stat.a;
				return base.a4;
			default:
				return '';
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('info'),
				$elm$html$Html$Attributes$title(textual)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fa fa-info')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Stats$SimpleDisplay$numberFormat = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
	{k4: 0});
var $author$project$Stats$SimpleDisplay$toNumberFromFloat = function (inp) {
	return A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Stats$SimpleDisplay$numberFormat, inp);
};
var $author$project$Stats$SimpleDisplay$toPercent = F2(
	function (value, total) {
		return $elm$core$Basics$floor((value * 100) / total);
	});
var $author$project$Stats$SimpleDisplay$multiProgress = F4(
	function (_v0, bgColor, showValue, valuePrepend) {
		var values = _v0.a;
		var total = _v0.b;
		var vt = A3(
			$elm$core$List$foldl,
			$elm$core$Basics$add,
			0,
			A2(
				$elm$core$List$map,
				function (a) {
					return a.gv;
				},
				values));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bar multi'),
					A2($elm$html$Html$Attributes$style, 'background', bgColor)
				]),
			A2(
				$elm$core$List$append,
				A2(
					$elm$core$List$map,
					function (valueColor) {
						var percent = A2(
							$author$project$Stats$SimpleDisplay$toPercent,
							valueColor.gv,
							A2($elm$core$Maybe$withDefault, 99999, total));
						var wid = (percent < 1) ? 1 : ((percent > 100) ? 100 : percent);
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$style,
									'width',
									$elm$core$String$fromFloat(wid) + '%'),
									A2($elm$html$Html$Attributes$style, 'background', valueColor.M),
									$elm$html$Html$Attributes$title(
									$elm$core$String$fromFloat(percent) + ('% (' + (valuePrepend + ($elm$core$String$fromFloat(valueColor.gv) + ')'))))
								]),
							_List_Nil);
					},
					values),
				showValue ? _List_fromArray(
					[
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$b,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										_Utils_ap(
											valuePrepend,
											$author$project$Stats$SimpleDisplay$toNumberFromFloat(vt)))
									]))
							])),
						A2(
						$elm$core$Maybe$withDefault,
						A2($elm$html$Html$b, _List_Nil, _List_Nil),
						A2(
							$elm$core$Maybe$map,
							function (t) {
								return A2(
									$elm$html$Html$b,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$b,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													_Utils_ap(
														valuePrepend,
														$author$project$Stats$SimpleDisplay$toNumberFromFloat(t)))
												]))
										]));
							},
							total))
					]) : _List_Nil));
	});
var $author$project$Stats$SimpleDisplay$unitView = function (base) {
	var _v0 = base.a9;
	if (!_v0.$) {
		var unit = _v0.a;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('unit')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(unit)
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Stats$SimpleDisplay$multiProgressBarView = F3(
	function (base, stat, item) {
		var val = function () {
			if (item.$ === 2) {
				var itm = item.a;
				return stat.a1(itm);
			} else {
				return _Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('progress')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('name')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(base.dz)
									]))
							])),
						A4(
						$author$project$Stats$SimpleDisplay$multiProgress,
						val,
						stat.e7,
						stat.gl,
						function () {
							var _v0 = stat.bb;
							if (_v0.$ === 1) {
								return '';
							} else {
								var v = _v0.a;
								return v;
							}
						}())
					]),
				$author$project$Stats$SimpleDisplay$unitView(base)));
	});
var $author$project$Stats$SimpleDisplay$progress = F6(
	function (value, total, bgColor, fgColor, showValue, valuePrepend) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bar'),
					A2($elm$html$Html$Attributes$style, 'background', bgColor)
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$style,
								'width',
								$elm$core$String$fromFloat(
									A2(
										$author$project$Stats$SimpleDisplay$toPercent,
										value,
										A2($elm$core$Maybe$withDefault, 99999, total))) + '%'),
								A2($elm$html$Html$Attributes$style, 'background', fgColor)
							]),
						_List_Nil)
					]),
				showValue ? _List_fromArray(
					[
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$b,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										_Utils_ap(
											valuePrepend,
											$author$project$Stats$SimpleDisplay$toNumberFromFloat(value)))
									]))
							])),
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$b,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												function (tot) {
													return _Utils_ap(
														valuePrepend,
														$author$project$Stats$SimpleDisplay$toNumberFromFloat(tot));
												},
												total)))
									]))
							]))
					]) : _List_Nil));
	});
var $author$project$Stats$SimpleDisplay$progressBarView = F3(
	function (base, stat, item) {
		var val = function () {
			if (item.$ === 2) {
				var itm = item.a;
				return stat.a1.hK(itm);
			} else {
				return {
					eY: $elm$core$Maybe$Just(100),
					gv: 100
				};
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('progress')
				]),
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('name')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(base.dz)
									]))
							])),
						A6(
						$author$project$Stats$SimpleDisplay$progress,
						val.gv,
						val.eY,
						stat.e7,
						stat.ft,
						stat.gl,
						function () {
							var _v0 = stat.bb;
							if (_v0.$ === 1) {
								return '';
							} else {
								var v = _v0.a;
								return v;
							}
						}())
					]),
				$author$project$Stats$SimpleDisplay$unitView(base)));
	});
var $author$project$Stats$SimpleDisplay$smallIconView = F3(
	function (base, stat, item) {
		var val = function () {
			if (item.$ === 2) {
				var itm = item.a;
				return stat.a1.hK(itm);
			} else {
				return {eY: 0};
			}
		}();
		var prepend = function () {
			var _v1 = stat.bb;
			if (!_v1.$) {
				var vl = _v1.a;
				return vl;
			} else {
				return '';
			}
		}();
		var color = function () {
			var _v0 = stat.c4;
			if (!_v0.$) {
				var colr = _v0.a;
				return colr;
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('smallIcon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(stat.cD),
							$elm$html$Html$Attributes$class('icon')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('name')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(base.dz)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('value')
								]),
							A2(
								$elm$core$List$append,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('value'),
												A2($elm$html$Html$Attributes$style, 'color', color)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												_Utils_ap(
													prepend,
													$author$project$Stats$SimpleDisplay$toNumberFromFloat(val.eY)))
											]))
									]),
								$author$project$Stats$SimpleDisplay$unitView(base)))
						]))
				]));
	});
var $author$project$Stats$SimpleDisplay$widgetize = function (item) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('widget')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('widgetContainer')
					]),
				_List_fromArray(
					[item]))
			]));
};
var $author$project$Stats$SimpleDisplay$statView = F2(
	function (stats, data) {
		return $author$project$Stats$SimpleDisplay$widgetize(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('statContainer')
					]),
				_List_fromArray(
					[
						function () {
						switch (stats.$) {
							case 1:
								var base = stats.a;
								var stat = stats.b;
								return A3($author$project$Stats$SimpleDisplay$progressBarView, base, stat, data);
							case 2:
								var base = stats.a;
								var stat = stats.b;
								return A3($author$project$Stats$SimpleDisplay$multiProgressBarView, base, stat, data);
							case 3:
								var base = stats.a;
								var stat = stats.b;
								return A3($author$project$Stats$SimpleDisplay$smallIconView, base, stat, data);
							default:
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('invalid')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Invalid')
										]));
						}
					}(),
						$author$project$Stats$SimpleDisplay$infoIcon(stats)
					])));
	});
var $author$project$Stats$SimpleDisplay$statRowView = F2(
	function (stats, statObj) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('widgetRow')
				]),
			A2(
				$elm$core$List$map,
				function (i) {
					return A2($author$project$Stats$SimpleDisplay$statView, i, statObj);
				},
				stats));
	});
var $author$project$Stats$SimpleDisplay$statGridView = F2(
	function (stats, item) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('widgetGrid')
				]),
			A2(
				$elm$core$List$map,
				function (row) {
					return A2($author$project$Stats$SimpleDisplay$statRowView, row, item);
				},
				stats));
	});
var $author$project$CWS$ActionBoard$statsSubView = F3(
	function (model, commitment, stats) {
		var statSet = (model.bK === 'Mitigation') ? $author$project$CWS$ActionBoard$defaultStatSetMit : ((model.bK === 'Preparedness') ? $author$project$CWS$ActionBoard$defaultStatSetPrep : ((model.bK === 'Prevention') ? $author$project$CWS$ActionBoard$defaultStatSetPrev : _List_Nil));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('categoryMiniDashboardContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('actionboard-subTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(model.a.cQ.dz + ' Dashboard: '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subTitleContent')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Wildfire ' + model.bK)
								]))
						])),
					A2(
					$author$project$Stats$SimpleDisplay$statGridView,
					statSet,
					A3($author$project$CWS$ActionBoard$aggregate, stats, model.bK, commitment))
				]));
	});
var $author$project$CWS$ActionBoard$actionBoardView = F4(
	function (model, commitment, stats, viewOnly) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('actionBoardContainer')
				]),
			_List_fromArray(
				[
					A3($author$project$CWS$ActionBoard$statsSubView, model, commitment, stats),
					A2($author$project$CWS$ActionBoard$checkllistSubView, model, viewOnly),
					$author$project$CWS$ActionBoard$confirmCloseView(model)
				]));
	});
var $author$project$CWS$getPEKeyFromPERoute = function (rt) {
	switch (rt.$) {
		case 0:
			var home = rt.a;
			return home.d;
		case 1:
			var action = rt.a;
			return action.d.d;
		case 4:
			var pe = rt.a;
			return pe.d.d;
		case 6:
			var pe = rt.a;
			return pe.d;
		default:
			return '';
	}
};
var $author$project$CWS$loadableValueElementView = F3(
	function (data, view_, map) {
		switch (data.$) {
			case 1:
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_Nil,
					$mdgriffith$elm_ui$Element$text('Loading'));
			case 2:
				var dat = data.a;
				return A2(
					$mdgriffith$elm_ui$Element$map,
					map,
					view_(dat));
			case 0:
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_Nil,
					$mdgriffith$elm_ui$Element$text('The data has not been requested. Something went wrong.'));
			default:
				var msg = data.a;
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_Nil,
					$mdgriffith$elm_ui$Element$text('There was an error loading the data needed for this view. ' + msg));
		}
	});
var $mdgriffith$elm_ui$Internal$Model$Right = 2;
var $mdgriffith$elm_ui$Element$alignRight = $mdgriffith$elm_ui$Internal$Model$AlignX(2);
var $mdgriffith$elm_ui$Internal$Flag$borderStyle = $mdgriffith$elm_ui$Internal$Flag$flag(11);
var $mdgriffith$elm_ui$Element$Border$solid = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$borderStyle, $mdgriffith$elm_ui$Internal$Style$classes.kw);
var $author$project$CWS$PE$Reports$newStatsView = function (cfg) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$Border$rounded(6),
				$mdgriffith$elm_ui$Element$Border$solid,
				$mdgriffith$elm_ui$Element$Border$width(1),
				$mdgriffith$elm_ui$Element$padding(10),
				$mdgriffith$elm_ui$Element$clip
			]),
		A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$spaceEvenly,
					$mdgriffith$elm_ui$Element$clip,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Border$widthEach(
							{kx: 1, me: 0, nA: 0, os: 0}),
							$mdgriffith$elm_ui$Element$paddingEach(
							{kx: 5, me: 0, nA: 0, os: 5}),
							$mdgriffith$elm_ui$Element$Font$size(20),
							$mdgriffith$elm_ui$Element$clip,
							$mdgriffith$elm_ui$Element$spaceEvenly
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$alignLeft,
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$fillPortion(3)),
									$mdgriffith$elm_ui$Element$padding(5),
									$mdgriffith$elm_ui$Element$clip
								]),
							A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[$mdgriffith$elm_ui$Element$centerX]),
								A2(
									$mdgriffith$elm_ui$Element$image,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$htmlAttribute(
											$elm$html$Html$Attributes$id(cfg.dz + 'Icon'))
										]),
									{hp: 'icon', nX: cfg.cD}))),
							A2(
							$mdgriffith$elm_ui$Element$textColumn,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$size(17),
									$mdgriffith$elm_ui$Element$Font$bold,
									$mdgriffith$elm_ui$Element$Font$color(
									A3($mdgriffith$elm_ui$Element$rgb, 0.1, 0.4, 0)),
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$fillPortion(9)),
									$mdgriffith$elm_ui$Element$clip,
									$mdgriffith$elm_ui$Element$padding(5)
								]),
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Wildfire')
										])),
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text(cfg.dz)
										]))
								]))
						])),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(35),
							$mdgriffith$elm_ui$Element$Font$color(cfg.c4),
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$padding(5),
							$mdgriffith$elm_ui$Element$clip
						]),
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$centerY, $mdgriffith$elm_ui$Element$Font$bold]),
						$mdgriffith$elm_ui$Element$text(cfg.e$))),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Font$size(15),
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$clip
						]),
					$mdgriffith$elm_ui$Element$text(cfg.a9))
				])));
};
var $author$project$CWS$PE$Reports$view = F3(
	function (_v0, model, rte) {
		var pe = _v0.eK;
		var stats = _v0.je;
		var logo = _v0.ig;
		var _v1 = _Utils_Tuple2(model, rte);
		if (_v1.a.$ === 1) {
			var mdl = _v1.a.a;
			var _v2 = _v1.b;
			var printStat = $author$project$CWS$PE$Reports$getStats(
				{eK: pe, je: stats});
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(690)),
						$mdgriffith$elm_ui$Element$padding(5),
						$mdgriffith$elm_ui$Element$htmlAttribute(
						$elm$html$Html$Attributes$id('content-window')),
						$mdgriffith$elm_ui$Element$centerX
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$Font$size(20)
								]),
							$mdgriffith$elm_ui$Element$text('Generating Report'))),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'opacity', '0'))
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$column,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$spacing(10)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$row,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$height(
												$mdgriffith$elm_ui$Element$px(50)),
												$mdgriffith$elm_ui$Element$Background$color(
												A3($mdgriffith$elm_ui$Element$rgb255, 32, 61, 5)),
												$mdgriffith$elm_ui$Element$Font$color(
												A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1)),
												$mdgriffith$elm_ui$Element$padding(5)
											]),
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[$mdgriffith$elm_ui$Element$centerY]),
												$mdgriffith$elm_ui$Element$text(pe.dz + ' Report')),
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$centerY,
														$mdgriffith$elm_ui$Element$alignRight,
														$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
														$mdgriffith$elm_ui$Element$Background$color(
														A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1)),
														$mdgriffith$elm_ui$Element$Border$rounded(50),
														$mdgriffith$elm_ui$Element$padding(7),
														$mdgriffith$elm_ui$Element$height(
														$mdgriffith$elm_ui$Element$px(40)),
														$mdgriffith$elm_ui$Element$width(
														$mdgriffith$elm_ui$Element$px(40)),
														$mdgriffith$elm_ui$Element$clip
													]),
												A2(
													$mdgriffith$elm_ui$Element$image,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
															$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
															$mdgriffith$elm_ui$Element$htmlAttribute(
															$elm$html$Html$Attributes$id('ReportLogo'))
														]),
													{hp: logo.kd, nX: logo.nX}))
											])),
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$height(
												$mdgriffith$elm_ui$Element$px(450)),
												$mdgriffith$elm_ui$Element$Background$color(
												A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1)),
												$mdgriffith$elm_ui$Element$htmlAttribute(
												$elm$html$Html$Attributes$id('ol-map-container'))
											]),
										A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$Background$color(
													A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1)),
													$mdgriffith$elm_ui$Element$htmlAttribute(
													$elm$html$Html$Attributes$id('ol-map'))
												]),
											$mdgriffith$elm_ui$Element$none)),
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$height(
												$mdgriffith$elm_ui$Element$px(30)),
												$mdgriffith$elm_ui$Element$Background$color(
												A3($mdgriffith$elm_ui$Element$rgb, 0.80, 0.85, 0.75)),
												$mdgriffith$elm_ui$Element$Font$color(
												A3($mdgriffith$elm_ui$Element$rgb255, 32, 61, 5)),
												$mdgriffith$elm_ui$Element$Font$bold,
												$mdgriffith$elm_ui$Element$padding(5)
											]),
										A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$centerY]),
											$mdgriffith$elm_ui$Element$text('Commitment Summary'))),
										A2(
										$mdgriffith$elm_ui$Element$textColumn,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$padding(10)
											]),
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_fromArray(
															[$mdgriffith$elm_ui$Element$centerY]),
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text('Participation Commitment:')
															])),
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_fromArray(
															[$mdgriffith$elm_ui$Element$centerY]),
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text(printStat.b1.kQ)
															]))
													])),
												A2(
												$mdgriffith$elm_ui$Element$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_Nil,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text('Projected:')
															])),
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_fromArray(
															[$mdgriffith$elm_ui$Element$centerY]),
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text(printStat.b1.no)
															]))
													])),
												A2(
												$mdgriffith$elm_ui$Element$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_Nil,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text('Confirmed:')
															])),
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_fromArray(
															[$mdgriffith$elm_ui$Element$centerY]),
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text(printStat.b1.kR)
															]))
													])),
												A2(
												$mdgriffith$elm_ui$Element$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_Nil,
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text('Actions Taken:')
															])),
														A2(
														$mdgriffith$elm_ui$Element$paragraph,
														_List_fromArray(
															[$mdgriffith$elm_ui$Element$centerY]),
														_List_fromArray(
															[
																$mdgriffith$elm_ui$Element$text(printStat.b1.au)
															]))
													]))
											])),
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$height(
												$mdgriffith$elm_ui$Element$px(30)),
												$mdgriffith$elm_ui$Element$Background$color(
												A3($mdgriffith$elm_ui$Element$rgb, 0.80, 0.85, 0.75)),
												$mdgriffith$elm_ui$Element$Font$color(
												A3($mdgriffith$elm_ui$Element$rgb255, 31, 61, 5)),
												$mdgriffith$elm_ui$Element$Font$bold,
												$mdgriffith$elm_ui$Element$padding(5)
											]),
										A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$centerY]),
											$mdgriffith$elm_ui$Element$text('Actions By Category'))),
										A2(
										$mdgriffith$elm_ui$Element$row,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$padding(10),
												$mdgriffith$elm_ui$Element$spacing(20),
												$mdgriffith$elm_ui$Element$height(
												$mdgriffith$elm_ui$Element$px(200))
											]),
										_List_fromArray(
											[
												$author$project$CWS$PE$Reports$newStatsView(
												{
													cD: '/images/Mitigation.svg',
													dz: 'Mitigation',
													a9: 'Acres Treated',
													e$: printStat.je.mo,
													c4: A3($mdgriffith$elm_ui$Element$rgb255, 143, 70, 162)
												}),
												$author$project$CWS$PE$Reports$newStatsView(
												{
													cD: '/images/Preparedness.svg',
													dz: 'Preparedness',
													a9: 'Actions Taken',
													e$: printStat.je.nj,
													c4: A3($mdgriffith$elm_ui$Element$rgb255, 203, 77, 21)
												}),
												$author$project$CWS$PE$Reports$newStatsView(
												{
													cD: '/images/Prevention.svg',
													dz: 'Prevention',
													a9: 'Actions Taken',
													e$: printStat.je.nk,
													c4: A3($mdgriffith$elm_ui$Element$rgb255, 31, 61, 5)
												})
											]))
									])),
								A2(
								$mdgriffith$elm_ui$Element$row,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
									]),
								_List_fromArray(
									[
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$alignLeft,
												$mdgriffith$elm_ui$Element$Font$size(5)
											]),
										$mdgriffith$elm_ui$Element$text(pe.ab)),
										A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$clip,
												$mdgriffith$elm_ui$Element$padding(5)
											]),
										A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$alignRight]),
											A2(
												$mdgriffith$elm_ui$Element$Input$button,
												_List_Nil,
												{
													h3: $mdgriffith$elm_ui$Element$text('Print'),
													ip: $elm$core$Maybe$Just($author$project$CWS$PE$Reports$Print)
												})))
									]))
							]))
					]));
		} else {
			var _v3 = _v1.a;
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_Nil,
				$mdgriffith$elm_ui$Element$text('You did something wrong'));
		}
	});
var $author$project$CWS$getReportsView = F2(
	function (model, rte) {
		return A3(
			$author$project$CWS$loadableValueElementView,
			model.b.aC,
			function (pe) {
				return A3(
					$author$project$CWS$loadableValueElementView,
					model.b.az,
					function (stats) {
						return A3(
							$author$project$CWS$PE$Reports$view,
							{ig: model.p.m.hN.ig, eK: pe, je: stats},
							model.a.bz,
							rte);
					},
					$author$project$CWS$Messages$ReportsMsg);
			},
			$elm$core$Basics$identity);
	});
var $author$project$CWS$getYearFromPERoute = F2(
	function (rt, chnk) {
		var _v0 = _Utils_Tuple2(rt, chnk);
		_v0$2:
		while (true) {
			if (_v0.b.$ === 2) {
				switch (_v0.a.$) {
					case 0:
						var home = _v0.a.a;
						var pe = _v0.b.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'Unknown',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.dz;
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (a) {
											return _Utils_eq(a.v, home.r);
										},
										pe.cj))));
					case 1:
						var actions = _v0.a.a;
						var pe = _v0.b.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'Unknown',
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.dz;
								},
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (a) {
											return _Utils_eq(a.v, actions.d.r);
										},
										pe.cj))));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return 'None';
	});
var $author$project$CWS$UploadDocuments$OneFileDesc = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$UploadDocuments$PeStartUpload = function (a) {
	return {$: 5, a: a};
};
var $author$project$CWS$UploadDocuments$defaultFileInfo = A3($author$project$CWS$UploadDocuments$FileInfo, '', 0, '');
var $author$project$CWS$UploadDocuments$OneFile = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$UploadDocuments$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue));
};
var $author$project$CWS$UploadDocuments$fileInput = function (disabled_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fileInput')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('uploadBtn'),
						$elm$html$Html$Attributes$for('fileUpload'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('disabled', disabled_)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Choose File')
							]))
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('file'),
						$elm$html$Html$Attributes$id('fileUpload'),
						$author$project$CWS$UploadDocuments$onChange($author$project$CWS$UploadDocuments$OneFile),
						$elm$html$Html$Attributes$disabled(disabled_)
					]),
				_List_Nil)
			]));
};
var $author$project$CWS$UploadDocuments$isNotValid = function (validity) {
	if (validity.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $author$project$CWS$UploadDocuments$peInstructions = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('uploadInstruction')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Acceptable file types: PDF, JPG, JPEG, TIF, TIFF, PNG, DOC, DOCX, XLS, XLSX, ZIP')
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Acceptable file size: Less than 25MB')
				]))
		]));
var $author$project$CWS$UploadDocuments$validMessages = function (model) {
	var _v0 = model.aw;
	if (_v0.$ === 2) {
		var validity = _v0.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('warning')
				]),
			_List_fromArray(
				[
					(!validity.hx) ? A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The file type is not acceptable.')
						])) : $elm$html$Html$text(''),
					(!validity.i9) ? A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The file is too large.')
						])) : $elm$html$Html$text(''),
					(!validity.he) ? A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Maximum number of files reached for this action.')
						])) : $elm$html$Html$text('')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$CWS$UploadDocuments$peFileUploadView = F2(
	function (model, disabled__s) {
		var upload = $author$project$CWS$UploadDocuments$PeStartUpload(model);
		var disabled_ = false;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('uploadContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Upload Documents')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('uploadWrapper')
						]),
					_List_fromArray(
						[
							$author$project$CWS$UploadDocuments$fileInput(disabled_),
							$author$project$CWS$UploadDocuments$peInstructions,
							$author$project$CWS$UploadDocuments$validMessages(model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('infoWrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('nameBit')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, $author$project$CWS$UploadDocuments$defaultFileInfo, model._).dz)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('descriptionBit action')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('fileDesc'),
											$elm$html$Html$Attributes$type_('text'),
											$author$project$CWS$UploadDocuments$onChange($author$project$CWS$UploadDocuments$OneFileDesc),
											$elm$html$Html$Attributes$value(model.bk),
											$elm$html$Html$Attributes$maxlength(500),
											$elm$html$Html$Attributes$placeholder('Enter Description (Optional)')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(upload),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'disabled',
													!$author$project$CWS$UploadDocuments$isNotValid(model.aw))
												])),
											$elm$html$Html$Attributes$class('btn uploadFileBtn'),
											$elm$html$Html$Attributes$disabled(
											disabled_ || (!$author$project$CWS$UploadDocuments$isNotValid(model.aw)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Upload')
										]))
								]))
						]))
				]));
	});
var $author$project$CWS$UploadDocuments$gridView = F3(
	function (cr, model, fileList) {
		var newModel = _Utils_update(
			model,
			{ff: cr});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('uploadDownloadContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('actionboard-subTitle')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(model.eK.dz + ' Dashboard: '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subTitleContent')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('All Documents')
								]))
						])),
					A2($author$project$CWS$UploadDocuments$peFileUploadView, newModel, !model.g4),
					A3(
					$author$project$CWS$UploadDocuments$fileGridView,
					newModel,
					$author$project$CWS$UploadDocuments$colDefs(cr),
					fileList),
					$author$project$CWS$UploadDocuments$confirmCloseView(newModel)
				]));
	});
var $author$project$CWS$Home$totalActionsViewViewView = function (statss) {
	var total = function () {
		if (statss.$ === 2) {
			var stats = statss.a;
			return A3(
				$elm$core$List$foldl,
				function (a) {
					return function (b) {
						return b + a.kX;
					};
				},
				0,
				A2(
					$elm$core$List$filter,
					function (a) {
						return a.jf === 4;
					},
					stats));
		} else {
			return 0;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('totalActions')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Total Approved Actions')
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromFloat(total))
					]))
			]));
};
var $author$project$PlugMapOld$Core$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('ol-map'),
				$elm$html$Html$Attributes$class('map-section')
			]),
		_List_Nil);
};
var $author$project$CWS$Home$mapSubView = F2(
	function (model, stat) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mapContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$CWS$Home$MapMsg,
					$author$project$PlugMapOld$Core$view(model.q)),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Need to explore more about your risk? Go to the '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(model.nl)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Advanced Viewer')
								]))
						])),
					$author$project$CWS$Home$totalActionsViewViewView(stat)
				]));
	});
var $author$project$CWS$Home$titleBarView = F2(
	function (state, year) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('titleBar')
				]),
			function () {
				if (state.$ === 2) {
					var pe = state.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('entity')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(pe.dz + (' Dashboard ' + year))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('commitment')
								]),
							_List_Nil)
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Loading')
								]))
						]);
				}
			}());
	});
var $author$project$CWS$Home$totalActionsView = function (statss) {
	var filtered = function () {
		if (statss.$ === 2) {
			var stats = statss.a;
			return A2(
				$elm$core$List$filter,
				function (a) {
					return a.jf === 4;
				},
				stats);
		} else {
			return _List_Nil;
		}
	}();
	return A2($elm$html$Html$div, _List_Nil, _List_Nil);
};
var $author$project$CWS$Home$miniDashboardSubView = F3(
	function (model, stats, year) {
		var targetCommitment = 654321.0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('miniDashboardContainer')
				]),
			_List_fromArray(
				[
					A2($author$project$CWS$Home$titleBarView, model.cQ, year),
					A2($author$project$Stats$SimpleDisplay$statGridView, model.jd, stats),
					$author$project$CWS$Home$totalActionsView(stats)
				]));
	});
var $author$project$CWS$Home$homeViewWithYear = F3(
	function (model, year, stat) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('homeContainer')
				]),
			_List_fromArray(
				[
					A3($author$project$CWS$Home$miniDashboardSubView, model, stat, year),
					A2($author$project$CWS$Home$mapSubView, model, stat)
				]));
	});
var $author$project$CWS$PeSelect$GotoSelectedPE = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$PeSelect$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$PeSelect$UpdatePE = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$html$Html$Attributes$size = function (n) {
	return A2(
		_VirtualDom_attribute,
		'size',
		$elm$core$String$fromInt(n));
};
var $author$project$CWS$PeSelect$peSelectView = F3(
	function (model, peList, year) {
		var options = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dz;
				},
				$elm$core$String$toLower),
			peList);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('peSelectContainer')
				]),
			($elm$core$List$length(options) > 0) ? _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('peSelectBox action')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Participating Entity')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Manager')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subTitle')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Choose PE to Manage')
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('peSelectDrop'),
									$elm$html$Html$Attributes$size(3),
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2(
										$elm$json$Json$Decode$map,
										function (x) {
											return $author$project$CWS$PeSelect$Internal(
												A2($author$project$CWS$PeSelect$UpdatePE, x, peList));
										},
										$elm$html$Html$Events$targetValue))
								]),
							A2(
								$elm$core$List$map,
								function (x) {
									return A2(
										$elm$html$Html$option,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$value(x.v)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(x.dz)
											]));
								},
								options)),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('peSelectBtn'),
									$elm$html$Html$Events$onClick(
									$author$project$CWS$PeSelect$Internal(
										$author$project$CWS$PeSelect$GotoSelectedPE(peList)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('GO')
								]))
						]))
				]) : _List_fromArray(
				[
					A2($elm$html$Html$div, _List_Nil, _List_Nil)
				]));
	});
var $author$project$CWS$peView = F2(
	function (model, subRt) {
		var targetYear = A2($author$project$CWS$getYearFromPERoute, subRt, model.b.aC);
		var targetPEKey = $author$project$CWS$getPEKeyFromPERoute(subRt);
		var selectedPE = A2($author$project$CWS$getSelectedPE, model, targetPEKey);
		switch (subRt.$) {
			case 6:
				var pe = subRt.a;
				var reportType = subRt.b;
				return A2($author$project$CWS$getReportsView, model, reportType);
			case 0:
				var home = subRt.a;
				return $mdgriffith$elm_ui$Element$html(
					A2(
						$elm$html$Html$map,
						$author$project$CWS$Messages$HomeMsg,
						A3($author$project$CWS$Home$homeViewWithYear, model.a.a2, targetYear, model.b.az)));
			case 1:
				var actions = subRt.a;
				var viewOnly = false;
				var spe = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.kQ;
					},
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (a) {
								return _Utils_eq(a.v, targetYear);
							},
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.cj;
									},
									selectedPE)))));
				var actionBoard = model.a.be;
				var newActionBoard = _Utils_update(
					actionBoard,
					{bK: actions.bK});
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$scrollbarY
						]),
					$mdgriffith$elm_ui$Element$html(
						A2(
							$elm$html$Html$map,
							$author$project$CWS$Messages$ActionBoardMsg,
							A4($author$project$CWS$ActionBoard$actionBoardView, newActionBoard, spe, model.b.az, viewOnly))));
			case 5:
				var peList = function () {
					var _v2 = model.b.D;
					if (_v2.$ === 2) {
						var pes = _v2.a;
						return pes;
					} else {
						return $author$project$CWS$NoPEAssigned;
					}
				}();
				var listPes = function () {
					switch (peList.$) {
						case 1:
							var pe = peList.a;
							return _List_fromArray(
								[pe]);
						case 2:
							var pes = peList.a;
							return pes;
						default:
							return _List_Nil;
					}
				}();
				return $mdgriffith$elm_ui$Element$html(
					A2(
						$elm$html$Html$map,
						$author$project$CWS$peSelectTranslator,
						A3($author$project$CWS$PeSelect$peSelectView, model.a.cS, listPes, 0)));
			case 2:
				return $mdgriffith$elm_ui$Element$html(
					$author$project$CWS$errorView('CWPP Document'));
			case 3:
				return $mdgriffith$elm_ui$Element$html(
					$author$project$CWS$errorView('Participation Agreement'));
			default:
				var pe = subRt.a;
				var oldallDocumentsModel = model.a.U;
				var newallDocumentsModel = _Utils_update(
					oldallDocumentsModel,
					{g4: true});
				var files = function () {
					var _v3 = model.b.aA;
					if (_v3.$ === 2) {
						var f = _v3.a;
						return f;
					} else {
						return _List_Nil;
					}
				}();
				return $mdgriffith$elm_ui$Element$html(
					A2(
						$elm$html$Html$map,
						$author$project$CWS$Messages$FileUploadMsg,
						A3($author$project$CWS$UploadDocuments$gridView, model.a.n, model.a.U, files)));
		}
	});
var $author$project$CWS$contentView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$clip,
				$mdgriffith$elm_ui$Element$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'position', 'relative')),
				$mdgriffith$elm_ui$Element$Font$size(
				A2($author$project$PAM$UI$Basic$scaleFont, model.w, -1))
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'position', 'absolute')),
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'top', '0')),
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'right', '0')),
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'bottom', '0')),
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'left', '0')),
						$mdgriffith$elm_ui$Element$scrollbarY
					]),
				function () {
					var _v0 = model.a.n.z;
					switch (_v0.$) {
						case 4:
							var subRt = _v0.a;
							return A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$scrollbarY
									]),
								A2($author$project$CWS$peView, model, subRt));
						case 5:
							var subRt = _v0.a;
							return A2($author$project$CWS$approverView, model, subRt);
						case 2:
							return $author$project$CWS$aboutView(model);
						case 3:
							var error = _v0.a;
							return $mdgriffith$elm_ui$Element$html(
								$author$project$CWS$errorView(error));
						case 0:
							return $mdgriffith$elm_ui$Element$html($author$project$CWS$loadingView);
						default:
							return $mdgriffith$elm_ui$Element$html(
								$author$project$CWS$errorView('not implemented'));
					}
				}())
			]));
};
var $author$project$CWS$Messages$MenuMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Menu$Absolute = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Menu$appMainLinks = _List_fromArray(
	[
		{
		bA: $author$project$CWS$Menu$Absolute('#/Approver/Dashboard'),
		b9: $elm$core$Maybe$Nothing,
		jr: 'Participating Entities'
	},
		{
		bA: $author$project$CWS$Menu$Absolute('#/Approver/Users'),
		b9: $elm$core$Maybe$Nothing,
		jr: 'Users'
	},
		{
		bA: $author$project$CWS$Menu$Absolute('#/Approver/Actions'),
		b9: $elm$core$Maybe$Nothing,
		jr: 'Action Approver'
	}
	]);
var $author$project$CWS$Menu$RouteRoute = function (a) {
	return {$: 4, a: a};
};
var $author$project$CWS$Menu$makeRouteLink = F2(
	function (title, route) {
		return {
			bA: $author$project$CWS$Menu$RouteRoute(route),
			b9: $elm$core$Maybe$Nothing,
			jr: title
		};
	});
var $author$project$CWS$Menu$makeActionCategoryLink = F3(
	function (category, peKey, year) {
		return A2(
			$author$project$CWS$Menu$makeRouteLink,
			'Wildfire ' + (category + ' Actions'),
			A2(
				$author$project$CWS$Route$makeSimpleFullRoute,
				A3($author$project$CWS$Route$makeActionCategory, peKey, year, category),
				$author$project$CWS$Route$None));
	});
var $author$project$CWS$Route$makeAllDocuments = F2(
	function (peKey, year) {
		return $author$project$CWS$Route$makePEMainRoute(
			$author$project$CWS$Route$PE_AllDocuments(
				{
					d: {d: peKey, r: year}
				}));
	});
var $author$project$CWS$Menu$StaticFileRoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$CWS$Menu$makeStaticFileLink = function (file) {
	return {
		bA: $author$project$CWS$Menu$StaticFileRoute(file),
		b9: function () {
			var _v0 = _Utils_Tuple2(file.mp, file.lv);
			if ((_v0.a === 1) && (!_v0.b.$)) {
				var f = _v0.b.a;
				return $elm$core$Maybe$Just('Exp. ' + f.hp);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		jr: file.dz
	};
};
var $author$project$CWS$Menu$peLinks = F3(
	function (peKey, year, staticFiles) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$append,
				_List_fromArray(
					[
						A2(
						$author$project$CWS$Menu$makeRouteLink,
						'Summary',
						A2(
							$author$project$CWS$Route$makeSimpleFullRoute,
							A2($author$project$CWS$Route$makePEHome, peKey, year),
							$author$project$CWS$Route$None)),
						A3($author$project$CWS$Menu$makeActionCategoryLink, 'Mitigation', peKey, year),
						A3($author$project$CWS$Menu$makeActionCategoryLink, 'Preparedness', peKey, year),
						A3($author$project$CWS$Menu$makeActionCategoryLink, 'Prevention', peKey, year)
					]),
				A2($elm$core$List$map, $author$project$CWS$Menu$makeStaticFileLink, staticFiles)),
			_List_fromArray(
				[
					A2(
					$author$project$CWS$Menu$makeRouteLink,
					'All Documents',
					A2(
						$author$project$CWS$Route$makeSimpleFullRoute,
						A2($author$project$CWS$Route$makeAllDocuments, peKey, year),
						$author$project$CWS$Route$None))
				]));
	});
var $author$project$CWS$Menu$peFromRt = function (rt) {
	var _v0 = rt.z;
	_v0$4:
	while (true) {
		if (_v0.$ === 4) {
			switch (_v0.a.$) {
				case 0:
					var h = _v0.a.a;
					return h;
				case 1:
					var a = _v0.a.a;
					return a.d;
				case 4:
					var d = _v0.a.a;
					return d.d;
				case 6:
					var _v1 = _v0.a;
					var pe = _v1.a;
					return pe;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return {d: 'Unknown', r: '9999'};
};
var $author$project$CWS$Menu$exportReportView = function (currentRoute) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('exportReports')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button btn widgetHeaderBtn'),
						$elm$html$Html$Attributes$href(
						$author$project$CWS$Route$routeToHref(
							A2(
								$author$project$CWS$Route$FullRoute,
								$author$project$CWS$Route$ParticipatingEntity(
									A2(
										$author$project$CWS$Route$Reports,
										$author$project$CWS$Menu$peFromRt(currentRoute),
										0)),
								$author$project$CWS$Route$None)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('EXPORT REPORT')
					]))
			]));
};
var $author$project$CWS$Menu$DownloadFile = function (a) {
	return {$: 1, a: a};
};
var $author$project$CWS$Menu$getPath = function (route) {
	return $author$project$CWS$Route$routeToHref(route);
};
var $author$project$CWS$Menu$getHrefSimple = function (route) {
	switch (route.$) {
		case 1:
			var path = route.a;
			return path;
		case 0:
			var path = route.a;
			return '#' + path;
		case 2:
			var path = route.a;
			return '#' + $author$project$CWS$Menu$getPath(path);
		case 3:
			var pe_ = route.a;
			var year = route.b;
			var path = route.c;
			if (pe_.$ === 2) {
				var pe = pe_.a;
				return '#/PE/' + (pe.v + ('/' + (A2($elm$core$Maybe$withDefault, '0', year) + ('/' + path))));
			} else {
				return '#/' + path;
			}
		case 4:
			var subroute = route.a;
			return $author$project$CWS$Route$routeToHref(subroute);
		default:
			return '';
	}
};
var $author$project$CWS$Menu$listMenuViewSimple = F2(
	function (links, currentRoute) {
		var header = function (link) {
			var _v1 = link.bA;
			if (_v1.$ === 5) {
				var file = _v1.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('menuLink'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'disabled',
								_Utils_eq(file.lv, $elm$core$Maybe$Nothing))
							])),
						$elm$html$Html$Events$onClick(
						$author$project$CWS$Menu$DownloadFile(file)),
						$elm$html$Html$Attributes$href(
						$author$project$CWS$Route$routeToHref(currentRoute))
					]);
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('menuLink'),
						$elm$html$Html$Attributes$href(
						$author$project$CWS$Menu$getHrefSimple(link.bA))
					]);
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('menuLinks')
				]),
			A2(
				$elm$core$List$map,
				function (link) {
					return A2(
						$elm$html$Html$a,
						header(link),
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(link.jr)
										]))
								]),
							function () {
								var _v0 = link.b9;
								if (!_v0.$) {
									var sub = _v0.a;
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('subtitle')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(sub)
												]))
										]);
								} else {
									return _List_Nil;
								}
							}()));
				},
				links));
	});
var $author$project$CWS$Menu$YearChange = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$Menu$yearSelectView = F2(
	function (years, currentRoute) {
		var currentYear = A2(
			$elm$core$Maybe$withDefault,
			'0',
			$author$project$CWS$Route$getYearFromRoute(currentRoute));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('yearSelect action')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Display Year: ')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$on,
							'change',
							A2(
								$elm$json$Json$Decode$map,
								function (newValue) {
									return $author$project$CWS$Menu$YearChange(newValue);
								},
								$elm$html$Html$Events$targetValue))
						]),
					A2(
						$elm$core$List$map,
						function (year) {
							return A2(
								$elm$html$Html$option,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(year.v),
										$elm$html$Html$Attributes$selected(
										_Utils_eq(year.v, currentYear))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(year.dz)
									]));
						},
						years))
				]));
	});
var $author$project$CWS$Menu$view = F3(
	function (links, currentRoute, years) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = currentRoute.z;
					switch (_v0.$) {
						case 5:
							return $elm$html$Html$text('');
						case 2:
							return $elm$html$Html$text('');
						default:
							return A2($author$project$CWS$Menu$yearSelectView, years, currentRoute);
					}
				}(),
					A2($author$project$CWS$Menu$listMenuViewSimple, links, currentRoute),
					function () {
					var _v1 = currentRoute.z;
					switch (_v1.$) {
						case 5:
							return $elm$html$Html$text('');
						case 2:
							return $elm$html$Html$text('');
						default:
							return $author$project$CWS$Menu$exportReportView(currentRoute);
					}
				}()
				]));
	});
var $author$project$CWS$menuSubView = function (model) {
	var _v0 = model.a.n.z;
	if (_v0.$ === 2) {
		return $mdgriffith$elm_ui$Element$none;
	} else {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$clip,
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, model.w, 1))
				]),
			$mdgriffith$elm_ui$Element$html(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('cwsMenu'),
							$elm$html$Html$Attributes$id('menu')
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = model.a.n.z;
							switch (_v1.$) {
								case 4:
									var rt = _v1.a;
									var targetPEKey = $author$project$CWS$getPEKeyFromPERoute(rt);
									var selectedPE = A2($author$project$CWS$getSelectedPE, model, targetPEKey);
									var peStaticFiles = function () {
										var _v3 = A2($elm$core$Dict$get, targetPEKey, model.b.aE);
										if ((!_v3.$) && (_v3.a.$ === 2)) {
											var files = _v3.a.a;
											return files;
										} else {
											return _List_Nil;
										}
									}();
									if (!selectedPE.$) {
										var pe = selectedPE.a;
										return A2(
											$elm$html$Html$map,
											$author$project$CWS$Messages$MenuMsg,
											A3(
												$author$project$CWS$Menu$view,
												A3($author$project$CWS$Menu$peLinks, pe.v, model.a.r, peStaticFiles),
												model.a.n,
												pe.cj));
									} else {
										return A2(
											$elm$html$Html$map,
											$author$project$CWS$Messages$MenuMsg,
											A3($author$project$CWS$Menu$view, _List_Nil, model.a.n, _List_Nil));
									}
								case 5:
									var appRt = _v1.a;
									return A2(
										$elm$html$Html$map,
										$author$project$CWS$Messages$MenuMsg,
										A3($author$project$CWS$Menu$view, $author$project$CWS$Menu$appMainLinks, model.a.n, _List_Nil));
								case 2:
									return $elm$html$Html$text('');
								default:
									return A2(
										$elm$html$Html$map,
										$author$project$CWS$Messages$MenuMsg,
										A3($author$project$CWS$Menu$view, _List_Nil, model.a.n, _List_Nil));
							}
						}()
						]))));
	}
};
var $author$project$CWS$Messages$CloseModal = {$: 16};
var $mdgriffith$elm_ui$Element$rgba255 = F4(
	function (red, green, blue, a) {
		return A4($mdgriffith$elm_ui$Internal$Model$Rgba, red / 255, green / 255, blue / 255, a);
	});
var $author$project$PAM$UI$Basic$transparent = function (pct) {
	return A4($mdgriffith$elm_ui$Element$rgba255, 0, 0, 0, pct);
};
var $author$project$PAM$UI$Basic$transparent25 = $author$project$PAM$UI$Basic$transparent(0.25);
var $author$project$CWS$DynamicModal$elementView = F8(
	function (model, windowSize, modalSize, bodyView, footerView, mapper, title, closeMsg) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width(
					A2($mdgriffith$elm_ui$Element$maximum, modalSize.jR, $mdgriffith$elm_ui$Element$fill)),
					$mdgriffith$elm_ui$Element$height(
					A2($mdgriffith$elm_ui$Element$maximum, modalSize.kT + modalSize.lH, $mdgriffith$elm_ui$Element$fill)),
					$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$transparent25),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, windowSize, -1)),
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$clip
				]),
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(modalSize.lH)),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$pineTree),
								$mdgriffith$elm_ui$Element$Font$color(
								A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1))
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$centerY,
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
										$mdgriffith$elm_ui$Element$padding(15),
										$mdgriffith$elm_ui$Element$Font$size(
										A2($author$project$PAM$UI$Basic$scaleFont, windowSize, 3))
									]),
								$mdgriffith$elm_ui$Element$text(title)),
								A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$alignRight,
										$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
									]),
								A2(
									$mdgriffith$elm_ui$Element$Input$button,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width(
											$mdgriffith$elm_ui$Element$px(modalSize.lH)),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
											$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
											$mdgriffith$elm_ui$Element$alignRight
										]),
									{
										h3: A2(
											$mdgriffith$elm_ui$Element$row,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$centerX,
													$mdgriffith$elm_ui$Element$centerY,
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$Font$size(22)
												]),
											_List_fromArray(
												[
													$author$project$PAM$UI$Basic$centeredIcon('fa fa-times')
												])),
										ip: $elm$core$Maybe$Just(closeMsg)
									}))
							])),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$Background$color(
								A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1)),
								$mdgriffith$elm_ui$Element$clip
							]),
						mapper(
							bodyView(model))),
						A2(
						$elm$core$Maybe$withDefault,
						$mdgriffith$elm_ui$Element$none,
						A2(
							$elm$core$Maybe$map,
							mapper,
							A2(
								$elm$core$Maybe$map,
								$mdgriffith$elm_ui$Element$el(
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$height(
											$mdgriffith$elm_ui$Element$px(50)),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$Background$color(
											A3($mdgriffith$elm_ui$Element$rgb255, 32, 61, 5)),
											$mdgriffith$elm_ui$Element$padding(15),
											$mdgriffith$elm_ui$Element$Font$color(
											A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1)),
											$mdgriffith$elm_ui$Element$Border$widthEach(
											{kx: 0, me: 0, nA: 0, os: 1}),
											$mdgriffith$elm_ui$Element$Border$color(
											A3($mdgriffith$elm_ui$Element$rgb, 0, 0, 0))
										])),
								footerView(model))))
					])));
	});
var $author$project$CWS$getActionModel = F3(
	function (model, id, catgrp) {
		return model.a.x;
	});
var $author$project$CWS$ActionDetail$confirmView = function (model) {
	var _v0 = model.aJ;
	switch (_v0.$) {
		case 1:
			var title = _v0.a;
			var question = _v0.b;
			var description = _v0.c;
			var confirmName = _v0.d;
			var confirmMsg = _v0.e;
			var cancelName = _v0.f;
			var cancelMsg = _v0.g;
			var id = _v0.h;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirmWrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('confirm')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(title)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('body')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('description')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(description)
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('question')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(question)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('actions')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('confirmAction'),
														$elm$html$Html$Events$onClick(
														confirmMsg(id))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(confirmName)
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('cancelAction'),
														$elm$html$Html$Events$onClick(
														cancelMsg(id))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(cancelName)
													]))
											]))
									]))
							]))
					]));
		case 2:
			var title = _v0.a;
			var question = _v0.b;
			var description = _v0.c;
			var confirmName = _v0.d;
			var confirmMsg = _v0.e;
			var id = _v0.f;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirmWrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('confirm')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(title)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('body')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('description')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(description)
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('question')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(question)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('actions')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('confirmAction'),
														$elm$html$Html$Events$onClick(
														confirmMsg(id))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(confirmName)
													]))
											]))
									]))
							]))
					]));
		default:
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	}
};
var $author$project$CWS$ActionDetail$approveNoteFieldFancy = _Utils_Tuple3(
	A2($author$project$CWS$ActionDetail$makeBasicInfo, '', true),
	$author$project$Fields$Shared$NoValidation,
	$author$project$Fields$GenericField$Custom(
		$author$project$Fields$CustomField$CustomField(
			function (readOnly) {
				return function (action) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Fields marked with a ')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('requiredLabel')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' are required to deny')
									]))
							]));
				};
			})));
var $author$project$CWS$ActionDetail$approverFieldsFancy = F2(
	function (readOnly, model) {
		return _Utils_ap(
			function () {
				var _v0 = model.c;
				if (_v0.$ === 2) {
					var action = _v0.a;
					var _v1 = _Utils_Tuple2(action.bK.ab, action.jE.ab);
					switch (_v1.b) {
						case 10:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField,
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 11:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 20:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										A2(
										$author$project$CWS$ActionDetail$acresFieldFancy,
										readOnly,
										$author$project$CWS$ActionDetail$actionHasSpatial(model.c)),
										$author$project$CWS$ActionDetail$biomassFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 21:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										A2(
										$author$project$CWS$ActionDetail$acresFieldFancy,
										readOnly,
										$author$project$CWS$ActionDetail$actionHasSpatial(model.c))
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 22:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 23:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField,
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 24:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										A2(
										$author$project$CWS$ActionDetail$acresFieldFancy,
										readOnly,
										$author$project$CWS$ActionDetail$actionHasSpatial(model.c))
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 30:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 31:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField,
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 32:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField,
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 33:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						case 34:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
						default:
							return _List_fromArray(
								[
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$nameFieldFancy(readOnly)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$typeChoiceField, readOnly, model.k)
									]),
									_List_fromArray(
									[
										A2($author$project$CWS$ActionDetail$customStartDatePickerField, model, readOnly),
										A2($author$project$CWS$ActionDetail$customEndDatePickerField, model, readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$biomassFieldFancy(readOnly),
										A2(
										$author$project$CWS$ActionDetail$acresFieldFancy,
										readOnly,
										$author$project$CWS$ActionDetail$actionHasSpatial(model.c))
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$costFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$hoursFieldFancy(readOnly),
										$author$project$CWS$ActionDetail$noField
									]),
									_List_fromArray(
									[
										$author$project$CWS$ActionDetail$descriptionFieldFancy(readOnly)
									])
								]);
					}
				} else {
					return _List_Nil;
				}
			}(),
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$CWS$ActionDetail$notesFieldFancy(false)
					]),
					_List_fromArray(
					[$author$project$CWS$ActionDetail$approveNoteFieldFancy])
				]));
	});
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Fields$MaybeStringField$toMaybeString = function (input) {
	return (!$elm$core$String$length(input)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(input);
};
var $author$project$Fields$MaybeStringField$longView = F4(
	function (field, readOnly, validation, data) {
		var _v0 = field.a1(data);
		var val = _v0.a;
		var _default = _v0.b;
		var displayValue = A2(
			$elm$core$Maybe$withDefault,
			readOnly ? _default : '',
			val);
		return A2(
			$elm$html$Html$textarea,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Events$onInput(
					function (a) {
						return A2(
							field.dI,
							data,
							$author$project$Fields$MaybeStringField$toMaybeString(a));
					}),
					$elm$html$Html$Attributes$disabled(readOnly),
					$elm$html$Html$Attributes$value(displayValue)
				]),
			_List_Nil);
	});
var $author$project$Fields$StringField$longView = F4(
	function (field, readOnly, validation, data) {
		return A2(
			$elm$html$Html$textarea,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Attributes$value(
					field.a1(data)),
					$elm$html$Html$Events$onInput(
					field.dI(data)),
					$elm$html$Html$Attributes$disabled(readOnly)
				]),
			_List_Nil);
	});
var $author$project$Fields$CustomField$view = F4(
	function (field, readOnly, validation, data) {
		return A2(field.a1, readOnly, data);
	});
var $author$project$Fields$DateField$split = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, 'T', input)));
};
var $author$project$Fields$DateField$view = F4(
	function (field, readOnly, validation, data) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('date'),
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Attributes$value(
					field.a1(data)),
					$elm$html$Html$Events$onInput(
					function (a) {
						return A2(field.dI, data, a);
					}),
					$elm$html$Html$Attributes$disabled(readOnly)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Fields$DateField$split(
						field.a1(data)))
				]));
	});
var $author$project$Fields$FloatField$view = F4(
	function (field, readOnly, validation, data) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('number'),
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromFloat(
						field.a1(data))),
					$elm$html$Html$Events$onInput(
					function (a) {
						return A2(
							field.dI,
							data,
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toFloat(a)));
					}),
					$elm$html$Html$Attributes$disabled(readOnly)
				]),
			_List_Nil);
	});
var $author$project$Fields$IntField$view = F4(
	function (field, readOnly, validation, data) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('number'),
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(
						field.a1(data))),
					$elm$html$Html$Events$onInput(
					function (a) {
						return A2(
							field.dI,
							data,
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(a)));
					}),
					$elm$html$Html$Attributes$disabled(readOnly)
				]),
			_List_Nil);
	});
var $author$project$Fields$MaybeDateField$split = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2($elm$core$String$split, 'T', input)));
};
var $author$project$Fields$MaybeDateField$toMaybeString = function (input) {
	return (!$elm$core$String$length(input)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(input);
};
var $author$project$Fields$MaybeDateField$view = F4(
	function (field, readOnly, validation, data) {
		var _v0 = field.a1(data);
		var val = _v0.a;
		var _default = _v0.b;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'type',
					(readOnly && _Utils_eq(val, $elm$core$Maybe$Nothing)) ? 'test' : 'date'),
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Attributes$value(
					function () {
						if (val.$ === 1) {
							return readOnly ? _default : '';
						} else {
							var v = val.a;
							return $author$project$Fields$MaybeDateField$split(v);
						}
					}()),
					$elm$html$Html$Events$onInput(
					function (a) {
						return A2(
							field.dI,
							data,
							$author$project$Fields$MaybeDateField$toMaybeString(a));
					}),
					$elm$html$Html$Attributes$disabled(readOnly)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						if (val.$ === 1) {
							return readOnly ? _default : '';
						} else {
							var v = val.a;
							return $author$project$Fields$MaybeDateField$split(v);
						}
					}())
				]));
	});
var $author$project$Fields$Shared$toMaybeString = function (input) {
	return (!$elm$core$String$length(input)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(input);
};
var $author$project$Fields$MaybeFloatField$view = F2(
	function (config, field) {
		var fieldData = config.ls;
		var isReadOnly = config.l1;
		var _v0 = field.a1(fieldData);
		var val = _v0.a;
		var _default = _v0.b;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_(
					(isReadOnly && _Utils_eq(val, $author$project$Fields$Shared$NotEntered)) ? 'text' : 'text'),
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Attributes$maxlength(
					function () {
						var _v1 = field.id;
						if (!_v1.$) {
							var something = _v1.a;
							return something + A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$map, $elm$core$String$length, field.iE));
						} else {
							return -1;
						}
					}()),
					$elm$html$Html$Attributes$value(
					function () {
						switch (val.$) {
							case 0:
								return isReadOnly ? _Utils_ap(
									A2($elm$core$Maybe$withDefault, '', field.iE),
									_default) : '';
							case 1:
								var val_ = val.a;
								var text_ = val.b;
								return _Utils_ap(
									A2($elm$core$Maybe$withDefault, '', field.iE),
									text_);
							default:
								var text_ = val.a;
								return _Utils_ap(
									A2($elm$core$Maybe$withDefault, '', field.iE),
									text_);
						}
					}()),
					$elm$html$Html$Events$onInput(
					function (z) {
						var a = function () {
							var _v7 = field.iE;
							if (_v7.$ === 1) {
								return z;
							} else {
								var something = _v7.a;
								return A2($elm$core$String$startsWith, something, z) ? A2(
									$elm$core$String$right,
									$elm$core$String$length(z) - $elm$core$String$length(something),
									z) : z;
							}
						}();
						var ms = $author$project$Fields$Shared$toMaybeString(
							A2(
								$elm$core$Maybe$withDefault,
								a,
								A2(
									$elm$core$Maybe$map,
									function (v) {
										if (_Utils_cmp(
											$elm$core$String$length(a),
											v) > 0) {
											switch (val.$) {
												case 0:
													return isReadOnly ? _default : '';
												case 1:
													var val_ = val.a;
													var text_ = val.b;
													return A2(
														$elm$core$Maybe$withDefault,
														text_,
														A2(
															$elm$core$Maybe$map,
															function (r) {
																var _v6 = _Utils_Tuple2(r.mk, r.mj);
																if (!_v6.a.$) {
																	if (!_v6.b.$) {
																		var min = _v6.a.a;
																		var max = _v6.b.a;
																		return (_Utils_cmp(val_, min) < 0) ? $elm$core$String$fromFloat(min) : ((_Utils_cmp(val_, max) > 0) ? $elm$core$String$fromFloat(max) : text_);
																	} else {
																		var min = _v6.a.a;
																		return (_Utils_cmp(val_, min) < 0) ? $elm$core$String$fromFloat(min) : text_;
																	}
																} else {
																	if (!_v6.b.$) {
																		var max = _v6.b.a;
																		return (_Utils_cmp(val_, max) > 0) ? $elm$core$String$fromFloat(max) : text_;
																	} else {
																		return text_;
																	}
																}
															},
															field.iM));
												default:
													var text_ = val.a;
													return text_;
											}
										} else {
											return a;
										}
									},
									field.id)));
						var parsedValue = function () {
							if (!ms.$) {
								var s = ms.a;
								return $elm$core$String$toFloat(s);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var _v3 = _Utils_Tuple2(ms, parsedValue);
						if (!_v3.a.$) {
							if (!_v3.b.$) {
								var text = _v3.a.a;
								var value = _v3.b.a;
								return A2(
									field.dI,
									fieldData,
									A2($author$project$Fields$Shared$Valid, value, text));
							} else {
								var text = _v3.a.a;
								return A2(
									field.dI,
									fieldData,
									$author$project$Fields$Shared$Invalid(text));
							}
						} else {
							return A2(field.dI, fieldData, $author$project$Fields$Shared$NotEntered);
						}
					}),
					$elm$html$Html$Attributes$disabled(isReadOnly)
				]),
			_List_Nil);
	});
var $author$project$Fields$MaybeStringField$view = F4(
	function (field, readOnly, validation, data) {
		var _v0 = field.a1(data);
		var val = _v0.a;
		var _default = _v0.b;
		var displayValue = A2(
			$elm$core$Maybe$withDefault,
			readOnly ? _default : '',
			val);
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text'),
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Attributes$value(displayValue),
					$elm$html$Html$Events$onInput(
					function (a) {
						return A2(
							field.dI,
							data,
							$author$project$Fields$MaybeStringField$toMaybeString(a));
					}),
					$elm$html$Html$Attributes$disabled(readOnly)
				]),
			_List_Nil);
	});
var $author$project$Fields$SingleChoiceField$view = F4(
	function (field, readOnly, validation, data) {
		return A2(
			$elm$html$Html$select,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('input'),
					A2(
					$elm$html$Html$Events$on,
					'change',
					A2(
						$elm$json$Json$Decode$map,
						function (newValue) {
							return A2(
								field.dI,
								data,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (_v0) {
											var key = _v0.a;
											var value = _v0.b;
											return _Utils_eq(key, newValue);
										},
										field.m6)));
						},
						$elm$html$Html$Events$targetValue)),
					$elm$html$Html$Attributes$value(
					function (_v1) {
						var a = _v1.a;
						var b = _v1.b;
						return a;
					}(
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2('-1', 'Not Selected'),
							field.a1(data)))),
					$elm$html$Html$Attributes$disabled(readOnly)
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var key = _v2.a;
					var val = _v2.b;
					return A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(key)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(val)
							]));
				},
				field.m6));
	});
var $author$project$Fields$StringField$view = F4(
	function (field, readOnly, validation, data) {
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text'),
					$elm$html$Html$Attributes$class('input'),
					$elm$html$Html$Attributes$value(
					field.a1(data)),
					$elm$html$Html$Events$onInput(
					field.dI(data)),
					$elm$html$Html$Attributes$disabled(readOnly)
				]),
			_List_Nil);
	});
var $author$project$Fields$GenericField$view = F4(
	function (basic, field, validation, data) {
		var _v0 = function () {
			switch (validation.$) {
				case 0:
					return _Utils_Tuple2(false, false);
				case 1:
					var rule = validation.a;
					return _Utils_Tuple2(
						true,
						!rule(data));
				default:
					var rule = validation.a;
					return _Utils_Tuple2(
						false,
						!rule(data));
			}
		}();
		var required = _v0.a;
		var invalid = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field string'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('required', required),
							_Utils_Tuple2('invalid', invalid)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title')
						]),
					(!required) ? _List_fromArray(
						[
							$elm$html$Html$text(basic.dz)
						]) : _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('requiredLabel')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('*')
								])),
							$elm$html$Html$text(basic.dz)
						])),
					function () {
					switch (field.$) {
						case 0:
							var sf = field.a;
							return A4($author$project$Fields$StringField$view, sf, basic.nq, validation, data);
						case 1:
							var sf = field.a;
							return A4($author$project$Fields$StringField$longView, sf, basic.nq, validation, data);
						case 2:
							var sf = field.a;
							return A4($author$project$Fields$MaybeStringField$view, sf, basic.nq, validation, data);
						case 3:
							var sf = field.a;
							return A4($author$project$Fields$MaybeStringField$longView, sf, basic.nq, validation, data);
						case 4:
							var intf = field.a;
							return A4($author$project$Fields$IntField$view, intf, basic.nq, validation, data);
						case 5:
							var ff = field.a;
							return A4($author$project$Fields$FloatField$view, ff, basic.nq, validation, data);
						case 6:
							var ff = field.a;
							return A2(
								$author$project$Fields$MaybeFloatField$view,
								{ls: data, lt: $elm$core$Maybe$Nothing, l1: basic.nq, l2: false, l3: true},
								ff);
						case 7:
							var ff = field.a;
							return A4($author$project$Fields$DateField$view, ff, basic.nq, validation, data);
						case 8:
							var ff = field.a;
							return A4($author$project$Fields$MaybeDateField$view, ff, basic.nq, validation, data);
						case 9:
							var sc = field.a;
							return A4($author$project$Fields$SingleChoiceField$view, sc, basic.nq, validation, data);
						default:
							var cu = field.a;
							return A4($author$project$Fields$CustomField$view, cu, basic.nq, validation, data);
					}
				}()
				]));
	});
var $author$project$CWS$ActionDetail$newFieldRowViewFancy = F2(
	function (row, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flexRow row')
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var basic = _v0.a;
					var validation = _v0.b;
					var field = _v0.c;
					return A4($author$project$Fields$GenericField$view, basic, field, validation, data);
				},
				row));
	});
var $author$project$CWS$ActionDetail$staticDetailsViewNew = F2(
	function (item, fancyFields) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fields')
						]),
					A2(
						$elm$core$List$map,
						function (fieldRow) {
							return A2($author$project$CWS$ActionDetail$newFieldRowViewFancy, fieldRow, item);
						},
						fancyFields))
				]));
	});
var $author$project$CWS$ActionDetail$staticDetailsView = function (model) {
	var _v0 = model.bd;
	switch (_v0) {
		case 1:
			var item = function () {
				var _v2 = model.c;
				if (_v2.$ === 2) {
					var e = _v2.a;
					return e;
				} else {
					return $author$project$CWS$Model$blankActionModel;
				}
			}();
			return A2(
				$author$project$CWS$ActionDetail$staticDetailsViewNew,
				item,
				A2(
					$author$project$CWS$ActionDetail$peFieldsFancy,
					function () {
						var _v1 = model.c;
						if (_v1.$ === 2) {
							var action = _v1.a;
							return !$author$project$CWS$ActionDetail$canEdit(action);
						} else {
							return false;
						}
					}(),
					model));
		case 2:
			var item = function () {
				var _v3 = model.c;
				if (_v3.$ === 2) {
					var e = _v3.a;
					return e;
				} else {
					return $author$project$CWS$Model$blankActionModel;
				}
			}();
			return A2(
				$author$project$CWS$ActionDetail$staticDetailsViewNew,
				item,
				A2($author$project$CWS$ActionDetail$approverFieldsFancy, true, model));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('hello')
					]));
	}
};
var $author$project$CWS$ActionDetail$detailsView = function (model) {
	return $mdgriffith$elm_ui$Element$html(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flexColumn action')
				]),
			_List_fromArray(
				[
					$author$project$CWS$ActionDetail$staticDetailsView(model)
				])));
};
var $author$project$CWS$DrawEditMap$ToggleToolbox = {$: 19};
var $author$project$CWS$DrawEditMap$calculateToolboxContentHeight = F2(
	function (env, extraPadding) {
		var zoomButtonHeight = 50;
		var spacing = 5;
		var padding = 10;
		var max = 500;
		var buttonSize = 25;
		var cHeight = ((((env.kS.lI - zoomButtonHeight) - (padding * 2)) - buttonSize) - spacing) - (extraPadding * 2);
		var height = (_Utils_cmp(cHeight, max) > 0) ? max : cHeight;
		return A2($mdgriffith$elm_ui$Element$maximum, height, $mdgriffith$elm_ui$Element$shrink);
	});
var $author$project$CWS$DrawEditMap$calculateToolboxHeight = function (env) {
	var zoomButtonHeight = 50;
	var padding = 10;
	var max = 500;
	var cHeight = (env.kS.lI - zoomButtonHeight) - (padding * 2);
	var height = (_Utils_cmp(cHeight, max) > 0) ? max : cHeight;
	return A2($mdgriffith$elm_ui$Element$maximum, height, $mdgriffith$elm_ui$Element$shrink);
};
var $author$project$CWS$DrawEditMap$areaViewEl = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_Nil,
		$mdgriffith$elm_ui$Element$text(
			'Total Acres: ' + function (a) {
				return (a === '0.00') ? '< 0.01' : a;
			}(
				A2(
					$elm$core$Maybe$withDefault,
					'-',
					A2(
						$elm$core$Maybe$map,
						$cuducos$elm_format_number$FormatNumber$format($cuducos$elm_format_number$FormatNumber$Locales$usLocale),
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$String$toFloat,
							A2(
								$elm$core$Maybe$map,
								$myrho$elm_round$Round$floor(2),
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.bH;
									},
									model.ay))))))));
};
var $author$project$CWS$DrawEditMap$maybeAreaView = F3(
	function (env, model, isReadOnly) {
		return (!_Utils_eq(model.ay, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
			$author$project$CWS$DrawEditMap$areaViewEl(model)) : $elm$core$Maybe$Nothing;
	});
var $author$project$CWS$DrawEditMap$maybeEditNotice = F3(
	function (env, model, isReadOnly) {
		return ((!isReadOnly) && ($elm$core$List$length(model.cZ) > 0)) ? $elm$core$Maybe$Just(
			A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$size(
						A2($author$project$PAM$UI$Basic$scaleFont, env.w, -2)),
						$mdgriffith$elm_ui$Element$spacing(4)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$Font$center]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('Drag a vertex to move it. Hold Alt and click a vertex to delete it. Click and drag from a line segment to add a new vertex. Click Select in the table above to edit a specific part.')
							]))
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$CWS$DrawEditMap$noShapeNotice = function (env) {
	return A2(
		$mdgriffith$elm_ui$Element$paragraph,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size(
				A2($author$project$PAM$UI$Basic$scaleFont, env.w, -2)),
				$mdgriffith$elm_ui$Element$Font$center,
				$mdgriffith$elm_ui$Element$centerX,
				$mdgriffith$elm_ui$Element$centerY
			]),
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$text('No geometry has been created for this item.')
			]));
};
var $author$project$CWS$DrawEditMap$Delete = function (a) {
	return {$: 15, a: a};
};
var $author$project$CWS$DrawEditMap$SelectItem = function (a) {
	return {$: 14, a: a};
};
var $author$project$CWS$DrawEditMap$ZoomTo = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$CWS$DrawEditMap$shapeTableEl = F3(
	function (windowConfig, model, isReadOnly) {
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					$mdgriffith$elm_ui$Element$padding(4),
					$mdgriffith$elm_ui$Element$inFront(
					model.e_ ? A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$Background$color(
								A2($author$project$PAM$UI$Basic$fadeColor, 0.25, $author$project$PAM$UI$Basic$black)),
								$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white)
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
								]),
							$mdgriffith$elm_ui$Element$text('Recalculating'))) : $mdgriffith$elm_ui$Element$none)
				]),
			A2(
				$mdgriffith$elm_ui$Element$indexedTable,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color(
						A4($mdgriffith$elm_ui$Element$rgba255, 130, 151, 80, 0.32)),
						$mdgriffith$elm_ui$Element$Font$color(
						A4($mdgriffith$elm_ui$Element$rgba255, 255, 255, 255, 1)),
						$mdgriffith$elm_ui$Element$padding(10),
						$mdgriffith$elm_ui$Element$Border$rounded(3),
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink)
					]),
				{
					kP: _List_fromArray(
						[
							{
							hN: A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Border$widthEach(
										{kx: 1, me: 0, nA: 0, os: 0}),
										$mdgriffith$elm_ui$Element$padding(4),
										$mdgriffith$elm_ui$Element$alignLeft
									]),
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignLeft]),
									$mdgriffith$elm_ui$Element$text('Parts'))),
							oH: function (index) {
								return function (spatial) {
									return A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$padding(4)
											]),
										A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$alignLeft]),
											$mdgriffith$elm_ui$Element$text(
												'Part ' + $elm$core$String$fromInt(
													A2($elm$core$Maybe$withDefault, 1, spatial.ab)))));
								};
							},
							jR: $mdgriffith$elm_ui$Element$fill
						},
							{
							hN: A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Border$widthEach(
										{kx: 1, me: 0, nA: 0, os: 0}),
										$mdgriffith$elm_ui$Element$padding(4)
									]),
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignLeft]),
									$mdgriffith$elm_ui$Element$text('Acres'))),
							oH: function (index) {
								return function (spatial) {
									return A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$padding(4)
											]),
										A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$alignLeft]),
											$mdgriffith$elm_ui$Element$text(
												function (a) {
													return (a === '0.00') ? '< 0.01' : a;
												}(
													A2(
														$elm$core$Maybe$withDefault,
														'< 0.01',
														A2(
															$elm$core$Maybe$map,
															$cuducos$elm_format_number$FormatNumber$format($cuducos$elm_format_number$FormatNumber$Locales$usLocale),
															$elm$core$String$toFloat(
																A2($myrho$elm_round$Round$floor, 2, spatial.bH))))))));
								};
							},
							jR: $mdgriffith$elm_ui$Element$fill
						},
							{
							hN: A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$Border$widthEach(
										{kx: 1, me: 0, nA: 0, os: 0}),
										$mdgriffith$elm_ui$Element$padding(4),
										$mdgriffith$elm_ui$Element$alignLeft,
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
									]),
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[$mdgriffith$elm_ui$Element$alignLeft]),
									$mdgriffith$elm_ui$Element$text(' '))),
							oH: function (index) {
								return function (spatial) {
									var titledBtn = F2(
										function (txt, msg) {
											return A2(
												$mdgriffith$elm_ui$Element$Input$button,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$htmlAttribute(
														$elm$html$Html$Attributes$title(txt))
													]),
												{
													h3: $mdgriffith$elm_ui$Element$text(txt),
													ip: $elm$core$Maybe$Just(
														$author$project$CWS$DrawEditMap$Internal(
															$author$project$CWS$DrawEditMap$Toolbox(msg)))
												});
										});
									var spatialId = A2($elm$core$Maybe$withDefault, 1, spatial.ab);
									var zoomBtn = A2(
										titledBtn,
										'Zoom',
										A3($author$project$CWS$DrawEditMap$ZoomTo, spatialId, 0, 0));
									var geomBtns = isReadOnly ? _List_fromArray(
										[zoomBtn]) : _List_fromArray(
										[
											A2(
											titledBtn,
											'Delete',
											$author$project$CWS$DrawEditMap$Delete(spatialId)),
											A2(
											$mdgriffith$elm_ui$Element$el,
											_List_Nil,
											$mdgriffith$elm_ui$Element$text('|')),
											_Utils_eq(
											model.P,
											$elm$core$Maybe$Just(spatialId)) ? A2(
											titledBtn,
											'Deselect',
											$author$project$CWS$DrawEditMap$SelectItem(spatialId)) : A2(
											titledBtn,
											'Select',
											$author$project$CWS$DrawEditMap$SelectItem(spatialId)),
											A2(
											$mdgriffith$elm_ui$Element$el,
											_List_Nil,
											$mdgriffith$elm_ui$Element$text('|')),
											zoomBtn
										]);
									return A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$padding(4),
												$mdgriffith$elm_ui$Element$alignLeft,
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
											]),
										A2(
											$mdgriffith$elm_ui$Element$row,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$alignRight,
													$mdgriffith$elm_ui$Element$spacing(4)
												]),
											geomBtns));
								};
							},
							jR: $mdgriffith$elm_ui$Element$fill
						}
						]),
					k1: model.cZ
				}));
	});
var $author$project$CWS$DrawEditMap$maybeShapesTable = F3(
	function (windowConfig, model, isReadOnly) {
		return $elm$core$Maybe$Just(
			A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(
						A2($mdgriffith$elm_ui$Element$minimum, 20, $mdgriffith$elm_ui$Element$shrink)),
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$centerX
					]),
				($elm$core$List$length(model.cZ) > 0) ? A3($author$project$CWS$DrawEditMap$shapeTableEl, windowConfig, model, isReadOnly) : $author$project$CWS$DrawEditMap$noShapeNotice(windowConfig)));
	});
var $author$project$CWS$DrawEditMap$Line = 2;
var $author$project$CWS$DrawEditMap$Point = 1;
var $author$project$CWS$DrawEditMap$Polygon = 3;
var $author$project$CWS$DrawEditMap$UpdateBuffer = function (a) {
	return {$: 10, a: a};
};
var $mdgriffith$elm_ui$Element$Input$Thumb = $elm$core$Basics$identity;
var $mdgriffith$elm_ui$Element$Input$defaultThumb = _List_fromArray(
	[
		$mdgriffith$elm_ui$Element$width(
		$mdgriffith$elm_ui$Element$px(16)),
		$mdgriffith$elm_ui$Element$height(
		$mdgriffith$elm_ui$Element$px(16)),
		$mdgriffith$elm_ui$Element$Border$rounded(8),
		$mdgriffith$elm_ui$Element$Border$width(1),
		$mdgriffith$elm_ui$Element$Border$color(
		A3($mdgriffith$elm_ui$Element$rgb, 0.5, 0.5, 0.5)),
		$mdgriffith$elm_ui$Element$Background$color(
		A3($mdgriffith$elm_ui$Element$rgb, 1, 1, 1))
	]);
var $mdgriffith$elm_ui$Internal$Flag$active = $mdgriffith$elm_ui$Internal$Flag$flag(32);
var $mdgriffith$elm_ui$Internal$Flag$focus = $mdgriffith$elm_ui$Internal$Flag$flag(31);
var $mdgriffith$elm_ui$Internal$Model$getHeight = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (attr, acc) {
				if (!acc.$) {
					var x = acc.a;
					return $elm$core$Maybe$Just(x);
				} else {
					if (attr.$ === 8) {
						var len = attr.a;
						return $elm$core$Maybe$Just(len);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			}),
		$elm$core$Maybe$Nothing,
		attrs);
};
var $mdgriffith$elm_ui$Internal$Model$getWidth = function (attrs) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (attr, acc) {
				if (!acc.$) {
					var x = acc.a;
					return $elm$core$Maybe$Just(x);
				} else {
					if (attr.$ === 7) {
						var len = attr.a;
						return $elm$core$Maybe$Just(len);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			}),
		$elm$core$Maybe$Nothing,
		attrs);
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $mdgriffith$elm_ui$Internal$Model$mapAttr = F2(
	function (fn, attr) {
		switch (attr.$) {
			case 0:
				return $mdgriffith$elm_ui$Internal$Model$NoAttribute;
			case 2:
				var description = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Describe(description);
			case 6:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignX(x);
			case 5:
				var y = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$AlignY(y);
			case 7:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Width(x);
			case 8:
				var x = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Height(x);
			case 3:
				var x = attr.a;
				var y = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$Class, x, y);
			case 4:
				var flag = attr.a;
				var style = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$StyleClass, flag, style);
			case 9:
				var location = attr.a;
				var elem = attr.b;
				return A2(
					$mdgriffith$elm_ui$Internal$Model$Nearby,
					location,
					A2($mdgriffith$elm_ui$Internal$Model$map, fn, elem));
			case 1:
				var htmlAttr = attr.a;
				return $mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$virtual_dom$VirtualDom$mapAttribute, fn, htmlAttr));
			default:
				var fl = attr.a;
				var trans = attr.b;
				return A2($mdgriffith$elm_ui$Internal$Model$TransformComponent, fl, trans);
		}
	});
var $mdgriffith$elm_ui$Element$Input$viewHorizontalThumb = F3(
	function (factor, thumbAttributes, trackHeight) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					A2($elm$core$Maybe$withDefault, $mdgriffith$elm_ui$Element$fill, trackHeight)),
					$mdgriffith$elm_ui$Element$centerY
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(
								$elm$core$Basics$round(factor * 10000)))
						]),
					$mdgriffith$elm_ui$Element$none),
					A2(
					$mdgriffith$elm_ui$Element$el,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$centerY,
						A2(
							$elm$core$List$map,
							$mdgriffith$elm_ui$Internal$Model$mapAttr($elm$core$Basics$never),
							thumbAttributes)),
					$mdgriffith$elm_ui$Element$none),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$fillPortion(
								$elm$core$Basics$round(
									$elm$core$Basics$abs(1 - factor) * 10000)))
						]),
					$mdgriffith$elm_ui$Element$none)
				]));
	});
var $mdgriffith$elm_ui$Element$Input$viewVerticalThumb = F3(
	function (factor, thumbAttributes, trackWidth) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$width(
					A2($elm$core$Maybe$withDefault, $mdgriffith$elm_ui$Element$fill, trackWidth)),
					$mdgriffith$elm_ui$Element$centerX
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$fillPortion(
								$elm$core$Basics$round(
									$elm$core$Basics$abs(1 - factor) * 10000)))
						]),
					$mdgriffith$elm_ui$Element$none),
					A2(
					$mdgriffith$elm_ui$Element$el,
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$centerX,
						A2(
							$elm$core$List$map,
							$mdgriffith$elm_ui$Internal$Model$mapAttr($elm$core$Basics$never),
							thumbAttributes)),
					$mdgriffith$elm_ui$Element$none),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$fillPortion(
								$elm$core$Basics$round(factor * 10000)))
						]),
					$mdgriffith$elm_ui$Element$none)
				]));
	});
var $mdgriffith$elm_ui$Element$Input$slider = F2(
	function (attributes, input) {
		var trackWidth = $mdgriffith$elm_ui$Internal$Model$getWidth(attributes);
		var trackHeight = $mdgriffith$elm_ui$Internal$Model$getHeight(attributes);
		var vertical = function () {
			var _v8 = _Utils_Tuple2(trackWidth, trackHeight);
			_v8$3:
			while (true) {
				if (_v8.a.$ === 1) {
					if (_v8.b.$ === 1) {
						var _v9 = _v8.a;
						var _v10 = _v8.b;
						return false;
					} else {
						break _v8$3;
					}
				} else {
					if ((!_v8.a.a.$) && (!_v8.b.$)) {
						switch (_v8.b.a.$) {
							case 0:
								var w = _v8.a.a.a;
								var h = _v8.b.a.a;
								return _Utils_cmp(h, w) > 0;
							case 2:
								return true;
							default:
								break _v8$3;
						}
					} else {
						break _v8$3;
					}
				}
			}
			return false;
		}();
		var factor = (input.gv - input.mk) / (input.mj - input.mk);
		var _v0 = input.oo;
		var thumbAttributes = _v0;
		var height = $mdgriffith$elm_ui$Internal$Model$getHeight(thumbAttributes);
		var thumbHeightString = function () {
			if (height.$ === 1) {
				return '20px';
			} else {
				if (!height.a.$) {
					var px = height.a.a;
					return $elm$core$String$fromInt(px) + 'px';
				} else {
					return '100%';
				}
			}
		}();
		var width = $mdgriffith$elm_ui$Internal$Model$getWidth(thumbAttributes);
		var thumbWidthString = function () {
			if (width.$ === 1) {
				return '20px';
			} else {
				if (!width.a.$) {
					var px = width.a.a;
					return $elm$core$String$fromInt(px) + 'px';
				} else {
					return '100%';
				}
			}
		}();
		var className = 'thmb-' + (thumbWidthString + ('-' + thumbHeightString));
		var thumbShadowStyle = _List_fromArray(
			[
				A2($mdgriffith$elm_ui$Internal$Model$Property, 'width', thumbWidthString),
				A2($mdgriffith$elm_ui$Internal$Model$Property, 'height', thumbHeightString)
			]);
		var _v1 = A2(
			$mdgriffith$elm_ui$Internal$Model$getSpacing,
			attributes,
			_Utils_Tuple2(5, 5));
		var spacingX = _v1.a;
		var spacingY = _v1.b;
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(input.h3) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : A2($mdgriffith$elm_ui$Element$spacingXY, spacingX, spacingY),
					$mdgriffith$elm_ui$Element$Region$announce,
					$mdgriffith$elm_ui$Element$width(
					function () {
						if (trackWidth.$ === 1) {
							return $mdgriffith$elm_ui$Element$fill;
						} else {
							if (!trackWidth.a.$) {
								return $mdgriffith$elm_ui$Element$shrink;
							} else {
								var x = trackWidth.a;
								return x;
							}
						}
					}()),
					$mdgriffith$elm_ui$Element$height(
					function () {
						if (trackHeight.$ === 1) {
							return $mdgriffith$elm_ui$Element$shrink;
						} else {
							if (!trackHeight.a.$) {
								return $mdgriffith$elm_ui$Element$shrink;
							} else {
								var x = trackHeight.a;
								return x;
							}
						}
					}())
				]),
			input.h3,
			A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						A2($elm$core$Maybe$withDefault, $mdgriffith$elm_ui$Element$fill, trackWidth)),
						$mdgriffith$elm_ui$Element$height(
						A2(
							$elm$core$Maybe$withDefault,
							$mdgriffith$elm_ui$Element$px(20),
							trackHeight))
					]),
				_List_fromArray(
					[
						A4(
						$mdgriffith$elm_ui$Internal$Model$element,
						$mdgriffith$elm_ui$Internal$Model$asEl,
						$mdgriffith$elm_ui$Internal$Model$NodeName('input'),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(input.h3),
								A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$active,
								A2($mdgriffith$elm_ui$Internal$Model$Style, 'input[type=\"range\"].' + (className + '::-moz-range-thumb'), thumbShadowStyle)),
								A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$hover,
								A2($mdgriffith$elm_ui$Internal$Model$Style, 'input[type=\"range\"].' + (className + '::-webkit-slider-thumb'), thumbShadowStyle)),
								A2(
								$mdgriffith$elm_ui$Internal$Model$StyleClass,
								$mdgriffith$elm_ui$Internal$Flag$focus,
								A2($mdgriffith$elm_ui$Internal$Model$Style, 'input[type=\"range\"].' + (className + '::-ms-thumb'), thumbShadowStyle)),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$class(className + ' ui-slide-bar focusable-parent')),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Events$onInput(
									function (str) {
										var _v4 = $elm$core$String$toFloat(str);
										if (_v4.$ === 1) {
											return input.mH(0);
										} else {
											var val = _v4.a;
											return input.mH(val);
										}
									})),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$type_('range')),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$step(
									function () {
										var _v5 = input.n0;
										if (_v5.$ === 1) {
											return 'any';
										} else {
											var step = _v5.a;
											return $elm$core$String$fromFloat(step);
										}
									}())),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$min(
									$elm$core$String$fromFloat(input.mk))),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$max(
									$elm$core$String$fromFloat(input.mj))),
								$mdgriffith$elm_ui$Internal$Model$Attr(
								$elm$html$Html$Attributes$value(
									$elm$core$String$fromFloat(input.gv))),
								vertical ? $mdgriffith$elm_ui$Internal$Model$Attr(
								A2($elm$html$Html$Attributes$attribute, 'orient', 'vertical')) : $mdgriffith$elm_ui$Internal$Model$NoAttribute,
								$mdgriffith$elm_ui$Element$width(
								vertical ? A2(
									$elm$core$Maybe$withDefault,
									$mdgriffith$elm_ui$Element$px(20),
									trackHeight) : A2($elm$core$Maybe$withDefault, $mdgriffith$elm_ui$Element$fill, trackWidth)),
								$mdgriffith$elm_ui$Element$height(
								vertical ? A2($elm$core$Maybe$withDefault, $mdgriffith$elm_ui$Element$fill, trackWidth) : A2(
									$elm$core$Maybe$withDefault,
									$mdgriffith$elm_ui$Element$px(20),
									trackHeight))
							]),
						$mdgriffith$elm_ui$Internal$Model$Unkeyed(_List_Nil)),
						A2(
						$mdgriffith$elm_ui$Element$el,
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width(
								A2($elm$core$Maybe$withDefault, $mdgriffith$elm_ui$Element$fill, trackWidth)),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height(
									A2(
										$elm$core$Maybe$withDefault,
										$mdgriffith$elm_ui$Element$px(20),
										trackHeight)),
								_Utils_ap(
									attributes,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$behindContent(
											vertical ? A3(
												$mdgriffith$elm_ui$Element$Input$viewVerticalThumb,
												factor,
												A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Internal$Model$htmlClass('focusable-thumb'),
													thumbAttributes),
												trackWidth) : A3(
												$mdgriffith$elm_ui$Element$Input$viewHorizontalThumb,
												factor,
												A2(
													$elm$core$List$cons,
													$mdgriffith$elm_ui$Internal$Model$htmlClass('focusable-thumb'),
													thumbAttributes),
												trackHeight))
										])))),
						$mdgriffith$elm_ui$Element$none)
					])));
	});
var $author$project$CWS$DrawEditMap$bufferOptions = F2(
	function (env, model) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$Border$color(
					A4($mdgriffith$elm_ui$Element$rgba255, 130, 151, 80, 1)),
					$mdgriffith$elm_ui$Element$Border$rounded(5),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, env.w, 1))
						]),
					$mdgriffith$elm_ui$Element$text(
						'Buffer: ' + ($elm$core$String$fromInt(model.dh) + 'ft'))),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$spacing(8),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('5'),
							A2(
							$mdgriffith$elm_ui$Element$Input$slider,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(30)),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$behindContent(
									A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$height(
												$mdgriffith$elm_ui$Element$px(15)),
												$mdgriffith$elm_ui$Element$centerY,
												$mdgriffith$elm_ui$Element$Border$rounded(15),
												$mdgriffith$elm_ui$Element$Background$color(
												A4($mdgriffith$elm_ui$Element$rgba255, 130, 151, 80, 1))
											]),
										$mdgriffith$elm_ui$Element$none))
								]),
							{
								h3: $mdgriffith$elm_ui$Element$Input$labelHidden('Buffer'),
								mj: 500,
								mk: 5,
								mH: function (_new) {
									return $author$project$CWS$DrawEditMap$Internal(
										$author$project$CWS$DrawEditMap$Toolbox(
											$author$project$CWS$DrawEditMap$UpdateBuffer(
												$elm$core$Basics$floor(_new))));
								},
								n0: $elm$core$Maybe$Just(1),
								oo: $mdgriffith$elm_ui$Element$Input$defaultThumb,
								gv: model.dh
							}),
							$mdgriffith$elm_ui$Element$text('500')
						]))
				]));
	});
var $author$project$CWS$DrawEditMap$drawTabToolOptions = F3(
	function (env, model, mode) {
		switch (mode) {
			case 1:
				return A2($author$project$CWS$DrawEditMap$bufferOptions, env, model);
			case 2:
				return A2($author$project$CWS$DrawEditMap$bufferOptions, env, model);
			case 3:
				return $mdgriffith$elm_ui$Element$none;
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$CWS$DrawEditMap$StartDrawing = function (a) {
	return {$: 7, a: a};
};
var $author$project$CWS$DrawEditMap$drawingModeToText = function (mode) {
	switch (mode) {
		case 0:
			return 'Not Drawing';
		case 1:
			return 'Point';
		case 2:
			return 'Line';
		default:
			return 'Polygon';
	}
};
var $author$project$CWS$DrawEditMap$getSrcForDrawingModeIcon = function (targetMode) {
	switch (targetMode) {
		case 1:
			return '/images/PointIcon.svg';
		case 2:
			return '/images/LineIcon.svg';
		case 3:
			return '/images/PolygonIcon.svg';
		default:
			return '/Unknown.svg';
	}
};
var $author$project$CWS$DrawEditMap$drawToolButton = F2(
	function (targetMode, activeMode) {
		var targetSize = 30;
		var innerPad = 5;
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Background$color(
					_Utils_eq(targetMode, activeMode) ? A4($mdgriffith$elm_ui$Element$rgba255, 154, 47, 0, 1) : A4($mdgriffith$elm_ui$Element$rgba255, 203, 77, 21, 1)),
					$mdgriffith$elm_ui$Element$Border$color(
					A4($mdgriffith$elm_ui$Element$rgba255, 32, 61, 5, 1)),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$mdgriffith$elm_ui$Element$Border$rounded(3),
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(targetSize)),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(targetSize)),
					$mdgriffith$elm_ui$Element$padding(innerPad),
					$mdgriffith$elm_ui$Element$htmlAttribute(
					$elm$html$Html$Attributes$title(
						$author$project$CWS$DrawEditMap$drawingModeToText(targetMode))),
					$mdgriffith$elm_ui$Element$clip
				]),
			{
				h3: A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(targetSize - (innerPad * 2))),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(targetSize - (innerPad * 2))),
							$mdgriffith$elm_ui$Element$clip
						]),
					A2(
						$mdgriffith$elm_ui$Element$image,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$centerY,
								$mdgriffith$elm_ui$Element$clip,
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(targetSize - (innerPad * 2)))
							]),
						{
							hp: $author$project$CWS$DrawEditMap$drawingModeToText(targetMode),
							nX: $author$project$CWS$DrawEditMap$getSrcForDrawingModeIcon(targetMode)
						})),
				ip: $elm$core$Maybe$Just(
					$author$project$CWS$DrawEditMap$Internal(
						$author$project$CWS$DrawEditMap$Toolbox(
							$author$project$CWS$DrawEditMap$StartDrawing(targetMode))))
			});
	});
var $author$project$CWS$DrawEditMap$saveNotice = function (env) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$size(
				A2($author$project$PAM$UI$Basic$scaleFont, env.w, -2)),
				$mdgriffith$elm_ui$Element$spacing(4)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$paragraph,
				_List_fromArray(
					[$mdgriffith$elm_ui$Element$Font$center]),
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$text('Use one of the tools below to draw. Multiple parts and overlapping areas will be merged into a single multi-part shape once you click the Save button.')
					]))
			]));
};
var $author$project$CWS$DrawEditMap$drawTabContent = F3(
	function (env, model, mode) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(4),
					$mdgriffith$elm_ui$Element$spacing(4)
				]),
			_List_fromArray(
				[
					$author$project$CWS$DrawEditMap$saveNotice(env),
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(4),
							$mdgriffith$elm_ui$Element$padding(4),
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, env.w, -2))
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Tools: '),
							A2($author$project$CWS$DrawEditMap$drawToolButton, 1, mode),
							A2($author$project$CWS$DrawEditMap$drawToolButton, 2, mode),
							A2($author$project$CWS$DrawEditMap$drawToolButton, 3, mode)
						])),
					A3($author$project$CWS$DrawEditMap$drawTabToolOptions, env, model, mode)
				]));
	});
var $author$project$CWS$DrawEditMap$AddSelectedReferenceFeatures = {$: 24};
var $author$project$CWS$DrawEditMap$CloseSelectLayerDrowdown = {$: 16};
var $author$project$CWS$DrawEditMap$SelectedLayerChanged = function (a) {
	return {$: 17, a: a};
};
var $author$project$CWS$DrawEditMap$ToggleSelectLayerDropdown = {$: 18};
var $author$project$PAM$UI$Basic$azureRadiance = A3($mdgriffith$elm_ui$Element$rgb255, 0, 126, 255);
var $author$project$PAM$UI$Basic$greenSmoke = A3($mdgriffith$elm_ui$Element$rgb255, 154, 172, 109);
var $mdgriffith$elm_ui$Internal$Model$boxShadowClass = function (shadow) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				shadow.hY ? 'box-inset' : 'box-',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.mA.a) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.mA.b) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.aI) + 'px',
				$mdgriffith$elm_ui$Internal$Model$floatClass(shadow.aV) + 'px',
				$mdgriffith$elm_ui$Internal$Model$formatColorClass(shadow.M)
			]));
};
var $mdgriffith$elm_ui$Internal$Flag$shadows = $mdgriffith$elm_ui$Internal$Flag$flag(19);
var $mdgriffith$elm_ui$Element$Border$shadow = function (almostShade) {
	var shade = {aI: almostShade.aI, M: almostShade.M, hY: false, mA: almostShade.mA, aV: almostShade.aV};
	return A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$shadows,
		A3(
			$mdgriffith$elm_ui$Internal$Model$Single,
			$mdgriffith$elm_ui$Internal$Model$boxShadowClass(shade),
			'box-shadow',
			$mdgriffith$elm_ui$Internal$Model$formatBoxShadow(shade)));
};
var $inkuzmin$elm_multiselect$Multiselect$ClickOnComponent = {$: 2};
var $inkuzmin$elm_multiselect$Multiselect$Focused = 1;
var $inkuzmin$elm_multiselect$Multiselect$Toggle = {$: 4};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.gv);
	});
var $rtfeldman$elm_css$Css$borderBottomWidth = $rtfeldman$elm_css$Css$prop1('border-bottom-width');
var $rtfeldman$elm_css$Css$borderColor3 = F3(
	function (c1, c2, c3) {
		var value = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[c1.gv, c2.gv, c3.gv]));
		return A2($rtfeldman$elm_css$Css$property, 'border-color', value);
	});
var $rtfeldman$elm_css$Css$borderLeftWidth = $rtfeldman$elm_css$Css$prop1('border-left-width');
var $rtfeldman$elm_css$Css$borderRightWidth = $rtfeldman$elm_css$Css$prop1('border-right-width');
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $rtfeldman$elm_css$Css$borderTopWidth = $rtfeldman$elm_css$Css$prop1('border-top-width');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		af: 1,
		ag: 0,
		M: 0,
		al: 0,
		aq: 0,
		gv: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				af: alpha / 255,
				ag: blue,
				M: 0,
				al: green,
				aq: red,
				gv: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$inlineBlock = {lb: 0, gv: 'inline-block'};
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			gE: 0,
			g2: 0,
			cz: 0,
			lB: 0,
			du: 0,
			cG: 0,
			br: 0,
			cH: 0,
			cI: 0,
			bU: 0,
			bV: 0,
			a5: 0,
			bv: numericValue,
			c$: 0,
			c3: unitLabel,
			a9: units,
			gv: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $rtfeldman$elm_css$Css$relative = {ng: 0, gv: 'relative'};
var $rtfeldman$elm_css$Css$solid = {ah: 0, ca: 0, gv: 'solid'};
var $rtfeldman$elm_css$Css$transparent = {M: 0, gv: 'transparent'};
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$zero = {du: 0, cG: 0, br: 0, cH: 0, cI: 0, bU: 0, bV: 0, mz: 0, bv: 0, eG: 0, c3: '', a9: 0, gv: '0'};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$arrow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$hex('#999'),
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderTopWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderLeftWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderRightWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderBottomWidth(
			$rtfeldman$elm_css$Css$px(2.5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]));
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowUpside = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$hex('#999')),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderTopWidth(
			$rtfeldman$elm_css$Css$px(2.5)),
			$rtfeldman$elm_css$Css$borderLeftWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderRightWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderBottomWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-2.5))
		]));
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$middle = $rtfeldman$elm_css$Css$prop1('middle');
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $rtfeldman$elm_css$Css$pointer = {g: 0, gv: 'pointer'};
var $rtfeldman$elm_css$Css$tableCell = {lb: 0, gv: 'table-cell'};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$tableCell),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(5))
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.k5) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.dz, record.k5, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{k5: decl, dz: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.g8;
	var imports = _v0.hT;
	var namespaces = _v0.im;
	var declarations = _v0.k6;
	var _v1 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v1.a;
	var compactedDeclarations = _v1.b;
	var finalDeclarations = A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {g8: charset, k6: finalDeclarations, hT: imports, im: namespaces};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.hy + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.gv)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A2(
				$elm$core$String$join,
				' and ',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var $rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap($rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var $rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var $rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$Structure$Output$indent, $rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		$elm$core$String$append,
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		var selectorStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2($elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					$rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return A2($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, $rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				$elm$core$String$join,
				',\n',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Css$Structure$Output$indent,
						$rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock($rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.dz;
			var declaration = decl.a.k5;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.g8;
	var imports = _v0.hT;
	var namespaces = _v0.im;
	var declarations = _v0.k6;
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					$elm$core$String$join,
					'\n\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _v9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {cr: charsProcessed, cC: hash, ar: seed, cX: shift};
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
	var acc = (!(!data.cC)) ? (data.ar ^ A2(
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
		A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
			15,
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.cC)))) : data.ar;
	var h0 = acc ^ data.cr;
	var h1 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			5,
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
					A2(
						$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
						15,
						A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.cC | ((255 & $elm$core$Char$toCode(c)) << data.cX);
		var _v0 = data.cX;
		if (_v0 === 24) {
			return {
				cr: data.cr + 1,
				cC: 0,
				ar: A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.ar, res),
				cX: 0
			};
		} else {
			return {cr: data.cr + 1, cC: res, ar: data.ar, cX: data.cX + 8};
		}
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
	function (seed, str) {
		return $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
				A4($rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$murmurSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, $rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{k5: str, dz: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.g8;
	var imports = _v0.hT;
	var namespaces = _v0.im;
	var snippets = _v0.ja;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {g8: charset, k6: declarations, hT: imports, im: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {g8: $elm$core$Maybe$Nothing, hT: _List_Nil, im: _List_Nil, ja: snippets};
};
var $rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
	return $elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
				$rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
					$elm$core$List$singleton(
						$rtfeldman$elm_css$Css$Preprocess$stylesheet(
							$elm$core$List$singleton(
								A2(
									$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
									styles,
									$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classProperty = A2(
		$elm$virtual_dom$VirtualDom$property,
		'className',
		$elm$json$Json$Encode$string(classname));
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $inkuzmin$elm_multiselect$Multiselect$withOptions = F2(
	function (options, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			function (m) {
				return {bt: m, ge: options.ge, go: options.go};
			},
			decoder);
	});
var $inkuzmin$elm_multiselect$Multiselect$onClickNoDefault = function (message) {
	var config = {ge: true, go: true};
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$custom,
		'click',
		A2(
			$inkuzmin$elm_multiselect$Multiselect$withOptions,
			config,
			$elm$json$Json$Decode$succeed(message)));
};
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$rel = $rtfeldman$elm_css$VirtualDom$Styled$attribute('rel');
var $inkuzmin$elm_multiselect$Multiselect$arrow = function (_v0) {
	var model = _v0;
	var arrowRel = (model.jf === 2) ? 'arrowUpside' : 'arrow';
	var arrowCss = (model.jf === 2) ? _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowUpside]) : _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$arrow]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowWrap])),
				$inkuzmin$elm_multiselect$Multiselect$onClickNoDefault($inkuzmin$elm_multiselect$Multiselect$Toggle)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(arrowCss),
						$rtfeldman$elm_css$Html$Styled$Attributes$rel(arrowRel)
					]),
				_List_Nil)
			]));
};
var $inkuzmin$elm_multiselect$Multiselect$Clear = {$: 7};
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		bV: 0,
		a5: 0,
		mz: 0,
		eE: 0,
		bv: val,
		c3: '',
		a9: 0,
		gv: $elm$core$String$fromFloat(val)
	};
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$clear = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1))
		]));
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.gv);
};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$clearWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(17)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#999')),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$tableCell),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color(
					$rtfeldman$elm_css$Css$hex('#D0021B'))
				]))
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $inkuzmin$elm_multiselect$Multiselect$clear = function (_v0) {
	var model = _v0;
	return (!$elm$core$List$isEmpty(model.P)) ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$clearWrap])),
				$inkuzmin$elm_multiselect$Multiselect$onClickNoDefault($inkuzmin$elm_multiselect$Multiselect$Clear)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$inkuzmin$elm_multiselect$Multiselect$SelectCss$clear]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('×')
					]))
			])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.gv);
};
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.gv, argB.gv, argC.gv])));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$table = {lb: 0, gv: 'table'};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$container = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#ccc')),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$hex('#d9d9d9'),
			$rtfeldman$elm_css$Css$hex('#ccc'),
			$rtfeldman$elm_css$Css$hex('#b3b3b3')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#333')),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(34)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$table)
		]));
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.gv);
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$boxShadowCustom = function (p) {
	return A2($rtfeldman$elm_css$Css$property, 'box-shadow', p);
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$focused = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#007eff')),
			$inkuzmin$elm_multiselect$Multiselect$SelectCss$boxShadowCustom('inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1)')
		]));
var $inkuzmin$elm_multiselect$Multiselect$Adjust = function (a) {
	return {$: 11, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Filter = function (a) {
	return {$: 10, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Shortcut = function (a) {
	return {$: 13, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $rtfeldman$elm_css$Css$initial = {gM: 0, R: 0, dg: 0, gS: 0, co: 0, gT: 0, cp: 0, bh: 0, ah: 0, d0: 0, M: 0, g: 0, lb: 0, cz: 0, fr: 0, dq: 0, ep: 0, bO: 0, lB: 0, cA: 0, t: 0, bo: 0, ew: 0, h2: 0, fL: 0, du: 0, cG: 0, br: 0, cH: 0, cI: 0, bU: 0, bV: 0, a5: 0, eA: 0, i: 0, h: 0, fU: 0, mz: 0, bv: 0, eG: 0, cP: 0, aT: 0, eV: 0, c_: 0, ca: 0, c$: 0, c0: 0, cb: 0, at: 0, c3: '', a9: 0, gv: 'initial', dU: 0, bG: 0};
var $rtfeldman$elm_css$Css$inherit = _Utils_update(
	$rtfeldman$elm_css$Css$initial,
	{gv: 'inherit'});
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		bo: 0,
		ew: 0,
		bV: 0,
		a5: 0,
		mz: 0,
		eE: 0,
		bv: val,
		c3: '',
		a9: 0,
		gv: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$none = {co: 0, gY: 0, ah: 0, g: 0, lb: 0, lM: 0, hV: 0, fL: 0, cI: 0, bU: 0, a5: 0, i: 0, h: 0, fU: 0, eG: 0, ne: 0, aT: 0, eN: 0, nF: 0, c_: 0, cb: 0, at: 0, u: 0, oC: 0, gv: 'none'};
var $rtfeldman$elm_css$Css$outlineStyle = $rtfeldman$elm_css$Css$prop1('outline-style');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$input = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$outlineStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$int(1)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(8))
		]));
var $rtfeldman$elm_css$Css$absolute = {ng: 0, gv: 'absolute'};
var $rtfeldman$elm_css$Css$fontStyle = $rtfeldman$elm_css$Css$prop1('font-style');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.gv;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$normal = {fn: 0, cA: 0, bo: 0, ga: 0, gv: 'normal', bG: 0};
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $rtfeldman$elm_css$Css$scroll = {dg: 0, gY: 0, hV: 0, cP: 0, nG: 0, gv: 'scroll'};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$inputMirrow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-100)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-100)),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$int(1))
		]));
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$inputWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(8))
		]));
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $debois$elm_dom$DOM$previousSibling = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'previousSibling', decoder);
};
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $inkuzmin$elm_multiselect$Multiselect$onKeyDown = function (tagger) {
	var domF = $debois$elm_dom$DOM$target(
		$debois$elm_dom$DOM$previousSibling($debois$elm_dom$DOM$offsetWidth));
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keypress',
		A2($elm$json$Json$Decode$map, tagger, domF));
};
var $rtfeldman$elm_css$Html$Styled$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $inkuzmin$elm_multiselect$Multiselect$onKeyPress = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $inkuzmin$elm_multiselect$Multiselect$onKeyUp = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue));
};
var $inkuzmin$elm_multiselect$Multiselect$Start = {$: 0};
var $inkuzmin$elm_multiselect$Multiselect$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $inkuzmin$elm_multiselect$Multiselect$preventDefaultButtons = function () {
	var options = {ge: true, go: false};
	var filterKey = function (code) {
		return (_Utils_eq(code, $inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow) || _Utils_eq(code, $inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow)) ? $elm$core$Result$Ok(code) : $elm$core$Result$Err('ignored input');
	};
	var decoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$always($inkuzmin$elm_multiselect$Multiselect$Start),
		A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, filterKey, $inkuzmin$elm_multiselect$Multiselect$fromResult),
			$rtfeldman$elm_css$Html$Styled$Events$keyCode));
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$custom,
		'keydown',
		A2($inkuzmin$elm_multiselect$Multiselect$withOptions, options, decoder));
}();
var $rtfeldman$elm_css$Html$Styled$Attributes$property = $rtfeldman$elm_css$VirtualDom$Styled$property;
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $inkuzmin$elm_multiselect$Multiselect$input = function (_v0) {
	var model = _v0;
	var w = $elm$core$String$fromFloat(model.fI + 23.0);
	var value = _Utils_eq(model.E, $inkuzmin$elm_multiselect$Multiselect$Utils$invisibleCharacter) ? A2(
		$rtfeldman$elm_css$Html$Styled$Attributes$property,
		'value',
		$elm$json$Json$Encode$string(model.E)) : A2(
		$rtfeldman$elm_css$Html$Styled$Attributes$property,
		'type',
		$elm$json$Json$Encode$string('text'));
	var inputStyle = A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', w + 'px');
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$inkuzmin$elm_multiselect$Multiselect$preventDefaultButtons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$inputWrap]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$inkuzmin$elm_multiselect$Multiselect$SelectCss$inputMirrow]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(model.E)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectInput' + model.Q),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$inkuzmin$elm_multiselect$Multiselect$SelectCss$input])),
						$inkuzmin$elm_multiselect$Multiselect$onKeyDown($inkuzmin$elm_multiselect$Multiselect$Adjust),
						$inkuzmin$elm_multiselect$Multiselect$onKeyPress($inkuzmin$elm_multiselect$Multiselect$Shortcut),
						$inkuzmin$elm_multiselect$Multiselect$onKeyUp($inkuzmin$elm_multiselect$Multiselect$Filter),
						inputStyle,
						value
					]),
				_List_Nil)
			]));
};
var $inkuzmin$elm_multiselect$Multiselect$OnHover = function (a) {
	return {$: 12, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$OnSelect = function (a) {
	return {$: 5, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Utils$fst = $elm$core$Tuple$first;
var $rtfeldman$elm_css$Css$borderBottomLeftRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-left-radius');
var $rtfeldman$elm_css$Css$borderBottomRightRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
var $rtfeldman$elm_css$Css$borderTopColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-top-color', c.gv);
};
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.gv, argB.gv, argC.gv, argD.gv])));
	});
var $rtfeldman$elm_css$Css$boxShadow4 = $rtfeldman$elm_css$Css$prop4('box-shadow');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ', ', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			af: alpha,
			ag: b,
			M: 0,
			al: g,
			aq: r,
			gv: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$menu = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderBottomRightRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$borderBottomLeftRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#ccc')),
			$rtfeldman$elm_css$Css$borderTopColor(
			$rtfeldman$elm_css$Css$hex('#e6e6e6')),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$zero,
			A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.06)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-1)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px($inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll)
		]));
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.gv, argB.gv])));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#666')),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px($inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight))
		]));
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItemHovered = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.08)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#333'))
		]));
var $rtfeldman$elm_css$Html$Styled$Events$onMouseOver = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $inkuzmin$elm_multiselect$Multiselect$menu = function (_v0) {
	var model = _v0;
	var _v1 = model.jf;
	if (_v1 === 2) {
		var hovered = function () {
			var _v3 = model.C;
			if (_v3.$ === 1) {
				return '';
			} else {
				var item = _v3.a;
				return $inkuzmin$elm_multiselect$Multiselect$Utils$fst(item);
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$inkuzmin$elm_multiselect$Multiselect$SelectCss$menu])),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectMenu' + model.Q)
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var name = _v2.a;
					var value = _v2.b;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_eq(name, hovered) ? _List_fromArray(
									[$inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItemHovered, $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem]) : _List_fromArray(
									[$inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem])),
								$inkuzmin$elm_multiselect$Multiselect$onClickNoDefault(
								$inkuzmin$elm_multiselect$Multiselect$OnSelect(
									_Utils_Tuple2(name, value))),
								$rtfeldman$elm_css$Html$Styled$Events$onMouseOver(
								$inkuzmin$elm_multiselect$Multiselect$OnHover(
									_Utils_Tuple2(name, value)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(value)
							]));
				},
				model.B));
	} else {
		return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	}
};
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$opened = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderBottomLeftRadius($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$borderBottomRightRadius($rtfeldman$elm_css$Css$zero)
		]));
var $inkuzmin$elm_multiselect$Multiselect$RemoveItem = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $rtfeldman$elm_css$Css$border2 = $rtfeldman$elm_css$Css$prop2('border');
var $rtfeldman$elm_css$Css$EmUnits = 0;
var $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'em');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$tag = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#007eff')),
			A2(
			$rtfeldman$elm_css$Css$border2,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.24)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.08)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.9)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1.4)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$top)
		]));
var $rtfeldman$elm_css$Css$borderRight3 = $rtfeldman$elm_css$Css$prop3('border-right');
var $rtfeldman$elm_css$Css$padding3 = $rtfeldman$elm_css$Css$prop3('padding');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$tagIcon = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('#d8eafd'))
				])),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A3(
			$rtfeldman$elm_css$Css$borderRight3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.24)),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(3)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
		]));
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$tagLabel = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
		]));
var $inkuzmin$elm_multiselect$Multiselect$tag = F2(
	function (name, value) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$inkuzmin$elm_multiselect$Multiselect$SelectCss$tag]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$inkuzmin$elm_multiselect$Multiselect$SelectCss$tagIcon])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$inkuzmin$elm_multiselect$Multiselect$RemoveItem(
								_Utils_Tuple2(name, value)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('×')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$inkuzmin$elm_multiselect$Multiselect$SelectCss$tagLabel]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(value)
						]))
				]));
	});
var $rtfeldman$elm_css$Css$inline = {lb: 0, gv: 'inline'};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$tagWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
		]));
var $inkuzmin$elm_multiselect$Multiselect$tags = function (_v0) {
	var model = _v0;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$tagWrap]))
			]),
		A2(
			$elm$core$List$map,
			function (_v1) {
				var name = _v1.a;
				var value = _v1.b;
				return A2($inkuzmin$elm_multiselect$Multiselect$tag, name, value);
			},
			model.P));
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$wrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]));
var $inkuzmin$elm_multiselect$Multiselect$styledView = function (_v0) {
	var model = _v0;
	var inputCss = (model.jf === 1) ? _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$container, $inkuzmin$elm_multiselect$Multiselect$SelectCss$focused]) : ((model.jf === 2) ? _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$container, $inkuzmin$elm_multiselect$Multiselect$SelectCss$opened]) : _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$container]));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$wrap])),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($inkuzmin$elm_multiselect$Multiselect$ClickOnComponent)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(inputCss)
					]),
				_List_fromArray(
					[
						$inkuzmin$elm_multiselect$Multiselect$tags(model),
						$inkuzmin$elm_multiselect$Multiselect$input(model),
						$inkuzmin$elm_multiselect$Multiselect$clear(model),
						$inkuzmin$elm_multiselect$Multiselect$arrow(model)
					])),
				$inkuzmin$elm_multiselect$Multiselect$menu(model)
			]));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var newStyles = _v0.b;
		var classname = _v0.c;
		return $elm$core$List$isEmpty(newStyles) ? styles : A3($elm$core$Dict$insert, classname, newStyles, styles);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_v0) {
	var val = _v0.a;
	return val;
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _v1 = properties.a;
				var styles = _v1.b;
				var classname = _v1.c;
				var rest = properties.b;
				if ($elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = $elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var _v1 = _v0.a;
		var classname = _v1.a;
		var styles = _v1.b;
		return A2($elm$core$Dict$singleton, classname, styles);
	}
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_v0) {
	var classname = _v0.a;
	var styles = _v0.b;
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		$elm$core$List$singleton(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					$elm$core$Dict$toList(dict)))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		$elm$core$List$singleton(
			$elm$virtual_dom$VirtualDom$text(
				$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $inkuzmin$elm_multiselect$Multiselect$view = A2($elm$core$Basics$composeR, $inkuzmin$elm_multiselect$Multiselect$styledView, $rtfeldman$elm_css$Html$Styled$toUnstyled);
var $author$project$CWS$DrawEditMap$referenceTabContent = F2(
	function (config, model) {
		var options = _List_fromArray(
			['1', '2']);
		var optionListConfig = A2(
			$author$project$PAM$UI$Select$defaultOptionListConfig,
			config,
			{
				ab: 'ahhhhhhhhhhhh',
				h3: 'Layers',
				mH: function (a) {
					return $author$project$CWS$DrawEditMap$Internal(
						$author$project$CWS$DrawEditMap$Toolbox(
							$author$project$CWS$DrawEditMap$SelectedLayerChanged(a)));
				},
				mS: $author$project$CWS$DrawEditMap$Internal(
					$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$CloseSelectLayerDrowdown)),
				P: $elm$core$Maybe$Just(model.e.P)
			});
		var optionConfig = A2(
			$author$project$PAM$UI$Select$defaultOptionConfig,
			config.w,
			{
				op: function (a) {
					return A2(
						$elm$core$Maybe$withDefault,
						'Select a Layer',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.dz;
							},
							a));
				}
			});
		var labelConfig = {
			kM: $elm$core$Maybe$Just('fa fa-caret-down'),
			h3: A2(
				$elm$core$Maybe$withDefault,
				'Select a Layer',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.dz;
					},
					model.e.P)),
			m3: $elm$core$Maybe$Just('fa fa-times'),
			iu: _List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$azureRadiance)
				])
		};
		var buttonConfig = A2(
			$author$project$PAM$UI$Select$defaultButtonConfig,
			config.w,
			{
				lI: $author$project$PAM$UI$Basic$inputHeight(config),
				ab: 'nooooooooooo',
				ip: $elm$core$Maybe$Just(
					$author$project$CWS$DrawEditMap$Internal(
						$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$ToggleSelectLayerDropdown))),
				jR: $mdgriffith$elm_ui$Element$fill
			});
		var selectConfig = function (a) {
			return _Utils_update(
				a,
				{
					iu: _List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$white),
							$mdgriffith$elm_ui$Element$Border$rounded(6),
							$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$black)
						])
				});
		}(
			A2(
				$author$project$PAM$UI$Select$defaultSelectConfig,
				config.w,
				{
					kB: _Utils_update(
						buttonConfig,
						{gV: $author$project$PAM$UI$Basic$white}),
					la: 0,
					l7: labelConfig,
					m4: _Utils_update(
						optionConfig,
						{
							ms: _List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Background$color(
									A2($author$project$PAM$UI$Basic$fadeColor, 0.08, $author$project$PAM$UI$Basic$azureRadiance)),
									$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$black)
								]),
							nM: _List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Background$color(
									A2($author$project$PAM$UI$Basic$fadeColor, 0.2, $author$project$PAM$UI$Basic$azureRadiance)),
									$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$azureRadiance)
								])
						}),
					m5: _Utils_update(
						optionListConfig,
						{
							gV: $author$project$PAM$UI$Basic$white,
							hI: $author$project$PAM$UI$Basic$black,
							lI: $mdgriffith$elm_ui$Element$px(150),
							m7: _List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Border$widthEach(
									{kx: 1, me: 0, nA: 0, os: 0}),
									$mdgriffith$elm_ui$Element$Border$color($author$project$PAM$UI$Basic$black),
									$mdgriffith$elm_ui$Element$Border$shadow(
									{
										aI: 4,
										M: A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.5),
										mA: _Utils_Tuple2(0, 4),
										aV: 2
									})
								])
						})
				}));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$spacing(4),
					$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$greenSmoke),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, config.w, -2))
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$spacing(4),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Select a Layer'),
							A3(
							$author$project$PAM$UI$Select$select,
							selectConfig,
							model.e.b_,
							_Utils_ap(
								_List_fromArray(
									[$elm$core$Maybe$Nothing]),
								A2($elm$core$List$map, $elm$core$Maybe$Just, model.hd.dH)))
						])),
					function () {
					if (!_Utils_eq(model.e.P, $elm$core$Maybe$Nothing)) {
						var _v0 = model.e.bW;
						switch (_v0) {
							case 2:
								return A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$spacing(4),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
										]),
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Selected Geometries'),
											A2(
											$mdgriffith$elm_ui$Element$paragraph,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
													$mdgriffith$elm_ui$Element$paddingEach(
													{kx: 10, me: 0, nA: 0, os: 0})
												]),
											_List_fromArray(
												[
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
														]),
													$mdgriffith$elm_ui$Element$html(
														A2(
															$elm$html$Html$map,
															function (a) {
																return $author$project$CWS$DrawEditMap$Internal(
																	$author$project$CWS$DrawEditMap$Toolbox(
																		$author$project$CWS$DrawEditMap$MultiMessage(a)));
															},
															$inkuzmin$elm_multiselect$Multiselect$view(model.e.an))))
												])),
											A2(
											$mdgriffith$elm_ui$Element$Input$button,
											_List_fromArray(
												[
													$mdgriffith$elm_ui$Element$Background$color(
													((($elm$core$List$length(model.e.as) > 0) && (!model.e.aR)) ? $author$project$PAM$UI$Basic$fadeColor(1) : $author$project$PAM$UI$Basic$fadeColor(0.5))($author$project$PAM$UI$Basic$orangeRoughy)),
													A2($mdgriffith$elm_ui$Element$paddingXY, 25, 0),
													$mdgriffith$elm_ui$Element$Border$rounded(16),
													$author$project$PAM$UI$Basic$title('Add'),
													$author$project$PAM$UI$Basic$montserrat,
													$mdgriffith$elm_ui$Element$height(
													$mdgriffith$elm_ui$Element$px(28)),
													$mdgriffith$elm_ui$Element$width(
													A2($mdgriffith$elm_ui$Element$minimum, 100, $mdgriffith$elm_ui$Element$shrink))
												]),
											{
												h3: A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
															$mdgriffith$elm_ui$Element$Font$size(
															A2($author$project$PAM$UI$Basic$scaleFont, config.w, -1)),
															$author$project$PAM$UI$Basic$montserrat,
															$mdgriffith$elm_ui$Element$centerY,
															$mdgriffith$elm_ui$Element$centerX
														]),
													$mdgriffith$elm_ui$Element$text('Add')),
												ip: (($elm$core$List$length(model.e.as) > 0) && (!model.e.aR)) ? $elm$core$Maybe$Just(
													$author$project$CWS$DrawEditMap$Internal(
														$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$AddSelectedReferenceFeatures))) : $elm$core$Maybe$Nothing
											}),
											function () {
											var _v1 = model.e.aR;
											switch (_v1) {
												case 0:
													return $mdgriffith$elm_ui$Element$none;
												case 1:
													return $mdgriffith$elm_ui$Element$text('Retreiving a shape');
												default:
													return $mdgriffith$elm_ui$Element$text(
														'Retreiving ' + ($elm$core$String$fromInt(model.e.aR) + ' shapes'));
											}
										}()
										]));
							case 1:
								return A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
											$mdgriffith$elm_ui$Element$Font$center,
											$mdgriffith$elm_ui$Element$Font$size(
											A2($author$project$PAM$UI$Basic$scaleFont, config.w, -2)),
											$mdgriffith$elm_ui$Element$padding(10),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
										]),
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Loading features.')
										]));
							case 3:
								return A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
											$mdgriffith$elm_ui$Element$Font$center,
											$mdgriffith$elm_ui$Element$Font$size(
											A2($author$project$PAM$UI$Basic$scaleFont, config.w, -2)),
											$mdgriffith$elm_ui$Element$padding(10),
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
										]),
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('Unable to load features for the selected layer. Please try again or use a different layer.')
										]));
							default:
								return $mdgriffith$elm_ui$Element$none;
						}
					} else {
						return A2(
							$mdgriffith$elm_ui$Element$paragraph,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
									$mdgriffith$elm_ui$Element$Font$center,
									$mdgriffith$elm_ui$Element$Font$size(
									A2($author$project$PAM$UI$Basic$scaleFont, config.w, -2)),
									$mdgriffith$elm_ui$Element$padding(10),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Select a layer above to display a list of features to choose from.')
								]));
					}
				}()
				]));
	});
var $author$project$CWS$DrawEditMap$ChooseFile = {$: 25};
var $author$project$PlugMap$Plugins$Upload$getStatusAsText = function (_v0) {
	var status = _v0.jf;
	switch (status.$) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				['Select a file to continue.']);
		case 2:
			return _List_fromArray(
				['Opening your file.']);
		case 3:
			return _List_fromArray(
				['Processing your file.']);
		case 4:
			return _List_fromArray(
				['Collecting features.']);
		case 5:
			return _List_fromArray(
				['Converting features.']);
		case 6:
			return _List_fromArray(
				['Processing features.']);
		case 7:
			return _List_fromArray(
				['Gathering some more information on the features.']);
		case 8:
			return _List_fromArray(
				['All processed. The features should appear shortly.']);
		default:
			var val = status.a;
			return _Utils_ap(
				_List_fromArray(
					['We ran into a problem with this file.']),
				val);
	}
};
var $author$project$CWS$DrawEditMap$uploadStatus = function (upld) {
	var txtItms = $author$project$PlugMap$Plugins$Upload$getStatusAsText(upld);
	return ($elm$core$List$length(txtItms) > 0) ? A2(
		$mdgriffith$elm_ui$Element$textColumn,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$Font$center,
				$mdgriffith$elm_ui$Element$centerX,
				$mdgriffith$elm_ui$Element$spacing(5)
			]),
		A2(
			$elm$core$List$map,
			function (txt) {
				return A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$Font$center]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(txt)
						]));
			},
			txtItms)) : $mdgriffith$elm_ui$Element$none;
};
var $author$project$PlugMap$Plugins$Upload$uploadableStatus = function (model) {
	var _v0 = model.jf;
	switch (_v0.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		default:
			return false;
	}
};
var $author$project$CWS$DrawEditMap$uploadTabContent = F2(
	function (config, model) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$padding(4),
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$spacing(10)
				]),
			_List_fromArray(
				[
					$author$project$PlugMap$Plugins$Upload$uploadableStatus(model.aX) ? A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
							A2($mdgriffith$elm_ui$Element$paddingXY, 25, 0),
							$mdgriffith$elm_ui$Element$Border$rounded(16),
							$author$project$PAM$UI$Basic$title('Choose File'),
							$author$project$PAM$UI$Basic$montserrat,
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(28)),
							$mdgriffith$elm_ui$Element$width(
							A2($mdgriffith$elm_ui$Element$minimum, 100, $mdgriffith$elm_ui$Element$shrink)),
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, config.w, -2))
						]),
					{
						h3: A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
									$mdgriffith$elm_ui$Element$Font$size(
									A2($author$project$PAM$UI$Basic$scaleFont, config.w, -2)),
									$author$project$PAM$UI$Basic$montserrat,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$centerX
								]),
							$mdgriffith$elm_ui$Element$text('Choose File')),
						ip: $elm$core$Maybe$Just(
							$author$project$CWS$DrawEditMap$Internal(
								$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$ChooseFile)))
					}) : $mdgriffith$elm_ui$Element$none,
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$Font$center,
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, config.w, -2))
						]),
					$author$project$CWS$DrawEditMap$uploadStatus(model.aX))
				]));
	});
var $author$project$CWS$DrawEditMap$tabContent = F2(
	function (config, model) {
		var _v0 = model.H;
		switch (_v0.$) {
			case 1:
				var mode = _v0.a;
				return A3($author$project$CWS$DrawEditMap$drawTabContent, config, model, mode);
			case 3:
				return A2($author$project$CWS$DrawEditMap$referenceTabContent, config, model);
			case 2:
				return A2($author$project$CWS$DrawEditMap$uploadTabContent, config, model);
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$CWS$DrawEditMap$maybeTabContent = F3(
	function (config, model, isReadOnly) {
		return (!isReadOnly) ? $elm$core$Maybe$Just(
			A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(
						((!_Utils_eq(model.H, $author$project$CWS$DrawEditMap$None)) ? $mdgriffith$elm_ui$Element$minimum(100) : $mdgriffith$elm_ui$Element$minimum(0))($mdgriffith$elm_ui$Element$shrink)),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$padding(3),
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'flex-basis', 'auto'))
					]),
				A2($author$project$CWS$DrawEditMap$tabContent, config, model))) : $elm$core$Maybe$Nothing;
	});
var $author$project$CWS$DrawEditMap$DrawClick = {$: 1};
var $author$project$CWS$DrawEditMap$ReferenceLayerClicked = {$: 3};
var $author$project$CWS$DrawEditMap$UploadClick = {$: 2};
var $author$project$CWS$DrawEditMap$toolTab = F3(
	function (labelText, isActive, action) {
		return A2(
			$mdgriffith$elm_ui$Element$Input$button,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$padding(6),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Background$color(
					isActive ? A4($mdgriffith$elm_ui$Element$rgba255, 130, 151, 80, 1) : A4($mdgriffith$elm_ui$Element$rgba255, 32, 61, 5, 1)),
					$mdgriffith$elm_ui$Element$Border$color(
					A4($mdgriffith$elm_ui$Element$rgba255, 130, 151, 80, 1)),
					$mdgriffith$elm_ui$Element$Border$width(1),
					$mdgriffith$elm_ui$Element$Font$color(
					isActive ? A4($mdgriffith$elm_ui$Element$rgba255, 200, 200, 200, 1) : A4($mdgriffith$elm_ui$Element$rgba255, 255, 255, 255, 1))
				]),
			{
				h3: A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX]),
					$mdgriffith$elm_ui$Element$text(labelText)),
				ip: action
			});
	});
var $author$project$CWS$DrawEditMap$toolTabs = F2(
	function (env, model) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$spaceEvenly,
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$padding(2)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$centerX
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A3(
								$author$project$CWS$DrawEditMap$toolTab,
								'Draw',
								function () {
									var _v0 = model.H;
									if (_v0.$ === 1) {
										return true;
									} else {
										return false;
									}
								}(),
								$elm$core$Maybe$Just(
									$author$project$CWS$DrawEditMap$Internal(
										$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$DrawClick)))),
								A3(
								$author$project$CWS$DrawEditMap$toolTab,
								'Upload',
								function () {
									var _v1 = model.H;
									if (_v1.$ === 2) {
										return true;
									} else {
										return false;
									}
								}(),
								$elm$core$Maybe$Just(
									$author$project$CWS$DrawEditMap$Internal(
										$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$UploadClick))))
							]),
						($elm$core$List$length(model.hd.dH) > 0) ? _List_fromArray(
							[
								A3(
								$author$project$CWS$DrawEditMap$toolTab,
								'Layers',
								function () {
									var _v2 = model.H;
									if (_v2.$ === 3) {
										return true;
									} else {
										return false;
									}
								}(),
								$elm$core$Maybe$Just(
									$author$project$CWS$DrawEditMap$Internal(
										$author$project$CWS$DrawEditMap$Toolbox($author$project$CWS$DrawEditMap$ReferenceLayerClicked))))
							]) : _List_Nil))
				]));
	});
var $author$project$CWS$DrawEditMap$maybeTabs = F3(
	function (env, model, isReadOnly) {
		return (!isReadOnly) ? $elm$core$Maybe$Just(
			A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(30)),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$padding(3),
						$mdgriffith$elm_ui$Element$clip
					]),
				A2($author$project$CWS$DrawEditMap$toolTabs, env, model))) : $elm$core$Maybe$Nothing;
	});
var $author$project$PAM$UI$Basic$transparent75 = $author$project$PAM$UI$Basic$transparent(0.75);
var $author$project$CWS$DrawEditMap$toolboxView = F4(
	function (windowConfig, model, open, enabled) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$alignRight,
					$mdgriffith$elm_ui$Element$spacing(5),
					$mdgriffith$elm_ui$Element$clip,
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
					$mdgriffith$elm_ui$Element$paddingEach(
					{kx: 0, me: 0, nA: 6, os: 0})
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(50))
						]),
					$mdgriffith$elm_ui$Element$none),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							$mdgriffith$elm_ui$Element$height(
							$author$project$CWS$DrawEditMap$calculateToolboxHeight(windowConfig))
						]),
					A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$spacing(5),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								$mdgriffith$elm_ui$Element$width(
								A2($mdgriffith$elm_ui$Element$maximum, 320, $mdgriffith$elm_ui$Element$fill))
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$Input$button,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(25)),
										$mdgriffith$elm_ui$Element$height(
										$mdgriffith$elm_ui$Element$px(25)),
										$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
										$mdgriffith$elm_ui$Element$Background$color(
										(enabled ? $elm$core$Basics$identity : $author$project$PAM$UI$Basic$fadeColor(0.25))($author$project$PAM$UI$Basic$asparagus)),
										$mdgriffith$elm_ui$Element$alignRight,
										$mdgriffith$elm_ui$Element$Border$rounded(3),
										$mdgriffith$elm_ui$Element$Border$color(
										A2($author$project$PAM$UI$Basic$fadeColor, 0.8, $author$project$PAM$UI$Basic$white)),
										$mdgriffith$elm_ui$Element$Border$width(2)
									]),
								{
									h3: A2(
										$mdgriffith$elm_ui$Element$row,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$centerX,
												$mdgriffith$elm_ui$Element$centerY,
												$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
												$mdgriffith$elm_ui$Element$Font$size(
												A2($author$project$PAM$UI$Basic$scaleFont, windowConfig.w, 1))
											]),
										_List_fromArray(
											[
												A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
														$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
														$mdgriffith$elm_ui$Element$padding(3)
													]),
												A2(
													$mdgriffith$elm_ui$Element$image,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
															$mdgriffith$elm_ui$Element$centerX
														]),
													{hp: 'Toolbox', nX: '/images/Pencil.svg'}))
											])),
									ip: enabled ? $elm$core$Maybe$Just(
										$author$project$CWS$DrawEditMap$Internal($author$project$CWS$DrawEditMap$ToggleToolbox)) : $elm$core$Maybe$Nothing
								}),
								(!open) ? $mdgriffith$elm_ui$Element$none : A2(
								$mdgriffith$elm_ui$Element$el,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width(
										$mdgriffith$elm_ui$Element$px(300)),
										$mdgriffith$elm_ui$Element$padding(6),
										$mdgriffith$elm_ui$Element$Border$rounded(6),
										$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$transparent75),
										$mdgriffith$elm_ui$Element$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'flex-basis', 'auto')),
										$mdgriffith$elm_ui$Element$height(
										A2($author$project$CWS$DrawEditMap$calculateToolboxContentHeight, windowConfig, 0)),
										$mdgriffith$elm_ui$Element$scrollbarY
									]),
								A2(
									$mdgriffith$elm_ui$Element$column,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$spacing(8),
											$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
											$mdgriffith$elm_ui$Element$padding(4),
											$mdgriffith$elm_ui$Element$height(
											A2(
												$mdgriffith$elm_ui$Element$minimum,
												175,
												A2($author$project$CWS$DrawEditMap$calculateToolboxContentHeight, windowConfig, 6))),
											$mdgriffith$elm_ui$Element$scrollbarY
										]),
									A2(
										$elm$core$List$filterMap,
										function (a) {
											return A2(a, model, false);
										},
										_List_fromArray(
											[
												$author$project$CWS$DrawEditMap$maybeTabs(windowConfig),
												$author$project$CWS$DrawEditMap$maybeTabContent(windowConfig),
												$author$project$CWS$DrawEditMap$maybeShapesTable(windowConfig),
												$author$project$CWS$DrawEditMap$maybeAreaView(windowConfig),
												$author$project$CWS$DrawEditMap$maybeEditNotice(windowConfig)
											]))))
							])))
				]));
	});
var $author$project$PlugMap$Core$MouseLeaveMap = 1;
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $mdgriffith$elm_ui$Element$Events$onMouseLeave = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onMouseLeave);
var $author$project$PlugMap$Core$view = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$author$project$PAM$UI$Basic$id('ol-map'),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$Events$onMouseLeave(1)
			]),
		_List_Nil);
};
var $author$project$PlugMap$Plugins$Identify$view = function (model) {
	return $mdgriffith$elm_ui$Element$none;
};
var $author$project$CWS$DrawEditMap$view = F2(
	function (env, model) {
		var appLegendType = function () {
			var _v1 = env.kh.kg;
			if (!_v1.$) {
				var appCofigVal = _v1.a;
				var _v2 = appCofigVal.nZ;
				if (!_v2.$) {
					var val = _v2.a;
					return val;
				} else {
					return '';
				}
			} else {
				return '';
			}
		}();
		var _v0 = model.a;
		switch (_v0) {
			case 1:
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$clip,
								$mdgriffith$elm_ui$Element$inFront(
								A4($author$project$CWS$DrawEditMap$toolboxView, env, model.A, !model.dO, model.c1))
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$map,
								$author$project$CWS$DrawEditMap$Internal,
								A2(
									$mdgriffith$elm_ui$Element$map,
									$author$project$CWS$DrawEditMap$MapMessage,
									$author$project$PlugMap$Core$view(model.q))),
								A2(
								$mdgriffith$elm_ui$Element$map,
								$author$project$CWS$DrawEditMap$identifyTranslator,
								$author$project$PlugMap$Plugins$Identify$view(model.a3))
							])));
			case 0:
				return A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$centerY,
							$mdgriffith$elm_ui$Element$Font$center,
							$mdgriffith$elm_ui$Element$padding(10)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('Just a moment')
						]));
			default:
				return A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text('The map encountered an error. Never fear, this is only development')
						]));
		}
	});
var $author$project$CWS$UploadDocuments$CancelDescriptionClicked = {$: 23};
var $author$project$CWS$UploadDocuments$EditClicked = function (a) {
	return {$: 21, a: a};
};
var $author$project$CWS$UploadDocuments$NoOp = {$: 0};
var $author$project$CWS$UploadDocuments$SaveDescriptionClicked = {$: 22};
var $author$project$CWS$UploadDocuments$getDescriptionOrDefault = function (input) {
	return (!$elm$core$String$length(input)) ? '(No Description)' : input;
};
var $author$project$CWS$UploadDocuments$truncate = F2(
	function (input, length) {
		return (_Utils_cmp(
			$elm$core$String$length(input),
			length) > 0) ? (A2($elm$core$String$left, length - 3, input) + '...') : input;
	});
var $author$project$CWS$UploadDocuments$singleFileView = F5(
	function (item, disabled_, editingThisItem, editingOtherItem, editing) {
		var fileId = function () {
			var _v1 = item.ab;
			if (!_v1.$) {
				var val = _v1.a;
				return val;
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fileContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('delete')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('deleteFileBtn'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('disabled', editingOtherItem || disabled_)
										])),
									$elm$html$Html$Events$onClick(
									(editingOtherItem || disabled_) ? $author$project$CWS$UploadDocuments$NoOp : $author$project$CWS$UploadDocuments$Delete(item)),
									$elm$html$Html$Attributes$title('Delete file')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fa fa-times')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('name')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$title(item.dz)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$CWS$UploadDocuments$truncate, item.dz, 35))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('description')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('controls')
								]),
							(!editingThisItem) ? _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('editFileDescriptionBtn'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('disabled', editingOtherItem || disabled_)
												])),
											$elm$html$Html$Events$onClick(
											(editingOtherItem || disabled_) ? $author$project$CWS$UploadDocuments$NoOp : $author$project$CWS$UploadDocuments$EditClicked(item)),
											$elm$html$Html$Attributes$title('Edit description')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fa fa-pencil')
												]),
											_List_Nil)
										]))
								]) : _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('saveFileDescriptionBtn'),
											$elm$html$Html$Events$onClick($author$project$CWS$UploadDocuments$SaveDescriptionClicked),
											$elm$html$Html$Attributes$title('Save description')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fa fa-check')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('cancelFileDescriptionBtn'),
											$elm$html$Html$Events$onClick($author$project$CWS$UploadDocuments$CancelDescriptionClicked),
											$elm$html$Html$Attributes$title('Cancel')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fa fa-times')
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('descriptionValue action')
								]),
							_List_fromArray(
								[
									function () {
									if (!editingThisItem) {
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$title(item.hp)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$CWS$UploadDocuments$truncate,
														$author$project$CWS$UploadDocuments$getDescriptionOrDefault(item.hp),
														40))
												]));
									} else {
										if (editing.$ === 1) {
											var file = editing.a;
											return A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Events$onInput(
														function (x) {
															return $author$project$CWS$UploadDocuments$EditClicked(
																_Utils_update(
																	item,
																	{hp: x}));
														}),
														$elm$html$Html$Attributes$value(file.hp)
													]),
												_List_Nil);
										} else {
											return $elm$html$Html$text('An error occured');
										}
									}
								}()
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('download')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('download'),
									$elm$html$Html$Events$onClick(
									$author$project$CWS$UploadDocuments$DownloadClicked(item))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Download')
								]))
						]))
				]));
	});
var $author$project$CWS$UploadDocuments$fileListView = F3(
	function (lists, disabled_, editing) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fileListContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sectionName')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Uploaded Files')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fileHeader')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('name')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('File Name')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('delete')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('description')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Description')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('uploadedList')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							var currentlyEditingThisItem = function () {
								if (!editing.$) {
									return false;
								} else {
									var file = editing.a;
									return _Utils_eq(item.ab, file.ab);
								}
							}();
							return A5(
								$author$project$CWS$UploadDocuments$singleFileView,
								item,
								disabled_,
								currentlyEditingThisItem,
								!_Utils_eq(editing, $author$project$CWS$UploadDocuments$NotEditing),
								editing);
						},
						lists))
				]));
	});
var $author$project$CWS$UploadDocuments$StartUpload = {$: 4};
var $author$project$CWS$UploadDocuments$instructions = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('uploadInstruction')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Acceptable file types: PDF, JPG, JPEG, TIF, TIFF, PNG, DOC, DOCX, XLS, XLSX, ZIP')
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Less than 25MB & less than 10 files per action')
				]))
		]));
var $author$project$CWS$UploadDocuments$fileUploadView = F2(
	function (model, disabled_) {
		var upload = $author$project$CWS$UploadDocuments$StartUpload;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('uploadContainer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Upload Receipts & Documents')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('uploadWrapper')
						]),
					_List_fromArray(
						[
							$author$project$CWS$UploadDocuments$fileInput(
							disabled_ || ($elm$core$List$length(model.aK) > 9)),
							$author$project$CWS$UploadDocuments$instructions,
							$author$project$CWS$UploadDocuments$validMessages(model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('infoWrapper')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('nameBit')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, $author$project$CWS$UploadDocuments$defaultFileInfo, model._).dz)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('descriptionBit action')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('fileDesc'),
											$elm$html$Html$Attributes$type_('text'),
											$author$project$CWS$UploadDocuments$onChange($author$project$CWS$UploadDocuments$OneFileDesc),
											$elm$html$Html$Attributes$value(model.bk),
											$elm$html$Html$Attributes$maxlength(500),
											$elm$html$Html$Attributes$placeholder('Enter Description (Optional)')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(upload),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'disabled',
													!$author$project$CWS$UploadDocuments$isNotValid(model.aw))
												])),
											$elm$html$Html$Attributes$class('btn uploadFileBtn'),
											$elm$html$Html$Attributes$disabled(
											disabled_ || ((!$author$project$CWS$UploadDocuments$isNotValid(model.aw)) || (($elm$core$List$length(model.aK) > 9) || _Utils_eq(model._, $elm$core$Maybe$Nothing))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Upload')
										]))
								]))
						]))
				]));
	});
var $author$project$CWS$UploadDocuments$blank = A2($elm$html$Html$div, _List_Nil, _List_Nil);
var $author$project$CWS$UploadDocuments$errorView = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]));
};
var $author$project$CWS$UploadDocuments$validationOverlayView = function (model) {
	return (model.gH <= 0) ? $author$project$CWS$UploadDocuments$errorView('Please save the action before uploading files') : $author$project$CWS$UploadDocuments$blank;
};
var $author$project$CWS$UploadDocuments$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('uploadDownloadContainer')
			]),
		_List_fromArray(
			[
				A2($author$project$CWS$UploadDocuments$fileUploadView, model, !model.g4),
				A3($author$project$CWS$UploadDocuments$fileListView, model.aK, !model.g3, model.a.hr),
				$author$project$CWS$UploadDocuments$validationOverlayView(model),
				$author$project$CWS$UploadDocuments$confirmCloseView(model)
			]));
};
var $author$project$CWS$ActionDetail$contentView = F3(
	function (model, forceReadOnly, env) {
		var _v0 = model.a.a$;
		switch (_v0) {
			case 0:
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$scrollbarY
						]),
					$author$project$CWS$ActionDetail$detailsView(model));
			case 1:
				var odum = model.a.ba;
				var dum = _Utils_update(
					odum,
					{
						g3: $author$project$CWS$ActionDetail$canUpload(model) && (!forceReadOnly),
						g4: $author$project$CWS$ActionDetail$canUpload(model) && (!forceReadOnly)
					});
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Font$size(10)
						]),
					$mdgriffith$elm_ui$Element$html(
						A2(
							$elm$html$Html$map,
							$author$project$CWS$ActionDetail$UploadDocumentsMsg,
							$author$project$CWS$UploadDocuments$view(dum))));
			default:
				var ns = {lI: env.dw.kT, jR: env.dw.jR};
				var ne = {kh: env.kh, kS: ns, Z: env.Z, w: env.w};
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Font$size(10),
							$mdgriffith$elm_ui$Element$clip
						]),
					A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$CWS$ActionDetail$mapTranslater,
						A2($author$project$CWS$DrawEditMap$view, ne, model.q)));
		}
	});
var $author$project$CWS$ActionDetail$ChangeSection = function (a) {
	return {$: 2, a: a};
};
var $author$project$CWS$ActionDetail$ApproveClicked = {$: 22};
var $author$project$CWS$ActionDetail$DenyClicked = {$: 23};
var $author$project$CWS$ActionDetail$canApprove = F2(
	function (action, model) {
		var status = action.jf;
		return (status === 2) || (status === 3);
	});
var $author$project$CWS$ActionDetail$canDeny = F2(
	function (action, model) {
		var status = action.jf;
		return ((status === 2) || (status === 4)) && (!_Utils_eq(action.cn, $elm$core$Maybe$Nothing));
	});
var $author$project$CWS$ActionDetail$appActionsView = function (model) {
	var details = function () {
		var _v0 = model.c;
		if (_v0.$ === 2) {
			var e = _v0.a;
			return e;
		} else {
			return $author$project$CWS$Model$blankActionModel;
		}
	}();
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('save'),
					$elm$html$Html$Events$onClick($author$project$CWS$ActionDetail$ApproveClicked),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'disabled',
							!A2($author$project$CWS$ActionDetail$canApprove, details, model))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Approve')
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('submit'),
					$elm$html$Html$Events$onClick(
					A2($author$project$CWS$ActionDetail$canDeny, details, model) ? $author$project$CWS$ActionDetail$DenyClicked : $author$project$CWS$ActionDetail$NoOp),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'disabled',
							!A2($author$project$CWS$ActionDetail$canDeny, details, model))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Deny')
				]))
		]);
};
var $author$project$CWS$ActionDetail$SaveClicked = function (a) {
	return {$: 20, a: a};
};
var $author$project$CWS$ActionDetail$SubmitClicked = function (a) {
	return {$: 21, a: a};
};
var $author$project$CWS$ActionDetail$peActionsView = function (model) {
	var details = function () {
		var _v2 = model.c;
		if (_v2.$ === 2) {
			var e = _v2.a;
			return e;
		} else {
			return $author$project$CWS$Model$blankActionModel;
		}
	}();
	var newDetails = function () {
		var _v1 = details.W;
		if (_v1.$ === 1) {
			return _Utils_update(
				details,
				{
					W: $elm$core$Maybe$Just(model.W)
				});
		} else {
			return details;
		}
	}();
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('save'),
					$elm$html$Html$Events$onClick(
					$author$project$CWS$ActionDetail$SaveClicked(model.W)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'disabled',
							!A2($author$project$CWS$ActionDetail$canSave, model, newDetails))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						var _v0 = model.T;
						switch (_v0.$) {
							case 0:
								return 'Save';
							case 3:
								return 'Save';
							case 4:
								var msg = _v0.a;
								return 'Error: ' + msg;
							default:
								return 'Saving';
						}
					}())
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('submit'),
					$elm$html$Html$Events$onClick(
					$author$project$CWS$ActionDetail$SubmitClicked(model.W)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'disabled',
							!A2($author$project$CWS$ActionDetail$canSubmit, details, model))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Submit')
				]))
		]);
};
var $author$project$CWS$ActionDetail$actionsView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('actions')
			]),
		function () {
			var _v0 = model.bd;
			switch (_v0) {
				case 1:
					return $author$project$CWS$ActionDetail$peActionsView(model);
				case 2:
					return $author$project$CWS$ActionDetail$appActionsView(model);
				default:
					return _List_Nil;
			}
		}());
};
var $author$project$CWS$ActionDetail$mapSectionToName = function (section) {
	switch (section) {
		case 0:
			return 'Action Details';
		case 1:
			return 'Receipts & Documents';
		default:
			return 'Map';
	}
};
var $author$project$CWS$ActionDetail$statusToText = function (status) {
	switch (status) {
		case 0:
			return 'New';
		case 1:
			return 'Not Submitted';
		case 4:
			return 'Approved';
		case 3:
			return 'Denied';
		default:
			return 'Submitted';
	}
};
var $author$project$CWS$ActionDetail$sectionView = function (model) {
	var details = function () {
		var _v0 = model.c;
		if (_v0.$ === 2) {
			var e = _v0.a;
			return e;
		} else {
			return $author$project$CWS$Model$blankActionModel;
		}
	}();
	var currentSectionMatches = function (section) {
		return _Utils_eq(model.a.a$, section);
	};
	var disabledNavButtonAttributes = function (section) {
		return _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$CWS$ActionDetail$ChangeSection(section)),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'active',
						currentSectionMatches(section)),
						_Utils_Tuple2('disabled', true)
					]))
			]);
	};
	var disabledNavButtonMaker = function (section) {
		return A2(
			$elm$html$Html$button,
			disabledNavButtonAttributes(section),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$CWS$ActionDetail$mapSectionToName(section))
						])),
					A2($elm$html$Html$i, _List_Nil, _List_Nil)
				]));
	};
	var navButtonAttributes = function (section) {
		return _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$CWS$ActionDetail$ChangeSection(section)),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'active',
						currentSectionMatches(section))
					]))
			]);
	};
	var navButtonMaker = function (section) {
		return A2(
			$elm$html$Html$button,
			navButtonAttributes(section),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$CWS$ActionDetail$mapSectionToName(section))
						])),
					A2($elm$html$Html$i, _List_Nil, _List_Nil)
				]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('actionDetailSections'),
				$elm$html$Html$Attributes$id('actionDetailSections')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('status')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Status:')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$CWS$ActionDetail$statusToText(details.jf))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('nav')
					]),
				_List_fromArray(
					[
						navButtonMaker(0),
						(model.a.ab > 0) ? navButtonMaker(1) : disabledNavButtonMaker(1),
						navButtonMaker(2)
					])),
				$author$project$CWS$ActionDetail$actionsView(model)
			]));
};
var $author$project$CWS$ActionDetail$view = F4(
	function (env, forceReadOnly, actionYear, model) {
		var newModel = _Utils_update(
			model,
			{W: actionYear});
		return A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$inFront(
					$mdgriffith$elm_ui$Element$html(
						$author$project$CWS$ActionDetail$confirmView(newModel))),
					$mdgriffith$elm_ui$Element$width(
					$mdgriffith$elm_ui$Element$px(env.dw.jR)),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(env.dw.kT)),
					$mdgriffith$elm_ui$Element$padding(0)
				]),
			A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$fillPortion(1)),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
							]),
						$mdgriffith$elm_ui$Element$html(
							$author$project$CWS$ActionDetail$sectionView(newModel))),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$fillPortion(4)),
								$mdgriffith$elm_ui$Element$height(
								A2($mdgriffith$elm_ui$Element$maximum, env.dw.kT, $mdgriffith$elm_ui$Element$fill)),
								$mdgriffith$elm_ui$Element$Font$size(
								A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1))
							]),
						A3($author$project$CWS$ActionDetail$contentView, newModel, forceReadOnly, env))
					])));
	});
var $author$project$CWS$getActionDetailModel = F4(
	function (model, id, catgrp, forceReadOnly) {
		return A8(
			$author$project$CWS$DynamicModal$elementView,
			A3($author$project$CWS$getActionModel, model, id, catgrp),
			model.w,
			$author$project$CWS$calculateModalContentSize(model),
			A3(
				$author$project$CWS$ActionDetail$view,
				{
					kh: model.p.m,
					Z: model.Z,
					dw: $author$project$CWS$calculateModalContentSize(model),
					w: model.p.aV
				},
				forceReadOnly,
				function () {
					var _v0 = model.a.n.z;
					if ((_v0.$ === 4) && (_v0.a.$ === 1)) {
						var m = _v0.a.a;
						return m.d.r;
					} else {
						return model.a.r;
					}
				}()),
			$elm$core$Basics$always($elm$core$Maybe$Nothing),
			function (msg) {
				return A2($mdgriffith$elm_ui$Element$map, $author$project$CWS$Messages$ActionDetailMsg, msg);
			},
			'Action Details',
			$author$project$CWS$Messages$CloseModal);
	});
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$Add = {$: 1};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$controls = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$Border$rounded(6)
					]),
				{
					h3: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$paddingEach(
								{kx: 10, me: 35, nA: 35, os: 10})
							]),
						$mdgriffith$elm_ui$Element$text('Save')),
					ip: $elm$core$Maybe$Just(
						$author$project$CWS$Approver$ManageParticipatingEntityUsers$Internal($author$project$CWS$Approver$ManageParticipatingEntityUsers$Add))
				})
			]));
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$footerSize = 30;
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$GridMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$NoOp = {$: 0};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$emailToggle = {
	dx: 0,
	dJ: true,
	jr: 'Email',
	js: $author$project$CWS$Approver$ManageParticipatingEntityUsers$Internal($author$project$CWS$Approver$ManageParticipatingEntityUsers$NoOp),
	dQ: 0
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$nameToggle = {
	dx: 0,
	dJ: true,
	jr: 'Name',
	js: $author$project$CWS$Approver$ManageParticipatingEntityUsers$Internal($author$project$CWS$Approver$ManageParticipatingEntityUsers$NoOp),
	dQ: 0
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$columnToggles = _List_fromArray(
	[$author$project$CWS$Approver$ManageParticipatingEntityUsers$nameToggle, $author$project$CWS$Approver$ManageParticipatingEntityUsers$emailToggle]);
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$ToggleSelected = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $mdgriffith$elm_ui$Element$Input$checkbox = F2(
	function (attrs, _v0) {
		var label = _v0.h3;
		var icon = _v0.cD;
		var checked = _v0.kF;
		var onChange = _v0.mH;
		var attributes = _Utils_ap(
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$Input$isHiddenLabel(label) ? $mdgriffith$elm_ui$Internal$Model$NoAttribute : $mdgriffith$elm_ui$Element$spacing(6),
					$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Events$onClick(
						onChange(!checked))),
					$mdgriffith$elm_ui$Element$Region$announce,
					$mdgriffith$elm_ui$Element$Input$onKeyLookup(
					function (code) {
						return _Utils_eq(code, $mdgriffith$elm_ui$Element$Input$enter) ? $elm$core$Maybe$Just(
							onChange(!checked)) : (_Utils_eq(code, $mdgriffith$elm_ui$Element$Input$space) ? $elm$core$Maybe$Just(
							onChange(!checked)) : $elm$core$Maybe$Nothing);
					}),
					$mdgriffith$elm_ui$Element$Input$tabindex(0),
					$mdgriffith$elm_ui$Element$pointer,
					$mdgriffith$elm_ui$Element$alignLeft,
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			attrs);
		return A3(
			$mdgriffith$elm_ui$Element$Input$applyLabel,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					A2($elm$html$Html$Attributes$attribute, 'role', 'checkbox')),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						A2(
							$elm$html$Html$Attributes$attribute,
							'aria-checked',
							checked ? 'true' : 'false')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$Input$hiddenLabelAttribute(label),
						attributes))),
			label,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
					]),
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[
							icon(checked)
						]))));
	});
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $mdgriffith$elm_ui$Internal$Model$Rotate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Flag$rotate = $mdgriffith$elm_ui$Internal$Flag$flag(24);
var $mdgriffith$elm_ui$Element$rotate = function (angle) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$rotate,
		A2(
			$mdgriffith$elm_ui$Internal$Model$Rotate,
			_Utils_Tuple3(0, 0, 1),
			angle));
};
var $mdgriffith$elm_ui$Element$transparent = function (on) {
	return on ? A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2($mdgriffith$elm_ui$Internal$Model$Transparency, 'transparent', 1.0)) : A2(
		$mdgriffith$elm_ui$Internal$Model$StyleClass,
		$mdgriffith$elm_ui$Internal$Flag$transparency,
		A2($mdgriffith$elm_ui$Internal$Model$Transparency, 'visible', 0.0));
};
var $mdgriffith$elm_ui$Element$Input$defaultCheckbox = function (checked) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Internal$Model$htmlClass('focusable'),
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$px(14)),
				$mdgriffith$elm_ui$Element$height(
				$mdgriffith$elm_ui$Element$px(14)),
				$mdgriffith$elm_ui$Element$Font$color($mdgriffith$elm_ui$Element$Input$white),
				$mdgriffith$elm_ui$Element$centerY,
				$mdgriffith$elm_ui$Element$Font$size(9),
				$mdgriffith$elm_ui$Element$Font$center,
				$mdgriffith$elm_ui$Element$Border$rounded(3),
				$mdgriffith$elm_ui$Element$Border$color(
				checked ? A3($mdgriffith$elm_ui$Element$rgb, 59 / 255, 153 / 255, 252 / 255) : A3($mdgriffith$elm_ui$Element$rgb, 211 / 255, 211 / 255, 211 / 255)),
				$mdgriffith$elm_ui$Element$Border$shadow(
				{
					aI: 1,
					M: checked ? A4($mdgriffith$elm_ui$Element$rgba, 238 / 255, 238 / 255, 238 / 255, 0) : A3($mdgriffith$elm_ui$Element$rgb, 238 / 255, 238 / 255, 238 / 255),
					mA: _Utils_Tuple2(0, 0),
					aV: 1
				}),
				$mdgriffith$elm_ui$Element$Background$color(
				checked ? A3($mdgriffith$elm_ui$Element$rgb, 59 / 255, 153 / 255, 252 / 255) : $mdgriffith$elm_ui$Element$Input$white),
				$mdgriffith$elm_ui$Element$Border$width(
				checked ? 0 : 1),
				$mdgriffith$elm_ui$Element$inFront(
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$Border$color($mdgriffith$elm_ui$Element$Input$white),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(6)),
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(9)),
							$mdgriffith$elm_ui$Element$rotate(
							$elm$core$Basics$degrees(-45)),
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$centerY,
							$mdgriffith$elm_ui$Element$moveUp(1),
							$mdgriffith$elm_ui$Element$transparent(!checked),
							$mdgriffith$elm_ui$Element$Border$widthEach(
							{kx: 2, me: 2, nA: 0, os: 0})
						]),
					$mdgriffith$elm_ui$Element$none))
			]),
		$mdgriffith$elm_ui$Element$none);
};
var $mdgriffith$elm_ui$Element$Input$Label = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $mdgriffith$elm_ui$Element$Input$OnRight = 0;
var $mdgriffith$elm_ui$Element$Input$labelRight = $mdgriffith$elm_ui$Element$Input$Label(0);
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$checkboxColumn = {
	a1: $author$project$Grid$Grid$DynamicGetter(
		function (obj) {
			return _Utils_Tuple2(
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$Input$checkbox,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
								$mdgriffith$elm_ui$Element$centerY
							]),
						{
							kF: obj.df,
							cD: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
							h3: A2($mdgriffith$elm_ui$Element$Input$labelRight, _List_Nil, $mdgriffith$elm_ui$Element$none),
							mH: function (a) {
								return $author$project$CWS$Approver$ManageParticipatingEntityUsers$Internal(
									A2($author$project$CWS$Approver$ManageParticipatingEntityUsers$ToggleSelected, obj, a));
							}
						})),
				'');
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (a) {
			return a;
		}
	},
	jr: 'Assigned',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$emailColumn = {
	a1: $author$project$Grid$Grid$StringGetter(
		function (obj) {
			return obj.ek;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (a) {
			return $elm$core$List$sortBy(
				function (b) {
					return $elm$core$String$toLower(b.ek);
				})(a);
		}
	},
	jr: 'Email',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$fill
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$nameColumn = {
	a1: $author$project$Grid$Grid$StringGetter(
		function (obj) {
			return obj.dz;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (a) {
			return $elm$core$List$sortBy(
				function (b) {
					return $elm$core$String$toLower(b.dz);
				})(a);
		}
	},
	jr: 'Name',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$fill
};
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$gridColumns = _List_fromArray(
	[$author$project$CWS$Approver$ManageParticipatingEntityUsers$checkboxColumn, $author$project$CWS$Approver$ManageParticipatingEntityUsers$nameColumn, $author$project$CWS$Approver$ManageParticipatingEntityUsers$emailColumn]);
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$gridHeaderSize = 30;
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$headerSize = 0;
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$gridView = F2(
	function (env, model) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					A2($mdgriffith$elm_ui$Element$maximum, ((env.dw.kT - $author$project$CWS$Approver$ManageParticipatingEntityUsers$headerSize) - $author$project$CWS$Approver$ManageParticipatingEntityUsers$gridHeaderSize) - $author$project$CWS$Approver$ManageParticipatingEntityUsers$footerSize, $mdgriffith$elm_ui$Element$fill)),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1)),
					$mdgriffith$elm_ui$Element$spacing(0)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px($author$project$CWS$Approver$ManageParticipatingEntityUsers$gridHeaderSize)),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$CWS$Approver$ManageParticipatingEntityUsers$Internal,
						A2(
							$mdgriffith$elm_ui$Element$map,
							$author$project$CWS$Approver$ManageParticipatingEntityUsers$GridMsg,
							A2(
								$author$project$Grid$Grid$filterView,
								{
									kO: $author$project$CWS$Approver$ManageParticipatingEntityUsers$columnToggles,
									Z: env.Z,
									lB: A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1),
									lI: $mdgriffith$elm_ui$Element$fill,
									ac: env.ac,
									w: env.w
								},
								model.fw)))),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(((env.dw.kT - $author$project$CWS$Approver$ManageParticipatingEntityUsers$headerSize) - $author$project$CWS$Approver$ManageParticipatingEntityUsers$gridHeaderSize) - $author$project$CWS$Approver$ManageParticipatingEntityUsers$footerSize)),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$clip
						]),
					A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$CWS$Approver$ManageParticipatingEntityUsers$Internal,
						A2(
							$mdgriffith$elm_ui$Element$map,
							$author$project$CWS$Approver$ManageParticipatingEntityUsers$GridMsg,
							A2(
								$author$project$Grid$Grid$gridView,
								{
									kN: $author$project$CWS$Approver$ManageParticipatingEntityUsers$gridColumns,
									k1: A2(
										$elm$core$List$filter,
										function (a) {
											return !_Utils_eq(model.ee, a.ab);
										},
										model.aY),
									Z: env.Z,
									lI: $mdgriffith$elm_ui$Element$px((((env.dw.kT - $author$project$CWS$Approver$ManageParticipatingEntityUsers$headerSize) - $author$project$CWS$Approver$ManageParticipatingEntityUsers$gridHeaderSize) - $author$project$CWS$Approver$ManageParticipatingEntityUsers$footerSize) - 32),
									ac: env.ac,
									w: env.w
								},
								model.fw))))
				]));
	});
var $author$project$CWS$Approver$ManageParticipatingEntityUsers$view = F2(
	function (env, model) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					A2($mdgriffith$elm_ui$Element$maximum, env.dw.kT, $mdgriffith$elm_ui$Element$fill)),
					$mdgriffith$elm_ui$Element$clip,
					$mdgriffith$elm_ui$Element$spacing(2),
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, env.w, 1))
				]),
			_List_fromArray(
				[
					A2($author$project$CWS$Approver$ManageParticipatingEntityUsers$gridView, env, model),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$alignBottom,
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px($author$project$CWS$Approver$ManageParticipatingEntityUsers$footerSize))
						]),
					$author$project$CWS$Approver$ManageParticipatingEntityUsers$controls(model))
				]));
	});
var $author$project$CWS$manageUsersView = F2(
	function (model, users) {
		return A2(
			$mdgriffith$elm_ui$Element$map,
			$author$project$CWS$manageUsersTranslator,
			A2(
				$author$project$CWS$Approver$ManageParticipatingEntityUsers$view,
				{
					Z: model.Z,
					dw: $author$project$CWS$calculateModalContentSize(model),
					ac: model.ac,
					w: model.p.aV
				},
				model.a.cK));
	});
var $author$project$CWS$managePEUsersView = function (model) {
	return A3(
		$author$project$CWS$loadableValueElementView,
		model.b.aY,
		$author$project$CWS$manageUsersView(model),
		$elm$core$Basics$identity);
};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$Add = {$: 1};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$Internal = function (a) {
	return {$: 0, a: a};
};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$controls = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$Border$rounded(6)
					]),
				{
					h3: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$paddingEach(
								{kx: 10, me: 35, nA: 35, os: 10})
							]),
						$mdgriffith$elm_ui$Element$text('Save')),
					ip: $elm$core$Maybe$Just(
						$author$project$CWS$Approver$ManageUserParticipatingEntities$Internal($author$project$CWS$Approver$ManageUserParticipatingEntities$Add))
				})
			]));
};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$footerSize = 30;
var $author$project$CWS$Approver$ManageUserParticipatingEntities$GridMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$NoOp = {$: 0};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$nameToggle = {
	dx: 0,
	dJ: true,
	jr: 'Name',
	js: $author$project$CWS$Approver$ManageUserParticipatingEntities$Internal($author$project$CWS$Approver$ManageUserParticipatingEntities$NoOp),
	dQ: 0
};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$columnToggles = _List_fromArray(
	[$author$project$CWS$Approver$ManageUserParticipatingEntities$nameToggle]);
var $author$project$CWS$Approver$ManageUserParticipatingEntities$ToggleSelected = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$CWS$Approver$ManageUserParticipatingEntities$checkboxColumn = {
	a1: $author$project$Grid$Grid$DynamicGetter(
		function (obj) {
			return _Utils_Tuple2(
				A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$Input$checkbox,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
								$mdgriffith$elm_ui$Element$centerY
							]),
						{
							kF: obj.df,
							cD: $mdgriffith$elm_ui$Element$Input$defaultCheckbox,
							h3: A2($mdgriffith$elm_ui$Element$Input$labelRight, _List_Nil, $mdgriffith$elm_ui$Element$none),
							mH: function (a) {
								return $author$project$CWS$Approver$ManageUserParticipatingEntities$Internal(
									A2($author$project$CWS$Approver$ManageUserParticipatingEntities$ToggleSelected, obj, a));
							}
						})),
				'');
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (a) {
			return a;
		}
	},
	jr: 'Assigned',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$shrink
};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$nameColumn = {
	a1: $author$project$Grid$Grid$StringGetter(
		function (obj) {
			return obj.d.dz;
		}),
	dx: $elm$core$Maybe$Nothing,
	m: 1,
	dJ: true,
	aD: {
		aP: function (a) {
			return $elm$core$List$sortBy(
				function (b) {
					return $elm$core$String$toLower(b.d.dz);
				})(a);
		}
	},
	jr: 'Name',
	dQ: 0,
	jR: $mdgriffith$elm_ui$Element$fill
};
var $author$project$CWS$Approver$ManageUserParticipatingEntities$gridColumns = _List_fromArray(
	[$author$project$CWS$Approver$ManageUserParticipatingEntities$checkboxColumn, $author$project$CWS$Approver$ManageUserParticipatingEntities$nameColumn]);
var $author$project$CWS$Approver$ManageUserParticipatingEntities$gridHeaderSize = 30;
var $author$project$CWS$Approver$ManageUserParticipatingEntities$headerSize = 0;
var $author$project$CWS$Approver$ManageUserParticipatingEntities$gridView = F2(
	function (env, model) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					A2($mdgriffith$elm_ui$Element$maximum, ((env.dw.kT - $author$project$CWS$Approver$ManageUserParticipatingEntities$headerSize) - $author$project$CWS$Approver$ManageUserParticipatingEntities$gridHeaderSize) - $author$project$CWS$Approver$ManageUserParticipatingEntities$footerSize, $mdgriffith$elm_ui$Element$fill)),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1)),
					$mdgriffith$elm_ui$Element$spacing(0)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px($author$project$CWS$Approver$ManageUserParticipatingEntities$gridHeaderSize)),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
						]),
					A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$CWS$Approver$ManageUserParticipatingEntities$Internal,
						A2(
							$mdgriffith$elm_ui$Element$map,
							$author$project$CWS$Approver$ManageUserParticipatingEntities$GridMsg,
							A2(
								$author$project$Grid$Grid$filterView,
								{
									kO: $author$project$CWS$Approver$ManageUserParticipatingEntities$columnToggles,
									Z: env.Z,
									lB: A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1),
									lI: $mdgriffith$elm_ui$Element$fill,
									ac: env.ac,
									w: env.w
								},
								model.fw)))),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(((env.dw.kT - $author$project$CWS$Approver$ManageUserParticipatingEntities$headerSize) - $author$project$CWS$Approver$ManageUserParticipatingEntities$gridHeaderSize) - $author$project$CWS$Approver$ManageUserParticipatingEntities$footerSize)),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$clip
						]),
					A2(
						$mdgriffith$elm_ui$Element$map,
						$author$project$CWS$Approver$ManageUserParticipatingEntities$Internal,
						A2(
							$mdgriffith$elm_ui$Element$map,
							$author$project$CWS$Approver$ManageUserParticipatingEntities$GridMsg,
							A2(
								$author$project$Grid$Grid$gridView,
								{
									kN: $author$project$CWS$Approver$ManageUserParticipatingEntities$gridColumns,
									k1: model.b4,
									Z: env.Z,
									lI: $mdgriffith$elm_ui$Element$px((((env.dw.kT - $author$project$CWS$Approver$ManageUserParticipatingEntities$headerSize) - $author$project$CWS$Approver$ManageUserParticipatingEntities$gridHeaderSize) - $author$project$CWS$Approver$ManageUserParticipatingEntities$footerSize) - 32),
									ac: env.ac,
									w: env.w
								},
								model.fw))))
				]));
	});
var $author$project$CWS$Approver$ManageUserParticipatingEntities$view = F2(
	function (env, model) {
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					A2($mdgriffith$elm_ui$Element$maximum, env.dw.kT, $mdgriffith$elm_ui$Element$fill)),
					$mdgriffith$elm_ui$Element$clip,
					$mdgriffith$elm_ui$Element$spacing(2),
					$mdgriffith$elm_ui$Element$padding(10),
					$mdgriffith$elm_ui$Element$Font$size(
					A2($author$project$PAM$UI$Basic$scaleFont, env.w, 1))
				]),
			_List_fromArray(
				[
					A2($author$project$CWS$Approver$ManageUserParticipatingEntities$gridView, env, model),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$alignBottom,
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px($author$project$CWS$Approver$ManageUserParticipatingEntities$footerSize))
						]),
					$author$project$CWS$Approver$ManageUserParticipatingEntities$controls(model))
				]));
	});
var $author$project$CWS$manageUserPEs_View = F2(
	function (model, pes) {
		return A2(
			$mdgriffith$elm_ui$Element$map,
			$author$project$CWS$managePEsTranslator,
			A2(
				$author$project$CWS$Approver$ManageUserParticipatingEntities$view,
				{
					Z: model.Z,
					dw: $author$project$CWS$calculateModalContentSize(model),
					ac: model.ac,
					w: model.p.aV
				},
				model.a.cJ));
	});
var $author$project$CWS$manageUserPEsView = function (model) {
	return A3(
		$author$project$CWS$loadableValueElementView,
		model.b.cg,
		$author$project$CWS$manageUserPEs_View(model),
		$elm$core$Basics$identity);
};
var $author$project$CWS$getCWSApproverModal = F2(
	function (model, sub) {
		switch (sub.$) {
			case 3:
				var pe = sub.a;
				return A8(
					$author$project$CWS$DynamicModal$elementView,
					model,
					model.w,
					$author$project$CWS$calculateModalContentSize(model),
					$author$project$CWS$managePEUsersView,
					$elm$core$Basics$always($elm$core$Maybe$Nothing),
					function (msg) {
						return msg;
					},
					function () {
						var _v1 = model.b.b0;
						if (_v1.$ === 2) {
							var users = _v1.a;
							return 'Manage Users: ' + A2(
								$elm$core$Maybe$withDefault,
								'unknown',
								$elm$core$List$head(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.dz;
										},
										A2(
											$elm$core$List$map,
											function ($) {
												return $.eK;
											},
											A2(
												$elm$core$List$filter,
												function (u) {
													return _Utils_eq(u.eK.v, pe.d);
												},
												users)))));
						} else {
							return 'Manage Participating Entities: ' + pe.d;
						}
					}(),
					$author$project$CWS$Messages$ConfirmClose);
			case 4:
				var user = sub.a;
				return A8(
					$author$project$CWS$DynamicModal$elementView,
					model,
					model.w,
					$author$project$CWS$calculateModalContentSize(model),
					$author$project$CWS$manageUserPEsView,
					$elm$core$Basics$always($elm$core$Maybe$Nothing),
					function (msg) {
						return msg;
					},
					function () {
						var _v2 = model.b.aY;
						if (_v2.$ === 2) {
							var users = _v2.a;
							return 'Manage Participating Entities: ' + A2(
								$elm$core$Maybe$withDefault,
								'unknown',
								$elm$core$List$head(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.dz;
										},
										A2(
											$elm$core$List$filter,
											function (u) {
												return _Utils_eq(u.ab, user.f);
											},
											users))));
						} else {
							return 'Manage Participating Entities: ' + user.f;
						}
					}(),
					$author$project$CWS$Messages$ConfirmClose);
			default:
				return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$PAM$UI$Basic$transparent0 = $author$project$PAM$UI$Basic$transparent(0.0);
var $author$project$CWS$modalElm = function (e) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$clip,
				$mdgriffith$elm_ui$Element$Background$color(
				A2($author$project$PAM$UI$Basic$fadeColor, 0.65, $author$project$PAM$UI$Basic$black))
			]),
		A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$transparent0),
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$clip
				]),
			A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$scrollbarY,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
					]),
				e)));
};
var $author$project$CWS$modalView = function (model) {
	var approver = function () {
		var _v1 = model.a.n.z;
		if (_v1.$ === 5) {
			return true;
		} else {
			return false;
		}
	}();
	var _v0 = model.a.n.K;
	switch (_v0.$) {
		case 1:
			var action = _v0.a;
			return $author$project$CWS$modalElm(
				A4($author$project$CWS$getActionDetailModel, model, action.ab, $elm$core$Maybe$Nothing, approver));
		case 2:
			var catgrp = _v0.a;
			return $author$project$CWS$modalElm(
				A4(
					$author$project$CWS$getActionDetailModel,
					model,
					-1,
					$elm$core$Maybe$Just(
						_Utils_Tuple2(catgrp.bK, catgrp.hM)),
					approver));
		case 3:
			var sub = _v0.a;
			return $author$project$CWS$modalElm(
				A2($author$project$CWS$getCWSApproverModal, model, sub));
		default:
			return $mdgriffith$elm_ui$Element$none;
	}
};
var $author$project$CWS$dynamicContentView = function (model) {
	return A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$inFront(
				$author$project$CWS$modalView(model)),
				$mdgriffith$elm_ui$Element$inFront(
				$mdgriffith$elm_ui$Element$html(
					$author$project$CWS$confirmCloseView(model))),
				$mdgriffith$elm_ui$Element$clip
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(model.a.n.z, model.f);
				_v0$2:
				while (true) {
					_v0$3:
					while (true) {
						switch (_v0.a.$) {
							case 2:
								var _v1 = _v0.a;
								return $mdgriffith$elm_ui$Element$none;
							case 4:
								if (_v0.a.a.$ === 5) {
									var _v2 = _v0.a.a;
									return $mdgriffith$elm_ui$Element$none;
								} else {
									if (_v0.b.$ === 3) {
										break _v0$2;
									} else {
										break _v0$3;
									}
								}
							default:
								if (_v0.b.$ === 3) {
									break _v0$2;
								} else {
									break _v0$3;
								}
						}
					}
					return $mdgriffith$elm_ui$Element$none;
				}
				return A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width(
							A2(
								$mdgriffith$elm_ui$Element$minimum,
								125,
								$mdgriffith$elm_ui$Element$fillPortion(2))),
							$mdgriffith$elm_ui$Element$clip
						]),
					$author$project$CWS$menuSubView(model));
			}(),
				A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$fillPortion(9)),
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
					]),
				$author$project$CWS$contentView(model))
			]));
};
var $author$project$CWS$supportedBrowserType = _List_fromArray(
	[0, 1]);
var $author$project$CWS$isSupportedBrowserType = function (type_) {
	return A2($elm$core$List$member, type_, $author$project$CWS$supportedBrowserType);
};
var $mdgriffith$elm_ui$Internal$Model$OnlyDynamic = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $mdgriffith$elm_ui$Internal$Model$AllowHover = 1;
var $mdgriffith$elm_ui$Internal$Model$Layout = 0;
var $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle = {
	kl: $elm$core$Maybe$Nothing,
	kt: $elm$core$Maybe$Nothing,
	nO: $elm$core$Maybe$Just(
		{
			aI: 0,
			M: A4($mdgriffith$elm_ui$Internal$Model$Rgba, 155 / 255, 203 / 255, 1, 1),
			mA: _Utils_Tuple2(0, 0),
			aV: 3
		})
};
var $mdgriffith$elm_ui$Internal$Model$optionsToRecord = function (options) {
	var combine = F2(
		function (opt, record) {
			switch (opt.$) {
				case 0:
					var hoverable = opt.a;
					var _v4 = record.lL;
					if (_v4.$ === 1) {
						return _Utils_update(
							record,
							{
								lL: $elm$core$Maybe$Just(hoverable)
							});
					} else {
						return record;
					}
				case 1:
					var focusStyle = opt.a;
					var _v5 = record.lA;
					if (_v5.$ === 1) {
						return _Utils_update(
							record,
							{
								lA: $elm$core$Maybe$Just(focusStyle)
							});
					} else {
						return record;
					}
				default:
					var renderMode = opt.a;
					var _v6 = record.mp;
					if (_v6.$ === 1) {
						return _Utils_update(
							record,
							{
								mp: $elm$core$Maybe$Just(renderMode)
							});
					} else {
						return record;
					}
			}
		});
	var andFinally = function (record) {
		return {
			lA: function () {
				var _v0 = record.lA;
				if (_v0.$ === 1) {
					return $mdgriffith$elm_ui$Internal$Model$focusDefaultStyle;
				} else {
					var focusable = _v0.a;
					return focusable;
				}
			}(),
			lL: function () {
				var _v1 = record.lL;
				if (_v1.$ === 1) {
					return 1;
				} else {
					var hoverable = _v1.a;
					return hoverable;
				}
			}(),
			mp: function () {
				var _v2 = record.mp;
				if (_v2.$ === 1) {
					return 0;
				} else {
					var actualMode = _v2.a;
					return actualMode;
				}
			}()
		};
	};
	return andFinally(
		A3(
			$elm$core$List$foldr,
			combine,
			{lA: $elm$core$Maybe$Nothing, lL: $elm$core$Maybe$Nothing, mp: $elm$core$Maybe$Nothing},
			options));
};
var $mdgriffith$elm_ui$Internal$Model$toHtml = F2(
	function (mode, el) {
		switch (el.$) {
			case 0:
				var html = el.a;
				return html($mdgriffith$elm_ui$Internal$Model$asEl);
			case 1:
				var styles = el.a.n2;
				var html = el.a.lN;
				return A2(
					html,
					mode(styles),
					$mdgriffith$elm_ui$Internal$Model$asEl);
			case 2:
				var text = el.a;
				return $mdgriffith$elm_ui$Internal$Model$textElement(text);
			default:
				return $mdgriffith$elm_ui$Internal$Model$textElement('');
		}
	});
var $mdgriffith$elm_ui$Internal$Model$renderRoot = F3(
	function (optionList, attributes, child) {
		var options = $mdgriffith$elm_ui$Internal$Model$optionsToRecord(optionList);
		var embedStyle = function () {
			var _v0 = options.mp;
			if (_v0 === 1) {
				return $mdgriffith$elm_ui$Internal$Model$OnlyDynamic(options);
			} else {
				return $mdgriffith$elm_ui$Internal$Model$StaticRootAndDynamic(options);
			}
		}();
		return A2(
			$mdgriffith$elm_ui$Internal$Model$toHtml,
			embedStyle,
			A4(
				$mdgriffith$elm_ui$Internal$Model$element,
				$mdgriffith$elm_ui$Internal$Model$asEl,
				$mdgriffith$elm_ui$Internal$Model$div,
				attributes,
				$mdgriffith$elm_ui$Internal$Model$Unkeyed(
					_List_fromArray(
						[child]))));
	});
var $mdgriffith$elm_ui$Internal$Model$rootStyle = function () {
	var families = _List_fromArray(
		[
			$mdgriffith$elm_ui$Internal$Model$Typeface('Open Sans'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Helvetica'),
			$mdgriffith$elm_ui$Internal$Model$Typeface('Verdana'),
			$mdgriffith$elm_ui$Internal$Model$SansSerif
		]);
	return _List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$bgColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'bg-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0)),
				'background-color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 1, 1, 1, 0))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontColor,
			A3(
				$mdgriffith$elm_ui$Internal$Model$Colored,
				'fc-' + $mdgriffith$elm_ui$Internal$Model$formatColorClass(
					A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1)),
				'color',
				A4($mdgriffith$elm_ui$Internal$Model$Rgba, 0, 0, 0, 1))),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontSize,
			$mdgriffith$elm_ui$Internal$Model$FontSize(20)),
			A2(
			$mdgriffith$elm_ui$Internal$Model$StyleClass,
			$mdgriffith$elm_ui$Internal$Flag$fontFamily,
			A2(
				$mdgriffith$elm_ui$Internal$Model$FontFamily,
				A3($elm$core$List$foldl, $mdgriffith$elm_ui$Internal$Model$renderFontClassName, 'font-', families),
				families))
		]);
}();
var $mdgriffith$elm_ui$Element$layoutWith = F3(
	function (_v0, attrs, child) {
		var options = _v0.m6;
		return A3(
			$mdgriffith$elm_ui$Internal$Model$renderRoot,
			options,
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$htmlClass(
					A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[$mdgriffith$elm_ui$Internal$Style$classes.iX, $mdgriffith$elm_ui$Internal$Style$classes.kf, $mdgriffith$elm_ui$Internal$Style$classes.nQ]))),
				_Utils_ap($mdgriffith$elm_ui$Internal$Model$rootStyle, attrs)),
			child);
	});
var $mdgriffith$elm_ui$Element$layout = $mdgriffith$elm_ui$Element$layoutWith(
	{m6: _List_Nil});
var $author$project$CWS$Messages$DismissBrowserWarning = {$: 29};
var $mdgriffith$elm_ui$Element$Font$alignLeft = A2($mdgriffith$elm_ui$Internal$Model$Class, $mdgriffith$elm_ui$Internal$Flag$fontAlignment, $mdgriffith$elm_ui$Internal$Style$classes.oe);
var $author$project$PAM$Settings$browserTypeToText = function (type_) {
	switch (type_) {
		case 0:
			return 'Chrome';
		case 1:
			return 'Edge';
		case 5:
			return 'Internet Explorer';
		case 3:
			return 'Opera';
		case 4:
			return 'Safari';
		case 2:
			return 'Firefox';
		default:
			return 'Unknown';
	}
};
var $author$project$CWS$notSupportedBanner = function (env) {
	var ta4 = _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
			$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$Font$size(
			A2($author$project$PAM$UI$Basic$scaleFont, env.w, -2)),
			$mdgriffith$elm_ui$Element$Font$alignLeft,
			$mdgriffith$elm_ui$Element$paddingEach(
			{kx: 0, me: 20, nA: 0, os: 0})
		]);
	var ta3 = _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
			$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$Font$size(
			A2($author$project$PAM$UI$Basic$scaleFont, env.w, -1)),
			$mdgriffith$elm_ui$Element$Font$alignLeft
		]);
	var ta2 = _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$Font$size(
			A2($author$project$PAM$UI$Basic$scaleFont, env.w, 1))
		]);
	var ta = _List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$Font$center,
			$mdgriffith$elm_ui$Element$Font$bold,
			$mdgriffith$elm_ui$Element$Font$size(
			A2($author$project$PAM$UI$Basic$scaleFont, env.w, 2))
		]);
	var okButton = A2(
		$mdgriffith$elm_ui$Element$Input$button,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
				$mdgriffith$elm_ui$Element$height(
				$author$project$PAM$UI$Basic$inputHeight(env)),
				A2($mdgriffith$elm_ui$Element$paddingXY, 25, 0),
				$mdgriffith$elm_ui$Element$Border$rounded(16),
				$author$project$PAM$UI$Basic$title('Ok'),
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$px(160)),
				$mdgriffith$elm_ui$Element$centerX
			]),
		{
			h3: A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Font$size(
						A2($author$project$PAM$UI$Basic$scaleFont, env.w, 1)),
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
						$author$project$PAM$UI$Basic$montserrat,
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$centerX
					]),
				$mdgriffith$elm_ui$Element$text('Ok')),
			ip: $elm$core$Maybe$Just($author$project$CWS$Messages$DismissBrowserWarning)
		});
	var dismiss = A2(
		$mdgriffith$elm_ui$Element$Input$button,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width(
				$mdgriffith$elm_ui$Element$px(15)),
				$mdgriffith$elm_ui$Element$height(
				$mdgriffith$elm_ui$Element$px(15)),
				$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$orangeRoughy),
				$mdgriffith$elm_ui$Element$alignRight
			]),
		{
			h3: A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				_List_fromArray(
					[
						$author$project$PAM$UI$Basic$centeredIcon('fa fa-times')
					])),
			ip: $elm$core$Maybe$Just($author$project$CWS$Messages$DismissBrowserWarning)
		});
	var header = A2(
		$mdgriffith$elm_ui$Element$row,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height(
				$mdgriffith$elm_ui$Element$px(46)),
				$mdgriffith$elm_ui$Element$padding(15),
				$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$pineTree)
			]),
		_List_fromArray(
			[dismiss]));
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$height(
				A2(
					$mdgriffith$elm_ui$Element$maximum,
					600,
					A2($mdgriffith$elm_ui$Element$minimum, 120, $mdgriffith$elm_ui$Element$shrink))),
				$mdgriffith$elm_ui$Element$width(
				A2(
					$mdgriffith$elm_ui$Element$maximum,
					620,
					A2($mdgriffith$elm_ui$Element$minimum, 160, $mdgriffith$elm_ui$Element$shrink))),
				$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$white),
				$mdgriffith$elm_ui$Element$Font$center,
				$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$black),
				$mdgriffith$elm_ui$Element$Font$bold,
				$mdgriffith$elm_ui$Element$centerY,
				$mdgriffith$elm_ui$Element$centerX,
				$mdgriffith$elm_ui$Element$clip,
				$mdgriffith$elm_ui$Element$Border$rounded(6),
				$mdgriffith$elm_ui$Element$Border$solid,
				$mdgriffith$elm_ui$Element$Border$color($author$project$PAM$UI$Basic$black),
				$mdgriffith$elm_ui$Element$Border$width(1)
			]),
		_List_fromArray(
			[
				header,
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$padding(10),
						$mdgriffith$elm_ui$Element$spacing(15)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$textColumn,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								$mdgriffith$elm_ui$Element$centerY,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								ta,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('The browser you are currently using is not supported.')
									])),
								A2(
								$mdgriffith$elm_ui$Element$paragraph,
								ta,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$text('Some features may not work as expected.')
									]))
							])),
						A2(
						$mdgriffith$elm_ui$Element$column,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$center,
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$centerY
							]),
						_List_fromArray(
							[
								A2(
								$mdgriffith$elm_ui$Element$textColumn,
								_List_fromArray(
									[
										$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
										$mdgriffith$elm_ui$Element$centerX
									]),
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$paragraph,
											ta3,
											_List_fromArray(
												[
													A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink)
														]),
													$mdgriffith$elm_ui$Element$text('Supported browsers'))
												]))
										]),
									A2(
										$elm$core$List$map,
										function (i) {
											return A2(
												$mdgriffith$elm_ui$Element$paragraph,
												ta4,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$text(
														$author$project$PAM$Settings$browserTypeToText(i))
													]));
										},
										$author$project$CWS$supportedBrowserType)))
							])),
						A2(
						$mdgriffith$elm_ui$Element$el,
						ta2,
						$mdgriffith$elm_ui$Element$text(
							'We detected the browser you are using is ' + $author$project$PAM$Settings$browserTypeToText(env.cq.jE))),
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								$mdgriffith$elm_ui$Element$padding(15)
							]),
						okButton)
					]))
			]));
};
var $author$project$PAM$UI$Basic$transparent50 = $author$project$PAM$UI$Basic$transparent(0.5);
var $author$project$CWS$versionView = function (version) {
	return A2(
		$mdgriffith$elm_ui$Element$el,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$transparent50),
				$mdgriffith$elm_ui$Element$Font$bold,
				$mdgriffith$elm_ui$Element$alignRight
			]),
		$mdgriffith$elm_ui$Element$text('v ' + version));
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $author$project$InPageOAuth$codeGetter = F2(
	function (model, state) {
		var _v0 = model.hd;
		if (!_v0.$) {
			var config = _v0.a;
			var auth = {
				ha: config.ha,
				nt: config.nt,
				nE: config.nE,
				a: $elm$core$Maybe$Just('PAM.init'),
				jF: config.gR
			};
			return A2(
				$mdgriffith$elm_ui$Element$row,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$Background$color(
						A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.5)),
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2(
							$elm$html$Html$Attributes$style,
							'opacity',
							(_Utils_eq(state, $author$project$InPageOAuth$NotStarted) || (model.mp === 1)) ? '0' : '1'))
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'opacity', '0')),
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(0)),
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(0)),
								$mdgriffith$elm_ui$Element$behindContent(
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
										]),
									A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$centerX,
												$mdgriffith$elm_ui$Element$centerY,
												$mdgriffith$elm_ui$Element$Font$color(
												A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
											]),
										$mdgriffith$elm_ui$Element$text('Waiting for server reply'))))
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
								]),
							$mdgriffith$elm_ui$Element$html(
								A2(
									$elm$html$Html$iframe,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(
											$elm$url$Url$toString(
												$truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthUrl(auth))),
											A2($elm$html$Html$Attributes$style, 'width', '100%'),
											A2($elm$html$Html$Attributes$style, 'height', '100%'),
											$elm$html$Html$Attributes$id('authFrame')
										]),
									_List_Nil)))),
						_Utils_eq(state, $author$project$InPageOAuth$Pending) ? A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$centerX,
								$mdgriffith$elm_ui$Element$centerY,
								$mdgriffith$elm_ui$Element$Font$color(
								A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
							]),
						$mdgriffith$elm_ui$Element$text('Logging you in ...')) : $mdgriffith$elm_ui$Element$none
					]));
		} else {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_Nil,
				$mdgriffith$elm_ui$Element$text('No configuration provided'));
		}
	});
var $author$project$InPageOAuth$modal = function (els) {
	return A2(
		$mdgriffith$elm_ui$Element$column,
		_List_fromArray(
			[
				$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
				$mdgriffith$elm_ui$Element$Background$color(
				A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.5)),
				$mdgriffith$elm_ui$Element$spacing(10),
				$mdgriffith$elm_ui$Element$padding(25)
			]),
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						A2($mdgriffith$elm_ui$Element$paddingXY, 25, 0),
						$mdgriffith$elm_ui$Element$Border$rounded(4),
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$black),
						$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$white),
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$centerY,
						$mdgriffith$elm_ui$Element$spacing(15),
						$mdgriffith$elm_ui$Element$padding(25),
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(350))
					]),
				els)
			]));
};
var $author$project$InPageOAuth$errorView = F2(
	function (model, errorMsg) {
		return $author$project$InPageOAuth$modal(
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY, $mdgriffith$elm_ui$Element$Font$bold]),
					$mdgriffith$elm_ui$Element$text('Error Authenticating')),
					A2(
					$mdgriffith$elm_ui$Element$paragraph,
					_List_fromArray(
						[$mdgriffith$elm_ui$Element$centerX, $mdgriffith$elm_ui$Element$centerY, $mdgriffith$elm_ui$Element$Font$center]),
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$text(errorMsg)
						]))
				]));
	});
var $author$project$InPageOAuth$gettingACLs = A2(
	$mdgriffith$elm_ui$Element$row,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$Background$color(
			A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.5))
		]),
	_List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$Font$color(
					A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
				]),
			$mdgriffith$elm_ui$Element$text('Mapping permissions'))
		]));
var $author$project$InPageOAuth$gettingToken = A2(
	$mdgriffith$elm_ui$Element$row,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$Background$color(
			A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.5))
		]),
	_List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$Font$color(
					A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
				]),
			$mdgriffith$elm_ui$Element$text('Getting token'))
		]));
var $author$project$InPageOAuth$gettingUserInfo = A2(
	$mdgriffith$elm_ui$Element$row,
	_List_fromArray(
		[
			$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
			$mdgriffith$elm_ui$Element$Background$color(
			A4($mdgriffith$elm_ui$Element$rgba, 0, 0, 0, 0.5))
		]),
	_List_fromArray(
		[
			A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$centerX,
					$mdgriffith$elm_ui$Element$centerY,
					$mdgriffith$elm_ui$Element$Font$color(
					A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
				]),
			$mdgriffith$elm_ui$Element$text('Retreiving profile'))
		]));
var $author$project$InPageOAuth$hideIfQuiet = F2(
	function (mode, vw) {
		if (mode === 1) {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'opacity', '0'))
					]),
				vw);
		} else {
			return vw;
		}
	});
var $author$project$InPageOAuth$OpenLogin = {$: 7};
var $author$project$InPageOAuth$unauthorized = function (model) {
	return $author$project$InPageOAuth$modal(
		_List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$centerX,
						$mdgriffith$elm_ui$Element$spacing(5),
						$mdgriffith$elm_ui$Element$Font$center,
						$mdgriffith$elm_ui$Element$Font$size(18)
					]),
				_List_fromArray(
					[
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$centerX]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text('You are currently logged out.')
							])),
						A2(
						$mdgriffith$elm_ui$Element$paragraph,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$centerX]),
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$text(
								'Please log in to access the ' + (A2(
									$elm$core$Maybe$withDefault,
									'application',
									A2(
										$elm$core$Maybe$map,
										function (a) {
											return a.hN.jr.jr;
										},
										model.kh)) + '.'))
							]))
					])),
				A2(
				$mdgriffith$elm_ui$Element$Input$button,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(25)),
						A2($mdgriffith$elm_ui$Element$paddingXY, 25, 0),
						$mdgriffith$elm_ui$Element$Border$rounded(16),
						$mdgriffith$elm_ui$Element$width(
						$mdgriffith$elm_ui$Element$px(100)),
						$mdgriffith$elm_ui$Element$Font$bold,
						$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
						$mdgriffith$elm_ui$Element$centerX
					]),
				{
					h3: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[$mdgriffith$elm_ui$Element$centerX]),
						$mdgriffith$elm_ui$Element$text('Login')),
					ip: $elm$core$Maybe$Just(
						$author$project$InPageOAuth$Internal($author$project$InPageOAuth$OpenLogin))
				}),
				function () {
				var _v0 = model.hd;
				if (!_v0.$) {
					var config = _v0.a;
					var auth = {
						ha: config.ha,
						nt: config.nt,
						nE: config.nE,
						a: $elm$core$Maybe$Just('PAM.init'),
						jF: config.gR
					};
					return A2(
						$mdgriffith$elm_ui$Element$el,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'opacity', '0')),
								$mdgriffith$elm_ui$Element$width(
								$mdgriffith$elm_ui$Element$px(0)),
								$mdgriffith$elm_ui$Element$height(
								$mdgriffith$elm_ui$Element$px(0)),
								$mdgriffith$elm_ui$Element$behindContent(
								A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
											$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
										]),
									A2(
										$mdgriffith$elm_ui$Element$el,
										_List_fromArray(
											[
												$mdgriffith$elm_ui$Element$centerX,
												$mdgriffith$elm_ui$Element$centerY,
												$mdgriffith$elm_ui$Element$Font$color(
												A3($mdgriffith$elm_ui$Element$rgb255, 255, 255, 255))
											]),
										$mdgriffith$elm_ui$Element$text('Waiting for server reply'))))
							]),
						A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$centerX,
									$mdgriffith$elm_ui$Element$centerY,
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
								]),
							$mdgriffith$elm_ui$Element$html(
								A2(
									$elm$html$Html$iframe,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(
											$elm$url$Url$toString(
												$truqu$elm_oauth2$OAuth$AuthorizationCode$makeAuthUrl(auth))),
											A2($elm$html$Html$Attributes$style, 'width', '100%'),
											A2($elm$html$Html$Attributes$style, 'height', '100%'),
											$elm$html$Html$Attributes$id('authFrame')
										]),
									_List_Nil))));
				} else {
					return $mdgriffith$elm_ui$Element$none;
				}
			}()
			]));
};
var $author$project$InPageOAuth$view = function (model) {
	var _v0 = model.a;
	switch (_v0.$) {
		case 0:
			return A2(
				$author$project$InPageOAuth$hideIfQuiet,
				model.mp,
				A2($author$project$InPageOAuth$codeGetter, model, model.a));
		case 1:
			return A2(
				$author$project$InPageOAuth$hideIfQuiet,
				model.mp,
				A2($author$project$InPageOAuth$codeGetter, model, model.a));
		case 2:
			return $author$project$InPageOAuth$unauthorized(model);
		case 3:
			return $mdgriffith$elm_ui$Element$none;
		case 4:
			return A2($author$project$InPageOAuth$hideIfQuiet, model.mp, $author$project$InPageOAuth$gettingToken);
		case 5:
			return A2($author$project$InPageOAuth$hideIfQuiet, model.mp, $author$project$InPageOAuth$gettingUserInfo);
		case 6:
			return A2($author$project$InPageOAuth$hideIfQuiet, model.mp, $author$project$InPageOAuth$gettingACLs);
		default:
			var err = _v0.a;
			return A2($author$project$InPageOAuth$errorView, model, err);
	}
};
var $author$project$PAM$UI$Basic$earlyDawn = A3($mdgriffith$elm_ui$Element$rgb255, 255, 250, 235);
var $author$project$PAM$Header$hasAnyRequiredRoles = F2(
	function (profile, link) {
		if ($elm$core$List$isEmpty(link.cV)) {
			return true;
		} else {
			var part = function (itm) {
				return A2($elm$core$List$member, itm, link.cV);
			};
			var _v0 = A2($elm$core$List$partition, part, profile.iW);
			var match = _v0.a;
			var nomatch = _v0.b;
			return A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty)(match);
		}
	});
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $mdgriffith$elm_ui$Element$link = F2(
	function (attrs, _v0) {
		var url = _v0.jF;
		var label = _v0.h3;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$rel('noopener noreferrer')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eb + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.bj + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ie)))),
								attrs))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $mdgriffith$elm_ui$Internal$Model$MoveX = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_ui$Internal$Flag$moveX = $mdgriffith$elm_ui$Internal$Flag$flag(25);
var $mdgriffith$elm_ui$Element$moveRight = function (x) {
	return A2(
		$mdgriffith$elm_ui$Internal$Model$TransformComponent,
		$mdgriffith$elm_ui$Internal$Flag$moveX,
		$mdgriffith$elm_ui$Internal$Model$MoveX(x));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $mdgriffith$elm_ui$Element$newTabLink = F2(
	function (attrs, _v0) {
		var url = _v0.jF;
		var label = _v0.h3;
		return A4(
			$mdgriffith$elm_ui$Internal$Model$element,
			$mdgriffith$elm_ui$Internal$Model$asEl,
			$mdgriffith$elm_ui$Internal$Model$NodeName('a'),
			A2(
				$elm$core$List$cons,
				$mdgriffith$elm_ui$Internal$Model$Attr(
					$elm$html$Html$Attributes$href(url)),
				A2(
					$elm$core$List$cons,
					$mdgriffith$elm_ui$Internal$Model$Attr(
						$elm$html$Html$Attributes$rel('noopener noreferrer')),
					A2(
						$elm$core$List$cons,
						$mdgriffith$elm_ui$Internal$Model$Attr(
							$elm$html$Html$Attributes$target('_blank')),
						A2(
							$elm$core$List$cons,
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							A2(
								$elm$core$List$cons,
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
								A2(
									$elm$core$List$cons,
									$mdgriffith$elm_ui$Internal$Model$htmlClass($mdgriffith$elm_ui$Internal$Style$classes.eb + (' ' + ($mdgriffith$elm_ui$Internal$Style$classes.bj + (' ' + $mdgriffith$elm_ui$Internal$Style$classes.ie)))),
									attrs)))))),
			$mdgriffith$elm_ui$Internal$Model$Unkeyed(
				_List_fromArray(
					[label])));
	});
var $author$project$PAM$Header$logoAndTitleView = F2(
	function (windowSize, config) {
		return A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$moveRight(32),
					A2($mdgriffith$elm_ui$Element$spacingXY, 24, 0)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$newTabLink,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width(
							$mdgriffith$elm_ui$Element$px(32)),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(40)),
							$mdgriffith$elm_ui$Element$centerX,
							$mdgriffith$elm_ui$Element$centerY
						]),
					{
						h3: A2(
							$mdgriffith$elm_ui$Element$image,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width(
									$mdgriffith$elm_ui$Element$px(32)),
									$mdgriffith$elm_ui$Element$height(
									$mdgriffith$elm_ui$Element$px(40))
								]),
							{hp: config.ig.kd, nX: config.ig.nX}),
						jF: config.ig.fC
					}),
					A2(
					$mdgriffith$elm_ui$Element$column,
					_List_fromArray(
						[
							A2($mdgriffith$elm_ui$Element$spacingXY, 0, 6),
							$author$project$PAM$UI$Basic$montserrat,
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, windowSize, 1))
						]),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$asparagus),
									$mdgriffith$elm_ui$Element$Font$bold
								]),
							$mdgriffith$elm_ui$Element$text(config.jr.jr)),
							A2(
							$mdgriffith$elm_ui$Element$el,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$orangeRoughy)
								]),
							$mdgriffith$elm_ui$Element$text(config.jr.gp))
						]))
				]));
	});
var $author$project$PAM$Header$CloseUserMenu = 3;
var $author$project$PAM$Header$Internal = $elm$core$Basics$identity;
var $author$project$PAM$Header$OpenUserMenu = 2;
var $author$project$PAM$Header$ToggleUserMenu = 1;
var $mdgriffith$elm_ui$Internal$Model$Top = 0;
var $mdgriffith$elm_ui$Element$alignTop = $mdgriffith$elm_ui$Internal$Model$AlignY(0);
var $mdgriffith$elm_ui$Internal$Model$OnLeft = 3;
var $mdgriffith$elm_ui$Element$onLeft = function (element) {
	return A2($mdgriffith$elm_ui$Element$createNearby, 3, element);
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $mdgriffith$elm_ui$Element$Events$onMouseEnter = A2($elm$core$Basics$composeL, $mdgriffith$elm_ui$Internal$Model$Attr, $elm$html$Html$Events$onMouseEnter);
var $author$project$PAM$UI$Basic$convertColor = function (color) {
	return function (_v0) {
		var red = _v0.aq;
		var green = _v0.al;
		var blue = _v0.ag;
		var alpha = _v0.af;
		return A4($mdgriffith$elm_ui$Element$rgba, red, green, blue, alpha);
	}(
		$avh4$elm_color$Color$toRgba(color));
};
var $avh4$elm_color$Color$hsla = F4(
	function (hue, sat, light, alpha) {
		var _v0 = _Utils_Tuple3(hue, sat, light);
		var h = _v0.a;
		var s = _v0.b;
		var l = _v0.c;
		var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
		var m1 = (l * 2) - m2;
		var hueToRgb = function (h__) {
			var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
			return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
		};
		var b = hueToRgb(h - (1 / 3));
		var g = hueToRgb(h);
		var r = hueToRgb(h + (1 / 3));
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, alpha);
	});
var $noahzgordon$elm_color_extra$Color$Manipulate$limit = A2($elm$core$Basics$clamp, 0, 1);
var $avh4$elm_color$Color$toHsla = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var minColor = A2(
		$elm$core$Basics$min,
		r,
		A2($elm$core$Basics$min, g, b));
	var maxColor = A2(
		$elm$core$Basics$max,
		r,
		A2($elm$core$Basics$max, g, b));
	var l = (minColor + maxColor) / 2;
	var s = _Utils_eq(minColor, maxColor) ? 0 : ((l < 0.5) ? ((maxColor - minColor) / (maxColor + minColor)) : ((maxColor - minColor) / ((2 - maxColor) - minColor)));
	var h1 = _Utils_eq(maxColor, r) ? ((g - b) / (maxColor - minColor)) : (_Utils_eq(maxColor, g) ? (2 + ((b - r) / (maxColor - minColor))) : (4 + ((r - g) / (maxColor - minColor))));
	var h2 = h1 * (1 / 6);
	var h3 = $elm$core$Basics$isNaN(h2) ? 0 : ((h2 < 0) ? (h2 + 1) : h2);
	return {af: a, hR: h3, ic: l, i2: s};
};
var $noahzgordon$elm_color_extra$Color$Manipulate$darken = F2(
	function (offset, cl) {
		var _v0 = $avh4$elm_color$Color$toHsla(cl);
		var hue = _v0.hR;
		var saturation = _v0.i2;
		var lightness = _v0.ic;
		var alpha = _v0.af;
		return A4(
			$avh4$elm_color$Color$hsla,
			hue,
			saturation,
			$noahzgordon$elm_color_extra$Color$Manipulate$limit(lightness - offset),
			alpha);
	});
var $avh4$elm_color$Color$fromRgba = function (components) {
	return A4($avh4$elm_color$Color$RgbaSpace, components.aq, components.al, components.ag, components.af);
};
var $author$project$PAM$UI$Basic$darkenColor = F2(
	function (val, color) {
		var c = $mdgriffith$elm_ui$Element$toRgb(color);
		return $author$project$PAM$UI$Basic$convertColor(
			A2(
				$noahzgordon$elm_color_extra$Color$Manipulate$darken,
				val,
				$avh4$elm_color$Color$fromRgba(c)));
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$PAM$Header$userMenuDropdownView = F4(
	function (env, model, profile, linkGroups) {
		var menuLinkDivider = A2(
			$mdgriffith$elm_ui$Element$el,
			_List_fromArray(
				[
					A2($mdgriffith$elm_ui$Element$paddingXY, 10, 5),
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
				]),
			A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height(
						$mdgriffith$elm_ui$Element$px(1)),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$earlyDawn)
					]),
				$mdgriffith$elm_ui$Element$none));
		var menuLink = function (l) {
			return A2(
				$mdgriffith$elm_ui$Element$link,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$mouseOver(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Background$color(
								A2($author$project$PAM$UI$Basic$darkenColor, 0.1, $author$project$PAM$UI$Basic$orangeRoughy))
							])),
						A2($mdgriffith$elm_ui$Element$paddingXY, 10, 5),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				{
					h3: A2(
						$mdgriffith$elm_ui$Element$el,
						_List_Nil,
						$mdgriffith$elm_ui$Element$text(l.dz)),
					jF: l.c
				});
		};
		var menuLinkGroup = function (group) {
			return A2(
				$mdgriffith$elm_ui$Element$column,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill)
					]),
				A2(
					$elm$core$List$map,
					menuLink,
					A2(
						$elm$core$List$filter,
						$author$project$PAM$Header$hasAnyRequiredRoles(profile),
						group)));
		};
		var _v0 = model.dT;
		if (!_v0) {
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$onLeft(
						A2(
							$mdgriffith$elm_ui$Element$column,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
									$mdgriffith$elm_ui$Element$paddingEach(
									_Utils_update(
										$author$project$PAM$UI$Basic$edges,
										{kx: 6, os: 6})),
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$Border$roundEach(
									_Utils_update(
										$author$project$PAM$UI$Basic$corners,
										{g0: 6, jw: 6})),
									$mdgriffith$elm_ui$Element$moveUp(6)
								]),
							A2(
								$elm$core$List$intersperse,
								menuLinkDivider,
								A2($elm$core$List$map, menuLinkGroup, linkGroups)))),
						$mdgriffith$elm_ui$Element$alignRight
					]),
				$mdgriffith$elm_ui$Element$none);
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$PAM$Header$userMenuView = F4(
	function (env, model, config, headerLinks) {
		var _v0 = env.f;
		if (_v0.$ === 3) {
			var profile = _v0.a.aB;
			return A2(
				$mdgriffith$elm_ui$Element$el,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$onLeft(headerLinks),
						$mdgriffith$elm_ui$Element$alignRight,
						$mdgriffith$elm_ui$Element$alignTop
					]),
				A2(
					$mdgriffith$elm_ui$Element$Input$button,
					_List_fromArray(
						[
							$author$project$PAM$UI$Basic$montserrat,
							$mdgriffith$elm_ui$Element$Font$bold,
							$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$earlyDawn),
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, env.w, 1)),
							$mdgriffith$elm_ui$Element$Border$roundEach(
							_Utils_update(
								$author$project$PAM$UI$Basic$corners,
								{g0: 6})),
							$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$orangeRoughy),
							A2($mdgriffith$elm_ui$Element$paddingXY, 10, 8),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$shrink),
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
							$mdgriffith$elm_ui$Element$below(
							A4($author$project$PAM$Header$userMenuDropdownView, env, model, profile, config.gu)),
							$mdgriffith$elm_ui$Element$Events$onMouseEnter(2),
							$mdgriffith$elm_ui$Element$Events$onMouseLeave(3)
						]),
					{
						h3: A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									A2($mdgriffith$elm_ui$Element$spacingXY, 10, 0)
								]),
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$text('Hi, ' + profile.dz),
									A2(
									$mdgriffith$elm_ui$Element$el,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$moveUp(2)
										]),
									$author$project$PAM$UI$Basic$centeredIcon('fa fa-chevron-down'))
								])),
						ip: $elm$core$Maybe$Just(1)
					}));
		} else {
			return $mdgriffith$elm_ui$Element$none;
		}
	});
var $author$project$PAM$Header$view = F5(
	function (env, headerElements, config, model, trans) {
		var prof = function () {
			var _v0 = env.f;
			if (_v0.$ === 3) {
				var profile = _v0.a.aB;
				return {iW: profile.iW};
			} else {
				return {iW: _List_Nil};
			}
		}();
		var headerLink = function (l) {
			return A2(
				$mdgriffith$elm_ui$Element$link,
				_List_fromArray(
					[
						$author$project$PAM$UI$Basic$montserrat,
						$mdgriffith$elm_ui$Element$Font$center,
						$mdgriffith$elm_ui$Element$Border$solid,
						$mdgriffith$elm_ui$Element$Border$widthEach(
						_Utils_update(
							$author$project$PAM$UI$Basic$edges,
							{kx: 2})),
						$mdgriffith$elm_ui$Element$Border$color($author$project$PAM$UI$Basic$transparent0),
						$mdgriffith$elm_ui$Element$mouseOver(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Border$color($author$project$PAM$UI$Basic$orangeRoughy)
							]))
					]),
				{
					h3: $mdgriffith$elm_ui$Element$text(l.dz),
					jF: l.c
				});
		};
		var headerLinks = A2(
			$mdgriffith$elm_ui$Element$row,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height(
					$mdgriffith$elm_ui$Element$px(env.ac.mh)),
					A2($mdgriffith$elm_ui$Element$paddingXY, 64, 0),
					$mdgriffith$elm_ui$Element$centerY
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$row,
					_List_fromArray(
						[
							$author$project$PAM$UI$Basic$montserrat,
							$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$earlyDawn),
							$mdgriffith$elm_ui$Element$Font$size(
							A2($author$project$PAM$UI$Basic$scaleFont, env.w, 1)),
							$mdgriffith$elm_ui$Element$Font$bold,
							$mdgriffith$elm_ui$Element$alignRight,
							$mdgriffith$elm_ui$Element$spacing(28)
						]),
					A2(
						$elm$core$List$map,
						headerLink,
						A2(
							$elm$core$List$filter,
							$author$project$PAM$Header$hasAnyRequiredRoles(prof),
							config.es)))
				]));
		return A2(
			$mdgriffith$elm_ui$Element$column,
			_List_fromArray(
				[
					$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
					$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill)
				]),
			_List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(env.ac.mh)),
							$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$pineTree),
							$mdgriffith$elm_ui$Element$inFront(
							A2(
								$mdgriffith$elm_ui$Element$map,
								trans,
								A2($author$project$PAM$Header$logoAndTitleView, env.w, config))),
							$mdgriffith$elm_ui$Element$inFront(
							A2(
								$mdgriffith$elm_ui$Element$map,
								trans,
								A4($author$project$PAM$Header$userMenuView, env, model, config, headerLinks)))
						]),
					$mdgriffith$elm_ui$Element$none),
					A2(
					$mdgriffith$elm_ui$Element$el,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$height(
							$mdgriffith$elm_ui$Element$px(env.ac.n3)),
							$mdgriffith$elm_ui$Element$Background$color($author$project$PAM$UI$Basic$asparagus)
						]),
					A2(
						$mdgriffith$elm_ui$Element$row,
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$padding(5),
								$mdgriffith$elm_ui$Element$spaceEvenly
							]),
						headerElements))
				]));
	});
var $author$project$CWS$appView = function (model) {
	return {
		gZ: _List_fromArray(
			[
				A2(
				$mdgriffith$elm_ui$Element$layout,
				_List_fromArray(
					[
						$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
						$mdgriffith$elm_ui$Element$clip,
						$mdgriffith$elm_ui$Element$Font$size(
						A2($author$project$PAM$UI$Basic$scaleFont, model.w, 1)),
						$mdgriffith$elm_ui$Element$Font$family(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$Font$typeface('Helvetica'),
								$mdgriffith$elm_ui$Element$Font$sansSerif
							]))
					]),
				A2(
					$mdgriffith$elm_ui$Element$column,
					_Utils_ap(
						_List_fromArray(
							[
								$mdgriffith$elm_ui$Element$inFront(
								A2(
									$mdgriffith$elm_ui$Element$map,
									$author$project$CWS$genericAuthTranslator(
										A2($elm$core$Maybe$withDefault, 0, model.bS)),
									$author$project$InPageOAuth$view(model.Y))),
								$mdgriffith$elm_ui$Element$inFront(
								function () {
									var _v0 = _Utils_Tuple2(model.f, model.a.ae);
									if (_v0.b.$ === 1) {
										var _v1 = _v0.b;
										return $mdgriffith$elm_ui$Element$none;
									} else {
										if (_v0.a.$ === 3) {
											return A2(
												$mdgriffith$elm_ui$Element$el,
												_List_fromArray(
													[
														$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
														$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
														$mdgriffith$elm_ui$Element$Background$color(
														A2($author$project$PAM$UI$Basic$fadeColor, 0.5, $author$project$PAM$UI$Basic$black))
													]),
												A2(
													$mdgriffith$elm_ui$Element$el,
													_List_fromArray(
														[
															$mdgriffith$elm_ui$Element$centerX,
															$mdgriffith$elm_ui$Element$centerY,
															$mdgriffith$elm_ui$Element$Font$color($author$project$PAM$UI$Basic$white),
															$mdgriffith$elm_ui$Element$Font$size(
															A2($author$project$PAM$UI$Basic$scaleFont, model.w, 2))
														]),
													$mdgriffith$elm_ui$Element$text('Loading ...')));
										} else {
											return $mdgriffith$elm_ui$Element$none;
										}
									}
								}()),
								$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
								$mdgriffith$elm_ui$Element$clip
							]),
						function () {
							var _v2 = _Utils_Tuple2(
								model.d1,
								$author$project$CWS$isSupportedBrowserType(model.cq.jE));
							if ((!_v2.a) && (!_v2.b)) {
								return _List_fromArray(
									[
										$mdgriffith$elm_ui$Element$inFront(
										$author$project$CWS$notSupportedBanner(model))
									]);
							} else {
								return _List_Nil;
							}
						}()),
					_List_fromArray(
						[
							A2(
							$mdgriffith$elm_ui$Element$row,
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
									$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$shrink),
									$mdgriffith$elm_ui$Element$Font$size(
									A2($author$project$PAM$UI$Basic$scaleFont, model.w, -2))
								]),
							_List_fromArray(
								[
									A5(
									$author$project$PAM$Header$view,
									model,
									_List_fromArray(
										[
											$author$project$CWS$versionView(model.p.jL)
										]),
									model.p.m.hN,
									model.a.ds,
									$author$project$CWS$headerTranslator)
								])),
							$author$project$CWS$dynamicContentView(model)
						])))
			]),
		jr: 'CWS'
	};
};
var $author$project$CWS$view = function (app) {
	if (!app.$) {
		var model = app.a;
		return $author$project$CWS$appView(model);
	} else {
		return {
			gZ: _List_fromArray(
				[
					A2(
					$mdgriffith$elm_ui$Element$layout,
					_List_fromArray(
						[
							$mdgriffith$elm_ui$Element$height($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$width($mdgriffith$elm_ui$Element$fill),
							$mdgriffith$elm_ui$Element$Font$size(10),
							$mdgriffith$elm_ui$Element$Font$family(
							_List_fromArray(
								[
									$mdgriffith$elm_ui$Element$Font$typeface('Helvetica'),
									$mdgriffith$elm_ui$Element$Font$sansSerif
								]))
						]),
					A2(
						$mdgriffith$elm_ui$Element$el,
						_List_Nil,
						A2(
							$mdgriffith$elm_ui$Element$textColumn,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$mdgriffith$elm_ui$Element$el,
											_List_fromArray(
												[$mdgriffith$elm_ui$Element$Font$bold]),
											$mdgriffith$elm_ui$Element$text('Oh no!'))
										])),
									A2(
									$mdgriffith$elm_ui$Element$paragraph,
									_List_Nil,
									_List_fromArray(
										[
											$mdgriffith$elm_ui$Element$text('We\'ve encountered a problem loading CWS.')
										]))
								]))))
				]),
			jr: 'Problem loading CWS'
		};
	}
};
var $author$project$CWS$main = $elm$browser$Browser$application(
	{lW: $author$project$CWS$init, m1: $author$project$CWS$Messages$OnLocationChange, m2: $author$project$CWS$Messages$LinkClicked, n5: $author$project$CWS$subscriptions, oB: $author$project$CWS$update, oH: $author$project$CWS$view});
_Platform_export({'CWS':{'init':$author$project$CWS$main($elm$json$Json$Decode$value)(0)}});}(this));